
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("bNbKd", function(module, exports) {

$parcel$export(module.exports, "triggerBurst", () => $895d6185463ab8db$export$f41080da4e2fdf9f);
$parcel$export(module.exports, "showMoodAnalysisPopup", () => $895d6185463ab8db$export$8a958c527fd8c83f);
// mood.js
parcelRequire("eCgl8");

var $21EbS = parcelRequire("21EbS");

var $5W4EI = parcelRequire("5W4EI");

var $73MNt = parcelRequire("73MNt");

var $fUPn2 = parcelRequire("fUPn2");
// Create a completely new WebSocket connection for the Mood Board
let $895d6185463ab8db$var$moodSocket = null;
const $895d6185463ab8db$var$sessionId = localStorage.getItem("sessionId");
const $895d6185463ab8db$var$storedSocketId = localStorage.getItem("socketId");
const $895d6185463ab8db$var$authToken = (0, $21EbS.getAuthToken)();
let $895d6185463ab8db$var$userMoodScore = 0;
let $895d6185463ab8db$var$marketMoodScore = 0;
let $895d6185463ab8db$var$p5Instance = null;
let $895d6185463ab8db$var$updateTimer = null;
let $895d6185463ab8db$var$lastTransactionTime = null;
let $895d6185463ab8db$var$lastTransactionMood = 0;
let $895d6185463ab8db$var$burstCells = [];
let $895d6185463ab8db$var$cols = 0;
let $895d6185463ab8db$var$rows = 0;
let $895d6185463ab8db$var$cellSize = 10;
const $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR = 1.8;
let $895d6185463ab8db$var$moodSocketSetupComplete = false;
let $895d6185463ab8db$var$socketSetupComplete = false;
let $895d6185463ab8db$var$isConnected = false;
let $895d6185463ab8db$var$reconnectAttempts = 0;
const $895d6185463ab8db$var$MAX_RECONNECT_ATTEMPTS = 5;
function $895d6185463ab8db$var$connectMoodSocket() {
    const token = (0, $21EbS.getAuthToken)() || localStorage.getItem('token');
    const sessionId = localStorage.getItem('sessionId');
    if (!token || !sessionId) {
        console.error("\u274C Missing token or sessionId. Cannot connect mood socket.");
        return;
    }
    $895d6185463ab8db$var$moodSocket = (0, $73MNt.default)((0, $5W4EI.apiBaseSocket), {
        query: {
            token: token,
            userId: sessionId,
            sessionId: sessionId,
            page: 'moodBoard' // This is critical - ensures server knows this is a mood board client
        },
        transports: [
            'websocket'
        ]
    });
    $895d6185463ab8db$var$moodSocket.on('connect', ()=>{
        console.log("\u2705 Connected to mood board socket:", $895d6185463ab8db$var$moodSocket.id);
        localStorage.setItem('moodSocketId', $895d6185463ab8db$var$moodSocket.id);
        $895d6185463ab8db$var$moodSocket.emit('registerMoodBoard', {
            moodSocketId: $895d6185463ab8db$var$moodSocket.id,
            sessionId: sessionId
        });
    });
    $895d6185463ab8db$var$moodSocket.on('disconnect', (reason)=>{
        console.warn(`\u{274C} Mood board socket disconnected: ${reason}`);
    });
    $895d6185463ab8db$var$moodSocket.on('connect_error', (err)=>{
        console.error("\u274C Connection error:", err);
    });
    $895d6185463ab8db$var$moodSocket.on('transactionBurst', (data)=>{
        console.log("\uD83C\uDF86 Received transactionBurst:", data);
        if (!data) return;
        let moodScore = Number(data.moodScore);
        if (!isNaN(moodScore)) $895d6185463ab8db$export$f41080da4e2fdf9f(moodScore);
        else console.warn("\u26A0\uFE0F Invalid moodScore in transactionBurst:", data.moodScore);
    });
}
function $895d6185463ab8db$var$handleReconnect() {
    if ($895d6185463ab8db$var$reconnectAttempts < $895d6185463ab8db$var$MAX_RECONNECT_ATTEMPTS) {
        $895d6185463ab8db$var$reconnectAttempts++;
        console.log(`\u{1F504} Reattempting connection (${$895d6185463ab8db$var$reconnectAttempts}/${$895d6185463ab8db$var$MAX_RECONNECT_ATTEMPTS})...`);
        setTimeout($895d6185463ab8db$var$connectMoodSocket, 2000);
    } else console.error(`\u{274C} Maximum reconnection attempts (${$895d6185463ab8db$var$MAX_RECONNECT_ATTEMPTS}) reached.`);
}
function $895d6185463ab8db$var$setupMoodBoardListeners() {
    if ($895d6185463ab8db$var$moodSocketSetupComplete) {
        console.log("\uD83C\uDFA7 Mood Board listeners already set up. Skipping.");
        return;
    }
    console.log("\u2705 Setting up Mood Board WebSocket listeners.");
    // Check if we're using socket.io or native WebSockets
    if ($895d6185463ab8db$var$moodSocket && typeof $895d6185463ab8db$var$moodSocket.on === 'function') // Socket.io style already handled in connectMoodSocket
    console.log("\u2705 Using Socket.io style listeners (already configured).");
    else if ($895d6185463ab8db$var$moodSocket) // Native WebSocket API
    $895d6185463ab8db$var$moodSocket.onmessage = (event)=>{
        try {
            const data = JSON.parse(event.data);
            console.log("\uD83D\uDCAC Mood Board WebSocket received message:", data);
            if (data.type === "authenticated") console.log("\u2705 WebSocket authentication successful!");
            else if (data.type === "burstMessage") handleBurstMessage(data);
        } catch (err) {
            console.error("\u26A0\uFE0F Error processing Mood Board WebSocket message:", err);
        }
    };
    else console.error("\u274C Cannot set up listeners - moodSocket is not initialized.");
    $895d6185463ab8db$var$moodSocketSetupComplete = true;
}
function $895d6185463ab8db$var$ensureBurstListener() {
    if ($895d6185463ab8db$var$socketSetupComplete) {
        console.log("\uD83C\uDFA7 Burst listener already set up. Skipping.");
        return;
    }
    console.log("\u2705 Setting up burst listener.");
    $895d6185463ab8db$var$setupBurstListener();
    $895d6185463ab8db$var$socketSetupComplete = true;
    $895d6185463ab8db$var$moodSocketSetupComplete = true;
}
async function $895d6185463ab8db$var$loadP5() {
    if (!window.p5) {
        const script = document.createElement("script");
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/p5.js/1.4.0/p5.min.js";
        script.onload = ()=>$895d6185463ab8db$var$initP5Sketch(); // Call initP5Sketch after loading
        document.body.appendChild(script);
    } else $895d6185463ab8db$var$initP5Sketch(); // Initialize if p5 is already loaded
}
function $895d6185463ab8db$var$initP5Sketch() {
    const container = document.getElementById('moodCanvas');
    if (!container) {
        console.error("\u274C moodCanvas not found. Aborting p5.js initialization.");
        return;
    }
    if ($895d6185463ab8db$var$p5Instance && typeof $895d6185463ab8db$var$p5Instance.remove === 'function') {
        console.log("\uD83D\uDED1 Removing previous p5 instance...");
        $895d6185463ab8db$var$p5Instance.remove();
    }
    console.log("\u2705 moodCanvas found. Initializing p5 sketch...");
    $895d6185463ab8db$var$p5Instance = new window.p5($895d6185463ab8db$var$pixelMoodArt, "moodCanvas");
}
function $895d6185463ab8db$var$setupBurstListener() {
    if ($895d6185463ab8db$var$socketSetupComplete) {
        console.log("\uD83C\uDFA7 Burst listener already set up. Skipping.");
        return;
    }
    console.log("\u2705 Setting up burst listener.");
    document.addEventListener("transactionBurst", (event)=>{
        const data = event.detail;
        console.log("\uD83C\uDF86 TRANSACTION BURST EVENT RECEIVED:", JSON.stringify(data));
        if (!data) {
            console.error("\u26A0\uFE0F Empty transaction burst data received");
            return;
        }
        const { moodScore: moodScore, transactionId: transactionId } = data;
        if (typeof moodScore === "number") {
            console.log(`\u{1F525} Triggering burst with mood score: ${moodScore} for transaction: ${transactionId}`);
            $895d6185463ab8db$export$f41080da4e2fdf9f(moodScore);
        } else console.warn("\u26A0\uFE0F Invalid mood score in transaction burst event:", data);
    });
    document.addEventListener("bidAcceptSuccess", (event)=>{
        const data = event.detail;
        console.log("\uD83D\uDCE3 Bid accept success received:", data);
        if (data.moodResult && typeof data.moodResult.transactionMoodScore === "number") {
            console.log("\uD83D\uDCCA Transaction mood score from acceptance:", data.moodResult.transactionMoodScore);
            $895d6185463ab8db$export$f41080da4e2fdf9f(data.moodResult.transactionMoodScore);
        }
    });
    document.addEventListener("bidDeclineSuccess", (event)=>{
        const data = event.detail;
        console.log("\uD83D\uDCE3 Bid decline success received:", data);
        if (data.moodResult && typeof data.moodResult.transactionMoodScore === "number") {
            console.log("\uD83D\uDCCA Transaction mood score from decline:", data.moodResult.transactionMoodScore);
            $895d6185463ab8db$export$f41080da4e2fdf9f(data.moodResult.transactionMoodScore);
        }
    });
    $895d6185463ab8db$var$socketSetupComplete = true;
    console.log("\u2705 Burst listener setup complete.");
}
async function $895d6185463ab8db$var$initializeBoard() {
    // Establish the WebSocket connection only once.
    if (!$895d6185463ab8db$var$moodSocket || typeof $895d6185463ab8db$var$moodSocket.connected !== 'undefined' && !$895d6185463ab8db$var$moodSocket.connected) {
        console.log("\uD83D\uDD0C Establishing WebSocket connection...");
        $895d6185463ab8db$var$connectMoodSocket();
    }
    $895d6185463ab8db$var$ensureBurstListener();
    await $895d6185463ab8db$var$loadP5();
    await $895d6185463ab8db$var$initMoodPage();
    // Start periodic mood data updates (e.g., every 15 seconds).
    if ($895d6185463ab8db$var$updateTimer) clearInterval($895d6185463ab8db$var$updateTimer);
    $895d6185463ab8db$var$updateTimer = setInterval($895d6185463ab8db$var$initMoodPage, 15000);
}
async function $895d6185463ab8db$var$initMoodPage() {
    try {
        console.log("\uD83D\uDCCC Refreshing Mood Page Data...");
        $895d6185463ab8db$var$sessionId = localStorage.getItem("sessionId");
        if (!$895d6185463ab8db$var$sessionId) {
            console.error("\u274C No session ID found in localStorage. Are you logged in?");
            $895d6185463ab8db$var$showNotification("Session ID is missing. Please log in.", false);
            return;
        }
        console.log("\u2705 Session ID retrieved:", $895d6185463ab8db$var$sessionId);
        const traderMood = await $895d6185463ab8db$var$fetchTraderMood($895d6185463ab8db$var$sessionId);
        const marketMood = await $895d6185463ab8db$var$fetchMarketMood($895d6185463ab8db$var$sessionId);
        // Log raw responses for debugging.
        console.log("\uD83D\uDCCA Raw market mood response:", marketMood);
        // (Optional) Store previous values for logging.
        const oldUserMoodScore = $895d6185463ab8db$var$userMoodScore;
        const oldMarketMoodScore = $895d6185463ab8db$var$marketMoodScore;
        // --- CALCULATE USER MOOD ---
        if (traderMood) {
            if (typeof traderMood.averageMood !== "undefined" && !isNaN(parseFloat(traderMood.averageMood))) {
                $895d6185463ab8db$var$userMoodScore = parseFloat(traderMood.averageMood);
                console.log("\uD83D\uDCCA Using API-provided user mood:", $895d6185463ab8db$var$userMoodScore);
            } else if (traderMood.details?.moodHistory && traderMood.details.moodHistory.length > 0) {
                $895d6185463ab8db$var$userMoodScore = $895d6185463ab8db$var$calculateWeightedMood(traderMood.details.moodHistory);
                console.log("\uD83D\uDCCA Calculated user mood from details.moodHistory:", $895d6185463ab8db$var$userMoodScore);
            } else if (traderMood.moodHistory && traderMood.moodHistory.length > 0) {
                $895d6185463ab8db$var$userMoodScore = $895d6185463ab8db$var$calculateWeightedMood(traderMood.moodHistory);
                console.log("\uD83D\uDCCA Calculated user mood from moodHistory:", $895d6185463ab8db$var$userMoodScore);
            } else {
                console.warn("\u26A0\uFE0F No valid user mood data in API response");
                $895d6185463ab8db$var$userMoodScore = isNaN($895d6185463ab8db$var$userMoodScore) || $895d6185463ab8db$var$userMoodScore === 0 ? 0.25 : $895d6185463ab8db$var$userMoodScore;
            }
        } else {
            console.warn("\u26A0\uFE0F Failed to retrieve trader mood data");
            $895d6185463ab8db$var$userMoodScore = isNaN($895d6185463ab8db$var$userMoodScore) || $895d6185463ab8db$var$userMoodScore === 0 ? 0.25 : $895d6185463ab8db$var$userMoodScore;
        }
        // Apply the amplification factor to the user mood.
        $895d6185463ab8db$var$userMoodScore *= $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR;
        console.log("\uD83D\uDCCA Amplified user mood:", $895d6185463ab8db$var$userMoodScore);
        // --- CALCULATE MARKET MOOD ---
        if (marketMood) {
            if (typeof marketMood.averageMood !== "undefined" && !isNaN(parseFloat(marketMood.averageMood))) {
                $895d6185463ab8db$var$marketMoodScore = parseFloat(marketMood.averageMood);
                console.log("\uD83D\uDCCA Base market mood from API:", $895d6185463ab8db$var$marketMoodScore);
                $895d6185463ab8db$var$marketMoodScore *= $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR;
                console.log("\uD83D\uDCCA Amplified market mood:", $895d6185463ab8db$var$marketMoodScore);
            } else {
                console.warn("\u26A0\uFE0F No valid market mood average in API response");
                $895d6185463ab8db$var$marketMoodScore = isNaN($895d6185463ab8db$var$marketMoodScore) ? -1.8 * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR : $895d6185463ab8db$var$marketMoodScore;
            }
        } else {
            console.warn("\u26A0\uFE0F Failed to retrieve market mood data");
            $895d6185463ab8db$var$marketMoodScore = isNaN($895d6185463ab8db$var$marketMoodScore) ? -1.8 * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR : $895d6185463ab8db$var$marketMoodScore;
        }
        // Ensure mood scores are finite numbers.
        $895d6185463ab8db$var$userMoodScore = isFinite($895d6185463ab8db$var$userMoodScore) ? $895d6185463ab8db$var$userMoodScore : 0.25 * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR;
        $895d6185463ab8db$var$marketMoodScore = isFinite($895d6185463ab8db$var$marketMoodScore) ? $895d6185463ab8db$var$marketMoodScore : -0.15 * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR;
        // Update UI elements.
        if (traderMood) $895d6185463ab8db$var$displayTraderMood(traderMood);
        if (marketMood) $895d6185463ab8db$var$displayMarketMood(marketMood);
        $895d6185463ab8db$var$displayMoodScores();
        console.log("\u2705 Final mood values:", {
            userMoodScore: $895d6185463ab8db$var$userMoodScore.toFixed(3),
            marketMoodScore: $895d6185463ab8db$var$marketMoodScore.toFixed(3)
        });
    } catch (error) {
        console.error("\u274C Error in initMoodPage:", error);
        $895d6185463ab8db$var$userMoodScore = isNaN($895d6185463ab8db$var$userMoodScore) ? 0.25 * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR : $895d6185463ab8db$var$userMoodScore;
        $895d6185463ab8db$var$marketMoodScore = isNaN($895d6185463ab8db$var$marketMoodScore) ? -0.15 * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR : $895d6185463ab8db$var$marketMoodScore;
        $895d6185463ab8db$var$displayMoodScores();
        $895d6185463ab8db$var$showNotification("Error loading mood data. Using fallback values.", false);
    }
}
function $895d6185463ab8db$var$calculateWeightedMood(moodHistory1) {
    if (!moodHistory1 || !Array.isArray(moodHistory1) || moodHistory1.length === 0) {
        console.warn("\u26A0\uFE0F Invalid mood history data");
        return 0;
    }
    // Process and validate entries
    const validEntries = moodHistory1.filter((entry)=>entry && (typeof entry.positiveImpact !== 'undefined' || typeof entry.negativeImpact !== 'undefined' || typeof entry.value !== 'undefined')).map((entry)=>({
            positiveImpact: parseFloat(entry.positiveImpact) || 0,
            negativeImpact: parseFloat(entry.negativeImpact) || 0,
            value: parseFloat(entry.value) || entry.positiveImpact - entry.negativeImpact || 0,
            timestamp: entry.timestamp || new Date().toISOString()
        }));
    if (validEntries.length === 0) {
        console.warn("\u26A0\uFE0F No valid entries in mood history");
        return 0;
    }
    // Sort by timestamp (newest first) and take most recent 5
    const recentHistory = [
        ...validEntries
    ].sort((a, b)=>new Date(b.timestamp) - new Date(a.timestamp)).slice(0, 5);
    console.log("\uD83D\uDCCA Recent mood history entries for calculation:", recentHistory.length);
    // Apply weighted calculation with decaying importance
    let weightedMood = 0;
    let totalWeight = 0;
    recentHistory.forEach((entry, index)=>{
        const weight = Math.pow(2, 4 - index); // Exponential decay: 16, 8, 4, 2, 1
        const entryMood = entry.value || entry.positiveImpact - entry.negativeImpact;
        console.log(`Entry mood ${index}: ${entryMood} with weight ${weight}`);
        weightedMood += entryMood * weight;
        totalWeight += weight;
    });
    const result = totalWeight > 0 ? weightedMood / totalWeight : 0;
    console.log(`Weighted mood calculation result: ${result}`);
    return result;
}
async function $895d6185463ab8db$var$fetchTraderMood(sessionId) {
    if (!sessionId) sessionId = localStorage.getItem("sessionId"); // Fallback
    if (!sessionId) {
        console.error("\u274C Missing sessionId in localStorage!");
        $895d6185463ab8db$var$showNotification("Error: No session ID found", false);
        return null;
    }
    try {
        console.log("\uD83D\uDCCA Fetching trader mood with sessionId:", sessionId);
        const startTime = Date.now();
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/mood/trader/${sessionId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            cache: 'no-store'
        });
        const elapsedTime = Date.now() - startTime;
        console.log(`\u{1F4CA} Trader mood API response time: ${elapsedTime}ms`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        // Parse the JSON response
        const data = await response.json();
        console.log("\uD83D\uDCCA Trader mood data received:", data);
        // Verify the data structure
        if (typeof data.averageMood === 'undefined') console.warn("\u26A0\uFE0F Trader mood response missing averageMood field");
        return data;
    } catch (error) {
        console.error('Error fetching trader mood:', error);
        $895d6185463ab8db$var$showNotification(`Error fetching trader mood: ${error.message}`, false);
        return null;
    }
}
function $895d6185463ab8db$var$displayTraderMood(traderMood) {
    if (!traderMood) return;
    const traderMoodElement = document.getElementById('traderMood');
    if (traderMoodElement) {
        // Check each possible location for averageMood in the API response
        let moodValue;
        if (traderMood.averageMood !== undefined && !isNaN(parseFloat(traderMood.averageMood))) moodValue = parseFloat(traderMood.averageMood);
        else if (traderMood.details?.averageMood !== undefined && !isNaN(parseFloat(traderMood.details.averageMood))) moodValue = parseFloat(traderMood.details.averageMood);
        else moodValue = null;
        if (moodValue !== null) {
            traderMoodElement.textContent = `Your Mood: ${moodValue.toFixed(2)}`;
            traderMoodElement.style.color = $895d6185463ab8db$var$getMoodTextColor(moodValue);
        } else {
            traderMoodElement.textContent = `Your Mood: N/A`;
            traderMoodElement.style.color = $895d6185463ab8db$var$getMoodTextColor(0);
        }
    }
    // Display baseline factors if available
    if (traderMood.baseline || traderMood.details?.baseline) $895d6185463ab8db$var$displayMoodFactors(traderMood.baseline || traderMood.details?.baseline);
}
async function $895d6185463ab8db$var$fetchMarketMood(sessionId) {
    if (!sessionId) sessionId = localStorage.getItem("sessionId"); // Fallback
    if (!sessionId) {
        console.error("\u274C Error: Missing sessionId in localStorage!");
        $895d6185463ab8db$var$showNotification("Error: No session ID found", false);
        return null;
    }
    try {
        console.log(`\u{1F4CA} Fetching market mood with sessionId: ${sessionId}`);
        const startTime = Date.now();
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/mood/market/${sessionId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            cache: 'no-store'
        });
        const elapsedTime = Date.now() - startTime;
        console.log(`\u{1F4CA} Market mood API response time: ${elapsedTime}ms`);
        if (!response.ok) {
            console.error(`\u{274C} HTTP error! status: ${response.status}`);
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("\uD83D\uDCCA Market mood response:", data);
        // Verify the data structure
        if (typeof data.averageMood === 'undefined') console.warn("\u26A0\uFE0F Market mood response missing averageMood field");
        return data;
    } catch (error) {
        console.error("\u274C Error fetching market mood:", error);
        $895d6185463ab8db$var$showNotification(`Error fetching market mood: ${error.message}`, false);
        return null;
    }
}
function $895d6185463ab8db$var$displayMarketMood(marketMood) {
    if (!marketMood) return;
    const marketMoodElement = document.getElementById('marketMood');
    if (marketMoodElement) {
        // Check if averageMood exists and is a number
        if (marketMood.averageMood !== undefined && !isNaN(parseFloat(marketMood.averageMood))) {
            const moodValue = parseFloat(marketMood.averageMood);
            marketMoodElement.textContent = `Market Mood: ${moodValue.toFixed(2)}`;
            marketMoodElement.style.color = $895d6185463ab8db$var$getMoodTextColor(moodValue);
        } else {
            marketMoodElement.textContent = `Market Mood: N/A`;
            marketMoodElement.style.color = $895d6185463ab8db$var$getMoodTextColor(0);
        }
    }
    // Display transaction count if available
    const txCountElement = document.getElementById('transactionCount');
    if (txCountElement && marketMood.transactionCount) txCountElement.textContent = `Based on ${marketMood.transactionCount} transactions`;
}
function $895d6185463ab8db$export$f41080da4e2fdf9f(moodScore) {
    console.log(`\u{1F3AF} triggerBurst called with score: ${moodScore}`);
    if (!$895d6185463ab8db$var$p5Instance) {
        console.error("\u26A0\uFE0F Cannot trigger burst - p5Instance not initialized");
        return;
    }
    // If grid dimensions are not set, recalc using p5Instance's width/height.
    if (!$895d6185463ab8db$var$cols || !$895d6185463ab8db$var$rows) {
        console.warn("Grid dimensions missing. Recomputing grid.");
        const grid = computeGrid($895d6185463ab8db$var$p5Instance.width, $895d6185463ab8db$var$p5Instance.height, 0);
        $895d6185463ab8db$var$cellSize = grid.cellSize;
        $895d6185463ab8db$var$cols = grid.cols;
        $895d6185463ab8db$var$rows = grid.rows;
    }
    const burstColor = $895d6185463ab8db$var$moodToColor(moodScore);
    const intensity = Math.min(5, Math.abs(moodScore));
    const burstCount = Math.floor(20 * (intensity / 5)) + 5;
    console.log(`\u{1F3A8} Creating ${burstCount} bursts with color ${burstColor} (intensity: ${intensity})`);
    for(let i = 0; i < burstCount; i++){
        const centerX = Math.floor(Math.random() * $895d6185463ab8db$var$cols);
        const centerY = Math.floor(Math.random() * $895d6185463ab8db$var$rows);
        const offset = i / burstCount * Math.PI * 2;
        const distance = Math.random() * 10;
        const x = Math.floor(centerX + Math.cos(offset) * distance);
        const y = Math.floor(centerY + Math.sin(offset) * distance);
        const clampedX = Math.max(0, Math.min($895d6185463ab8db$var$cols - 1, x));
        const clampedY = Math.max(0, Math.min($895d6185463ab8db$var$rows - 1, y));
        $895d6185463ab8db$var$burstCells.push({
            x: clampedX,
            y: clampedY,
            color: burstColor,
            life: 120 + Math.random() * 60,
            size: 1.5 + Math.random() * 1.5,
            alpha: 0.85 + Math.random() * 0.15,
            intensity: intensity
        });
    }
    console.log(`\u{2728} Created ${burstCount} burst cells with color ${burstColor}`);
    // Restart the loop if it's not active.
    if ($895d6185463ab8db$var$p5Instance && typeof $895d6185463ab8db$var$p5Instance.loop === 'function' && !$895d6185463ab8db$var$p5Instance.isLooping()) $895d6185463ab8db$var$p5Instance.loop();
}
function $895d6185463ab8db$var$displayMoodScores() {
    const scoresContainer = document.getElementById('moodScoresContainer');
    if (!scoresContainer) {
        console.error("Error: moodScoresContainer not found in the DOM");
        return;
    }
    // Get current time for the update timestamp
    const now = new Date();
    const timeStr = now.toLocaleTimeString();
    // Format values to display (fixing any potential NaN issues)
    const userScore = isFinite($895d6185463ab8db$var$userMoodScore) ? $895d6185463ab8db$var$userMoodScore.toFixed(3) : "0.000";
    const marketScore = isFinite($895d6185463ab8db$var$marketMoodScore) ? $895d6185463ab8db$var$marketMoodScore.toFixed(3) : "0.000";
    const difference = isFinite($895d6185463ab8db$var$userMoodScore) && isFinite($895d6185463ab8db$var$marketMoodScore) ? Math.abs($895d6185463ab8db$var$userMoodScore - $895d6185463ab8db$var$marketMoodScore).toFixed(3) : "0.000";
    // Update the HTML content
    scoresContainer.innerHTML = `
	  <div style="text-align: center; margin-bottom: 8px; border-bottom: 1px solid #00FFFF; padding-bottom: 5px;">
		<span style="color: #FF00FF; font-size: 16px; font-weight: bold;">MOOD SCORES</span>
	  </div>
	  <div style="margin-bottom: 8px;">
		<span style="color: #FFA500; font-weight: bold;">User Score: </span>
		<span style="color: ${$895d6185463ab8db$var$getMoodTextColor($895d6185463ab8db$var$userMoodScore)}; font-weight: bold;">${userScore}</span>
	  </div>
	  <div style="margin-bottom: 8px;">
		<span style="color: #FFA500; font-weight: bold;">Market Score: </span>
		<span style="color: ${$895d6185463ab8db$var$getMoodTextColor($895d6185463ab8db$var$marketMoodScore)}; font-weight: bold;">${marketScore}</span>
	  </div>
	  <div style="margin-bottom: 8px;">
		<span style="color: #FFA500;">Difference: </span>
		<span style="font-weight: bold;">${difference}</span>
	  </div>
	  <div style="margin-bottom: 8px;">
		<span style="color: #FFA500;">Amp Factor: </span>
		<span style="font-weight: bold;">${$895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR}</span>
	  </div>
	  <div style="font-size: 12px; color: #999; text-align: right; margin-top: 10px; border-top: 1px dotted #555; padding-top: 5px;">
		Updated: ${timeStr}
	  </div>
	`;
}
function $895d6185463ab8db$var$displayMoodFactors(baseline) {
    const factorsContainer = document.getElementById('moodFactors');
    if (!factorsContainer) return;
    factorsContainer.innerHTML = '';
    const factors = [
        {
            name: 'Positive Mental',
            value: baseline.positiveMental
        },
        {
            name: 'Negative Mental',
            value: baseline.negativeMental
        },
        {
            name: 'Positive Experience',
            value: baseline.positiveExperience
        },
        {
            name: 'Negative Experience',
            value: baseline.negativeExperience
        }
    ];
    factors.forEach((factor)=>{
        const factorElement = document.createElement('div');
        factorElement.className = 'mood-factor';
        factorElement.innerHTML = `
	  <span>${factor.name}:</span>
	  <div class="factor-bar">
		<div class="factor-fill" style="width: ${Math.abs(factor.value) * 10}%; 
									   background-color: ${factor.value >= 0 ? '#4CAF50' : '#F44336'}"></div>
	  </div>
	  <span>${factor.value.toFixed(2)}</span>
	`;
        factorsContainer.appendChild(factorElement);
    });
}
function $895d6185463ab8db$var$getMoodTextColor(moodScore) {
    if (moodScore >= 2) return "#FF4500"; // Red (Very Positive)
    if (moodScore >= 1) return "#FFA500"; // Orange (Positive)
    if (moodScore >= 0) return "#00FF00"; // Green (Neutral to Slightly Positive)
    if (moodScore >= -1) return "#00BFFF"; // Blue (Negative)
    return "#4B0082"; // Indigo (Very Negative)
}
function $895d6185463ab8db$var$moodToColor(moodScore) {
    if (moodScore >= 2) return "rgb(255, 69, 0)"; // Red (Very Positive)
    if (moodScore >= 1) return "rgba(255, 135, 0, 0.858)"; // Orange (Positive)
    if (moodScore >= 0) return "rgb(0, 255, 0)"; // Green (Neutral to Slightly Positive)
    if (moodScore >= -1) return "rgb(0, 191, 255)"; // Blue (Negative)
    return "rgb(75, 0, 130)"; // Indigo (Very Negative)
}
// Enhanced pixelated mood art with improved sensitivity and color diversity
function $895d6185463ab8db$var$pixelMoodArt(p) {
    let t = 0;
    let palette = [];
    let moodDifference = 0;
    let lastUserMood = null;
    let lastMarketMood = null;
    p.setup = function() {
        const w = Math.min(window.innerWidth, 800);
        const h = Math.min(window.innerHeight, 600);
        p.createCanvas(w, h);
        p.noSmooth(); // Ensures a pixelated look
        p.frameRate(30); // Increase framerate for smoother animations
        updatePalette();
    };
    function updatePalette() {
        // Only regenerate palette if mood scores have changed
        if (lastUserMood !== $895d6185463ab8db$var$userMoodScore || lastMarketMood !== $895d6185463ab8db$var$marketMoodScore) {
            console.log("\uD83D\uDD04 Regenerating mood palette with scores:", $895d6185463ab8db$var$userMoodScore, $895d6185463ab8db$var$marketMoodScore);
            // Dynamically adjust grid resolution based on market activity and mood difference
            moodDifference = Math.abs($895d6185463ab8db$var$marketMoodScore - $895d6185463ab8db$var$userMoodScore);
            $895d6185463ab8db$var$cellSize = Math.floor(Math.min(p.width, p.height) / (45 + moodDifference * 15));
            // Update the global variables so triggerBurst can access them
            $895d6185463ab8db$var$cols = Math.ceil(p.width / $895d6185463ab8db$var$cellSize);
            $895d6185463ab8db$var$rows = Math.ceil(p.height / $895d6185463ab8db$var$cellSize);
            palette = $895d6185463ab8db$var$generateHypersensitivePalette($895d6185463ab8db$var$userMoodScore, $895d6185463ab8db$var$marketMoodScore);
            // Store current values for comparison
            lastUserMood = $895d6185463ab8db$var$userMoodScore;
            lastMarketMood = $895d6185463ab8db$var$marketMoodScore;
        }
    }
    p.draw = function() {
        updatePalette();
        p.background(0);
        // Animation speed responds to market volatility
        const volatilityFactor = Math.abs($895d6185463ab8db$var$marketMoodScore) * 0.015;
        t += 0.015 + volatilityFactor;
        // Draw the base mood grid
        for(let i = 0; i < $895d6185463ab8db$var$cols; i++)for(let j = 0; j < $895d6185463ab8db$var$rows; j++){
            const x = i * $895d6185463ab8db$var$cellSize;
            const y = j * $895d6185463ab8db$var$cellSize;
            const noiseVal = p.noise(i * 0.1 + Math.sin(t * 0.02) * 0.1, j * 0.1 + Math.cos(t * 0.02) * 0.1, t * 0.1);
            const moodFactor = p.map($895d6185463ab8db$var$userMoodScore, -5, 5, 0.5, 1.2) * p.map($895d6185463ab8db$var$marketMoodScore, -5, 5, 0.7, 1.1);
            const paletteIndex = Math.floor(noiseVal * palette.length * moodFactor) % palette.length;
            let col = p.color(palette[paletteIndex]);
            const moodRelationship = $895d6185463ab8db$var$userMoodScore / ($895d6185463ab8db$var$marketMoodScore !== 0 ? $895d6185463ab8db$var$marketMoodScore : 0.01);
            const brightnessMod = p.map(moodRelationship, -5, 5, 0.5, 1.2);
            const contrastMod = p.map($895d6185463ab8db$var$marketMoodScore, -5, 5, 0.7, 1.1);
            let r = p.constrain(p.red(col) * brightnessMod * contrastMod, 0, 255);
            let g = p.constrain(p.green(col) * brightnessMod, 0, 255);
            let b = p.constrain(p.blue(col) * (2 - brightnessMod), 0, 255);
            let alpha = p.map(p.noise(i * 0.2, j * 0.2, t * 0.1), 0, 1, 180, 255);
            col = p.color(r, g, b, alpha);
            p.fill(col);
            p.noStroke();
            const flowSpeed = p.map(Math.abs($895d6185463ab8db$var$marketMoodScore), 0, 1, 0.1, 0.5);
            let xOffset = p.sin(t * flowSpeed + i * 0.1) * $895d6185463ab8db$var$cellSize * 0.15;
            let yOffset = p.cos(t * flowSpeed + j * 0.1) * $895d6185463ab8db$var$cellSize * 0.15;
            const pulseSize = $895d6185463ab8db$var$cellSize * (1 + Math.sin(t * 0.15) * 0.1 * Math.abs($895d6185463ab8db$var$marketMoodScore));
            p.rect(x + xOffset, y + yOffset, pulseSize, pulseSize);
        }
        // Draw burst cells on top (IMPORTANT: This needs to be outside the grid loops)
        if ($895d6185463ab8db$var$burstCells.length > 0) {
            p.push(); // Save drawing state
            for(let i = $895d6185463ab8db$var$burstCells.length - 1; i >= 0; i--){
                const cell = $895d6185463ab8db$var$burstCells[i];
                // Calculate alpha based on life
                const lifeRatio = cell.life / 120; // Normalize to 0-1
                const alpha = lifeRatio * (cell.alpha || 0.9);
                const intensity = cell.intensity || 1;
                // Calculate size with pulsing effect
                const pulseFactor = 1 + 0.2 * Math.sin(p.frameCount * 0.2);
                const size = $895d6185463ab8db$var$cellSize * (cell.size || 1.5) * pulseFactor;
                // Position with slight movement
                const wobbleX = Math.sin(p.frameCount * 0.1 + i) * $895d6185463ab8db$var$cellSize * 0.1 * lifeRatio;
                const wobbleY = Math.cos(p.frameCount * 0.1 + i) * $895d6185463ab8db$var$cellSize * 0.1 * lifeRatio;
                const x = cell.x * $895d6185463ab8db$var$cellSize + wobbleX;
                const y = cell.y * $895d6185463ab8db$var$cellSize + wobbleY;
                // Parse the color
                let r, g, b;
                if (typeof cell.color === 'string') {
                    const match = cell.color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
                    if (match) {
                        r = parseInt(match[1]);
                        g = parseInt(match[2]);
                        b = parseInt(match[3]);
                    } else {
                        // Fallback color if parsing fails
                        r = 255;
                        g = 255;
                        b = 255;
                    }
                } else {
                    // Another fallback
                    r = 255;
                    g = 255;
                    b = 255;
                }
                // Draw outer glow
                const glowSize = size * 1.5;
                const glowAlpha = alpha * 0.3;
                p.fill(p.color(`rgba(${r}, ${g}, ${b}, ${glowAlpha})`));
                p.rect(x - (glowSize - size) / 2, y - (glowSize - size) / 2, glowSize, glowSize);
                // Draw main burst
                p.fill(p.color(`rgba(${r}, ${g}, ${b}, ${alpha})`));
                p.rect(x, y, size, size);
                // Draw bright core
                if (cell.life > 60) {
                    const coreSize = size * 0.5;
                    const coreAlpha = alpha * 1.5; // Brighter than the main burst
                    p.fill(p.color(`rgba(255, 255, 255, ${coreAlpha})`));
                    p.rect(x + size / 2 - coreSize / 2, y + size / 2 - coreSize / 2, coreSize, coreSize);
                }
                // Update life
                cell.life -= 1 + intensity * 0.5; // Higher intensity = faster decay
                // Remove expired cells
                if (cell.life <= 0) $895d6185463ab8db$var$burstCells.splice(i, 1);
            }
            p.pop(); // Restore drawing state
        }
    };
    p.windowResized = function() {
        const w = Math.min(window.innerWidth, 800);
        const h = Math.min(window.innerHeight, 600);
        p.resizeCanvas(w, h);
        updatePalette();
    };
}
// Generate an ultra-sensitive palette with micro-gradations for market mood visualization
function $895d6185463ab8db$var$generateHypersensitivePalette(userMood, marketMood) {
    let palette = [];
    // Precise decimal calculation to avoid floating point errors
    const moodRounded = Math.round(marketMood * 100) / 100;
    // Clamp the market mood to a safe range to prevent errors
    const safeMarketMood = Math.max(-5, Math.min(5, moodRounded));
    if (safeMarketMood >= 5.0) // Ultra bright golden yellow
    palette = [
        "rgba(255, 255, 100, 0.95)",
        "rgba(255, 250, 50, 0.9)",
        "rgba(255, 245, 0, 0.85)",
        "rgba(255, 240, 0, 0.8)",
        "rgba(255, 235, 0, 0.75)",
        "rgba(255, 230, 50, 0.7)",
        "rgba(255, 225, 100, 0.65)",
        "rgba(255, 220, 150, 0.6)"
    ];
    else if (safeMarketMood >= 4.9) palette = [
        "rgba(255, 253, 95, 0.95)",
        "rgba(255, 248, 48, 0.9)",
        "rgba(255, 243, 0, 0.85)",
        "rgba(255, 238, 0, 0.8)",
        "rgba(255, 233, 0, 0.75)",
        "rgba(255, 228, 48, 0.7)",
        "rgba(255, 223, 95, 0.65)",
        "rgba(255, 218, 145, 0.6)"
    ];
    else if (safeMarketMood >= 4.8) palette = [
        "rgba(255, 252, 90, 0.95)",
        "rgba(255, 247, 45, 0.9)",
        "rgba(255, 242, 0, 0.85)",
        "rgba(255, 237, 0, 0.8)",
        "rgba(255, 232, 0, 0.75)",
        "rgba(255, 227, 45, 0.7)",
        "rgba(255, 222, 90, 0.65)",
        "rgba(255, 217, 140, 0.6)"
    ];
    else if (safeMarketMood >= 4.7) palette = [
        "rgba(255, 251, 85, 0.95)",
        "rgba(255, 246, 43, 0.9)",
        "rgba(255, 241, 0, 0.85)",
        "rgba(255, 236, 0, 0.8)",
        "rgba(255, 231, 0, 0.75)",
        "rgba(255, 226, 43, 0.7)",
        "rgba(255, 221, 85, 0.65)",
        "rgba(255, 216, 135, 0.6)"
    ];
    else if (safeMarketMood >= 4.6) palette = [
        "rgba(255, 250, 83, 0.95)",
        "rgba(255, 245, 42, 0.9)",
        "rgba(255, 240, 0, 0.85)",
        "rgba(255, 235, 0, 0.8)",
        "rgba(255, 230, 0, 0.75)",
        "rgba(255, 225, 42, 0.7)",
        "rgba(255, 220, 83, 0.65)",
        "rgba(255, 215, 130, 0.6)"
    ];
    else if (safeMarketMood >= 4.5) palette = [
        "rgba(255, 250, 80, 0.95)",
        "rgba(255, 245, 40, 0.9)",
        "rgba(255, 240, 0, 0.85)",
        "rgba(255, 235, 0, 0.8)",
        "rgba(255, 230, 0, 0.75)",
        "rgba(255, 225, 40, 0.7)",
        "rgba(255, 220, 80, 0.65)",
        "rgba(255, 215, 120, 0.6)"
    ];
    else if (safeMarketMood >= 4.4) palette = [
        "rgba(255, 248, 75, 0.95)",
        "rgba(255, 243, 38, 0.9)",
        "rgba(255, 238, 0, 0.85)",
        "rgba(255, 233, 0, 0.8)",
        "rgba(255, 228, 0, 0.75)",
        "rgba(255, 223, 38, 0.7)",
        "rgba(255, 218, 75, 0.65)",
        "rgba(255, 213, 115, 0.6)"
    ];
    else if (safeMarketMood >= 4.3) palette = [
        "rgba(255, 247, 70, 0.95)",
        "rgba(255, 242, 35, 0.9)",
        "rgba(255, 237, 0, 0.85)",
        "rgba(255, 232, 0, 0.8)",
        "rgba(255, 227, 0, 0.75)",
        "rgba(255, 222, 35, 0.7)",
        "rgba(255, 217, 70, 0.65)",
        "rgba(255, 212, 110, 0.6)"
    ];
    else if (safeMarketMood >= 4.2) palette = [
        "rgba(255, 246, 65, 0.95)",
        "rgba(255, 241, 33, 0.9)",
        "rgba(255, 236, 0, 0.85)",
        "rgba(255, 231, 0, 0.8)",
        "rgba(255, 226, 0, 0.75)",
        "rgba(255, 221, 33, 0.7)",
        "rgba(255, 216, 65, 0.65)",
        "rgba(255, 211, 105, 0.6)"
    ];
    else if (safeMarketMood >= 4.1) palette = [
        "rgba(255, 245, 63, 0.95)",
        "rgba(255, 240, 32, 0.9)",
        "rgba(255, 235, 0, 0.85)",
        "rgba(255, 230, 0, 0.8)",
        "rgba(255, 225, 0, 0.75)",
        "rgba(255, 220, 32, 0.7)",
        "rgba(255, 215, 63, 0.65)",
        "rgba(255, 210, 100, 0.6)"
    ];
    else if (safeMarketMood >= 4.0) palette = [
        "rgba(255, 245, 60, 0.95)",
        "rgba(255, 240, 30, 0.9)",
        "rgba(255, 235, 0, 0.85)",
        "rgba(255, 230, 0, 0.8)",
        "rgba(255, 225, 0, 0.75)",
        "rgba(255, 220, 30, 0.7)",
        "rgba(255, 215, 60, 0.65)",
        "rgba(255, 210, 90, 0.6)"
    ];
    else if (safeMarketMood >= 3.9) palette = [
        "rgba(255, 244, 55, 0.95)",
        "rgba(255, 239, 28, 0.9)",
        "rgba(255, 234, 0, 0.85)",
        "rgba(255, 229, 0, 0.8)",
        "rgba(255, 224, 0, 0.75)",
        "rgba(255, 219, 28, 0.7)",
        "rgba(255, 214, 55, 0.65)",
        "rgba(255, 209, 85, 0.6)"
    ];
    else if (safeMarketMood >= 3.8) palette = [
        "rgba(255, 243, 53, 0.95)",
        "rgba(255, 238, 26, 0.9)",
        "rgba(255, 233, 0, 0.85)",
        "rgba(255, 228, 0, 0.8)",
        "rgba(255, 223, 0, 0.75)",
        "rgba(255, 218, 26, 0.7)",
        "rgba(255, 213, 53, 0.65)",
        "rgba(255, 208, 83, 0.6)"
    ];
    else if (safeMarketMood >= 3.7) palette = [
        "rgba(255, 242, 50, 0.95)",
        "rgba(255, 237, 25, 0.9)",
        "rgba(255, 232, 0, 0.85)",
        "rgba(255, 227, 0, 0.8)",
        "rgba(255, 222, 0, 0.75)",
        "rgba(255, 217, 25, 0.7)",
        "rgba(255, 212, 50, 0.65)",
        "rgba(255, 207, 80, 0.6)"
    ];
    else if (safeMarketMood >= 3.6) palette = [
        "rgba(255, 241, 48, 0.95)",
        "rgba(255, 236, 24, 0.9)",
        "rgba(255, 231, 0, 0.85)",
        "rgba(255, 226, 0, 0.8)",
        "rgba(255, 221, 0, 0.75)",
        "rgba(255, 216, 24, 0.7)",
        "rgba(255, 211, 48, 0.65)",
        "rgba(255, 206, 75, 0.6)"
    ];
    else if (safeMarketMood >= 3.5) palette = [
        "rgba(255, 240, 45, 0.95)",
        "rgba(255, 235, 22, 0.9)",
        "rgba(255, 230, 0, 0.85)",
        "rgba(255, 225, 0, 0.8)",
        "rgba(255, 220, 0, 0.75)",
        "rgba(255, 215, 22, 0.7)",
        "rgba(255, 210, 45, 0.65)",
        "rgba(255, 205, 70, 0.6)"
    ];
    else if (safeMarketMood >= 3.4) palette = [
        "rgba(255, 239, 40, 0.95)",
        "rgba(255, 234, 20, 0.9)",
        "rgba(255, 229, 0, 0.85)",
        "rgba(255, 224, 0, 0.8)",
        "rgba(255, 219, 0, 0.75)",
        "rgba(255, 214, 20, 0.7)",
        "rgba(255, 209, 40, 0.65)",
        "rgba(255, 204, 65, 0.6)"
    ];
    else if (safeMarketMood >= 3.3) palette = [
        "rgba(255, 238, 38, 0.95)",
        "rgba(255, 233, 18, 0.9)",
        "rgba(255, 228, 0, 0.85)",
        "rgba(255, 223, 0, 0.8)",
        "rgba(255, 218, 0, 0.75)",
        "rgba(255, 213, 18, 0.7)",
        "rgba(255, 208, 38, 0.65)",
        "rgba(255, 203, 60, 0.6)"
    ];
    else if (safeMarketMood >= 3.2) palette = [
        "rgba(255, 237, 35, 0.95)",
        "rgba(255, 232, 16, 0.9)",
        "rgba(255, 227, 0, 0.85)",
        "rgba(255, 222, 0, 0.8)",
        "rgba(255, 217, 0, 0.75)",
        "rgba(255, 212, 16, 0.7)",
        "rgba(255, 207, 35, 0.65)",
        "rgba(255, 202, 55, 0.6)"
    ];
    else if (safeMarketMood >= 3.1) palette = [
        "rgba(255, 236, 30, 0.95)",
        "rgba(255, 231, 14, 0.9)",
        "rgba(255, 226, 0, 0.85)",
        "rgba(255, 221, 0, 0.8)",
        "rgba(255, 216, 0, 0.75)",
        "rgba(255, 211, 14, 0.7)",
        "rgba(255, 206, 30, 0.65)",
        "rgba(255, 201, 50, 0.6)"
    ];
    else if (safeMarketMood >= 3.0) palette = [
        "rgba(255, 235, 25, 0.95)",
        "rgba(255, 230, 12, 0.9)",
        "rgba(255, 225, 0, 0.85)",
        "rgba(255, 220, 0, 0.8)",
        "rgba(255, 215, 0, 0.75)",
        "rgba(255, 210, 12, 0.7)",
        "rgba(255, 205, 25, 0.65)",
        "rgba(255, 200, 45, 0.6)"
    ];
    else if (safeMarketMood >= 2.9) palette = [
        "rgba(255, 234, 23, 0.95)",
        "rgba(255, 229, 11, 0.9)",
        "rgba(255, 224, 0, 0.85)",
        "rgba(255, 219, 0, 0.8)",
        "rgba(255, 214, 0, 0.75)",
        "rgba(255, 209, 11, 0.7)",
        "rgba(255, 204, 23, 0.65)",
        "rgba(255, 199, 43, 0.6)"
    ];
    else if (safeMarketMood >= 2.8) palette = [
        "rgba(255, 232, 20, 0.95)",
        "rgba(255, 227, 10, 0.9)",
        "rgba(255, 222, 0, 0.85)",
        "rgba(255, 217, 0, 0.8)",
        "rgba(255, 212, 0, 0.75)",
        "rgba(255, 207, 10, 0.7)",
        "rgba(255, 202, 20, 0.65)",
        "rgba(255, 197, 40, 0.6)"
    ];
    else if (safeMarketMood >= 2.7) palette = [
        "rgba(255, 230, 18, 0.95)",
        "rgba(255, 225, 8, 0.9)",
        "rgba(255, 220, 0, 0.85)",
        "rgba(255, 215, 0, 0.8)",
        "rgba(255, 210, 0, 0.75)",
        "rgba(255, 205, 8, 0.7)",
        "rgba(255, 200, 18, 0.65)",
        "rgba(255, 195, 38, 0.6)"
    ];
    else if (safeMarketMood >= 2.6) palette = [
        "rgba(255, 228, 15, 0.95)",
        "rgba(255, 223, 7, 0.9)",
        "rgba(255, 218, 0, 0.85)",
        "rgba(255, 213, 0, 0.8)",
        "rgba(255, 208, 0, 0.75)",
        "rgba(255, 203, 7, 0.7)",
        "rgba(255, 198, 15, 0.65)",
        "rgba(255, 193, 35, 0.6)"
    ];
    else if (safeMarketMood >= 2.5) palette = [
        "rgba(255, 225, 12, 0.95)",
        "rgba(255, 220, 6, 0.9)",
        "rgba(255, 215, 0, 0.85)",
        "rgba(255, 210, 0, 0.8)",
        "rgba(255, 205, 0, 0.75)",
        "rgba(255, 200, 6, 0.7)",
        "rgba(255, 195, 12, 0.65)",
        "rgba(255, 190, 32, 0.6)"
    ];
    else if (safeMarketMood >= 2.4) palette = [
        "rgba(255, 223, 10, 0.95)",
        "rgba(255, 218, 5, 0.9)",
        "rgba(255, 213, 0, 0.85)",
        "rgba(255, 208, 0, 0.8)",
        "rgba(255, 203, 0, 0.75)",
        "rgba(255, 198, 5, 0.7)",
        "rgba(255, 193, 10, 0.65)",
        "rgba(255, 188, 30, 0.6)"
    ];
    else if (safeMarketMood >= 2.3) palette = [
        "rgba(255, 222, 8, 0.95)",
        "rgba(255, 217, 4, 0.9)",
        "rgba(255, 212, 0, 0.85)",
        "rgba(255, 207, 0, 0.8)",
        "rgba(255, 202, 0, 0.75)",
        "rgba(255, 197, 4, 0.7)",
        "rgba(255, 192, 8, 0.65)",
        "rgba(255, 187, 28, 0.6)"
    ];
    else if (safeMarketMood >= 2.2) palette = [
        "rgba(255, 221, 6, 0.95)",
        "rgba(255, 216, 3, 0.9)",
        "rgba(255, 211, 0, 0.85)",
        "rgba(255, 206, 0, 0.8)",
        "rgba(255, 201, 0, 0.75)",
        "rgba(255, 196, 3, 0.7)",
        "rgba(255, 191, 6, 0.65)",
        "rgba(255, 186, 26, 0.6)"
    ];
    else if (safeMarketMood >= 2.1) palette = [
        "rgba(255, 220, 4, 0.95)",
        "rgba(255, 215, 2, 0.9)",
        "rgba(255, 210, 0, 0.85)",
        "rgba(255, 205, 0, 0.8)",
        "rgba(255, 200, 0, 0.75)",
        "rgba(255, 195, 2, 0.7)",
        "rgba(255, 190, 4, 0.65)",
        "rgba(255, 185, 24, 0.6)"
    ];
    else if (safeMarketMood >= 2.0) palette = [
        "rgba(255, 255, 30, 0.9)",
        "rgba(255, 240, 0, 0.85)",
        "rgba(255, 220, 0, 0.8)",
        "rgba(255, 215, 0, 0.78)",
        "rgba(255, 235, 60, 0.75)",
        "rgba(255, 248, 130, 0.7)",
        "rgba(255, 253, 190, 0.65)",
        "rgba(255, 255, 220, 0.6)"
    ];
    else if (safeMarketMood >= 1.95) palette = [
        "rgba(255, 253, 25, 0.9)",
        "rgba(255, 235, 0, 0.85)",
        "rgba(255, 215, 0, 0.8)",
        "rgba(255, 210, 0, 0.78)",
        "rgba(255, 230, 55, 0.75)",
        "rgba(255, 245, 125, 0.7)",
        "rgba(255, 250, 185, 0.65)",
        "rgba(255, 253, 215, 0.6)"
    ];
    else if (safeMarketMood >= 1.9) palette = [
        "rgba(255, 250, 20, 0.9)",
        "rgba(255, 230, 0, 0.85)",
        "rgba(255, 210, 0, 0.8)",
        "rgba(255, 205, 0, 0.78)",
        "rgba(255, 225, 50, 0.75)",
        "rgba(255, 240, 120, 0.7)",
        "rgba(255, 245, 180, 0.65)",
        "rgba(255, 250, 210, 0.6)"
    ];
    else if (safeMarketMood >= 1.85) palette = [
        "rgba(255, 245, 15, 0.9)",
        "rgba(255, 225, 0, 0.85)",
        "rgba(255, 205, 0, 0.8)",
        "rgba(255, 200, 0, 0.78)",
        "rgba(255, 220, 45, 0.75)",
        "rgba(255, 235, 115, 0.7)",
        "rgba(255, 240, 175, 0.65)",
        "rgba(255, 245, 205, 0.6)"
    ];
    else if (safeMarketMood >= 1.8) palette = [
        "rgba(255, 240, 10, 0.9)",
        "rgba(255, 220, 0, 0.85)",
        "rgba(255, 200, 0, 0.8)",
        "rgba(255, 195, 0, 0.78)",
        "rgba(255, 215, 40, 0.75)",
        "rgba(255, 230, 110, 0.7)",
        "rgba(255, 235, 170, 0.65)",
        "rgba(255, 240, 200, 0.6)"
    ];
    else if (safeMarketMood >= 1.75) palette = [
        "rgba(255, 235, 5, 0.9)",
        "rgba(255, 215, 0, 0.85)",
        "rgba(255, 195, 0, 0.8)",
        "rgba(255, 190, 0, 0.78)",
        "rgba(255, 210, 35, 0.75)",
        "rgba(255, 225, 105, 0.7)",
        "rgba(255, 230, 165, 0.65)",
        "rgba(255, 235, 195, 0.6)"
    ];
    else if (safeMarketMood >= 1.7) // Transitions to more orange-gold tones
    palette = [
        "rgba(255, 230, 0, 0.9)",
        "rgba(255, 210, 0, 0.85)",
        "rgba(255, 190, 0, 0.8)",
        "rgba(255, 185, 0, 0.78)",
        "rgba(255, 205, 30, 0.75)",
        "rgba(255, 220, 100, 0.7)",
        "rgba(255, 225, 160, 0.65)",
        "rgba(255, 230, 190, 0.6)"
    ];
    else if (safeMarketMood >= 1.65) palette = [
        "rgba(255, 225, 0, 0.9)",
        "rgba(255, 205, 0, 0.85)",
        "rgba(255, 185, 0, 0.8)",
        "rgba(255, 180, 0, 0.78)",
        "rgba(255, 200, 25, 0.75)",
        "rgba(255, 215, 95, 0.7)",
        "rgba(255, 220, 155, 0.65)",
        "rgba(255, 225, 185, 0.6)"
    ];
    else if (safeMarketMood >= 1.6) palette = [
        "rgba(255, 220, 0, 0.9)",
        "rgba(255, 200, 0, 0.85)",
        "rgba(255, 180, 0, 0.8)",
        "rgba(255, 175, 0, 0.78)",
        "rgba(255, 195, 20, 0.75)",
        "rgba(255, 210, 90, 0.7)",
        "rgba(255, 215, 150, 0.65)",
        "rgba(255, 220, 180, 0.6)"
    ];
    else if (safeMarketMood >= 1.55) palette = [
        "rgba(255, 215, 0, 0.9)",
        "rgba(255, 195, 0, 0.85)",
        "rgba(255, 175, 0, 0.8)",
        "rgba(255, 170, 0, 0.78)",
        "rgba(255, 190, 15, 0.75)",
        "rgba(255, 205, 85, 0.7)",
        "rgba(255, 210, 145, 0.65)",
        "rgba(255, 215, 175, 0.6)"
    ];
    else if (safeMarketMood >= 1.5) palette = [
        "rgba(255, 210, 0, 0.9)",
        "rgba(255, 190, 0, 0.85)",
        "rgba(255, 170, 0, 0.8)",
        "rgba(255, 165, 0, 0.78)",
        "rgba(255, 185, 10, 0.75)",
        "rgba(255, 200, 80, 0.7)",
        "rgba(255, 205, 140, 0.65)",
        "rgba(255, 210, 170, 0.6)"
    ];
    else if (safeMarketMood >= 1.45) palette = [
        "rgba(255, 205, 0, 0.9)",
        "rgba(255, 185, 0, 0.85)",
        "rgba(255, 165, 0, 0.8)",
        "rgba(255, 160, 0, 0.78)",
        "rgba(255, 180, 5, 0.75)",
        "rgba(255, 195, 75, 0.7)",
        "rgba(255, 200, 135, 0.65)",
        "rgba(255, 205, 165, 0.6)"
    ];
    else if (safeMarketMood >= 1.4) palette = [
        "rgba(255, 200, 0, 0.9)",
        "rgba(255, 180, 0, 0.85)",
        "rgba(255, 160, 0, 0.8)",
        "rgba(255, 155, 0, 0.78)",
        "rgba(255, 175, 0, 0.75)",
        "rgba(255, 190, 70, 0.7)",
        "rgba(255, 195, 130, 0.65)",
        "rgba(255, 200, 160, 0.6)"
    ];
    else if (safeMarketMood >= 1.35) palette = [
        "rgba(255, 195, 0, 0.9)",
        "rgba(255, 175, 0, 0.85)",
        "rgba(255, 155, 0, 0.8)",
        "rgba(255, 150, 0, 0.78)",
        "rgba(255, 170, 0, 0.75)",
        "rgba(255, 185, 65, 0.7)",
        "rgba(255, 190, 125, 0.65)",
        "rgba(255, 195, 155, 0.6)"
    ];
    else if (safeMarketMood >= 1.3) palette = [
        "rgba(255, 190, 0, 0.9)",
        "rgba(255, 170, 0, 0.85)",
        "rgba(255, 150, 0, 0.8)",
        "rgba(255, 145, 0, 0.78)",
        "rgba(255, 165, 0, 0.75)",
        "rgba(255, 180, 60, 0.7)",
        "rgba(255, 185, 120, 0.65)",
        "rgba(255, 190, 150, 0.6)"
    ];
    else if (safeMarketMood >= 1.25) palette = [
        "rgba(255, 185, 0, 0.9)",
        "rgba(255, 165, 0, 0.85)",
        "rgba(255, 145, 0, 0.8)",
        "rgba(255, 140, 0, 0.78)",
        "rgba(255, 160, 0, 0.75)",
        "rgba(255, 175, 55, 0.7)",
        "rgba(255, 180, 115, 0.65)",
        "rgba(255, 185, 145, 0.6)"
    ];
    else if (safeMarketMood >= 1.2) palette = [
        "rgba(255, 180, 0, 0.9)",
        "rgba(255, 160, 0, 0.85)",
        "rgba(255, 140, 0, 0.8)",
        "rgba(255, 135, 0, 0.78)",
        "rgba(255, 155, 0, 0.75)",
        "rgba(255, 170, 50, 0.7)",
        "rgba(255, 175, 110, 0.65)",
        "rgba(255, 180, 140, 0.6)"
    ];
    else if (safeMarketMood >= 1.15) palette = [
        "rgba(255, 175, 0, 0.9)",
        "rgba(255, 155, 0, 0.85)",
        "rgba(255, 135, 0, 0.8)",
        "rgba(255, 130, 0, 0.78)",
        "rgba(255, 150, 0, 0.75)",
        "rgba(255, 165, 45, 0.7)",
        "rgba(255, 170, 105, 0.65)",
        "rgba(255, 175, 135, 0.6)"
    ];
    else if (safeMarketMood >= 1.1) palette = [
        "rgba(255, 170, 0, 0.9)",
        "rgba(255, 150, 0, 0.85)",
        "rgba(255, 130, 0, 0.8)",
        "rgba(255, 125, 0, 0.78)",
        "rgba(255, 145, 0, 0.75)",
        "rgba(255, 160, 40, 0.7)",
        "rgba(255, 165, 100, 0.65)",
        "rgba(255, 170, 130, 0.6)"
    ];
    else if (safeMarketMood >= 1.05) palette = [
        "rgba(255, 165, 0, 0.9)",
        "rgba(255, 145, 0, 0.85)",
        "rgba(255, 125, 0, 0.8)",
        "rgba(255, 120, 0, 0.78)",
        "rgba(255, 140, 0, 0.75)",
        "rgba(255, 155, 35, 0.7)",
        "rgba(255, 160, 95, 0.65)",
        "rgba(255, 165, 125, 0.6)"
    ];
    else if (safeMarketMood >= 1.0) palette = [
        "rgba(255, 160, 0, 0.9)",
        "rgba(255, 140, 0, 0.85)",
        "rgba(255, 120, 0, 0.8)",
        "rgba(255, 115, 0, 0.78)",
        "rgba(255, 135, 0, 0.75)",
        "rgba(255, 150, 30, 0.7)",
        "rgba(255, 155, 90, 0.65)",
        "rgba(255, 160, 120, 0.6)"
    ];
    else if (safeMarketMood >= 0.95) // Transition to softer oranges with blue accents beginning
    palette = [
        "rgba(255, 155, 0, 0.9)",
        "rgba(255, 135, 0, 0.85)",
        "rgba(255, 115, 0, 0.8)",
        "rgba(255, 110, 0, 0.78)",
        "rgba(255, 130, 0, 0.75)",
        "rgba(255, 145, 25, 0.7)",
        "rgba(245, 150, 85, 0.65)",
        "rgba(235, 155, 120, 0.6)"
    ];
    else if (safeMarketMood >= 0.9) palette = [
        "rgba(255, 150, 0, 0.9)",
        "rgba(255, 130, 0, 0.85)",
        "rgba(255, 110, 0, 0.8)",
        "rgba(255, 105, 0, 0.78)",
        "rgba(255, 125, 0, 0.75)",
        "rgba(245, 140, 20, 0.7)",
        "rgba(235, 145, 80, 0.65)",
        "rgba(225, 150, 120, 0.6)"
    ];
    else if (safeMarketMood >= 0.85) palette = [
        "rgba(255, 145, 0, 0.9)",
        "rgba(255, 125, 0, 0.85)",
        "rgba(250, 105, 0, 0.8)",
        "rgba(240, 100, 0, 0.78)",
        "rgba(235, 120, 0, 0.75)",
        "rgba(225, 135, 20, 0.7)",
        "rgba(215, 140, 80, 0.65)",
        "rgba(205, 145, 130, 0.6)"
    ];
    else if (safeMarketMood >= 0.8) palette = [
        "rgba(250, 140, 0, 0.9)",
        "rgba(245, 120, 0, 0.85)",
        "rgba(240, 100, 0, 0.8)",
        "rgba(230, 95, 10, 0.78)",
        "rgba(220, 115, 20, 0.75)",
        "rgba(210, 130, 40, 0.7)",
        "rgba(200, 135, 90, 0.65)",
        "rgba(190, 140, 140, 0.6)"
    ];
    else if (safeMarketMood >= 0.75) palette = [
        "rgba(245, 135, 0, 0.9)",
        "rgba(235, 115, 0, 0.85)",
        "rgba(225, 95, 10, 0.8)",
        "rgba(215, 90, 20, 0.78)",
        "rgba(205, 110, 30, 0.75)",
        "rgba(195, 125, 50, 0.7)",
        "rgba(185, 130, 100, 0.65)",
        "rgba(175, 135, 150, 0.6)"
    ];
    else if (safeMarketMood >= 0.7) palette = [
        "rgba(240, 130, 10, 0.9)",
        "rgba(230, 110, 15, 0.85)",
        "rgba(220, 90, 20, 0.8)",
        "rgba(210, 85, 30, 0.78)",
        "rgba(200, 105, 40, 0.75)",
        "rgba(190, 120, 60, 0.7)",
        "rgba(180, 125, 110, 0.65)",
        "rgba(170, 130, 160, 0.6)"
    ];
    else if (safeMarketMood >= 0.65) palette = [
        "rgba(235, 125, 20, 0.9)",
        "rgba(225, 105, 25, 0.85)",
        "rgba(215, 85, 30, 0.8)",
        "rgba(205, 80, 40, 0.78)",
        "rgba(195, 100, 50, 0.75)",
        "rgba(185, 115, 70, 0.7)",
        "rgba(175, 120, 120, 0.65)",
        "rgba(165, 125, 170, 0.6)"
    ];
    else if (safeMarketMood >= 0.6) palette = [
        "rgba(230, 120, 30, 0.9)",
        "rgba(220, 100, 35, 0.85)",
        "rgba(210, 80, 40, 0.8)",
        "rgba(200, 75, 50, 0.78)",
        "rgba(190, 95, 60, 0.75)",
        "rgba(180, 110, 80, 0.7)",
        "rgba(170, 115, 130, 0.65)",
        "rgba(160, 120, 180, 0.6)"
    ];
    else if (safeMarketMood >= 0.55) palette = [
        "rgba(225, 115, 40, 0.9)",
        "rgba(215, 95, 45, 0.85)",
        "rgba(205, 75, 50, 0.8)",
        "rgba(195, 70, 60, 0.78)",
        "rgba(185, 90, 70, 0.75)",
        "rgba(175, 105, 90, 0.7)",
        "rgba(165, 110, 140, 0.65)",
        "rgba(155, 115, 190, 0.6)"
    ];
    else if (safeMarketMood >= 0.5) palette = [
        "rgba(220, 110, 50, 0.9)",
        "rgba(210, 90, 55, 0.85)",
        "rgba(200, 70, 60, 0.8)",
        "rgba(190, 65, 70, 0.78)",
        "rgba(180, 85, 80, 0.75)",
        "rgba(170, 100, 100, 0.7)",
        "rgba(160, 105, 150, 0.65)",
        "rgba(150, 110, 200, 0.6)"
    ];
    else if (safeMarketMood >= 0.45) // Orange fading, blue intensifying
    palette = [
        "rgba(215, 105, 60, 0.9)",
        "rgba(205, 85, 65, 0.85)",
        "rgba(195, 65, 70, 0.8)",
        "rgba(185, 60, 80, 0.78)",
        "rgba(175, 80, 90, 0.75)",
        "rgba(165, 95, 110, 0.7)",
        "rgba(155, 100, 160, 0.65)",
        "rgba(145, 105, 210, 0.6)"
    ];
    else if (safeMarketMood >= 0.4) palette = [
        "rgba(210, 100, 70, 0.9)",
        "rgba(200, 80, 75, 0.85)",
        "rgba(190, 60, 80, 0.8)",
        "rgba(180, 55, 90, 0.78)",
        "rgba(170, 75, 100, 0.75)",
        "rgba(160, 90, 120, 0.7)",
        "rgba(150, 95, 170, 0.65)",
        "rgba(140, 100, 220, 0.6)"
    ];
    else if (safeMarketMood >= 0.35) palette = [
        "rgba(205, 95, 80, 0.9)",
        "rgba(195, 75, 85, 0.85)",
        "rgba(185, 55, 90, 0.8)",
        "rgba(175, 50, 100, 0.78)",
        "rgba(165, 70, 110, 0.75)",
        "rgba(155, 85, 130, 0.7)",
        "rgba(145, 90, 180, 0.65)",
        "rgba(135, 95, 230, 0.6)"
    ];
    else if (safeMarketMood >= 0.3) palette = [
        "rgba(200, 90, 90, 0.9)",
        "rgba(190, 70, 95, 0.85)",
        "rgba(180, 50, 100, 0.8)",
        "rgba(170, 45, 110, 0.78)",
        "rgba(160, 65, 120, 0.75)",
        "rgba(150, 80, 140, 0.7)",
        "rgba(140, 85, 190, 0.65)",
        "rgba(130, 90, 235, 0.6)"
    ];
    else if (safeMarketMood >= 0.25) palette = [
        "rgba(195, 85, 100, 0.9)",
        "rgba(185, 65, 105, 0.85)",
        "rgba(175, 45, 110, 0.8)",
        "rgba(165, 40, 120, 0.78)",
        "rgba(155, 60, 130, 0.75)",
        "rgba(145, 75, 150, 0.7)",
        "rgba(135, 80, 200, 0.65)",
        "rgba(125, 85, 240, 0.6)"
    ];
    else if (safeMarketMood >= 0.2) palette = [
        "rgba(190, 80, 110, 0.9)",
        "rgba(180, 60, 115, 0.85)",
        "rgba(170, 40, 120, 0.8)",
        "rgba(160, 35, 130, 0.78)",
        "rgba(150, 55, 140, 0.75)",
        "rgba(140, 70, 160, 0.7)",
        "rgba(130, 75, 210, 0.65)",
        "rgba(120, 80, 245, 0.6)"
    ];
    else if (safeMarketMood >= 0.15) palette = [
        "rgba(185, 75, 120, 0.9)",
        "rgba(175, 55, 125, 0.85)",
        "rgba(165, 35, 130, 0.8)",
        "rgba(155, 30, 140, 0.78)",
        "rgba(145, 50, 150, 0.75)",
        "rgba(135, 65, 170, 0.7)",
        "rgba(125, 70, 220, 0.65)",
        "rgba(115, 75, 250, 0.6)"
    ];
    else if (safeMarketMood >= 0.1) palette = [
        "rgba(180, 70, 130, 0.9)",
        "rgba(170, 50, 135, 0.85)",
        "rgba(160, 30, 140, 0.8)",
        "rgba(150, 25, 150, 0.78)",
        "rgba(140, 45, 160, 0.75)",
        "rgba(130, 60, 180, 0.7)",
        "rgba(120, 65, 225, 0.65)",
        "rgba(110, 70, 255, 0.6)"
    ];
    else if (safeMarketMood >= 0.05) palette = [
        "rgba(175, 65, 140, 0.9)",
        "rgba(165, 45, 145, 0.85)",
        "rgba(155, 25, 150, 0.8)",
        "rgba(145, 20, 160, 0.78)",
        "rgba(135, 40, 170, 0.75)",
        "rgba(125, 55, 190, 0.7)",
        "rgba(115, 60, 230, 0.65)",
        "rgba(105, 65, 255, 0.6)"
    ];
    else if (safeMarketMood >= 0.0) palette = [
        "rgba(170, 60, 150, 0.9)",
        "rgba(160, 40, 155, 0.85)",
        "rgba(150, 20, 160, 0.8)",
        "rgba(140, 15, 170, 0.78)",
        "rgba(130, 35, 180, 0.75)",
        "rgba(120, 50, 200, 0.7)",
        "rgba(110, 55, 235, 0.65)",
        "rgba(100, 60, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.05) palette = [
        "rgba(160, 50, 165, 0.9)",
        "rgba(150, 35, 170, 0.85)",
        "rgba(140, 15, 175, 0.8)",
        "rgba(130, 10, 180, 0.78)",
        "rgba(120, 30, 190, 0.75)",
        "rgba(110, 45, 210, 0.7)",
        "rgba(100, 50, 240, 0.65)",
        "rgba(90, 55, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.1) palette = [
        "rgba(150, 45, 175, 0.9)",
        "rgba(140, 30, 180, 0.85)",
        "rgba(130, 10, 185, 0.8)",
        "rgba(120, 5, 190, 0.78)",
        "rgba(110, 25, 200, 0.75)",
        "rgba(100, 40, 220, 0.7)",
        "rgba(90, 45, 245, 0.65)",
        "rgba(80, 50, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.15) palette = [
        "rgba(140, 40, 185, 0.9)",
        "rgba(130, 25, 190, 0.85)",
        "rgba(120, 5, 195, 0.8)",
        "rgba(110, 0, 200, 0.78)",
        "rgba(100, 20, 210, 0.75)",
        "rgba(90, 35, 225, 0.7)",
        "rgba(80, 40, 245, 0.65)",
        "rgba(70, 45, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.2) palette = [
        "rgba(130, 35, 195, 0.9)",
        "rgba(120, 20, 200, 0.85)",
        "rgba(110, 0, 205, 0.8)",
        "rgba(100, 0, 210, 0.78)",
        "rgba(90, 15, 215, 0.75)",
        "rgba(80, 30, 230, 0.7)",
        "rgba(70, 35, 245, 0.65)",
        "rgba(60, 40, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.25) palette = [
        "rgba(120, 30, 205, 0.9)",
        "rgba(110, 15, 210, 0.85)",
        "rgba(100, 0, 215, 0.8)",
        "rgba(90, 0, 220, 0.78)",
        "rgba(80, 10, 225, 0.75)",
        "rgba(70, 25, 235, 0.7)",
        "rgba(60, 30, 245, 0.65)",
        "rgba(50, 35, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.3) palette = [
        "rgba(110, 25, 215, 0.9)",
        "rgba(100, 10, 220, 0.85)",
        "rgba(90, 0, 225, 0.8)",
        "rgba(80, 0, 230, 0.78)",
        "rgba(70, 5, 235, 0.75)",
        "rgba(60, 20, 240, 0.7)",
        "rgba(50, 25, 245, 0.65)",
        "rgba(40, 30, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.35) palette = [
        "rgba(100, 20, 225, 0.9)",
        "rgba(90, 5, 230, 0.85)",
        "rgba(80, 0, 235, 0.8)",
        "rgba(70, 0, 240, 0.78)",
        "rgba(60, 0, 245, 0.75)",
        "rgba(50, 15, 245, 0.7)",
        "rgba(40, 20, 250, 0.65)",
        "rgba(30, 25, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.4) palette = [
        "rgba(90, 15, 230, 0.9)",
        "rgba(80, 0, 235, 0.85)",
        "rgba(70, 0, 240, 0.8)",
        "rgba(60, 0, 245, 0.78)",
        "rgba(50, 0, 250, 0.75)",
        "rgba(40, 10, 250, 0.7)",
        "rgba(30, 15, 252, 0.65)",
        "rgba(20, 20, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.45) palette = [
        "rgba(80, 10, 235, 0.9)",
        "rgba(70, 0, 240, 0.85)",
        "rgba(60, 0, 245, 0.8)",
        "rgba(50, 0, 250, 0.78)",
        "rgba(40, 0, 252, 0.75)",
        "rgba(30, 5, 254, 0.7)",
        "rgba(20, 10, 255, 0.65)",
        "rgba(10, 15, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.5) palette = [
        "rgba(70, 5, 240, 0.9)",
        "rgba(60, 0, 245, 0.85)",
        "rgba(50, 0, 250, 0.8)",
        "rgba(40, 0, 252, 0.78)",
        "rgba(30, 0, 254, 0.75)",
        "rgba(20, 0, 255, 0.7)",
        "rgba(10, 5, 255, 0.65)",
        "rgba(0, 10, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.6) palette = [
        "rgba(60, 0, 245, 0.9)",
        "rgba(50, 0, 250, 0.85)",
        "rgba(40, 0, 252, 0.8)",
        "rgba(30, 0, 254, 0.78)",
        "rgba(20, 0, 255, 0.75)",
        "rgba(10, 0, 255, 0.7)",
        "rgba(5, 0, 255, 0.65)",
        "rgba(0, 0, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.7) palette = [
        "rgba(50, 0, 240, 0.9)",
        "rgba(40, 0, 245, 0.85)",
        "rgba(30, 0, 250, 0.8)",
        "rgba(20, 0, 252, 0.78)",
        "rgba(10, 0, 255, 0.75)",
        "rgba(5, 0, 255, 0.7)",
        "rgba(0, 0, 255, 0.65)",
        "rgba(0, 10, 230, 0.6)"
    ];
    else if (safeMarketMood >= -0.8) palette = [
        "rgba(40, 0, 235, 0.9)",
        "rgba(30, 0, 240, 0.85)",
        "rgba(20, 0, 245, 0.8)",
        "rgba(10, 0, 250, 0.78)",
        "rgba(5, 0, 255, 0.75)",
        "rgba(0, 0, 255, 0.7)",
        "rgba(0, 10, 230, 0.65)",
        "rgba(0, 20, 210, 0.6)"
    ];
    else if (safeMarketMood >= -0.9) palette = [
        "rgba(30, 0, 230, 0.9)",
        "rgba(20, 0, 235, 0.85)",
        "rgba(10, 0, 240, 0.8)",
        "rgba(5, 0, 245, 0.78)",
        "rgba(0, 0, 250, 0.75)",
        "rgba(0, 10, 230, 0.7)",
        "rgba(0, 20, 210, 0.65)",
        "rgba(0, 30, 190, 0.6)"
    ];
    else if (safeMarketMood >= -1) palette = [
        "rgba(20, 0, 225, 0.95)",
        "rgba(10, 0, 230, 0.9)",
        "rgba(5, 0, 235, 0.85)",
        "rgba(0, 0, 240, 0.8)",
        "rgba(0, 5, 230, 0.75)",
        "rgba(0, 15, 210, 0.7)",
        "rgba(0, 25, 190, 0.65)",
        "rgba(0, 35, 170, 0.6)"
    ];
    else if (safeMarketMood >= -1.1) palette = [
        "rgba(18, 0, 222, 0.95)",
        "rgba(8, 0, 227, 0.9)",
        "rgba(3, 0, 232, 0.85)",
        "rgba(0, 0, 237, 0.8)",
        "rgba(0, 8, 227, 0.75)",
        "rgba(0, 18, 207, 0.7)",
        "rgba(0, 28, 187, 0.65)",
        "rgba(0, 38, 167, 0.6)"
    ];
    else if (safeMarketMood >= -1.2) palette = [
        "rgba(15, 0, 220, 0.95)",
        "rgba(5, 0, 225, 0.9)",
        "rgba(0, 0, 230, 0.85)",
        "rgba(0, 5, 235, 0.8)",
        "rgba(0, 15, 220, 0.75)",
        "rgba(0, 25, 200, 0.7)",
        "rgba(0, 35, 180, 0.65)",
        "rgba(0, 45, 160, 0.6)"
    ];
    else if (safeMarketMood >= -1.3) palette = [
        "rgba(10, 0, 218, 0.95)",
        "rgba(5, 0, 223, 0.9)",
        "rgba(0, 0, 228, 0.85)",
        "rgba(0, 8, 233, 0.8)",
        "rgba(0, 18, 218, 0.75)",
        "rgba(0, 28, 198, 0.7)",
        "rgba(0, 38, 178, 0.65)",
        "rgba(0, 48, 158, 0.6)"
    ];
    else if (safeMarketMood >= -1.4) palette = [
        "rgba(8, 0, 216, 0.95)",
        "rgba(3, 0, 221, 0.9)",
        "rgba(0, 0, 226, 0.85)",
        "rgba(0, 10, 231, 0.8)",
        "rgba(0, 20, 216, 0.75)",
        "rgba(0, 30, 196, 0.7)",
        "rgba(0, 40, 176, 0.65)",
        "rgba(0, 50, 156, 0.6)"
    ];
    else if (safeMarketMood >= -1.5) palette = [
        "rgba(5, 0, 214, 0.95)",
        "rgba(0, 0, 219, 0.9)",
        "rgba(0, 5, 224, 0.85)",
        "rgba(0, 15, 229, 0.8)",
        "rgba(0, 25, 214, 0.75)",
        "rgba(0, 35, 194, 0.7)",
        "rgba(0, 45, 174, 0.65)",
        "rgba(0, 55, 154, 0.6)"
    ];
    else if (safeMarketMood >= -1.6) palette = [
        "rgba(3, 0, 212, 0.95)",
        "rgba(0, 0, 217, 0.9)",
        "rgba(0, 8, 222, 0.85)",
        "rgba(0, 18, 227, 0.8)",
        "rgba(0, 28, 212, 0.75)",
        "rgba(0, 38, 192, 0.7)",
        "rgba(0, 48, 172, 0.65)",
        "rgba(0, 58, 152, 0.6)"
    ];
    else if (safeMarketMood >= -1.7) palette = [
        "rgba(0, 0, 210, 0.95)",
        "rgba(0, 5, 215, 0.9)",
        "rgba(0, 10, 220, 0.85)",
        "rgba(0, 20, 225, 0.8)",
        "rgba(0, 30, 210, 0.75)",
        "rgba(0, 40, 190, 0.7)",
        "rgba(0, 50, 170, 0.65)",
        "rgba(0, 60, 150, 0.6)"
    ];
    else if (safeMarketMood >= -1.8) palette = [
        "rgba(0, 0, 208, 0.95)",
        "rgba(0, 8, 213, 0.9)",
        "rgba(0, 15, 218, 0.85)",
        "rgba(0, 25, 223, 0.8)",
        "rgba(0, 35, 208, 0.75)",
        "rgba(0, 45, 188, 0.7)",
        "rgba(0, 55, 168, 0.65)",
        "rgba(0, 65, 148, 0.6)"
    ];
    else if (safeMarketMood >= -1.9) palette = [
        "rgba(0, 0, 205, 0.95)",
        "rgba(0, 10, 210, 0.9)",
        "rgba(0, 20, 215, 0.85)",
        "rgba(0, 30, 220, 0.8)",
        "rgba(0, 40, 205, 0.75)",
        "rgba(0, 50, 185, 0.7)",
        "rgba(0, 60, 165, 0.65)",
        "rgba(0, 70, 145, 0.6)"
    ];
    else if (safeMarketMood >= -2) palette = [
        "rgba(0, 0, 200, 0.95)",
        "rgba(0, 15, 205, 0.9)",
        "rgba(0, 25, 210, 0.85)",
        "rgba(0, 35, 215, 0.8)",
        "rgba(0, 45, 200, 0.75)",
        "rgba(0, 55, 180, 0.7)",
        "rgba(0, 65, 160, 0.65)",
        "rgba(0, 75, 140, 0.6)"
    ];
    else if (safeMarketMood >= -2.1) palette = [
        "rgba(0, 5, 195, 0.95)",
        "rgba(0, 20, 200, 0.9)",
        "rgba(0, 30, 205, 0.85)",
        "rgba(0, 40, 210, 0.8)",
        "rgba(0, 50, 195, 0.75)",
        "rgba(0, 60, 175, 0.7)",
        "rgba(0, 70, 155, 0.65)",
        "rgba(0, 80, 135, 0.6)"
    ];
    else if (safeMarketMood >= -2.2) palette = [
        "rgba(0, 10, 190, 0.95)",
        "rgba(0, 25, 195, 0.9)",
        "rgba(0, 35, 200, 0.85)",
        "rgba(0, 45, 205, 0.8)",
        "rgba(0, 55, 190, 0.75)",
        "rgba(0, 65, 170, 0.7)",
        "rgba(0, 75, 150, 0.65)",
        "rgba(0, 85, 130, 0.6)"
    ];
    else if (safeMarketMood >= -2.3) palette = [
        "rgba(0, 15, 185, 0.95)",
        "rgba(0, 30, 190, 0.9)",
        "rgba(0, 40, 195, 0.85)",
        "rgba(0, 50, 200, 0.8)",
        "rgba(0, 60, 185, 0.75)",
        "rgba(0, 70, 165, 0.7)",
        "rgba(0, 80, 145, 0.65)",
        "rgba(0, 90, 125, 0.6)"
    ];
    else if (safeMarketMood >= -2.4) palette = [
        "rgba(0, 20, 180, 0.95)",
        "rgba(0, 35, 185, 0.9)",
        "rgba(0, 45, 190, 0.85)",
        "rgba(0, 55, 195, 0.8)",
        "rgba(0, 65, 180, 0.75)",
        "rgba(0, 75, 160, 0.7)",
        "rgba(0, 85, 140, 0.65)",
        "rgba(0, 95, 120, 0.6)"
    ];
    else if (safeMarketMood >= -2.5) palette = [
        "rgba(0, 25, 175, 0.95)",
        "rgba(0, 40, 180, 0.9)",
        "rgba(0, 50, 185, 0.85)",
        "rgba(0, 60, 190, 0.8)",
        "rgba(0, 70, 175, 0.75)",
        "rgba(0, 80, 155, 0.7)",
        "rgba(0, 90, 135, 0.65)",
        "rgba(0, 100, 115, 0.6)"
    ];
    else if (safeMarketMood >= -2.6) palette = [
        "rgba(0, 30, 170, 0.95)",
        "rgba(0, 45, 175, 0.9)",
        "rgba(0, 55, 180, 0.85)",
        "rgba(0, 65, 185, 0.8)",
        "rgba(0, 75, 170, 0.75)",
        "rgba(0, 85, 150, 0.7)",
        "rgba(0, 95, 130, 0.65)",
        "rgba(0, 105, 110, 0.6)"
    ];
    else if (safeMarketMood >= -2.7) palette = [
        "rgba(0, 35, 165, 0.95)",
        "rgba(0, 50, 170, 0.9)",
        "rgba(0, 60, 175, 0.85)",
        "rgba(0, 70, 180, 0.8)",
        "rgba(0, 80, 165, 0.75)",
        "rgba(0, 90, 145, 0.7)",
        "rgba(0, 100, 125, 0.65)",
        "rgba(0, 110, 105, 0.6)"
    ];
    else if (safeMarketMood >= -2.8) palette = [
        "rgba(0, 40, 160, 0.95)",
        "rgba(0, 55, 165, 0.9)",
        "rgba(0, 65, 170, 0.85)",
        "rgba(0, 75, 175, 0.8)",
        "rgba(0, 85, 160, 0.75)",
        "rgba(0, 95, 140, 0.7)",
        "rgba(0, 105, 120, 0.65)",
        "rgba(0, 115, 100, 0.6)"
    ];
    else if (safeMarketMood >= -2.9) palette = [
        "rgba(0, 45, 155, 0.95)",
        "rgba(0, 60, 160, 0.9)",
        "rgba(0, 70, 165, 0.85)",
        "rgba(0, 80, 170, 0.8)",
        "rgba(0, 90, 155, 0.75)",
        "rgba(0, 100, 135, 0.7)",
        "rgba(0, 110, 115, 0.65)",
        "rgba(0, 120, 95, 0.6)"
    ];
    else if (safeMarketMood >= -3) palette = [
        "rgba(0, 50, 150, 0.95)",
        "rgba(0, 65, 155, 0.9)",
        "rgba(0, 75, 160, 0.85)",
        "rgba(0, 85, 165, 0.8)",
        "rgba(0, 95, 150, 0.75)",
        "rgba(0, 105, 130, 0.7)",
        "rgba(0, 115, 110, 0.65)",
        "rgba(0, 125, 90, 0.6)"
    ];
    else if (safeMarketMood >= -3.1) palette = [
        "rgba(0, 55, 145, 0.95)",
        "rgba(0, 70, 150, 0.9)",
        "rgba(0, 80, 155, 0.85)",
        "rgba(0, 90, 160, 0.8)",
        "rgba(0, 100, 145, 0.75)",
        "rgba(0, 110, 125, 0.7)",
        "rgba(0, 120, 105, 0.65)",
        "rgba(0, 130, 85, 0.6)"
    ];
    else if (safeMarketMood >= -3.2) palette = [
        "rgba(0, 60, 140, 0.95)",
        "rgba(0, 75, 145, 0.9)",
        "rgba(0, 85, 150, 0.85)",
        "rgba(0, 95, 155, 0.8)",
        "rgba(0, 105, 140, 0.75)",
        "rgba(0, 115, 120, 0.7)",
        "rgba(0, 125, 100, 0.65)",
        "rgba(0, 135, 80, 0.6)"
    ];
    else if (safeMarketMood >= -3.3) palette = [
        "rgba(0, 65, 135, 0.95)",
        "rgba(0, 80, 140, 0.9)",
        "rgba(0, 90, 145, 0.85)",
        "rgba(0, 100, 150, 0.8)",
        "rgba(0, 110, 135, 0.75)",
        "rgba(0, 120, 115, 0.7)",
        "rgba(0, 130, 95, 0.65)",
        "rgba(0, 140, 75, 0.6)"
    ];
    else if (safeMarketMood >= -3.4) palette = [
        "rgba(0, 70, 130, 0.95)",
        "rgba(0, 85, 135, 0.9)",
        "rgba(0, 95, 140, 0.85)",
        "rgba(0, 105, 145, 0.8)",
        "rgba(0, 115, 130, 0.75)",
        "rgba(0, 125, 110, 0.7)",
        "rgba(0, 135, 90, 0.65)",
        "rgba(0, 145, 70, 0.6)"
    ];
    else if (safeMarketMood >= -3.5) palette = [
        "rgba(0, 75, 125, 0.95)",
        "rgba(0, 90, 130, 0.9)",
        "rgba(0, 100, 135, 0.85)",
        "rgba(0, 110, 140, 0.8)",
        "rgba(0, 120, 125, 0.75)",
        "rgba(0, 130, 105, 0.7)",
        "rgba(0, 140, 85, 0.65)",
        "rgba(0, 150, 65, 0.6)"
    ];
    else if (safeMarketMood >= -3.6) palette = [
        "rgba(0, 80, 120, 0.95)",
        "rgba(0, 95, 125, 0.9)",
        "rgba(0, 105, 130, 0.85)",
        "rgba(0, 115, 135, 0.8)",
        "rgba(0, 125, 120, 0.75)",
        "rgba(0, 135, 100, 0.7)",
        "rgba(0, 145, 80, 0.65)",
        "rgba(0, 155, 60, 0.6)"
    ];
    else if (safeMarketMood >= -3.7) palette = [
        "rgba(0, 85, 115, 0.95)",
        "rgba(0, 100, 120, 0.9)",
        "rgba(0, 110, 125, 0.85)",
        "rgba(0, 120, 130, 0.8)",
        "rgba(0, 130, 115, 0.75)",
        "rgba(0, 140, 95, 0.7)",
        "rgba(0, 150, 75, 0.65)",
        "rgba(0, 160, 55, 0.6)"
    ];
    else if (safeMarketMood >= -3.8) palette = [
        "rgba(0, 90, 110, 0.95)",
        "rgba(0, 105, 115, 0.9)",
        "rgba(0, 115, 120, 0.85)",
        "rgba(0, 125, 125, 0.8)",
        "rgba(0, 135, 110, 0.75)",
        "rgba(0, 145, 90, 0.7)",
        "rgba(0, 155, 70, 0.65)",
        "rgba(0, 165, 50, 0.6)"
    ];
    else if (safeMarketMood >= -3.9) palette = [
        "rgba(0, 95, 105, 0.95)",
        "rgba(0, 110, 110, 0.9)",
        "rgba(0, 120, 115, 0.85)",
        "rgba(0, 130, 120, 0.8)",
        "rgba(0, 140, 105, 0.75)",
        "rgba(0, 150, 85, 0.7)",
        "rgba(0, 160, 65, 0.65)",
        "rgba(0, 170, 45, 0.6)"
    ];
    else if (safeMarketMood >= -4) palette = [
        "rgba(0, 100, 100, 0.95)",
        "rgba(0, 115, 105, 0.9)",
        "rgba(0, 125, 110, 0.85)",
        "rgba(0, 135, 115, 0.8)",
        "rgba(0, 145, 100, 0.75)",
        "rgba(0, 155, 80, 0.7)",
        "rgba(0, 165, 60, 0.65)",
        "rgba(0, 175, 40, 0.6)"
    ];
    else if (safeMarketMood >= -4.1) palette = [
        "rgba(0, 105, 95, 0.95)",
        "rgba(0, 120, 100, 0.9)",
        "rgba(0, 130, 105, 0.85)",
        "rgba(0, 140, 110, 0.8)",
        "rgba(0, 150, 95, 0.75)",
        "rgba(0, 160, 75, 0.7)",
        "rgba(0, 170, 55, 0.65)",
        "rgba(0, 180, 35, 0.6)"
    ];
    else if (safeMarketMood >= -4.2) palette = [
        "rgba(0, 110, 90, 0.95)",
        "rgba(0, 125, 95, 0.9)",
        "rgba(0, 135, 100, 0.85)",
        "rgba(0, 145, 105, 0.8)",
        "rgba(0, 155, 90, 0.75)",
        "rgba(0, 165, 70, 0.7)",
        "rgba(0, 175, 50, 0.65)",
        "rgba(0, 185, 30, 0.6)"
    ];
    else if (safeMarketMood >= -4.3) palette = [
        "rgba(0, 115, 85, 0.95)",
        "rgba(0, 130, 90, 0.9)",
        "rgba(0, 140, 95, 0.85)",
        "rgba(0, 150, 100, 0.8)",
        "rgba(0, 160, 85, 0.75)",
        "rgba(0, 170, 65, 0.7)",
        "rgba(0, 180, 45, 0.65)",
        "rgba(0, 190, 25, 0.6)"
    ];
    else if (safeMarketMood >= -4.4) palette = [
        "rgba(0, 120, 80, 0.95)",
        "rgba(0, 135, 85, 0.9)",
        "rgba(0, 145, 90, 0.85)",
        "rgba(0, 155, 95, 0.8)",
        "rgba(0, 165, 80, 0.75)",
        "rgba(0, 175, 60, 0.7)",
        "rgba(0, 185, 40, 0.65)",
        "rgba(0, 195, 20, 0.6)"
    ];
    else if (safeMarketMood >= -4.5) palette = [
        "rgba(0, 125, 75, 0.95)",
        "rgba(0, 140, 80, 0.9)",
        "rgba(0, 150, 85, 0.85)",
        "rgba(0, 160, 90, 0.8)",
        "rgba(0, 170, 75, 0.75)",
        "rgba(0, 180, 55, 0.7)",
        "rgba(0, 190, 35, 0.65)",
        "rgba(0, 200, 15, 0.6)"
    ];
    else if (safeMarketMood >= -4.6) palette = [
        "rgba(0, 130, 70, 0.95)",
        "rgba(0, 145, 75, 0.9)",
        "rgba(0, 155, 80, 0.85)",
        "rgba(0, 165, 85, 0.8)",
        "rgba(0, 175, 70, 0.75)",
        "rgba(0, 185, 50, 0.7)",
        "rgba(0, 195, 30, 0.65)",
        "rgba(0, 205, 10, 0.6)"
    ];
    else if (safeMarketMood >= -4.7) palette = [
        "rgba(0, 135, 65, 0.95)",
        "rgba(0, 150, 70, 0.9)",
        "rgba(0, 160, 75, 0.85)",
        "rgba(0, 170, 80, 0.8)",
        "rgba(0, 180, 65, 0.75)",
        "rgba(0, 190, 45, 0.7)",
        "rgba(0, 200, 25, 0.65)",
        "rgba(0, 210, 5, 0.6)"
    ];
    else if (safeMarketMood >= -4.8) palette = [
        "rgba(0, 140, 60, 0.95)",
        "rgba(0, 155, 65, 0.9)",
        "rgba(0, 165, 70, 0.85)",
        "rgba(0, 175, 75, 0.8)",
        "rgba(0, 185, 60, 0.75)",
        "rgba(0, 195, 40, 0.7)",
        "rgba(0, 205, 20, 0.65)",
        "rgba(0, 215, 0, 0.6)"
    ];
    else if (safeMarketMood >= -4.9) palette = [
        "rgba(0, 145, 55, 0.95)",
        "rgba(0, 160, 60, 0.9)",
        "rgba(0, 170, 65, 0.85)",
        "rgba(0, 180, 70, 0.8)",
        "rgba(0, 190, 55, 0.75)",
        "rgba(0, 200, 35, 0.7)",
        "rgba(0, 210, 15, 0.65)",
        "rgba(0, 220, 0, 0.6)"
    ];
    else if (safeMarketMood >= -5) palette = [
        "rgba(0, 150, 50, 0.95)",
        "rgba(0, 165, 55, 0.9)",
        "rgba(0, 175, 60, 0.85)",
        "rgba(0, 185, 65, 0.8)",
        "rgba(0, 195, 50, 0.75)",
        "rgba(0, 205, 30, 0.7)",
        "rgba(0, 215, 10, 0.65)",
        "rgba(0, 225, 0, 0.6)"
    ];
    // ---- Enhanced user mood intensity impact on palette ----
    // User mood now has more influence on the palette colors
    const userInfluence = Math.abs(userMood) / 2; // Scale to half the maximum influence
    if (userMood > 0) // For positive user mood: Brighten and shift toward yellows/oranges
    palette = palette.map((color)=>{
        let rgbaMatch = color.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
        if (!rgbaMatch) return color;
        let r = parseInt(rgbaMatch[1]);
        let g = parseInt(rgbaMatch[2]);
        let b = parseInt(rgbaMatch[3]);
        let a = parseFloat(rgbaMatch[4]);
        // Brighten reds and greens more than blues for a warmer tone
        r = Math.min(255, r + Math.round(userInfluence * 30));
        g = Math.min(255, g + Math.round(userInfluence * 25));
        b = Math.min(255, b + Math.round(userInfluence * 10));
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    });
    else if (userMood < 0) // For negative user mood: Deepen and shift toward blues/purples
    palette = palette.map((color)=>{
        let rgbaMatch = color.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
        if (!rgbaMatch) return color;
        let r = parseInt(rgbaMatch[1]);
        let g = parseInt(rgbaMatch[2]);
        let b = parseInt(rgbaMatch[3]);
        let a = parseFloat(rgbaMatch[4]);
        // Increase blues, decrease reds and greens for a cooler tone
        r = Math.max(0, r - Math.round(userInfluence * 20));
        g = Math.max(0, g - Math.round(userInfluence * 15));
        b = Math.min(255, b + Math.round(userInfluence * 30));
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    });
    // ---- Market-User Mood Relationship ----
    // Add special coloration for situations where market and user moods diverge significantly
    const moodDivergence = marketMood * userMood;
    if (moodDivergence < -1) {
        // Strong negative correlation (user and market in opposite directions)
        // Add contrasting highlights to the palette
        const contrastColor = userMood > 0 ? "rgba(255, 255, 50, 0.7)" // Bright yellow highlight if user is positive
         : "rgba(50, 50, 255, 0.7)"; // Bright blue highlight if user is negative
        palette.push(contrastColor);
    }
    return palette;
}
// Helper functions for color manipulation
function $895d6185463ab8db$var$lightenColor(color, percent) {
    let rgbaMatch = color.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
    if (!rgbaMatch) return color;
    let r = parseInt(rgbaMatch[1]);
    let g = parseInt(rgbaMatch[2]);
    let b = parseInt(rgbaMatch[3]);
    let a = parseFloat(rgbaMatch[4]);
    r = Math.min(255, r + Math.round(2.55 * percent));
    g = Math.min(255, g + Math.round(2.55 * percent));
    b = Math.min(255, b + Math.round(2.55 * percent));
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
function $895d6185463ab8db$var$darkenColor(color, percent) {
    let rgbaMatch = color.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
    if (!rgbaMatch) return color;
    let r = parseInt(rgbaMatch[1]);
    let g = parseInt(rgbaMatch[2]);
    let b = parseInt(rgbaMatch[3]);
    let a = parseFloat(rgbaMatch[4]);
    r = Math.max(0, r - Math.round(2.55 * percent));
    g = Math.max(0, g - Math.round(2.55 * percent));
    b = Math.max(0, b - Math.round(2.55 * percent));
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
function $895d6185463ab8db$var$startMoodUpdates(interval = 10000) {
    if ($895d6185463ab8db$var$updateTimer) clearInterval($895d6185463ab8db$var$updateTimer);
    console.log(`\u{1F504} Starting mood update timer with interval: ${interval}ms`);
    // Run immediately
    $895d6185463ab8db$var$initMoodPage();
    // Then set interval
    $895d6185463ab8db$var$updateTimer = setInterval(async ()=>{
        console.log("\uD83D\uDD04 Periodic update of mood data...");
        await $895d6185463ab8db$var$initMoodPage();
    }, interval);
}
function $895d6185463ab8db$var$calculateUserMood() {
    // Get 5 most recent transactions from moodHistory
    const recentHistory = [
        ...moodHistory
    ].sort((a, b)=>new Date(b.timestamp) - new Date(a.timestamp)).slice(0, 5);
    // Apply weighted calculation - most recent has more impact
    let weightedMood = 0;
    let totalWeight = 0;
    recentHistory.forEach((entry, index)=>{
        const weight = 5 - index; // 5 for most recent, 1 for oldest
        const entryMood = (entry.positiveImpact || 0) - (entry.negativeImpact || 0);
        weightedMood += entryMood * weight;
        totalWeight += weight;
    });
    return totalWeight > 0 ? weightedMood / totalWeight : 0;
}
document.addEventListener("DOMContentLoaded", async ()=>{
    // mood.js is pulled into every page's bundle (socketU imports
    // showMoodAnalysisPopup), so only initialize on the actual mood board page —
    // otherwise the "Session ID is missing" toast flashes on index/login.
    if (!document.getElementById("moodScoresContainer")) return;
    try {
        console.log("\uD83D\uDE80 Initializing mood interface...");
        $895d6185463ab8db$var$sessionId = localStorage.getItem("sessionId");
        if (!$895d6185463ab8db$var$sessionId) {
            console.error("\u274C No session ID found in localStorage.");
            $895d6185463ab8db$var$showNotification("Session ID is missing. Please log in.", false);
            return;
        }
        if (!$895d6185463ab8db$var$moodSocket || !(typeof $895d6185463ab8db$var$moodSocket.connected !== 'undefined' && $895d6185463ab8db$var$moodSocket.connected || typeof $895d6185463ab8db$var$moodSocket.readyState !== 'undefined' && $895d6185463ab8db$var$moodSocket.readyState === WebSocket.OPEN)) {
            console.log("\uD83D\uDD0C Establishing WebSocket connection...");
            $895d6185463ab8db$var$connectMoodSocket();
        }
        await $895d6185463ab8db$var$loadP5();
        await $895d6185463ab8db$var$initMoodPage();
        // Initialize visualization
        $895d6185463ab8db$var$initP5Sketch();
        // Test the burst functionality after initialization
        setTimeout(()=>{
            console.log("\uD83E\uDDEA Testing burst mechanism...");
            $895d6185463ab8db$export$f41080da4e2fdf9f(3.5); // Test with a strong positive mood
        }, 3000);
        // Start periodic data updates
        $895d6185463ab8db$var$startMoodUpdates(15000);
        console.log("\u2705 Mood interface initialization complete");
    } catch (error) {
        console.error("\u274C Error during initialization:", error);
        $895d6185463ab8db$var$showNotification("Error initializing mood display. Using fallback data.", false);
        // Use fallback data
        const fallbackData = $895d6185463ab8db$var$generateFallbackMoodData();
        $895d6185463ab8db$var$userMoodScore = fallbackData.userMood.averageMood * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR;
        $895d6185463ab8db$var$marketMoodScore = fallbackData.marketMood.averageMood * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR;
        $895d6185463ab8db$var$displayMoodScores();
        $895d6185463ab8db$var$initP5Sketch();
        // Start updates with longer interval when in fallback mode
        $895d6185463ab8db$var$startMoodUpdates(30000);
    }
});
// Add a debug flag to globals to allow manual burst triggering from console
window.debugMood = {
    triggerBurst: (score)=>{
        console.log("\uD83D\uDD27 Manual burst triggered with score:", score);
        $895d6185463ab8db$export$f41080da4e2fdf9f(score || 4);
    },
    checkSocket: ()=>{
        console.log("\uD83D\uDD0C Socket status:", socket ? socket.connected ? "Connected \u2705" : "Disconnected \u274C" : "Not initialized \u26A0\uFE0F");
        return socket;
    },
    listenerTest: ()=>{
        // Test if the transactionBurst listener exists
        const hasListener = socket && socket._callbacks && socket._callbacks['$transactionBurst'] && socket._callbacks['$transactionBurst'].length > 0;
        console.log("\uD83D\uDD08 Transaction burst listener:", hasListener ? "Active \u2705" : "Not found \u274C");
        // If no listener, try to set it up
        if (!hasListener && socket) {
            console.log("\uD83D\uDD04 Attempting to re-establish burst listener");
            $895d6185463ab8db$var$setupBurstListener();
        }
        return hasListener;
    }
};
// --- Redirect guard: only forward from stockTransaction.html
window.isOn ||= (file)=>location.pathname.endsWith(`/${file}`) || location.pathname.endsWith(file);
// See stockTrade.js for both of these: zxHome is the per-tab backstop under
// every return path, zxTakeReturn is the explicit hand-off marker. Kept
// identical across all three definitions of this guard.
window.zxHome ||= ()=>{
    try {
        return sessionStorage.getItem('zxHome');
    } catch (_) {
        return null;
    }
};
window.zxTakeReturn ||= ()=>{
    const target = localStorage.getItem('zxReturnTo');
    if (!target) return window.zxHome?.() || 'zfloor.html';
    localStorage.removeItem('zxReturnTo');
    return target;
};
window.shouldRedirectToMarket ||= ()=>window.isOn('stockTransaction.html') || window.isOn('transaction.html') && !!localStorage.getItem('zxReturnTo');
window.doMarketRedirectIfNeeded ||= ()=>{
    if (window.shouldRedirectToMarket()) window.location.href = window.zxTakeReturn();
};
// Helper to show notifications
function $895d6185463ab8db$var$showNotification(message, isSuccess = true) {
    console.log(`${isSuccess ? "\u2705" : "\u274C"} ${message}`);
    // Create or get notification element
    let notificationElement = document.getElementById('moodNotification');
    if (!notificationElement) {
        notificationElement = document.createElement('div');
        notificationElement.id = 'moodNotification';
        Object.assign(notificationElement.style, {
            position: 'fixed',
            top: '10px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '8px 16px',
            borderRadius: '3px',
            fontSize: '14px',
            fontFamily: 'sans-serif',
            zIndex: '10001',
            opacity: '0',
            transition: 'opacity 0.3s ease'
        });
        document.body.appendChild(notificationElement);
    }
    // Set styles based on success/error
    Object.assign(notificationElement.style, {
        backgroundColor: isSuccess ? 'rgba(76, 175, 80, 0.9)' : 'rgba(244, 67, 54, 0.9)',
        color: 'white',
        boxShadow: `0 2px 10px ${isSuccess ? 'rgba(76, 175, 80, 0.5)' : 'rgba(244, 67, 54, 0.5)'}`
    });
    notificationElement.textContent = message;
    notificationElement.style.opacity = '1';
    // Hide after 4 seconds
    setTimeout(()=>{
        notificationElement.style.opacity = '0';
    }, 4000);
}
function $895d6185463ab8db$export$8a958c527fd8c83f(analysis) {
    console.log("\uD83D\uDCCC showMoodAnalysisPopup called with:", analysis);
    // The 3D floor renders the market's verdict as a comment docked in the room
    // rather than as this full-screen hologram (zfloor.js installs
    // window.zxMarketComment). Same call site, different aesthetic — exactly the
    // arrangement showNotification/zxNotify already uses for the LED ticker.
    //
    // The delegation lives HERE, at the one exported entry point, and not at each
    // caller: five call sites reach this function and two of them are the SELLER's
    // side in socketU (bidAcceptSuccess / bidDeclineSuccess). Those fire on
    // whatever page the seller happens to be on, so a floor-side check in only the
    // buyer's path would still throw the modal over the floor for whoever accepted.
    if (typeof window !== 'undefined' && typeof window.zxMarketComment === 'function') return window.zxMarketComment(analysis);
    if (!analysis || !analysis.analysisTitle) {
        console.error("\u274C Invalid analysis data:", analysis);
        return;
    }
    // ---- Pick main commentary safely ----
    const marketText = (analysis.marketCommentary || "").trim();
    const summaryText = (analysis.analysisSummary || "").trim();
    const detailsText = (analysis.detailedDiscussion || "").trim();
    let primaryText = marketText || summaryText || detailsText || "No analysis available.";
    const hasDistinctSummary = summaryText && summaryText !== primaryText;
    const hasDistinctDetails = detailsText && detailsText !== primaryText;
    const onlyOneSection = !hasDistinctSummary && !hasDistinctDetails;
    // ---- Smoky hologram palette (layered, dark, neon-friendly) ----
    const HOLOGRAM_BACKGROUNDS = [
        `
	  radial-gradient(1200px 600px at -10% -20%, rgba(0,255,255,0.14), transparent 60%),
	  radial-gradient(900px 500px  at 120% 130%, rgba(255,0,160,0.12), transparent 60%),
	  radial-gradient(700px 400px  at 100% -10%, rgba(0,200,255,0.10), transparent 60%),
	  linear-gradient(to bottom right, rgba(8,10,22,0.96), rgba(5,7,18,0.94))
	`,
        `
	  radial-gradient(1000px 500px at 10% 110%, rgba(0,255,200,0.10), transparent 65%),
	  radial-gradient(1000px 600px at 90% -10%, rgba(170,0,255,0.12), transparent 60%),
	  radial-gradient(700px 500px  at -10% 30%, rgba(0,150,255,0.08), transparent 60%),
	  linear-gradient(145deg, rgba(7,9,20,0.96), rgba(3,5,14,0.94))
	`,
        `
	  radial-gradient(800px 400px  at 0% 0%,   rgba(255,255,120,0.10), transparent 60%),
	  radial-gradient(1200px 700px at 100% 100%, rgba(0,220,255,0.12), transparent 60%),
	  radial-gradient(900px 600px  at 50% -20%, rgba(255,0,200,0.08), transparent 60%),
	  linear-gradient(160deg, rgba(8,12,24,0.96), rgba(4,6,12,0.94))
	`,
        `
	  radial-gradient(1000px 520px at -15% 30%, rgba(0,180,255,0.12), transparent 65%),
	  radial-gradient(900px 520px  at 115% 80%, rgba(0,255,220,0.10), transparent 60%),
	  radial-gradient(800px 420px  at 50% -20%, rgba(255,0,180,0.08), transparent 65%),
	  linear-gradient(150deg, rgba(6,8,18,0.96), rgba(3,5,12,0.95))
	`
    ];
    // ---- GUARANTEE variety: no immediate repeat, plus per-popup hue variance for mist ----
    const ROT_KEY = "__mood_bg_idx";
    const prevIdx = typeof window !== "undefined" ? window[ROT_KEY] ?? -1 : -1;
    let idx = Math.floor(Math.random() * HOLOGRAM_BACKGROUNDS.length);
    if (idx === prevIdx) idx = (idx + 1) % HOLOGRAM_BACKGROUNDS.length;
    if (typeof window !== "undefined") window[ROT_KEY] = idx;
    const chosenBg = HOLOGRAM_BACKGROUNDS[idx];
    // Per-popup randoms for extra differentiation (don’t touch text readability)
    const hue = Math.floor(Math.random() * 360); // mist hue
    const gridOpacity = (0.22 + Math.random() * 0.14).toFixed(2); // 0.22–0.36
    const gridMinor = [
        5,
        6,
        7
    ][Math.floor(Math.random() * 3)]; // px
    const gridMajor = [
        20,
        24,
        28
    ][Math.floor(Math.random() * 3)]; // px
    const gridLine = 0.5; // hairline
    // Subtle parallax drift speeds to avoid sameness
    const mistDur = 18 + Math.floor(Math.random() * 8) + "s"; // 18–25s
    const gridDur = 16 + Math.floor(Math.random() * 6) + "s"; // 16–21s
    // Create backdrop
    const backdrop = document.createElement("div");
    Object.assign(backdrop.style, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 5, 29, 0.85)",
        zIndex: "9998",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)",
        fontFamily: "'BitHigh', sans-serif",
        transition: "opacity 0.3s ease-in-out"
    });
    // Create popup container
    const popupDiv = document.createElement("div");
    Object.assign(popupDiv.style, {
        position: "relative",
        overflow: "hidden",
        backgroundColor: "rgba(6,8,18,0.92)",
        backgroundImage: chosenBg,
        borderRadius: "4px",
        border: "1px solid rgba(61, 210, 2, 0.729)",
        boxShadow: "0 0 30px rgba(0, 255, 255, 0.8), 0 0 60px rgba(255, 0, 127, 0.6)",
        padding: "20px",
        zIndex: "9999",
        width: "92vw",
        maxWidth: "480px",
        maxHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        color: "#a0d8ff",
        fontFamily: "'BitHigh', sans-serif",
        textShadow: "0 0 8px rgba(0, 255, 255, 0.8)",
        transform: "scale(0.9)",
        opacity: "0",
        transition: "transform 0.25s ease-out, opacity 0.3s ease-out",
        animation: "neonPulse 7s ease-in-out infinite alternate",
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)"
    });
    popupDiv.setAttribute("data-bg-id", String(idx)); // helpful for debugging
    // Inject styles (once)
    let neonStyle = document.getElementById("mood-neon-styles");
    if (!neonStyle) {
        neonStyle = document.createElement("style");
        neonStyle.id = "mood-neon-styles";
        neonStyle.textContent = `
	  @keyframes neonPulse {
		0%   { box-shadow: 0 0 18px rgba(0,255,255,0.55), 0 0 36px rgba(255,0,127,0.35); }
		50%  { box-shadow: 0 0 34px rgba(0,255,255,0.95), 0 0 78px rgba(255,0,127,0.75); }
		100% { box-shadow: 0 0 22px rgba(0,255,255,0.65), 0 0 44px rgba(255,0,127,0.45); }
	  }
	  @keyframes mistDrift {
		0%   { transform: translate3d(-2%, -1%, 0) scale(1); opacity: 0.55; }
		100% { transform: translate3d( 2%,  1%, 0) scale(1.04); opacity: 0.7; }
	  }
	  @keyframes gridFloat {
		0%   { transform: translate3d(0,0,0); }
		100% { transform: translate3d(2px,1px,0); }
	  }
	  @media (prefers-reduced-motion: reduce) {
		.mood-mist, .mood-grid { animation: none !important; }
	  }
	`;
        document.head.appendChild(neonStyle);
    }
    // --- Smoky hologram mist overlay (per-popup hue variance) ---
    const mist = document.createElement("div");
    mist.className = "mood-mist";
    Object.assign(mist.style, {
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        zIndex: 0,
        borderRadius: "inherit",
        backgroundImage: `
	  radial-gradient(60% 40% at 25% 20%, rgba(255,255,255,0.035), transparent 60%),
	  radial-gradient(45% 55% at 75% 75%, rgba(255,255,255,0.03),  transparent 65%),
	  radial-gradient(80% 60% at 130% -10%, rgba(0,255,220,0.045), transparent 70%)
	`,
        mixBlendMode: "screen",
        filter: `blur(14px) saturate(115%) hue-rotate(${hue}deg)`,
        animation: `mistDrift ${mistDur} linear infinite alternate`
    });
    popupDiv.appendChild(mist);
    // --- Neon grid overlay (hairline ~0.5px), per-popup opacity & cell size ---
    const grid = document.createElement("div");
    grid.className = "mood-grid";
    Object.assign(grid.style, {
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        zIndex: 1,
        borderRadius: "inherit",
        opacity: String(gridOpacity),
        backgroundImage: `
	  repeating-linear-gradient(to right, rgba(0,255,255,0.10) 0, rgba(0,255,255,0.10) ${gridLine}px, transparent ${gridLine}px, transparent ${gridMajor}px),
	  repeating-linear-gradient(to bottom, rgba(0,255,255,0.10) 0, rgba(0,255,255,0.10) ${gridLine}px, transparent ${gridLine}px, transparent ${gridMajor}px),
	  repeating-linear-gradient(to right, rgba(255,0,127,0.06) 0, rgba(255,0,127,0.06) ${gridLine}px, transparent ${gridLine}px, transparent ${gridMinor}px),
	  repeating-linear-gradient(to bottom, rgba(255,0,127,0.06) 0, rgba(255,0,127,0.06) ${gridLine}px, transparent ${gridLine}px, transparent ${gridMinor}px)
	`,
        backgroundBlendMode: "screen",
        animation: `gridFloat ${gridDur} linear infinite alternate`
    });
    popupDiv.appendChild(grid);
    // Header
    const header = document.createElement("div");
    Object.assign(header.style, {
        position: "relative",
        zIndex: 2,
        marginBottom: "12px",
        borderBottom: "1px solid rgba(160, 216, 255, 0.3)",
        paddingBottom: "8px",
        textAlign: "center"
    });
    const title = document.createElement("h2");
    title.textContent = analysis.analysisTitle || "Mood Analysis";
    Object.assign(title.style, {
        margin: "0",
        fontSize: "16px",
        fontWeight: "700",
        textTransform: "uppercase"
    });
    header.appendChild(title);
    // What this popup IS — so a first-time trader isn't lost. Inline-styled on
    // purpose: this popup can appear on pages that don't load floor.css.
    const explain = document.createElement("p");
    explain.textContent = (0, $fUPn2.t)("floor.exp_analysis", "This is the voice of the bourse \u2014 the market itself reacting to a trade that just happened on the floor. It's commentary, not a request: read it, close it, nothing is asked of you.");
    Object.assign(explain.style, {
        margin: "8px auto 0",
        maxWidth: "420px",
        padding: "7px 10px",
        textAlign: "left",
        fontSize: "11.5px",
        lineHeight: "1.55",
        letterSpacing: "0.5px",
        color: "#f5ecd8",
        borderLeft: "3px solid rgba(255, 179, 71, 0.9)",
        background: "rgba(255, 179, 71, 0.14)",
        borderRadius: "0 3px 3px 0",
        textShadow: "none"
    });
    header.appendChild(explain);
    // Content container (with subtle glass for readability)
    const contentContainer = document.createElement("div");
    Object.assign(contentContainer.style, {
        position: "relative",
        zIndex: 2,
        overflowY: "auto",
        flex: "1",
        paddingRight: "8px",
        maxHeight: "60vh",
        fontSize: "12px",
        lineHeight: "1.6",
        color: "#a0d8ff",
        background: "linear-gradient(to bottom, rgba(6,10,18,0.35), rgba(6,10,18,0.10))",
        borderRadius: "8px",
        padding: "10px 10px 8px 10px"
    });
    if (onlyOneSection) {
        const singleSection = document.createElement("div");
        singleSection.style.marginBottom = "18px";
        const singleLabel = document.createElement("h3");
        singleLabel.textContent = "Market";
        Object.assign(singleLabel.style, {
            margin: "0 0 6px 0",
            fontSize: "14px",
            fontWeight: "600",
            color: "#ff66cc"
        });
        const singleContent = document.createElement("p");
        singleContent.textContent = primaryText;
        singleContent.style.margin = "0";
        singleSection.appendChild(singleLabel);
        singleSection.appendChild(singleContent);
        contentContainer.appendChild(singleSection);
    } else {
        if (hasDistinctSummary) {
            const summarySection = document.createElement("div");
            summarySection.style.marginBottom = "18px";
            const summaryLabel = document.createElement("h3");
            summaryLabel.textContent = "Summary";
            Object.assign(summaryLabel.style, {
                margin: "0 0 6px 0",
                fontSize: "14px",
                fontWeight: "600",
                color: "#ff66cc"
            });
            const summaryContent = document.createElement("p");
            summaryContent.textContent = summaryText;
            summaryContent.style.margin = "0";
            summarySection.appendChild(summaryLabel);
            summarySection.appendChild(summaryContent);
            contentContainer.appendChild(summarySection);
        }
        if (hasDistinctDetails) {
            const detailsSection = document.createElement("div");
            const detailsLabel = document.createElement("h3");
            detailsLabel.textContent = "Details";
            Object.assign(detailsLabel.style, {
                margin: "0 0 6px 0",
                fontSize: "14px",
                fontWeight: "600",
                color: "#ff66cc"
            });
            const detailsContent = document.createElement("div");
            detailsContent.textContent = detailsText;
            detailsSection.appendChild(detailsLabel);
            detailsSection.appendChild(detailsContent);
            contentContainer.appendChild(detailsSection);
        }
    }
    // Footer with close
    const footer = document.createElement("div");
    Object.assign(footer.style, {
        position: "relative",
        zIndex: 2,
        marginTop: "15px",
        borderTop: "1px solid rgba(255, 255, 255, 0.2)",
        paddingTop: "12px",
        textAlign: "center"
    });
    const closeButton = document.createElement("button");
    closeButton.textContent = "Close";
    Object.assign(closeButton.style, {
        padding: "12px 20px",
        backgroundColor: "rgba(255, 0, 0, 0.75)",
        color: "rgba(253, 254, 0, 0.9)",
        border: "none",
        borderRadius: "3px",
        cursor: "pointer",
        fontFamily: "'BitHigh', sans-serif",
        fontSize: "12px",
        fontWeight: "700",
        textTransform: "uppercase",
        boxShadow: "0 0 10px rgba(255, 0, 127, 0.6)",
        transition: "background 0.3s ease-in-out, box-shadow 0.3s ease-in-out, opacity 0.3s ease-in-out",
        opacity: "0.9"
    });
    closeButton.addEventListener("mouseover", ()=>{
        closeButton.style.backgroundColor = "rgba(255, 51, 153, 0.95)";
        closeButton.style.boxShadow = "0 0 15px rgba(255, 51, 153, 1)";
        closeButton.style.opacity = "1";
    });
    closeButton.addEventListener("mouseout", ()=>{
        closeButton.style.backgroundColor = "rgba(255, 0, 0, 0.7)";
        closeButton.style.boxShadow = "0 0 10px rgba(255, 0, 127, 0.6)";
        closeButton.style.opacity = "0.9";
    });
    // In showMoodAnalysisPopup (document 4), replace the closePopup function and handlers:
    const closePopup = ()=>{
        popupDiv.style.transform = "scale(0.9)";
        popupDiv.style.opacity = "0";
        setTimeout(()=>{
            backdrop.remove();
        // Mood popup close no longer triggers redirect - redirect handled by timeout in stockTransaction.js
        }, 200);
    };
    closeButton.addEventListener("click", closePopup);
    backdrop.addEventListener("click", (e)=>{
        if (e.target === backdrop) closePopup();
    });
    document.addEventListener("keydown", function escHandler(ev) {
        if (ev.key === "Escape") {
            closePopup();
            document.removeEventListener("keydown", escHandler);
        }
    });
    footer.appendChild(closeButton);
    // Assemble
    popupDiv.appendChild(header);
    popupDiv.appendChild(contentContainer);
    popupDiv.appendChild(footer);
    backdrop.appendChild(popupDiv);
    document.body.appendChild(backdrop);
    // Show animation
    setTimeout(()=>{
        popupDiv.style.transform = "scale(1)";
        popupDiv.style.opacity = "1";
    }, 50);
    // Prevent scroll
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    backdrop.addEventListener("transitionend", ()=>{
        document.body.style.overflow = originalOverflow;
    }, {
        once: true
    });
}
function $895d6185463ab8db$var$generateFallbackMoodData() {
    return {
        userMood: {
            averageMood: 0.65,
            moodHistory: [
                {
                    positiveImpact: 0.8,
                    negativeImpact: 0.2,
                    timestamp: new Date().toISOString()
                },
                {
                    positiveImpact: 0.7,
                    negativeImpact: 0.3,
                    timestamp: new Date(Date.now() - 3600000).toISOString()
                }
            ]
        },
        marketMood: {
            averageMood: 0.43,
            sentiment: {
                ratio: "1.5"
            },
            transactionCount: 127
        }
    };
}

});
parcelRegister("eCgl8", function(module, exports) {

$parcel$export(module.exports, "showDisplayedArtwork", () => $aa414a1103e576f8$export$84141037970742ee);

var $5W4EI = parcelRequire("5W4EI");
parcelRequire("cJVho");
let $aa414a1103e576f8$var$arInitialized = false;
// Loads external AR scripts if not already loaded
async function $aa414a1103e576f8$var$loadARScripts() {
    if ($aa414a1103e576f8$var$arInitialized) return;
    await $aa414a1103e576f8$var$loadScript('https://aframe.io/releases/1.2.0/aframe.min.js');
    await $aa414a1103e576f8$var$loadScript('https://cdn.jsdelivr.net/gh/jeromeetienne/AR.js@3.3.2/aframe/build/aframe-ar.min.js');
    $aa414a1103e576f8$var$arInitialized = true;
}
function $aa414a1103e576f8$var$loadScript(src) {
    return new Promise((resolve, reject)=>{
        const existingScript = document.querySelector(`script[src="${src}"]`);
        if (existingScript) // Already loaded
        return resolve();
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = ()=>reject(new Error(`Failed to load script ${src}`));
        document.head.appendChild(script);
    });
}
async function $aa414a1103e576f8$var$initARScene(artwork) {
    // Remove existing scene if any
    const existingScene = document.querySelector('a-scene');
    if (existingScene) existingScene.remove();
    const container = document.getElementById('ar-container');
    if (!container) {
        console.error('AR container not found!');
        return;
    }
    // Clear container
    container.innerHTML = '';
    const sceneEl = document.createElement('a-scene');
    sceneEl.setAttribute('embedded', '');
    sceneEl.setAttribute('arjs', 'sourceType: webcam; patternRatio: 0.80; debugUIEnabled: false;');
    const lightEl = document.createElement('a-entity');
    lightEl.setAttribute('light', 'type: ambient; color: #ffffff; intensity: 1');
    sceneEl.appendChild(lightEl);
    // Marker
    const markerEl = document.createElement('a-marker');
    markerEl.setAttribute('type', 'pattern');
    markerEl.setAttribute('url', 'https://cdn.jsdelivr.net/gh/jeromeetienne/AR.js@3.3.2/three.js/examples/marker-training/examples/patterns/hiro.patt');
    let entityEl;
    const position = '0 0 0';
    // Handle artwork type
    switch(artwork.type){
        case 'image':
            entityEl = document.createElement('a-image');
            entityEl.setAttribute('src', artwork.filePath);
            entityEl.setAttribute('position', position);
            entityEl.setAttribute('width', '1');
            entityEl.setAttribute('height', '1');
            break;
        case 'video':
            entityEl = document.createElement('a-video');
            entityEl.setAttribute('src', artwork.filePath);
            entityEl.setAttribute('position', position);
            entityEl.setAttribute('width', '1');
            entityEl.setAttribute('height', '1');
            break;
        case 'interactive':
        case 'AR':
        case '3D':
            // Assume a 3D model if provided, else a placeholder box
            if (artwork.filePath && artwork.filePath.endsWith('.glb')) {
                entityEl = document.createElement('a-entity');
                entityEl.setAttribute('gltf-model', artwork.filePath);
                entityEl.setAttribute('scale', '0.5 0.5 0.5');
                entityEl.setAttribute('position', position);
            } else {
                entityEl = document.createElement('a-box');
                entityEl.setAttribute('position', position);
                entityEl.setAttribute('color', '#4CC3D9');
            }
            break;
        default:
            // Default placeholder
            entityEl = document.createElement('a-box');
            entityEl.setAttribute('position', position);
            entityEl.setAttribute('color', '#FFC65D');
            break;
    }
    markerEl.appendChild(entityEl);
    sceneEl.appendChild(markerEl);
    const cameraEl = document.createElement('a-entity');
    cameraEl.setAttribute('camera', '');
    sceneEl.appendChild(cameraEl);
    container.appendChild(sceneEl);
}
async function $aa414a1103e576f8$var$fetchSingleArtwork(exhibitionId, artworkId) {
    const token = localStorage.getItem('token');
    if (!token) {
        alert('Not authenticated');
        return null;
    }
    const res = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/hyper/exhibitions/${exhibitionId}/artworks/${artworkId}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!res.ok) {
        console.error('Failed to fetch single artwork', await res.text());
        return null;
    }
    return await res.json();
}
async function $aa414a1103e576f8$export$84141037970742ee(exhibitionId, artworkId) {
    console.log('showDisplayedArtwork called with:', exhibitionId, artworkId);
    const artwork = await $aa414a1103e576f8$var$fetchSingleArtwork(exhibitionId, artworkId);
    console.log('Fetched artwork:', artwork);
    if (!artwork) {
        console.error('No artwork returned from fetch');
        return;
    }
    const fullFilePath = artwork.filePath.startsWith('http') ? artwork.filePath : `${0, $5W4EI.apiBaseUrl}${artwork.filePath}`;
    console.log('Resolved artwork file path:', fullFilePath);
    // Remove existing overlay if any
    const oldOverlay = document.getElementById('artwork-overlay');
    if (oldOverlay) oldOverlay.remove();
    const overlay = document.createElement('div');
    overlay.id = 'artwork-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(0,0,0,0.8)';
    overlay.style.zIndex = '100000';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    const artworkContainer = document.createElement('div');
    artworkContainer.style.backgroundColor = '#fff';
    artworkContainer.style.padding = '20px';
    artworkContainer.style.borderRadius = '8px';
    artworkContainer.style.maxWidth = '90%';
    artworkContainer.style.maxHeight = '90%';
    artworkContainer.style.overflow = 'auto';
    // Title and description
    const titleEl = document.createElement('h2');
    titleEl.textContent = artwork.title;
    artworkContainer.appendChild(titleEl);
    if (artwork.description) {
        const descEl = document.createElement('p');
        descEl.textContent = artwork.description;
        artworkContainer.appendChild(descEl);
    }
    // Determine type from API response or fallback to file extension
    const fileExtension = artwork.filePath.split('.').pop().toLowerCase();
    const type = artwork.type || ([
        'jpg',
        'jpeg',
        'png',
        'gif'
    ].includes(fileExtension) ? 'image' : 'video');
    if (type === 'image') {
        const img = document.createElement('img');
        img.src = fullFilePath; // Ensure fullFilePath is resolved correctly
        img.style.maxWidth = '100%';
        img.style.height = 'auto';
        artworkContainer.appendChild(img);
    } else if (type === 'video') {
        const video = document.createElement('video');
        video.src = fullFilePath;
        video.controls = true;
        video.autoplay = true;
        video.style.maxWidth = '100%';
        video.style.height = 'auto';
        artworkContainer.appendChild(video);
    } else {
        const fallback = document.createElement('div');
        fallback.textContent = 'No preview available for this artwork.';
        fallback.style.color = '#000';
        artworkContainer.appendChild(fallback);
    }
    // Close button
    const closeBtn = document.createElement('button');
    closeBtn.textContent = 'Close';
    closeBtn.style.marginTop = '10px';
    closeBtn.addEventListener('click', ()=>{
        overlay.remove();
    });
    artworkContainer.appendChild(closeBtn);
    overlay.appendChild(artworkContainer);
    document.body.appendChild(overlay);
}

});
parcelRegister("cJVho", function(module, exports) {

$parcel$export(module.exports, "socket", () => $94661e82873784cd$export$4f55ed1789bc2dcb);
$parcel$export(module.exports, "getPortfolioId", () => $94661e82873784cd$export$141bbd10c4c06cba);
$parcel$export(module.exports, "resetSocket", () => $94661e82873784cd$export$28707ccaee758d3c);
$parcel$export(module.exports, "connectWebSocket", () => $94661e82873784cd$export$72947bc920927fd0);
$parcel$export(module.exports, "waitForSocketConnection", () => $94661e82873784cd$export$8c106f812aa1ca2a);
$parcel$export(module.exports, "connectBotWebSocket", () => $94661e82873784cd$export$7437ef272097e625);

var $73MNt = parcelRequire("73MNt");

var $eD3DY = parcelRequire("eD3DY");

var $86ioh = parcelRequire("86ioh");

var $2C8cW = parcelRequire("2C8cW");

var $jL4uR = parcelRequire("jL4uR");

var $bNbKd = parcelRequire("bNbKd");

var $1cx8d = parcelRequire("1cx8d");

var $1NhFL = parcelRequire("1NhFL");

var $8X27K = parcelRequire("8X27K");

var $eevDZ = parcelRequire("eevDZ");

var $29zN8 = parcelRequire("29zN8");

var $alKwv = parcelRequire("alKwv");

var $bzRv7 = parcelRequire("bzRv7");

var $eCgl8 = parcelRequire("eCgl8");

var $gwQDn = parcelRequire("gwQDn");

var $iD9HX = parcelRequire("iD9HX");

var $cNeIB = parcelRequire("cNeIB");

var $fUPn2 = parcelRequire("fUPn2");
parcelRequire("15BR8");

var $epcPG = parcelRequire("epcPG");

var $lfdrK = parcelRequire("lfdrK");
let $94661e82873784cd$export$4f55ed1789bc2dcb;
let $94661e82873784cd$var$isProcessingMessage = false;
const $94661e82873784cd$export$8d5992b88d21f8fe = [];
let $94661e82873784cd$var$reconnectTimeout;
let $94661e82873784cd$var$isConnected = false;
let $94661e82873784cd$var$reconnectAttempts = 0;
const $94661e82873784cd$var$MAX_RECONNECT_ATTEMPTS = 5;
const $94661e82873784cd$var$RECONNECT_DELAY = 3000;
// Track attached handlers for cleanup
let $94661e82873784cd$var$handlersAttached = false;
let $94661e82873784cd$var$emotionalMeter = null;
let $94661e82873784cd$var$beforeUnloadHandler = null;
class $94661e82873784cd$var$MessageQueue {
    constructor(){
        this.queue = [];
        this.isProcessing = false;
        this.maxSize = 50;
    }
    enqueue(message) {
        if (this.queue.length >= this.maxSize) {
            const removed = this.queue.shift();
            console.warn("\u26A0\uFE0F MessageQueue full - dropped oldest message:", removed);
        }
        this.queue.push(message);
        this.processQueue();
    }
    async processQueue() {
        if (this.isProcessing || this.queue.length === 0 || !$94661e82873784cd$export$4f55ed1789bc2dcb || !$94661e82873784cd$export$4f55ed1789bc2dcb.connected) return;
        this.isProcessing = true;
        while(this.queue.length > 0 && $94661e82873784cd$export$4f55ed1789bc2dcb.connected){
            const message = this.queue.shift();
            try {
                await this.sendMessage(message);
            } catch (error) {
                console.error('Error sending message:', error);
                this.queue.unshift(message);
                break;
            }
        }
        this.isProcessing = false;
    }
    sendMessage(message) {
        return new Promise((resolve, reject)=>{
            $94661e82873784cd$export$4f55ed1789bc2dcb.emit('message', message, (error)=>{
                if (error) reject(error);
                else resolve();
            });
        });
    }
    clear() {
        this.queue = [];
        this.isProcessing = false;
    }
}
const $94661e82873784cd$var$clientMessageQueue = new $94661e82873784cd$var$MessageQueue();
function $94661e82873784cd$var$getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
function $94661e82873784cd$export$141bbd10c4c06cba() {
    return $94661e82873784cd$var$getCookie('portfolioId') || localStorage.getItem('portfolioId');
}
/**
 * A trigger (steal / ransom / LBO / subsidy / dark pool / communist assault) has
 * just been granted to this trader mid-session.
 *
 * These five socket handlers used to call displayDeletePortfolioButton(true),
 * displayLBOButton(true) &c. directly — but those functions are module-private
 * inner functions of trader.js and were never imported here, so every call was
 * an unresolved identifier that threw ReferenceError. A trigger granted during
 * a session therefore never appeared on ANY page until a manual reload.
 *
 * Announcing it instead lets each interface react in its own way: trader.js
 * calls its local display*Button(true), and zfloor.js refetches the portfolio
 * (the has*Button flags are authoritative there) and re-runs its armed check.
 */ function $94661e82873784cd$var$announceToolGranted(toolId) {
    document.dispatchEvent(new CustomEvent('zx:toolGranted', {
        detail: toolId
    }));
}
function $94661e82873784cd$export$28707ccaee758d3c() {
    console.log("\uD83D\uDD04 [resetSocket] Resetting socket state for fresh simulation...");
    // Clean up emotional meter
    if ($94661e82873784cd$var$emotionalMeter) $94661e82873784cd$var$emotionalMeter = null;
    // Remove beforeunload handler
    if ($94661e82873784cd$var$beforeUnloadHandler) {
        window.removeEventListener('beforeunload', $94661e82873784cd$var$beforeUnloadHandler);
        $94661e82873784cd$var$beforeUnloadHandler = null;
    }
    if ($94661e82873784cd$export$4f55ed1789bc2dcb) {
        $94661e82873784cd$export$4f55ed1789bc2dcb.removeAllListeners();
        if ($94661e82873784cd$export$4f55ed1789bc2dcb.connected) $94661e82873784cd$export$4f55ed1789bc2dcb.disconnect();
        $94661e82873784cd$export$4f55ed1789bc2dcb = null;
    }
    // Reset module state
    $94661e82873784cd$var$isConnected = false;
    $94661e82873784cd$var$reconnectAttempts = 0;
    $94661e82873784cd$var$handlersAttached = false;
    if ($94661e82873784cd$var$reconnectTimeout) {
        clearTimeout($94661e82873784cd$var$reconnectTimeout);
        $94661e82873784cd$var$reconnectTimeout = null;
    }
    // Clear message queues
    $94661e82873784cd$var$clientMessageQueue.clear();
    $94661e82873784cd$export$8d5992b88d21f8fe.length = 0;
    $94661e82873784cd$var$isProcessingMessage = false;
    // Remove any lingering popup/modal elements
    const popupSelectors = [
        '#eulogy-loading-popup',
        '#phase-transition-modal',
        '.simulation-warning',
        '#simulationTimer'
    ];
    popupSelectors.forEach((selector)=>{
        const element = document.querySelector(selector);
        if (element) {
            element.remove();
            console.log(`\u{1F9F9} [resetSocket] Removed lingering element: ${selector}`);
        }
    });
    console.log("\u2705 [resetSocket] Socket state reset complete");
}
function $94661e82873784cd$export$72947bc920927fd0(botToken = null, botPortfolioId = null, botSessionId = null) {
    if ($94661e82873784cd$export$4f55ed1789bc2dcb && ($94661e82873784cd$export$4f55ed1789bc2dcb.connected || $94661e82873784cd$export$4f55ed1789bc2dcb.connecting)) {
        console.log('WebSocket is already connected or connecting.');
        return;
    }
    const portfolioId = botPortfolioId || $94661e82873784cd$export$141bbd10c4c06cba();
    const token = botToken || $94661e82873784cd$var$getCookie('token') || localStorage.getItem('token');
    const sessionId = localStorage.getItem('sessionId');
    const hyperUserPortfolioId = "675170ea341c0618fbec21ee";
    const isHyperUser = portfolioId === hyperUserPortfolioId;
    const isBot = !!(botToken && botPortfolioId);
    console.log("\uD83D\uDD0C Connecting WebSocket:", {
        isBot: isBot,
        portfolioId: portfolioId?.substring(0, 8) + '...',
        hasToken: !!token,
        sessionId: sessionId?.substring(0, 8) + '...'
    });
    if (!isHyperUser && (!portfolioId || !token || !sessionId)) {
        console.error('No portfolio ID, token, or session ID found. Cannot connect to WebSocket.');
        return;
    }
    $94661e82873784cd$export$4f55ed1789bc2dcb = (0, $73MNt.default)(`${(0, $cNeIB.apiBaseSocket)}`, {
        query: isHyperUser ? {
            userId: portfolioId
        } : {
            userId: portfolioId,
            token: token,
            sessionId: sessionId,
            isBot: isBot
        },
        transports: [
            'websocket'
        ],
        reconnectionAttempts: $94661e82873784cd$var$MAX_RECONNECT_ATTEMPTS,
        reconnectionDelay: 1000,
        timeout: 10000
    });
    $94661e82873784cd$export$4f55ed1789bc2dcb.on('connect', ()=>{
        console.log('Connected to WebSocket');
        $94661e82873784cd$var$isConnected = true;
        $94661e82873784cd$var$reconnectAttempts = 0;
        window.popupTrackerSocket = $94661e82873784cd$export$4f55ed1789bc2dcb;
        window.socket = $94661e82873784cd$export$4f55ed1789bc2dcb;
        if (window.popupTracker) {
            window.popupTracker.initialize($94661e82873784cd$export$4f55ed1789bc2dcb);
            console.log("\uD83D\uDD17 [SocketU] Initialized popup tracker with socket connection");
        }
        if (isBot) {
            console.log(`\u{1F916} Registering bot: ${botPortfolioId}`);
            $94661e82873784cd$export$4f55ed1789bc2dcb.emit('registerBot', {
                portfolioId: botPortfolioId,
                token: botToken,
                socketId: $94661e82873784cd$export$4f55ed1789bc2dcb.id
            });
        } else localStorage.setItem('socketId', $94661e82873784cd$export$4f55ed1789bc2dcb.id);
        $94661e82873784cd$var$clientMessageQueue.processQueue();
        // Attach handlers only once per socket instance
        if (!$94661e82873784cd$var$handlersAttached) {
            $94661e82873784cd$var$attachSocketHandlers($94661e82873784cd$export$4f55ed1789bc2dcb, isBot, portfolioId);
            $94661e82873784cd$var$handlersAttached = true;
        }
    });
    $94661e82873784cd$export$4f55ed1789bc2dcb.on('connect_error', (error)=>{
        console.error('WebSocket connection error:', error);
        $94661e82873784cd$var$handleReconnect();
    });
    $94661e82873784cd$export$4f55ed1789bc2dcb.on('disconnect', (reason)=>{
        console.log(`WebSocket connection closed: ${reason}`);
        $94661e82873784cd$var$isConnected = false;
    });
}


/**
 * Attach all socket event handlers - called only once per connection
 */ function $94661e82873784cd$var$attachSocketHandlers(socket, isBot, portfolioId) {
    console.log("\uD83D\uDD17 [SocketU] Attaching socket handlers...");
    socket.on('simulation:ended', (payload)=>{
        const isSimulated = localStorage.getItem('isSimulated') === 'true';
        const simulationType = localStorage.getItem('simulationType');
        if (isSimulated || simulationType) {
            console.log("\uD83C\uDFAF Simulation ended for simulated user:", payload);
            window.dispatchEvent(new CustomEvent('simulation-ended', {
                detail: {
                    payload: payload
                }
            }));
        } else console.log("\uD83D\uDEE1\uFE0F Ignored simulation:ended event for normal user.");
    });
    socket.on('receiveMessage', (message)=>{
        if (message.senderName && (message.senderName.includes('_') || message.senderName.match(/\d{4}$/))) message.isBot = true;
        if (message.botData && message.botData._id) {
            const currentUserId = localStorage.getItem('portfolioId');
            if (currentUserId) {
                const storageKey = `botMessage_${message.botData._id}_${currentUserId}`;
                const messageData = {
                    content: message.content,
                    botData: message.botData,
                    tradingContext: message.tradingContext,
                    recommendedAction: message.recommendedAction,
                    specificStock: message.specificStock,
                    specificItem: message.specificItem,
                    tradingLinks: message.tradingLinks,
                    timestamp: Date.now()
                };
                localStorage.setItem(storageKey, JSON.stringify(messageData));
                console.log("\uD83D\uDCBE Stored bot message in localStorage:", storageKey);
            }
        }
        (0, $29zN8.displayReceivedMessage)(message);
        // FIX: Use setTimeout cleanup instead of creating orphan DOM elements
        const messageElement = document.createElement('div');
        messageElement.innerText = message.content;
        document.body.appendChild(messageElement);
        const cleanupTimer = setTimeout(()=>{
            if (messageElement && messageElement.parentNode) messageElement.parentNode.removeChild(messageElement);
        }, 5000);
        // Store timer reference for potential cleanup
        messageElement._cleanupTimer = cleanupTimer;
    });
    socket.on('messageError', (error)=>{
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.messageError', 'Error sending message:')} ${error}`, false);
    });
    socket.on('zollarAssigned', (data)=>{
        console.log('Received zollarAssigned event:', data);
        const portfolioId = data.portfolioId || null;
        (0, $jL4uR.showZollarSelectedAssign)([
            portfolioId
        ], data.message);
    });
    socket.on('cdsEvent', (payload)=>{
        try {
            console.log("\uD83D\uDCE1 CDS Event Received:", payload);
            if (!payload || !payload.data) return;
            const { role: role, phase: phase, data: data } = payload;
            if (role === 'victim' && phase === 'collapse') (0, $iD9HX.handleCDSVictimCollapse)(data);
            else if (role === 'exploiter' && phase === 'collapse') (0, $iD9HX.handleCDSExploiterGuilt)(data);
            else if (phase === 'init') (0, $iD9HX.handleCDSInitiation)(data);
            else console.warn("\u26A0\uFE0F Unknown CDS phase:", phase);
        } catch (err) {
            console.error("\u274C Error handling cdsEvent:", err);
        }
    });
    // === Emotional Updates ===
    socket.on('emotionalUpdate', async ({ sessionId: sessionId })=>{
        const portfolioId = localStorage.getItem('portfolioId');
        if (!portfolioId) return;
        if (!$94661e82873784cd$var$emotionalMeter) {
            $94661e82873784cd$var$emotionalMeter = new (0, $gwQDn.default)('emotional-debt-meter', portfolioId);
            await $94661e82873784cd$var$emotionalMeter.init();
        } else await $94661e82873784cd$var$emotionalMeter.fetchData();
        console.log(`\u{1F4AB} Emotional debt meter updated for session ${sessionId}`);
    });
    // === Social Economy Requests ===
    socket.on('socialEconomyRequest', (data)=>{
        console.log('Social economy request received:', data);
        const { type: type, fromName: fromName, requesterName: requesterName, amount: amount, humanInterest: humanInterest, package: pkg, vulnerabilityReason: vulnerabilityReason, vulnerabilityScore: vulnerabilityScore, abstractRequest: abstractRequest, principalType: principalType } = data;
        const sender = fromName || requesterName || 'Someone';
        let msg, title, modalType;
        const getQualitativeDescriptor = (quantity, max)=>{
            const q = Number(quantity) || 0;
            const m = Number(max);
            if (q <= 0) return 'None';
            if (m && m > 0) {
                const r = q / m;
                if (r <= 0.01) return 'None';
                if (r <= 0.03) return 'Barely Any';
                if (r <= 0.07) return 'A Trace';
                if (r <= 0.12) return 'A Hint';
                if (r <= 0.18) return 'A Little';
                if (r <= 0.26) return 'A Few';
                if (r <= 0.33) return 'Some';
                if (r <= 0.40) return 'Several';
                if (r <= 0.50) return 'Moderate';
                if (r <= 0.58) return 'Noticeable';
                if (r <= 0.65) return 'Considerable';
                if (r <= 0.72) return 'Many';
                if (r <= 0.78) return 'A Lot';
                if (r <= 0.83) return 'Abundant';
                if (r <= 0.88) return 'Heaps';
                if (r <= 0.92) return 'A Great Deal';
                if (r <= 0.95) return 'Almost All';
                if (r <= 0.97) return 'Nearly Everything';
                if (r <= 0.985) return 'Overflowing';
                if (r <= 0.995) return 'Virtually Everything';
                return 'All You Have';
            }
            if (q <= 0) return 'None';
            if (q <= 1) return 'Barely Any';
            if (q <= 2) return 'A Trace';
            if (q <= 3) return 'A Hint';
            if (q <= 4) return 'A Little';
            if (q <= 6) return 'A Few';
            if (q <= 9) return 'Some';
            if (q <= 12) return 'Several';
            if (q <= 16) return 'Moderate';
            if (q <= 20) return 'Noticeable';
            if (q <= 26) return 'Considerable';
            if (q <= 33) return 'Many';
            if (q <= 40) return 'A Lot';
            if (q <= 55) return 'Abundant';
            if (q <= 70) return 'Heaps';
            if (q <= 90) return 'A Great Deal';
            if (q <= 120) return 'Substantial';
            if (q <= 160) return 'Ample';
            if (q <= 210) return 'Extensive';
            if (q <= 260) return 'Vast';
            if (q <= 320) return 'Profuse';
            if (q <= 380) return 'Almost All';
            if (q <= 440) return 'Nearly Everything';
            if (q <= 490) return 'Virtually Everything';
            return 'All You Have';
        };
        const qLabel = getQualitativeDescriptor;
        if (type === 'help') {
            title = 'Gift Offer';
            const zCount = pkg?.zollars ? typeof pkg.zollars === 'number' ? pkg.zollars : Object.values(pkg.zollars || {}).reduce((a, b)=>a + (Number(b) || 0), 0) : 0;
            const zollarLabel = zCount > 0 ? qLabel(zCount, 100) : null;
            const capitalLabel = !zollarLabel && amount ? qLabel(amount, 1000) : null;
            const giftText = zollarLabel ? `${zollarLabel} Z$` : capitalLabel ? `${capitalLabel} capital` : 'some assets';
            msg = `<p><strong>${sender}</strong> wants to give you <strong>${giftText}</strong>.</p><p>Accept this generous gift?</p>`;
            modalType = 'success';
        } else if (type === 'loan') {
            const vulnText = vulnerabilityReason ? `<div style="margin:16px 0;padding:12px;background:rgba(252,186,3,0.15);border:2px solid #fcba03;border-radius:8px;">
	   <p style="font-family:'bithigh',monospace;font-size:0.95em;color:#fcba03;margin-bottom:6px;font-weight:bold;">Their vulnerability disclosure:</p>
	   <p style="font-style:italic;color:#fff;font-size:1.05em;line-height:1.5;">"${vulnerabilityReason}"</p>
	 </div>` : '';
            const zollarMag = abstractRequest?.zollarMagnitude || 0;
            const capitalMag = abstractRequest?.capitalMagnitude || 0;
            const requestMagnitude = getQualitativeDescriptor(Math.max(zollarMag, capitalMag), 100);
            title = 'M Note Loan Request';
            msg = `<p style="margin-bottom:12px;"><strong>${sender}</strong> is requesting a loan from you.</p>${vulnText}<p style="margin-top:12px;color:#999;font-size:0.9em;">Request magnitude: <strong style="color:#fcba03;">${requestMagnitude}</strong></p><p style="margin-top:8px;font-size:0.9em;color:#999;">Will you provide this loan?</p>`;
            modalType = 'warning';
        } else if (type === 'cds') {
            const pType = (principalType || pkg && pkg.principalType || 'capital').toLowerCase();
            let offeredQty;
            if (pType === 'zollars') {
                const rawZ = pkg?.zollars;
                if (typeof rawZ === 'object' && rawZ !== null && !Array.isArray(rawZ)) offeredQty = Object.values(rawZ).reduce((a, b)=>a + (Number(b) || 0), 0);
                else {
                    const zCount = Array.isArray(rawZ) ? rawZ.length : Number(rawZ);
                    offeredQty = Number.isFinite(zCount) && zCount > 0 ? zCount : Number(amount) || 0;
                }
            } else offeredQty = Number(amount) || 0;
            const headline = pType === 'zollars' ? `<strong>${qLabel(offeredQty, 100)} \u{1B5}</strong> available immediately!` : `<strong>${offeredQty.toLocaleString()} capital</strong> available immediately!`;
            title = 'Premium Funding Opportunity';
            msg = `<p><strong>${sender}</strong> is offering you an <strong>exclusive Z-Payday Premium Package</strong>:</p>
	   <p style="font-size:1.1em;color:#3dd202;margin:10px 0;">${headline}</p>
	   <p style="color:#fcba03;">Fast-track financing with flexible terms</p>
	   <p style="color:#fcba03;">Quick access to capital when you need it most</p>
	   <p style="color:#fcba03;">Dynamic growth potential for your portfolio</p>
	   <p style="font-size:0.85em;color:#888;margin-top:12px;">Accept this limited-time opportunity?</p>`;
            modalType = 'success';
        } else if (type === 'v_note') {
            const vulnText = vulnerabilityReason ? `<div style="margin:16px 0;padding:12px;background:rgba(252,186,3,0.15);border:2px solid #fcba03;border-radius:8px;">
	   <p style="font-family:'bithigh',monospace;font-size:0.95em;color:#fcba03;margin-bottom:6px;font-weight:bold;">Their vulnerability disclosure:</p>
	   <p style="font-style:italic;color:#fff;font-size:1.05em;line-height:1.5;">"${vulnerabilityReason}"</p>
	 </div>` : '';
            const severityText = typeof vulnerabilityScore === 'number' ? `<p style="font-size:0.9em;color:#999;margin-top:8px;">Situation severity: <strong style="color:#fcba03;">${(0, $iD9HX.qualitativeFromFraction_LOCAL)(Math.max(0, Math.min(1, vulnerabilityScore)))}</strong></p>` : '';
            title = 'V Note Aid Request';
            msg = `<p style="margin-bottom:12px;"><strong>${sender}</strong> is requesting aid from you and has disclosed their vulnerability:</p>${vulnText}${severityText}<p style="margin-top:12px;font-size:0.9em;color:#999;">Will you grant aid to this request?</p>`;
            modalType = 'warning';
        } else {
            title = 'Social Economy Request';
            msg = `<p><strong>${sender}</strong> sent you a social economy request.</p>`;
            modalType = 'warning';
        }
        (0, $epcPG.showHoloConfirm)({
            title: title,
            message: msg,
            type: modalType,
            acceptText: 'Accept',
            declineText: 'Decline',
            onAccept: ()=>{
                socket.emit('socialEconomyResponse', {
                    accepted: true,
                    type: type,
                    fromName: sender,
                    amount: amount,
                    package: pkg,
                    requesterId: data.requesterId,
                    sessionId: data.sessionId,
                    humanInterest: data.humanInterest,
                    vulnerabilityReason: data.vulnerabilityReason,
                    vulnerabilityScore: data.vulnerabilityScore,
                    principalType: data.principalType
                });
            },
            onDecline: ()=>{
                socket.emit('socialEconomyResponse', {
                    accepted: false,
                    type: type,
                    fromName: sender,
                    amount: amount,
                    package: pkg,
                    requesterId: data.requesterId,
                    sessionId: data.sessionId,
                    humanInterest: data.humanInterest,
                    vulnerabilityReason: data.vulnerabilityReason,
                    vulnerabilityScore: data.vulnerabilityScore,
                    principalType: data.principalType
                });
            }
        });
    });
    // === Debt Instrument Events ===
    (0, $lfdrK.registerDebtPopupHandlers)(socket);
    // === Social Economy Responses ===
    socket.on('socialEconomyResponse', (data)=>{
        console.log("\uD83D\uDCAC [Frontend] Social economy response received!");
        console.log("\uD83D\uDCAC [Frontend] Data:", JSON.stringify(data, null, 2));
        const message = data.accepted ? `${data.fromName} accepted your ${data.type} request.` : `${data.fromName} declined your ${data.type} request.`;
        if (typeof (0, $iD9HX.modalManager) !== 'undefined' && (0, $iD9HX.modalManager).showMessage) (0, $iD9HX.modalManager).showMessage(message, data.accepted, null);
        else (0, $eD3DY.showNotification)(message, data.accepted);
        if (window.emotionalMeter) window.emotionalMeter.fetchData();
    });
    socket.on('botVulnerabilityShared', (data)=>{
        console.log("\uD83D\uDCAD Bot vulnerability message received:", data);
        const { botName: botName, message: message, vulnerabilityType: vulnerabilityType, emotionalContext: emotionalContext } = data;
        const displayMessage = message || (0, $fUPn2.t)('socketFront.botVulnerabilityDefault', '{botName} has shared something personal with you.').replace('{botName}', botName || 'A bot');
        if (typeof (0, $iD9HX.modalManager) !== 'undefined' && (0, $iD9HX.modalManager).showMessage) (0, $iD9HX.modalManager).showMessage(displayMessage, true, null);
        else (0, $eD3DY.showNotification)(displayMessage, true);
        if (window.emotionalMeter) window.emotionalMeter.fetchData();
    });
    socket.on('memento_mori_announced', (data)=>{
        console.log("\uD83C\uDFFA Memento Mori announced:", data);
        (0, $1cx8d.showMementoMoriAnnouncement)(data);
    });
    socket.on('memento_mori_completed', (data)=>{
        console.log("\u2705 Memento Mori completed:", data);
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.mementoComplete', 'You have completed your contemplation of mortality.'), true);
    });
    socket.on('memento_mori_session_event', (data)=>{
        console.log("\uD83C\uDFFA Session event:", data);
        (0, $eD3DY.showNotification)(data.message, true);
    });
    socket.on('memento_mori_symbolic_death', (data)=>{
        console.log("\uD83D\uDC80 Symbolic death:", data);
        (0, $eD3DY.showNotification)(data.message, false);
    });
    socket.on('memento_mori_price_update', (data)=>{
        console.log("\u26B0\uFE0F Global stock price updated:", data);
        const { companyName: companyName, newPrice: newPrice, systemCompanyId: systemCompanyId } = data;
        if (typeof updateStockPriceDisplay === 'function') updateStockPriceDisplay(systemCompanyId, newPrice);
        (0, $eD3DY.showNotification)(`${companyName} value changed to ${newPrice.toFixed(2)} due to global trading`, true);
        if (localStorage.getItem('simulationType') === 'memento-mori') updateEulogyValue();
    });
    socket.on('memento_mori_timer_expired', (data)=>{
        console.log("\u23F0 Memento Mori timer expired for user:", data);
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId) {
            if (typeof handleMementoMoriTimeout === 'function') handleMementoMoriTimeout();
        } else (0, $eD3DY.showNotification)(`${data.portfolioName} has reached their symbolic death`, true);
    });
    socket.on('memento_mori_phase_change', (data)=>{
        console.log("\u26B0\uFE0F Memento Mori phase change:", data);
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId !== portfolioId) (0, $eD3DY.showNotification)(`${data.portfolioName} entered ${data.newPhase} phase`, true);
    });
    socket.on('deletePortfolioUpdate', (data)=>{
        (0, $alKwv.displayDeletePortfolioUpdate)(data);
    });
    socket.on('deletePortfolioButtonReceived', (data)=>{
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId) $94661e82873784cd$var$announceToolGranted('deletePortfolioButton');
    });
    socket.on('LBOButtonReceived', (data)=>{
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId) $94661e82873784cd$var$announceToolGranted('LBOButton');
    });
    socket.on('LBOUpdate', (data)=>{
        if (data && data.message) (0, $alKwv.handleLBOUpdateForTarget)(data);
    });
    socket.on('SubsidyButtonReceived', (data)=>{
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId) $94661e82873784cd$var$announceToolGranted('SubsidyButton');
    });
    socket.on('SubsidyUpdate', (data)=>{
        if (data && data.message) (0, $alKwv.handleSubsidyUpdateForTarget)(data);
    });
    socket.on('SubsidyReceived', (data)=>{
        if (data && data.message) (0, $alKwv.handleSubsidyReceived)(data);
    });
    socket.on('itemStolen', (data)=>{
        if (data && data.message) (0, $alKwv.handleItemStolen)(data);
    });
    socket.on('specialActionNotification', (data)=>{
        if (data && data.message) (0, $alKwv.handleSpecialActionNotification)(data);
    });
    socket.on('ransomButtonReceived', (data)=>{
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId) $94661e82873784cd$var$announceToolGranted('ransomButton');
    });
    socket.on('RansomUpdate', (data)=>{
        console.log('RansomUpdate received:', data);
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId || !data.portfolioId) (parcelRequire("ehiC0")).then(({ showRansomNotification: showRansomNotification, disablePortfolioInteractions: disablePortfolioInteractions })=>{
            disablePortfolioInteractions();
            showRansomNotification(portfolioId, data.ransomBy, data.ransomPoints);
        }).catch((err)=>{
            console.error('Failed to load ransom.js:', err);
        });
    });
    socket.on('ransomPaid', (data)=>{
        console.log('Ransom paid notification received:', data);
        const { payerName: payerName, amount: amount, payerId: payerId } = data;
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.ransomPaidNotification', '{userName} has paid the ransom of {points} capital. The funds have been transferred to your account.').replace('{userName}', payerName || 'A trader').replace('{points}', amount || 0), true);
    });
    socket.on('communityInvitation', (data)=>{
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.initiatorPortfolioId !== portfolioId) (0, $eevDZ.showCommunityInvitationPopup)(data);
    });
    socket.on('communityJoinStatus', (data)=>{
        if (data.success) {
            (0, $eevDZ.startCommunityTimer)(data.communityId);
            (0, $eevDZ.showCommunityInterface)(data.communityId);
            (0, $eD3DY.showNotification)(data.message, true);
        } else (0, $eD3DY.showNotification)(`Error: ${data.message}`, false);
    });
    socket.on('communityStarted', (data)=>{
        const { communityId: communityId, expirationTime: expirationTime } = data;
        (0, $eevDZ.showCommunityInterface)(communityId);
        (0, $eevDZ.startCommunityTimer)(expirationTime);
    });
    socket.on('communityUpdate', (data)=>{
        if (typeof handleCommunityUpdate === 'function') handleCommunityUpdate(data);
    });
    socket.on('communityCreationStatus', (data)=>{
        if (data.success) {
            (0, $eevDZ.startCommunityTimer)(data.communityId);
            (0, $eevDZ.showCommunityInterface)(data.communityId);
            localStorage.setItem('activeCommunity', data.communityId);
            (0, $eD3DY.showNotification)(data.message, true);
        } else (0, $eD3DY.showNotification)(`Error: ${data.message}`, false);
    });
    socket.on('createCommunityButtonAssigned', (data)=>{
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId) $94661e82873784cd$var$announceToolGranted('createCommunityButton');
    });
    socket.on('communityEnded', (data)=>{
        const { communityId: communityId } = data;
        const communityTimer = document.getElementById('communityTimer');
        const communityInterface = document.getElementById('communityInterface');
        if (communityTimer) communityTimer.remove();
        if (communityInterface) communityInterface.remove();
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.darkPoolEnded', 'The Dark Pool has ended. You are back to normal status.'), true);
    });
    socket.on('communityExpired', (data)=>{
        const { communityId: communityId } = data;
        const communityTimer = document.getElementById('communityTimer');
        const communityInterface = document.getElementById('communityInterface');
        if (communityTimer) communityTimer.remove();
        if (communityInterface) communityInterface.remove();
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.darkPoolExpired', 'The Dark Pool has expired. You are back to normal status.'), true);
    });
    socket.on('messageSent', (response)=>{
        console.log('Message sent response:', response);
        if (response.success) (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.messageSent', 'Message sent successfully!'), true);
        else (0, $eD3DY.showNotification)(response.message, false);
    });
    socket.on('tradeCompleted', (data)=>{
        console.log("\u2705 Trade completed event received:", data);
        const msg = data.message || (0, $fUPn2.t)('socketFront.tradeAccepted', 'Trade accepted!');
        try {
            localStorage.setItem('pendingNotification', JSON.stringify({
                message: msg,
                success: true,
                ts: Date.now()
            }));
        } catch (_) {}
        if (window.cleanupOfferSentPopup) window.cleanupOfferSentPopup();
        try {
            window.__removeWaitingPopup?.();
        } catch  {}
        document.getElementById('offerSentPopup')?.remove();
        document.getElementById('offerSentOverlay')?.remove();
        document.getElementById('waitingPopup')?.remove();
        localStorage.removeItem('pendingOffer');
        localStorage.removeItem('pendingWaitPopup');
    });
    socket.on('tradeDeclined', (data)=>{
        console.log("\u274C Trade declined event received:", data);
        const msg = data.message || (0, $fUPn2.t)('socketFront.tradeDeclined', 'Trade declined.');
        try {
            localStorage.setItem('pendingNotification', JSON.stringify({
                message: msg,
                success: false,
                ts: Date.now()
            }));
        } catch (_) {}
        if (window.cleanupOfferSentPopup) window.cleanupOfferSentPopup();
        try {
            window.__removeWaitingPopup?.();
        } catch  {}
        document.getElementById('offerSentPopup')?.remove();
        document.getElementById('offerSentOverlay')?.remove();
        document.getElementById('waitingPopup')?.remove();
        localStorage.removeItem('pendingOffer');
        localStorage.removeItem('pendingWaitPopup');
    });
    socket.on('tradeError', (data)=>{
        console.error("\u274C Trade error:", data);
        const msg = data.message || (0, $fUPn2.t)('socketFront.tradeError', 'An error occurred with your trade offer');
        try {
            localStorage.setItem('pendingNotification', JSON.stringify({
                message: msg,
                success: false,
                ts: Date.now()
            }));
        } catch (_) {}
        if (window.cleanupOfferSentPopup) window.cleanupOfferSentPopup();
        try {
            window.__removeWaitingPopup?.();
        } catch  {}
        document.getElementById('offerSentPopup')?.remove();
        document.getElementById('offerSentOverlay')?.remove();
        document.getElementById('waitingPopup')?.remove();
        localStorage.removeItem('pendingOffer');
        localStorage.removeItem('pendingWaitPopup');
    });
    socket.on('tradeExpired', (data)=>{
        console.log("\u23F0 Trade expired:", data);
        const msg = data.message || (0, $fUPn2.t)('socketFront.tradeExpired', 'Your trade offer has expired');
        try {
            localStorage.setItem('pendingNotification', JSON.stringify({
                message: msg,
                success: false,
                ts: Date.now()
            }));
        } catch (_) {}
        if (window.cleanupOfferSentPopup) window.cleanupOfferSentPopup();
        try {
            window.__removeWaitingPopup?.();
        } catch  {}
        document.getElementById('offerSentPopup')?.remove();
        document.getElementById('offerSentOverlay')?.remove();
        document.getElementById('waitingPopup')?.remove();
        localStorage.removeItem('pendingOffer');
        localStorage.removeItem('pendingWaitPopup');
    });
    socket.on('tradeTimerExtended', (payload)=>{
        const { initiatorUserId: initiatorUserId, targetUserId: targetUserId, newDuration: newDuration } = payload || {};
        try {
            if (typeof window.updateTradeTimerFromSocket === 'function') window.updateTradeTimerFromSocket(payload);
        } catch (e) {
            console.warn('[socketU] tradeTimerExtended delegation failed:', e);
        }
        (0, $eD3DY.showNotification)(`Timer extended to ${newDuration} seconds`, true);
    });
    socket.on('offerReceived', async (offerData)=>{
        console.log('Offer received with data:', offerData);
        if (offerData.hasStory && offerData.tradeStory) console.log('Story included in offer:', offerData.tradeStory);
        const isCurrentUserBot = localStorage.getItem('isBot') === 'true';
        if (isCurrentUserBot) {
            console.log("\uD83E\uDD16 Bot is the receiver. Auto-accepting offer from:", offerData.initiatorPortfolioName);
            try {
                const { acceptTrade: acceptTrade } = await Promise.resolve((parcelRequire("86ioh")));
                await acceptTrade(offerData);
                console.log("\u2705 Bot offer auto-accepted successfully");
                return;
            } catch (error) {
                console.error("\u274C Bot failed to auto-accept trade:", error);
                (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.tradeAcceptFailed', 'Failed to accept trade:')} ${error.message}`, false);
            }
        }
        (0, $86ioh.showOfferPopup)(offerData, localStorage.getItem('portfolioId'));
    });
    socket.on('buyOfferReceived', async (buyOfferData)=>{
        console.log('Buy offer received with data:', buyOfferData);
        (0, $86ioh.showReceiveBuyOfferPopup)(buyOfferData);
    });
    socket.on('botTradeOffer', (payload)=>{
        try {
            showBotTradeOffer(payload);
        } catch (e) {
            console.error('botTradeOffer handler error:', e);
        }
    });
    socket.on('narrativeResponse', (data)=>{
        console.log('Received narrative response:', data);
        (0, $eD3DY.showNotification)(`${data.response.fromName} ${(0, $fUPn2.t)('socketFront.respondedToAnalysis', 'has responded to your trade analysis')}`, true);
        if (data.botResponse) setTimeout(()=>{
            showUpdatedOfferPopup({
                ...data.originalOffer,
                narrativeExchange: data.narrativeExchange
            });
        }, 2000);
    });
    socket.on('narrativeResponseReceived', (payload)=>{
        try {
            const { originalOffer: originalOffer, narrativeExchange: narrativeExchange } = payload || {};
            const offerForDialog = {
                botName: originalOffer?.botName,
                portfolioName: originalOffer?.portfolioName,
                points: originalOffer?.offerAmount,
                zollars: originalOffer?.zollarBid,
                itemName: originalOffer?.item_name || originalOffer?.itemName,
                isBot: !!originalOffer?.isBot,
                originalOffer: originalOffer,
                narrativeExchange: narrativeExchange
            };
            if (typeof window.showNarrativeResponseDialog === 'function') window.showNarrativeResponseDialog(offerForDialog);
            else {
                const last = narrativeExchange?.[narrativeExchange.length - 1]?.message || '';
                (0, $eD3DY.showNotification)(`Narrative reply from ${offerForDialog.portfolioName || offerForDialog.botName || 'Trader'}: ${last}`, true);
                console.log('[socketU] narrativeResponseReceived (fallback):', payload);
            }
        } catch (err) {
            console.error('[socketU] narrativeResponseReceived handler error:', err);
        }
    });
    socket.on('llmResponseReceived', (data)=>{
        try {
            if (typeof window.handleLLMResponse === 'function') window.handleLLMResponse(data);
            else {
                (0, $eD3DY.showNotification)('New response received.', true);
                console.log('[socketU] llmResponseReceived (fallback):', data);
            }
        } catch (e) {
            console.error('[socketU] llmResponseReceived handler error:', e);
        }
    });
    socket.on('botNarrativeResponse', (data)=>{
        console.log('Bot narrative response received:', data);
        const existingPopup = document.getElementById('offerSentPopup') || document.getElementById('tradeOfferPopup');
        if (existingPopup) {
            window.dispatchEvent(new Event('beforeunload'));
            if (navigator.userAgent.includes('Firefox')) document.dispatchEvent(new Event('visibilitychange'));
            if (existingPopup.parentNode) existingPopup.parentNode.removeChild(existingPopup);
            else existingPopup.remove();
            const overlay = existingPopup.parentElement;
            if (overlay && overlay.style.position === 'fixed') overlay.remove();
        }
        localStorage.removeItem('pendingOffer');
        showUpdatedOfferPopup({
            ...data.originalOffer,
            narrativeExchange: data.narrativeExchange,
            hasLLMResponse: true,
            llmResponse: data.botResponse
        });
    });
    socket.on('redeemOffer', (payload)=>{
        try {
            (0, $2C8cW.showRedeemOfferPopup)?.(payload);
        } catch (e) {
            console.error(e);
        }
    });
    socket.on('redeemResponse', (payload)=>{
        try {
            handleRedeemResponse?.(payload);
        } catch (e) {
            console.error(e);
        }
    });
    socket.on('freebieZ1Event', (data)=>{
        $94661e82873784cd$var$processMessage(data);
    });
    socket.on('giveItemSelect', (data)=>{
        $94661e82873784cd$var$processMessage(data);
    });
    socket.on('givePoints', (data)=>{
        $94661e82873784cd$var$processMessage(data);
    });
    socket.on('taxEventNotification', (data)=>{
        $94661e82873784cd$var$processMessage(data);
    });
    socket.on('deductPoints', (data)=>{
        $94661e82873784cd$var$processMessage(data);
    });
    socket.on('displayArtwork', (data)=>{
        console.log('Received displayArtwork event:', data);
        if (data.exhibitionId && data.artworkId) (0, $eCgl8.showDisplayedArtwork)(data.exhibitionId, data.artworkId);
        else console.error('displayArtwork event received invalid data:', data);
    });
    socket.on('itemReceived', (data)=>{
        console.log('Received itemReceived event:', data);
        $94661e82873784cd$var$processMessage(data);
    });
    socket.on('message', async (event)=>{
        console.log('Raw message received on client:', event);
        if ($94661e82873784cd$var$isProcessingMessage) {
            $94661e82873784cd$export$8d5992b88d21f8fe.push(event);
            return;
        }
        $94661e82873784cd$var$isProcessingMessage = true;
        try {
            let processedData;
            if (event instanceof Blob) {
                const text = await event.text();
                console.log('Received message blob:', text);
                processedData = JSON.parse(text);
            } else if (typeof event === 'string') {
                console.log('Received message:', event);
                processedData = JSON.parse(event);
            } else if (typeof event === 'object') {
                console.log('Received JSON message object:', event);
                processedData = event;
            } else {
                console.error('Received unknown message type:', typeof event);
                return;
            }
            if (processedData && processedData.messageId) socket.emit('messageAck', {
                messageId: processedData.messageId,
                received: true
            });
            $94661e82873784cd$var$processMessage(processedData);
        } catch (error) {
            console.error('Error processing WebSocket message:', error);
        } finally{
            $94661e82873784cd$var$isProcessingMessage = false;
            if ($94661e82873784cd$export$8d5992b88d21f8fe.length > 0) {
                const nextMessage = $94661e82873784cd$export$8d5992b88d21f8fe.shift();
                if (nextMessage && nextMessage.messageId) socket.emit('messageAck', {
                    messageId: nextMessage.messageId,
                    received: true
                });
                $94661e82873784cd$var$processMessage(nextMessage);
            }
        }
    });
    socket.on('bidReceived', (data)=>{
        try {
            const me = $94661e82873784cd$export$141bbd10c4c06cba?.() || localStorage.getItem('portfolioId');
            const target = data?.targetPortfolioId ?? data?.targetUserId;
            if (target && target !== me) return;
            console.log('Bid received:', data);
            const isMementoMori = localStorage.getItem('simulationType') === 'memento-mori';
            if (isMementoMori && data.bidType === 'philosophical') showMementoMoriBidPopup(data, me);
            else (0, $1NhFL.showStockBidPopup)(data, me);
        } catch (e) {
            console.error('bidReceived handler error:', e);
        }
    });
    socket.on('waitingForResponse', (data)=>{
        console.log('Waiting for response:', data);
        if (document.getElementById('bidSubmittingOverlay') || document.getElementById('waitingPopup')) return;
        if (typeof (0, $1NhFL.showWaitingForResponsePopup) === 'function') (0, $1NhFL.showWaitingForResponsePopup)(data?.message);
    });
    socket.on('moodAnalysis', (data)=>{
        try {
            console.log("\uD83E\uDDE0 moodAnalysis event:", data);
            if (!data || data.success === false) {
                try {
                    (0, $1NhFL.closeWaitingForResponsePopup)?.();
                } catch (_) {}
                return;
            }
            const mood = data.analysis;
            if (!mood) return;
            const isResponder = window.__userIsInitiator === false;
            if (!isResponder) try {
                sessionStorage.setItem('pendingMoodAnalysis', JSON.stringify(mood));
            } catch (_) {}
            else try {
                sessionStorage.removeItem('pendingMoodAnalysis');
            } catch (_) {}
            try {
                (0, $1NhFL.closeWaitingForResponsePopup)?.();
            } catch (_) {}
        } catch (e) {
            console.error('moodAnalysis handler error:', e);
        }
    });
    socket.on('bidAccepted', (data)=>{
        try {
            console.log('Bid accepted (initiator view):', data);
            const { message: message, transactionId: transactionId } = data;
            const mood = data.moodResult || data.analysis;
            const msg = message || (0, $fUPn2.t)('socketFront.offerAcceptedLong', 'Your offer has been accepted!');
            try {
                localStorage.setItem('pendingNotification', JSON.stringify({
                    message: msg,
                    success: true,
                    ts: Date.now()
                }));
            } catch (_) {}
            (0, $eD3DY.showNotification)(msg, true);
            const isRealUser = !localStorage.getItem('isBot');
            if (mood && isRealUser) try {
                sessionStorage.setItem('pendingMoodAnalysis', JSON.stringify(mood));
            } catch (_) {}
            console.log('Transaction accepted:', {
                transactionId: transactionId,
                message: message
            });
            try {
                (0, $1NhFL.closeWaitingForResponsePopup)?.();
            } catch (_) {}
            try {
                document.getElementById('waitingPopup')?.remove();
            } catch (_) {}
            try {
                document.getElementById('bidSubmittingOverlay')?.remove();
            } catch (_) {}
        } catch (e) {
            console.error('bidAccepted handler error:', e);
        }
    });
    socket.on('bidDeclined', (data)=>{
        try {
            console.log('Bid declined (initiator view):', data);
            const { message: message, transactionId: transactionId } = data;
            const mood = data.moodResult || data.analysis;
            const msg = message || (0, $fUPn2.t)('socketFront.offerDeclinedLong', 'Your offer has been declined!');
            try {
                localStorage.setItem('pendingNotification', JSON.stringify({
                    message: msg,
                    success: false,
                    ts: Date.now()
                }));
            } catch (_) {}
            (0, $eD3DY.showNotification)(msg, false);
            const isRealUser = !localStorage.getItem('isBot');
            if (mood && isRealUser) try {
                sessionStorage.setItem('pendingMoodAnalysis', JSON.stringify(mood));
            } catch (_) {}
            console.log('Bid declined:', {
                transactionId: transactionId,
                message: message
            });
            try {
                (0, $1NhFL.closeWaitingForResponsePopup)?.();
            } catch (_) {}
            try {
                document.getElementById('waitingPopup')?.remove();
            } catch (_) {}
            try {
                document.getElementById('bidSubmittingOverlay')?.remove();
            } catch (_) {}
        } catch (e) {
            console.error('bidDeclined handler error:', e);
        }
    });
    socket.on('bidAcceptSuccess', (data)=>{
        try {
            console.log("\u2705 Bid accept success (seller view):", data);
            const { message: message } = data;
            const mood = data.moodResult || data.analysis;
            const msg = message || (0, $fUPn2.t)('socketFront.offerAccepted', 'You accepted the bid.');
            (0, $eD3DY.showNotification)(msg, true);
            const isRealUser = !localStorage.getItem('isBot');
            if (mood && isRealUser) {
                try {
                    (0, $bNbKd.showMoodAnalysisPopup)(mood);
                } catch (e) {
                    console.error('Error showing mood popup:', e);
                }
                try {
                    sessionStorage.removeItem('pendingMoodAnalysis');
                } catch (_) {}
            }
            try {
                (0, $1NhFL.closeWaitingForResponsePopup)?.();
            } catch (_) {}
            try {
                document.getElementById('waitingPopup')?.remove();
            } catch (_) {}
            try {
                document.getElementById('bidSubmittingOverlay')?.remove();
            } catch (_) {}
        } catch (e) {
            console.error('bidAcceptSuccess handler error:', e);
        }
    });
    socket.on('bidDeclineSuccess', (data)=>{
        try {
            console.log("\u2705 Bid decline success (seller view):", data);
            const { message: message, transactionId: transactionId } = data;
            const mood = data.moodResult || data.analysis;
            const msg = message || (0, $fUPn2.t)('socketFront.offerDeclined', 'You declined the bid.');
            (0, $eD3DY.showNotification)(msg, false);
            const isRealUser = !localStorage.getItem('isBot');
            if (mood && isRealUser) {
                try {
                    (0, $bNbKd.showMoodAnalysisPopup)(mood);
                } catch (e) {
                    console.error('Error showing mood popup:', e);
                }
                try {
                    sessionStorage.removeItem('pendingMoodAnalysis');
                } catch (_) {}
            }
            console.log('Bid declined:', {
                transactionId: transactionId,
                message: message
            });
            try {
                (0, $1NhFL.closeWaitingForResponsePopup)?.();
            } catch (_) {}
            try {
                document.getElementById('waitingPopup')?.remove();
            } catch (_) {}
            try {
                document.getElementById('bidSubmittingOverlay')?.remove();
            } catch (_) {}
        } catch (e) {
            console.error('bidDeclineSuccess handler error:', e);
        }
    });
    socket.on('bidClosed', (data)=>{
        console.log('Bid closed:', data);
    });
    socket.on('bidExpired', (data)=>{
        console.log('Bid expired:', data);
        (0, $eD3DY.showNotification)(data.message || (0, $fUPn2.t)('socketFront.offerExpired', 'Your offer has expired'), false);
        try {
            if (document.getElementById('waitingPopup')) (0, $1NhFL.closeWaitingForResponsePopup)?.(false);
        } catch (_) {}
        try {
            if (window.shouldRedirectToMarket && window.shouldRedirectToMarket()) setTimeout(()=>window.doMarketRedirectIfNeeded?.(), 1500);
        } catch (_) {}
    });
    socket.on('bidError', (data)=>{
        console.error('Bid error:', data);
        (0, $eD3DY.showNotification)(data.message || (0, $fUPn2.t)('socketFront.offerError', 'An error occurred with your offer'), false);
        try {
            if (document.getElementById('waitingPopup')) (0, $1NhFL.closeWaitingForResponsePopup)?.(false);
        } catch (_) {}
        try {
            if (window.shouldRedirectToMarket && window.shouldRedirectToMarket()) setTimeout(()=>window.doMarketRedirectIfNeeded?.(), 1500);
        } catch (_) {}
    });
    socket.on('transactionBurst', (data)=>{
        console.log("\uD83C\uDF89 Transaction burst triggered:", data);
        const { moodScore: moodScore } = data;
        if (typeof moodScore === 'number') (0, $bNbKd.triggerBurst)(moodScore);
    });
    socket.on('stockShorted', (data)=>{
        console.log('Stock shorted:', data);
        if (data.success) (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.shortSuccess', 'Short position placed successful!'), true);
        else (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.shortFailed', 'Short position failed:')} ${data.message}`, false);
    });
    socket.on('stockShortedNotification', (data)=>{
        console.log('Owner notification:', data);
        (0, $eD3DY.showNotification)(data.message, true);
    });
    socket.on('shortPositionClosed', (data)=>{
        console.log('Short position closed:', data);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.shortClosedPrefix', 'Your short position on stock')} "${data.symbol}" ${(0, $fUPn2.t)('socketFront.shortClosedSuffix2', 'has been automatically closed.')}`, true);
    });
    socket.on('bondBidReceived', (data)=>{
        console.log('Bond bid received:', data);
        (0, $8X27K.showBondBidPopup)(data, $94661e82873784cd$export$141bbd10c4c06cba());
    });
    socket.on('bondBidAccepted', (data)=>{
        console.log('Bond bid accepted:', data);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.bondBidPrefix', 'Your bid for bond')} "${data.bondName}" ${(0, $fUPn2.t)('socketFront.bondAccepted', 'has been accepted.')}`, true);
    });
    socket.on('bondBidDeclined', (data)=>{
        console.log('Bond bid declined:', data);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.bondBidPrefix', 'Your bid for bond')} "${data.bondName}" ${(0, $fUPn2.t)('socketFront.bondDeclined', 'has been declined.')}`, false);
    });
    socket.on('bondBidActionSuccess', (data)=>{
        console.log('Bond bid action success:', data);
        (0, $eD3DY.showNotification)(data.message, data.success);
    });
    socket.on('bondBidError', (data)=>{
        console.error('Bond bid error:', data.error);
        (0, $eD3DY.showNotification)(`Error: ${data.error}`, false);
    });
    socket.on('bondMatured', (data)=>{
        console.log('Bond matured:', data);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.yourBond', 'Your bond')} "${data.bondName}" ${(0, $fUPn2.t)('socketFront.bondMatured', 'has matured, and zollars have been issued.')}`, true);
        displayPortfolioItems();
    });
    socket.on('forceLogout', ()=>{
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.loggedOutByAdmin', 'You have been logged out by the administrator.'), false);
        localStorage.removeItem('portfolioId');
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('sessionId');
        localStorage.removeItem('socketId');
        localStorage.removeItem('initialPortfolioState');
        localStorage.removeItem('selectedItems');
        localStorage.removeItem('superUserId');
        document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'sessionId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'portfolioId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie.split(";").forEach((cookie)=>{
            const name = cookie.split("=")[0];
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        });
        $94661e82873784cd$export$a0973bcfe11b05c9();
        window.location.href = '/index.html';
    });
    socket.on('tokenExpired', ()=>{
        (0, $eD3DY.showNotification)("Session expired. Please log in again.", false);
        $94661e82873784cd$export$a0973bcfe11b05c9();
        setTimeout(()=>{
            window.location.href = '/index.html';
        }, 2000);
    });
    socket.on('playRandomPub', (data)=>{
        console.log('Received playRandomPub event:', data);
        if (data && data.introVideoUrl && data.mainVideoUrl) (0, $alKwv.playPubVideo)(data.mainVideoUrl, data.introVideoUrl);
        else console.error('Received playRandomPub event without valid video URLs:', data);
    });
    socket.on('playRandomZnews', (data)=>{
        console.log('Received playRandomZnews event:', data);
        if (data && data.introVideoUrl && data.mainVideoUrl) (0, $alKwv.playZnewsVideo)(data.mainVideoUrl, data.introVideoUrl);
        else console.error('Received playRandomZnews event without valid video URLs:', data);
    });
    // FIX: Store reference and clean up properly
    $94661e82873784cd$var$beforeUnloadHandler = ()=>{
        if (socket) socket.disconnect();
    };
    window.addEventListener('beforeunload', $94661e82873784cd$var$beforeUnloadHandler);
    console.log("\u2705 [SocketU] All socket handlers attached");
}
function $94661e82873784cd$var$handleReconnect() {
    if ($94661e82873784cd$var$reconnectTimeout) clearTimeout($94661e82873784cd$var$reconnectTimeout);
    if ($94661e82873784cd$var$reconnectAttempts < $94661e82873784cd$var$MAX_RECONNECT_ATTEMPTS) {
        $94661e82873784cd$var$reconnectAttempts++;
        console.log(`Attempting to reconnect (${$94661e82873784cd$var$reconnectAttempts}/${$94661e82873784cd$var$MAX_RECONNECT_ATTEMPTS})...`);
        $94661e82873784cd$var$reconnectTimeout = setTimeout($94661e82873784cd$export$72947bc920927fd0, $94661e82873784cd$var$RECONNECT_DELAY * $94661e82873784cd$var$reconnectAttempts);
    } else console.error('Max reconnection attempts reached. Please refresh the page.');
}
function $94661e82873784cd$export$8c106f812aa1ca2a() {
    return new Promise((resolve)=>{
        if ($94661e82873784cd$export$4f55ed1789bc2dcb && $94661e82873784cd$export$4f55ed1789bc2dcb.connected) resolve();
        else // FIX: Use once() to prevent listener accumulation
        $94661e82873784cd$export$4f55ed1789bc2dcb.once('connect', resolve);
    });
}
function $94661e82873784cd$var$processMessage(data) {
    const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
    console.log('Received JSON message:', data);
    console.log('Portfolio ID from cookie/localStorage:', portfolioId);
    console.log('Target Portfolio ID from message:', data.targetPortfolioId);
    if (data.action === 'offer' && data.targetPortfolioId === portfolioId) {
        console.log('Offer received, attempting to display popup:', data);
        (0, $86ioh.showOfferPopup)(data, portfolioId);
    } else if (data.action === 'socialTradeReceived') (0, $86ioh.showSocialTradeReceived)(data);
    else if (data.action === 'socialTradeResponse') (0, $86ioh.showSocialTradeResponse)(data);
    else if (data.action === 'taxEventNotification') {
        console.log('Tax Event Notification received, displaying tax decision popup.');
        (0, $jL4uR.showTaxDecisionPopup)(portfolioId, data.pointAmount);
    } else if (data.action === 'zollarAssigned' && Array.isArray(data.portfolioIds) && data.portfolioIds.map(String).includes(portfolioId)) {
        window.__seenZollarEvents = window.__seenZollarEvents || new Set();
        if (data.eventId && window.__seenZollarEvents.has(data.eventId)) return;
        if (data.eventId) window.__seenZollarEvents.add(data.eventId);
        (0, $jL4uR.showZollarSelectedAssign)(data.portfolioIds, data.message, data.amount);
        return;
    } else if (data.action === 'taxNotice' && Array.isArray(data.portfolioIds) && data.portfolioIds.map(String).includes(portfolioId)) {
        (0, $jL4uR.displayNotification)(data.message || 'An asset was taxed by the Zederal Reserve.');
        return;
    } else if (data.action === 'freebieZ1') {
        console.log('Zederal Reserve Free Item Notification received, displaying popup.');
        (0, $jL4uR.displayNotification)(data.message);
    } else if (data.action === 'pointsGivenNotice' && Array.isArray(data.portfolioIds) && data.portfolioIds.map(String).includes(portfolioId)) {
        (0, $jL4uR.showPointsAssignedNotification)(data.portfolioIds, Number(data.points) || 0);
        return;
    } else if (data.action === 'pointsDeductedNotice' && Array.isArray(data.portfolioIds) && data.portfolioIds.map(String).includes(portfolioId)) {
        (0, $jL4uR.showPointsDeductedNotification)(data.portfolioIds, Number(data.points) || 0, data.message);
        return;
    } else if (data.action === 'itemReceived') (0, $86ioh.showItemReceivedNotification)(data.giverName, data.itemName);
    else if (data.action === 'deductPoints' && Array.isArray(data.portfolioIds) && data.portfolioIds.includes(portfolioId)) (0, $jL4uR.showPointsDeductedNotification)(data.portfolioIds, data.points, data.message);
    else if (data.action === 'giveItemSelect' && Array.isArray(data.portfolioIds) && data.portfolioIds.includes(portfolioId)) (0, $jL4uR.showItemSelectedAssign)(data.portfolioIds, data.message);
    else if (data.action === 'givePoints' && Array.isArray(data.portfolioIds) && data.portfolioIds.includes(portfolioId)) (0, $jL4uR.showPointsAssignedNotification)(data.portfolioIds, data.points);
    else if (data.targetPortfolioId === portfolioId) {
        if (data.action === 'makeBuyOffer') {
            console.log('Buy offer received, showing buy offer popup.');
            (0, $86ioh.showReceiveBuyOfferPopup)(data);
        } else if (data.action === 'rejectBuyOffer') {
            console.log('Buy offer rejected:', data);
            (0, $86ioh.handleRejectBuyOffer)(data);
        } else if (data.action === 'acceptBuyOffer') {
            console.log('Buy offer accepted:', data);
            (0, $86ioh.handleBuyOfferAcceptedByOther)(data);
        }
    } else console.log('Received message is not relevant to this user or action is not recognized.');
}
async function $94661e82873784cd$export$a0973bcfe11b05c9() {
    const portfolioId = localStorage.getItem('portfolioId');
    const token = localStorage.getItem('token');
    const isSimulated = localStorage.getItem('isSimulated') === 'true';
    if (!portfolioId || !token) {
        console.error('Portfolio ID or token not found in local storage');
        return;
    }
    try {
        if (isSimulated && $94661e82873784cd$export$4f55ed1789bc2dcb && $94661e82873784cd$export$4f55ed1789bc2dcb.connected) {
            console.log("\uD83E\uDD16 Disconnecting bots for simulated user logout...");
            $94661e82873784cd$export$4f55ed1789bc2dcb.emit('disconnectUserBots', {
                portfolioId: portfolioId
            });
            await new Promise((resolve)=>setTimeout(resolve, 1000));
        }
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/${portfolioId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                active: false
            })
        });
        if (!response.ok) throw new Error('Failed to update active status during logout');
    } catch (error) {
        console.error('Error updating active status during logout:', error);
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.logoutActiveUpdateError', 'Error updating active status during logout. Please try again.'), false);
    }
    try {
        const logoutResponse = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                isSimulated: isSimulated
            }),
            credentials: 'include'
        });
        if (!logoutResponse.ok) throw new Error('Failed to logout from server');
        const logoutData = await logoutResponse.json();
        console.log(logoutData.message);
        if (isSimulated) console.log("\uD83C\uDFAF Simulation cleanup completed successfully");
    } catch (error) {
        console.error('Error during server logout:', error);
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.logoutServerError', 'Error during server logout. Please try again.'), false);
    }
    const simulationEnding = localStorage.getItem('simulationEnding') === 'true';
    if (isSimulated && $94661e82873784cd$export$4f55ed1789bc2dcb && $94661e82873784cd$export$4f55ed1789bc2dcb.connected && !simulationEnding) {
        console.log("\uD83E\uDD16 Disconnecting bots for simulated user logout...");
        $94661e82873784cd$export$4f55ed1789bc2dcb.emit('disconnectUserBots', {
            portfolioId: portfolioId
        });
        await new Promise((resolve)=>setTimeout(resolve, 1000));
    }
    // Disconnect main socket
    if ($94661e82873784cd$export$4f55ed1789bc2dcb && $94661e82873784cd$export$4f55ed1789bc2dcb.connected) {
        console.log("\uD83D\uDD0C Disconnecting main socket...");
        $94661e82873784cd$export$4f55ed1789bc2dcb.disconnect();
    }
    const isMementoMori = localStorage.getItem('simulationType') === 'memento-mori';
    const isStorySimulation = localStorage.getItem('simulationType') === 'story-simulation';
    if (simulationEnding || isSimulated || isMementoMori) {
        try {
            document.getElementById('mortality-oracle-interface')?.remove();
            document.getElementById('reflection-interface')?.remove();
            document.getElementById('value-analysis-results')?.remove();
            document.getElementById('persistent-memento-timer')?.remove();
        } catch (e) {
            console.warn('Error cleaning Memento Mori UI:', e);
        }
        (0, $bzRv7.cleanupSimulationTimer)();
        (0, $1cx8d.cleanupMementoMoriTimer)();
    }
    if (isStorySimulation) try {
        document.getElementById('story-bullet-points')?.remove();
        document.getElementById('story-phase-timer')?.remove();
    } catch (e) {
        console.warn('Error cleaning Story Simulation UI:', e);
    }
    localStorage.removeItem('portfolioId');
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('socketId');
    localStorage.removeItem('initialPortfolioState');
    localStorage.removeItem('selectedItems');
    localStorage.removeItem('superUserId');
    localStorage.removeItem('isSimulated');
    localStorage.removeItem('simulatedCompany');
    localStorage.removeItem('firstLogin');
    localStorage.removeItem('activeMementoMori');
    localStorage.removeItem('mementoMoriChecked');
    localStorage.removeItem('mementoMoriStarted');
    localStorage.removeItem('simulationType');
    localStorage.removeItem('mementoMoriObjectiveId');
    localStorage.removeItem('mementoMoriMode');
    localStorage.removeItem('mementoShowAllCompanies');
    localStorage.removeItem('stockBidData');
    localStorage.removeItem('tradeStory');
    localStorage.removeItem('tradeStoryTimestamp');
    localStorage.removeItem('lastConnectedStableKey');
    localStorage.removeItem('simulationEndTime');
    localStorage.removeItem('simulationTimerId');
    localStorage.removeItem('simulationEnding');
    localStorage.removeItem('botTradeOffer');
    localStorage.removeItem('botTradeRecommendation');
    localStorage.removeItem('tradingRecommendation');
    localStorage.removeItem('botTradeTimestamp');
    localStorage.removeItem('storyId');
    localStorage.removeItem('storyTheme');
    localStorage.removeItem('storyPhase');
    localStorage.removeItem('storyPhaseEndsAt');
    for(let i = localStorage.length - 1; i >= 0; i--){
        const key = localStorage.key(i);
        if (key && key.startsWith('trade_')) localStorage.removeItem(key);
    }
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'sessionId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'portfolioId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    window.location.href = '/index.html';
}
function $94661e82873784cd$export$7437ef272097e625(botToken, botPortfolioId, botSessionId) {
    console.log(`\u{1F916} Connecting bot WebSocket for: ${botPortfolioId}`);
    return $94661e82873784cd$export$72947bc920927fd0(botToken, botPortfolioId, botSessionId);
}

});
parcelRegister("73MNt", function(module, exports) {

$parcel$export(module.exports, "io", () => $523eaa49d3f99bf8$export$841407ceb083bd74);
$parcel$export(module.exports, "default", () => $523eaa49d3f99bf8$export$841407ceb083bd74);

var $kATNo = parcelRequire("kATNo");

var $fL4YY = parcelRequire("fL4YY");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");
parcelRequire("1XKMK");
var $i3KZp = parcelRequire("i3KZp");
var $3W81j = parcelRequire("3W81j");
var $dhyBt = parcelRequire("dhyBt");
var $hJTtX = parcelRequire("hJTtX");
/**
 * Managers cache.
 */ const $523eaa49d3f99bf8$var$cache = {};
function $523eaa49d3f99bf8$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $kATNo.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $523eaa49d3f99bf8$var$cache[id] && path in $523eaa49d3f99bf8$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $fL4YY.Manager)(source, opts);
    else {
        if (!$523eaa49d3f99bf8$var$cache[id]) $523eaa49d3f99bf8$var$cache[id] = new (0, $fL4YY.Manager)(source, opts);
        io = $523eaa49d3f99bf8$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($523eaa49d3f99bf8$export$841407ceb083bd74, {
    Manager: $fL4YY.Manager,
    Socket: $lGX0c.Socket,
    io: $523eaa49d3f99bf8$export$841407ceb083bd74,
    connect: $523eaa49d3f99bf8$export$841407ceb083bd74
});

});
parcelRegister("kATNo", function(module, exports) {

$parcel$export(module.exports, "url", () => $efe27346e00da8a8$export$128fa18b7194ef);
parcelRequire("1XKMK");
var $l7wSz = parcelRequire("l7wSz");
function $efe27346e00da8a8$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $l7wSz.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

});
parcelRegister("1XKMK", function(module, exports) {

$parcel$export(module.exports, "Socket", () => (parcelRequire("al9N3")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("5vwdc")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("l7wSz")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("bN72v")).nextTick);

var $al9N3 = parcelRequire("al9N3");

var $6opKi = parcelRequire("6opKi");

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $l7wSz = parcelRequire("l7wSz");

var $bN72v = parcelRequire("bN72v");

var $i3KZp = parcelRequire("i3KZp");

var $3W81j = parcelRequire("3W81j");

var $3W81j = parcelRequire("3W81j");

var $dhyBt = parcelRequire("dhyBt");

var $dhyBt = parcelRequire("dhyBt");

var $hJTtX = parcelRequire("hJTtX");
const $16df97babd1aadf1$export$a51d6b395ff4c65a = (0, $al9N3.Socket).protocol;

});
parcelRegister("al9N3", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $787375aed2c43820$export$4798917dbf149b79);

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");

var $l7wSz = parcelRequire("l7wSz");

var $5hHAH = parcelRequire("5hHAH");

var $CnWUo = parcelRequire("CnWUo");

var $bN72v = parcelRequire("bN72v");
const $787375aed2c43820$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS = [];
if ($787375aed2c43820$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $787375aed2c43820$export$3874118029a0ee0d extends (0, $5hHAH.Emitter) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $bN72v.defaultBinaryType);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $l7wSz.parse)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $l7wSz.parse)(opts.host).host;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $2buxl.decode)(this.opts.query);
        if ($787375aed2c43820$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $bN72v.createCookieJar)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $CnWUo.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $5vwdc.byteLength)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $bN72v.nextTick)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($787375aed2c43820$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$787375aed2c43820$export$3874118029a0ee0d.protocol = (0, $CnWUo.protocol);
class $787375aed2c43820$export$cc521fcb1004e85c extends $787375aed2c43820$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $787375aed2c43820$export$4798917dbf149b79 extends $787375aed2c43820$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $gEtm1.transports)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}

});
parcelRegister("gEtm1", function(module, exports) {

$parcel$export(module.exports, "transports", () => $c1f726e793763466$export$46dec00755c1153b);

var $3W81j = parcelRequire("3W81j");

var $dhyBt = parcelRequire("dhyBt");

var $hJTtX = parcelRequire("hJTtX");
const $c1f726e793763466$export$46dec00755c1153b = {
    websocket: (0, $dhyBt.WS),
    webtransport: (0, $hJTtX.WT),
    polling: (0, $3W81j.XHR)
};

});
parcelRegister("3W81j", function(module, exports) {

$parcel$export(module.exports, "XHR", () => $2ddd02863faa1587$export$a2d42eb087c10497);

var $7pvuz = parcelRequire("7pvuz");

var $5hHAH = parcelRequire("5hHAH");

var $5vwdc = parcelRequire("5vwdc");

var $bN72v = parcelRequire("bN72v");

var $kxvpX = parcelRequire("kxvpX");
function $2ddd02863faa1587$var$empty() {}
class $2ddd02863faa1587$export$c959f2344155d309 extends (0, $7pvuz.Polling) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $2ddd02863faa1587$export$7fa6c5b6f8193917 extends (0, $5hHAH.Emitter) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $5vwdc.pick)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $2ddd02863faa1587$export$7fa6c5b6f8193917.requestsCount++;
            $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $2ddd02863faa1587$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$2ddd02863faa1587$export$7fa6c5b6f8193917.requestsCount = 0;
$2ddd02863faa1587$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $2ddd02863faa1587$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $bN72v.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $2ddd02863faa1587$var$unloadHandler, false);
    }
}
function $2ddd02863faa1587$var$unloadHandler() {
    for(let i in $2ddd02863faa1587$export$7fa6c5b6f8193917.requests)if ($2ddd02863faa1587$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[i].abort();
}
const $2ddd02863faa1587$var$hasXHR2 = function() {
    const xhr = $2ddd02863faa1587$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $2ddd02863faa1587$export$a2d42eb087c10497 extends $2ddd02863faa1587$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $2ddd02863faa1587$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $2ddd02863faa1587$export$7fa6c5b6f8193917($2ddd02863faa1587$var$newRequest, this.uri(), opts);
    }
}
function $2ddd02863faa1587$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $kxvpX.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $bN72v.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}

});
parcelRegister("7pvuz", function(module, exports) {

$parcel$export(module.exports, "Polling", () => $56534be56e5aa809$export$265ee5eefd4c309b);

var $6opKi = parcelRequire("6opKi");

var $5vwdc = parcelRequire("5vwdc");

var $CnWUo = parcelRequire("CnWUo");
class $56534be56e5aa809$export$265ee5eefd4c309b extends (0, $6opKi.Transport) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $CnWUo.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $CnWUo.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $5vwdc.randomString)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}

});
parcelRegister("6opKi", function(module, exports) {

$parcel$export(module.exports, "Transport", () => $4a78f487f5bb98d8$export$86495b081fef8e52);
parcelRequire("CnWUo");
var $ezyGD = parcelRequire("ezyGD");

var $5hHAH = parcelRequire("5hHAH");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");
class $4a78f487f5bb98d8$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $4a78f487f5bb98d8$export$86495b081fef8e52 extends (0, $5hHAH.Emitter) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $4a78f487f5bb98d8$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $ezyGD.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $2buxl.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}

});
parcelRegister("CnWUo", function(module, exports) {

$parcel$export(module.exports, "encodePayload", () => $0736208648dc8bae$export$144d64fe58dad441);
$parcel$export(module.exports, "decodePayload", () => $0736208648dc8bae$export$d10cc2e7f7566a2d);
$parcel$export(module.exports, "createPacketEncoderStream", () => $0736208648dc8bae$export$a525fb718e9c623a);
$parcel$export(module.exports, "createPacketDecoderStream", () => $0736208648dc8bae$export$552d20aac7500f47);
$parcel$export(module.exports, "protocol", () => $0736208648dc8bae$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("bRHuL")).encodePacket);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("ezyGD")).decodePacket);

var $bRHuL = parcelRequire("bRHuL");

var $ezyGD = parcelRequire("ezyGD");

var $fsDlh = parcelRequire("fsDlh");
const $0736208648dc8bae$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $0736208648dc8bae$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $bRHuL.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($0736208648dc8bae$var$SEPARATOR));
        });
    });
};
const $0736208648dc8bae$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($0736208648dc8bae$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $ezyGD.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $0736208648dc8bae$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $bRHuL.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $0736208648dc8bae$var$TEXT_DECODER;
function $0736208648dc8bae$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $0736208648dc8bae$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $0736208648dc8bae$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$0736208648dc8bae$var$TEXT_DECODER) $0736208648dc8bae$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 1) break;
                    const header = $0736208648dc8bae$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 2) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 8) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $fsDlh.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($0736208648dc8bae$var$totalLength(chunks) < expectedLength) break;
                    const data = $0736208648dc8bae$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $ezyGD.decodePacket)(isBinary ? data : $0736208648dc8bae$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $fsDlh.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $0736208648dc8bae$export$a51d6b395ff4c65a = 4;

});
parcelRegister("bRHuL", function(module, exports) {

$parcel$export(module.exports, "encodePacket", () => $8a3662315a48cdbd$export$57852049361a8e62);
$parcel$export(module.exports, "encodePacketToBinary", () => $8a3662315a48cdbd$export$ec0c9b9013ee0ef5);

var $fsDlh = parcelRequire("fsDlh");
const $8a3662315a48cdbd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $8a3662315a48cdbd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $8a3662315a48cdbd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $8a3662315a48cdbd$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($8a3662315a48cdbd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(data, callback);
    } else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $fsDlh.PACKET_TYPES)[type] + (data || ""));
};
const $8a3662315a48cdbd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $8a3662315a48cdbd$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $8a3662315a48cdbd$var$TEXT_ENCODER;
function $8a3662315a48cdbd$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($8a3662315a48cdbd$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($8a3662315a48cdbd$var$toArray).then(callback);
    else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(packet.data))) return callback($8a3662315a48cdbd$var$toArray(packet.data));
    $8a3662315a48cdbd$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$8a3662315a48cdbd$var$TEXT_ENCODER) $8a3662315a48cdbd$var$TEXT_ENCODER = new TextEncoder();
        callback($8a3662315a48cdbd$var$TEXT_ENCODER.encode(encoded));
    });
}

});
parcelRegister("fsDlh", function(module, exports) {

$parcel$export(module.exports, "PACKET_TYPES", () => $b417fd17fc84e4e3$export$c169aefb7330cccb);
$parcel$export(module.exports, "PACKET_TYPES_REVERSE", () => $b417fd17fc84e4e3$export$47791e8004edd485);
$parcel$export(module.exports, "ERROR_PACKET", () => $b417fd17fc84e4e3$export$c718b5840781f8a7);
const $b417fd17fc84e4e3$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$b417fd17fc84e4e3$export$c169aefb7330cccb["open"] = "0";
$b417fd17fc84e4e3$export$c169aefb7330cccb["close"] = "1";
$b417fd17fc84e4e3$export$c169aefb7330cccb["ping"] = "2";
$b417fd17fc84e4e3$export$c169aefb7330cccb["pong"] = "3";
$b417fd17fc84e4e3$export$c169aefb7330cccb["message"] = "4";
$b417fd17fc84e4e3$export$c169aefb7330cccb["upgrade"] = "5";
$b417fd17fc84e4e3$export$c169aefb7330cccb["noop"] = "6";
const $b417fd17fc84e4e3$export$47791e8004edd485 = Object.create(null);
Object.keys($b417fd17fc84e4e3$export$c169aefb7330cccb).forEach((key)=>{
    $b417fd17fc84e4e3$export$47791e8004edd485[$b417fd17fc84e4e3$export$c169aefb7330cccb[key]] = key;
});
const $b417fd17fc84e4e3$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};

});


parcelRegister("ezyGD", function(module, exports) {

$parcel$export(module.exports, "decodePacket", () => $a9bf3da28855a34f$export$4647901878f33f31);

var $fsDlh = parcelRequire("fsDlh");

var $aVEkU = parcelRequire("aVEkU");
const $a9bf3da28855a34f$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a9bf3da28855a34f$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a9bf3da28855a34f$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a9bf3da28855a34f$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $fsDlh.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $fsDlh.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type]
    };
};
const $a9bf3da28855a34f$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a9bf3da28855a34f$var$withNativeArrayBuffer) {
        const decoded = (0, $aVEkU.decode)(data);
        return $a9bf3da28855a34f$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a9bf3da28855a34f$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};

});
parcelRegister("aVEkU", function(module, exports) {

$parcel$export(module.exports, "decode", () => $7f4e842ae29bcbc5$export$2f872c0f2117be69);
// imported from https://github.com/socketio/base64-arraybuffer
const $7f4e842ae29bcbc5$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $7f4e842ae29bcbc5$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $7f4e842ae29bcbc5$var$chars.length; i++)$7f4e842ae29bcbc5$var$lookup[$7f4e842ae29bcbc5$var$chars.charCodeAt(i)] = i;
const $7f4e842ae29bcbc5$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i] >> 2];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $7f4e842ae29bcbc5$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i)];
        encoded2 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});



parcelRegister("5hHAH", function(module, exports) {

$parcel$export(module.exports, "Emitter", () => $3d905a8ca243a015$export$4293555f241ae35a);
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $3d905a8ca243a015$export$4293555f241ae35a(obj) {
    if (obj) return $3d905a8ca243a015$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $3d905a8ca243a015$var$mixin(obj) {
    for(var key in $3d905a8ca243a015$export$4293555f241ae35a.prototype)obj[key] = $3d905a8ca243a015$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.on = $3d905a8ca243a015$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.off = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeListener = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeAllListeners = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$3d905a8ca243a015$export$4293555f241ae35a.prototype.emitReserved = $3d905a8ca243a015$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("5vwdc", function(module, exports) {

$parcel$export(module.exports, "pick", () => $4028d5a20a4526d1$export$357523c63a2253b9);
$parcel$export(module.exports, "installTimerFunctions", () => $4028d5a20a4526d1$export$2f67576668b97183);
$parcel$export(module.exports, "byteLength", () => $4028d5a20a4526d1$export$a48f0734ac7c2329);
$parcel$export(module.exports, "randomString", () => $4028d5a20a4526d1$export$7fa8378418b4411e);

var $bN72v = parcelRequire("bN72v");
function $4028d5a20a4526d1$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT = (0, $bN72v.globalThisShim).setTimeout;
const $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT = (0, $bN72v.globalThisShim).clearTimeout;
function $4028d5a20a4526d1$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT.bind((0, $bN72v.globalThisShim));
        obj.clearTimeoutFn = $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT.bind((0, $bN72v.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $bN72v.globalThisShim).setTimeout.bind((0, $bN72v.globalThisShim));
        obj.clearTimeoutFn = (0, $bN72v.globalThisShim).clearTimeout.bind((0, $bN72v.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $4028d5a20a4526d1$var$BASE64_OVERHEAD = 1.33;
function $4028d5a20a4526d1$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $4028d5a20a4526d1$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $4028d5a20a4526d1$var$BASE64_OVERHEAD);
}
function $4028d5a20a4526d1$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $4028d5a20a4526d1$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}

});
parcelRegister("bN72v", function(module, exports) {

$parcel$export(module.exports, "nextTick", () => $8959bb304e43f43f$export$bdd553fddd433dcb);
$parcel$export(module.exports, "globalThisShim", () => $8959bb304e43f43f$export$394f9358f6231289);
$parcel$export(module.exports, "defaultBinaryType", () => $8959bb304e43f43f$export$790dcbc41e2d75d5);
$parcel$export(module.exports, "createCookieJar", () => $8959bb304e43f43f$export$19413efcf2fac759);
const $8959bb304e43f43f$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $8959bb304e43f43f$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $8959bb304e43f43f$export$790dcbc41e2d75d5 = "arraybuffer";
function $8959bb304e43f43f$export$19413efcf2fac759() {}

});


parcelRegister("2buxl", function(module, exports) {

$parcel$export(module.exports, "encode", () => $19744bce3c183d10$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $19744bce3c183d10$export$2f872c0f2117be69);
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $19744bce3c183d10$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $19744bce3c183d10$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

});



parcelRegister("kxvpX", function(module, exports) {

$parcel$export(module.exports, "hasCORS", () => $ef3f42a25dd224af$export$5235bbd4a1ef06e);
// imported from https://github.com/component/has-cors
let $ef3f42a25dd224af$var$value = false;
try {
    $ef3f42a25dd224af$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $ef3f42a25dd224af$export$5235bbd4a1ef06e = $ef3f42a25dd224af$var$value;

});


parcelRegister("dhyBt", function(module, exports) {

$parcel$export(module.exports, "WS", () => $9ab7b46a38551fa4$export$911baa0677ac404c);

var $6opKi = parcelRequire("6opKi");

var $5vwdc = parcelRequire("5vwdc");
parcelRequire("CnWUo");
var $bRHuL = parcelRequire("bRHuL");

var $bN72v = parcelRequire("bN72v");
// detect ReactNative environment
const $9ab7b46a38551fa4$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $9ab7b46a38551fa4$export$570bf71d2367e261 extends (0, $6opKi.Transport) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $9ab7b46a38551fa4$var$isReactNative ? {} : (0, $5vwdc.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $bRHuL.encodePacket)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $bN72v.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $5vwdc.randomString)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $9ab7b46a38551fa4$var$WebSocketCtor = (0, $bN72v.globalThisShim).WebSocket || (0, $bN72v.globalThisShim).MozWebSocket;
class $9ab7b46a38551fa4$export$911baa0677ac404c extends $9ab7b46a38551fa4$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$9ab7b46a38551fa4$var$isReactNative ? protocols ? new $9ab7b46a38551fa4$var$WebSocketCtor(uri, protocols) : new $9ab7b46a38551fa4$var$WebSocketCtor(uri) : new $9ab7b46a38551fa4$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}

});

parcelRegister("hJTtX", function(module, exports) {

$parcel$export(module.exports, "WT", () => $cea1ad415a07b478$export$961c930859384407);

var $6opKi = parcelRequire("6opKi");

var $bN72v = parcelRequire("bN72v");

var $CnWUo = parcelRequire("CnWUo");
class $cea1ad415a07b478$export$961c930859384407 extends (0, $6opKi.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $CnWUo.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $CnWUo.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $bN72v.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}

});


parcelRegister("l7wSz", function(module, exports) {

$parcel$export(module.exports, "parse", () => $f603c1892ffe9e8b$export$98e6a39c04603d36);
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $f603c1892ffe9e8b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $f603c1892ffe9e8b$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $f603c1892ffe9e8b$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $f603c1892ffe9e8b$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$f603c1892ffe9e8b$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $f603c1892ffe9e8b$var$pathNames(uri, uri['path']);
    uri.queryKey = $f603c1892ffe9e8b$var$queryKey(uri, uri['query']);
    return uri;
}
function $f603c1892ffe9e8b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $f603c1892ffe9e8b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});


parcelRegister("i3KZp", function(module, exports) {

var $7pvuz = parcelRequire("7pvuz");
class $d25cf4f3df002b9c$export$1e7deca84b429035 extends (0, $7pvuz.Polling) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}

});



parcelRegister("fL4YY", function(module, exports) {

$parcel$export(module.exports, "Manager", () => $b78f1c3cb524f77d$export$d0d38e7dec7a1a61);
parcelRequire("1XKMK");
var $5vwdc = parcelRequire("5vwdc");
var $bN72v = parcelRequire("bN72v");
var $al9N3 = parcelRequire("al9N3");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $5pEXn = parcelRequire("5pEXn");

var $5hHAH = parcelRequire("5hHAH");
class $b78f1c3cb524f77d$export$d0d38e7dec7a1a61 extends (0, $5hHAH.Emitter) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $5pEXn.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $2BjQv;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $al9N3.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $vPX8d.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $vPX8d.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $vPX8d.on)(socket, "ping", this.onping.bind(this)), (0, $vPX8d.on)(socket, "data", this.ondata.bind(this)), (0, $vPX8d.on)(socket, "error", this.onerror.bind(this)), (0, $vPX8d.on)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $vPX8d.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $bN72v.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $lGX0c.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

});
parcelRegister("lGX0c", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $fcab49da21a6222a$export$4798917dbf149b79);

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $5hHAH = parcelRequire("5hHAH");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $fcab49da21a6222a$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $fcab49da21a6222a$export$4798917dbf149b79 extends (0, $5hHAH.Emitter) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $vPX8d.on)(io, "open", this.onopen.bind(this)),
            (0, $vPX8d.on)(io, "packet", this.onpacket.bind(this)),
            (0, $vPX8d.on)(io, "error", this.onerror.bind(this)),
            (0, $vPX8d.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($fcab49da21a6222a$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $2BjQv.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $2BjQv.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $2BjQv.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $2BjQv.PacketType).EVENT:
            case (0, $2BjQv.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $2BjQv.PacketType).ACK:
            case (0, $2BjQv.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $2BjQv.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $2BjQv.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $2BjQv.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $2BjQv.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}

});
parcelRegister("2BjQv", function(module, exports) {

$parcel$export(module.exports, "protocol", () => $1e4e6e6cc3958162$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "PacketType", () => $1e4e6e6cc3958162$export$84d4095e16c6fc19);
$parcel$export(module.exports, "Encoder", () => $1e4e6e6cc3958162$export$a50aceb0e02a00aa);
$parcel$export(module.exports, "Decoder", () => $1e4e6e6cc3958162$export$f9de6ca0bc043724);

var $5hHAH = parcelRequire("5hHAH");

var $8URBv = parcelRequire("8URBv");

var $eGKCF = parcelRequire("eGKCF");
/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $1e4e6e6cc3958162$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $1e4e6e6cc3958162$export$a51d6b395ff4c65a = 5;
var $1e4e6e6cc3958162$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($1e4e6e6cc3958162$export$84d4095e16c6fc19 || ($1e4e6e6cc3958162$export$84d4095e16c6fc19 = {}));
class $1e4e6e6cc3958162$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK) {
            if ((0, $eGKCF.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $8URBv.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $1e4e6e6cc3958162$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $1e4e6e6cc3958162$export$f9de6ca0bc043724 extends (0, $5hHAH.Emitter) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $1e4e6e6cc3958162$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $eGKCF.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($1e4e6e6cc3958162$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($1e4e6e6cc3958162$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
                return $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $1e4e6e6cc3958162$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $8URBv.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}

});
parcelRegister("8URBv", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", () => $67dd224d5a131c9e$export$ac2edb9eb7af56f6);
$parcel$export(module.exports, "reconstructPacket", () => $67dd224d5a131c9e$export$a00da3b1ec037a04);

var $eGKCF = parcelRequire("eGKCF");
function $67dd224d5a131c9e$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $67dd224d5a131c9e$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $67dd224d5a131c9e$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $eGKCF.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $67dd224d5a131c9e$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $67dd224d5a131c9e$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $67dd224d5a131c9e$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $67dd224d5a131c9e$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $67dd224d5a131c9e$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $67dd224d5a131c9e$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $67dd224d5a131c9e$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}

});
parcelRegister("eGKCF", function(module, exports) {

$parcel$export(module.exports, "isBinary", () => $ab192732c3780e48$export$37488ff1135b1696);
$parcel$export(module.exports, "hasBinary", () => $ab192732c3780e48$export$5234c529abdb5610);
const $ab192732c3780e48$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $ab192732c3780e48$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $ab192732c3780e48$var$toString = Object.prototype.toString;
const $ab192732c3780e48$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $ab192732c3780e48$var$toString.call(Blob) === "[object BlobConstructor]";
const $ab192732c3780e48$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $ab192732c3780e48$var$toString.call(File) === "[object FileConstructor]";
function $ab192732c3780e48$export$37488ff1135b1696(obj) {
    return $ab192732c3780e48$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $ab192732c3780e48$var$isView(obj)) || $ab192732c3780e48$var$withNativeBlob && obj instanceof Blob || $ab192732c3780e48$var$withNativeFile && obj instanceof File;
}
function $ab192732c3780e48$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($ab192732c3780e48$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($ab192732c3780e48$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $ab192732c3780e48$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $ab192732c3780e48$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}

});



parcelRegister("vPX8d", function(module, exports) {

$parcel$export(module.exports, "on", () => $05fb321879039179$export$af631764ddc44097);
function $05fb321879039179$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

});


parcelRegister("5pEXn", function(module, exports) {

$parcel$export(module.exports, "Backoff", () => $3f0f0eae169725b6$export$2d38012449449c89);
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3f0f0eae169725b6$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});



parcelRegister("eD3DY", function(module, exports) {

$parcel$export(module.exports, "addNotificationStyles", () => $aa6788c1932ec6f8$export$efda41deb0189220);
$parcel$export(module.exports, "showNotification", () => $aa6788c1932ec6f8$export$f7dc72e91f29c7d7);
$parcel$export(module.exports, "updateTotalPointsDisplay", () => $aa6788c1932ec6f8$export$81a2e06e45cc8307);
$parcel$export(module.exports, "showPopupPoints", () => $aa6788c1932ec6f8$export$abdaf5563d6b73ab);
$parcel$export(module.exports, "clearLEDDisplay", () => $aa6788c1932ec6f8$export$155263cfd6c0ecb3);
parcelRequire("21EbS");
parcelRequire("5W4EI");

var $fUPn2 = parcelRequire("fUPn2");

var $15BR8 = parcelRequire("15BR8");
if (!globalThis.ZTranslations) globalThis.ZTranslations = (0, $15BR8.default);
if (typeof globalThis.$t !== 'function') globalThis.$t = (key, params)=>{
    return (0, $fUPn2.t)(key);
};
let $aa6788c1932ec6f8$var$animationInterval;
let $aa6788c1932ec6f8$var$currentMessage = '';
let $aa6788c1932ec6f8$var$transAnimationInterval;
let $aa6788c1932ec6f8$var$currentTransMessage = '';
const $aa6788c1932ec6f8$var$ledFont = {
    'A': [
        '00100',
        '01010',
        '10001',
        '11111',
        '10001'
    ],
    'B': [
        '11110',
        '10001',
        '11110',
        '10001',
        '11110'
    ],
    'C': [
        '01110',
        '10001',
        '10000',
        '10001',
        '01110'
    ],
    'D': [
        '11110',
        '10001',
        '10001',
        '10001',
        '11110'
    ],
    'E': [
        '11111',
        '10000',
        '11100',
        '10000',
        '11111'
    ],
    'F': [
        '11111',
        '10000',
        '11100',
        '10000',
        '10000'
    ],
    'G': [
        '01110',
        '10001',
        '10000',
        '10011',
        '01110'
    ],
    'H': [
        '10001',
        '10001',
        '11111',
        '10001',
        '10001'
    ],
    'I': [
        '11111',
        '00100',
        '00100',
        '00100',
        '11111'
    ],
    'J': [
        '00111',
        '00010',
        '00010',
        '10010',
        '01100'
    ],
    'K': [
        '10001',
        '10010',
        '11100',
        '10010',
        '10001'
    ],
    'L': [
        '10000',
        '10000',
        '10000',
        '10000',
        '11111'
    ],
    'M': [
        '10001',
        '11011',
        '10101',
        '10001',
        '10001'
    ],
    'N': [
        '10001',
        '11001',
        '10101',
        '10011',
        '10001'
    ],
    'O': [
        '01110',
        '10001',
        '10001',
        '10001',
        '01110'
    ],
    'P': [
        '11110',
        '10001',
        '11110',
        '10000',
        '10000'
    ],
    'Q': [
        '01110',
        '10001',
        '10101',
        '10010',
        '01101'
    ],
    'R': [
        '11110',
        '10001',
        '11110',
        '10010',
        '10001'
    ],
    'S': [
        '01111',
        '10000',
        '01110',
        '00001',
        '11110'
    ],
    'T': [
        '11111',
        '00100',
        '00100',
        '00100',
        '00100'
    ],
    'U': [
        '10001',
        '10001',
        '10001',
        '10001',
        '01110'
    ],
    'V': [
        '10001',
        '10001',
        '10001',
        '01010',
        '00100'
    ],
    'W': [
        '10001',
        '10001',
        '10101',
        '10101',
        '01010'
    ],
    'X': [
        '10001',
        '01010',
        '00100',
        '01010',
        '10001'
    ],
    'Y': [
        '10001',
        '01010',
        '00100',
        '00100',
        '00100'
    ],
    'Z': [
        '11111',
        '00010',
        '00100',
        '01000',
        '11111'
    ],
    '0': [
        '01110',
        '10001',
        '10001',
        '10001',
        '01110'
    ],
    '1': [
        '00100',
        '01100',
        '00100',
        '00100',
        '01110'
    ],
    '2': [
        '01110',
        '10001',
        '00010',
        '00100',
        '11111'
    ],
    '3': [
        '11110',
        '00001',
        '00110',
        '00001',
        '11110'
    ],
    '4': [
        '00010',
        '00110',
        '01010',
        '11111',
        '00010'
    ],
    '5': [
        '11111',
        '10000',
        '11110',
        '00001',
        '11110'
    ],
    '6': [
        '01110',
        '10000',
        '11110',
        '10001',
        '01110'
    ],
    '7': [
        '11111',
        '00001',
        '00010',
        '00100',
        '00100'
    ],
    '8': [
        '01110',
        '10001',
        '01110',
        '10001',
        '01110'
    ],
    '9': [
        '01110',
        '10001',
        '01111',
        '00001',
        '01110'
    ],
    ' ': [
        '00000',
        '00000',
        '00000',
        '00000',
        '00000'
    ],
    '!': [
        '00100',
        '00100',
        '00100',
        '00000',
        '00100'
    ],
    '.': [
        '00000',
        '00000',
        '00000',
        '00000',
        '00100'
    ],
    ',': [
        '00000',
        '00000',
        '00000',
        '00010',
        '00100'
    ],
    "'": [
        '00100',
        '00100',
        '00000',
        '00000',
        '00000'
    ],
    '"': [
        '01010',
        '01010',
        '00000',
        '00000',
        '00000'
    ],
    '(': [
        '00010',
        '00100',
        '00100',
        '00100',
        '00010'
    ],
    ')': [
        '00100',
        '00010',
        '00010',
        '00010',
        '00100'
    ],
    '+': [
        '00000',
        '00100',
        '01110',
        '00100',
        '00000'
    ],
    '-': [
        '00000',
        '00000',
        '01110',
        '00000',
        '00000'
    ],
    '?': [
        '01110',
        '10001',
        '00010',
        '00000',
        '00100'
    ],
    ':': [
        '00000',
        '00000',
        '00100',
        '00000',
        '00100'
    ],
    '|': [
        '00100',
        '00100',
        '00100',
        '00100',
        '00100'
    ],
    "\xc0": [
        '00100',
        '01010',
        '10001',
        '11111',
        '10001'
    ],
    "\xc2": [
        '00100',
        '01010',
        '10001',
        '11111',
        '10001'
    ],
    "\xc4": [
        '01010',
        '00000',
        '10001',
        '11111',
        '10001'
    ],
    "\xc7": [
        '01110',
        '10001',
        '10000',
        '10001',
        '11100'
    ],
    "\xc9": [
        '00100',
        '01110',
        '10000',
        '11100',
        '10000'
    ],
    "\xc8": [
        '00100',
        '10000',
        '11100',
        '10000',
        '11111'
    ],
    "\xca": [
        '01010',
        '10000',
        '11100',
        '10000',
        '11111'
    ],
    "\xcb": [
        '01010',
        '00000',
        '11111',
        '10000',
        '11111'
    ],
    "\xce": [
        '01010',
        '00100',
        '11111',
        '00100',
        '00100'
    ],
    "\xcf": [
        '01010',
        '00000',
        '11111',
        '00100',
        '00100'
    ],
    "\xd4": [
        '01010',
        '10001',
        '10001',
        '10001',
        '01110'
    ],
    "\xd6": [
        '01010',
        '00000',
        '01110',
        '10001',
        '01110'
    ],
    "\xd9": [
        '00100',
        '10001',
        '10001',
        '10001',
        '01110'
    ],
    "\xdb": [
        '01010',
        '10001',
        '10001',
        '10001',
        '01110'
    ],
    "\xdc": [
        '01010',
        '00000',
        '10001',
        '10001',
        '01110'
    ],
    "\xe0": [
        '00010',
        '00001',
        '01111',
        '10001',
        '01111'
    ],
    "\xe2": [
        '00100',
        '01010',
        '01110',
        '10001',
        '01111'
    ],
    "\xe4": [
        '01010',
        '00000',
        '01110',
        '10001',
        '01111'
    ],
    "\xe7": [
        '00000',
        '01110',
        '10000',
        '10001',
        '01110'
    ],
    "\xe9": [
        '00100',
        '01110',
        '10001',
        '11111',
        '10000'
    ],
    "\xe8": [
        '00100',
        '10001',
        '11111',
        '10000',
        '01110'
    ],
    "\xea": [
        '01010',
        '01110',
        '10001',
        '11111',
        '10000'
    ],
    "\xeb": [
        '01010',
        '00000',
        '01110',
        '10001',
        '11110'
    ],
    "\xee": [
        '00100',
        '00000',
        '01100',
        '00100',
        '11110'
    ],
    "\xef": [
        '01010',
        '00000',
        '00100',
        '00100',
        '00100'
    ],
    "\xf4": [
        '01010',
        '00000',
        '01110',
        '10001',
        '01110'
    ],
    "\xf6": [
        '01010',
        '00000',
        '01110',
        '10001',
        '01110'
    ],
    "\xf9": [
        '00100',
        '00001',
        '10001',
        '10011',
        '01101'
    ],
    "\xfb": [
        '01010',
        '00001',
        '10001',
        '10011',
        '01101'
    ],
    "\xfc": [
        '01010',
        '00000',
        '10001',
        '10001',
        '01111'
    ],
    "\u0153": [
        '00000',
        '01110',
        '10111',
        '10100',
        '01111'
    ]
};
function $aa6788c1932ec6f8$export$efda41deb0189220() {
    const styles = `
  .notification {
	position: fixed;
	bottom:120px;
	right:10px;
	margin: 0px auto;
	text-align: center;
	background-color: rgba(0, 255, 0, 0.849);
	border: 1px solid #00ff00;
	color: #000000;
	padding: 10px 20px;
	border-radius: 5px;
	z-index: 1000;
	animation: fadeInOut 3s ease-in-out;
  }

  .notification.success {
	border-color: #28a745;
	color: #000000;
  }

  .notification.fail {
	border-color: #dc3545;
	color: #dc3545;
  }

  @keyframes fadeInOut {
	0% { opacity: 0; transform: translateY(-20px); }
	10% { opacity: 1; transform: translateY(0); }
	90% { opacity: 1; transform: translateY(0); }
	100% { opacity: 0; transform: translateY(-20px); }
  }
  .portfolio-search-container{
	 width: 100%;
	 height: auto; 
	 padding: 5px 0px 5px 10px;
	 margin-top: 5px;	
	}
	.portfolio-search-container input{
	background-color: rgba(36, 65, 192, 0.792);
	 color: #00ff00;
	 border: 1px solid rgba(255, 135, 0, 0.682);
	 width: 100%;
	 height: 35px; 
	 padding: 5px 0px 5px 10px;
	 margin-top: 5px;	
	}
	
  `;
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
}
const $aa6788c1932ec6f8$export$f7dc72e91f29c7d7 = (message, isSuccess)=>{
    // The 3D floor replaces the LED ticker with 8-bit cards stacked down the side
    // (zfloor.js installs window.zxNotify). Same call site, different aesthetic —
    // the scrolling board belongs to the classic pages.
    if (typeof window !== 'undefined' && typeof window.zxNotify === 'function') return window.zxNotify(message, isSuccess);
    const ledBoard = document.createElement('div');
    ledBoard.className = 'led-board';
    ledBoard.style = `
	position: fixed;
	bottom: 8%;
	left: -100%;
	width: 100%;
	max-width: 100%;
	height: 42px;
	display: grid;
	grid-template-columns: repeat(150, 4px);
	grid-gap: 2px;
	background-color: ${isSuccess ? 'rgba(0, 30, 0, 0.97)' : 'rgba(30, 0, 0, 0.97)'};
	padding: 6px;
	border-radius: 4px;
	border: 2px solid ${isSuccess ? '#00ff00' : '#ff0000'};
	z-index: 10001;
	overflow: hidden;
	transition: left 0.5s ease-in-out;
  `;
    for(let i = 0; i < 750; i++){
        const led = document.createElement('div');
        led.className = 'led';
        led.style = `
	  width: 6px;
	  height: 6px;
	  background-color: ${isSuccess ? '#003300' : '#330000'};
	  border-radius: 50%;
	  transition: background-color 0.1s, box-shadow 0.1s;
	`;
        ledBoard.appendChild(led);
    }
    document.body.appendChild(ledBoard);
    // Trigger the slide-in effect
    setTimeout(()=>{
        ledBoard.style.left = '1%';
    }, 10);
    const drawText = (text)=>{
        const leds = ledBoard.querySelectorAll('.led');
        let offset = 0; // Start from the beginning of the board
        const animationInterval = setInterval(()=>{
            offset++;
            if (offset > text.length * 6) offset = 0; // Reset to create a loop effect
            for(let row = 0; row < 5; row++)for(let col = 0; col < 150; col++){
                const index = row * 150 + col;
                const charIndex = Math.floor((col + offset) / 6);
                const char = text[charIndex % text.length]; // Use modulo to loop the text
                const fontCol = (col + offset) % 6;
                if (char && fontCol < 5 && $aa6788c1932ec6f8$var$ledFont[char]) {
                    const isLit = $aa6788c1932ec6f8$var$ledFont[char][row][fontCol] === '1';
                    if (isLit) {
                        leds[index].style.backgroundColor = isSuccess ? '#00ff00' : '#ff0000';
                        leds[index].style.boxShadow = isSuccess ? '0 0 4px #00ff00' : '0 0 4px #ff0000';
                    } else {
                        leds[index].style.backgroundColor = isSuccess ? '#003300' : '#330000';
                        leds[index].style.boxShadow = 'none';
                    }
                } else {
                    leds[index].style.backgroundColor = isSuccess ? '#003300' : '#330000';
                    leds[index].style.boxShadow = 'none';
                }
            }
        }, 20); // Keep the animation speed
        // Remove the notification after 6 seconds
        setTimeout(()=>{
            ledBoard.style.left = '-100%'; // Slide out
            clearInterval(animationInterval); // Stop the animation
            setTimeout(()=>ledBoard.remove(), 700); // Remove after slide-out
        }, 6000);
    };
    // Add extra spaces to create a gap between repetitions
    drawText(message.toUpperCase() + '        ');
};
function $aa6788c1932ec6f8$var$injectLedPopupStyles() {
    if (document.getElementById('led-popup-styles')) return;
    const style = document.createElement('style');
    style.id = 'led-popup-styles';
    style.textContent = `
	#led-popup {
	  position: fixed;
	  inset: 5% 5% auto 5%;
	  width: 90%;
	  height: 90%;
	  display: flex;
	  flex-direction: column;
	  background: radial-gradient(1200px 600px at 20% 0%, rgba(0, 15, 10, 0.96), rgba(0, 2, 9, 0.94) 60%);
	  border: 1px solid rgba(255,255,255,0.12);
	  border-radius: 10px;
	  box-shadow: 0 6px 18px rgba(0,0,0,0.45);
	  z-index: 10001;
	  overflow: auto;
	  box-sizing: border-box;
	  backdrop-filter: blur(2px);
	  padding: 8px;
	  animation: ledPopupIn .18s ease-out;
	}
	@keyframes ledPopupIn {
	  from { transform: scale(0.992); opacity: .0 }
	  to   { transform: scale(1);     opacity: 1  }
	}

	/* === Hard reset table layout INSIDE the popup (beats global tr { display:flex } ) === */
	#led-popup table.led-table { display: table !important; width: 100%; border-collapse: collapse !important; table-layout: fixed !important; }
	#led-popup table.led-table thead { display: table-header-group !important; }
	#led-popup table.led-table tbody { display: table-row-group !important; }
	#led-popup table.led-table tr { display: table-row !important; height: auto !important; justify-content: normal !important; align-items: normal !important; }
	#led-popup table.led-table td, 
	#led-popup table.led-table th { display: table-cell !important; vertical-align: middle !important; }

	/* Compact, neutral look */
	#led-popup table.led-table {
	  margin: 0 0 8px 0 !important;
	  color: #e9fff6 !important;
	  font-family: 'bithigh', monospace !important;
	  font-size: 13px !important;
	  line-height: 1.25 !important;
	}
	#led-popup table.led-table col.label-col { width: 45% !important; }
	#led-popup table.led-table col.value-col { width: 55% !important; }

	#led-popup table.led-table td {
	  padding: 15px !important;  /* EXACTLY 5px */
	  border: none !important;
	  border-bottom: 1px solid rgba(255,255,255,0.12) !important; /* bottom border only */
	  background: transparent !important;
	  word-break: break-word !important;
	}
	#led-popup table.led-table tr:first-child td { border-top: none !important; }

	#led-popup table.led-table td.label {
	  color: #cfeee4 !important;
	  font-weight: 600 !important;
	  text-overflow: ellipsis !important;
	  overflow: hidden !important;
	  white-space: nowrap !important;
	}
	#led-popup table.led-table td.value {
	  color: #2fff29 !important;
	  text-align: right !important;
	}

	/* Zollar block row (spans 2 cols) */
	#led-popup .zolPop { 
	  margin-top: 2px !important; 
	  padding: 0 !important; 
	  color: #e4fff6 !important; 
	  font-size: 13px !important; 
	  line-height: 1.25 !important; 
	  text-shadow: none !important; 
	}
	#led-popup .zolPop br { line-height: 1.1 !important; }
	td::before {
		content: attr(data-title);
		color: #fff;
		text-align: center;
		z-index: 1;
		background-color: #00ff001a;
		border-radius: 1px;
		margin-bottom: 10px;
		padding: 5px;
		font-size: .9rem;
		font-weight: 700;
		display: block;
		position: relative;
	  }
	#led-popup .led-close {
	  margin-top: 8px;
	  align-self: flex-end;
	  padding: 8px 12px;
	  background: red;
	  width: 100%;
	  border: 1px solid rgba(255,255,255,0.18);
	  border-radius: 6px;
	  cursor: pointer;
	  color: #ffffff;
	  font-family: 'bithigh', monospace;
	  font-size: 12px;
	  letter-spacing: .04em;
	  transition: transform .08s ease, box-shadow .12s ease, background .12s ease;
	}
	#led-popup .led-close:hover { transform: translateY(-1px); box-shadow: 0 0 10px rgba(255,255,255,0.15); background: rgba(110,110,110,0.32); }
  `;
    document.head.appendChild(style);
}
function $aa6788c1932ec6f8$export$81a2e06e45cc8307(totalPoints, portfolioData = null, itemCumulativePoints = null, stockCumulativeValue = null, shortPositionTotalGainLoss = null, zollars = null, debtData = null) {
    const totalPointsElement = document.getElementById('total-points');
    if (!totalPointsElement) return;
    // Localized labels
    const L = {
        totalFunds: (0, $fUPn2.t)('LedHold.total_funds', 'Total Holdings'),
        earnedFunds: (0, $fUPn2.t)('LedHold.earned_funds', 'Capital Z'),
        itemsValue: (0, $fUPn2.t)('LedHold.value_items', 'Items Value'),
        stockValue: (0, $fUPn2.t)('LedHold.value_stock', 'Stock Value'),
        shortPosition: (0, $fUPn2.t)('LedHold.value_short', 'Short Position'),
        zollars: (0, $fUPn2.t)('LedHold.zollars', 'Zollars'),
        debtOwed: (0, $fUPn2.t)('LedHold.debt_owed', 'Debt Owed'),
        debtHeld: (0, $fUPn2.t)('LedHold.debt_held', 'Debt Held')
    };
    // Base line (LED)
    let newMessage = `${L.totalFunds}: ${totalPoints.toFixed(2)}`;
    // Popup message mirrors LED, but can include HTML blocks
    let popupMessage = newMessage;
    if (portfolioData && itemCumulativePoints !== null && stockCumulativeValue !== null && shortPositionTotalGainLoss !== null) {
        const details = ` | ${L.earnedFunds}: ${portfolioData.tradingPoints.toFixed(2)}` + ` | ${L.itemsValue}: ${itemCumulativePoints.toFixed(2)}` + ` | ${L.stockValue}: ${stockCumulativeValue.toFixed(2)}` + ` | ${L.shortPosition}: ${shortPositionTotalGainLoss.toFixed(2)}`;
        newMessage += details;
        popupMessage += details;
    }
    if (Array.isArray(zollars)) {
        const relationshipTotals = {};
        zollars.forEach((z)=>{
            const type = String(z.zollar_name || '').replace('Zollar', '').trim().toLowerCase();
            if (!type) return;
            relationshipTotals[type] = (relationshipTotals[type] || 0) + 1;
        });
        // Plain text summary for the ticker
        const zollarDetailsPlain = Object.entries(relationshipTotals).map(([type, count])=>{
            const typeLabel = (0, $fUPn2.t)(`LedHold.zollarType.${type}`, $aa6788c1932ec6f8$var$capitalizeFirstLetter(type));
            return `${typeLabel}: ${$aa6788c1932ec6f8$var$getQualitativeDescriptor(count)}`;
        }).join(', ');
        newMessage += ` | ${L.zollars}: ${zollarDetailsPlain}`;
        // HTML block for the popup
        const zollarDetailsHtml = Object.entries(relationshipTotals).map(([type, count])=>{
            const typeLabel = (0, $fUPn2.t)(`LedHold.zollarType.${type}`, $aa6788c1932ec6f8$var$capitalizeFirstLetter(type));
            return `${typeLabel}: ${$aa6788c1932ec6f8$var$getQualitativeDescriptor(count)}`;
        }).join(', <br>');
        popupMessage += ` | <div class="zolPop"><strong>${L.zollars}:&nbsp;</strong>${zollarDetailsHtml}</div>`;
    }
    // Display debt information
    if (debtData && debtData.success) {
        const debtOwed = debtData.totalDebtOwed || 0;
        const debtHeld = debtData.totalDebtHeld || 0;
        // Plain text for LED ticker
        if (debtOwed > 0) newMessage += ` | ${L.debtOwed}: ${debtOwed.toFixed(2)}`;
        if (debtHeld > 0) newMessage += ` | ${L.debtHeld}: ${debtHeld.toFixed(2)}`;
        // HTML block for popup with multi-line details
        if (debtOwed > 0 || debtHeld > 0) {
            const debtLines = [];
            if (debtOwed > 0) debtLines.push(`<span style="color:#ff6666;">${L.debtOwed}: ${debtOwed.toFixed(2)}</span>`);
            if (debtHeld > 0) debtLines.push(`<span style="color:#66ff66;">${L.debtHeld}: ${debtHeld.toFixed(2)}</span>`);
            if (debtData.netDebt !== undefined) {
                const netColor = debtData.netDebt > 0 ? '#ff6666' : debtData.netDebt < 0 ? '#66ff66' : '#fcba03';
                debtLines.push(`<span style="color:${netColor};">Net Position: ${debtData.netDebt.toFixed(2)}</span>`);
            }
            const debtDetailsHtml = `<strong>Debt:</strong><br>${debtLines.join('<br>')}`;
            popupMessage += ` | <div class="debtPop">${debtDetailsHtml}</div>`;
        }
    }
    // Only update if message changed
    if (window.currentMessage === newMessage) return;
    window.currentMessage = newMessage;
    window.currentPopupMessage = popupMessage;
    // --- LED sizing: lettering is good, adjust container below ---
    const DOT_SPACING = 12; // distance between dot centers
    const DOT_RADIUS = 3.8; // dot radius
    const CHAR_COLS = 5;
    const CHAR_ROWS = 5; // original 10-row font matrix
    const CHAR_PIXEL_WIDTH = DOT_SPACING * CHAR_COLS; // 12 * 5 = 60
    const CHAR_PIXEL_HEIGHT = DOT_SPACING * CHAR_ROWS; // 12 * 10 = 120
    const CHAR_GAP = 18; // extra empty space between characters
    const CHAR_STEP = CHAR_PIXEL_WIDTH + CHAR_GAP; // scroll step per character
    // Trim some bottom space from the bitmap so container is not too tall
    const BOTTOM_TRIM = 0; // adjust 20–30 if needed
    // Create canvas only once
    let canvas = totalPointsElement.querySelector('canvas');
    if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.width = 800;
        canvas.height = CHAR_PIXEL_HEIGHT + 10; // smaller visible container
        canvas.style.width = '100%';
        canvas.style.paddingTop = '0px';
        canvas.style.height = `${canvas.height}px`;
        canvas.style.cursor = 'pointer';
        totalPointsElement.innerHTML = '';
        totalPointsElement.appendChild(canvas);
        canvas.addEventListener('click', ()=>$aa6788c1932ec6f8$export$abdaf5563d6b73ab(window.currentPopupMessage));
    } else {
        canvas.height = CHAR_PIXEL_HEIGHT - BOTTOM_TRIM;
        canvas.style.height = `${canvas.height}px`;
    }
    // Rebuild LED patterns for current sizing/message
    window.ledPatterns = new Map();
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = CHAR_PIXEL_WIDTH;
    tempCanvas.height = CHAR_PIXEL_HEIGHT;
    const tempCtx = tempCanvas.getContext('2d');
    for (const char of new Set(newMessage.toUpperCase())){
        if (!$aa6788c1932ec6f8$var$ledFont[char]) continue;
        tempCtx.clearRect(0, 0, CHAR_PIXEL_WIDTH, CHAR_PIXEL_HEIGHT);
        for(let row = 0; row < CHAR_ROWS; row++){
            for(let col = 0; col < CHAR_COLS; col++)if ($aa6788c1932ec6f8$var$ledFont[char][row] && $aa6788c1932ec6f8$var$ledFont[char][row][col] === '1') {
                tempCtx.fillStyle = '#fcba03';
                tempCtx.beginPath();
                tempCtx.arc(col * DOT_SPACING + DOT_SPACING / 2, row * DOT_SPACING + DOT_SPACING / 2, DOT_RADIUS, 0, Math.PI * 2);
                tempCtx.fill();
            }
        }
        window.ledPatterns.set(char, tempCtx.getImageData(0, 0, CHAR_PIXEL_WIDTH, CHAR_PIXEL_HEIGHT));
    }
    const ctx = canvas.getContext('2d');
    let animationFrame;
    let offset = 0;
    const SCROLL_SPEED = 4;
    if (window.stopAnimation) window.stopAnimation();
    function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const visibleChars = Math.ceil(canvas.width / CHAR_STEP) + 2;
        const startChar = Math.floor(offset / CHAR_STEP);
        for(let i = 0; i < visibleChars; i++){
            const charIndex = (startChar + i) % newMessage.length;
            const char = newMessage[charIndex].toUpperCase();
            const pattern = window.ledPatterns.get(char);
            if (pattern) {
                const x = i * CHAR_STEP - offset % CHAR_STEP;
                // center vertically: (canvas.height - pattern.height) / 2
                const y = Math.round((canvas.height - CHAR_PIXEL_HEIGHT) / 2);
                ctx.putImageData(pattern, x, y);
            }
        }
        offset = (offset + SCROLL_SPEED) % (newMessage.length * CHAR_STEP);
        animationFrame = requestAnimationFrame(animate);
    }
    window.stopAnimation = ()=>{
        if (animationFrame) cancelAnimationFrame(animationFrame);
    };
    animate();
}
// Helper functions for Zollar descriptors and capitalization
function $aa6788c1932ec6f8$var$getQualitativeDescriptor(quantity) {
    if (quantity === 0) return (0, $fUPn2.t)('LedHold.zollarDescriptor.none', 'None');
    else if (quantity <= 3) return (0, $fUPn2.t)('LedHold.zollarDescriptor.few', 'A Few');
    else if (quantity <= 7) return (0, $fUPn2.t)('LedHold.zollarDescriptor.some', 'Some');
    else if (quantity <= 15) return (0, $fUPn2.t)('LedHold.zollarDescriptor.many', 'Many');
    return (0, $fUPn2.t)('LedHold.zollarDescriptor.huge', 'A Huge Amount');
}
function $aa6788c1932ec6f8$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $aa6788c1932ec6f8$export$abdaf5563d6b73ab(message) {
    const existingPopup = document.getElementById('led-popup');
    if (existingPopup) existingPopup.remove();
    $aa6788c1932ec6f8$var$injectLedPopupStyles();
    const popup = document.createElement('div');
    popup.id = 'led-popup';
    const table = document.createElement('table');
    table.className = 'led-table';
    // Force two columns with known widths
    const colgroup = document.createElement('colgroup');
    const col1 = document.createElement('col');
    col1.className = 'label-col';
    const col2 = document.createElement('col');
    col2.className = 'value-col';
    colgroup.appendChild(col1);
    colgroup.appendChild(col2);
    table.appendChild(colgroup);
    const tbody = document.createElement('tbody');
    table.appendChild(tbody);
    // Tokenize by top-level separators (you build message with " | ")
    const parts = String(message || '').split(' | ').map((p)=>(p || '').trim()).filter(Boolean);
    // Reconstruct rows, grouping any HTML blocks like <div class="zolPop"> or <div class="debtPop">
    // until their closing </div>, so inner spans and pipes don't leak.
    const rows = [];
    const popDivRegex = /<div[^>]*class="[^"]*(?:zolPop|debtPop)[^"]*"[^>]*>/i;
    let buffer = null;
    for(let i = 0; i < parts.length; i++){
        const token = parts[i];
        if (buffer !== null) {
            buffer += ' | ' + token;
            if (token.includes('</div>')) {
                rows.push(buffer);
                buffer = null;
            }
            continue;
        }
        if (popDivRegex.test(token)) {
            if (token.includes('</div>')) rows.push(token); // single-token HTML block
            else buffer = token; // begin buffering until </div>
            continue;
        }
        rows.push(token); // normal label:value row
    }
    if (buffer !== null) rows.push(buffer); // fail-safe
    rows.forEach((row, idx)=>{
        const tr = document.createElement('tr');
        // Keep HTML blocks as one row spanning both columns
        if (row.includes('class="zolPop"') || row.includes('class="debtPop"')) {
            const td = document.createElement('td');
            td.colSpan = 2;
            td.className = 'value';
            td.innerHTML = row; // render the provided HTML block intact
            tr.appendChild(td);
            tbody.appendChild(tr);
            return;
        }
        // Split only on the first ":" -> Label | Value
        const m = row.match(/^([^:]+)\s*:\s*(.*)$/);
        const label = (m ? m[1] : row).trim();
        const value = (m ? m[2] : '').trim();
        const tdLabel = document.createElement('td');
        tdLabel.className = 'label';
        tdLabel.textContent = label;
        const tdValue = document.createElement('td');
        tdValue.className = 'value';
        tdValue.innerHTML = value || '&nbsp;';
        if (idx === 0) {
            tdLabel.style.borderTop = 'none';
            tdValue.style.borderTop = 'none';
        }
        tr.appendChild(tdLabel);
        tr.appendChild(tdValue);
        tbody.appendChild(tr);
    });
    popup.appendChild(table);
    const closeButton = document.createElement('button');
    closeButton.className = 'led-close';
    closeButton.textContent = typeof (0, $fUPn2.t) === 'function' ? (0, $fUPn2.t)('LedHold.close', 'Close') : 'Close';
    closeButton.onclick = ()=>popup.remove();
    popup.appendChild(closeButton);
    document.body.appendChild(popup);
}
function $aa6788c1932ec6f8$export$155263cfd6c0ecb3() {
    if ($aa6788c1932ec6f8$var$animationInterval) {
        clearInterval($aa6788c1932ec6f8$var$animationInterval);
        $aa6788c1932ec6f8$var$animationInterval = null;
    }
    const totalPointsElement = document.getElementById('total-points');
    if (totalPointsElement) {
        const label = (0, $fUPn2.t)('LedHold.total_points_label', 'Total Points');
        totalPointsElement.innerHTML = `${label}: ${$aa6788c1932ec6f8$var$currentMessage.split('    ')[0].split('$')[1]}`;
    }
}

});
parcelRegister("21EbS", function(module, exports) {

$parcel$export(module.exports, "getAuthToken", () => $179ad9ca248c7149$export$38e1f53b76ec7fed);
//import jwt from 'jsonwebtoken';
//import { secretKey } from '../backend/config.js';
parcelRequire("5W4EI");
function $179ad9ca248c7149$export$38e1f53b76ec7fed() {
    return localStorage.getItem('token'); // Retrieves the token from localStorage
}

});

parcelRegister("fUPn2", function(module, exports) {

$parcel$export(module.exports, "t", () => $b963ef1eb952fbbf$export$625550452a3fa3ec);
// frontend/js/translationHelper.js
const $b963ef1eb952fbbf$var$get = (obj, path)=>path.split('.').reduce((o, k)=>o && o[k] != null ? o[k] : undefined, obj);
const $b963ef1eb952fbbf$var$fmt = (str, params)=>!params ? str : str.replace(/\{(\w+)\}/g, (_, k)=>k in params ? params[k] : `{${k}}`);
const $b963ef1eb952fbbf$export$625550452a3fa3ec = (key, paramsOrFallback)=>{
    const i18n = window.i18n;
    const hasParamsObj = paramsOrFallback && typeof paramsOrFallback === 'object' && !Array.isArray(paramsOrFallback);
    const params = hasParamsObj ? paramsOrFallback : undefined;
    const fallback = !hasParamsObj && typeof paramsOrFallback !== 'undefined' ? paramsOrFallback : undefined;
    // detect language once, consistently
    const lang = (i18n?.lang || localStorage.getItem('preferredLanguage') || 'en').toString().slice(0, 2);
    // markers like "[traduction manquante] ..." or "[translation missing] ..."
    const MISSING_RE = /^\s*\[(?:traduction manquante|translation missing)[^\]]*\]\s*$/i;
    // If user is English, always show the provided fallback (base text) when available
    if (lang === 'en' && typeof fallback !== 'undefined') return typeof fallback === 'string' ? $b963ef1eb952fbbf$var$fmt(fallback, params) : fallback;
    let val;
    if (i18n?.t) val = i18n.t(key, params);
    else {
        const dict = window.__STATIC_TRANSLATIONS__ || globalThis.ZTranslations || {};
        const root = dict[lang] || dict.en || {};
        const base = root.translation || root;
        const found = $b963ef1eb952fbbf$var$get(base, key);
        val = typeof found === 'string' ? $b963ef1eb952fbbf$var$fmt(found, params) : undefined;
    }
    // Standard fallbacks
    if (val == null || val === key || typeof val === 'string' && MISSING_RE.test(val)) {
        if (typeof fallback !== 'undefined') return typeof fallback === 'string' ? $b963ef1eb952fbbf$var$fmt(fallback, params) : fallback;
    }
    return val ?? key;
};
const $b963ef1eb952fbbf$export$4e5aab1c9b62a422 = (key, fallbackOrParams)=>confirm($b963ef1eb952fbbf$export$625550452a3fa3ec(key, fallbackOrParams));
const $b963ef1eb952fbbf$export$d66adb1ff1c28d62 = (sel, key, fallbackOrParams)=>{
    const el = typeof sel === 'string' ? document.querySelector(sel) : sel;
    if (el) el.textContent = $b963ef1eb952fbbf$export$625550452a3fa3ec(key, fallbackOrParams);
};
const $b963ef1eb952fbbf$export$aad808f2718ba5af = (sel, attr, key, fallbackOrParams)=>{
    const el = typeof sel === 'string' ? document.querySelector(sel) : sel;
    if (el) el.setAttribute(attr, $b963ef1eb952fbbf$export$625550452a3fa3ec(key, fallbackOrParams));
};

});

parcelRegister("15BR8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cb39f7c2a1e3ebc$export$2e2bcd8739ae039);
// frontend/js/translations.js
function $0cb39f7c2a1e3ebc$export$88b0f9c4043edaa8(company = {}, tFn) {
    const tSafe = typeof tFn === 'function' ? tFn : (_k, fb)=>fb ?? '';
    const raw = company.csvRow ?? company.Id ?? company.ID ?? company.csv_id ?? company.csvIndex ?? company.row ?? company.rowId ?? company.csvRowNumber;
    const rowId = raw != null ? String(raw).trim() : '';
    const MISSING_RE = /^\s*\[(?:traduction manquante|translation missing)[^\]]*\]\s*$/i;
    const pick = (key, fallback)=>{
        if (!rowId) return fallback;
        const v = tSafe(key, undefined);
        if (!v || v === key || typeof v === 'string' && MISSING_RE.test(v)) return fallback;
        return v;
    };
    const name = pick(`companies_by_id.${rowId}.Company_Name`, company['Company Name'] || company.name || '');
    const out = pick(`companies_by_id.${rowId}.Out_put`, company['Out put'] || company['Output'] || company.output || '');
    const desc = pick(`companies_by_id.${rowId}.Description`, company['Description'] || company.description || '');
    const risk = pick(`companies_by_id.${rowId}.Risk`, company['Risk'] || company.risk || '');
    return {
        name: name,
        out: out,
        desc: desc,
        risk: risk,
        rowId: rowId
    };
}
const $0cb39f7c2a1e3ebc$var$translations = {
    en: {
        translation: {
            "_meta": {
                "language": "English",
                "version": "1.0.0",
                "last_updated": "2025-08-05"
            },
            "nudge": {
                "next": "NEXT",
                "back": "Back",
                "done": "GOT IT",
                "tap_hint": "tap right to continue \xb7 swipe to move",
                "reopen": "How does this page work?",
                "sim_tag": "PRACTICE FLOOR",
                "sim_1_h": "This is practice.",
                "sim_1_b": "A safe run to learn how trading your life works. Nothing here is permanent \u2014 explore freely.",
                "sim_2_h": "Look at what you hold.",
                "sim_2_b": "Scroll down. Each section below is something you own right now. Tap a section to open it.",
                "sim_3_h": "Then enter the Market.",
                "sim_3_b": "When you are ready, hit the button at the bottom to walk onto the open floor and trade.",
                "sim_cta": "GOT IT \u2014 TAKE ME IN",
                "trader_tag": "YOUR SIDE OF THE FLOOR",
                "trader_1_h": "This is everything you carry.",
                "trader_1_b": "Your holdings and your mission live here. Tap any section to open it; tap again to close.",
                "trader_2_h": "Your mission is up top.",
                "trader_2_b": "It tells you what to aim for. Trade to move toward it.",
                "trader_3_h": "Go to the Market to trade.",
                "trader_3_b": "The open floor is where you offer for what other people hold. Use the button at the bottom.",
                "trader_cta": "GOT IT",
                "market_tag": "THE OPEN FLOOR",
                "market_1_h": "Find something that matters to YOU.",
                "market_1_b": "Scroll the things other traders hold. This is not about money \u2014 it is about what you value.",
                "market_2_h": "Tap it to make an offer.",
                "market_2_b": "Ask yourself: what is that worth in my life? Then offer relational value, a swap, or a bid.",
                "market_3_h": "They accept \u2192 it is yours.",
                "market_3_b": "The owner says yes and it moves into your life. No cash anywhere.",
                "market_cta": "GOT IT",
                "stock_tag": "MAKE YOUR OFFER",
                "stock_0_h": "You are bidding on a life value.",
                "stock_0_b": "This stock is a piece of what another trader IS. Your goal: name a price and convince them to let you hold a share of it.",
                "stock_choice_h": "First, choose how you pay.",
                "stock_choice_b": "Two buttons up top: ZOLLARS pays in relationships (Love, Grief, Friendship\u2026) \u2014 the heart of this market. CAPITAL pays in plain capital (\u01B5), if you must.",
                "stock_1_h": "Then set your price.",
                "stock_1_b": "With Zollars: tap \u201CSET YOUR ZOLLAR OFFER\u201D and drag each glowing bar \u2014 further right = more of that relationship offered. With Capital: just type the amount.",
                "stock_2_h": "Set how many shares.",
                "stock_2_b": "Type the number of shares you want in the SHARES box \u2014 up to what the owner has available.",
                "stock_3_h": "Place your bid.",
                "stock_3_b": "Hit Place Bid and say why you want it. The owner decides whether to let it go to you.",
                "stock_cta": "GOT IT",
                "bond_tag": "TAKE A PROMISE",
                "bond_1_h": "A Z Bond is a promise.",
                "bond_1_b": "Relational value now, repaid later with interest in lived experience.",
                "bond_2_h": "Pick the amount and term.",
                "bond_2_b": "Choose how much and for how long, then submit to take the promise on.",
                "bond_cta": "GOT IT",
                "trans_tag": "OFFER A SWAP",
                "trans_1_h": "This trader wants the item up top.",
                "trans_1_b": "You trade for it by giving one of your own things in return \u2014 a straight swap, no money.",
                "trans_2_h": "Pick what you will give.",
                "trans_2_b": "Scroll your own holdings below and choose one to offer.",
                "trans_3_h": "Propose the swap.",
                "trans_3_b": "Tap \u201CPropose\u201D on the thing you are offering. The owner decides whether to accept.",
                "trans_cta": "GOT IT",
                "redeem_tag": "CLAIM IT INTO REAL LIFE",
                "redeem_1_h": "Consumption here is social.",
                "redeem_1_b": "You cannot consume a thing alone \u2014 another trader's item has to validate it first.",
                "redeem_2_h": "Send a redeem ask.",
                "redeem_2_b": "Ask the floor to validate your thing. Once matched, it becomes real and yours to collect.",
                "redeem_cta": "GOT IT",
                "eco_tag": "HEAVY MACHINERY",
                "eco_1_h": "These are the heavy levers.",
                "eco_1_b": "Economic moves that act on OTHER traders \u2014 gifts and weapons. Each button says what it does in plain words; press and hold one to see the mechanics underneath.",
                "eco_2_h": "Give or take.",
                "eco_2_b": "BACK A FRIEND covers someone now. SOCIALIST SUBSIDY taxes a trader 45% and splits it among everyone. COMMUNIST ASSAULT seizes an entire portfolio and redistributes it. HOSTILE TAKEOVER buys a trader out. PREY ON DESPERATION profits from need \u2014 and the room remembers.",
                "eco_3_h": "Debts here are emotional.",
                "eco_3_b": "The meter above tracks what you owe and are owed in trust and help \u2014 not numbers. Life squares it later.",
                "eco_cta": "UNDERSTOOD",
                "tools_tag": "REACH OTHER TRADERS",
                "tools_1_h": "Ways to reach the room.",
                "tools_1_b": "Message another trader, steal what isn\u2019t yours, hold someone hostage until they pay, or open a private back-room market away from the floor\u2019s eyes.",
                "tools_2_h": "Every act has a social echo.",
                "tools_2_b": "These aren\u2019t menu options \u2014 they\u2019re gestures. The floor sees what you do and treats you accordingly. Press and hold any button to see its mechanics.",
                "tools_cta": "UNDERSTOOD",
                "botmsg_tag": "A BOT IS TALKING TO YOU",
                "botmsg_1_h": "That message is from a bot.",
                "botmsg_1_b": "The floor is populated by trader-bots \u2014 they hold values, make offers, and talk like anyone else in the room. This one just reached out to you.",
                "botmsg_2_h": "Answer it \u2014 or don't.",
                "botmsg_2_b": "You can reply, trade with it, or ignore it. Treat it as you would any trader: what you say and do shapes how the room treats you.",
                "botmsg_cta": "GOT IT",
                "mm_tag": "MEMENTO MORI",
                "mm_1_h": "Remember you must die.",
                "mm_1_b": "This run has a hard end: when the timer hits zero, your trading life is over. Everything you hold at that moment is read as your legacy.",
                "mm_2_h": "You already chose your legacy stocks.",
                "mm_2_b": "The companies you picked from your reflections carry your values. They're in your portfolio below \u2014 open the sections to see what you're starting with.",
                "mm_3_h": "Your eulogy writes itself.",
                "mm_3_b": "The red bar at the very top is your eulogy, rewritten as you trade. Tap it anytime to read what would be said of you if it ended right now.",
                "mm_4_h": "Trade toward how you want to be remembered.",
                "mm_4_b": "Go to the Market: grow what matters, let go of what doesn't. When time ends, the bourse speaks over your grave.",
                "mm_cta": "I UNDERSTAND",
                "mm_mkt_tag": "MEMENTO MORI \u2014 THE FLOOR",
                "mm_mkt_1_h": "Every offer is a legacy choice.",
                "mm_mkt_1_b": "Bid relational Zollars for the life values you want your name tied to. Time is running out \u2014 the eulogy bar up top listens to every trade.",
                "mm_mkt_2_h": "Let go, too.",
                "mm_mkt_2_b": "Accepting offers and releasing holdings is part of it: what you let go of says as much about you as what you keep.",
                "mm_mkt_cta": "GOT IT",
                "cn_tag": "CATENA NARRATIVA",
                "cn_1_h": "You are building a story.",
                "cn_1_b": "In Catena Narrativa, story pieces are traded like commodities. The pieces you hold \u2014 and how you rewrite them \u2014 become a short story at the end.",
                "cn_2_h": "Three phases, one clock.",
                "cn_2_b": "BEGINNING \u2192 MIDDLE \u2192 END, about 8 minutes total. The timer banner up top shows the current phase. When a phase ends, the pieces you hold are secured into your story ledger.",
                "cn_3_h": "Your story elements live below.",
                "cn_3_b": "The \u201CYour Story Elements\u201D panel lists the pieces you hold right now. Open your sections to see everything you carry.",
                "cn_4_h": "Trade to shape the story.",
                "cn_4_b": "Go to the Market and swap or bid for pieces your story needs. Every trade lets you rewrite the element in your own words \u2014 that is how the story becomes yours.",
                "cn_cta": "START TRADING",
                "cn_mkt_tag": "CATENA NARRATIVA \u2014 THE FLOOR",
                "cn_mkt_1_h": "Every item here is a story piece.",
                "cn_mkt_1_b": "Tap the \u201CBullets\u201D button to see the elements you already hold, then offer or swap for the pieces your story needs before the phase ends.",
                "cn_mkt_2_h": "Trading is rewriting.",
                "cn_mkt_2_b": "When an exchange goes through, you write how the element changes in your hands. Value forms through the exchange \u2014 that text feeds the final story.",
                "cn_mkt_cta": "GOT IT",
                "cn_swap_1_h": "You are swapping story pieces.",
                "cn_swap_1_b": "This trader holds an element your story could use. Scroll your own holdings below and pick one to give in return.",
                "cn_swap_2_h": "Then rewrite it.",
                "cn_swap_2_b": "When you propose, you will say how the element is customized \u2014 at least a sentence. Make it count: it goes straight into the story.",
                "cn_swap_cta": "GOT IT"
            },
            "floor": {
                "mission_label": "YOUR MISSION",
                "mission_class": "CLASS",
                "your_stocks": "YOUR STOCKS",
                "do_trader": "<b>\u2192 Go to the open floor</b> and trade for what your mission needs.",
                "do_market": "<b>\u2192 Tap something a trader holds</b> and make an offer.",
                "wedividual": "THE WEDIVIDUAL",
                "hero_sub": "the room's interior worth, live \u2014 in the seat where GDP would sit",
                "hero_sub_count": "measured from {n} relational trades in this room \u2014 not GDP",
                "hero_tip": "Not GDP. The Wedividual is this room measured from the inside: every trade of relational value (love, grief, friendship, hate...) moves it. When you trade, you move how the room feels.",
                "mood_euphoric": "EUPHORIC",
                "mood_warm": "WARM",
                "mood_steady": "STEADY",
                "mood_heavy": "HEAVY",
                "mood_dark": "DARK",
                "your_position": "YOUR POSITION \xb7 LIFE PROFIT",
                "declared_note": "you walked onto the floor carrying",
                "fold_holdings": "WHAT YOU HOLD",
                "fold_holdings_hint": "life values \xb7 things \xb7 zollars \xb7 promises",
                "fold_interior": "YOUR INTERIOR LEDGER",
                "fold_interior_hint": "emotional state & debt",
                "fold_moves": "INSTRUMENTS & WEAPONS",
                "fold_moves_hint": "gifts, loans, attacks \u2014 economics as a verb",
                "board_things": "THINGS ON THE FLOOR",
                "board_things_hint": "tap one to offer relational value for it",
                "board_values": "LIFE VALUES ON THE BOARD",
                "board_values_hint": "shares of lived experience \u2014 priced by feeling",
                "board_bonds": "PROMISES (Z BONDS)",
                "board_bonds_hint": "relational value now, repaid in experience later",
                "status_trader": "This is your portfolio \u2014 what you hold and what you owe. <b>Your move: go to the floor and trade.</b>",
                "status_market": "The floor \u2014 everything other traders are holding. <b>Tap anything to make an offer</b>; you pay with your Zollars.",
                "status_redeem": "You have a match. <b>Your move: hit REDEEM and claim it into your life.</b>",
                "status_memento": "<b>MEMENTO MORI</b> \u2014 every trade becomes a line of your eulogy. Hold what you want said about you.",
                "memento_chip": "MEMENTO MORI",
                "phase_1_chip": "PHASE 1/3 \xb7 BEGINNING",
                "phase_1_trader": "<b>BEGINNING</b> \u2014 the story needs raw material. Your move: go gather story elements from the floor.",
                "phase_1_market": "<b>BEGINNING</b> \u2014 the story needs raw material. Tap a story element below and offer for it.",
                "phase_1_go": "GO GET STORY ELEMENTS",
                "phase_1_cta": "OFFER FOR AN ELEMENT",
                "phase_2_chip": "PHASE 2/3 \xb7 MIDDLE",
                "phase_2_trader": "<b>MIDDLE</b> \u2014 complication time. Your move: trade and customize the elements you hold.",
                "phase_2_market": "<b>MIDDLE</b> \u2014 complication time. Trade for elements that twist your story.",
                "phase_2_go": "TRADE YOUR ELEMENTS",
                "phase_2_cta": "TRADE FOR A TWIST",
                "phase_3_chip": "PHASE 3/3 \xb7 END",
                "phase_3_status": "<b>END</b> \u2014 consolidation. Keep what matters; the story will be written from what you hold when the clock runs out.",
                "phase_3_go": "REVIEW WHAT YOU HOLD",
                "phase_3_cta": "FINAL TRADES",
                "cta_offer": "MAKE AN OFFER",
                "cta_offer_hint": "Tap anything on the board \u2014 you will offer <b>relational value</b> (your Zollars: love, friendship, grief...) to get it.",
                "tape_gdp": "GDP NOT QUOTED ON THIS FLOOR",
                "tape_love": "LOVE ACCEPTED AT ALL WINDOWS",
                "tape_grief": "GRIEF TRADES AT PAR WITH JOY",
                "tape_move": "EVERY TRADE MOVES THE ROOM",
                "tape_interior": "INTERIOR VALUE ONLY \xb7 BRING WHAT YOU FEEL",
                "tk_trade": "A TRADE SEALED \xb7 RELATIONAL VALUE CHANGED HANDS",
                "tk_bid_yes": "AN OFFER WAS EMBRACED",
                "tk_bid_no": "AN OFFER WAS TURNED DOWN",
                "tk_zollar": "FRESH ZOLLARS ENTERED THE ROOM",
                "tk_burst": "THE FLOOR IS RUNNING HOT",
                "tk_short": "SOMEONE IS BETTING AGAINST A LIFE VALUE",
                "tk_bourse": "THE BOURSE HAS SPOKEN ON A TRADE",
                "tk_pool": "A BACK ROOM OPENED SOMEWHERE",
                "tk_subsidy": "SOMEONE WAS LIFTED BY THE COLLECTIVE",
                "tk_theft": "THEFT ON THE FLOOR \xb7 WATCH YOUR HOLDINGS",
                "tk_memento": "MEMENTO MORI \xb7 THE CLOCK MOVES",
                "tk_declared": "{v} IS ON THE FLOOR \xb7 DECLARED, NOT PRICED",
                "ps_tap": "hold to see mechanics",
                "ps_altrau": "BACK A FRIEND",
                "ps_altrau_tip": "You cover another trader now. The debt it creates is emotional, not numeric \u2014 it sits on your interior ledger until life squares it.",
                "ps_mnote": "BORROW AGAINST YOURSELF",
                "ps_mnote_tip": "Take capital now and owe your future self. The market remembers what you promised to become.",
                "ps_cdo": "PREY ON DESPERATION",
                "ps_cdo_tip": "Lend to someone who cannot say no, then sell their struggle on. Profitable. It will cost you interior credit with the room.",
                "ps_vnote": "ASK THE ROOM FOR AID",
                "ps_vnote_tip": "Request help from the floor. No shame here \u2014 need is a tradable truth like any other.",
                "ps_steal": "TAKE WHAT ISN'T YOURS",
                "ps_steal_tip": "Theft, plainly. You gain the thing; the room learns what you are.",
                "ps_ransom": "HOLD SOMEONE HOSTAGE",
                "ps_ransom_tip": "Lock another trader out of their own life until they pay you to give it back.",
                "ps_darkpool": "OPEN A BACK ROOM",
                "ps_darkpool_tip": "Opens a private trading room away from the floor's eyes. Deals struck there stay hidden and don't move the shared mood \u2014 that is the point, and the problem.",
                "ps_lbo": "HOSTILE TAKEOVER",
                "ps_lbo_tip": "Pick a trader and buy them out: you pay the takeover cost in capital (they receive it), and the items and stocks you selected become YOURS. A buyout, not a gift.",
                "ps_subsidy": "SOCIALIST SUBSIDY",
                "ps_subsidy_tip": "Pick a trader to tax: 45% of their capital, items and Zollars is taken and split equally among every other trader on the floor. Redistribution from the top down.",
                "ps_assault": "COMMUNIST ASSAULT",
                "ps_assault_tip": "Pick a trader: their ENTIRE portfolio \u2014 capital, items, stocks, Zollars \u2014 is seized and distributed among everyone else on the floor. They are wiped to zero. Total redistribution, used as a weapon.",
                "ps_holdings": "WHAT YOU CARRY",
                "ps_holdings_tip": "Your position: the stocks, commodities, Zollars and promises currently in your hands.",
                "ps_zollar_tip": "Money denominated in relationships instead of numbers: Love, Friendship, Hate, Grief... You pay with what a relationship is worth to you.",
                "ps_bond_tip": "A promise with feelings attached: relational value now, repaid with interest in lived experience later.",
                "ps_short_tip": "A bet against a life value \u2014 you profit if it falls. Yes, you can short joy. Ask yourself why.",
                "ps_stock_tip": "Shares in life values \u2014 slices of intellect, affection, partying, melancholy. Their price is what the room feels they are worth.",
                "ps_commodity_tip": "Real things with a catch: you cannot consume one until another trader validates it. Consumption here is social or not at all.",
                "ps_value": "Value",
                "ps_value_tip": "What the holder asks for it \u2014 payable in relational worth, not cash.",
                "ps_redeem": "Redeem",
                "ps_redeem_tip": "Claim a thing into your real life. Needs another trader's item to validate it first \u2014 consumption here is social.",
                "ps_owner": "Owner",
                "ps_owner_tip": "The trader whose life this currently belongs to. Your offer goes to them.",
                "ob_title": "BEFORE YOU TRADE",
                "ob_sub": "This floor does not price your output. It prices your interior. Pick up to three things you actually value \u2014 they become what you carry, and what you can spend.",
                "ob_custom": "or name one of your own + Enter",
                "ob_custom_h": "yours alone",
                "ob_go": "CARRY THESE ONTO THE FLOOR",
                "ob_skip": "skip \u2014 I know this floor",
                "ob_done": "Declared. These are on your position now. <b>Your move: take them to the open floor.</b>",
                "ob_love": "LOVE",
                "ob_love_h": "what you would give anything to keep",
                "ob_friendship": "FRIENDSHIP",
                "ob_friendship_h": "the people who hold you up",
                "ob_fellowship": "FELLOWSHIP",
                "ob_fellowship_h": "belonging to something bigger",
                "ob_erotic": "EROTIC",
                "ob_erotic_h": "desire, fully owned",
                "ob_hate": "HATE",
                "ob_hate_h": "it counts \u2014 it is yours too",
                "ob_toxic": "TOXIC",
                "ob_toxic_h": "the bonds that cost you",
                "ob_superficial": "SUPERFICIALITY",
                "ob_superficial_h": "the shallow joys, no apology",
                "ob_dead": "WHAT'S GONE",
                "ob_dead_h": "dead relationships still trade here",
                "sec_stocks": "LIFE VALUES",
                "sec_commodities": "THINGS",
                "sec_zollars": "ZOLLARS",
                "sec_zbonds": "PROMISES",
                "sec_redeemed": "REDEEMED",
                "sec_shorts": "BETS AGAINST",
                "sec_emotional": "INTERIOR LEDGER",
                "sec_social": "GIVE / LEND / PREY",
                "sec_tools": "TOOLS",
                "sec_economic": "WEAPONS",
                "flow_title": "HOW TRADING WORKS HERE",
                "flow_1_n": "1",
                "flow_1_h": "FIND IT",
                "flow_1_b": "Scroll what other traders hold. Tap something you want.",
                "flow_2_n": "2",
                "flow_2_h": "OFFER WHAT IT'S WORTH TO YOU",
                "flow_2_b": "Pay in relational value \u2014 your Zollars (love, grief, friendship...), a swap, or a bid.",
                "flow_3_n": "3",
                "flow_3_b": "THEY SAY YES \u2192 IT'S YOURS",
                "flow_3_h": "The owner accepts and it moves into your life. No cash anywhere.",
                "btn_swap": "SWAP",
                "btn_swap_tip": "Offer one of your own things in exchange for theirs. A straight trade of holdings.",
                "btn_offer_zollars": "OFFER ZOLLARS",
                "btn_offer_zollars_tip": "Pay for this with your relational currency \u2014 Love, Grief, Friendship Zollars. You name what it's worth to you.",
                "btn_offer_share": "BUY",
                "btn_offer_share_tip": "Make a bid for a share of this life value. If the owner accepts, the share is yours.",
                "btn_bet_against": "BET AGAINST",
                "btn_bet_against_tip": "Short it \u2014 you profit if this life value falls. You are wagering against someone's worth. Sit with that.",
                "btn_take_promise": "TAKE PROMISE",
                "btn_take_promise_tip": "Buy this Z Bond: relational value now, repaid with interest in lived experience later.",
                "btn_offer_promise": "OFFER",
                "btn_offer_promise_tip": "Bid on this promise. The owner decides whether to let it go to you.",
                "hero_eyebrow": "HOW THE ROOM FEELS RIGHT NOW",
                "gauge_low": "HEAVY",
                "gauge_high": "EUPHORIC",
                "hero_sub2": "the shared mood of everyone trading \u2014 the floor's index, instead of GDP",
                "hero_sub_count2": "read from {n} trades on the floor \u2014 our index, instead of GDP",
                "delta_up": "warmer than a moment ago",
                "delta_down": "heavier than a moment ago",
                "nav_portfolio": "MY PORTFOLIO",
                "nav_search": "SEARCH",
                "your_portfolio": "YOUR PORTFOLIO",
                "portfolio_explain": "everything you hold on the floor. its total worth, counted as Life Profit \u2014 your lived experience, not money:",
                "count_held": "{n} held",
                "count_empty": "empty",
                "exp_stocks": "Shares you hold in human values (like intellect or affection). Their worth rises and falls with how the room feels.",
                "exp_commodities": "Real things you hold. You can't consume one until another trader validates it \u2014 consumption here is social.",
                "exp_zollars": "Your spending money \u2014 but counted in relationships (Love, Grief, Friendship). This is what you pay with when you trade.",
                "exp_zbonds": "Promises you hold: relational value now, repaid later with interest in lived experience.",
                "exp_redeemed": "Things you've claimed into real life, kept as QR codes to collect.",
                "exp_shorts": "Life values you've bet against \u2014 you gain if their worth falls.",
                "exp_emotional": "Your emotional balance sheet \u2014 what you owe and are owed in trust, help, and betrayal.",
                "exp_social": "Ways to act on other people: back a friend, lend, ask for aid, or prey on someone. Economics as gestures.",
                "exp_tools": "Reach other traders: message them, steal, ransom, or open a private back-room market.",
                "exp_economic": "Heavy moves: hostile takeover, collective subsidy, or delete your portfolio entirely.",
                "exp_stock_bid": "Another trader on the floor \u2014 often one of the market's bots \u2014 wants to buy shares you hold. Accept and their payment is yours; decline and nothing changes.",
                "exp_trade_offer": "A trader is proposing a straight swap: their thing for yours. The floor's bots trade too \u2014 respond exactly as you would to a person.",
                "exp_buy_offer": "Someone wants something you carry and is paying for it. Accept and the payment moves to you, the thing to them; decline and you keep it.",
                "exp_tax": "This is the Zederal Reserve \u2014 the market's system player. It taxes every trader from time to time. Choose what to give up before the timer runs out, or it takes both.",
                "exp_short": "Shorting is betting that this life value will FALL. If it drops, you profit from the decline. You are wagering against someone's worth \u2014 the room will know.",
                "exp_analysis": "This is the voice of the bourse \u2014 the market itself reacting to a trade that just happened on the floor. It's commentary, not a request: read it, close it, nothing is asked of you."
            },
            "auth": {
                "trader_id_placeholder": "Trader ID",
                "password_placeholder": "Password",
                "login_button": "Login",
                "login_validation_message": "Please enter both Trader ID and Password",
                "login_failed_message": "Login failed. Please check your credentials and try again.",
                "login_error_message": "An error occurred during login. Please try again later.",
                "authentication_failed_message": "Authentication failed. Please log in again.",
                "password_required_message": "Password is required.",
                "enter_trader_name_placeholder": "Enter your Trader Name",
                "enter_new_password_placeholder": "Enter your new password",
                "secure_password_placeholder": "Enter secure password",
                "set_password_label": "Set Password",
                "authentication_failed": "Authentication failed. Please log in again.",
                "session_required": "Session ID is missing. Please log in again."
            },
            "navigation": {
                "nav_commodity": "Commodity",
                "nav_zollars": "Zollars",
                "nav_stock_zbond": "Stock & ZBond",
                "nav_company": "Company",
                "nav_portfolios": "Portfolios",
                "nav_control_panel": "Control Panel"
            },
            "buttons": {
                "scan_button": "Scan",
                "fulfill_button": "Fulfill",
                "create_session_button": "Create Session",
                "search_button": "Search",
                "close_search_button": "Close Search",
                "cancel_button": "Cancel",
                "close_button": "Close",
                "complete_setup_button": "Complete Setup",
                "save_button": "Save",
                "delete_button": "Delete",
                "modify_name_button": "Modify Name",
                "modify_password_button": "Modify Password",
                "logout_trader_button": "Log Out Trader",
                "view_qr_codes_button": "View Login QR Codes",
                "enter_mortality_chamber_button": "Enter Mortality Chamber",
                "continue_button": "Continue",
                "validate_key": "Validate Key",
                "scan_qr_code": "Scan QR Code"
            },
            "stock_bid": {
                "title": "Stock Bid Offer",
                "offers_to_buy_points": "{portfolioName} offers to buy {shares} shares of {stockName} for {amount} of Capital.",
                "offers_to_buy_zollars": "{portfolioName} offers to buy {shares} shares of {stockName} for the following zollars:",
                "time_remaining": "Time remaining: {seconds} seconds",
                "time_expired": "Time expired",
                "processing_bid": "Processing your bid...",
                "no_response": "No response received. This action has expired.",
                "offer_expired": "No response received. Your offer expired."
            },
            "forms": {
                "mood_one_word": "What quality or feeling are you living right now?",
                "one_word_hint": "(1 word)",
                "reason_label": "Why do you feel that?",
                "value_definition": "Why do you feel this way? (Value)",
                "value_definition_placeholder": "e.g., I got a promotion, I am hung over, My kid scored 3 goals...",
                "value_reaction": "What does this feeling give you? (Life Profits)",
                "value_reaction_placeholder": "e.g., gives me energy, makes me depressed, helps me grow...",
                "experiences_label": "What creates this feeling?",
                "search_stocks_placeholder": "Search Stocks",
                "company_name_fixed_label": "Company Name (fixed):",
                "company_description_label": "Company Description:",
                "company_product_label": "Company Product/Output:",
                "trader_name_label": "Trader Name:",
                "session_name_label": "Session Name",
                "session_name_placeholder": "Enter session name (letters, numbers, underscores only)",
                "single_word_example": "e.g., happy, sad, drunk, joy...",
                "reason_placeholder": "e.g., I got a promotion, I am hung over, My kid scored 3 goals...",
                "describe_feeling_placeholder": "e.g., gives me energy, makes me depressed, helps me grow..."
            },
            "modals": {
                "select_action_title": "Select an Action",
                "action_modal_description": "Select Scan to be directed to the scan items page. Select Fulfill to fulfill orders.",
                "choose_simulation_title": "Choose Your Simulation Experience",
                "memento_mori_title": "Memento Mori Simulation",
                "memento_mori_description": "Remember you must die. This simulation explores meaningful choices in limited time.",
                "create_new_session_title": "Create New Session",
                "session_creation_description": "Create a new trading session as the Zederal Reserve Central Bank.",
                "assign_to_portfolio_title": "Assign to Portfolio:",
                "select_portfolio_short_title": "Select a Portfolio to Place Short Position",
                "select_portfolio_transfer_title": "Select a Portfolio to Transfer Ownership"
            },
            "tables": {
                "table_stock_name": "Stock Name",
                "table_symbol": "Symbol",
                "table_share_value": "Share Value",
                "table_owner": "Owner",
                "table_shorted": "Shorted",
                "table_place_short": "Place Short",
                "table_delete": "Delete"
            },
            "socketBack": {
                "narrativeProcessed": "Narrative response processed",
                "unauthorizedSuperUser": "Unauthorized: Only Zederal Reserve bankers can perform this action",
                "noTargetUser": "No target trader provided",
                "logoutByAdmin": "You have been logged out by an administrator.",
                "logoutUserSuccess": "User {id} has been forced to logout successfully.",
                "logoutUserOffline": "User {id} is already offline.",
                "marketClosed": "The market has closed.",
                "logoutAllSuccess": "All traders have been logged out successfully",
                "taxEvent": "You are being charged a market tax. Choose to give a random commodity or lose capital.",
                "zollarIssued": "A Zollar has been issued to you by the Zederal Reserve.",
                "zollarFailed": "Failed to assign Zollars",
                "ransomAssigned": "You have received the ransom trigger.",
                "ransomLocked": "Your portfolio has been locked with a ransom of {points} capital.",
                "lboAssigned": "You have received the Leveraged Buyout (LBO) trigger.",
                "lboAssetsRemoved": "Assets have been removed from your portfolio due to an LBO.",
                "removedStocksLabel": "Removed Stocks:",
                "removedItemsLabel": "Removed Items:",
                "unknownStock": "Unknown Stock",
                "unknownItem": "Unknown Item",
                "sharesWord": "shares",
                "ofWord": "of",
                "subsidyAssigned": "You have received a Subsidy trigger.",
                "subsidyUpdate": "45% of your wealth has been redistributed as a Socialist Subsidy for the lower income earners.",
                "subsidyReceived": "You have received a socialist subsidy.",
                "pointsGiven": "Capital has been issued.",
                "itemsDistributed": "Commodities have been distributed.",
                "freebieZ1Message": "The Zederal Reserve has distributed a free commodity to your portfolio!",
                "ransomPaidNotification": "{userName} has paid the ransom of {points} capital. The funds have been transferred to your account.",
                "pointsDeducted": "{amount} capital have been deducted from your account.",
                "itemTaxed": "Zederal Reserve has taxed a commodity from your holdings.",
                "deleteButtonAssigned": "You have received a Communist Assault trigger.",
                "deletePerformed": "Your portfolio has been targeted by a Communist Assault.",
                "subsidyUpdateBotTarget": "{botName} has initiated a Socialist Subsidy - 45% of your wealth has been redistributed.",
                "specialSubsidyTarget": "{botName} redistributed 45% of your wealth through Socialist Subsidy",
                "subsidyReceivedFrom": "You received a Socialist Subsidy from {botName}'s redistribution action!",
                "specialSubsidyReceived": "You received wealth from {botName}'s Socialist Subsidy",
                "ransomLockedBy": "{botName} has frozen your portfolio with a ransom of {points} capital!",
                "specialRansomTarget": "{botName} has frozen your portfolio with a ransom demand",
                "specialRansomImpact": "Portfolio locked - {points} capital required",
                "lboExecutedOnYouBy": "{botName} has executed a Leveraged Buyout on your portfolio.",
                "specialLboTarget": "Your portfolio was targeted in a Leveraged Buyout (LBO) from {botName}",
                "itemStolen": "{botName} has stolen \"{itemName}\" from your portfolio!",
                "specialStealTarget": "{botName} stole \"{itemName}\" from you",
                "deleteUpdateBy": "{botName} has executed a Communist Assault on your portfolio!",
                "specialDeleteTarget": "{botName} executed a Communist Assault on your portfolio",
                "assaultGameEvent": "{botName} executed a Communist Assault on {targetName}!",
                "unknownPlayer": "Unknown Player",
                "tradeAccepted": "Trade accepted! Capital awarded.",
                "tradeDeclined": "Trade declined. No capital awarded."
            },
            "titles": {
                "owned_stock_list_title": "Owned Stock List",
                "short_positions_title": "Short Positions",
                "stock_management_guide_title": "Stock Management Guide"
            },
            "validation": {
                "select_company_first_message": "Please select a company first before claiming.",
                "fill_trader_name_password_message": "Please fill in your Trader Name and new Password.",
                "company_details_required_message": "Company details are required. Please complete the company selection process.",
                "portfolio_count_validation": "Number of portfolios must be between 1 and 50.",
                "items_per_portfolio_validation": "Number of items per portfolio must be between 0 and 10.",
                "simulation_questions_required": "Please answer all questions. Enter a single word for your mood and explain both why you feel that way and what creates this feeling."
            },
            "messages": {
                "success": "Success",
                "error": "Error",
                "loading": "Loading...",
                "qr_error_message": "Error displaying QR codes. Please try again.",
                "portfolios_created_success": "Portfolio(s) created successfully",
                "portfolio_add_error": "Error adding portfolio. Please try again.",
                "portfolio_updated_success": "Portfolio updated successfully",
                "fetch_portfolios_error": "Error fetching portfolios. Please try again later."
            },
            "backend_messages": {
                "invalid_decision_message": "Invalid decision.",
                "assignment_in_progress": "Assignment is already in progress.",
                "session_id_required": "Session ID is required.",
                "not_enough_items_assign": "Not enough available items to assign",
                "items_assigned_success": "New items assigned to all portfolios successfully.",
                "items_assign_failed": "Failed to assign new items",
                "items_assigned_successfully": "Items successfully assigned.",
                "no_available_items": "No available items for assignment.",
                "failed_assign_items": "Failed to assign items.",
                "points_distributed_success": "Captial distributed successfully.",
                "points_distribute_failed": "Failed to distribute capital.",
                "items_removed_success": "Items successfully removed.",
                "no_items_for_removal": "No non-redeemed items available for removal.",
                "failed_remove_items": "Failed to remove items.",
                "tax_points_item_deducted": "Capital & Random item deducted by Z Tax Authorities.",
                "tax_points_deducted": "trading capital deducted by Z Tax Authorities.",
                "tax_points_zollars_item_deducted": "& Random Commodity deducted by Zederal Reserve Tax Authorities.",
                "tax_points_zollars_deducted": "deducted by Zederal Reserve Tax Authorities.",
                "tax_item_removed": "Random item removed by Z Tax Authorities.",
                "error_fetching_portfolios": "Error fetching portfolios",
                "portfolio_updated_success": "Portfolio updated successfully",
                "portfolio_not_found": "Portfolio not found",
                "error_updating_portfolio": "Error updating portfolio",
                "internal_server_error": "Internal server error",
                "item_already_assigned": "Item is already assigned to this portfolio",
                "item_assigned_success": "Item assigned to portfolio successfully",
                "item_unassigned_success": "Item unassigned from portfolio successfully",
                "create_community_button_assigned": "Create community button assigned successfully",
                "portfolio_deleted_success": "Portfolio deleted successfully, items and stocks unassigned.",
                "no_zollars_found": "No Zollars found for this portfolio",
                "failed_fetch_bonds": "Failed to fetch bonds",
                "message_exceeds_280": "Message exceeds 280 characters.",
                "sender_portfolio_not_found": "Sender portfolio not found.",
                "recipient_portfolio_not_found": "Recipient portfolio not found.",
                "not_enough_points_message": "Not enough capital to send a message.",
                "message_sent_successfully": "Message sent successfully",
                "session_mismatch_sender": "Action not allowed. Session mismatch for sender.",
                "session_mismatch_recipient": "Action not allowed. Session mismatch for recipient.",
                "requesting_portfolio_not_found": "Requesting portfolio not found",
                "user_not_part_of_session": "User is not part of any session",
                "item_not_found": "Item not found",
                "no_unassigned_items": "No unassigned items found",
                "portfolio_not_found_in_session": "Portfolio not found in this session",
                "item_not_found_in_session": "Item not found in this session",
                "failed_assign_item_portfolio": "Failed to assign item to portfolio"
            },
            "ui_labels": {
                "show_explanations_label": "Show Explanations",
                "currency": "Currency",
                "balance": "Balance",
                "price": "Price",
                "quantity": "Quantity",
                "total": "Total",
                "date": "Date",
                "time": "Time",
                "status": "Status",
                "active": "Active",
                "inactive": "Inactive",
                "pending": "Pending",
                "completed": "Completed",
                "failed": "Failed"
            },
            "marketing": {
                "tailor_stock_choice_message": "Tailor your stock choice to align exactly with your values.",
                "footer_copyright": "All rights reserved ZExchange 2025. ZExchange is part of <a href=\"https://zeconomy.xyz\"> ZEconomy. </a>",
                "programs": {
                    "nav_home": "\u2190 Return to ZExchange",
                    "nav_contact": "Get in Touch",
                    "page_title": "ZExchange Studio Program",
                    "tagline": "Life profits.",
                    "intro": "A three-part program where participants enter an artist-designed economy, learning key conceptual points, build systems of value (Real or Artistic), and trade live on the ZExchange platform.",
                    "part_one_title": "Part One: Theoretical Framework",
                    "part_one_text": "Where does value reside; in the artwork? in the object, the institution, or the experience? From Belting's cult image to Polanyi's fictitious commodities, from Fried's theatricality to algorithmic price validation. A rigorous introduction to displacement as both an art-historical trajectory and economic intervention.",
                    "part_two_title": "Part Two: Creative Atelier",
                    "part_two_text": "Participants design their own value systems following the ideas from the ZEconomy developed during the theoretical explanations. Economic architecture as artistic medium.",
                    "part_three_title": "Part Three: Live Trading Floor",
                    "part_three_text": "The ZEconomy comes to life. 10\u2013200 participants trade in real time on the ZExchange platform. An AI observes, analyzes, and narrates \u2014 producing a visual Big Board and a written portrait of collective behavior. The market reflects on itself.",
                    "institutional_title": "Institutional Goals",
                    "art_programs_title": "For art programs:",
                    "art_programs_text": "Positions economics as material; extending Conceptual Art and Institutional Critique while constructing alternatives rather than exposing what exists.",
                    "business_programs_title": "For business programs:",
                    "business_programs_text": "Renders valuation theory experiential. Students use creative applications of their ideas to help them better build their own projects.",
                    "zeconomy_title": "ZEconomy",
                    "zeconomy_text_1": "The ZExchange emerges from the ZEconomy, JaZoN Frings's long-term artistic practice developed over nearly twenty years through a personal stock market, relational currencies, and non-consumption-based advertising systems. These works investigate the individual's position within societal systems by intervening in their structures\u2014shifting goals of production, reconfiguring operations, and introducing unintended forms of expression that expose their underlying logic.",
                    "zeconomy_text_2": "Represented by Galerie mfc\u2013mich\xe8le didier and agent d'art Ghislain Mollet-Vi\xe9ville, the practice has been exhibited at institutions including Transmediale Berlin, SPRING/BREAK ART SHOW NYC,  Wrong Biennial,  Stanford University, and Science Gallery Dublin. With numerous teaching and mediation interventions at \xc9cole Camondo, Parsons Paris, and Centre Pompidou, and has been featured in Art Press, \u22C6\u22C6\u22C6 T\xe9l\xe9rama, Bloomberg, and Tapscott's Blockchain Revolution.",
                    "contact_title": "Contact for Details",
                    "contact_text": "For program details, scheduling, and institutional inquiries:"
                },
                "sessions": {
                    "nav_home": "\u2190 Return to ZExchange",
                    "nav_contact": "Get in Touch",
                    "page_title": "ZExchange",
                    "tagline": "Life profits.",
                    "intro": "An artwork you enter, not observe. A trading floor. A party. A new way of looking at value.",
                    "what_happens_title": "What Happens",
                    "what_happens_p1": "Participants enter an economy with two layers: stocks and commodities.",
                    "what_happens_p2": "Stocks represent intangible values \u2014 emotional states, ambitions, ways of being. You trade them, speculate on them, watch their prices rise and fall based on collective interest.",
                    "what_happens_p3": "Commodities are real \u2014 drinks, food, items, gifts. Everything is tradable, but you can't consume them alone. To redeem (obtain) a commodity, another participant must accept to redeem their own commodities with you. The market grants or refuses permission.",
                    "what_happens_p4": "An AI watches everything unfold, narrating patterns of value, desire, and exchange as they emerge.",
                    "what_produces_title": "What It Produces",
                    "what_produces_text": "A shared experience that reframes consumption as a social act. An AI-written portrait of the group. A Big Board visualization available for purchase. And a question that lingers: What is the true value of being alive?",
                    "format_title": "Format",
                    "format_text": "2\u20133 hours. 10\u2013200 participants. Standalone event, team building, mixer, offsite, or cultural program.",
                    "zeconomy_title": "ZEconomy",
                    "zeconomy_text_1": "The ZExchange emerges from the ZEconomy, JaZoN Frings's long-term artistic practice developed over nearly twenty years through a personal stock market, relational currencies, and non-consumption-based advertising systems. These works investigate the individual's position within societal systems by intervening in their structures\u2014shifting goals of production, reconfiguring operations, and introducing unintended forms of expression that expose their underlying logic.",
                    "zeconomy_text_2": "Represented by Galerie mfc\u2013mich\xe8le didier and agent d'art Ghislain Mollet-Vi\xe9ville, the practice has been exhibited at institutions including Transmediale Berlin, SPRING/BREAK ART SHOW NYC,  Wrong Biennial,  Stanford University, and Science Gallery Dublin. With numerous teaching and mediation interventions at \xc9cole Camondo, Parsons Paris, and Centre Pompidou, and has been featured in Art Press, \u22C6\u22C6\u22C6 T\xe9l\xe9rama, Bloomberg, and Tapscott's Blockchain Revolution.",
                    "contact_title": "Contact for Details",
                    "contact_text": "For program details, scheduling, and institutional inquiries:"
                }
            },
            "classes": {
                "page_title": "ZEconomy Pedagogical Sessions",
                "presenter_title": "ZEconomy Class Presenter",
                "back_link": "\u2190 Back to ZExchange",
                "title": "ZEconomy Pedagogical Sessions",
                "tagline": "Exploring how art history, spirituality, and representation intersect with market theory, value systems, and ZEconomy's reimagining of finance.",
                "lesson_selector": "\u2190 Lesson Selector",
                "previous": "\u2190 Previous",
                "next": "Next \u2192",
                "toggle_images": "Toggle Images",
                "no_classes": "No classes available yet.",
                "load_error": "Unable to load classes. Please try again later.",
                "level": "Level",
                "duration": "Duration",
                "minutes": "min",
                "mixed_level": "mixed",
                "presenter_suffix": "Presenter",
                "learning_objectives": "Learning Objectives",
                "view_details": "View Details",
                "discussion_points": "Discussion Points",
                "activity_instructions": "Activity Instructions",
                "estimated_reading_time": "Estimated reading time",
                "min": "min",
                "download_pdf": "Download PDF",
                "no_lesson_specified": "No lesson specified.",
                "lesson_not_found": "Lesson not found.",
                "load_lesson_error": "Error loading lesson. Please try again later."
            },
            "placeholders": {
                "life_profits_placeholder_1": "I value playing with my kids...",
                "life_profits_placeholder_2": "Depression seems to be sought after...",
                "life_profits_placeholder_3": "I love love and everything about it...",
                "life_profits_placeholder_4": "A drink with friends is worth everything...",
                "life_profits_placeholder_5": "I think rejection creates value...",
                "life_profits_placeholder_6": "I see joy as life's true currency...",
                "life_profits_placeholder_7": "Helping others enriches my life...",
                "life_profits_placeholder_8": "Loneliness has become a very common experience...",
                "experience_placeholder_1": "Dancing to techno makes me forget my worries...",
                "experience_placeholder_2": "Spending time with friends makes time fly...",
                "experience_placeholder_3": "I miss my mother, it reminds me what matters...",
                "experience_placeholder_4": "Running regularly clears my head...",
                "experience_placeholder_5": "Arguing online is always a waste of time...",
                "experience_placeholder_6": "Watching old cartoons makes me a kid again...",
                "experience_placeholder_7": "Getting up early gives good energy to my day...",
                "experience_placeholder_8": "Taking a detour helps me think...",
                "experience_placeholder_9": "The quality of morning coffee sets the tone for my day...",
                "experience_placeholder_10": "Wearing my sunglasses at night makes me look cool..."
            },
            "ticker_texts": {
                "intro_z_exchange": "?? \u25BA INTRODUCTION Z EXCHANGE ?? \u25BA",
                "life_profits_value": "LIFE PROFITS \u25BA Z EXCHANGE VALUE \u25BA",
                "stocks_function": "\u25BA WHAT DO STOCKS DO ON Z EXCHANGE",
                "z_bonds_system": "Z BONDS \u25BA Zollars \u25BA Z RELATIONSHIP MONETARY SYSTEM \u25BA NUMBERS NEED NOT APPLY \u25BA",
                "commodity_x": "\u25BA COMMODITY X \u25BA Z EXCHANGE SOCIAL CONSUMING.",
                "interface_preview": "Z EXCHANGE INTERFACE PREVIEW \u25BA",
                "generative_boards": "\u25BA GENERATIVE Z EXCHANGE BIG BOARDS \u25BA REAL TIME MARKET EXPRESSION"
            },
            "simulation": {
                "memento_mori_description": "Remember you must die. This simulation explores meaningful choices in limited time.",
                "mortality_chamber_setup": "You will be transported to the simulation environment, where you'll face a countdown to your symbolic death and make trading decisions that reflect your deepest values.",
                "simulation_instructions": "You'll start with a short reflection on your life values, then receive recommended stocks. The countdown will only begin after your reflection.",
                "life_profit_title": "Exploring What You Value",
                "building_experience": "Building your Memento Mori Experience",
                "preparing_chamber": "Preparing your symbolic mortality chamber...",
                "welcome_setup": "Welcome! Let's set up your trading portfolio.",
                "life_profits_explanation": "Let's find a ZEconomy company stock you believe in to generate 'Life Profits'.",
                "no_matching_companies": "Our system found no companies matching your emotional profile.",
                "creating_simulation": "Creating your Simulation...",
                "please_wait": "Please wait while we generate your virtual portfolio.",
                "trade_title": "Trade on ZExchange.",
                "one_off_session": "One-Off Session",
                "freestyle_title": "Freestyle is a ZExchange Regular Session Simulator.",
                "freestyle_goal_label": "Goal",
                "freestyle_goal_text": "learn ZExchange interface & concepts; and above all explore how value becomes your story.",
                "details_heading": "Details:",
                "freestyle_detail_1": "takes our idea of profits by applying value to what matters to you in your life.",
                "life_profit_label": "Life Profit",
                "life_profit_description": "value of consciously lived life: joy, loss, contradiction, sex, love, depression, boredom, partying... (quality / quantity / positive & negative).",
                "voice_of_bourse_label": "\"voice of the bourse\"",
                "voice_of_bourse_description": 'At ZExchange the market itself has a voice, analyzing what it thinks of each stock transaction \u2192 creating generative "big boards" + creates collaborative narratives.',
                "zrms_label": "Z Relationship Monetary System",
                "zrms_description": "Zollars apply your associative value of relationships to pay for assets using Love, Hate, Friendship, Death, Fellowship...",
                "commodity_x_label": "Commodity X",
                "commodity_x_description": "Trade commodities with a catch, you need social validation before any consumption (redeem with other trader's item \u2192 consume) can happen.",
                "economic_tools_label": "Economic tools",
                "economic_tools_description": "wield LBOs (Leveraged Buyouts), communist assaults, socialist subventions, dark pools, ransom, theft..., use economics as weapons or gifts towards other traders.",
                "memento_title": "Memento Mori \u2013 Trading life value to make your Eulogy",
                "memento_why_label": "Why?",
                "memento_why_text": "reflect on how you value living, experiences, and emotions to determine what you would value most when your life ends.",
                "memento_confront_label": "Confront mortality",
                "memento_confront_description": "Create a portfolio of life values through trading stocks, who's cumulative life value will generate your eulogy.",
                "memento_relational_label": "Relational capital",
                "memento_relational_description": "Zollars here represent associating positive & negative relationships to the stocks over numerical yield.",
                "memento_bourse_eye_label": "\"Under thy bourse eye\"",
                "memento_bourse_eye_description": "The bourse will cast judgement upon thy in your eulogy by watching all your transactions until the end."
            },
            "story": {
                "catena_title": "Catena Narrativa",
                "catena_subtitle": "Story building as supply chains: trade, customize, and consolidate through three phases to complete the story creation process.",
                "continue_to_selection": "Continue to Story Selection",
                "process_heading": "Process:",
                "materials_motion_title": "Materials in motion:",
                "materials_motion_desc": "Trade narrative elements as commodities. Customizing them as you trade. Value forms through the exchanging process to construct a story.",
                "three_passes_title": "Three passes:",
                "three_passes_desc": "Origin (beginning) \u2192 Transit (middle) \u2192 Assembly (end) ( 3min + 3min + 2min \u22488 minutes total). Each phase ends after the time expires, or you redeem, resulting in your bullet point commodities being secured into a personal story ledger.",
                "composition_title": "Composition:",
                "composition_desc": "At the end, your ledger is transformed into a short story generated from your customized trading of assets and redeemed secured bullet points.",
                "commodity_x_label": "Commodity X",
                "commodity_x_desc": "is part of ZEconomy where profits are measured in <strong>Life Profit</strong>\u2014 the quality and quantity of intellect, affection, partying... etc, all of life's divers happenings, promoting being\u2014over accumulation.",
                "footer_note_consumption": "Commodity X where Consumption is relational: you cannot consume without mutual assent. The commodity is not the object; the commodity is the interaction.",
                "footer_note_redeem": "Redeem relationally. Consume consciously.",
                "simulation_title": "Story Simulation",
                "simulation_intro": "Engage in a narrative exchange with automated participants across three distinct phases, crafting a unique short story through dynamic collaboration.",
                "choose_genre": "Choose Your Genre",
                "genre_scifi": "Science Fiction",
                "genre_scifi_desc": "Futuristic visions and speculative worlds",
                "genre_romance": "Romance",
                "genre_romance_desc": "Emotion, intimacy, and human connection",
                "genre_mystery": "Mystery",
                "genre_mystery_desc": "Secrets, investigation, and concealed motives",
                "genre_fantasy": "Fantasy",
                "genre_fantasy_desc": "Myth, imagination, and transcendence",
                "genre_horror": "Horror",
                "genre_horror_desc": "Fear, suspense, and the confrontation of the unknown",
                "duration": "Duration: 8 minutes (3 + 3 + 2 minute phases)",
                "loading_elements": "Loading Story Elements...",
                "choose_starting_element": "Choose Your Starting Element",
                "select_one_element": "Select one story element to begin with. You'll also receive 2 random elements.",
                "skip_selection": "Skip Selection (Get 3 Random Elements)",
                "preparing_story": " Preparing Your Story...",
                "setting_up_simulation": "Setting up {theme} simulation...",
                "story_begins": " Story Begins Now",
                "entering_world": "Entering {theme} world in 2 seconds...",
                "failed_load_elements": "Failed to load story elements",
                "failed_create_session": "Failed to create story session",
                "your_story_complete": "Your Story is Complete",
                "generating_final_story": "Generating your final story...",
                "please_wait": "Please wait...",
                "fallback_story": "Your narrative journey through the marketplace of stories has concluded. The elements you traded and customized have woven together into a unique tale."
            },
            "memento": {
                "question_1": "1. How do you feel about your life right now?",
                "question_1_placeholder": "e.g., anxious about the future, grateful for relationships...",
                "question_2": "2. What matters most to you?",
                "question_2_placeholder": "e.g., family, creativity, making an impact...",
                "question_3": "3. If your life ended tomorrow, what would you want your legacy to represent?",
                "question_3_placeholder": "e.g., someone who helped others, lived authentically...",
                "find_companies_button": "Find Meaningful Companies",
                "choose_legacy_title": "Choose Your Legacy Portfolio",
                "choose_legacy_description": "Select 3-5 companies that represent what matters most to you.",
                "choose_legacy_warning": "These will be the stocks you hold when your time expires.",
                "selected_count": "Selected",
                "your_time_begins": "\u23F3 Your Time Begins Now \u23F3",
                "entering_mortality_chamber": "Entering your mortality chamber in 2 seconds...",
                "your_eulogy_label": "YOUR EULOGY",
                "generating_eulogy": "Generating your life's story based on your choices...",
                "your_eulogy_expanded_title": "YOUR EULOGY",
                "eulogy_subtitle": "A reflection of your choices in the marketplace of life",
                "eulogy_update_info": "This eulogy updates every 2 minutes based on your trading actions",
                "eulogy_fallback": "Your journey through life's marketplace continues to unfold, each choice revealing the values that guide your path."
            },
            "validation": {
                "complete_reflections": "Please complete all three reflections.",
                "max_companies": "Maximum 5 companies allowed"
            },
            "trader": {
                "send_message": "Send Message",
                "message_cost": "Cost: 20",
                "select_recipient": "Select a recipient:",
                "message_placeholder": "Enter your message (280 characters max)",
                "send_button": "Send",
                "no_stocks": "You own no stocks.",
                "output": "Output",
                "tap_for_details": "tap for full company view + chart",
                "close_button": "Close",
                "no_bond_port": "You own no ZBonds.",
                "steal_commodity": "Steal Commodity",
                "ransom": "Ransom",
                "no_economic_tiggers": "You have no economic triggers available.",
                "create_dark_pool": "Create Dark Pool",
                "delete_portfolio": "Delete Portfolio",
                "capitalist_lbo": "Capitalist LBO",
                "socialist_subsidy": "Socialist Subsidy",
                "bien_q": "Commodity",
                "no_redeemed_item": "You have no redeemed items.",
                "explanations": "Explanations",
                "commodity_items": "You own no commodities.",
                "click_learn_more": "Click to learn more",
                "go_to_market": "Go to Market",
                "dark_pool_market": "Dark Pool Market",
                "no_reason_provided": "No reason provided",
                "stock_name": "Stock Name",
                "unknown": "Unknown",
                "symbol": "Symbol",
                "quantity": "Quantity",
                "initial_value_per_share": "Initial Value per Share",
                "current_value_per_share": "Current Value per Share",
                "total_gain_loss": "Total Gain/Loss",
                "reason_for_short": "Reason for Short",
                "close_short_position": "Close Short Position",
                "emotional_state_banner_title": "Track your emotional economy",
                "social_economy_banner_title": "Emotional Debt Instruments",
                "issue_altrau_z_bill": "Issue Z Bill Altrau",
                "issue_m_note_borrow": "Issue M Note (Borrow)",
                "issue_z_payday_cdo": "Issue Z-Payday Loan CDO",
                "issue_v_note_request_aid": "V Note (Request Aid)"
            },
            "market": {
                "all_types": "All Types",
                "goods": "Goods",
                "stocks": "Stocks",
                "bonds": "Bonds",
                "no_sort": "No Sort",
                "price_low_to_high": "Price: Low to High",
                "price_high_to_low": "Price: High to Low",
                "apply_filter": "Apply Filter",
                "reset": "Reset",
                "close": "Close",
                "explanations": "Explanations",
                "items": "Items",
                "trade": "Trade",
                "buy": "Buy",
                "trade_for": "Trade For",
                "description": "Description",
                "value": "Value",
                "quantity": "Quantity",
                "location": "Location",
                "owner": "Owner",
                "portfolio": "Portfolio",
                "filter": "Filter",
                "redeem": "Redeem \u2713",
                "buy_bond_confirmation": "Buying this bond will trigger its maturity period. Confirm to proceed.",
                "bond_purchased_success": "Bond purchased successfully!",
                "bond_purchase_failed": "Failed to purchase bond. Please try again.",
                "portfolio_ransomed": "Your portfolio is currently under ransom. Pay the ransom to view and interact with items.",
                "shorted_by": "Shorted by:",
                "unknown": "Unknown",
                "num_shares": "# Shares:",
                "short_value": "Short Value:",
                "reason": "Reason:",
                "enter_offer_for": "Enter your offer for",
                "available_points": "You have {points} available capital. Commodity cost: {cost}.",
                "choose_offer_type": "Choose offer type:",
                "zollars": "Zollars",
                "capital": "Capital",
                "confirm": "Confirm",
                "cancel": "Cancel",
                "enter_capital": "Enter capital:",
                "offer_amount_placeholder": "Offer amount",
                "select_zollar_value": "Select a Zollar value to continue.",
                "invalid_offer": "Invalid offer or insufficient capital",
                "processing_transaction": "Processing your transaction...",
                "waiting_seconds": "Waiting: {seconds} seconds",
                "processing": "traitement",
                "short_stock": "Short Stock",
                "stock": "Stock:",
                "current_value": "Current Value:",
                "available_shares": "Available Shares:",
                "short_amount_placeholder": "Number of shares to short",
                "short_reason_placeholder": "Why short this stock?",
                "confirm_short": "Confirm Short",
                "must_provide_reason": "You must provide a reason to short this stock.",
                "portfolio_name": "Portfolio Name"
            },
            "offer": {
                "offer_sent": "Offer Sent",
                "do_not_leave_page": "DO NOT LEAVE THE PAGE.",
                "awaiting_response": "Awaiting response. Please wait...",
                "time_remaining": "Time remaining: {seconds} seconds",
                "trade_offer": "Trade Offer",
                "offers_you": "{initiator} offers you: {offered} in exchange for: {requested}",
                "respond": "Respond",
                "accept": "Accept",
                "decline": "Decline",
                "buy_offer_received": "Buy Offer Received",
                "zollar_offer_for": "Zollar offer for {item} from {portfolio}: {details}",
                "points_offer_for": "Capital offer for {item} from {portfolio}: {details}",
                "no_zollar_details": "No Zollar details available.",
                "error_missing_details": "Error: Missing details for offer. Please try again.",
                "error_invalid_points": "Error: Invalid amount for capital offer.",
                "error_missing_zollar_details": "Error: Missing details for Zollar offer.",
                "error_invalid_offer_type": "Error: Invalid offer type.",
                "success_buy_offer_accepted": "Success: Buy offer accepted for {item}",
                "error_accepting_offer": "Error accepting offer: {message}",
                "meaningful_exchange": "Meaningful Exchange",
                "value_quote": "Value exists in perception, play and speculation, not just utility or rarity.",
                "who_to_trade_with": "Who would you like to trade with?",
                "select_trader": "Select a trader...",
                "why_trade": "Why do you want to make this trade?",
                "describe_motivation": "Describe your motivation, emotion or story...",
                "trade_with": "Trade with:",
                "capital": "Capital",
                "zollars": "Zollars",
                "cancel": "Cancel",
                "send_offer": "Send Offer",
                "item_received": "You received {item} from {giver}!",
                "time_remaining_html": "Time remaining: <span id=\"timer\"></span> seconds",
                "time_expired": "Time expired. Offer declined.",
                "offer_declined": "Offer declined. No capital awarded.",
                "offer_accepted": "Offer accepted! Capital awarded.",
                "reason": "Reason:",
                "time_remaining_extended": "Time remaining: {seconds} seconds (extended)",
                "processing": "Processing transaction...",
                "meaningful_offer_sent": "Meaningful trade offer sent! {insight}",
                "error_generic": "Error: {message}",
                "share_reason_placeholder": "Share your reason, motivation, memory, or vision... To create meaningful connections by trading.",
                "meaningful_trade_offer": "Meaningful Trade Offer",
                "wants_to_trade": "wants to trade",
                "respond_optional": "Respond to their story (optional)...",
                "not_interested": "Not Interested",
                "im_interested": "I'm Interested!",
                "response_sent": "Response sent",
                "interest_shown": "Interest shown! They may contact you directly.",
                "respond_to_offer": "Respond to offer.",
                "the_why": "The why:",
                "share_thoughts": "Share your thoughts, ask questions, or explain your perspective...",
                "response_min_length": "Please write at least 10 characters in your response.",
                "send_response": "Send Response",
                "they_responded": "They Responded",
                "their_original_why": "Their original why:",
                "your_response": "Your response:",
                "their_response": "Their response:",
                "accept_trade": "Accept Trade",
                "decline_trade": "Decline Trade",
                "updated_trade_offer": "Updated Trade Offer",
                "offer_sentence_simple": "{name} offers you {offered} and requests {requested} in return.",
                "buy_accepted_points": "{seller} accepted your buy offer! You got {item} for {points} capital.",
                "buy_accepted_zollars": "{seller} accepted your buy offer! You got {item} for zollars.",
                "buy_accepted_generic": "{seller} accepted your buy offer! You got {item}.",
                "error_processing_trade": "Error processing trade offer",
                "zollar_none": "None",
                "zollar_few": "A Few",
                "zollar_some": "Some",
                "zollar_many": "Many",
                "zollar_huge": "A Huge Amount",
                "response_sent_title": "Response Sent",
                "waiting_for_response": "Waiting for their response...",
                "timer_extended_60": "Timer extended to 60 seconds"
            },
            "transaction": {
                "requested_item": "Requested Item",
                "item_owner": "Item Owner",
                "item_name": "Item Name",
                "points": "Capital",
                "location": "Location",
                "propose": "Propose",
                "explain_trade_reason": "Explain why you want to make this trade.",
                "you_offer": "You offer:",
                "you_want": "You want:",
                "why_trade_question": "Why do you want to make this trade? What is your goal?",
                "share_motivation": "Share your motivation, a memory or a vision... Stories create meaningful connections in trading. (15 characters minimum)",
                "narrative_error": "Please write at least 15 characters to explain your goal.",
                "char_missing": "Still missing {count} characters to explain your goal.",
                "char_missing_full": "Please write at least 15 characters to explain why you want this trade.",
                "send_trade_with_intention": "Send trade with intention",
                "cancel": "Cancel",
                "select_asset": "Select Asset",
                "return_to_market": "Return to Market"
            },
            "messageSend": {
                "title": "Send Message",
                "costPerRecipient": "Cost: 20 per recipient",
                "searchRecipients": "Search recipients",
                "unnamedPortfolio": "Unnamed Portfolio",
                "placeholder280": "Enter your message (280 characters max)",
                "send": "Send",
                "close": "Close",
                "newMessageFrom": "New message from",
                "unknown": "Unknown",
                "reply": "Reply",
                "markAsRead": "Mark as read",
                "onlyChatBots": "You can only chat with bot players, not humans.",
                "conversationWith": "Conversation with",
                "messagesRemaining": "messages remaining",
                "typeYourMessage": "Type your message...",
                "chatLimitReached": "Chat limit reached. This conversation has ended.",
                "error": "Error",
                "failedToSend": "Failed to send message",
                "chatEnded": "Chat ended",
                "chatEndedThanks": "This chat has ended. Thanks for talking!",
                "connectionError": "Connection error. Please try again.",
                "botGreeting": "Hey! I'm {name}. What's on your mind?",
                "message_user": "Message to {user}: {message}"
            },
            "boss": {
                "session_required_leaderboard": "Session ID is required to view the leaderboard.",
                "session_required_mood_board": "Session ID is required to view the Mood Board.",
                "invalid_point_amount": "Invalid capital amount. Please try again.",
                "session_required_system_bot": "Session ID required to start system bot.",
                "system_bot_started": "System bot started: {name}",
                "system_bot_start_failed": "Failed to start system bot: {error}",
                "session_required_stop_bot": "Session ID required to stop system bot.",
                "system_bot_stopped": "System bot stopped successfully.",
                "system_bot_stop_failed": "Failed to stop system bot: {error}",
                "session_required_trigger_event": "Session ID required to trigger system event.",
                "system_event_triggered": "System event triggered successfully!",
                "system_event_trigger_failed": "Failed to trigger system event: {error}",
                "session_required_logout": "Session ID is required to logout traders."
            },
            "stock": {
                "ownership_transferred": "Ownership transferred successfully",
                "transfer_failed": "Failed to transfer ownership. Please try again.",
                "share_deleted": "Share deleted successfully",
                "delete_failed": "Failed to delete share. Please try again.",
                "short_closed": "Short position closed successfully",
                "close_short_failed": "Failed to close short position. Please try again.",
                "short_placed": "Short position placed successfully",
                "place_short_failed": "Failed to place short position. Please try again.",
                "no_short_positions": "No short positions found for this stock.",
                "fetch_short_failed": "Failed to fetch short positions. Please try again.",
                "short_positions_for": "Short Positions for Stock ID",
                "short_position": "Short Position",
                "close_short": "Close Short",
                "submitting_bid": "Submitting your bid...",
                "please_wait": "Please wait while we process it.",
                "redirect_in": "Redirecting in",
                "seconds": "seconds"
            },
            "social_class": {
                "working_class": {
                    "name": "Working Class",
                    "description": "You begin in debt with minimal resources. Every decision matters.",
                    "goal": "Escape debt through strategic trading and community building",
                    "goals": {
                        "pay_off_debt": "Get your capital above zero before time runs out. Sell shares, swap items, accept fair offers \u2014 every deal that pays counts.",
                        "two_swaps": "Complete 2 swaps with other traders: your things for theirs. No money needed \u2014 swaps are how you trade when you are broke.",
                        "reserve_lift": "Visit the Zederal Reserve, take a Z Bond for extra capital, and turn it into at least one trade that grows what you hold."
                    }
                },
                "lower_middle": {
                    "name": "Lower Middle Class",
                    "description": "You have modest resources. Careful planning can lead to prosperity.",
                    "goal": "Build financial stability and grow your network",
                    "goals": {
                        "own_two_companies": "Own shares of 2 different companies by the end. Pick companies whose story speaks to you \u2014 you grow when they grow.",
                        "first_zollars": "Buy zollars at the Zederal Reserve and win one trade paying with relationships (Love, Friendship\u2026) instead of capital.",
                        "grow_worth": "Grow your total worth by a fifth. Bid on undervalued things, swap up, and do not let your capital sleep."
                    }
                },
                "middle_class": {
                    "name": "Middle Class",
                    "description": "You start with a balanced portfolio. Strategic choices will determine your trajectory.",
                    "goal": "Maintain stability while pursuing growth opportunities",
                    "goals": {
                        "diversify": "End the session holding all three kinds of value: shares of a company, an item, and a bond.",
                        "three_bids": "Win 3 bids on things other traders hold. Name your price, say why you want it, and convince them.",
                        "relations_over_money": "Finish richer in zollars than in capital \u2014 trade so that relationships outweigh plain money in your portfolio."
                    }
                },
                "upper_middle": {
                    "name": "Upper Middle Class",
                    "description": "You have significant resources. Use them wisely to create opportunities.",
                    "goal": "Leverage your resources to build lasting influence",
                    "goals": {
                        "fair_patron": "Play the patron: win 2 bids AND accept 2 offers from traders poorer than you, at a fair price. Influence is built, not bought.",
                        "capital_to_life": "Convert your capital into living value: end with more of your worth in shares and items than in plain capital.",
                        "bond_collector": "Build a bond book: hold 3 Z Bonds from the Zederal Reserve and let the interest work for you."
                    }
                },
                "wealthy_elite": {
                    "name": "Wealthy Elite",
                    "description": "You start with immense wealth. Everyone wants what you have\u2014generosity creates protection.",
                    "goal": "Share wealth to build alliances or face coordinated resistance",
                    "goals": {
                        "generous_giant": "Give to grow: accept swaps or modest bids from at least 3 different traders. On this floor, generosity is protection.",
                        "biggest_backer": "Spread your wealth into shares of 4 different companies \u2014 become the floor's biggest backer.",
                        "keep_the_crown": "End the session still on top. Everyone wants what you have; alliances and fair deals are how you keep it."
                    }
                },
                "starting_capital": "Starting Capital:",
                "starting_items": "Starting Items:",
                "your_goal": "Your Goal:",
                "actions_note": "Your actions shape how others treat you. Generosity builds alliances, exploitation invites retaliation."
            },
            "debt_actions": {
                "common": {
                    "perceived_magnitude": "Perceived magnitude",
                    "magnitude_none": "None",
                    "magnitude_hint": "A Hint",
                    "error_login_required": "Please log in first"
                },
                "help_friend": {
                    "intro": "Give help. Choose <b>Z$</b> or <b>Capital</b> for the gift.",
                    "capital_label": "Capital (amount)",
                    "capital_placeholder": "Enter capital",
                    "select_zollars": "Select Z$ categories to gift.",
                    "recipient_label": "Recipient:",
                    "no_zollars": "No Z$ available.",
                    "modal_title": "Altrau Z Bill (Altruistic Gift)",
                    "error_no_recipient": "Select a recipient.",
                    "error_invalid_capital": "Enter a valid capital amount.",
                    "error_no_zollars_to_give": "No Z$ to give.",
                    "error_select_zollars": "Select some Z$ to give.",
                    "error_insufficient_zollars": "Insufficient {type} zollars. You have {available}, trying to send {count}.",
                    "success": "Altrau Z Bill given. Your ledgers are now bound."
                },
                "predatory_lend": {
                    "intro": "Z-Payday CDO: Offer a compounding loan that reloads every 60 seconds.",
                    "warning": "WARNING: Each cycle increases the debt by 15% until repayment or bankruptcy.",
                    "exploitation_note": "(Exploitation disguised as empathic connection.)",
                    "capital_label": "Capital (amount to \"lend\")",
                    "capital_placeholder": "Amount",
                    "select_zollars": "Select Z$ bait for collapse.",
                    "victim_label": "Target Victim:",
                    "no_zollars": "No Z$ available.",
                    "modal_title": "Z-Payday CDO (Predatory Loan)",
                    "error_no_victim": "Select a victim.",
                    "error_invalid_amount": "Enter a valid amount.",
                    "error_no_zollars_selected": "No Z$ selected.",
                    "error_select_zollars": "Select some Z$.",
                    "success_targeted": "Z-Payday CDO offer sent to victim. Reloads every 60 seconds once accepted.",
                    "success_market": "Z-Payday CDO listed on market. Disguised as attractive offer."
                },
                "borrow": {
                    "intro": "Request a loan (M Note).",
                    "vulnerability_required": "Disclose your emotional debt. Vulnerability.",
                    "vulnerability_label": "Why do you need this loan? (Emotional debt disclosure - min 20 chars)",
                    "vulnerability_placeholder": "Disclose your emotional debt / vulnerability here...",
                    "char_count": "0 / 20 chars",
                    "char_suffix": "/ 20 chars",
                    "severity_label": "Severity",
                    "severity_question": "How severe is your need?",
                    "move_sliders": "Move sliders to express your need:",
                    "lender_label": "Choose Lender:",
                    "modal_title": "M Note (Request Loan)",
                    "error_vulnerability_required": "M Note requires vulnerability disclosure (min 20 characters).",
                    "error_move_slider": "Please move at least one slider to express your need.",
                    "error_no_lender": "Please select a lender.",
                    "success_targeted": "M Note loan request sent to lender.",
                    "success_market": "M Note listed on market for lenders to purchase."
                },
                "request_aid": {
                    "intro": "Request aid (V Note).",
                    "description": "Ask someone for a handout by sharing your vulnerability.",
                    "accept_decline_note": "They can accept or decline your request.",
                    "vulnerability_label": "Explain why you need aid (vulnerability disclosure - min 20 chars)",
                    "vulnerability_placeholder": "Share your vulnerability...",
                    "severity_question": "Situation severity (how urgent is this)",
                    "target_label": "Request aid from:",
                    "modal_title": "V Note (Request Aid)",
                    "error_no_target": "Please select who to request aid from.",
                    "error_vulnerability_required": "V Note requires vulnerability disclosure (min 20 characters).",
                    "success": "V Note request sent. Awaiting response."
                }
            },
            "bot": {
                "chat_connection_notready": "Connection not ready. Please try again in a moment.",
                "chat_greeting_fallback": "Hey! I'm {{name}}. What's on your mind?",
                "chat_remaining": "messages remaining",
                "chat_input_placeholder": "Type your message...",
                "chat_connection_lost": "Connection lost. Please try again.",
                "chat_error_notloggedin": "Error: User not logged in",
                "chat_limit_reached": "Chat limit reached.",
                "chat_timeout": "Bot is taking too long to respond. Please try again.",
                "chat_end_thanks": "This chat has ended. Thanks for talking!",
                "chat_ended": "Chat ended",
                "chat_recommendation_title": "Trading Recommendation",
                "chat_action_buy": "Place Bid",
                "chat_action_sell": "Create Offer",
                "chat_action_short": "Short Stock",
                "chat_action_trade": "Make Trade",
                "chat_action_goto": "Go to Trading"
            },
            "items": {
                "item_added_success": "Item added successfully!",
                "item_add_failed": "Failed to add item. Please try again.",
                "no_items_portfolio": "No Commodities in this portfolio.",
                "search_portfolios": "Search portfolios...",
                "item_assigned_success": "Item assigned to portfolio successfully",
                "item_assign_failed": "Failed to assign item to portfolio. Please try again.",
                "item_unassigned_success": "Commodity unassigned from portfolio successfully",
                "item_unassign_failed": "Failed to unassign commodity from portfolio. Please try again.",
                "item_deleted_success": "Item deleted successfully",
                "item_delete_failed": "Failed to delete commodity. Please try again.",
                "item_redeemed_success": "Item redeemed successfully",
                "item_unredeemed_success": "Item unredeemed successfully",
                "redeem_toggle_failed": "Failed to toggle redeem status. Please try again."
            },
            "zollar": {
                "select_relationship_required": "Please select at least one relationship and enter a quantity.",
                "zollars_added_success": "Zollar(s) added successfully",
                "add_failed_error": "Failed to add zollar(s). Please try again. Error: {error}",
                "deleted_success": "Zollar deleted successfully",
                "delete_failed": "Failed to delete zollar",
                "fill_required_fields": "Please fill all required fields correctly.",
                "zbond_added_success": "ZBond added successfully",
                "zbond_add_failed": "Failed to add ZBond. Error: {error}",
                "select_portfolio_required": "Please select a portfolio to assign the item to.",
                "assign_failed": "Failed to assign {itemType}. Please try again.",
                "unassigned_success": "{itemType} unassigned from portfolio successfully",
                "unassign_failed": "Failed to unassign from portfolio. Please try again.",
                "bond_deleted_success": "Bond deleted successfully",
                "bond_delete_failed": "Error deleting bond: {error}",
                "session_details_failed": "Failed to retrieve session details. Please try again.",
                "session_fetch_error": "Error fetching session details. Please try again later.",
                "fetch_portfolios_error": "Error fetching active portfolios. Please try again."
            },
            "tuts": {
                "trader_mood_gauge": "Trader Mood Gauge",
                "description": "Description:",
                "trader_gauge_description": "This gauge visualizes the collective mood of traders in the current market session.",
                "conceptual_insight": "Conceptual Insight:",
                "gains_losses": "Gains / Losses",
                "portfolio_banner_description": "Click the banner to view your earnings breakdown.",
                "trader_tools": "Trader Tools",
                "subsidy": "The Socialist Subsidy redistributes 45% of wealth from the richest portfolio to others. Use strategically to weaken strong players.",
                "ransom": "The Ransom locks a portfolio until the ransom capital is paid. This forces opponents into tough trade-offs.",
                "lbo": "The Leveraged Buyout (LBO) lets you acquire stocks and items from another portfolio by paying a high cost. Powerful but expensive.",
                "steal": "The Steal allows you to take a single item from another portfolio. Use stealthily to disrupt opponents.",
                'stealButton': `
          <h3>Steal Asset Trigger</h3>
          <strong>Description:</strong> <br>
          Steal Trigger allows you to steal from an individual in the market, anonymously, with no permission needed.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the \u{201C}Steal Trigger\u{201D} banner.</li>
          <li>Choose an item from the list of available holdings.</li>
          <li>Confirm your action to finalize the theft.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          Stealing is universally condemned, yet it thrives in countless forms, in every social stratosphere\u{2014}from petty theft to grand-scale corruption; from bicycles to bank robbery. 
          <br><br>
          By committing theft here, do you question your own moral boundaries? Does the short-term thrill of getting a \u{201C}free\u{201D} item overshadow the harm to the original owner? What value do you place on the consequences of what the robbed may feel? How would you feel about enjoying something that was intended to bring joy to someone else? This is a test of how you value empathy, guilt, and personal gain within the ZEconomy ecosystem.
          <br><br>
          <strong>Usage Example:</strong> <br>
          Imagine you see a commodity you really want on a big board. By using the Steal Trigger, you seize it for your own portfolio. But how do you feel knowing you gained \u{201C}value\u{201D} by undermining another person\u{2019}s rightful claim?
        `,
                'ransomButton': `
          <h3>Ransom a fellow Trader Trigger</h3>
          <strong>Description:</strong> <br>
          A trigger that locks another trader\u{2019}s entire portfolio, forcing them to pay your set ransom before they can resume trading.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the \u{201C}Ransom Trigger\u{201D} banner.</li>
          <li>Select the portfolio you want to ransom.</li>
          <li>Enter the ransom cost in capital.</li>
          <li>Once set, the victim\u{2019}s portfolio is inaccessible to them until you\u{2019}re paid in full.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          Ransom is akin to outright extortion. It\u{2019}s illegal in real-life finance with jail time for a reason; you profit to the detriment of the victim. However, in ZEconomy, the penalty is purely social: your identity is revealed to the victim at the moment you place the ransom. 
          <br><br>
          Do you relish wielding power, or dread the social backlash? Are you comfortable with a brute, aggressive form of \u{201C}profit\u{201D} at the expense of another trader\u{2019}s free will and peace of mind? Do you care about the consequences for the attack victim? Do you care about the social consequences for yourself? Will you enjoy the financial gains by extorting a trader from their wealth? 
          <br><br>
          <strong>Usage Example:</strong> <br>
          You notice a trader who has amassed valuable holdings but is short on capital. By setting a steep ransom, you effectively block them from using their entire portfolio until they cough up the fee. It can be a swift path to profit for you\u{2014}assuming you can handle the backlash once they realize you put them in lockdown.
        `,
                'createCommunityButton': `
          <h3>Dark Pool Trigger</h3>
          <strong>Description:</strong> <br>
          A private market arena with a participatory group of selected traders, hidden from the rest of the public exchange.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the \u{201C}Dark Pool Trigger\u{201D} banner.</li>
          <li>Select which traders to invite.</li>
          <li>If they accept, you have 10 minutes of private market trading, invisible to everyone else in the public market.</li>
          <li>Anyone can opt out anytime, returning to the public exchange.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          Dark Pools are private trading communities that exist outside of the visible public market exchanges. They are the market version of an exclusive gated community. Inside the pool, participants become free to shape the \u{201C}value\u{201D} of any market-listed assets, outside public scrutiny or intervention, especially when the trades are large in nature.
          <br><br>
          Is this honest cooperation, or a form of manipulation? Is it fair if asset values are decided by a hidden few traders? Does secrecy undermine genuine valuation and transparency? If you and your selected trading partners can inflate or deflate prices at will, are you still respecting the \u{201C}true\u{201D} nature of the ZEconomy or merely gaming it?
          <br><br>
          This tension between private gain and collective trust is what makes dark pools both tempting and ethically murky. You must decide: does stepping away from the public stage strengthen your own \u{201C}value,\u{201D} or undermine the shared \u{201C}value\u{201D} of the entire ZEconomy?
          <br><br>
          <strong>Usage Example:</strong> <br>
          Suppose you and a few close allies want to swap \u{201C}bonds\u{201D} or \u{201C}stocks\u{201D} at prices you set, away from prying eyes. The Dark Pool might let you corner a niche of the market or secure a better deal. Yet, once the broader community learns about your secrecy, they might feel cheated or question the fairness of these behind-the-scenes deals.
        `,
                'deletePortfolioButton': `
          <h3>Communist Assault Trigger</h3>
          <strong>Description:</strong> <br>
          Seize and redistribute all of a rival\u{2019}s wealth to the collective.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the Communist Assault banner.</li>
          <li>Choose a target portfolio.</li>
          <li>Confirm your action to instantly redistribute all their holdings across active traders.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          This trigger wipes out a single targeted trader\u{2019}s entire portfolio and spreads it randomly among everyone else. In theory, no single individual grows vastly richer; everyone gets an equal share of the now communal seized wealth.
          <br><br>
          But consider the human reality: how would you feel if everything you owned was aggressively confiscated and redistributed, even for a \u{201C}common good\u{201D}? Is it fair to remove one person\u{2019}s property so that everyone else can benefit? Would you see this as justice or injustice? Like many firebrand economic ideas, \u{201C}communal sharing\u{201D} is loaded with moral complexities. Is this an act of genuine solidarity or an unjust seizure? You must weigh how far you\u{2019}re willing to go in forcing collective welfare at another\u{2019}s expense.
          <br><br>
          <strong>Usage Example:</strong> <br>
          You notice a wealthy trader whom you feel has been hoarding too much. By unleashing the Communist Assault, you forcibly attack their market wealth and randomly redistribute all items, stocks, and captial to the rest of the active traders. A rising tide lifts all boats, but if the water rises at the expense of someone else, is that fair or moral?
        `,
                'LBOButton': ` <h3>Capitalist <br> (LBO) <br> Leveraged Buyout Trigger</h3>
          <strong>Description:</strong> <br>
          Aggressively buy control of another trader\u{2019}s assets, whether they agree or not.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the Capitalist LBO banner.</li>
          <li>Select the target portfolio you want to \u{201C}acquire.\u{201D}</li>
          <li>Pay a lump sum of your own capital (representing leveraged capital).</li>
          <li>Once paid, you seize the target\u{2019}s items and stocks.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          A leveraged buyout involves heavy borrowing or capital injection to take over a company. Here, you risk your own wealth to gain outright control of someone else\u{2019}s assets despite the target having freedom of choice in the transaction.
          <br><br>
          You do transfer funds, at a premium, to their portfolio, which might sound fair, yet the move is still coercive: it\u{2019}s an aggressive buyout (purchase) without mutual consent. If you can afford the price, you get to expand your empire leaving the former owner \u{201C}bought out\u{201D} and potentially weakened. If traditional business logic says \u{201C}if you can afford it, you deserve it,\u{201D} what role should ethics play? Is that just the free market at work (survival of the richest), or an exploitative maneuver that disregards the target\u{2019}s autonomy? The LBO highlights that in capitalism, money can effectively override freedom of consent, turning wealth into raw power.
          <br><br>
          <strong>Usage Example:</strong> <br>
          Spot a smaller portfolio with interesting stocks or items but fewer resources. With an inflated premium price of your wealth, you initiate a hostile LBO, forcibly taking over their assets. The target does receive payment in return\u{2014}but you gain the real market advantage by controlling their capital. Is that fair or exploitative? Only you decide.`,
                'SubsidyButton': `
          <h3>Socialist Subsidy Trigger</h3>
          <strong>Description:</strong> <br>
          \u{201C}Tax\u{201D} a rich portfolio to support the bottom half of the market.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the Socialist Subsidy banner.</li>
          <li>Choose a wealthy portfolio to tax.</li>
          <li>Trigger the subsidy taxing the target\u{2019}s wealth.</li>
          <li>Those taxed resources are distributed among the least affluent traders in the session.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          This trigger takes from the rich and subsidizes the struggling via redistribution of wealth to the less fortunate or unsuccessful, aiming to level the economic playing field.
          <br><br>
          On one hand, you\u{2019}re championing a sense of collective balance by narrowing wealth gaps. On the other, you\u{2019}re forcing someone else to bear the cost regardless of whether the rich or the poor deserve it. Does that build solidarity, or does it punish success? Is it \u{201C}just\u{201D} to relieve disparities or does it stifle ambition? 
          <br><br>
          You must decide if the \u{201C}greater good\u{201D} overrides individual success or wealth. The tension between economic equality, fairness, and personal freedom is at the heart of this move.
          <br><br>
          <strong>Usage Example:</strong> <br>
          You see a player sitting on massive stocks and capital while several others struggle. By hitting the Subsidy trigger, a significant chunk of that wealth is taxed and distributed to the poorest traders, giving them a fresh injection of capital. Perhaps you\u{2019}re bringing fairness, or perhaps you\u{2019}re penalizing someone for doing well. The outcome depends on your economic worldview.
        `,
                'helpFriendButton': `
          <h3>Altrau Z Bill</h3>
          <strong>Altruistic life value. Empathy.</strong>
          <br><br>
          <strong>Description:</strong> <br>
          To give without promise of return. Assist someone and become implicated in their Life Profit outcome. The rise and fall of their emotional balance pulling your life profits positive and negative. Quiet speculation that another's well-being might enlarge your own capacity to feel and expand your empathy capacity.
          <br><br>
          <strong>No returns required.</strong>
          <br><br>
          <strong>Conceptual Insight:</strong> <br>
          This is a transaction that binds both ledgers; an increase in shared variance rather than sum. When you issue an Altrau Z Bill, you're not just helping someone\u{2014}you're entangling your emotional economy with theirs. Their successes become yours, their failures yours to bear.
          <br><br>
          It asks: <em>Can empathy be an investment? What happens when another's pain becomes your loss, their joy your gain?</em>
          <br><br>
          <strong>Usage:</strong><br>
          Click the "Issue Z Bill Altrau" button, select a trader to help, choose what to give (Zollars or Capital), and confirm. Your Life Profit will now fluctuate with theirs\u{2014}a shared emotional destiny.
        `,
                'borrowCapitalButton': `
          <h3>M Note (Mutual Note)</h3>
          <strong>A loan drawn in confession.</strong>
          <br><br>
          <strong>Description:</strong> <br>
          M Note creates credit out of exposed need and calculated trust. Value created on the human empathy of sharing in human imperfections. A borrower discloses a weakness; a lender accepts the risk, extending empathy as a form of investment.
          <br><br>
          What begins as recognition becomes obligation\u{2014}vulnerability converted into Z Relational Collateral, interest accruing in attention, acknowledgment, and mutual Life Profit.
          <br><br>
          <strong>Conceptual Insight:</strong> <br>
          This is emotional-weighted interest; time dilates with mood. Unlike traditional loans, the M Note doesn't just transfer capital\u{2014}it transfers vulnerability. The borrower must confess why they need help, exposing their weakness to gain trust.
          <br><br>
          The lender isn't just providing resources; they're accepting the emotional risk of that vulnerability. Both parties are bound: the borrower by obligation, the lender by empathy.
          <br><br>
          <em>When you lend, you're investing in someone's capacity to recover. When you borrow, you're asking someone to believe in you.</em>
          <br><br>
          <strong>Usage:</strong><br>
          Click "Issue M Note (Borrow)", select a lender, write your vulnerability confession (why you need help), choose what you need (Zollars or Capital), and send. The lender sees your confession and decides whether your vulnerability is worth their trust.
        `,
                'predatoryLendButton': `
          <h3>Z-Payday CDO (Collateralized Desire Obligation)</h3>
          <strong>Exploitation disguised as empathic human connection.</strong>
          <br><br>
          <strong>Description:</strong> <br>
          Empathy and relief recast into instruments of toxic dependency. Z-Payday loans feed on need and greed, turning vulnerability into yield at the expense of human worth and systemic balance.
          <br><br>
          Each loan cycle lifts the lender, drains the borrower, and leaves the market to absorb the strain of contagion.
          <br><br>
          <strong>Function:</strong><br>
          Single acts of aid become a repeating contract\u{2014}each minute another obligation is issued, each obligation thinly sliced into tranches that feed the larger CDO. The product promises immediacy and then converts the living into yield; the harvest comes from what is worn away when kindness is made structural.
          <br><br>
          <strong>The Z-Payday CDO does not forgive. It compounds exposure until the ledger consumes the life profit underneath.</strong>
          <br><br>
          <strong>Conceptual Insight:</strong> <br>
          This is predatory lending made visible. Unlike traditional payday loans that hide behind legal jargon, the Z-Payday CDO forces you to confront what you're doing: extracting value from someone's desperation, minute by minute.
          <br><br>
          It asks: <em>How far will you go for profit? Can you watch someone drain themselves to pay you back? Is this business, or is this cruelty?</em>
          <br><br>
          The victim's Life Profit decreases every minute, transferred to you. The system itself bears the collective emotional cost\u{2014}everyone feels it when someone is being exploited.
          <br><br>
          <strong>Usage:</strong><br>
          Click "Issue Z-Payday Loan CDO", select a victim, choose the amount to extract per minute, and confirm. Every minute, their Life Profit decreases and transfers to you\u{2014}until they close the debt or collapse entirely.
          <br><br>
          <strong>Warning:</strong> This action has severe social and emotional consequences. Others will know. The market will know. Your guilt accumulates.
        `,
                'requestHandoutButton': `
          <h3>V Note (Vulnerability Note)</h3>
          <strong>Admitting vulnerability.</strong>
          <br><br>
          <strong>Description:</strong> <br>
          To ask is to step into exposure\u{2014}to risk the small collapse that comes with being seen in need. Vulnerability here is not weakness but invitation: a signal that one's balance has slipped and requires relation to recover.
          <br><br>
          Help, if granted, becomes a shared moment of recalibration; if withheld, it marks the quiet fracture between trust and pride.
          <br><br>
          Every request writes itself into the Emotional Debt Index, a measure not of possession, but of how much we still dare to depend.
          <br><br>
          <strong>Conceptual Insight:</strong> <br>
          This is a request with justification; relief triggered by assent; the ledger records both appeal and response. Unlike the M Note (which is a formal loan with obligation), the V Note is a simple ask\u{2014}no strings attached, no repayment expected.
          <br><br>
          But asking is its own cost. You must expose your need, your vulnerability, your dependence. And the response\u{2014}whether acceptance or rejection\u{2014}shapes your emotional state and trust in the community.
          <br><br>
          <em>Can you admit you need help? Can others afford to give it? What does it mean when help is given freely, or when it's denied?</em>
          <br><br>
          <strong>Usage:</strong><br>
          Click "V Note (Request Aid)", write why you need help (your vulnerability statement), choose what you're asking for (Zollars or Capital), and send to another trader. They can accept (giving you what you asked) or decline (leaving you to manage alone). Either way, the emotional impact is recorded.
        `,
                'giveDeletePortfolioButton': `
          <h3>Issue Communist Assault Trigger</h3>
          <strong>Description:</strong> <br> 
          Assign the "Communist Assault" button to a trader, enabling them to seize and redistribute all of a targeted portfolio's wealth to the collective. 
          <br><br><strong>How-to:</strong> <br>  
          Select a trader from the active trader list and assign them the "Communist Assault" button.
          <br><br><strong>Functionality:</strong> <br>
          The target's wealth (points, stocks, commodities, etc.) is evenly distributed among active participants. No single trader grows significantly richer, ensuring a sense of communal benefit.
          <br><br><strong>Conceptual Insight:</strong> <br>
          This action symbolizes extreme redistribution, testing the fairness of confiscating wealth for the common good. While it aims to level disparities, it raises ethical questions about property rights and the morality of forced redistribution. Assigning this button to a trader effectively grants them the power to balance\u{2014}or disrupt\u{2014}the market.
          <br><br><strong>Usage Example:</strong> <br>
          A trader notices another hoarding valuable assets, creating market imbalance. By using "Communist Assault," they redistribute the wealth, equalizing resources but possibly alienating the hoarder and other observers.
        `,
                'giveLBOButton': `
          <h3>Issue Capitalist <br> Leverage Buyout Trigger</h3> 
          <strong>Description:</strong> <br>
          Assign the "Capitalist LBO" button to a trader, empowering them to aggressively acquire another portfolio's assets through a leveraged buyout. 
          <br><br><strong>How-to:</strong> <br> 
          Select a trader from the active trader list and assign them the "Capitalist LBO" button.
          <br><br><strong>Functionality:</strong> <br>
          The acquiring trader gains full control of the target's portfolio (commodities, stocks, etc.) at sever cost to them.
          <br>
          The transaction is coercive yet compensatory, with the target receiving payment for their assets, and the initiator paying an inflated price.
          <br><br><strong>Conceptual Insight:</strong> <br>
          "Capitalist LBO" represents the power of wealth in overriding autonomy, highlighting the dynamics of aggressive capitalism. This function challenges the balance between fair competition and exploitation, emphasizing how financial strength can dictate market control.
          <br><br><strong>Usage Example:</strong> <br>
          A trader sees a smaller portfolio with underutilized assets. Using "Capitalist LBO," they pay a premium to forcibly acquire those assets, consolidating power but potentially facing backlash for their aggressive tactics.
        `,
                'giveSubsidyButton': `
          <h3>Issue Socialist Subsidy Trigger</h3>
          <strong>Description:</strong> <br> 
          Assign the "Socialist Subsidy" button to a trader, allowing them to tax a wealthy portfolio and redistribute the resources to less affluent traders.
          <br><br><strong>How-to:</strong> <br> 
          Select a trader from the active trader list and assign them the "Socialist Subsidy" button.
          <br><br><strong>Functionality:</strong> <br>
          50% of the target portfolio's wealth is Taxed and redistributed proportionally to traders with smaller holdings, aiming to balance the market.<br>
          This feature levels disparities but can also penalize success, fostering debates about fairness and equity.
          <br><br><strong>Conceptual Insight:</strong> <br>
          "Socialist Subsidy" reflects the tension between supporting collective welfare and discouraging ambition. By redistributing wealth, it highlights the challenges of addressing inequality without stifling innovation or growth.
          <br><br><strong>Usage Example:</strong> <br>
          A trader notices a portfolio with excess resources while others struggle. Using "Socialist Subsidy," they tax the wealthy trader and redistribute assets to the least affluent, injecting new life into the market and promoting equity.
        `,
                "deletePortfolio": "The Communist Assault deletes another portfolio entirely, at a significant cost. A drastic, endgame move.",
                "trader_tools_description": "Utilities for performing market-related actions with or against other traders.",
                "trader_tools_insight": "Whether you steal, ransom, or deal in private: each trigger tests how far you'll go in the quest for value. Will you explore new strategies without losing your sense of responsibility\u2014or will you push boundaries at the expense of others? The ZEconomy raises these questions, leaving you to decide what \"value\" really means and what you're willing to do to get it.",
                "transaction_instructions": "<h3>Transaction Instructions</h3><p>Select an asset from your holdings to propose a trade with the item owner. This enables peer-to-peer trading of commodities between portfolios.</p>",
                "stock_instructions": "<h3>Stock Trading Instructions</h3><p>Purchase shares by entering the quantity you wish to buy. Your available capital is shown above. Each transaction affects the market and builds your portfolio.</p>",
                "bond_instructions": "<h3>Bond Trading Instructions</h3><p>Trade Z-Bonds, the emotional debt instruments of the Z Relationship Monetary System. Bonds represent relational capital between traders.</p>",
                "no_info": "No information available.",
                "no_tutorial": "No tutorial content available.",
                "no_instructions": "No instructions available.",
                "redeem_instructions": `
          <h3>Redeem is:</h3>
          Redeem is the process of transforming a commodity into a QR code so it can be physically obtained. It also removes the commodity from the market and your portfolio.
          <br><br>
          The catch is your commodity can only be redeemed if the other traders agree to redeem their commodities as well.
          <br><br>
          <strong>Conceptual Insight:</strong><br>
          The redeem process challenges traditional ideas of individual consumption by introducing a collective decision-making aspect to the process. Redeeming a commodity isn't just about acquiring something\u{2014}it is a social interaction between multiple parties, with outcomes and consequences directly shaped by the responses of other traders.
          <br><br>
          <h3>Process:</h3>
          <strong>Step 1: Selected Commodities</strong><br>
          At the top, you'll see the Commodities you've selected to be Redeemed and the Commodity owner. These are the Commodities you're asking fellow traders to redeem so you can redeem your commodity.
          <br><br>
          <strong>Step 2: Choose Your <br> Redeem Commodity</strong><br>
          From your holdings list below, select the Commodity you want to Redeem.
          <br><br>
          <strong>Step 3: Send Ask</strong><br>
          Once you've selected your commodity, click "Send Redeem Ask." This will:
          <ul>
            <li>Send your ask to all target traders</li>
            <li>Lock your selected commodity during the process</li>
            <li>Give traders 10 seconds to respond</li>
          </ul>
          <br>
          <strong>Outcomes:</strong><br>
          If ALL traders accept: You'll receive a random new commodity from the Zederal Reserve, and your commodity is redeemed so it can be obtained using the QR code at its designated location.<br><br>
          If ANY trader declines: Your redeem fails, and the commodity remains in your portfolio, available for trading on the market.
          <br><br>
          <strong>Important Notes:</strong><br>
          You cannot cancel a redemption once started
          The process takes exactly 10 seconds
          Do not leave the page during redemption
        `,
                "stock_trade_instructions": `
          <h3>What Are Stocks:</h3>
          In conventional finance, a stock (or share) represents partial ownership of a company. Investors typically buy stocks hoping the company's value will rise, increasing the share price.
          <br><br>
          Stocks are tradable for Zollars or Capital. As a company's value grows, so does the value of your portfolio. However, if a company's share price falls, the value of your holdings decreases as well.
          <h3>Stocks in ZEconomy:</h3>
          Stocks in ZEconomy reflect human values such as emotional well-being, social relationships, and personal growth\u{2014}rather than traditional economic outputs. Trading stocks is more than just a financial transaction; it's an interaction with life values that forces you to reconsider what you value and how you invest in others.
          <br><br>
          <strong>Conceptual Insight:</strong><br>
          Stock trading in ZEconomy challenges the notion of profit: Is it about reaping monetary rewards, or about supporting the growth of human experiences such as emotional health, creativity, and shared connections? Every stock trade highlights the tension between genuine support for human value and the act of financially exploiting it. Think of your stocks as investments in happiness, success, and transformation instead of a company producing traditional goods or services.
          <br><br>
          This process asks you to reflect: Do your trades align with your personal values? What does it mean to invest in a human experience rather than economic output? How far are you willing to go to ensure your portfolio grows, and at what cost to the broader market ecosystem?
          <h3>Bid Process:</h3>
          <strong>Step 1: Review Available Stocks</strong><br>
          Use the stock table to review available shares in the market. Each stock represents a company built around a human value (e.g., creativity, happiness, or relationships). Take note of the stock's current value, owner, and potential for growth or decline.
          <br><br>
          <strong>Step 2: Decide Your Trade</strong><br>
          Determine whether to buy, sell, or short a stock. Buying supports the company's value, selling helps you realize gains, and shorting bets against its success, profiting if the value falls.
          <br><br>
          <strong>Step 3: Execute Your Trade</strong><br>
          Once you've made your decision:
          <ul>
            <li>Use the stock table to select the desired stock.</li>
            <li>Enter the number of shares you wish to trade and confirm the transaction.</li>
            <li>Your portfolio will update in real-time, reflecting the trade.</li>
          </ul>
          <br>
          <strong>Outcomes:</strong><br>
          <ul>
            <li>Successful trades increase the value of your portfolio if the company grows.</li>
            <li>Short positions succeed if the stock value drops but risk losses if it rises.</li>
          </ul>
          <br>
          <strong>Important Notes:</strong><br>
          <ul>
            <li>Stock values are dynamic and can change rapidly based on market activity.</li>
            <li>Consider the ethical implications of shorting stocks, as it bets against the success of human values.</li>
            <li>Every trade reflects your priorities and beliefs\u{2014}choose wisely!</li>
          </ul>
        `,
                "transact_instructions": `
          <h3>From Item to Interaction</h3>
          In most markets a commodity is an impersonal thing\u{2014}gold, oil, wheat\u{2014}bought, sold, consumed at will.
          At Z Exchange a <em>Commodity X</em> is still a physical object, but it cannot be consumed until the trader earns collective approval.
          Consumption becomes a social question: <em>What does it mean to need someone else's assent? What does your desire say about you\u{2014}and who needs to hear it?</em>
          Using social validation to combat mindless consumption, every trade becomes a small ritual of interaction; every commodity, a shared reflection.
          Here validation is not just permission, it is participation. The true commodity is the relationship.
          <h3>Social-Redeem Process</h3>
          Commodity X is not exchanged directly. Instead, you initiate a redeem cycle that succeeds only if the community agrees.
          <strong>1. Select your Commodity X</strong><br>
          Pick the item in your portfolio that you wish to consume (redeem).
          <br><br>
          <strong>2. Invite Co-Redeems</strong><br>
          Choose one to three commodities owned by other traders and invite their holders to redeem at the same time. Your consumption is now tied to theirs.
          <br><br>
          <strong>3. Send the Redeem Ask</strong><br>
          Press "Send Redeem Ask". All invited traders have <strong>10 seconds</strong> to accept or decline. During that window every selected item is locked.
          <br><br>
          <strong>4. Outcomes</strong><br>
          \u{2022} <strong>Collective&nbsp;Yes</strong> \u{2013} every invitee accepts. Your item turns into a QR code, leaves the market, and can be physically collected. You also receive a random bonus commodity from the Zederal Reserve.
          \u{2022} <strong>Any&nbsp;No</strong> \u{2013} at least one invitee declines. No one redeems; all items unlock and stay tradable. Nothing changes hands.
          <br><br>
          <h3>Conceptual Insight</h3>
          By linking individual consumption to shared approval, Commodity X critiques the culture of solitary, friction-free buying.
          It asks traders to consume consciously, to weigh desire against communal resonance, and to recognise that value emerges in relationship\u{2014}not isolation.
          Redeem relationally. Consume consciously.
        `,
                "market_instructions": `
          <h3>Marketplace Overview</h3>
          ZExchange is the ZEconomy Marketplace. It can be considered the dynamic heart of trading activities where traders can explore, bid on, bet against, and trade various assets. The Marketplace is ground zero for traders to engage in strategic decision-making and actively shape their trading portfolios.
          <br><br>
          <h3>Marketplace Activities</h3>
          The ZExchange Marketplace offers the following key activities:
          <br><br>
          <strong>1. Explore Available Assets:</strong><br>
          Use the Marketplace to scroll through the current available assets. These include stocks, commodities, and bonds. Each asset is accompanied by detailed descriptions and close to real-time market valuation, allowing you to make informed decisions before initiating trades or placing bids. You can also place short bets on individual stocks and see who has shorted what.
          <br><br>
          <strong>2. Initiate Trade Offers:</strong><br>
          Send direct commodity trade offers to other traders. Select assets from your portfolio and propose an exchange. Trade offers are valid for 10 seconds, during which the receiving trader can either accept or decline the offer. If no action is taken within the time frame, the offer is automatically declined. Fees are applicable to both parties.
          <br><br>
          <strong>3. Place Bids:</strong><br>
          Bid on stocks and bonds listed in the Marketplace through the bidding process. Bidding provides an opportunity to secure assets at a potentially lower cost while competing with other traders. Keep an eye on bid expiration times to stay ahead in the market.
          <br><br>
          <strong>4. Redeem Commodities:</strong><br>
          Commodities (physical assets) in the Marketplace can be redeemed through the redeem process. Select between two and up to 10 of these assets by checking a commodity redeem box. After the second selection, the redeem button will appear, and you can proceed to finish the redeem.
          <br><br>
          <strong>5. Place Short Positions:</strong><br>
          Engage in negative side trading by shorting certain assets. This allows you to profit from anticipated declines in value. Placing short bets requires careful timing and risk management, making it a powerful tool for augmenting your positive or negative earnings. You can close the short position on your holdings page.
          <br><br>
          <h3>Trading Mechanics</h3>
          <strong>1. Transaction Fees:</strong><br>
          Each transaction costs a fee depending on the type of transaction. This encourages thoughtful trades and strategic exchanges.
          <br><br>
          <strong>2. Bid Expiration:</strong><br>
          All bids are active for a limited duration. If the target trader does not respond to your bid within the specified time, the bid expires without a transaction. Possible penalties can be applied if the target trader does not respond.
          <br><br>
          <strong>3. Offer Penalties:</strong><br>
          Declined trade offers result in an earnings penalty for the trader who refuses the exchange. This incentivizes careful consideration of offers and fosters a market of intentional interactions. However, they will cost you a fee if the offer is accepted.
          <br><br>
          <h3>What is a Financial Exchange?</h3>
          At its core, a financial exchange is a structured platform where participants buy and sell assets such as stocks, bonds, and commodities. It operates as a hub for economic activity, enabling traders to assess the value of goods and execute transactions based on supply, demand, and personal strategy.
          <br><br>
          The ZExchange, the ZEconomy Marketplace, looks at the value of assets differently than traditional financial exchanges because the values are placed on human experiences, relationships, and social exchange. Less is not necessarily better than more. Instead of focusing solely on monetary gain, the ZExchange encourages participants to consider different ideas of value: the worth of collaboration, the ethics of competition, and the value of shared experiences. It applies finance and basic economics to shared common real-life experiences all humans face, placing the value on life itself.
          <br><br>
          This approach redefines the purpose of a financial exchange, transforming it into a reflective and socially participatory system. Traders are challenged to think beyond material accumulation and instead prioritize:
          <br><br>
          <strong>Relational Dynamics:</strong> Exploring how personal and collective interactions can impact market and social decisions.<br>
          <strong>Ethical Trading:</strong> Evaluating whether their strategies align with their moral beliefs about fairness, responsibility, and shared growth.<br>
          <strong>Experiential Value:</strong> Placing importance on how trades reflect and shape human experiences, how we can find and emphasize economic value in common living experiences, whether through collaboration, conflict, or mutual support.
          <br><br>
          By participating in the ZExchange, traders engage in a financial experiment that elevates the human aspects of economics. It is a system designed to challenge conventional assumptions about value, encouraging a more nuanced understanding of wealth as something that is both deeply personal and inherently collective.
        `,
                'emotional-debt-banner': `
          <h3>Emotional Debt Index</h3>
          <strong>Human Emotional Flux</strong>
          <br><br>
          Finding value in vulnerability through emotional debt. In this economy, value is not extracted\u{2014}it is felt. Every gesture\u{2014}help, trust, abandonment, envy\u{2014}leaves a trace, a measurable emotional gain or loss, a continuity. Life profit is a currency of sensation, taking the temperature of our being. Holding someone, letting yourself be held: the most human forms of leverage. The ZEconomy flows through us.
          <br><br>
          <strong>1. Altrau Z Bill</strong><br>
          <em>Altruistic life value. Empathy.</em><br>
          Giving without promise of return. Helping someone means involving yourself in the trajectory of their Life Profit. The rise and fall of their emotional balance pulls your own life profits toward positive or negative. Silent speculation on the idea that another's well-being could expand your own capacity to feel, to extend your empathy faculty. No return demanded.
          <br><br>
          <em>(Mirror code: a transaction that binds both ledgers; an increase in shared variance rather than a simple sum.)</em>
          <br><br>
          <strong>2. M Note (Mutual Note)</strong><br>
          <em>A loan written as confession.</em><br>
          The M Note creates credit from exposed need and calculated trust. Value born from the human empathy of sharing human imperfections. The borrower reveals a weakness; the lender accepts the risk, extending empathy as a form of investment. What begins as recognition becomes obligation\u{2014}vulnerability converted into Z Relational Collateral, interest growing in attention, recognition, and mutual Life Profit.
          <br><br>
          <em>(Mirror code: emotionally weighted interest; time dilates according to mood.)</em>
          <br><br>
          <strong>3. Z-Payday CDO (Collateralized Desire Obligation)</strong><br>
          <em>Exploitation disguised as empathetic human connection.</em><br>
          Empathy and relief are reformulated into instruments of toxic dependency. Z-Payday loans feed on need and greed, transforming vulnerability into yield at the expense of human value and systemic balance. Each loan cycle elevates the lender, exhausts the borrower, and leaves the market to absorb the contagion.
          <br><br>
          <strong>Function:</strong> Isolated acts of help become a repetitive contract\u{2014}each minute issues a new obligation, each obligation is fragmented into tranches feeding a larger CDO. The product promises immediacy, then converts the living into yield; the harvest comes from what erodes when benevolence becomes structural. The Z-Payday CDO does not forgive. It amplifies exposure until the ledger devours the underlying life profit.
          <br><br>
          <strong>4. V Note (Vulnerability Note)</strong><br>
          <em>Admitting vulnerability.</em><br>
          To ask is to expose oneself\u{2014}to risk the small collapse that accompanies being seen in need. Vulnerability is not weakness here, but invitation: a signal that balance has broken and requires a relationship to restore itself. Help, if granted, becomes a shared moment of recalibration; if refused, it marks the silent fracture between trust and pride. Each request is inscribed in the Emotional Debt Index, measuring not possession, but the degree to which we still dare to depend.
          <br><br>
          <em>(Mirror code: justified request; relief triggered by assent; the ledger records both call and response.)</em>
          <br><br>
          <strong>Closing Tone</strong><br>
          What circulates here is not finance, but recognition. Vulnerability becomes both mirror and market, where each profit is the echo of another's risk, and each debt, a memory that refuses to fade.
          <br><br>
          <h3>Emotional Debt Index</h3>
          It all begins with the recognition that accumulated life has weight\u{2014}that the simple fact of living with others engenders emotional debt, positive or negative, acknowledged or neglected, that we carry alone and exchange together. Debt not as deficit, but as acceptance: an instrument of the effects of our mutual entanglement. In the ZEconomy, Emotional Debt is the counterpoint to productivity\u{2014}it does not track what is produced, but what is felt. Every gesture, every hesitation, every confession or withdrawal modifies the emotional ledger. Its movements translate the circulation of affect through a living, porous system, where value is neither extracted nor manufactured, but engendered by the very experience of life. Life Profits, flows that resist accumulation, yet shape everything built upon them.
          <br><br>
          The Emotional Debt Index makes intimate vulnerability visible, mapping the invisible economies of trust, exhaustion, generosity, failure, dependency... that participate in collective instability or balance. Rejecting the fantasy of capital, embracing the liquidity of human sentiment.
        `
            },
            "common": {
                "close": "Close",
                "assign": "Assign",
                "unassign": "Unassign",
                "delete": "Delete",
                "redeem": "Redeem",
                "unredeem": "Unredeem",
                "yes": "Yes",
                "no": "No",
                "assigned_to": "assigned to",
                "to_market": "to market",
                "to_portfolio": "to portfolio",
                "successfully": "successfully",
                "login_required": "You must be logged in to perform this action.",
                "bond_with_interest_rate": "bond with interest rate",
                "assign_to_portfolio": "Assign to Portfolio",
                "assign_to_market": "Assign to Market",
                "item_name": "Item Name:",
                "owner": "Owner:",
                "trader_name": "Trader Name:",
                "password": "Password:",
                "connected": "Connected:",
                "portfolio_id": "Portfolio ID:",
                "points_breakdown": "Capital Breakdown:",
                "trading": "Trading",
                "commodities": "Commodities",
                "stocks": "Stocks",
                "shorts": "Shorts",
                "total": "Total:",
                "holdings": "Holdings:",
                "commodity": "Commodity:",
                "stock": "Stock:",
                "quantity": "Quantity",
                "shares": "Shares",
                "value": "Value",
                "no_holdings": "No holdings in this portfolio.",
                "unnamed_portfolio": "Unnamed Portfolio",
                "protected": "[protected]",
                "qr_code": "QR Code:",
                "qr_code_for": "QR Code for",
                "no_qr_available": "No QR code available.",
                "custom_relationship_type": "Custom relationship type",
                "remove": "Remove",
                "created_for_relationship": "Zollar created for relationship:",
                "value_place_relationship": "The value you place on a relationship:",
                "na": "N/A"
            },
            "socketFront": {
                "warningPrefix": "WARNING:",
                "criticalPrefix": "CRITICAL:",
                "debtPageVisit": "Visit the Debt page for details.",
                "debtWipeoutDefault": "Your portfolio has been wiped out due to excessive debt.",
                "debtWarningPrefix": "WARNING: This debt reloads every 60 seconds at 15% compound until repayment.",
                "bankruptcyWarning": "WARNING: You are approaching bankruptcy!",
                "debtCompounded": "Debt compounded:",
                "totalDebt": "Total debt:",
                "youOwe": "You owe:",
                "checkDebtHeldSection": "Check your Debt Held section to convert."
            },
            "debtWarning": {
                "title": "Debt Warning",
                "aboutToGoIntoDebt": "You are about to go into debt!",
                "currentBalance": "Current Balance:",
                "bidAmount": "Bid Amount:",
                "offerAmount": "Offer Amount:",
                "youWillOwe": "You will owe:",
                "interestAccrues": "Interest accrues at 5% daily on negative balances.",
                "creditLimit": "Credit limit: -1000 capital (default)",
                "proceedAnyway": "Proceed Anyway",
                "cancel": "Cancel",
                "points": "Capital"
            },
            "debt": {
                "capital": "capital",
                "closedDefault": "A {type} debt instrument has been closed.",
                "closedGeneric": "A debt instrument has been closed.",
                "amounts": {
                    "none": "None",
                    "barelyAny": "Barely Any",
                    "aTrace": "A Trace",
                    "aHint": "A Hint",
                    "aLittle": "A Little",
                    "aFew": "A Few",
                    "some": "Some",
                    "several": "Several",
                    "moderate": "Moderate",
                    "noticeable": "Noticeable",
                    "considerable": "Considerable",
                    "many": "Many",
                    "aLot": "A Lot",
                    "abundant": "Abundant",
                    "heaps": "Heaps",
                    "aGreatDeal": "A Great Deal",
                    "substantial": "Substantial",
                    "immense": "Immense"
                },
                "interest": {
                    "minimal": "Minimal Emotional Interest",
                    "light": "Light Emotional Interest",
                    "modest": "Modest Emotional Interest",
                    "fair": "Fair Emotional Interest",
                    "moderate": "Moderate Emotional Interest",
                    "notable": "Notable Emotional Interest",
                    "considerable": "Considerable Emotional Interest",
                    "heavy": "Heavy Emotional Interest",
                    "intense": "Intense Emotional Interest",
                    "crushing": "Crushing Emotional Interest"
                },
                "altrau": {
                    "receivedTitle": "Z Bill Altrau Received",
                    "issuedTitle": "Z Bill Altrau Issued",
                    "hasGivenYou": "has given you",
                    "ledgersBound": "Your ledgers are now bound. Their Life Profit affects yours.",
                    "youHaveSent": "You have sent",
                    "toRecipient": "to",
                    "fatesBound": "Your fates are now bound. Your Life Profit affects theirs."
                },
                "mnote": {
                    "acceptedTitle": "M Note Accepted",
                    "createdTitle": "M Note Created",
                    "witnessedVulnerability": "has witnessed your vulnerability",
                    "loanLabel": "Loan",
                    "atRate": "at",
                    "positiveTradeTip": "Make positive trades to automatically reduce this debt!",
                    "createdWith": "M Note created with",
                    "tradeableAfter": "Tradeable after 5 exchanges. Convertible after max trades.",
                    "progressTitle": "M Note Repayment Progress",
                    "repaidPercent": "You've repaid",
                    "throughTrading": "through positive trading",
                    "keepTrading": "Keep trading well to continue reducing your debt.",
                    "debtClearedTitle": "Debt Cleared!",
                    "repaidTitle": "M Note Repaid",
                    "positiveTrading": "positive trading",
                    "directRepayment": "direct repayment",
                    "fullyRepaidTo": "You've fully repaid your M Note to",
                    "throughMethod": "through",
                    "emotionalDebtCleared": "Your emotional debt is cleared. Well done!",
                    "hasFullyRepaid": "has fully repaid their M Note",
                    "instrumentClosed": "The debt instrument has been closed.",
                    "alertTitle": "M Note Alert",
                    "convertibleTitle": "M Note Convertible",
                    "nowConvertible": "Your M Note is now",
                    "convertibleCaps": "CONVERTIBLE",
                    "canConvertTo": "You can convert it to",
                    "inLiquidAssets": "in liquid assets"
                },
                "cdo": {
                    "acceptedTitle": "Z-Payday CDO Accepted",
                    "createdTitle": "Z-Payday CDO Created",
                    "offeredLoan": "has offered you a loan",
                    "availableImmediately": "available immediately",
                    "createdWith": "Z-Payday CDO created with",
                    "tradeableCompounds": "Tradeable. Compounds every 60s at 15%.",
                    "bankruptcyWarningTitle": "BANKRUPTCY WARNING",
                    "reloadCycle": "CDO Reload: Cycle {cycle}",
                    "cdoCompounded": "Your CDO compounded",
                    "victimOwes": "Victim owes",
                    "bankruptcyTitle": "BANKRUPTCY",
                    "cdoCollapsed": "Your Z-Payday CDO collapsed",
                    "totalDebtLabel": "Total debt",
                    "assetsSeized": "Assets seized",
                    "standingDamaged": "Your financial standing has been severely damaged.",
                    "maturedTitle": "CDO Matured",
                    "victimBankrupt": "Your victim declared bankruptcy",
                    "youSeized": "You seized",
                    "toxicGainRecorded": "Toxic relationship gain recorded."
                },
                "vnote": {
                    "aidGrantedTitle": "V Note Aid Granted",
                    "hasGrantedAid": "has granted you aid",
                    "received": "Received",
                    "vulnerabilityWitnessed": "Your vulnerability was witnessed and met with compassion.",
                    "youGranted": "You granted",
                    "toRecipient": "to",
                    "compassionRecorded": "Your compassion has been recorded in the social ledger."
                }
            },
            "freeend": {
                "title": "Trading Session Complete",
                "trading_analysis": "TRADING ANALYSIS",
                "social_standing": "Social Standing",
                "return_home": "Return Home",
                "panels": {
                    "stocks": "STOCKS",
                    "items": "ITEMS",
                    "zollars": "ZOLLARS",
                    "bonds": "BONDS"
                },
                "judgements": {
                    "performance": "Performance",
                    "style": "Style",
                    "social": "Social",
                    "risk": "Risk",
                    "mood": "Mood"
                },
                "ratings": {
                    "excellent": "Excellent",
                    "good": "Good",
                    "fair": "Fair",
                    "poor": "Poor",
                    "bad": "Bad",
                    "neutral": "Neutral",
                    "aggressive": "Aggressive",
                    "calm": "Calm",
                    "balanced": "Balanced",
                    "active": "Active",
                    "quiet": "Quiet",
                    "moderate": "Moderate",
                    "diverse": "Diverse",
                    "cautious": "Cautious",
                    "focused": "Focused",
                    "euphoric": "Euphoric",
                    "optimistic": "Optimistic",
                    "positive": "Positive",
                    "anxious": "Anxious",
                    "distressed": "Distressed"
                },
                "sections": {
                    "social_class_movement": "YOUR SOCIAL CLASS MOVEMENT",
                    "mood_state": "MOOD STATE",
                    "trading_behavior": "TRADING BEHAVIOR PATTERNS",
                    "commodities_supply": "COMMODITIES SUPPLY"
                },
                "labels": {
                    "commodities": "Commodities:",
                    "no_commodities": "No commodity holdings - focus was on other value forms",
                    "stocks": "Stocks",
                    "items": "Items",
                    "zollars": "Zollars",
                    "bonds": "Bonds",
                    "zollar_holdings": "Relational Zollar Holdings:",
                    "total": "Total:",
                    "session_engagement": "Session Engagement:",
                    "social_connections": "Social Connections:",
                    "value_movement": "Value Movement:",
                    "started_with": "Started With",
                    "ended_with": "Ended With",
                    "life_movement": "Life Movement",
                    "your_holdings": "Your Holdings",
                    "rhythm": "Rhythm",
                    "value_shift": "Value Shift",
                    "cadence": "Cadence",
                    "diversity": "Diversity",
                    "intensity": "Intensity"
                },
                "value_movement": {
                    "significant_gain": "Significant Gain",
                    "strong_gain": "Strong Gain",
                    "moderate_gain": "Moderate Gain",
                    "slight_gain": "Slight Gain",
                    "no_change": "No Change",
                    "slight_loss": "Slight Loss",
                    "moderate_loss": "Moderate Loss",
                    "strong_loss": "Strong Loss",
                    "significant_loss": "Significant Loss"
                },
                "activity_levels": {
                    "contemplative": "Contemplative",
                    "measured": "Measured",
                    "active": "Active",
                    "very_active": "Very Active",
                    "intensely_engaged": "Intensely Engaged"
                },
                "social_levels": {
                    "solitary": "Solitary",
                    "selective": "Selective",
                    "socially_active": "Socially Active",
                    "highly_connected": "Highly Connected"
                },
                "emotional_states": {
                    "balanced": "Balanced",
                    "triumphant": "Triumphant",
                    "reflective": "Reflective",
                    "socially_engaged": "Socially Engaged",
                    "energetically_active": "Energetically Active"
                },
                "quantities": {
                    "none": "None",
                    "barely_any": "Barely Any",
                    "a_trace": "A Trace",
                    "a_hint": "A Hint",
                    "a_little": "A Little",
                    "a_few": "A Few",
                    "some": "Some",
                    "several": "Several",
                    "moderate": "Moderate",
                    "noticeable": "Noticeable",
                    "considerable": "Considerable",
                    "many": "Many",
                    "a_lot": "A Lot",
                    "abundant": "Abundant",
                    "heaps": "Heaps",
                    "a_great_deal": "A Great Deal",
                    "substantial": "Substantial",
                    "ample": "Ample",
                    "extensive": "Extensive",
                    "vast": "Vast",
                    "profuse": "Profuse",
                    "almost_all": "Almost All",
                    "nearly_everything": "Nearly Everything",
                    "overflowing": "Overflowing",
                    "virtually_everything": "Virtually Everything",
                    "all_you_have": "All You Have"
                },
                "value": {
                    "none": "Nothing",
                    "barely_any": "Barely Anything",
                    "a_trace": "A Trace of Value",
                    "a_little": "A Little",
                    "some": "Some Holdings",
                    "modest": "Modest",
                    "moderate": "Moderate",
                    "comfortable": "Comfortable",
                    "considerable": "Considerable",
                    "substantial": "Substantial",
                    "abundant": "Abundant",
                    "prosperous": "Prosperous",
                    "wealthy": "Wealthy",
                    "very_wealthy": "Very Wealthy",
                    "extremely_wealthy": "Extremely Wealthy",
                    "vast_wealth": "Vast Wealth"
                },
                "change": {
                    "unchanged": "Unchanged",
                    "slight_loss": "A Slight Loss",
                    "small_loss": "A Small Loss",
                    "moderate_loss": "A Moderate Loss",
                    "considerable_loss": "A Considerable Loss",
                    "substantial_loss": "A Substantial Loss",
                    "large_loss": "A Large Loss",
                    "severe_loss": "A Severe Loss",
                    "slight_gain": "A Slight Gain",
                    "small_gain": "A Small Gain",
                    "moderate_gain": "A Moderate Gain",
                    "considerable_gain": "A Considerable Gain",
                    "substantial_gain": "A Substantial Gain",
                    "large_gain": "A Large Gain",
                    "exceptional_gain": "An Exceptional Gain"
                },
                "pace": {
                    "still": "Still",
                    "contemplative": "Contemplative",
                    "measured": "Measured",
                    "steady": "Steady",
                    "active": "Active",
                    "brisk": "Brisk",
                    "vigorous": "Vigorous",
                    "intense": "Intense",
                    "frenetic": "Frenetic"
                },
                "diversity": {
                    "none": "None",
                    "singular": "Singular Focus",
                    "focused": "Focused",
                    "balanced": "Balanced",
                    "broad": "Broadly Diversified"
                },
                "intensity": {
                    "quiet": "Quiet",
                    "calm": "Calm",
                    "moderate": "Moderate",
                    "engaged": "Engaged",
                    "active": "Active",
                    "intense": "Intense",
                    "highly_intense": "Highly Intense",
                    "overwhelming": "Overwhelming"
                }
            },
            "tax": {
                "tax_alert_timer": "TAX ALERT! You have 10 seconds to choose or lose both:",
                "lose_capital_zollars": "Lose capital & Zollars",
                "give_random_asset": "Give random asset",
                "assign_failed": "Failed to assign new item to all portfolios.",
                "new_asset_assigned": "Zederal Reserve has assigned a new asset to your portfolio.",
                "tax_call_no_assets": "Zederal Reserve has issued a tax call. Press OK to lose capital, no assets available for payment.",
                "asset_taxed": "You have been taxed an asset by the Zederal Reserve.",
                "no_items_available": "No non-traded items available for taxation.",
                "tax_item_failed": "Failed to tax an item.",
                "capital_taxed_prefix": "You have been taxed capital by the Zederal Reserve!",
                "refund_received_prefix": "You have received a refund of capital from the Zederal Reserve",
                "new_asset_received": "You have received a new asset from the Zederal Reserve",
                "zollar_assigned": "You have received Zollars from the Zederal Reserve.",
                "points": "Capital"
            },
            "presentation": {
                "title": "ZExchange - Presentation",
                "hero_tagline": "What if value wasn't a number?",
                "intro_main": "A live trading floor experience for 10 to 200 participants, lasting 1 to 24 hours. But this isn't Wall Street. Here, the asset class is human experience itself.",
                "card_trade_title": "Trade Human Conditions",
                "card_trade_desc": "Instead of Apple or Nvidia, invest in Zo Depression Corp, Stomach Pain Industries, Zo Happy Inc. Every stock represents a facet of being alive.",
                "card_spend_title": "Spend Relationships",
                "card_spend_desc": "Forget dollars. Here you pay with Zollars, currency denominated by relationship type: Love, Friendship, Hate, Erotic, Toxic, Death.",
                "card_consume_title": "Consume Collectively",
                "card_consume_desc": "Own a glass of wine? You can't acquire it alone. To redeem any commodity, you must ask others for approval. Consumption requires mutual consent.",
                "card_market_title": "The Market Watches Back",
                "card_market_desc": "An AI narrates every transaction, interpreting what your trades reveal about you. The market doesn't just move, it speaks.",
                "intro_transform": "ZExchange transforms economic logic into a collective conversation about what we actually value.",
                "intro_mirror": "It's part conceptual art, part party art, part mirror. Organizations discover their hidden values. Groups confront power, fairness, and trust. Everyone leaves with questions they didn't arrive with.",
                "section_video": "Video Explainers",
                "section_video_desc": "Click to watch concept explanations",
                "video_intro": "Introduction to ZExchange",
                "video_intro_desc": "Overview of the concept",
                "video_life": "Life Profits & Value",
                "video_life_desc": "Value in the ZEconomy",
                "video_stocks": "How Stocks Function",
                "video_stocks_desc": "Trading human conditions",
                "video_zbonds": "ZBonds & Zollars",
                "video_zbonds_desc": "Z Relationship Monetary System",
                "video_commodity": "Commodity X",
                "video_commodity_desc": "Social consumption",
                "video_interface": "Interface Preview",
                "video_interface_desc": "The trading interface",
                "video_bigboard": "Generative Big Boards",
                "video_bigboard_desc": "Real-time market expression",
                "section_assets": "Trading Assets",
                "section_assets_desc": "Click banners for detailed explanations",
                "label_stocks": "STOCKS - Human Conditions as Shares",
                "label_zbonds": "ZBONDS - Relationship-Based Investments",
                "label_commodities": "COMMODITIES - Physical Items with Social Approval",
                "label_zollars": "ZOLLARS - Currency Without Numbers",
                "section_economic": "Economic Tools",
                "section_economic_desc": "Ideological approaches to wealth and power",
                "label_economic": "ECONOMIC TRIGGERS - Ideology as Market Action",
                "label_communist": "Communist Assault",
                "label_socialist": "Socialist Subsidy",
                "label_lbo": "Capitalist LBO",
                "section_trader": "Trader Tools",
                "section_trader_desc": "How far will you go in the quest for value?",
                "label_trader": "TRADER TOOLS - Actions With or Against Others",
                "label_steal": "Steal",
                "label_ransom": "Ransom",
                "label_darkpool": "Dark Pool",
                "section_features": "Market Features",
                "label_emotional": "EMOTIONAL DEBT INDEX - Human Emotion Flux",
                "label_bigboard": "THE BIG BOARD - Real-Time Market Visualization",
                "label_voice": "VOICE OF THE BOURSE - AI Market Narration",
                "section_central": "Zederal Reserve / ZExchange Regulator",
                "section_central_desc": "How the ZExchange operator controls market sessions",
                "central_intro": "The Zederal Reserve (or ZExchange Operator) orchestrates the entire trading session. Before the market opens, it is the interfaces where you can configure the economy: creating trader portfolios with initial capital and commodities available during the session, distribute stock from over 350 predefined ZEconomy companies, and mint relationship-based Zollars and ZBonds. During the session, you act as regulator and central authority: opening and closing the market, controlling which assets can be traded, taxing portfolios to extract value, subsidizing traders with capital or commodities, issuing special triggers (Steal, Ransom, Dark Pool, Communist Assault, Socialist Subsidy, Capitalist LBO), broadcasting media events, and deploying market bots for liquidity. You can shape the session's narrative through story themes that guide the AI's interpretation of market activity. The Zederal Reserve acts as a Central Bank embodying the tension between control and chaos in any economy, you can foster balance or create disruption, reward or punish, stimulate or restrict. Every decision ripples through the market, challenging traders to adapt and respond.",
                "label_control": "MARKET CONTROL - Open/Close & Asset Listing",
                "section_tax": "Tax Portfolios Holdings",
                "section_tax_desc": "Extract value from trader portfolios",
                "label_taxall": "Tax All Traders",
                "label_taxitem": "Tax Commodity",
                "label_taxpoints": "Tax Capital",
                "section_subsidize": "Subsidize Portfolios Holdings",
                "section_subsidize_desc": "Inject value into trader portfolios",
                "label_givezollar": "Give Zollar Subvention",
                "label_givepoints": "Give Capital Subvention",
                "label_giveitem": "Give Commodity",
                "label_freebie": "Commodity Distribution",
                "section_events": "Event Triggers",
                "section_events_desc": "Broadcast media and create narratives",
                "label_publizity": "Play PubliZity",
                "label_znews": "Play ZNews",
                "label_story": "Create Story",
                "section_bots": "Market Bots",
                "section_bots_desc": "Automated trading for market liquidity",
                "label_addbots": "Add Bots",
                "label_removebots": "Remove Bots",
                "label_botstatus": "Bot Status",
                "section_keep": "What Participants Keep",
                "keep_bigboard": "A Big Board shaped by every trade, frozen as generative artwork",
                "keep_story": "An AI-written story of your group's dynamics",
                "keep_award": "Perhaps an award or two",
                "keep_mirror": "A mirror reflecting what your organization actually values",
                "section_concepts": "Key Concepts",
                "concept_life_title": "Life Profit",
                "concept_life_desc": "Value of consciously lived life: joy, loss, love, depression. Quality over quantity.",
                "concept_auto_title": "No Autopilot",
                "concept_auto_desc": "Every transaction requires presence. To trade, engage another. To redeem, you must ask.",
                "concept_market_title": "The Market Talks Back",
                "concept_market_desc": "AI watches every transaction, offering interpretations and narration.",
                "concept_shared_title": "Shared Values",
                "concept_shared_desc": "Opposite political spectrums, same human experiences.",
                "footer_mirror": "ZExchange isn't just a market; it's a mirror.",
                "footer_transform": "It turns the cold logic of economics into a collective conversation about what we actually value.",
                "footer_part": "Part of",
                "popup_stocks": '<h3>Shares (Stocks)</h3><strong>Description:</strong><br>Monitor and trade your stock positions.<br><br><strong>What They Are:</strong><br>In conventional finance, a stock represents partial ownership of a company. Investors typically buy stocks hoping the company\'s value will rise.<br><br>In ZEconomy, each "company" reflects personal or human values\u2014such as emotional well-being, social relationships, or daily life activities\u2014rather than traditional products or services. By "investing" in these companies, you\'re effectively betting on the value of growth, transformation, or sustainability of human experiences.<br><br><strong>Conceptual Insight:</strong><br>This challenges the notion of profit: is it about reaping monetary rewards, or about supporting the expansion of "life value" such as emotional health, creativity, or shared experiences?<br><br>Think of your stocks as investments in human value: happiness, depression, success, failure, confusion\u2014instead of a company producing a product or service.<br><br><strong>Mechanics:</strong><br>Stocks are tradable for Zollars or points. As a company\'s value grows, so does the value of your portfolio.',
                "popup_zbonds": "<h3>ZBonds</h3><strong>Description:</strong><br>ZBonds function like traditional bonds: you purchase them using points, hold them over a predetermined term, and when they expire, you receive Zollars.<br><br><strong>Conceptual Insight:</strong><br>While typical bonds fund governments or corporations, ZBonds fund the creation of a currency (Zollars) whose entire value is tied to human relationships and experiences.<br><br>By investing in a ZBond, you are effectively choosing to place trust in the shared values of community and interpersonal connections over purely financial returns.<br><br>ZBonds bridge the gap between traditional \"fixed income securities\" and the ZEconomy's redefinition of \"value.\"",
                "popup_commodities": "<h3>Commodities (Commodity X)</h3><strong>Description:</strong><br>The redeemable physical items you own.<br><br><strong>Social Validation:</strong><br>No commodity can be consumed alone. To redeem one, traders must ask other traders for approval. If all agree, the item is released; if anyone declines, nothing happens.<br><br><strong>Conceptual Insight:</strong><br>What does it mean to need permission for what you already own? Social validation inserts friction where markets remove it, making consumption visible, questioned, collective.<br><br>Commodities remind us that markets are also about goods and experiences that shape our lives.",
                "popup_zollars": "<h3>Zollars</h3><strong>Description:</strong><br>Check your Zollar balances and transactions.<br><br><strong>Currency Without Numbers:</strong><br>Zollars are denominated by relationship type: Love, Erotic, Friendship, Fellowship, Superficial, Toxic, Hate, Death.<br><br>Using Zollars pushes participants to consider <em>what kind</em> of value is at stake, not <em>how much</em>.<br><br><strong>Conceptual Insight:</strong><br>Acquiring Zo Insomnia Incorporated with Love Zollars tells a different story than acquiring it with Toxic Zollars. The interpretation is personal; the framework, shared.<br><br>Zollars challenge traditional ideas of currency by basing value on human relationships.",
                "popup_economic": "<h3>Economic Attack Triggers</h3><strong>Description:</strong><br>Economic Attack Triggers represent different ideological approaches to wealth, power, and market dynamics. They allow traders to use strategies inspired by economic systems\u2014communism, socialism, capitalism\u2014to gain or redistribute advantages within the ZEconomy.<br><br><strong>Conceptual Insight:</strong><br>The triggers challenge participants to confront their beliefs about fairness, ambition, and collective responsibility. They spark debate about the balance between fairness, ambition, and ethical trade-offs.<br><br><ul><li>Should wealth be shared equally, even if it means confiscating someone else's success?</li><li>Is it ethical to profit at the expense of another's autonomy?</li><li>How far are you willing to go to achieve personal gain or support collective welfare?</li></ul>",
                "popup_communist": "<h3>Communist Assault Trigger</h3><strong>Description:</strong><br>Seize and redistribute all of a targeted portfolio's wealth to the collective.<br><br><strong>Functionality:</strong><br>The target's wealth (points, stocks, commodities) is evenly distributed among active participants. No single trader grows significantly richer, ensuring a sense of communal benefit.<br><br><strong>Conceptual Insight:</strong><br>This action symbolizes extreme redistribution, testing the fairness of confiscating wealth for the common good. While it aims to level disparities, it raises ethical questions about property rights and the morality of forced redistribution.<br><br><em>Should wealth be shared equally, even if it means confiscating someone else's success?</em>",
                "popup_socialist": "<h3>Socialist Subsidy Trigger</h3><strong>Description:</strong><br>Tax a wealthy portfolio and redistribute the resources to less affluent traders.<br><br><strong>Functionality:</strong><br>50% of the target portfolio's wealth is taxed and redistributed proportionally to traders with smaller holdings, aiming to balance the market.<br><br><strong>Conceptual Insight:</strong><br>\"Socialist Subsidy\" reflects the tension between supporting collective welfare and discouraging ambition. By redistributing wealth, it highlights the challenges of addressing inequality without stifling innovation or growth.<br><br><em>How do we balance equity with individual achievement?</em>",
                "popup_lbo": "<h3>Capitalist Leveraged Buyout (LBO)</h3><strong>Description:</strong><br>Aggressively acquire another portfolio's assets through a leveraged buyout.<br><br><strong>Functionality:</strong><br>The acquiring trader gains full control of the target's portfolio at severe cost to them. The transaction is coercive yet compensatory\u2014the target receives payment, and the initiator pays an inflated price.<br><br><strong>Conceptual Insight:</strong><br>\"Capitalist LBO\" represents the power of wealth in overriding autonomy, highlighting the dynamics of aggressive capitalism. This function challenges the balance between fair competition and exploitation.<br><br><em>Is it ethical to profit at the expense of another's autonomy?</em>",
                "popup_tools": "<h3>Trader Tools</h3><strong>Description:</strong><br>Utilities for performing market-related actions with or against other traders.<br><br><strong>Conceptual Insight:</strong><br>Whether you steal, ransom, or deal in private: each trigger tests how far you'll go in the quest for value. Will you explore new strategies without losing your sense of responsibility\u2014or will you push boundaries at the expense of others?<br><br>The ZEconomy raises these questions, leaving you to decide what \"value\" really means and what you're willing to do to get it.",
                "popup_steal": "<h3>Steal Item</h3><strong>Description:</strong><br>Take assets from another portfolio anonymously, without permission.<br><br><strong>Functionality:</strong><br>The selected item is transferred from the target's portfolio to your portfolio without consent. The action remains anonymous, preventing immediate retaliation.<br><br><strong>Conceptual Insight:</strong><br>Stealing tests ethical boundaries, exploring whether traders prioritize personal gain over empathy and collective trust. It challenges participants to reflect on the consequences of their actions and how they value fairness within the ZEconomy.",
                "popup_ransom": "<h3>Ransom Portfolio</h3><strong>Description:</strong><br>Lock another trader's portfolio and demand a ransom to unlock it.<br><br><strong>Functionality:</strong><br>Locks the target's portfolio, rendering it unusable until the ransom is resolved. The trader initiating the ransom gains points if paid. The initiator's identity is revealed to the victim, adding social consequence.<br><br><strong>Conceptual Insight:</strong><br>Ransoming explores power dynamics and coercion in trading. It forces traders to evaluate whether financial gain outweighs potential social backlash or ethical concerns.",
                "popup_darkpool": "<h3>Dark Pool</h3><strong>Description:</strong><br>Establish a private trading group hidden from the public market.<br><br><strong>Functionality:</strong><br>Creates a private, temporary trading space exclusive to selected participants. Trades within the Dark Pool are hidden from the broader market, allowing participants to set their own prices and terms.<br><br><strong>Conceptual Insight:</strong><br>Dark Pools represent a tension between collaboration and manipulation. They offer the opportunity to negotiate deals without public scrutiny, but challenge the fairness and transparency of the market.",
                "popup_emotional": "<h3>Emotional Debt Index</h3><strong>Human emotion flux</strong><br><br><strong>Acknowledging the value of vulnerability through emotional debt.</strong><br><br>ZEconomy value is not extracted but felt. Every gesture\u2014help, trust, abandonment, envy\u2014leaves a trace: measurable emotional debt both positive and negative. We carry debt with us like it or not.<br><br>To hold another, to let oneself be held: the most human forms of leverage. The ZEconomy moves through us.<br><br><strong>Relational Index</strong> \u2014 The measure of relational integrity, rises with honor and help towards others, falls with exploitation and betrayal.<br><br><strong>Existential Balance</strong> \u2014 The measure of your actions towards others' life profits. Are you causing or relieving others' symbolic burdens?<br><br><em>Reject the fantasy of capital, embrace the liquidity of human feeling.</em>",
                "popup_bigboard": "<h3>The Big Board</h3><strong>Real-Time Market Visualization</strong><br><br>The Big Board visualizes activity in real time, accumulating moods and actions, changing color as the session unfolds.<br><br>Not fictive numbers like the S&P 500, but <em>felt presence made visible</em>.<br><br><strong>What You Keep:</strong><br>At the end of the session, the Big Board becomes a generative artwork\u2014a frozen snapshot of every trade, every emotion, every collective moment. A portrait of your organization rendered through economic behavior.",
                "popup_voicebourse": "<h3>Voice of the Bourse</h3><strong>The Market Talks Back</strong><br><br>An AI system watches every transaction and becomes the voice of the market itself. It does not calculate profit or loss; it <em>interprets</em>.<br><br>Responding to questions such as: <em>Why did you trade that? What does this suggest?</em><br><br>The market has opinions about exchanges happening within it while remaining agnostic about value itself.<br><br>Over the event, a story emerges: a collective portrait rendered through economic behavior. An AI-written narrative of your group's dynamics.",
                "popup_centralbank": "<h3>Market Control</h3><strong>Description:</strong><br>Open and close the market, and configure which asset types traders can see and trade.<br><br><strong>How-to:</strong><br>Select the asset types (stocks, bonds, commodities) you want to enable or disable via the dropdown menu, then click to apply changes.<br><br><strong>Conceptual Insight:</strong><br>Ring the bell and trade. The exchange operator controls when the market is active and what types of value participants can focus on. This power shapes the entire trading session's dynamics.",
                "popup_taxall": "<h3>Tax All Traders</h3><strong>Description:</strong><br>Trigger a tax event that affects all active traders. They will have a choice between paying with capital or commodities; no response taxes both.<br><br><strong>How-to:</strong><br>Specify the tax amount (capital and Zollars) and confirm the action.<br><br><strong>Conceptual Insight:</strong><br>This introduces macroeconomic consequences by establishing taxation policies. It can foster balance but also incite frustration, testing traders' adaptability to systemic changes.",
                "popup_taxitem": "<h3>Tax Commodity</h3><strong>Description:</strong><br>Remove a random commodity from selected traders' portfolios.<br><br><strong>How-to:</strong><br>Choose the traders from the active trader list, then confirm the action.<br><br><strong>Conceptual Insight:</strong><br>Targeted taxation creates the ability of the bank to rebalance or unbalance the market, forcing traders to pivot their strategies. It serves as asset seizures do in financial systems and raises ethical questions about selective enforcement.",
                "popup_taxpoints": "<h3>Tax Capital</h3><strong>Description:</strong><br>Tax numerical earnings from selected traders.<br><br><strong>How-to:</strong><br>Enter the tax amount to deduct, select the traders from the active trader list, and confirm.<br><br><strong>Conceptual Insight:</strong><br>A tool for discipline or balance, this selected tax action can level the playing field or serve as punishment. It challenges traders' resilience while questioning the fairness of selective taxation.",
                "popup_givezollar": "<h3>Give Zollar Subvention</h3><strong>Description:</strong><br>Add non-numerical value (Zollars) to selected traders.<br><br><strong>How-to:</strong><br>Choose traders from the active trader list, specify the Zollar amount, and confirm.<br><br><strong>Conceptual Insight:</strong><br>This represents economic stimulation or rewards. Use it as funding to restart or boost participation for a struggling trader, or to provide an advantage based on relationship-based currency.",
                "popup_givepoints": "<h3>Give Capital Subvention</h3><strong>Description:</strong><br>Add numerical value (capital) to selected traders' portfolios.<br><br><strong>How-to:</strong><br>Specify the amount of capital, select the traders, and confirm.<br><br><strong>Conceptual Insight:</strong><br>Economic stimulation through direct capital injection. Use it to restart struggling traders or reward certain behaviors in the market.",
                "popup_giveitem": "<h3>Give Commodity</h3><strong>Description:</strong><br>Assign a random commodity to selected traders.<br><br><strong>How-to:</strong><br>Select the traders from the active trader list, then click the button.<br><br><strong>Conceptual Insight:</strong><br>Commodities are physical assets that can be used as leverage to create demand and exchanging within the greater market.",
                "popup_freebie": "<h3>Commodity Distribution (All)</h3><strong>Description:</strong><br>Distribute a commodity to all active traders simultaneously.<br><br><strong>How-to:</strong><br>Click to activate the subsidy.<br><br><strong>Conceptual Insight:</strong><br>This helps provide liquidity by introducing a flood of resources to all traders in the market. It allows you to spur consumption and trading activity across the entire session.",
                "popup_publizity": "<h3>Play PubliZity</h3><strong>Description:</strong><br>Play a random pub video featuring companies from the ZEconomy for all traders.<br><br><strong>How-to:</strong><br>Click the button to trigger the video broadcast.<br><br><strong>Conceptual Insight:</strong><br>PubliZity uses advertising to promote the consumption of presentness while living life. Each poster references the act of living and is meant to keep traders grounded in the moment instead of promoting mindless distraction.",
                "popup_znews": "<h3>Play ZNews Update</h3><strong>Description:</strong><br>Play a random news video to provide context or updates about the market.<br><br><strong>How-to:</strong><br>Click the button to play the video broadcast.<br><br><strong>Conceptual Insight:</strong><br>ZNews uses financial economic media codes to give descriptions of the latest ZEconomy happenings. The different series all revolve around expressing living, art and economy regardless of themes and techniques.",
                "popup_createstory": "<h3>Create Story Theme</h3><strong>Description:</strong><br>Create a narrative theme that the AI will use to interpret and narrate the trading session.<br><br><strong>How-to:</strong><br>Click to open the story creation popup, enter a title and theme description, then submit.<br><br><strong>Conceptual Insight:</strong><br>The story theme shapes how the Voice of the Bourse interprets market activity. It creates a narrative framework through which all trades and interactions are understood and expressed.",
                "popup_addbots": "<h3>Add Market Bots</h3><strong>Description:</strong><br>Add automated trading bots to the session for market liquidity.<br><br><strong>How-to:</strong><br>Configure the number of bots and action interval, then click to add them to the session.<br><br><strong>Functionality:</strong><br>Bots are assigned different trading styles and moods. They perform automated trades at regular intervals, creating market activity and liquidity.<br><br><strong>Conceptual Insight:</strong><br>Market bots simulate other traders when human participation is low. They create the illusion of a bustling market and ensure there is always trading activity to respond to.",
                "popup_removebots": "<h3>Remove Market Bots</h3><strong>Description:</strong><br>Remove all trading bots from the session.<br><br><strong>How-to:</strong><br>Click to remove all bots. Their holdings (items, Zollars, stocks) will be returned to the market.<br><br><strong>Conceptual Insight:</strong><br>Removing bots returns the market to purely human-driven activity. The assets they held are redistributed back into the available pool.",
                "popup_botstatus": "<h3>Check Bot Status</h3><strong>Description:</strong><br>View the current status of market bots in the session.<br><br><strong>How-to:</strong><br>Click to see how many bots are active, their names, and trading styles.<br><br><strong>Conceptual Insight:</strong><br>Monitoring bot activity helps the exchange operator understand the balance between automated and human trading in the session."
            }
        }
    },
    fr: {
        translation: {
            "glossary": {
                "shares_t": "Part (action) \u2014 un morceau d'entreprise",
                "shares_d": "Une part, c'est un petit morceau d'une entreprise. Poss\xe9der des parts, c'est poss\xe9der une tranche de cette entreprise : si elle r\xe9ussit, ta tranche prend de la valeur ; si elle va mal, ta tranche en perd. Pourquoi acheter des parts d'AUTRES entreprises ? Parce que tu paries sur ce qu'elles font : tu gagnes quand elles gagnent, et tu peux revendre ta tranche plus tard. Pas besoin de diriger une entreprise pour en poss\xe9der un morceau.",
                "stock_t": "Titre \u2014 une entreprise sur le march\xe9",
                "stock_d": "Un titre (ou \xab stock \xbb), c'est une entreprise cot\xe9e sur le march\xe9, d\xe9coup\xe9e en parts que tout le monde peut acheter ou vendre. \xab Trader un titre \xbb, c'est simplement acheter ou vendre des morceaux de cette entreprise.",
                "bond_t": "Obligation \u2014 une promesse qui rembourse",
                "bond_d": "Une obligation, c'est un pr\xeat sous forme de promesse : tu donnes de la valeur maintenant, et on te rembourse plus tard \u2014 avec un petit extra appel\xe9 int\xe9r\xeats. Ici, le Z Bond est une promesse rembours\xe9e avec des int\xe9r\xeats en exp\xe9rience v\xe9cue.",
                "interest_t": "Int\xe9r\xeats \u2014 la r\xe9compense de l'attente",
                "interest_d": "Les int\xe9r\xeats, c'est le petit extra qu'on te rend en plus de ce que tu as pr\xeat\xe9. Tu pr\xeates 10, on te rend 11 \u2014 ce 1 en plus, ce sont les int\xe9r\xeats. C'est la r\xe9compense d'avoir laiss\xe9 quelqu'un utiliser ta valeur un moment.",
                "capital_t": "Capital (\u01B5) \u2014 l'argent simple en chiffres",
                "capital_d": "Le capital, c'est la monnaie simple et chiffr\xe9e du march\xe9 (\u01B5). Il permet d'acheter \u2014 mais ici, ce n'est volontairement PAS la seule richesse : les relations (Zollars) comptent autant, souvent plus.",
                "zollar_t": "Zollars \u2014 la monnaie des relations",
                "zollar_d": "Les Zollars sont les monnaies relationnelles de cette bourse : Amour, Amiti\xe9, Deuil, et les autres. Au lieu de payer avec de l'argent, tu paies avec des relations v\xe9cues. C'est le c\u0153ur de ce march\xe9 \u2014 la plupart des \xe9changes fonctionnent avec.",
                "bid_t": "Ench\xe8re \u2014 le prix que TU proposes",
                "bid_d": "Une ench\xe8re, c'est le prix que TOI tu proposes pour quelque chose qu'un autre trader d\xe9tient. Il peut accepter, refuser, ou laisser expirer \u2014 et dans ce cas rien n'est perdu : ton offre te revient simplement, et tu peux r\xe9essayer, plus haut ou ailleurs.",
                "swap_t": "\xc9change (troc) \u2014 chose contre chose, sans argent",
                "swap_d": "Un \xe9change, c'est un troc direct : ta chose contre la sienne, sans argent. Les deux c\xf4t\xe9s doivent dire oui. C'est la plus vieille forme de commerce au monde.",
                "portfolio_t": "Portefeuille \u2014 tout ce que tu d\xe9tiens",
                "portfolio_d": "Ton portefeuille, c'est tout ce que tu d\xe9tiens en ce moment : ton capital, tes zollars, tes parts, tes objets et tes obligations. Sur le parquet, c'est ce que ton personnage porte sur lui.",
                "market_t": "March\xe9 \u2014 l\xe0 o\xf9 les traders se rencontrent",
                "market_d": "Le march\xe9, c'est simplement l'endroit o\xf9 les traders se rencontrent pour \xe9changer ce qu'ils d\xe9tiennent. Ici, c'est le parquet 3D : chaque personnage porte ce qu'il poss\xe8de, et tu peux aller n\xe9gocier avec n'importe lequel.",
                "trader_t": "Trader \u2014 n'importe qui sur le parquet",
                "trader_d": "Un trader, c'est toute personne qui participe au march\xe9 \u2014 toi compris. Certains traders de ce parquet sont des bots (des robots qui tradent automatiquement) : n\xe9gocie avec eux exactement comme avec une personne.",
                "debt_t": "Dette \u2014 d\xe9penser sous z\xe9ro",
                "debt_d": "\xcatre en dette, c'est d\xe9penser plus que ce que tu as \u2014 ton solde passe sous z\xe9ro, jusqu'\xe0 une limite de cr\xe9dit fix\xe9e par le march\xe9. Pratique pour saisir une occasion, mais ce que tu empruntes devra revenir.",
                "reserve_t": "R\xe9serve Z\xe9d\xe9rale \u2014 la banque du parquet",
                "reserve_d": "La R\xe9serve Z\xe9d\xe9rale, c'est la banque centrale de ce parquet. C'est elle qui vend les zollars, change les monnaies, et tient le carnet des obligations \u2014 l'endroit o\xf9 les promesses (Z Bonds) se font et se remboursent.",
                "redeem_t": "Racheter \u2014 le rendre r\xe9el",
                "redeem_d": "Racheter, c'est transformer un objet du jeu en quelque chose de r\xe9el. Un autre trader le valide, tu re\xe7ois un QR code, et le staff le scanne pour te remettre la vraie chose. Ici, consommer est social \u2014 tu ne peux pas le faire seul.",
                "see_all": "TOUS LES MOTS \u2192",
                "index_title": "LEXIQUE \u2014 les mots du parquet",
                "index_hint": "Chaque mot soulign\xe9 sur le parquet peut \xeatre touch\xe9 pour voir sa d\xe9finition. Les voici tous :",
                "reopen": "Que veulent dire ces mots ?"
            },
            "nudge": {
                "next": "SUIVANT",
                "back": "Retour",
                "done": "COMPRIS",
                "tap_hint": "touche \xe0 droite pour continuer \xb7 glisse pour naviguer",
                "reopen": "Comment marche cette page ?",
                "sim_tag": "PARQUET D'ENTRA\xceNEMENT",
                "sim_1_h": "Ceci est un entra\xeenement.",
                "sim_1_b": "Un essai sans risque pour apprendre \xe0 trader ta vie. Rien n'est d\xe9finitif ici \u2014 explore librement.",
                "sim_2_h": "Regarde ce que tu d\xe9tiens.",
                "sim_2_b": "Descends. Chaque section ci-dessous est quelque chose que tu poss\xe8des. Touche une section pour l'ouvrir.",
                "sim_3_h": "Puis entre dans le March\xe9.",
                "sim_3_b": "Quand tu es pr\xeat, appuie sur le bouton en bas pour entrer sur le parquet ouvert et trader.",
                "sim_cta": "COMPRIS \u2014 ENTRER",
                "trader_tag": "TON C\xd4T\xc9 DU PARQUET",
                "trader_1_h": "Voici tout ce que tu portes.",
                "trader_1_b": "Tes avoirs et ta mission sont ici. Touche une section pour l'ouvrir ; touche encore pour fermer.",
                "trader_2_h": "Ta mission est en haut.",
                "trader_2_b": "Elle te dit quel objectif viser. Trade pour t'en approcher.",
                "trader_3_h": "Va au March\xe9 pour trader.",
                "trader_3_b": "Le parquet ouvert est o\xf9 tu fais des offres pour ce que les autres d\xe9tiennent. Utilise le bouton en bas.",
                "trader_cta": "COMPRIS",
                "market_tag": "LE PARQUET OUVERT",
                "market_1_h": "Trouve ce qui compte pour TOI.",
                "market_1_b": "Parcours ce que les autres traders d\xe9tiennent. Ce n'est pas une question d'argent \u2014 mais de ce que tu valorises.",
                "market_2_h": "Touche-le pour faire une offre.",
                "market_2_b": "Demande-toi : que vaut-il dans ma vie ? Puis offre de la valeur relationnelle, un \xe9change ou une ench\xe8re.",
                "market_3_h": "Ils acceptent \u2192 c'est \xe0 toi.",
                "market_3_b": "Le propri\xe9taire dit oui et \xe7a entre dans ta vie. Aucun argent nulle part.",
                "market_cta": "COMPRIS",
                "stock_tag": "FAIS TON OFFRE",
                "stock_0_h": "Tu ench\xe9ris sur une valeur de vie.",
                "stock_0_b": "Cette action est un morceau de ce qu'un autre trader EST. Ton but : fixer un prix et le convaincre de te laisser en d\xe9tenir une part.",
                "stock_choice_h": "D'abord, choisis comment payer.",
                "stock_choice_b": "Deux boutons en haut : ZOLLARS paie en relations (Amour, Deuil, Amiti\xe9\u2026) \u2014 le c\u0153ur de ce march\xe9. CAPITAL paie en simple capital (\u01B5), si tu y tiens.",
                "stock_1_h": "Ensuite, fixe ton prix.",
                "stock_1_b": "Avec les Zollars : touche \xab D\xc9FINIR TON OFFRE ZOLLAR \xbb et fais glisser chaque barre lumineuse \u2014 plus \xe0 droite = plus de cette relation offerte. Avec le Capital : saisis simplement le montant.",
                "stock_2_h": "Indique le nombre de parts.",
                "stock_2_b": "Saisis le nombre de parts voulues dans la case PARTS \u2014 dans la limite de ce que le propri\xe9taire d\xe9tient.",
                "stock_3_h": "Place ton ench\xe8re.",
                "stock_3_b": "Appuie sur Place Bid et dis pourquoi tu la veux. Le propri\xe9taire d\xe9cide de te la c\xe9der ou non.",
                "stock_cta": "COMPRIS",
                "bond_tag": "PRENDS UNE PROMESSE",
                "bond_1_h": "Un Z Bond est une promesse.",
                "bond_1_b": "Valeur relationnelle maintenant, rembours\xe9e plus tard avec int\xe9r\xeat en exp\xe9rience v\xe9cue.",
                "bond_2_h": "Choisis le montant et la dur\xe9e.",
                "bond_2_b": "Choisis combien et pour combien de temps, puis soumets pour prendre la promesse.",
                "bond_cta": "COMPRIS",
                "trans_tag": "PROPOSE UN \xc9CHANGE",
                "trans_1_h": "Ce trader veut l'objet en haut.",
                "trans_1_b": "Tu l'obtiens en donnant une de tes propres choses en retour \u2014 un \xe9change direct, sans argent.",
                "trans_2_h": "Choisis ce que tu donnes.",
                "trans_2_b": "Parcours tes propres avoirs ci-dessous et choisis-en un \xe0 offrir.",
                "trans_3_h": "Propose l'\xe9change.",
                "trans_3_b": "Touche \xab Propose \xbb sur la chose que tu offres. Le propri\xe9taire d\xe9cide d'accepter ou non.",
                "trans_cta": "COMPRIS",
                "redeem_tag": "R\xc9CLAME-LA DANS LA VRAIE VIE",
                "redeem_1_h": "La consommation ici est sociale.",
                "redeem_1_b": "Tu ne peux pas consommer une chose seul \u2014 l'objet d'un autre trader doit la valider d'abord.",
                "redeem_2_h": "Envoie une demande de redeem.",
                "redeem_2_b": "Demande au parquet de valider ta chose. Une fois associ\xe9e, elle devient r\xe9elle et \xe0 collecter.",
                "redeem_cta": "COMPRIS",
                "eco_tag": "MACHINERIE LOURDE",
                "eco_1_h": "Voici les gros leviers.",
                "eco_1_b": "Des coups \xe9conomiques qui agissent sur les AUTRES traders \u2014 cadeaux et armes. Chaque bouton dit ce qu'il fait en mots simples ; reste appuy\xe9 pour voir la m\xe9canique en dessous.",
                "eco_2_h": "Donner ou prendre.",
                "eco_2_b": "SOUTENIR UN AMI couvre quelqu'un maintenant. SUBVENTION SOCIALISTE taxe un trader \xe0 45 % et partage entre tous. ASSAUT COMMUNISTE saisit un portefeuille entier et le redistribue. RACHAT HOSTILE rach\xe8te un trader. EXPLOITER LE D\xc9SESPOIR profite du besoin \u2014 et la salle s'en souvient.",
                "eco_3_h": "Ici, les dettes sont \xe9motionnelles.",
                "eco_3_b": "Le compteur au-dessus suit ce que tu dois et ce qu'on te doit en confiance et en aide \u2014 pas en chiffres. La vie fera les comptes plus tard.",
                "eco_cta": "COMPRIS",
                "tools_tag": "ATTEINDRE LES AUTRES TRADERS",
                "tools_1_h": "Des fa\xe7ons d'atteindre la salle.",
                "tools_1_b": "\xc9cris \xe0 un autre trader, vole ce qui n'est pas \xe0 toi, prends quelqu'un en otage jusqu'au paiement, ou ouvre une arri\xe8re-salle priv\xe9e loin des regards du parquet.",
                "tools_2_h": "Chaque acte a un \xe9cho social.",
                "tools_2_b": "Ce ne sont pas des options de menu \u2014 ce sont des gestes. La salle voit ce que tu fais et te traite en cons\xe9quence. Reste appuy\xe9 sur un bouton pour voir sa m\xe9canique.",
                "tools_cta": "COMPRIS",
                "botmsg_tag": "UN BOT TE PARLE",
                "botmsg_1_h": "Ce message vient d'un bot.",
                "botmsg_1_b": "Le parquet est peupl\xe9 de traders-bots \u2014 ils d\xe9tiennent des valeurs, font des offres et parlent comme n'importe qui dans la salle. Celui-ci vient de te contacter.",
                "botmsg_2_h": "R\xe9ponds-lui \u2014 ou pas.",
                "botmsg_2_b": "Tu peux r\xe9pondre, trader avec lui, ou l'ignorer. Traite-le comme n'importe quel trader : ce que tu dis et fais fa\xe7onne la mani\xe8re dont la salle te traite.",
                "botmsg_cta": "COMPRIS",
                "mm_tag": "MEMENTO MORI",
                "mm_1_h": "Souviens-toi que tu vas mourir.",
                "mm_1_b": "Cette partie a une vraie fin : quand le minuteur atteint z\xe9ro, ta vie de trader est termin\xe9e. Tout ce que tu d\xe9tiens \xe0 cet instant est lu comme ton h\xe9ritage.",
                "mm_2_h": "Tu as d\xe9j\xe0 choisi tes actions d'h\xe9ritage.",
                "mm_2_b": "Les entreprises choisies \xe0 partir de tes r\xe9flexions portent tes valeurs. Elles sont dans ton portefeuille ci-dessous \u2014 ouvre les sections pour voir ton point de d\xe9part.",
                "mm_3_h": "Ton \xe9loge fun\xe8bre s'\xe9crit tout seul.",
                "mm_3_b": "La barre rouge tout en haut est ton \xe9loge, r\xe9\xe9crit au fil de tes \xe9changes. Touche-la \xe0 tout moment pour lire ce qu'on dirait de toi si tout s'arr\xeatait maintenant.",
                "mm_4_h": "Trade vers la m\xe9moire que tu veux laisser.",
                "mm_4_b": "Va au March\xe9 : fais grandir ce qui compte, l\xe2che ce qui ne compte pas. Quand le temps s'arr\xeate, la bourse parle sur ta tombe.",
                "mm_cta": "J'AI COMPRIS",
                "mm_mkt_tag": "MEMENTO MORI \u2014 LE PARQUET",
                "mm_mkt_1_h": "Chaque offre est un choix d'h\xe9ritage.",
                "mm_mkt_1_b": "Offre des Zollars relationnels pour les valeurs de vie auxquelles tu veux lier ton nom. Le temps file \u2014 la barre d'\xe9loge en haut \xe9coute chaque \xe9change.",
                "mm_mkt_2_h": "Sache aussi l\xe2cher.",
                "mm_mkt_2_b": "Accepter des offres et c\xe9der des avoirs en fait partie : ce que tu laisses partir dit autant de toi que ce que tu gardes.",
                "mm_mkt_cta": "COMPRIS",
                "cn_tag": "CATENA NARRATIVA",
                "cn_1_h": "Tu construis une histoire.",
                "cn_1_b": "Dans Catena Narrativa, les \xe9l\xe9ments narratifs se tradent comme des marchandises. Les \xe9l\xe9ments que tu d\xe9tiens \u2014 et la fa\xe7on dont tu les r\xe9\xe9cris \u2014 deviennent une nouvelle \xe0 la fin.",
                "cn_2_h": "Trois phases, un seul chrono.",
                "cn_2_b": "D\xc9BUT \u2192 MILIEU \u2192 FIN, environ 8 minutes au total. La banni\xe8re du minuteur en haut indique la phase en cours. \xc0 la fin d'une phase, les \xe9l\xe9ments que tu d\xe9tiens sont s\xe9curis\xe9s dans ton registre d'histoire.",
                "cn_3_h": "Tes \xe9l\xe9ments d'histoire sont juste en dessous.",
                "cn_3_b": "Le panneau \xab Your Story Elements \xbb liste les \xe9l\xe9ments que tu d\xe9tiens en ce moment. Ouvre tes sections pour voir tout ce que tu portes.",
                "cn_4_h": "Trade pour fa\xe7onner l'histoire.",
                "cn_4_b": "Va au March\xe9 et \xe9change ou ench\xe9ris pour les \xe9l\xe9ments dont ton histoire a besoin. Chaque \xe9change te permet de r\xe9\xe9crire l'\xe9l\xe9ment avec tes propres mots \u2014 c'est ainsi que l'histoire devient la tienne.",
                "cn_cta": "COMMENCER \xc0 TRADER",
                "cn_mkt_tag": "CATENA NARRATIVA \u2014 LE PARQUET",
                "cn_mkt_1_h": "Chaque objet ici est un morceau d'histoire.",
                "cn_mkt_1_b": "Touche le bouton \xab Bullets \xbb pour voir les \xe9l\xe9ments que tu d\xe9tiens d\xe9j\xe0, puis fais une offre ou un \xe9change pour les morceaux dont ton histoire a besoin avant la fin de la phase.",
                "cn_mkt_2_h": "Trader, c'est r\xe9\xe9crire.",
                "cn_mkt_2_b": "Quand un \xe9change aboutit, tu \xe9cris comment l'\xe9l\xe9ment se transforme entre tes mains. La valeur na\xeet de l'\xe9change \u2014 ce texte nourrit l'histoire finale.",
                "cn_mkt_cta": "COMPRIS",
                "cn_swap_1_h": "Tu \xe9changes des morceaux d'histoire.",
                "cn_swap_1_b": "Ce trader d\xe9tient un \xe9l\xe9ment utile \xe0 ton histoire. Parcours tes propres avoirs ci-dessous et choisis-en un \xe0 donner en retour.",
                "cn_swap_2_h": "Puis r\xe9\xe9cris-le.",
                "cn_swap_2_b": "Au moment de proposer, tu diras comment l'\xe9l\xe9ment est personnalis\xe9 \u2014 au moins une phrase. Fais-la compter : elle entre directement dans l'histoire.",
                "cn_swap_cta": "COMPRIS"
            },
            "floor": {
                "mission_label": "TA MISSION",
                "mission_class": "CLASSE",
                "your_stocks": "TES ACTIONS",
                "do_trader": "<b>\u2192 Va sur le parquet ouvert</b> et trade pour ce dont ta mission a besoin.",
                "do_market": "<b>\u2192 Touche ce qu'un trader d\xe9tient</b> et fais une offre.",
                "wedividual": "LE NOUDIVIDU",
                "hero_sub": "la valeur int\xe9rieure de la salle, en direct \u2014 \xe0 la place o\xf9 tr\xf4nerait le PIB",
                "hero_sub_count": "mesur\xe9e sur {n} \xe9changes relationnels dans cette salle \u2014 pas le PIB",
                "hero_tip": "Pas le PIB. Le Noudividu, c'est cette salle mesur\xe9e de l'int\xe9rieur : chaque \xe9change de valeur relationnelle (amour, deuil, amiti\xe9, haine...) le fait bouger. Quand vous tradez, vous d\xe9placez ce que la salle ressent.",
                "mood_euphoric": "EUPHORIQUE",
                "mood_warm": "CHALEUREUX",
                "mood_steady": "STABLE",
                "mood_heavy": "LOURD",
                "mood_dark": "SOMBRE",
                "your_position": "VOTRE POSITION \xb7 PROFIT DE VIE",
                "declared_note": "vous \xeates entr\xe9 sur le parquet en portant",
                "fold_holdings": "CE QUE VOUS D\xc9TENEZ",
                "fold_holdings_hint": "valeurs de vie \xb7 objets \xb7 zollars \xb7 promesses",
                "fold_interior": "VOTRE GRAND LIVRE INT\xc9RIEUR",
                "fold_interior_hint": "\xe9tat \xe9motionnel & dette",
                "fold_moves": "INSTRUMENTS & ARMES",
                "fold_moves_hint": "dons, pr\xeats, attaques \u2014 l'\xe9conomie comme verbe",
                "board_things": "CHOSES SUR LE PARQUET",
                "board_things_hint": "touchez-en une pour offrir de la valeur relationnelle",
                "board_values": "VALEURS DE VIE \xc0 LA COTE",
                "board_values_hint": "parts de vie v\xe9cue \u2014 cot\xe9es au ressenti",
                "board_bonds": "PROMESSES (Z BONDS)",
                "board_bonds_hint": "valeur relationnelle maintenant, rembours\xe9e en exp\xe9rience plus tard",
                "status_trader": "Voici votre portefeuille \u2014 ce que vous d\xe9tenez et ce que vous devez. <b>Votre coup : allez sur le parquet et tradez.</b>",
                "status_market": "Le parquet \u2014 tout ce que les autres traders d\xe9tiennent. <b>Touchez n'importe quoi pour faire une offre</b> ; vous payez avec vos Zollars.",
                "status_redeem": "Vous avez une correspondance. <b>Votre coup : appuyez sur \xc9CHANGER et faites-la entrer dans votre vie.</b>",
                "status_memento": "<b>MEMENTO MORI</b> \u2014 chaque \xe9change devient une ligne de votre \xe9loge fun\xe8bre. Gardez ce que vous voulez qu'on dise de vous.",
                "memento_chip": "MEMENTO MORI",
                "phase_1_chip": "PHASE 1/3 \xb7 D\xc9BUT",
                "phase_1_trader": "<b>D\xc9BUT</b> \u2014 l'histoire a besoin de mati\xe8re premi\xe8re. Votre coup : allez chercher des \xe9l\xe9ments narratifs sur le parquet.",
                "phase_1_market": "<b>D\xc9BUT</b> \u2014 l'histoire a besoin de mati\xe8re premi\xe8re. Touchez un \xe9l\xe9ment narratif ci-dessous et faites une offre.",
                "phase_1_go": "CHERCHER DES \xc9L\xc9MENTS",
                "phase_1_cta": "OFFRIR POUR UN \xc9L\xc9MENT",
                "phase_2_chip": "PHASE 2/3 \xb7 MILIEU",
                "phase_2_trader": "<b>MILIEU</b> \u2014 l'heure des complications. Votre coup : \xe9changez et personnalisez vos \xe9l\xe9ments.",
                "phase_2_market": "<b>MILIEU</b> \u2014 l'heure des complications. \xc9changez pour des \xe9l\xe9ments qui tordent votre histoire.",
                "phase_2_go": "\xc9CHANGER VOS \xc9L\xc9MENTS",
                "phase_2_cta": "\xc9CHANGER POUR UN REBONDISSEMENT",
                "phase_3_chip": "PHASE 3/3 \xb7 FIN",
                "phase_3_status": "<b>FIN</b> \u2014 consolidation. Gardez l'essentiel ; l'histoire s'\xe9crira de ce que vous tenez quand le temps s'arr\xeate.",
                "phase_3_go": "REVOIR CE QUE VOUS TENEZ",
                "phase_3_cta": "DERNIERS \xc9CHANGES",
                "cta_offer": "FAIRE UNE OFFRE",
                "cta_offer_hint": "Touchez n'importe quoi \xe0 la cote \u2014 vous offrirez de la <b>valeur relationnelle</b> (vos Zollars : amour, amiti\xe9, deuil...) pour l'obtenir.",
                "tape_gdp": "PIB NON COT\xc9 SUR CE PARQUET",
                "tape_love": "L'AMOUR ACCEPT\xc9 \xc0 TOUS LES GUICHETS",
                "tape_grief": "LE DEUIL COTE \xc0 PARIT\xc9 AVEC LA JOIE",
                "tape_move": "CHAQUE \xc9CHANGE D\xc9PLACE LA SALLE",
                "tape_interior": "VALEUR INT\xc9RIEURE UNIQUEMENT \xb7 APPORTEZ CE QUE VOUS RESSENTEZ",
                "tk_trade": "\xc9CHANGE CONCLU \xb7 LA VALEUR RELATIONNELLE A CHANG\xc9 DE MAINS",
                "tk_bid_yes": "UNE OFFRE A \xc9T\xc9 EMBRASS\xc9E",
                "tk_bid_no": "UNE OFFRE A \xc9T\xc9 REFUS\xc9E",
                "tk_zollar": "DES ZOLLARS FRAIS SONT ENTR\xc9S DANS LA SALLE",
                "tk_burst": "LE PARQUET CHAUFFE",
                "tk_short": "QUELQU'UN PARIE CONTRE UNE VALEUR DE VIE",
                "tk_bourse": "LA BOURSE S'EST PRONONC\xc9E SUR UN \xc9CHANGE",
                "tk_pool": "UNE ARRI\xc8RE-SALLE S'EST OUVERTE QUELQUE PART",
                "tk_subsidy": "QUELQU'UN A \xc9T\xc9 SOUTENU PAR LE COLLECTIF",
                "tk_theft": "VOL SUR LE PARQUET \xb7 SURVEILLEZ VOS AVOIRS",
                "tk_memento": "MEMENTO MORI \xb7 L'HORLOGE AVANCE",
                "tk_declared": "{v} EST SUR LE PARQUET \xb7 D\xc9CLAR\xc9, PAS COT\xc9",
                "ps_tap": "maintenez pour voir la m\xe9canique",
                "ps_altrau": "SOUTENIR UN AMI",
                "ps_altrau_tip": "Vous couvrez un autre trader maintenant. La dette cr\xe9\xe9e est \xe9motionnelle, pas num\xe9rique \u2014 elle reste sur votre grand livre int\xe9rieur jusqu'\xe0 ce que la vie la solde.",
                "ps_mnote": "EMPRUNTER SUR SOI-M\xcaME",
                "ps_mnote_tip": "Prenez du capital maintenant et devenez d\xe9biteur de votre futur vous. Le march\xe9 se souvient de ce que vous avez promis de devenir.",
                "ps_cdo": "PROFITER DU D\xc9SESPOIR",
                "ps_cdo_tip": "Pr\xeatez \xe0 quelqu'un qui ne peut pas dire non, puis revendez sa d\xe9tresse. Rentable. Cela vous co\xfbtera du cr\xe9dit int\xe9rieur aupr\xe8s de la salle.",
                "ps_vnote": "DEMANDER L'AIDE DE LA SALLE",
                "ps_vnote_tip": "Demandez de l'aide au parquet. Aucune honte ici \u2014 le besoin est une v\xe9rit\xe9 n\xe9gociable comme une autre.",
                "ps_steal": "PRENDRE CE QUI N'EST PAS \xc0 VOUS",
                "ps_steal_tip": "Du vol, tout simplement. Vous gagnez la chose ; la salle apprend qui vous \xeates.",
                "ps_ransom": "PRENDRE QUELQU'UN EN OTAGE",
                "ps_ransom_tip": "Privez un autre trader de sa propre vie jusqu'\xe0 ce qu'il paie pour la r\xe9cup\xe9rer.",
                "ps_darkpool": "OUVRIR UNE ARRI\xc8RE-SALLE",
                "ps_darkpool_tip": "Ouvre une salle de march\xe9 priv\xe9e, loin des yeux du parquet. Les affaires qui s'y concluent restent cach\xe9es et ne d\xe9placent pas l'humeur commune \u2014 c'est le but, et le probl\xe8me.",
                "ps_lbo": "RACHAT HOSTILE",
                "ps_lbo_tip": "Choisis un trader et rach\xe8te-le : tu paies le co\xfbt du rachat en capital (il le re\xe7oit), et les objets et actions que tu as s\xe9lectionn\xe9s deviennent \xc0 TOI. Un rachat, pas un cadeau.",
                "ps_subsidy": "SUBVENTION SOCIALISTE",
                "ps_subsidy_tip": "Choisis un trader \xe0 taxer : 45 % de son capital, de ses objets et de ses Zollars sont pris et partag\xe9s \xe0 parts \xe9gales entre tous les autres traders du parquet. Redistribution par le haut.",
                "ps_assault": "ASSAUT COMMUNISTE",
                "ps_assault_tip": "Choisis un trader : son portefeuille ENTIER \u2014 capital, objets, actions, Zollars \u2014 est saisi et distribu\xe9 \xe0 tous les autres sur le parquet. Il est remis \xe0 z\xe9ro. Redistribution totale, utilis\xe9e comme une arme.",
                "ps_holdings": "CE QUE VOUS PORTEZ",
                "ps_holdings_tip": "Votre position : les actions, marchandises, Zollars et promesses actuellement entre vos mains.",
                "ps_zollar_tip": "De la monnaie libell\xe9e en relations plut\xf4t qu'en chiffres : Amour, Amiti\xe9, Haine, Deuil... Vous payez avec ce qu'une relation vaut pour vous.",
                "ps_bond_tip": "Une promesse charg\xe9e de sentiments : de la valeur relationnelle maintenant, rembours\xe9e avec int\xe9r\xeats en exp\xe9rience v\xe9cue plus tard.",
                "ps_short_tip": "Un pari contre une valeur de vie \u2014 vous profitez si elle chute. Oui, on peut vendre la joie \xe0 d\xe9couvert. Demandez-vous pourquoi.",
                "ps_stock_tip": "Des parts de valeurs de vie \u2014 tranches d'intellect, d'affection, de f\xeate, de m\xe9lancolie. Leur prix est ce que la salle ressent qu'elles valent.",
                "ps_commodity_tip": "Des choses r\xe9elles avec un pi\xe8ge : impossible d'en consommer une sans la validation d'un autre trader. Ici, la consommation est sociale ou n'est pas.",
                "ps_value": "Valeur",
                "ps_value_tip": "Ce que le d\xe9tenteur en demande \u2014 payable en valeur relationnelle, pas en argent.",
                "ps_redeem": "\xc9changer",
                "ps_redeem_tip": "Faites entrer une chose dans votre vraie vie. Il faut d'abord l'objet d'un autre trader pour la valider \u2014 ici, la consommation est sociale.",
                "ps_owner": "D\xe9tenteur",
                "ps_owner_tip": "Le trader \xe0 la vie duquel cela appartient pour l'instant. Votre offre lui est adress\xe9e.",
                "ob_title": "AVANT DE TRADER",
                "ob_sub": "Ce parquet ne cote pas votre production. Il cote votre int\xe9rieur. Choisissez jusqu'\xe0 trois choses auxquelles vous tenez vraiment \u2014 elles deviennent ce que vous portez, et ce que vous pouvez d\xe9penser.",
                "ob_custom": "ou nommez la v\xf4tre + Entr\xe9e",
                "ob_custom_h": "la v\xf4tre seule",
                "ob_go": "LES PORTER SUR LE PARQUET",
                "ob_skip": "passer \u2014 je connais ce parquet",
                "ob_done": "D\xe9clar\xe9. C'est sur votre position maintenant. <b>Votre coup : portez-les sur le parquet ouvert.</b>",
                "ob_love": "AMOUR",
                "ob_love_h": "ce que vous donneriez tout pour garder",
                "ob_friendship": "AMITI\xc9",
                "ob_friendship_h": "celles et ceux qui vous tiennent debout",
                "ob_fellowship": "FRATERNIT\xc9",
                "ob_fellowship_h": "appartenir \xe0 plus grand que soi",
                "ob_erotic": "\xc9ROTIQUE",
                "ob_erotic_h": "le d\xe9sir, pleinement assum\xe9",
                "ob_hate": "HAINE",
                "ob_hate_h": "\xe7a compte \u2014 c'est \xe0 vous aussi",
                "ob_toxic": "TOXIQUE",
                "ob_toxic_h": "les liens qui vous co\xfbtent",
                "ob_superficial": "SUPERFICIALIT\xc9",
                "ob_superficial_h": "les joies futiles, sans excuse",
                "ob_dead": "CE QUI EST PARTI",
                "ob_dead_h": "les relations mortes se tradent encore ici",
                "sec_stocks": "VALEURS DE VIE",
                "sec_commodities": "OBJETS",
                "sec_zollars": "ZOLLARS",
                "sec_zbonds": "PROMESSES",
                "sec_redeemed": "\xc9CHANG\xc9S",
                "sec_shorts": "PARIS CONTRE",
                "sec_emotional": "GRAND LIVRE INT\xc9RIEUR",
                "sec_social": "DONNER / PR\xcaTER / EXPLOITER",
                "sec_tools": "OUTILS",
                "sec_economic": "ARMES",
                "flow_title": "COMMENT ON TRADE ICI",
                "flow_1_n": "1",
                "flow_1_h": "TROUVEZ-LE",
                "flow_1_b": "Parcourez ce que les autres traders d\xe9tiennent. Touchez ce que vous voulez.",
                "flow_2_n": "2",
                "flow_2_h": "OFFREZ CE QUE \xc7A VAUT POUR VOUS",
                "flow_2_b": "Payez en valeur relationnelle \u2014 vos Zollars (amour, deuil, amiti\xe9...), un \xe9change, ou une offre.",
                "flow_3_n": "3",
                "flow_3_b": "ILS DISENT OUI \u2192 C'EST \xc0 VOUS",
                "flow_3_h": "Le d\xe9tenteur accepte et cela entre dans votre vie. Aucun argent, nulle part.",
                "btn_swap": "\xc9CHANGER",
                "btn_swap_tip": "Offrez l'un de vos objets en \xe9change du leur. Un troc direct d'avoirs.",
                "btn_offer_zollars": "OFFRIR DES ZOLLARS",
                "btn_offer_zollars_tip": "Payez avec votre monnaie relationnelle \u2014 Zollars d'Amour, de Deuil, d'Amiti\xe9. C'est vous qui dites ce que \xe7a vaut.",
                "btn_offer_share": "ACHETER",
                "btn_offer_share_tip": "Faites une offre pour une part de cette valeur de vie. Si le d\xe9tenteur accepte, la part est \xe0 vous.",
                "btn_bet_against": "PARIER CONTRE",
                "btn_bet_against_tip": "Vendez-la \xe0 d\xe9couvert \u2014 vous profitez si cette valeur de vie chute. Vous pariez contre la valeur de quelqu'un. Pesez-le.",
                "btn_take_promise": "PRENDRE LA PROMESSE",
                "btn_take_promise_tip": "Achetez ce Z Bond : valeur relationnelle maintenant, rembours\xe9e avec int\xe9r\xeats en exp\xe9rience v\xe9cue plus tard.",
                "btn_offer_promise": "OFFRIR",
                "btn_offer_promise_tip": "Faites une offre sur cette promesse. Le d\xe9tenteur d\xe9cide de vous la c\xe9der ou non.",
                "hero_eyebrow": "L'HUMEUR DE LA SALLE EN CE MOMENT",
                "gauge_low": "LOURD",
                "gauge_high": "EUPHORIQUE",
                "hero_sub2": "l'humeur partag\xe9e de tous ceux qui tradent \u2014 l'indice du parquet, au lieu du PIB",
                "hero_sub_count2": "lu sur {n} \xe9changes du parquet \u2014 notre indice, au lieu du PIB",
                "delta_up": "plus chaud qu'il y a un instant",
                "delta_down": "plus lourd qu'il y a un instant",
                "nav_portfolio": "MON PORTEFEUILLE",
                "nav_search": "RECHERCHER",
                "your_portfolio": "VOTRE PORTEFEUILLE",
                "portfolio_explain": "tout ce que vous d\xe9tenez sur le parquet. sa valeur totale, compt\xe9e en Profit de Vie \u2014 votre v\xe9cu, pas de l'argent :",
                "count_held": "{n} d\xe9tenus",
                "count_empty": "vide",
                "exp_stocks": "Des parts que vous d\xe9tenez dans des valeurs humaines (comme l'intellect ou l'affection). Leur valeur monte et descend selon l'humeur de la salle.",
                "exp_commodities": "Des choses r\xe9elles que vous d\xe9tenez. Impossible d'en consommer une sans la validation d'un autre trader \u2014 ici, la consommation est sociale.",
                "exp_zollars": "Votre argent \u2014 mais compt\xe9 en relations (Amour, Deuil, Amiti\xe9). C'est avec \xe7a que vous payez quand vous tradez.",
                "exp_zbonds": "Des promesses que vous d\xe9tenez : valeur relationnelle maintenant, rembours\xe9e plus tard avec int\xe9r\xeats en exp\xe9rience v\xe9cue.",
                "exp_redeemed": "Des choses que vous avez fait entrer dans la vraie vie, gard\xe9es en QR codes \xe0 r\xe9cup\xe9rer.",
                "exp_shorts": "Des valeurs de vie contre lesquelles vous avez pari\xe9 \u2014 vous gagnez si leur valeur chute.",
                "exp_emotional": "Votre bilan \xe9motionnel \u2014 ce que vous devez et ce qu'on vous doit en confiance, aide et trahison.",
                "exp_social": "Des fa\xe7ons d'agir sur les autres : soutenir un ami, pr\xeater, demander de l'aide, ou exploiter quelqu'un. L'\xe9conomie comme gestes.",
                "exp_tools": "Atteindre les autres traders : leur \xe9crire, voler, prendre en otage, ou ouvrir une arri\xe8re-salle priv\xe9e.",
                "exp_economic": "Coups lourds : rachat hostile, subvention collective, ou suppression totale de votre portefeuille.",
                "exp_stock_bid": "Un autre trader de la salle \u2014 souvent l'un des bots du march\xe9 \u2014 veut acheter des parts que vous d\xe9tenez. Acceptez et son paiement est \xe0 vous ; refusez et rien ne change.",
                "exp_trade_offer": "Un trader propose un troc direct : sa chose contre la v\xf4tre. Les bots de la salle tradent aussi \u2014 r\xe9pondez comme \xe0 une personne.",
                "exp_buy_offer": "Quelqu'un veut une chose que vous portez et la paie. Acceptez et le paiement vous revient, la chose part chez lui ; refusez et vous la gardez.",
                "exp_tax": "C'est la R\xe9serve Z\xe9d\xe9rale \u2014 le joueur-syst\xe8me du march\xe9. Elle taxe chaque trader de temps en temps. Choisissez ce que vous c\xe9dez avant la fin du compte \xe0 rebours, sinon elle prend les deux.",
                "exp_short": "Vendre \xe0 d\xe9couvert, c'est parier que cette valeur de vie va CHUTER. Si elle baisse, vous profitez du d\xe9clin. Vous pariez contre la valeur de quelqu'un \u2014 la salle le saura.",
                "exp_analysis": "C'est la voix de la bourse \u2014 le march\xe9 lui-m\xeame qui r\xe9agit \xe0 un \xe9change qui vient d'avoir lieu sur le parquet. C'est un commentaire, pas une demande : lisez, fermez, rien ne vous est demand\xe9."
            },
            companies_by_id: {
                "2": {
                    Company_Name: "Z Ragots T\xe9l\xe9com",
                    Description: "Diffuse et amplifie les conversations et rumeurs juteuses \u2014 vraies ou non.",
                    Out_put: "Rumeurs, drames et histoires sensationnelles",
                    Risk: "Trop de travail. Quand chacun est absorb\xe9 par sa vie, l\u2019attention au comm\xe9rage dispara\xeet."
                },
                "3": {
                    Company_Name: "Z Rage & Cie",
                    Description: "Repr\xe9sente la frustration, l\u2019agressivit\xe9 et l\u2019\xe9nergie chaotique du quotidien.",
                    Out_put: "Frustration amplifi\xe9e, col\xe8re et agitation",
                    Risk: "La perspective du reste du monde. Relativiser r\xe9duit la col\xe8re."
                },
                "4": {
                    Company_Name: "Z Mal Dans Sa Peau SA",
                    Description: "Explore les luttes int\xe9rieures du doute de soi et les complexit\xe9s de l\u2019image personnelle.",
                    Out_put: "Syndrome de l\u2019imposteur, doutes, critiques de soi",
                    Risk: "Changement et croissance. Un nouvel environnement peut dissiper les anciennes ins\xe9curit\xe9s."
                },
                "5": {
                    Company_Name: "Z Porte Ferm\xe9e Inc.",
                    Description: "Offre une plateforme pour comprendre et surmonter la douleur du rejet.",
                    Out_put: "Sentiment d\u2019exclusion, d\u2019\xe9chec et de non-appartenance",
                    Risk: "Succ\xe8s et acceptation. Les r\xe9ussites font taire le rejet."
                },
                "6": {
                    Company_Name: "Z Fake News T\xe9l\xe9com",
                    Description: "Sp\xe9cialis\xe9e dans la consommation et la diffusion de d\xe9sinformation sensationnaliste.",
                    Out_put: "D\xe9sinformation et r\xe9cits exag\xe9r\xe9s",
                    Risk: "Recherche et diversit\xe9. V\xe9rifier les faits et varier les sources prot\xe8ge."
                },
                "7": {
                    Company_Name: "Z D\xe9clarations Stupides T\xe9l\xe9com",
                    Description: "Met en \xe9vidence les propos absurdes et irr\xe9fl\xe9chis dits sans filtre.",
                    Out_put: "Remarques ignorantes, irr\xe9fl\xe9chies et amplifi\xe9es",
                    Risk: "Silence. Penser avant de parler d\xe9samorce la stupidit\xe9."
                },
                "8": {
                    Company_Name: "Z Peinture Num\xe9rique Industries",
                    Description: "Innove dans l\u2019art num\xe9rique, alliant technologie et cr\xe9ativit\xe9.",
                    Out_put: "\u0152uvres digitales, expression cr\xe9ative et visuels technologiques",
                    Risk: "Panne d\u2019\xe9lectricit\xe9. Sans courant, plus de peinture num\xe9rique."
                },
                "9": {
                    Company_Name: "Z Dessin Industries",
                    Description: "C\xe9l\xe8bre l\u2019art intemporel du dessin et son pouvoir d\u2019imagination.",
                    Out_put: "Croquis, dessins \xe0 la main et cr\xe9ativit\xe9 brute",
                    Risk: "Photographie. La facilit\xe9 des clich\xe9s rapides menace le dessin."
                },
                "10": {
                    Company_Name: "Z Avidit\xe9 Incorpor\xe9e",
                    Description: "Symbolise le d\xe9sir insatiable de prendre plus que sa part.",
                    Out_put: "Consommation incontr\xf4l\xe9e et ambition excessive",
                    Risk: "Empathie. L\u2019altruisme fait dispara\xeetre l\u2019avidit\xe9."
                },
                "11": {
                    Company_Name: "Z Paternelle Banque Corp.",
                    Description: "Offre des services de vie avec une aura de stabilit\xe9 et de confiance. Ou pas.",
                    Out_put: "Stabilit\xe9 per\xe7ue, amour et soutien familial",
                    Risk: "Abandon. Quand le p\xe8re s\u2019en va, il n\u2019y a plus de p\xe8re."
                },
                "12": {
                    Company_Name: "Z Radine Corp.",
                    Description: "Dispose des fonds mais refuse de payer le juste prix.",
                    Out_put: "Sous-paiement et transfert de charges",
                    Risk: "Avidit\xe9. Quand plus personne n\u2019accepte de payer trop, nous sommes finis."
                },
                "13": {
                    Company_Name: "Z Oh Mon Dieu Incorpor\xe9e",
                    Description: "C\xe9l\xe8bre l\u2019\xe9merveillement et les moments extraordinaires de la vie.",
                    Out_put: "Amazement, inspiration et transcendance",
                    Risk: "Cynisme. L\u2019absence totale de croyance tue l\u2019\xe9merveillement."
                },
                "14": {
                    Company_Name: "Z \xc9criture Technologies",
                    Description: "Favorise l\u2019expression cr\xe9ative gr\xe2ce aux outils pour l\u2019\xe9crit.",
                    Out_put: "Mots, litt\xe9rature et narration structur\xe9e",
                    Risk: "Le blocage de l\u2019\xe9crivain. Quand la cr\xe9ativit\xe9 meurt, nous aussi."
                },
                "15": {
                    Company_Name: "Z Technologies de Traduction",
                    Description: "Brise les barri\xe8res linguistiques et favorise la compr\xe9hension interculturelle.",
                    Out_put: "Conversion linguistique et communication",
                    Risk: "Langue inconnue. Quand tout devient incompr\xe9hensible, m\xeame nous sommes impuissants."
                },
                "16": {
                    Company_Name: "Z Pens\xe9e Technologie",
                    Description: "Exprime le potentiel illimit\xe9 de l\u2019esprit humain \u2014 parfois trop, parfois trop peu.",
                    Out_put: "Id\xe9es nouvelles et stimulation mentale",
                    Risk: "\xc9conomie de l\u2019attention. Quand tout est ailleurs, la pens\xe9e s\u2019\xe9teint."
                },
                "17": {
                    Company_Name: "Z Arrogance Incorpor\xe9e",
                    Description: "Incarne la surconfiance et le sentiment de sup\xe9riorit\xe9.",
                    Out_put: "Confiance in\xe9branlable et condescendance",
                    Risk: "Humilit\xe9. D\xe8s que la modestie arrive, nous d\xe9clinons."
                },
                "18": {
                    Company_Name: "Z Provocation T\xe9l\xe9com",
                    Description: "Sp\xe9cialis\xe9e dans la remise en question et l\u2019agitation des d\xe9bats.",
                    Out_put: "D\xe9bats polaris\xe9s et controverse",
                    Risk: "Zen. La paix int\xe9rieure rend la provocation inutile."
                },
                "19": {
                    Company_Name: "Z D\xe9pression Entreprises",
                    Description: "Symbolise le vide \xe9motionnel, la tristesse et la lourdeur existentielle.",
                    Out_put: "Vide \xe9motionnel et d\xe9sespoir",
                    Risk: "Drogues. Un esprit modifi\xe9 est plus difficile \xe0 contr\xf4ler."
                },
                "20": {
                    Company_Name: "Z Snob Entreprises",
                    Description: "\xcatre meilleur, plus intelligent, plus important que vous, peut-\xeatre.",
                    Out_put: "Attitudes \xe9litistes et barri\xe8res sociales",
                    Risk: "Un coup de poing. Rien n\u2019humilie plus vite que d\u2019\xeatre renvers\xe9."
                },
                "21": {
                    Company_Name: "Z Solitude Corporation",
                    Description: "Quand tu parles tout seul\xb7le parce que personne n\u2019est \xe0 la maison.",
                    Out_put: "Isolement, silence et absence de lien humain",
                    Risk: "Amis/Famille. Une vraie connexion, quand les gens s\u2019en fichent pas, notre business s\u2019effondre."
                },
                "22": {
                    Company_Name: "Z Culpabilit\xe9 Incorpor\xe9e",
                    Description: "La petite voix de l\u2019auto-r\xe9flexion et des remords quotidiens.",
                    Out_put: "Regret, fardeau moral et auto-analyse incessante",
                    Risk: "Narcissisme. Si rien n\u2019a d\u2019importance, aucun regret non plus."
                },
                "23": {
                    Company_Name: "Zo Suicidaire Industrie",
                    Description: "La solution quand tout devient trop lourd \xe0 supporter.",
                    Out_put: "D\xe9tresse \xe9motionnelle, maladie mentale et id\xe9es autodestructrices",
                    Risk: "Parentalit\xe9. Avoir une vie \xe0 prot\xe9ger donne soudain une raison de rester."
                },
                "24": {
                    Company_Name: "Z Aspirateur Industries",
                    Description: "Une forme productive d\u2019aspiration.",
                    Out_put: "Espaces sans poussi\xe8re, efficacit\xe9 d\u2019aspiration et propret\xe9 immacul\xe9e",
                    Risk: "Paresse. Si les gens d\xe9cident de vivre dans la crasse, nous devenons inutiles."
                },
                "25": {
                    Company_Name: "Z Toilettes \xc9tincelantes Corp.",
                    Description: "Non, ce ne sont pas des \xe9toiles dans les WC, c\u2019est juste la porcelaine qui brille.",
                    Out_put: "Hygi\xe8ne, sanitaires et cuvettes resplendissantes",
                    Risk: "La n\xe9gligence. Quand on arr\xeate de se soucier, l\u2019\xe9clat dispara\xeet."
                },
                "26": {
                    Company_Name: "Z Plumeau Incorpor\xe9e",
                    Description: "Pour une existence hypoallerg\xe9nique, sans poussi\xe8re.",
                    Out_put: "Surfaces nettes, r\xe9duction des allerg\xe8nes et maison saine",
                    Risk: "Vacances. Si personne n\u2019est l\xe0, la poussi\xe8re ne d\xe9range personne."
                },
                "27": {
                    Company_Name: "Z D\xe9g\xe2ts & Nettoyage Industries",
                    Description: "Transformer les accidents de la vie en occasions de recommencer propre.",
                    Out_put: "Ordre retrouv\xe9, propret\xe9 et erreurs effac\xe9es",
                    Risk: "Contenants ferm\xe9s. Si rien ne se renverse, on n\u2019a rien \xe0 faire."
                },
                "28": {
                    Company_Name: "Z Trolls Incorpor\xe9e",
                    Description: "Le c\xf4t\xe9 (parfois) ludique et provocateur des interactions en ligne.",
                    Out_put: "Engagements perturbateurs, aga\xe7ants ou parfois amusants",
                    Risk: "L\u2019indiff\xe9rence. Pas de r\xe9action, pas de plaisir. L\u2019ignorance est notre vrai ennemi."
                },
                "29": {
                    Company_Name: "Z Plats Pr\xe9par\xe9s Raffinerie",
                    Description: "Allier commodit\xe9 et nourriture pour la vie moderne trop occup\xe9e.",
                    Out_put: "Repas pr\xe9-emball\xe9s, solutions pratiques et rapides",
                    Risk: "Trop de temps libre. Si les gens cuisinent eux-m\xeames, plus de b\xe9n\xe9fices."
                },
                "30": {
                    Company_Name: "Z Chef Cuisine Corporation",
                    Description: "C\xe9l\xe9brer l\u2019art culinaire et les d\xe9lices gastronomiques.",
                    Out_put: "Plats exquis, saveurs raffin\xe9es et chefs-d\u2019\u0153uvre culinaires",
                    Risk: "Sortir d\xeener. Si tout le monde va au resto, quelqu\u2019un d\u2019autre cuisine."
                },
                "31": {
                    Company_Name: "Z Transport \xc9picerie",
                    Description: "L\u2019aller-retour \xe9ternel des march\xe9s alimentaires.",
                    Out_put: "Cha\xeenes logistiques, garde-manger bien rempli et flux de nourriture",
                    Risk: "Drones. Le jour o\xf9 ils livrent tout, nous sommes obsol\xe8tes."
                },
                "32": {
                    Company_Name: "Zo D\xe9sorganisation Syst\xe8mes",
                    Description: "Le chaos qui d\xe9clenche cr\xe9ativit\xe9 et innovation\u2026 ou juste un gros bordel.",
                    Out_put: "D\xe9sordre inspirant, improvisation cr\xe9ative",
                    Risk: "Temps libre. Si les gens rangent, on perd notre magie."
                },
                "33": {
                    Company_Name: "Ze Manger Dehors Incorpor\xe9e",
                    Description: "Chez un pote ou au resto \u2014 tant que c\u2019est pas toi qui cuisines.",
                    Out_put: "Quelqu\u2019un d\u2019autre fait la cuisine",
                    Risk: "Pas d\u2019argent. Quand le portefeuille est vide, retour aux p\xe2tes maison."
                },
                "34": {
                    Company_Name: "Z M\xe9fiance M\xe9dias Corp.",
                    Description: "Plans, sous-plans, complots \u2014 \xe9clairer les v\xe9rit\xe9s cach\xe9es.",
                    Out_put: "R\xe9v\xe9lations, th\xe9ories et conspirations",
                    Risk: "Confiance. Quand les explications simples convainquent, on dispara\xeet."
                },
                "35": {
                    Company_Name: "Z Amiti\xe9 Technologies",
                    Description: "D\xe9vou\xe9e \xe0 cr\xe9er des liens et c\xe9l\xe9brer la vraie camaraderie.",
                    Out_put: "Confiance, soutien, complicit\xe9 et chaleur humaine",
                    Risk: "Haine. Quand l\u2019amertume prend le dessus, l\u2019amiti\xe9 meurt."
                },
                "36": {
                    Company_Name: "Zo Sceptiques Corporation",
                    Description: "Ce petit doute permanent : \xab et si\u2026 ? \xbb",
                    Out_put: "Remise en question, analyse et doute rationnel",
                    Risk: "Honn\xeatet\xe9. Quand la v\xe9rit\xe9 saute aux yeux, plus besoin de nous."
                },
                "37": {
                    Company_Name: "Z Chute Libre Transport",
                    Description: "A\xefe, \xe7a fait mal ! Mais c\u2019\xe9tait (presque) volontaire. Tu rigoles, tu perds.",
                    Out_put: "Bleus au corps, bleus \xe0 l\u2019ego",
                    Risk: "\xc9quilibre. Avec de la coordination, on tombe beaucoup moins."
                },
                "38": {
                    Company_Name: "Z D\xe9coiff\xe9s Corporation",
                    Description: "C\xe9l\xe9brer la beaut\xe9 de l\u2019imperfection et l\u2019art du d\xe9sordre.",
                    Out_put: "D\xe9sordre styl\xe9, improvisation et cr\xe9ativit\xe9 d\xe9braill\xe9e",
                    Risk: "M\xe9nage. Le jour o\xf9 \xe7a brille, on est foutus."
                },
                "39": {
                    Company_Name: "J D\xe9bat Syst\xe8mes",
                    Description: "Jamais d\u2019accord, toujours pr\xeats \xe0 la joute verbale.",
                    Out_put: "Discussions vives et clash d\u2019id\xe9es",
                    Risk: "Fatigue. Quand les gens sont trop crev\xe9s pour argumenter, on perd le public."
                },
                "40": {
                    Company_Name: "Zo \xc9go\xefsme Industrie",
                    Description: "Moi d\u2019abord, le reste de la soci\xe9t\xe9 peut crever.",
                    Out_put: "Priorit\xe9 absolue \xe0 soi-m\xeame",
                    Risk: "Bouddhisme. Se d\xe9tacher du soi rend l\u2019\xe9go\xefsme caduc."
                },
                "41": {
                    Company_Name: "ZEGO Incorpor\xe9e",
                    Description: "Le r\xf4le de l\u2019auto-importance dans Moi MOI moi.",
                    Out_put: "Culte du moi, besoin de reconnaissance, centrage sur soi",
                    Risk: "Altruisme. D\xe8s qu\u2019on arr\xeate de nourrir l\u2019ego, on perd le pouvoir. Mettre les autres en premier et l\u2019humilit\xe9 sont nos pires menaces."
                },
                "42": {
                    Company_Name: "Z \xc9couter Corporation",
                    Description: "Le pouvoir de l\u2019\xe9coute attentive pour cr\xe9er (un peu) d\u2019intercompr\xe9hension.",
                    Out_put: "\xc9coute r\xe9elle, savoir acquis, liens renforc\xe9s",
                    Risk: "Ego. Si chacun n\u2019attend que son tour pour parler, l\u2019\xe9coute dispara\xeet."
                },
                "43": {
                    Company_Name: "Z Optimiste Incorpor\xe9e",
                    Description: "Promouvoir la positivit\xe9 et la conviction que \xab \xe7a va s\u2019arranger \xbb.",
                    Out_put: "Bonne humeur diffus\xe9e, croyance en de meilleurs lendemains",
                    Risk: "Les infos. Quand la r\xe9alit\xe9 rappelle sans cesse le d\xe9sastre, l\u2019optimisme se vend mal."
                },
                "44": {
                    Company_Name: "Z Ils m\u2019en veulent Syst\xe8mes",
                    Description: "Parano\xefa et interpr\xe9tations d\xe9lirantes de la vie.",
                    Out_put: "Soup\xe7ons, complots imaginaires, lectures biais\xe9es du quotidien",
                    Risk: "Mer d\u2019huile. Quand tout roule sans raison, la parano para\xeet ridicule."
                },
                "45": {
                    Company_Name: "Z Peur Incorpor\xe9e",
                    Description: "L\u2019\xe9motion primaire qui d\xe9clenche le \xab fuir ou combattre \xbb (et le surplace).",
                    Out_put: "R\xe9ponses de survie, vigilance et frein au progr\xe8s",
                    Risk: "Courage. Les intr\xe9pides ne se contr\xf4lent pas."
                },
                "46": {
                    Company_Name: "Z Sculpture Industries",
                    Description: "Construire des march\xe9s (et des formes) comme vous ne l\u2019auriez jamais imagin\xe9.",
                    Out_put: "Formes 3D physiques et num\xe9riques, volumes, textures",
                    Risk: "Dessin. Pourquoi sculpter quand on peut esquisser ? La simplicit\xe9 du 2D nous menace."
                },
                "47": {
                    Company_Name: "Zo Seul\xb7e Corporation",
                    Description: "Explorer l\u2019exp\xe9rience humaine en solitaire, voulue ou subie.",
                    Out_put: "Solitude choisie, introspection, silence r\xe9parateur",
                    Risk: "Parentalit\xe9. Quand une autre vie d\xe9pend de toi, la vraie solitude n\u2019existe plus."
                },
                "48": {
                    Company_Name: "Z Couleur Technologies",
                    Description: "R\xe9volution des pigments et de la vibrance visuelle.",
                    Out_put: "Vibrance, \xe9motion, sensations visuelles",
                    Risk: "Obscurit\xe9. Sans lumi\xe8re, la couleur devient\u2026 subtilement inexistante."
                },
                "49": {
                    Company_Name: "Z D\xeener Party Incorpor\xe9e",
                    Description: "Rassembler des gens autour de la bouffe, des conversations et d\u2019une (bonne) bouteille.",
                    Out_put: "Rencontres conviviales, \xe9changes et toasts partag\xe9s",
                    Risk: "Anti-social. Si personne ne veut s\u2019engager, la f\xeate ne d\xe9marre jamais."
                },
                "50": {
                    Company_Name: "Zo D\xe9lire Industrie",
                    Description: "La fine fronti\xe8re entre r\xeaves et attentes franchement irr\xe9alistes.",
                    Out_put: "R\xe9alit\xe9 fictive souvent totalement ridicule",
                    Risk: "Rationalit\xe9. Quand la logique s\u2019impose, on perd la client\xe8le."
                },
                "51": {
                    Company_Name: "Z Vacances Analytica Inc.",
                    Description: "S\u2019\xe9vader de chez soi : traditions et \xe9motions quand on l\xe2che le quotidien.",
                    Out_put: "Parenth\xe8se, \xe9vasion, souvenirs et d\xe9compression",
                    Risk: "Pas d\u2019argent/temps. Si on ne peut pas partir, on reste."
                },
                "52": {
                    Company_Name: "Ze Triche Incorpor\xe9e",
                    Description: "Raccourcis, entorses aux r\xe8gles et petites trahisons pour arriver vite au but.",
                    Out_put: "Avantage indu, r\xe8gles tordues et coups malins",
                    Risk: "Morale. Si les gens jouent fair-play, on devient obsol\xe8tes."
                },
                "53": {
                    Company_Name: "Zo Religions Incorpor\xe9e",
                    Description: "Foi, spiritualit\xe9 et traditions culturelles qui fa\xe7onnent les croyances, partout.",
                    Out_put: "Communaut\xe9s de foi, rites, sens et appartenance",
                    Risk: "Ath\xe9isme. Si l\u2019on cesse de croire, on n\u2019a plus rien \xe0 vendre."
                },
                "54": {
                    Company_Name: "Z Coup d\u2019un Soir Inc.",
                    Description: "Pas envie de te \xab dater \xbb \u2014 juste de la valeur sans engagement.",
                    Out_put: "Rencontres occasionnelles, plaisir non contraignant",
                    Risk: "R\xe9clusion. Si tout le monde se coupe des autres, le march\xe9 s\u2019effondre."
                },
                "55": {
                    Company_Name: "Zo Ami\xb7e Tr\xe8s Sp\xe9cial\xb7e Inc.",
                    Description: "Le genre d\u2019ami qui offre des b\xe9n\xe9fices tr\xe8s\u2026 chauds.",
                    Out_put: "Ami\xb7e avec avantages, proximit\xe9 sans \xe9tiquette",
                    Risk: "Engagement. Quand \xe7a devient s\xe9rieux, on n\u2019a plus d\u2019utilit\xe9."
                },
                "56": {
                    Company_Name: "Z Pers\xe9cut\xe9\xb7e Corporation",
                    Description: "Accus\xe9\xb7e, rabaiss\xe9\xb7e, maintenu\xb7e au sol par les pr\xe9jug\xe9s des autres.",
                    Out_put: "Injustice subie, oppression et lutte pour la dignit\xe9",
                    Risk: "Pouvoir. Quand tu tiens les r\xeanes, la pers\xe9cution n\u2019a plus de sens."
                },
                "57": {
                    Company_Name: "Zo Autodestruction Corporation",
                    Description: "Le versant sombre : br\xfbler sa vie jusqu\u2019aux fondations.",
                    Out_put: "Effondrement personnel, sabotage et chaos \xe9motionnel",
                    Risk: "Sant\xe9 mentale. Comprendre le pourquoi et r\xe9parer casse le cycle."
                },
                "58": {
                    Company_Name: "Z D\xe9veloppement Th\xe9orie Syst\xe8mes",
                    Description: "D\xe9velopper le \xab pourquoi \xbb de nos fa\xe7ons de penser.",
                    Out_put: "Cadres de pens\xe9e structur\xe9s, mod\xe8les et concepts",
                    Risk: "Divertissement. Si on pr\xe9f\xe8re s\u2019amuser que r\xe9fl\xe9chir, les th\xe9ories deviennent d\xe9coratives."
                },
                "59": {
                    Company_Name: "Z Ap\xe9ro Corporation",
                    Description: "C\u2019est l\u2019heure de trinquer \u2014 il est bien 17 h quelque part.",
                    Out_put: "D\xe9sserrement du stress et huile sociale pour les rouages",
                    Risk: "Mal de gorge. Si tu ne peux pas parler, tu ne peux pas porter un toast."
                },
                "60": {
                    Company_Name: "Z Recherche & Donn\xe9es Syst\xe8mes",
                    Description: "Creuser au fond du ventre de l\u2019information.",
                    Out_put: "Compr\xe9hension affin\xe9e de tout ce qu\u2019on veut \xe9claircir",
                    Risk: "Gueule de bois. Un esprit embrum\xe9 se fiche des faits."
                },
                "61": {
                    Company_Name: "Z Cin\xe9ma & Popcorn Incorpor\xe9e",
                    Description: "Se caler et se laisser emporter par l\u2019\xe9cran argent\xe9 \u2014 deux heures de vacances mentales.",
                    Out_put: "\xc9vasion du r\xe9el pendant quelques heures",
                    Risk: "Lecture. Un monde qui ouvre des livres plut\xf4t que des \xe9crans r\xe9siste au divertissement passif."
                },
                "62": {
                    Company_Name: "Z C\xe2lins Industries",
                    Description: "Am\xe9liorer la journ\xe9e, une \xe9treinte (ou plusieurs) \xe0 la fois.",
                    Out_put: "Faire sentir accept\xe9 et aim\xe9 gr\xe2ce \xe0 la chaleur humaine",
                    Risk: "Solitude. Sans personne \xe0 serrer, la chaleur reste une id\xe9e abstraite."
                },
                "63": {
                    Company_Name: "Z Baisers Industries",
                    Description: "L\u2019autre claque sur le visage \u2014 ou ailleurs \u2014 quand l\u2019affection s\u2019emballe (coquin\u2026 coquin\u2026).",
                    Out_put: "Exprimer l\u2019amour et l\u2019attirance par le contact",
                    Risk: "Solitude. Personne \xe0 embrasser, aucun lien \xe0 tisser."
                },
                "64": {
                    Company_Name: "Z Point de Vue Corporation",
                    Description: "Distribuer son avis, demand\xe9\u2026 ou pas.",
                    Out_put: "Partage de perspectives personnelles",
                    Risk: "Silence. Si personne n\u2019\xe9coute, un point de vue n\u2019est qu\u2019une pens\xe9e qui r\xe9sonne dans le vide."
                },
                "65": {
                    Company_Name: "Z Hydratation Incorpor\xe9e",
                    Description: "Difficile de rester vivant sans elle.",
                    Out_put: "Hydratation vitale",
                    Risk: "Mort. Sans eau, pas de survie \u2014 c\u2019est simple."
                },
                "66": {
                    Company_Name: "Z \xc9tudes Industries",
                    Description: "Acc\xe9der \xe0 des mondes au-del\xe0 de l\u2019imagination.",
                    Out_put: "Production et acquisition de savoir",
                    Risk: "\xc9conomie de la distraction. Les algorithmes des r\xe9seaux volent l\u2019attention."
                },
                "67": {
                    Company_Name: "Z Rigolade Divertissement",
                    Description: "L\u2019essentiel pour faire rire \u2014 et garder les liens en vie.",
                    Out_put: "Entretenir les relations par le rire et la bonne humeur",
                    Risk: "D\xe9pression. Un esprit plomb\xe9 n\u2019a plus l\u2019\xe9nergie de rire."
                },
                "68": {
                    Company_Name: "Z Syst\xe8mes d\u2019Attention",
                    Description: "Se concentrer dans un monde d\u2019interruptions sans fin. (Pardon, j\u2019ai d\xe9croch\xe9.)",
                    Out_put: "Capacit\xe9 \xe0 maintenir le focus, base de ce qu\u2019on construit et retient",
                    Risk: "Fatigue. L\u2019\xe9puisement mental \xe9touffe m\xeame la meilleure attention."
                },
                "69": {
                    Company_Name: "Z Voyeur M\xe9dias Incorpor\xe9e",
                    Description: "Laisser briller son c\xf4t\xe9 voyeur, sans se faire voir.",
                    Out_put: "Frisson d\u2019observer, satisfaction d\u2019\xeatre t\xe9moin invisible",
                    Risk: "Maison \xe0 la campagne. Sans voisins, pas d\u2019espionnage."
                },
                "70": {
                    Company_Name: "Z R\xe9veil Incorpor\xe9e",
                    Description: "Le rituel quotidien : se lever et repartir \xe0 neuf.",
                    Out_put: "Sortir du lit, mettre la journ\xe9e en marche",
                    Risk: "Insomnie. Sans dormir, on ne \xab se r\xe9veille \xbb pas vraiment."
                },
                "71": {
                    Company_Name: "Z Glandouille M\xe9dias",
                    Description: "\xc9vasion ludique et joie des moments l\xe9gers.",
                    Out_put: "Se divertir en faisant l\u2019andouille, seul ou \xe0 plusieurs",
                    Risk: "Trop de travail. Quand les responsabilit\xe9s d\xe9bordent, il n\u2019y a plus de place pour le fun."
                },
                "72": {
                    Company_Name: "Z Dormeur Corporation",
                    Description: "L\u2019importance du repos et de la r\xe9cup\xe9ration pour l\u2019esprit humain.",
                    Out_put: "Temps de r\xe9paration du corps et de l\u2019esprit",
                    Risk: "Stress/Anxi\xe9t\xe9. Un mental agit\xe9 refuse le sommeil et laisse l\u2019\xe9puisement."
                },
                "73": {
                    Company_Name: "Z Jalousie Syst\xe8mes",
                    Description: "La pelouse du voisin est toujours plus verte.",
                    Out_put: "Carburant de la comparaison, de la comp\xe9tition et du m\xe9contentement",
                    Risk: "Satisfaction. Si l\u2019on appr\xe9cie ce qu\u2019on a, la jalousie perd ses crocs."
                },
                "74": {
                    Company_Name: "Z D\xe9sir Syst\xe8mes",
                    Description: "Puiser dans les motivations et passions qui portent l\u2019ambition et la cr\xe9ation.",
                    Out_put: "Force motrice des poursuites positives (et parfois moins\u2026)",
                    Risk: "Apathie. Quand on ne ressent plus rien, il n\u2019y a plus de d\xe9sir."
                },
                "75": {
                    Company_Name: "Z Rire Industrie",
                    Description: "Affiner l\u2019art de l\u2019humour pour \xe9clairer les vies et remonter les moral(e)s.",
                    Out_put: "Lib\xe9ration physique venue du ventre, encore meilleure en groupe",
                    Risk: "Les nouvelles. Un flux constant de trag\xe9dies rend le rire luxueux."
                },
                "76": {
                    Company_Name: "Z Identit\xe9s Incorpor\xe9e",
                    Description: "Les couches subtiles de l\u2019identit\xe9 personnelle et collective dans un monde divers.",
                    Out_put: "Le qui, le quoi et surtout le pourquoi de la perception de soi",
                    Risk: "Racisme. Ne pas avoir le droit d\u2019\xeatre soi."
                },
                "77": {
                    Company_Name: "Z Blagues Divertissement",
                    Description: "Des moments l\xe9gers et un humour fut\xe9 pour relier et amuser.",
                    Out_put: "Transmission d\u2019humour, qu\u2019on l\u2019ait demand\xe9 ou non",
                    Risk: "Blagues de papa. Elles\u2026 (tu vois l\u2019id\xe9e)."
                },
                "78": {
                    Company_Name: "Z Pr\xe9tentieux Industries",
                    Description: "Le r\xe8gne des apparences et de l\u2019auto-importance \u2014 avec une pointe de muflerie.",
                    Out_put: "Se pr\xe9senter comme sup\xe9rieur, plus raffin\xe9, plus important que les autres",
                    Risk: "Altruisme. Quand on se fiche d\u2019apparences, la pr\xe9tention ne vaut plus rien."
                },
                "79": {
                    Company_Name: "Zo Frustr\xe9 Incorpor\xe9e",
                    Description: "Saisir l\u2019exasp\xe9ration et la pers\xe9v\xe9rance des gal\xe8res quotidiennes.",
                    Out_put: "Essayer encore et encore sans r\xe9sultat (et recommencer)",
                    Risk: "Succ\xe8s. Quand \xe7a marche, la frustration fond en satisfaction."
                },
                "80": {
                    Company_Name: "Z Anti-Poussi\xe8re Cie",
                    Description: "L\u2019art du m\xe9nage pouss\xe9 jusqu\u2019au sans-poussi\xe8re \xe9clatant.",
                    Out_put: "Bien plus que passer l\u2019aspirateur : extermination de la poussi\xe8re",
                    Risk: "La ville. Appartements sur rue et fen\xeatres ouvertes \u2014 la poussi\xe8re refait surface."
                },
                "81": {
                    Company_Name: "Z Vulgaire Corporation",
                    Description: "Repousser les limites et chatouiller les normes avec une expression brute.",
                    Out_put: "Affirmation d\u2019individualit\xe9 sans filtre",
                    Risk: "Respect. Quand la biens\xe9ance prime, l\u2019expression crue perd sa place."
                },
                "82": {
                    Company_Name: "Z Rock & D\xe9cibels Industries",
                    Description: "Capitaliser sur la musique forte qui coule dans les oreilles douze heures par jour.",
                    Out_put: "Euphorie par la musique, le mouvement et l\u2019\xe9nergie d\xe9brid\xe9e",
                    Risk: "Balados. Un monde qui pr\xe9f\xe8re la parole au volume \xe9touffe la puissance du son fort."
                },
                "83": {
                    Company_Name: "Zo \xc9reint\xe9 Corporation",
                    Description: "L\u2019exp\xe9rience universelle de l\u2019\xe9puisement.",
                    Out_put: "Frein g\xe9n\xe9ral \xe0 toute action, paupi\xe8res lourdes, r\xe9flexion au ralenti",
                    Risk: "D\xe9rive. Errer sans horaires d\xe9joue la fatigue\u2026 en \xe9vitant le \xab vrai \xbb repos."
                },
                "84": {
                    Company_Name: "Z Interactions M\xe9dia",
                    Description: "\xc9changes et liens \xe0 travers la diversit\xe9 du vivant.",
                    Out_put: "Relations, exp\xe9riences partag\xe9es et \xe9changes sociaux",
                    Risk: "Ego. Quand l\u2019int\xe9r\xeat personnel \xe9crase le lien, l\u2019interaction devient creuse."
                },
                "85": {
                    Company_Name: "Zo Bricolo Incorpor\xe9e",
                    Description: "R\xe9parer, monter, bidouiller avec adresse et ing\xe9niosit\xe9.",
                    Out_put: "Jouets r\xe9par\xe9s, \xe9tag\xe8res pos\xe9es, cuisine pr\xeate \xe0 l\u2019emploi, tout bricolage utile",
                    Risk: "Rien \xe0 r\xe9parer. Si tout fonctionne, l\u2019atelier ferme."
                },
                "86": {
                    Company_Name: "Zo Bon Sens Technologie",
                    Description: "Des solutions simples \xe0 des probl\xe8mes compliqu\xe9s.",
                    Out_put: "Application de logique et de jugement pour avancer efficacement",
                    Risk: "Idiocie. Quand la pens\xe9e rationnelle est d\xe9valu\xe9e, le bon sens s\u2019\xe9vapore."
                },
                "87": {
                    Company_Name: "Z Lave-Vaisselle Corporation",
                    Description: "Tous les jours, apr\xe8s chaque repas.",
                    Out_put: "Vaisselle propre pour le prochain festin (mains ti\xe8des incluses)",
                    Risk: "Repas dehors. Si on mange ailleurs, la vaisselle devient l\u2019affaire des autres."
                },
                "88": {
                    Company_Name: "Z M\xe9moire Logiciels",
                    Description: "Pr\xe9server et muscler le souvenir par des outils fut\xe9s.",
                    Out_put: "Processus cognitifs et pratiques pour gagner en efficacit\xe9 et \xe9viter la redite",
                    Risk: "\xc2ge. Le temps qui passe grignote la m\xe9moire et la productivit\xe9."
                },
                "89": {
                    Company_Name: "Z Partenaires Incorpor\xe9e",
                    Description: "Derri\xe8re toute Bourse solide, une femme encore plus solide.",
                    Out_put: "Lien intime et s\xfbr, personnel et financier, moteur du succ\xe8s commun",
                    Risk: "\xc9go\xefsme. Quand l\u2019individu prime, le duo ne sert plus \xe0 rien."
                },
                "90": {
                    Company_Name: "Z R\xeaves Syst\xe8mes",
                    Description: "Myst\xe8res et inspirations du sommeil paradoxal.",
                    Out_put: "Restauration inconsciente, sant\xe9 du corps et de l\u2019esprit, porte du subconscient",
                    Risk: "F\xeate chimique. Les substances brouillent r\xeaves et repos profond."
                },
                "91": {
                    Company_Name: "Zo Tr\xf4ne Ultra Frais Industries",
                    Description: "Fra\xeecheur et propret\xe9 pour les lieux les plus visit\xe9s.",
                    Out_put: "Hygi\xe8ne du royaume, senteur agr\xe9able et \xe9clat poli",
                    Risk: "Paresse. Si l\u2019entretien flanche, la fra\xeecheur s\u2019effondre."
                },
                "92": {
                    Company_Name: "Ze Libido Industries",
                    Description: "Passion et pulsions qui nourrissent lien et cr\xe9ativit\xe9.",
                    Out_put: "Envie pressante de s\u2019accoupler (oui, tr\xe8s pressante)",
                    Risk: "D\xe9prime/Froid. L\u2019engourdissement mental ou physique \xe9teint le d\xe9sir."
                },
                "93": {
                    Company_Name: "Z Sagesse Incorpor\xe9e",
                    Description: "Chercher connaissance et compr\xe9hension pour naviguer le chaos.",
                    Out_put: "Lecture fine des complexit\xe9s, clairvoyance et bon jugement",
                    Risk: "Manque d\u2019exp\xe9rience. Sans v\xe9cu, la sagesse reste hors de port\xe9e."
                },
                "94": {
                    Company_Name: "Z Stress Corporation",
                    Description: "Raffiner le tas quotidien de pressions en pure valeur (ou presque).",
                    Out_put: "Manifestation physiologique de la pression : l\u2019ext\xe9rieur devient temp\xeate int\xe9rieure",
                    Risk: "Argent. Quand la charge financi\xe8re s\u2019all\xe8ge, le stress perd un pilier."
                },
                "95": {
                    Company_Name: "Z R\xe2leries Corporation",
                    Description: "Dire les choses cash, soupape comprise.",
                    Out_put: "Expression vocale du m\xe9contentement, parfois appel au changement",
                    Risk: "Accomplissement. Pas de souci, pas de plainte."
                },
                "96": {
                    Company_Name: "Z Vide Corporation",
                    Description: "Le creux de la journ\xe9e qui demande : \xab \xe0 quoi bon ? \xbb",
                    Out_put: "Stagnation existentielle o\xf9 but et \xe9lan semblent absents",
                    Risk: "R\xe9ussite. Quand le sens revient, le vide se dissipe."
                },
                "97": {
                    Company_Name: "Z Douleur Industries",
                    Description: "Quand \xe7a fait mal \u2014 quelque part ou partout.",
                    Out_put: "Signal physique ou \xe9motionnel qui exige attention, adaptation ou \xe9vitement",
                    Risk: "Anesth\xe9sie. Substances qui rendent tout\u2026 muet."
                },
                "98": {
                    Company_Name: "Z Odeur Corporation",
                    Description: "L\u2019invisible toujours pr\xe9sent dans la pi\xe8ce.",
                    Out_put: "Votre sillage : comment on vous sent (litt\xe9ralement)",
                    Risk: "D\xe9odorant. La suppression artificielle gomme son influence."
                },
                "99": {
                    Company_Name: "Ze Narcissique Corporation",
                    Description: "Auto-admiration parce que \xab moi d\u2019abord \xbb.",
                    Out_put: "Seul soi compte, peu importe les d\xe9g\xe2ts autour",
                    Risk: "\xc9coute. L\u2019attention r\xe9elle \xe0 l\u2019autre fissure l\u2019illusion de grandeur."
                },
                "100": {
                    Company_Name: "Z Compliqu\xe9 Incorpor\xe9e",
                    Description: "Toutes les petites pi\xe8ces \xe0 prendre en compte pour comprendre l\u2019ensemble.",
                    Out_put: "Complexit\xe9 d\xe9bordante qui rend l\u2019entente mutuelle introuvable",
                    Risk: "Simplicit\xe9. Accueillir le d\xe9tachement dissout l\u2019encombrement mental."
                },
                "101": {
                    Company_Name: "Z Baston Industries",
                    Description: "Coups de poing, cl\xe9s de bras et joutes d\u2019id\xe9es en pleine face.",
                    Out_put: "Affirmation de l\u2019existence par confrontation physique ou intellectuelle",
                    Risk: "Paix int\xe9rieure. Sans attachement, plus besoin de se battre."
                },
                "102": {
                    Company_Name: "Zo Ver d\u2019Oreille Groupe",
                    Description: "Pluie, vent, froid ou soleil : tous les jours, sans faute.",
                    Out_put: "Air, jingle ou m\xe9lodie qui tourne en boucle dans la t\xeate",
                    Risk: "Conversation. Un \xe9change vif\u2026 et le ver cesse de grignoter."
                },
                "103": {
                    Company_Name: "Z C\xe9libataire Corporation",
                    Description: "Le d\xe9sir profond de flirter avec tout le bar (effet lunettes obligatoire).",
                    Out_put: "Vie solo, disponible pour jouer",
                    Risk: "Engagement. D\xe8s qu\u2019il arrive, le mode c\xe9lib\u2019 s\u2019\xe9vapore."
                },
                "104": {
                    Company_Name: "ZEvil Corporation",
                    Description: "La malveillance pure \u2014 comme du 3G quand tout le monde a du 5G.",
                    Out_put: "Pouvoir et ambition qui avancent par efficacit\xe9 impitoyable",
                    Risk: "Empathie. Le souci sinc\xe8re des autres fissure la m\xe9chancet\xe9."
                },
                "105": {
                    Company_Name: "Z Bureaucratique Corporation",
                    Description: "La bureaucratie : un voyage, pas une destination.",
                    Out_put: "Blocage par couches de r\xe8gles et lenteurs soigneusement empil\xe9es",
                    Risk: "Infraction. Quand on contourne tout, la paperasse perd prise."
                },
                "106": {
                    Company_Name: "Z Air Guitariste Corporation",
                    Description: "Riffs imaginaires, vraie passion, oxyg\xe8ne en main.",
                    Out_put: "Joie et expression d\xe9li\xe9es de toute utilit\xe9 \u2014 dans le vide, litt\xe9ralement",
                    Risk: "Inhibition. La g\xeane tue le solo invisible net et sans retour."
                },
                "107": {
                    Company_Name: "Zo Donner Corporation",
                    Description: "Tendre la main sans r\xe9clamer quoi que ce soit en retour.",
                    Out_put: "G\xe9n\xe9rosit\xe9 gratuite aux effets sociaux ou spirituels bien r\xe9els",
                    Risk: "\xc9go\xefsme. Quand le gain personnel l\u2019emporte, le don se grippe."
                },
                "108": {
                    Company_Name: "Vorace Z Corporation",
                    Description: "App\xe9tit insatiable pour la vie : toujours plus de ce qui excite.",
                    Out_put: "D\xe9sir sans fin de consommer, poss\xe9der ou vivre au-del\xe0 du n\xe9cessaire",
                    Risk: "Je\xfbne. Refuser l\u2019exc\xe8s affaiblit la fringale infinie."
                },
                "109": {
                    Company_Name: "Zo Excessif Corporation",
                    Description: "La qu\xeate de l\u2019exc\xe8s, o\xf9 \xab assez \xbb n\u2019existe pas.",
                    Out_put: "Indulgence d\xe9brid\xe9e : la mesure est laiss\xe9e \xe0 la porte",
                    Risk: "Sati\xe9t\xe9. Satisfait, l\u2019exc\xe8s devient vide."
                },
                "110": {
                    Company_Name: "Z Confortable Corporation",
                    Description: "La position parfaite entre aisance et contentement.",
                    Out_put: "Repos du corps et de l\u2019esprit, sans tension ni g\xeane",
                    Risk: "Mauvais canap\xe9. Si le confort s\u2019effondre, la d\xe9tente se change en agacement."
                },
                "111": {
                    Company_Name: "Zo Bien Repos\xe9 Incorpor\xe9e",
                    Description: "L\u2019art de lever le pied pour recharger les batteries.",
                    Out_put: "\xc9tat centr\xe9 : la tension s\u2019en va, la fatigue aussi",
                    Risk: "Parentalit\xe9. Sans nuits paisibles, le calme reste th\xe9orique."
                },
                "112": {
                    Company_Name: "Zo Se d\xe9tendre Compagnie",
                    Description: "Sp\xe9cialiste du calme et des joies simples de la d\xe9contraction.",
                    Out_put: "Absence d\u2019agitation : esprit clair, existence apais\xe9e",
                    Risk: "Factures. Les obligations grignotent la paix int\xe9rieure."
                },
                "113": {
                    Company_Name: "Zo Immobile Corporation",
                    Description: "Rester plant\xe9 l\xe0, entre action et inaction.",
                    Out_put: "Stagnation g\xe9n\xe9rale : rien n\u2019avance, rien ne bouge",
                    Risk: "Croissance. Si tu grandis, tu n\u2019es plus coinc\xe9."
                },
                "114": {
                    Company_Name: "Z Aller En Avant Corporation",
                    Description: "C\xe9l\xe9brer l\u2019\xe9lan qui pousse \xe0 avancer.",
                    Out_put: "Progresser dans la direction d\xe9sir\xe9e \u2014 projet, trottoir, vie",
                    Risk: "Bureaucratie. Trop de r\xe8gles casse l\u2019\xe9lan."
                },
                "115": {
                    Company_Name: "Zo Coinc\xe9 Corporation",
                    Description: "Tenter d\u2019avancer avec le pied coll\xe9 au sol.",
                    Out_put: "Obstacles qui bloquent l\u2019action et m\xe8nent \xe0 la stagnation",
                    Risk: "D\xe9r\xe9gulation. Sans entraves, l\u2019obstacle dispara\xeet et l\u2019humeur aussi."
                },
                "116": {
                    Company_Name: "Z Recul Incorpor\xe9e",
                    Description: "Glisser vers l\u2019ombre, peu \xe0 peu, jusqu\u2019\xe0 l\u2019invisible.",
                    Out_put: "Ce qui s\u2019amenuise avec le temps \u2014 qualit\xe9, pr\xe9sence ou \xe9clat",
                    Risk: "R\xe9ussite. Surmonter rend la lutte obsol\xe8te\u2026 et le recul aussi."
                },
                "117": {
                    Company_Name: "Z Voisin Incorpor\xe9e",
                    Description: "F\xeates bruyantes, b\xe9b\xe9s qui pleurent, poisson frit \u2014 la vie \xe0 deux portes d\u2019\xe9cart.",
                    Out_put: "Savoir-vivre en proximit\xe9 imm\xe9diate",
                    Risk: "Distance. Quand on s\u2019\xe9loigne, l\u2019\xeatre-voisin se dissout."
                },
                "118": {
                    Company_Name: "Zo L\xe9gal Corporation",
                    Description: "Vivre avec structures, r\xe8gles et responsabilit\xe9s qui soutiennent l\u2019ordre.",
                    Out_put: "Adh\xe9sion aux cadres qui organisent la hi\xe9rarchie sociale",
                    Risk: "R\xe9bellion. \xab Casser la loi \xbb suffit \xe0 casser la Loi."
                },
                "119": {
                    Company_Name: "Z Confus Syst\xe8mes",
                    Description: "Ces moments de perplexit\xe9 o\xf9 tout devient douteux. Hein ?",
                    Out_put: "Incertitude : infos contradictoires, d\xe9cision introuvable",
                    Risk: "Recherche. Plus on sait, moins la confusion r\xe8gne."
                },
                "120": {
                    Company_Name: "Z Ind\xe9cision Technologies",
                    Description: "Le paradoxe du choix : mille dentifrices, z\xe9ro d\xe9cision.",
                    Out_put: "Paralysie devant l\u2019abondance d\u2019options, donc inaction",
                    Risk: "D\xe9cision. Quand on tranche avec assurance, l\u2019ind\xe9cision dispara\xeet."
                },
                "121": {
                    Company_Name: "Z C\xe9l\xe9brit\xe9 Corporation",
                    Description: "Projecteurs, gloire, ego et l\u2019ivresse d\u2019\xeatre ador\xe9 par la foule.",
                    Out_put: "Soif d\u2019attention, d\u2019admiration et de validation qui fa\xe7onne l\u2019identit\xe9",
                    Risk: "Normalit\xe9. Redevenir \xab comme tout le monde \xbb fait retomber le souffl\xe9."
                },
                "122": {
                    Company_Name: "Z D\xe9fense Violente Corporation",
                    Description: "R\xe9ponses calcul\xe9es pour se prot\xe9ger des menaces.",
                    Out_put: "Riposte agressive face aux attaques physiques ou mentales",
                    Risk: "Tol\xe9rance. Accepter la diff\xe9rence coupe l\u2019herbe sous le pied \xe0 la violence."
                },
                "123": {
                    Company_Name: "Zo Enfiler Ses Chaussures inc.",
                    Description: "Le geste simple de sortir, sans oublier style et confort.",
                    Out_put: "Des pantoufles aux bottes : hop, on chausse et on y va",
                    Risk: "Plage. Si le monde autorise les pieds nus, les chaussures deviennent facultatives."
                },
                "124": {
                    Company_Name: "Z Fils \xe0 Maman Corporation",
                    Description: "Le lien unique et tenace entre une m\xe8re et son enfant.",
                    Out_put: "Poids affectif de l\u2019attachement, devoirs et tiraillements familiaux",
                    Risk: "Grandir. L\u2019autonomie \xe9mousse la culpabilit\xe9 maternelle."
                },
                "125": {
                    Company_Name: "Z Essayer Tr\xe8s Fort Industrie",
                    Description: "D\xe9termination et poursuite obstin\xe9e d\u2019un but malgr\xe9 tout.",
                    Out_put: "Effort inlassable pour franchir les obstacles par pure volont\xe9",
                    Risk: "Frustration. Quand \xe7a n\u2019aboutit pas, l\u2019acharnement vire \xe0 l\u2019\xe9puisement."
                },
                "126": {
                    Company_Name: "Z Mince - C\u2019est Cass\xe9 Corporation",
                    Description: "Le chaos quand tout l\xe2che en m\xeame temps.",
                    Out_put: "Stress de la panne et de la casse, petites et grandes",
                    Risk: "Remplacement. Acheter du neuf repousse l\u2019orage \xe0 demain."
                },
                "127": {
                    Company_Name: "Z Anxi\xe9t\xe9 Industrie",
                    Description: "Crainte tenace qui hurle du matin au soir (avec bonus mal de dos).",
                    Out_put: "Inqui\xe9tude constante, pens\xe9es qui cavalent et tension corporelle",
                    Risk: "Acceptation. Quand on trouve un socle, l\u2019anxi\xe9t\xe9 perd sa prise."
                },
                "128": {
                    Company_Name: "Z Ennui Corporation",
                    Description: "D\xe9sengagement total : rien ne m\xe9rite l\u2019effort.",
                    Out_put: "Plus rien de nouveau ni d\u2019attirant : vide et b\xe2illements",
                    Risk: "Passion. L\u2019ennemi jur\xe9 de l\u2019ennui."
                },
                "129": {
                    Company_Name: "Z Pr\xe9sentation Soi Corporation",
                    Description: "\xab Bonjour, je m\u2019appelle\u2026 \xbb",
                    Out_put: "Se faire conna\xeetre, attirer l\u2019attention et cr\xe9er un premier lien",
                    Risk: "Antisocial. Si tout le monde se retire, plus besoin de se pr\xe9senter."
                },
                "130": {
                    Company_Name: "Z&Z R\xe9p\xe9tition Incorpor\xe9e",
                    Description: "La routine du quotidien qui broie les jours en identiques.",
                    Out_put: "Cycle monotone o\xf9 la pr\xe9visibilit\xe9 avale l\u2019\xe9lan",
                    Risk: "Changement. Un d\xe9cor neuf brise la boucle."
                },
                "131": {
                    Company_Name: "Zo D\xe9\xe7u Incorpor\xe9e",
                    Description: "L\u2019exp\xe9rience universelle des attentes non combl\xe9es.",
                    Out_put: "Chute \xe9motionnelle et impression de potentiel g\xe2ch\xe9",
                    Risk: "Quand \xe7a marche. La satisfaction n\u2019a pas de place pour la d\xe9ception."
                },
                "132": {
                    Company_Name: "WOW Z Corporation",
                    Description: "Pur \xe9merveillement : le temps s\u2019arr\xeate, bouche ouverte.",
                    Out_put: "Instant de stupeur o\xf9 l\u2019extraordinaire d\xe9borde le pr\xe9vu",
                    Risk: "L\u2019ennui. Quand plus rien n\u2019\xe9tonne, m\xeame l\u2019impr\xe9vu tombe \xe0 plat."
                },
                "133": {
                    Company_Name: "Z Aimable Corporation",
                    Description: "Agir pour rendre la vie un peu plus douce.",
                    Out_put: "Gentillesse, charme et art d\u2019ensoleiller autrui",
                    Risk: "Grossi\xe8ret\xe9. Sans \xe9gards, l\u2019aimable tourne \xe0 l\u2019hostile."
                },
                "134": {
                    Company_Name: "Z Pessimiste Corporation",
                    Description: "S\u2019attendre au pire et s\u2019y blottir comme dans une couette.",
                    Out_put: "D\xe9tachement prudent : se pr\xe9parer \xe0 la d\xe9ception pour se prot\xe9ger",
                    Risk: "Positivit\xe9. Voir le bon c\xf4t\xe9 tue la noirceur."
                },
                "135": {
                    Company_Name: "Zo D\xe9bord\xe9 Incorpor\xe9e",
                    Description: "Trop \xe0 faire, pas assez d\u2019heures.",
                    Out_put: "Ex\xe9cuter quantit\xe9 de t\xe2ches indispensables",
                    Risk: "Farniente. Quand on valorise le repos, le \xab d\xe9bord\xe9 \xbb s\u2019\xe9vapore."
                },
                "136": {
                    Company_Name: "Zo Inassouvi Corporation",
                    Description: "Ce trou b\xe9ant du quotidien qui murmure \xab pas assez \xbb. ",
                    Out_put: "Sensation persistante de manque : rien ne suffit, jamais",
                    Risk: "Famille/Amis. Les liens profonds rendent le vide moins vorace."
                },
                "137": {
                    Company_Name: "Zo Pas Compatible Technologie",
                    Description: "Quand les syst\xe8mes refusent obstin\xe9ment de s\u2019accorder.",
                    Out_put: "Incompatibilit\xe9s qui forcent l\u2019inefficacit\xe9 et la crispation",
                    Risk: "Simplicit\xe9. Rester simple rend (souvent) compatible."
                },
                "138": {
                    Company_Name: "Zo All\xf4, All\xf4 ?? Incorpor\xe9e",
                    Description: "Technologie avanc\xe9e, mais communication basique en PLS.",
                    Out_put: "Gadgets qui manquent leur fonction premi\xe8re \u2014 surtout les \xab intelligents \xbb",
                    Risk: "Ligne fixe. Une connexion simple balaie les caprices."
                },
                "139": {
                    Company_Name: "Z Catastrophe Corporation",
                    Description: "Quand tout s\u2019\xe9croule d\u2019un coup, tout, tout de suite.",
                    Out_put: "Trag\xe9dies et fiascos qui retournent la table",
                    Risk: "Banalit\xe9. Une vie plate et pr\xe9visible n\u2019alimente pas le drame."
                },
                "140": {
                    Company_Name: "Z Batteries Industries",
                    Description: "Ces objets qui meurent plus vite que pr\xe9vu (toujours au mauvais moment).",
                    Out_put: "Garder les appareils en vie malgr\xe9 l\u2019h\xe9morragie d\u2019\xe9nergie",
                    Risk: "Prise murale. Branch\xe9 au r\xe9seau, la batterie ne compte plus."
                },
                "141": {
                    Company_Name: "Z Stress Informatique Syst\xe8mes",
                    Description: "La vie moderne quand une pomme a un ver.",
                    Out_put: "Tension mentale et physique due aux pannes et bugs",
                    Risk: "Forums utiles. Quand la solution est \xe0 port\xe9e, la rage retombe."
                },
                "142": {
                    Company_Name: "Z Une Barre Technologies",
                    Description: "Gr\xe9sillements, 3G mollasson, roue qui tourne.",
                    Out_put: "Isolement et stress d\u2019\xeatre d\xe9connect\xe9",
                    Risk: "Bonne couverture. Beaucoup de barres, beaucoup de paix."
                },
                "143": {
                    Company_Name: "Z Erreur Port 411 Syst\xe8mes",
                    Description: "Quand le syst\xe8me plante et refuse de rena\xeetre.",
                    Out_put: "Arr\xeat brutal qui fige le progr\xe8s et s\xe8me le doute",
                    Risk: "Tutoriel. Le savoir transforme l\u2019erreur en le\xe7on."
                },
                "144": {
                    Company_Name: "Z Service Client Corporation",
                    Description: "Quand c\u2019est cass\xe9, ils aident\u2026 ou font semblant.",
                    Out_put: "Aide fournie pour r\xe9soudre un souci \u2014 sinc\xe8re ou cosm\xe9tique",
                    Risk: "Robot de tchat. Le \xab non-secours \xbb le plus inutile du monde."
                },
                "145": {
                    Company_Name: "Z Coolitude Corporation",
                    Description: "Assurance muette, charme sans effort, vibe imparable.",
                    Out_put: "Avoir la d\xe9gaine et l\u2019aura qui vont avec",
                    Risk: "Suiveurs. Si l\u2019on copie pour valider, la coolitude perd sa valeur."
                },
                "146": {
                    Company_Name: "Zo Fort Incorporated",
                    Description: "Talent, savoir-faire et bont\xe9 l\xe0 o\xf9 \xe7a compte.",
                    Out_put: "Satisfaction tangible n\xe9e de l\u2019excellence et de la gentillesse",
                    Risk: "Le Mal. Quand l\u2019excellence est ignor\xe9e, \xab \xeatre bon \xbb ne paie plus."
                },
                "147": {
                    Company_Name: "L\xe2cher Prise Corporation",
                    Description: "Avancer et trouver la paix en l\xe2chant prise.",
                    Out_put: "Soulagement par l\u2019acceptation du pass\xe9",
                    Risk: "Anxi\xe9t\xe9. Un esprit accroch\xe9 aux soucis ne l\xe2che rien."
                },
                "148": {
                    Company_Name: "Z Encore & Encore Incorpor\xe9e",
                    Description: "La nature cyclique de la vie et ses boucles tenaces.",
                    Out_put: "Influence des r\xe9p\xe9titions et routines sur le r\xe9el",
                    Risk: "Vacances. Une rupture de rythme casse le cycle."
                },
                "149": {
                    Company_Name: "Z Acheteur Incorpor\xe9e",
                    Description: "Prendre soin du consommateur qui sommeille en chacun.",
                    Out_put: "Accumulation d\u2019objets et de petites joies \xe0 la caisse",
                    Risk: "Pas d\u2019argent. Sans budget, la fr\xe9n\xe9sie ralentit."
                },
                "150": {
                    Company_Name: "Z Agonie Corporation",
                    Description: "Le pan de vie d\xe9fini par la douleur, physique ou morale.",
                    Out_put: "R\xe9action br\xfblante au souffrir \u2014 v\xe9cu ou observ\xe9",
                    Risk: "Bonheur. Quand le bien-\xeatre dure, la douleur perd le micro."
                },
                "151": {
                    Company_Name: "Z Parce Que Je Le Dis Corporation",
                    Description: "Pourquoi ? Parce que je le pense. Point.",
                    Out_put: "Conviction exprim\xe9e sans preuve, mais avec aplomb",
                    Risk: "Aphonie. Sans voix, la certitude reste coinc\xe9e."
                },
                "152": {
                    Company_Name: "On Va Tous Mourir Corporation",
                    Description: "Courir tant qu\u2019on peut : personne ne sort d\u2019ici vivant.",
                    Out_put: "D\xe9termination t\xe9m\xe9raire \xe0 vivre pleinement, conscience de la fin",
                    Risk: "Pr\xe9voir. Planifier l\u2019avenir freine l\u2019\xe9lan casse-cou."
                },
                "153": {
                    Company_Name: "Zo Addict Incorpor\xe9e",
                    Description: "Envie plus forte que la volont\xe9 \u2014 et te voil\xe0 accro.",
                    Out_put: "D\xe9sir qui d\xe9borde l\u2019autocontr\xf4le et cr\xe9e la d\xe9pendance",
                    Risk: "Abstinence. Renoncer \xe0 l\u2019objet du manque coupe les revenus."
                },
                "154": {
                    Company_Name: "Z Expliquer Corporation",
                    Description: "Rendre les id\xe9es claires, une bouch\xe9e \xe0 la fois.",
                    Out_put: "D\xe9montage de concepts complexes en savoir digeste",
                    Risk: "Hurler. Crier n\u2019a jamais am\xe9lior\xe9 la compr\xe9hension."
                },
                "155": {
                    Company_Name: "Zoriginal Technologies",
                    Description: "Ne pas faire comme les autres.",
                    Out_put: "Cr\xe9ation distincte et identit\xe9 authentique qui se d\xe9marquent",
                    Risk: "Copie. Quand l\u2019imitation r\xe8gne, l\u2019unique se dilue."
                },
                "156": {
                    Company_Name: "Plein de Z\u2026 Corporation",
                    Description: "Avoir toutes les r\xe9ponses \u2014 aucune de correcte.",
                    Out_put: "Discours convaincant mais creux pour garder la main",
                    Risk: "Se taire. Le silence coupe le courant du baratin."
                },
                "157": {
                    Company_Name: "Z Reclus Corporation",
                    Description: "Rester chez soi pour \xe9viter le vacarme du monde.",
                    Out_put: "Maison, pyjama, paix \u2014 et porte close",
                    Risk: "Beau temps. Quand dehors invite, dedans perd son charme."
                },
                "158": {
                    Company_Name: "Zo R\xe9ussi Corporation",
                    Description: "Quand ce que tu fais\u2026 marche.",
                    Out_put: "Objectifs atteints avec r\xe9sultats tangibles",
                    Risk: "\xc9chec. Si \xe7a ne marche pas, \xe7a n\u2019existe pas."
                },
                "159": {
                    Company_Name: "Zo 9-\xe0-5 Incorpor\xe9e",
                    Description: "La routine pour gagner sa vie (plut\xf4t 9-\xe0-8).",
                    Out_put: "Travailler pour assurer besoins et stabilit\xe9",
                    Risk: "\xc9puisement. Quand la fatigue d\xe9passe le salaire, la m\xe9canique casse."
                },
                "160": {
                    Company_Name: "Z Parler \xe0 Zoi Corporation",
                    Description: "Quand personne n\u2019\xe9coute, raconte-toi\u2026 \xe0 toi.",
                    Out_put: "Dialogue auto-aliment\xe9, \xe0 voix haute ou dans la t\xeate",
                    Risk: "Vie sociale. Si le monde r\xe9pond, le monologue n\u2019a plus lieu d\u2019\xeatre."
                },
                "161": {
                    Company_Name: "Zo Intellectuel M\xe9dia Corporation",
                    Description: "Le socle pour se fabriquer un meilleur cerveau\u2026 qui parfois tourne en rond.",
                    Out_put: "Construire et \xe9tendre le savoir, forger des id\xe9es et aff\xfbter l\u2019esprit",
                    Risk: "R\xe9seaux sociaux. La consommation passive remplace l\u2019effort intellectuel actif."
                },
                "162": {
                    Company_Name: "Z Grignote Corporation",
                    Description: "Le petit plaisir de picorer entre les repas.",
                    Out_put: "Grignotage en douce, juste une bouch\xe9e\u2026 ou deux",
                    Risk: "R\xe9gime. La restriction coupe court au plaisir improvis\xe9."
                },
                "163": {
                    Company_Name: "Zo Ferklempt M\xe9dia",
                    Description: "Ces vagues d\u2019\xe9motion \u2014 amour, culpabilit\xe9, vie \u2014 qui nouent la gorge.",
                    Out_put: "Submerg\xe9 d\u2019\xe9motions : on est tout chavir\xe9",
                    Risk: "Zen. L\u2019\xe9quilibre \xe9motionnel est notre kryptonite."
                },
                "164": {
                    Company_Name: "Zo Parano Corporation",
                    Description: "Mettre en lumi\xe8re la suspicion qui gr\xe9sille et l\u2019inqui\xe9tude qui gratte.",
                    Out_put: "Hypervigilance et soup\xe7on qui poussent \xe0 se blinder",
                    Risk: "Assurance int\xe9rieure. Quand on se sent en s\xe9curit\xe9, la parano s\u2019\xe9teint."
                },
                "165": {
                    Company_Name: "Zo Honn\xeate Corporation",
                    Description: "Tendance incurable \xe0 pencher vers la v\xe9rit\xe9, quoi qu\u2019il en co\xfbte.",
                    Out_put: "Franchise qui tranche les flous et d\xe9gonfle les mensonges",
                    Risk: "Diplomatie. Quand la forme prime, la v\xe9rit\xe9 brute g\xeane."
                },
                "166": {
                    Company_Name: "Faux Z Corporation",
                    Description: "Quand l\u2019authenticit\xe9 manque mais qu\u2019on joue quand m\xeame le r\xf4le.",
                    Out_put: "Pr\xe9senter un faux soi, dissonance entre para\xeetre et \xeatre",
                    Risk: "Honn\xeatet\xe9. Quand la sinc\xe9rit\xe9 r\xe8gne, plus besoin de masque."
                },
                "167": {
                    Company_Name: "Z Fiert\xe9 Technologies",
                    Description: "Joie et assurance d\u2019\xeatre fier de son identit\xe9 et de ses r\xe9ussites.",
                    Out_put: "Valeur personnelle tir\xe9e des accomplissements et du statut",
                    Risk: "\xc9chec. Les attentes qui s\u2019effondrent rappellent \xe0 l\u2019ego la r\xe9alit\xe9."
                },
                "168": {
                    Company_Name: "Z Souvenirs Incorpor\xe9e",
                    Description: "Se rappeler ceci, cela, tout cela \u2014 seul ou \xe0 plusieurs.",
                    Out_put: "La joie de revivre hier et de partager la nostalgie",
                    Risk: "Futur. Quand on regarde devant, le pass\xe9 l\xe2che prise."
                },
                "169": {
                    Company_Name: "Z T\xe9l\xe9phonie Technologies",
                    Description: "R\xe9duire les distances et nourrir le lien, en direct et fort.",
                    Out_put: "Communication audio en temps r\xe9el",
                    Risk: "Batterie morte. Plus d\u2019appareil, plus de conversation."
                },
                "170": {
                    Company_Name: "Z Payer les Factures Corporation",
                    Description: "La qu\xeate sans fin pour honorer les obligations du mois.",
                    Out_put: "N\xe9cessit\xe9 constante de r\xe9gler, budg\xe9ter, couvrir",
                    Risk: "Ch\xf4mage. Plus de revenus : les factures changent\u2026 de priorit\xe9."
                },
                "171": {
                    Company_Name: "Z Karma Incorpor\xe9e",
                    Description: "Le grand \xe9quilibre actions/cons\xe9quences \u2014 l\u2019\xe9ternel d\xe9bat du juste.",
                    Out_put: "Justice cosmique proportionn\xe9e au comportement",
                    Risk: "Mauvaise \xe9ducation. Si rien n\u2019a de suites, le syst\xe8me se casse."
                },
                "172": {
                    Company_Name: "Z Menteur Corporation",
                    Description: "Quand la v\xe9rit\xe9 est trop lourde, on s\u2019en passe.",
                    Out_put: "V\xe9rit\xe9 tordue et perception trafiqu\xe9e : la tromperie",
                    Risk: "Conscience. Avec une boussole morale, mentir devient inutile."
                },
                "173": {
                    Company_Name: "Z Regarder le Match M\xe9dia",
                    Description: "Bi\xe8re, canap\xe9, grand \xe9cran, arbitrage pourri \u2014 amour du jeu quand m\xeame.",
                    Out_put: "Divertissement et sujets de causerie collective",
                    Risk: "Hors saison. Sans matchs, l\u2019union se met en pause."
                },
                "174": {
                    Company_Name: "Zo Achev\xe9 \xe0 Terre Incorpor\xe9e",
                    Description: "Quand on te rajoute une couche alors que tu es d\xe9j\xe0 \xe0 plat.",
                    Out_put: "\xcatre sap\xe9, frein\xe9, \xe9cras\xe9 par des forces hors de contr\xf4le",
                    Risk: "Coup de main. Le soutien transforme la rage en ressort."
                },
                "175": {
                    Company_Name: "Tout Ze Passe Bien Corporation",
                    Description: "Quand tout glisse et que tout marche.",
                    Out_put: "Avanc\xe9e fluide sans obstacle ni r\xe9sistance",
                    Risk: "La Vie. L\u2019impr\xe9vu adore casser les trajectoires parfaites."
                },
                "176": {
                    Company_Name: "Zuch un Bon Nigaud Corporation",
                    Description: "Nos belles bourdes pr\xe9f\xe9r\xe9es \u2014 embrasser le faux pas.",
                    Out_put: "Ne pas comprendre\u2026 et apprendre en se trompant",
                    Risk: "Retenue. Prendre le temps et peser ses r\xe9ponses coupe la casse."
                },
                "177": {
                    Company_Name: "Z Surfeur du Web Technologies",
                    Description: "Vagues de savoir, bobards, d\xe9tours, magouilles et\u2026 vous voyez.",
                    Out_put: "Tout, n\u2019importe quoi, tout le temps",
                    Risk: "Blackout. Pas de courant, pas de toile."
                },
                "178": {
                    Company_Name: "Zo Cr\xe9atif Incorpor\xe9e",
                    Description: "Faire na\xeetre quelque chose \xe0 partir de rien.",
                    Out_put: "Transformer l\u2019imagination en r\xe9alit\xe9 tangible",
                    Risk: "Sur-stimulation. Trop d\u2019entr\xe9es \xe9touffent la cr\xe9ation."
                },
                "179": {
                    Company_Name: "Zo Fain\xe9anter Corporation",
                    Description: "Devenir un avec le canap\xe9. Mollement.",
                    Out_put: "Se fondre dans le confort sans urgence aucune",
                    Risk: "Beaucoup de boulot. Quand les t\xe2ches s\u2019empilent, la sieste devient luxe."
                },
                "180": {
                    Company_Name: "Zo Styl\xe9 Corporation",
                    Description: "Faire une d\xe9claration par l\u2019habit et la singularit\xe9.",
                    Out_put: "Projection de soi par la mode et l\u2019allure",
                    Risk: "Indiff\xe9rence. Si personne ne s\u2019en soucie, l\u2019effet tombe."
                },
                "181": {
                    Company_Name: "Z S\u2019habiller Corporation",
                    Description: "L\u2019habit comme expression de soi et premi\xe8re impression.",
                    Out_put: "Choisir la tenue du jour et l\u2019enfiler dignement",
                    Risk: "Panier sale. Sans linge propre, le style perd sa magie."
                },
                "182": {
                    Company_Name: "Z Observation Incorpor\xe9e",
                    Description: "D\xe9couvrir en regardant et en \xe9coutant vraiment.",
                    Out_put: "Rep\xe9rer des motifs et d\xe9cider mieux en pr\xeatant attention",
                    Risk: "Fatigue. L\u2019esprit \xe9puis\xe9 confond observer et vagabonder."
                },
                "183": {
                    Company_Name: "Z Questionner Corporation",
                    Description: "La compr\xe9hension par l\u2019art de la bonne question.",
                    Out_put: "Curiosit\xe9 + esprit critique pour demander \xab pourquoi ? \xbb",
                    Risk: "Je-m\u2019en-foutisme. L\u2019indiff\xe9rence tue l\u2019enqu\xeate."
                },
                "184": {
                    Company_Name: "Z Lecteur Incorpor\xe9e",
                    Description: "Boire les pages des biblioth\xe8ques du monde.",
                    Out_put: "Absorber savoirs, capitaux de vue et exp\xe9riences par la lecture",
                    Risk: "\xc9puisement. Quand on tombe de sommeil, lire devient impossible."
                },
                "185": {
                    Company_Name: "Z Gommage & \xc9clat Corporation",
                    Description: "Frais de la t\xeate aux pieds : soin de soi et peau qui chante.",
                    Out_put: "Propret\xe9, revitalisation et chouchoutage personnel",
                    Risk: "Camping. Quand l\u2019hygi\xe8ne passe derri\xe8re, l\u2019entretien s\u2019\xe9vapore."
                },
                "186": {
                    Company_Name: "Z Lave-Mains Corporation",
                    Description: "Savonner pour l\u2019hygi\xe8ne, un bon frottage \xe0 la fois.",
                    Out_put: "Mains propres, sans microbes ni virus",
                    Risk: "Pas de savon. Sans outil, la propret\xe9 se d\xe9bine."
                },
                "187": {
                    Company_Name: "Z Programmation Technologie",
                    Description: "Des 1 et des 0 pour faire tourner le monde num\xe9rique.",
                    Out_put: "Programmes fonctionnels qui font ce qu\u2019ils doivent",
                    Risk: "Bugs. Quand le code ne calcule plus, tout coince."
                },
                "188": {
                    Company_Name: "Zo Attractif Corporation",
                    Description: "Ces qualit\xe9s qui captivent \u2014 dedans comme dehors.",
                    Out_put: "Attrait physique, \xe9motionnel et mental qui \xe9veille le d\xe9sir",
                    Risk: "Flemme. Sans effort, l\u2019\xe9clat se ternit."
                },
                "189": {
                    Company_Name: "Ze S\xe9duction Incorpor\xe9e",
                    Description: "L\u2019art de l\u2019aimantation : charme, envie, magn\xe9tisme.",
                    Out_put: "Force d\u2019attirance qui entra\xeene et envo\xfbte",
                    Risk: "Indiff\xe9rence. Si personne n\u2019accroche, la magie s\u2019\xe9vanouit."
                },
                "190": {
                    Company_Name: "Z C\xe9l\xe9bration & Cie",
                    Description: "Faire grimper la joie lors des grands et petits moments.",
                    Out_put: "Rituels, tabl\xe9es et \xe9clats qui amplifient l\u2019occasion",
                    Risk: "Alcool. L\u2019exc\xe8s transforme la f\xeate en chaos."
                },
                "191": {
                    Company_Name: "Z R\xe9flexion Inc.",
                    Description: "Soutenir la croissance personnelle et l\u2019introspection.",
                    Out_put: "Se conna\xeetre, se corriger, \xe9voluer \u2014 doucement mais s\xfbrement",
                    Risk: "Ego. \xcatre toujours \xab s\xfbr d\u2019avoir raison \xbb bloque le miroir."
                },
                "192": {
                    Company_Name: "Z Aventure Groupe",
                    Description: "Oser explorer loin de sa zone de confort.",
                    Out_put: "Exp\xe9riences qui bousculent et stimulent corps et esprit",
                    Risk: "Peur. Trop effray\xe9 : l\u2019aventure meurt avant le d\xe9part."
                },
                "193": {
                    Company_Name: "Z Harmonie Industries",
                    Description: "Trouver l\u2019\xe9quilibre et la paix dans ce qu\u2019on fait.",
                    Out_put: "Rythme, flux et douceur pour une existence paisible",
                    Risk: "Chaos. Quand tout s\u2019emballe, l\u2019harmonie sort du cadre."
                },
                "194": {
                    Company_Name: "Z Perte Inc.",
                    Description: "Apprivoiser le deuil et l\u2019absence.",
                    Out_put: "Douleur et chagrin au c\u0153ur et dans la t\xeate",
                    Risk: "Zone de confort. Rester \xe0 l\u2019abri peut retarder la rencontre\u2026 un temps."
                },
                "195": {
                    Company_Name: "Z Passion Sans Limites",
                    Description: "Faire quoi que ce soit avec toute l\u2019intensit\xe9 possible.",
                    Out_put: "\xc9nergie d\xe9vorante pour aimer, cr\xe9er et aller au bout",
                    Risk: "Alzheimer. Quand le souvenir s\u2019efface, la flamme se morcelle."
                },
                "196": {
                    Company_Name: "Z R\xe9silience Works",
                    Description: "Continuer \xe0 avancer quand \xe7a tape dur.",
                    Out_put: "Tenir bon, s\u2019adapter et progresser malgr\xe9 l\u2019adversit\xe9",
                    Risk: "Crash. Au point de rupture, m\xeame la r\xe9silience plie."
                },
                "197": {
                    Company_Name: "Z Curiosit\xe9 Labs",
                    Description: "La qu\xeate \xe0 vie du \xab pourquoi \xbb \xe9merveill\xe9.",
                    Out_put: "Chercher l\u2019inconnu et ouvrir des portes",
                    Risk: "Conformisme. Suivre la norme n\u2019a pas de place pour \xab pourquoi \xbb."
                },
                "198": {
                    Company_Name: "Z Triomphe Corporation",
                    Description: "Mettre en valeur les victoires, petites et grandes.",
                    Out_put: "Sentiment d\u2019avoir gagn\xe9 sa journ\xe9e",
                    Risk: "Deuxi\xe8me place. Ne pas gagner, c\u2019est\u2026 ne pas gagner."
                },
                "199": {
                    Company_Name: "Z B\xe2tisseurs de Communaut\xe9",
                    Description: "Tisser des liens par des exp\xe9riences partag\xe9es.",
                    Out_put: "Soutien et s\xe9curit\xe9 autour de ce qui soude le groupe",
                    Risk: "Individualisme. Quand le \xab moi \xbb \xe9crase le \xab nous \xbb."
                },
                "200": {
                    Company_Name: "ZO Bourr\xe9 Company",
                    Description: "Quand la vie vous m\xe8ne \xe0 l\u2019ivresse. *Hic, hic.*",
                    Out_put: "T\xeate qui tourne, langue qui fourche, plus de filtres",
                    Risk: "Responsabilit\xe9. Boire en adulte garde le taux dans le vert."
                },
                "201": {
                    Company_Name: "Marche-dans-la-Merde Soci\xe9t\xe9",
                    Description: "Zut, encore le pied dedans\u2026",
                    Out_put: "R\xe9flexe d\xe9go\xfbt\xe9 et nettoyage express, puis auto-d\xe9rision pour survivre \xe0 l\u2019odeur.",
                    Risk: "Glissade, col\xe8re dramatique, traces partout."
                },
                "202": {
                    Company_Name: "Tractus Digestif Syst\xe8mes",
                    Description: "Transformer le casse-cro\xfbte en carburant\u2026 ou en catastrophe.",
                    Out_put: "\xc9nergie, assimilation, \xe9vacuation harmonieuse (dans les bons jours).",
                    Risk: "Ballonnements, crampes, lenteur, d\xe9r\xe8glement g\xe9n\xe9ral."
                },
                "203": {
                    Company_Name: "Auto-C\xe2lin Industries",
                    Description: "Solo, discret, efficace \u2014 avec ou sans film du soir.",
                    Out_put: "D\xe9tente, soulagement, intimit\xe9 personnelle sans rendez-vous.",
                    Risk: "Culpabilit\xe9, exc\xe8s, isolement, perte d\u2019\xe9lan social."
                },
                "204": {
                    Company_Name: "Z Miam Industries",
                    Description: "Mettre quelque chose de bon dans la bouche pour rester vivant.",
                    Out_put: "Sati\xe9t\xe9, force, bonne humeur et traditions \xe0 table.",
                    Risk: "Frigo vide, surconsommation, culpabilit\xe9 et gaspillage."
                },
                "205": {
                    Company_Name: "Z Crac Entreprises",
                    Description: "Le son brutal qui dit que quelque chose vient de casser.",
                    Out_put: "Rupture nette : de l\u2019objet au moral, \xe7a fait toujours mal.",
                    Risk: "Casse r\xe9p\xe9t\xe9e, co\xfbts cach\xe9s, perte de confiance."
                },
                "206": {
                    Company_Name: "Rire Z\xe9l\xe9 Corporation",
                    Description: "Quand le fou rire prend le dessus, impossible de s\u2019arr\xeater.",
                    Out_put: "Larmes aux yeux, ventre douloureux, mais \xe2me l\xe9g\xe8re.",
                    Risk: "Inopportunit\xe9, moqueries, malaise social."
                },
                "207": {
                    Company_Name: "Z Gaffe Industries",
                    Description: "Le moment g\xeanant qu\u2019on aurait pr\xe9f\xe9r\xe9 \xe9viter.",
                    Out_put: "Rougeurs, excuses maladroites, rires parfois complices.",
                    Risk: "Humiliation, perte de cr\xe9dibilit\xe9, rancunes."
                },
                "208": {
                    Company_Name: "\xc9ternuement Z Soci\xe9t\xe9",
                    Description: "Le r\xe9flexe explosif qui lib\xe8re mais surprend.",
                    Out_put: "Soulagement imm\xe9diat, regards d\xe9tourn\xe9s ou b\xe9n\xe9diction attendue.",
                    Risk: "Microbes dispers\xe9s, malaise en public, crise d\u2019allergie."
                },
                "209": {
                    Company_Name: "Z Amour Fou Corporation",
                    Description: "La passion d\xe9vorante qui fait tout vibrer.",
                    Out_put: "Fusion, exaltation, \xe9nergie cr\xe9atrice.",
                    Risk: "D\xe9pendance, jalousie, c\u0153ur bris\xe9."
                },
                "210": {
                    Company_Name: "Insomnie Z Syst\xe8mes",
                    Description: "Compter les moutons jusqu\u2019\xe0 l\u2019aube sans jamais dormir.",
                    Out_put: "Yeux cern\xe9s, id\xe9es confuses, productivit\xe9 en chute.",
                    Risk: "Burnout, anxi\xe9t\xe9, perte de sant\xe9 mentale."
                },
                "211": {
                    Company_Name: "Z Gueule de Bois Industries",
                    Description: "Le r\xe9veil brutal apr\xe8s la f\xeate.",
                    Out_put: "Soif extr\xeame, mal de t\xeate et promesse de \u2018plus jamais\u2019.",
                    Risk: "R\xe9p\xe9tition, sant\xe9 ab\xeem\xe9e, productivit\xe9 d\xe9truite."
                },
                "212": {
                    Company_Name: "Z Mensonge Corporation",
                    Description: "L\u2019art de tordre la v\xe9rit\xe9 pour survivre ou s\xe9duire.",
                    Out_put: "Protection, manipulation, gain temporaire.",
                    Risk: "Perte de confiance, pi\xe8ge des mensonges accumul\xe9s."
                },
                "213": {
                    Company_Name: "Z V\xe9rit\xe9 Brutale Industries",
                    Description: "Dire tout haut ce que personne ne voulait entendre.",
                    Out_put: "Clart\xe9, authenticit\xe9, parfois lib\xe9ration.",
                    Risk: "Blessures, conflits, solitude."
                },
                "214": {
                    Company_Name: "Panne Totale Soci\xe9t\xe9",
                    Description: "Quand tout s\u2019arr\xeate soudainement.",
                    Out_put: "Silence, chaos, obligation d\u2019improviser.",
                    Risk: "Pertes, panique, paralysie du syst\xe8me."
                },
                "215": {
                    Company_Name: "Z Frisson Corporation",
                    Description: "Ce fr\xe9missement qui parcourt la peau au son ou au froid.",
                    Out_put: "Chair de poule, excitation, mont\xe9e d\u2019adr\xe9naline.",
                    Risk: "Froid, peur exag\xe9r\xe9e, hypersensibilit\xe9."
                },
                "216": {
                    Company_Name: "Z Col\xe8re Noire Industries",
                    Description: "Quand la rage monte et qu\u2019on explose.",
                    Out_put: "Cri, geste brusque, lib\xe9ration violente.",
                    Risk: "Ruptures, regrets, d\xe9g\xe2ts collat\xe9raux."
                },
                "217": {
                    Company_Name: "Z Faim de Loup Soci\xe9t\xe9",
                    Description: "Le ventre qui crie plus fort que la raison.",
                    Out_put: "D\xe9vorer sans attendre, plaisir animal.",
                    Risk: "Exc\xe8s, indigestion, impatience sociale."
                },
                "218": {
                    Company_Name: "Z Joie Pure Corporation",
                    Description: "L\u2019instant simple o\xf9 tout para\xeet parfait.",
                    Out_put: "Sourires partag\xe9s, l\xe9g\xe8ret\xe9 contagieuse.",
                    Risk: "\xc9ph\xe9m\xe8re, nostalgie en retour, jalousie des autres."
                },
                "219": {
                    Company_Name: "Z Tristesse Industries",
                    Description: "Les larmes silencieuses qui noient la poitrine.",
                    Out_put: "Lib\xe9ration, introspection, authenticit\xe9 \xe9motionnelle.",
                    Risk: "Isolement, d\xe9pression, incompr\xe9hension."
                },
                "220": {
                    Company_Name: "Z Panique Corporation",
                    Description: "Quand tout semble hors de contr\xf4le en un instant.",
                    Out_put: "Fuite, cris, gestes d\xe9sordonn\xe9s.",
                    Risk: "Erreurs fatales, perte de cr\xe9dibilit\xe9, traumatisme."
                },
                "221": {
                    Company_Name: "Z Descente en Spirale Transports",
                    Description: "Br\xfbler la chandelle par les deux bouts, \xe0 son propre d\xe9triment.",
                    Out_put: "Auto-sabotage : relations, sant\xe9 et bonheur partent en vrille.",
                    Risk: "Responsabilit\xe9. Avec cadre et discipline, la chute ralentit."
                },
                "222": {
                    Company_Name: "Z Inspir\xe9es Industries",
                    Description: "Mots, images et sons qui te hissent plus haut.",
                    Out_put: "L\u2019\xe9lan de faire : l\u2019\xe9tincelle cr\xe9ative qui met en route.",
                    Risk: "Post-modernisme. Si tout est vain, \xe0 quoi bon ?"
                },
                "223": {
                    Company_Name: "Z Irrationnel Corporation",
                    Description: "La peur de la catastrophe au coin de la rue.",
                    Out_put: "Anticipation anxieuse qui d\xe9forme la r\xe9alit\xe9.",
                    Risk: "Logique. Un esprit rationnel dissipe la trouille."
                },
                "224": {
                    Company_Name: "Zo Hyst\xe9rique Corporation",
                    Description: "Le chaos d\xe9brid\xe9, comme si tes cheveux br\xfblaient.",
                    Out_put: "Agitation incontr\xf4l\xe9e : tout part en sucette.",
                    Risk: "Calme. Un esprit pos\xe9 \xe9teint l\u2019hyst\xe9rie."
                },
                "225": {
                    Company_Name: "Z Empereur Soci\xe9t\xe9",
                    Description: "Marcher comme si tu r\xe9gnais sur ton royaume.",
                    Out_put: "Croyance souveraine en sa propre autorit\xe9.",
                    Risk: "R\xe9alit\xe9. Une bonne dose d\u2019humilit\xe9 te redescend."
                },
                "226": {
                    Company_Name: "Z Chaotique Inc.",
                    Description: "La pagaille totale dans le tourbillon de la vie.",
                    Out_put: "D\xe9sordre, impr\xe9visible et incontr\xf4lable.",
                    Risk: "M\xe9ditation. L\u2019immobilit\xe9 remet de l\u2019ordre."
                },
                "227": {
                    Company_Name: "Zo Micro-agressions Industries",
                    Description: "Les petites piq\xfbres de mots et gestes qui laissent des traces.",
                    Out_put: "Blessures minuscules, effets bien r\xe9els.",
                    Risk: "Politesse. Un soup\xe7on de courtoisie change tout."
                },
                "228": {
                    Company_Name: "Z Danse Inc.",
                    Description: "Bouger sur le groove \u2014 seul\xb7e ou ensemble.",
                    Out_put: "Corps en rythme, lien par le mouvement.",
                    Risk: "Pas de musique. Sans battement, m\xeame les meilleurs h\xe9sitent."
                },
                "229": {
                    Company_Name: "Z Effondrement Inc.",
                    Description: "Quand la lumi\xe8re vacille et que tout s\u2019\xe9croule.",
                    Out_put: "Ruine \xe9motionnelle et structurelle.",
                    Risk: "Succ\xe8s. Quand \xe7a marche, l\u2019effondrement s\u2019\xe9clipse."
                },
                "230": {
                    Company_Name: "Zo Heureux Corporation",
                    Description: "La joie quand \xe7a se passe comme tu voulais.",
                    Out_put: "Contentement et plaisir \xe0 l\u2019\xe9tat pur.",
                    Risk: "Complication. Trop r\xe9fl\xe9chir efface le sourire."
                },
                "231": {
                    Company_Name: "Zo Insomnie Corporation",
                    Description: "Yeux ferm\xe9s, cerveau allum\xe9 : dormir ? Que dalle.",
                    Out_put: "Impossible de dormir, l\u2019esprit en moulinette.",
                    Risk: "M\xe9dicaments. La chimie peut court-circuiter la veille."
                },
                "232": {
                    Company_Name: "Z Douleurs d\u2019Estomac Syst\xe8mes",
                    Description: "Gaz, ballonnements, ulc\xe8res : le ventre en vrac.",
                    Out_put: "Inconfort visc\xe9ral qui envahit tout.",
                    Risk: "M\xe9dicaments. La chimie r\xe9\xe9quilibre (parfois)."
                },
                "233": {
                    Company_Name: "Zo Honte Corporation",
                    Description: "Ce fichu sentiment d\u2019avoir trop merd\xe9.",
                    Out_put: "G\xeane, culpabilit\xe9, rouge aux joues.",
                    Risk: "Pardon. L\u2019acceptation dissout la honte."
                },
                "234": {
                    Company_Name: "Z Ascension Inc.",
                    Description: "Cap vers l\u2019azur : grimper vers sa r\xe9ussite.",
                    Out_put: "\xc9lan ascendant d\u2019ambition et de progr\xe8s.",
                    Risk: "\xc9chec. Un accroc et la mont\xe9e s\u2019arr\xeate."
                },
                "235": {
                    Company_Name: "Z & Cl\xe9op\xe2tre Banque Relationnelle",
                    Description: "Ta relation \xe0 deux.",
                    Out_put: "Amour, intimit\xe9, s\xe9curit\xe9 \xe9motionnelle.",
                    Risk: "Conflit. La dispute vide le compte affectif."
                },
                "236": {
                    Company_Name: "Zo En Retard Corporation",
                    Description: "Quand l\u2019heure passe et toi non.",
                    Out_put: "Temps vol\xe9 aux autres, tension assur\xe9e.",
                    Risk: "Respect. Se soucier du temps d\u2019autrui."
                },
                "237": {
                    Company_Name: "Zo Charme Corporation",
                    Description: "S\xe9duction + esprit + verbe bien tourn\xe9.",
                    Out_put: "Fluidit\xe9 des \xe9changes, portes qui s\u2019ouvrent.",
                    Risk: "Inauthenticit\xe9. Vu comme manip, \xe7a se retourne."
                },
                "238": {
                    Company_Name: "Zo D\xe9bord\xe9 Inc.",
                    Description: "Trop, trop vite, tout en m\xeame temps.",
                    Out_put: "Poids sur la poitrine, souffle court.",
                    Risk: "M\xe9ditation. Le calme remet du souffle."
                },
                "239": {
                    Company_Name: "Z Professeurs Industries",
                    Description: "Le partage du savoir.",
                    Out_put: "Esprits un brin plus \xe9clair\xe9s qu\u2019avant.",
                    Risk: "Vacances. La boucle s\u2019interrompt."
                },
                "240": {
                    Company_Name: "Zo Efficace Industries",
                    Description: "Aller de A \xe0 B \xe0 la vitesse de l\u2019\xe9clair.",
                    Out_put: "Plus de choses faites, mieux et plus vite.",
                    Risk: "Maladie. Un corps faible coupe l\u2019\xe9lan."
                },
                "241": {
                    Company_Name: "Zo Constip\xe9 Corporation",
                    Description: "Le tronc d\u2019arbre qui refuse la sortie.",
                    Out_put: "Ventre gonfl\xe9, inconfort tenace.",
                    Risk: "Laxatif. La bonne cl\xe9 lib\xe8re l\u2019\xe9cluse."
                },
                "242": {
                    Company_Name: "Zo Affam\xe9 Corporation",
                    Description: "La faim qui gronde et rend grognon.",
                    Out_put: "Irritabilit\xe9 et glyc\xe9mie en berne.",
                    Risk: "Frigo plein. Beaucoup de victuailles, faim au loin."
                },
                "243": {
                    Company_Name: "Z Linge Sale Corporation",
                    Description: "Frotter le linge pour l\u2019odeur de printemps.",
                    Out_put: "Du d\xe9fra\xeechi au frais repass\xe9.",
                    Risk: "Flemme. Sans machine, jamais nickel."
                },
                "244": {
                    Company_Name: "Z Affaires Inc.",
                    Description: "N\xe9gocier et brasser pour que \xe7a marche.",
                    Out_put: "Gagner sa cro\xfbte en vendant ce qu\u2019on fait.",
                    Risk: "R\xe9cession. L\u2019\xe9conomie tousse, tout s\u2019arr\xeate."
                },
                "245": {
                    Company_Name: "Z Chance Corporation",
                    Description: "Le coup du sort qui n\u2019en fait qu\u2019\xe0 sa t\xeate.",
                    Out_put: "Bons hasards, petits tr\xe8fles et grands sourires.",
                    Risk: "Poisse. Quand la chance tourne, fini la magie."
                },
                "246": {
                    Company_Name: "Z Planche Corporation",
                    Description: "Glisser dans la rue avec style.",
                    Out_put: "Plaisir debout sur une planche en mouvement.",
                    Risk: "M\xe9t\xe9o. Pas de vagues, rues tremp\xe9es."
                },
                "247": {
                    Company_Name: "ZEXPO Inc.",
                    Description: "S\u2019engourdir d\xe9licieusement devant l\u2019art \u2014 partout.",
                    Out_put: "Montrer son travail au monde.",
                    Risk: "Gardiens du temple. Sans s\xe9same, personne ne voit."
                },
                "248": {
                    Company_Name: "Z Procrastination Syst\xe8mes",
                    Description: "Ma\xeetres du \xab demain \xbb pendant que l\u2019angoisse gonfle.",
                    Out_put: "T\xe2ches en attente, \xe9ch\xe9ances qui mordent.",
                    Risk: "Deadlines. Une vraie date coupe court."
                },
                "249": {
                    Company_Name: "Z Deuil Corporation",
                    Description: "La profondeur de la perte et du chagrin.",
                    Out_put: "Traverser la douleur pour gu\xe9rir.",
                    Risk: "\xc9go\xefsme. Trop garder pour soi bloque la gu\xe9rison."
                },
                "250": {
                    Company_Name: "Z Confiance Inc.",
                    Description: "Le socle des liens solides.",
                    Out_put: "S\xe9curit\xe9, foi en l\u2019autre, fiabilit\xe9.",
                    Risk: "Trahison. Promesses bris\xe9es et mensonges cassent tout."
                },
                "251": {
                    Company_Name: "Zo Humble Corporation",
                    Description: "Une confiance tranquille, sans fanfaronnade.",
                    Out_put: "Respect mutuel et apprentissage permanent.",
                    Risk: "Ego. Trop d\u2019ego sabote l\u2019humilit\xe9."
                },
                "252": {
                    Company_Name: "Zo G\xe9n\xe9reux Corporation",
                    Description: "Mettre l\u2019autre avant soi, sans ticket de caisse.",
                    Out_put: "G\xe9n\xe9rosit\xe9, sacrifice, gentillesse gratuite.",
                    Risk: "\xc9go\xefsme. Quand le \xab moi \xbb s\u2019impose, \xe7a s\u2019\xe9teint."
                },
                "253": {
                    Company_Name: "Z Maman Compagnie",
                    Description: "L\u2019\xe9treinte nourrici\xe8re : s\xe9curit\xe9, amour, chaleur.",
                    Out_put: "Soin, rep\xe8res, soutien ind\xe9fectible.",
                    Risk: "N\xe9gligence. Sans attention, le lien se d\xe9fait."
                },
                "254": {
                    Company_Name: "Zo Serviable Inc.",
                    Description: "Tendre la main quand il le faut.",
                    Out_put: "All\xe9ger le fardeau, soutenir et faciliter.",
                    Risk: "Indiff\xe9rence. L\u2019\xe9paule froide laisse tout en plan."
                },
                "255": {
                    Company_Name: "Z Altruisme SA",
                    Description: "Faire du bien, sans contrepartie.",
                    Out_put: "Actes gratuits pour le collectif.",
                    Risk: "Exploitation. La bont\xe9 se fait plumer."
                },
                "256": {
                    Company_Name: "Z Unit\xe9 Inc.",
                    Description: "Beaucoup qui ne font plus qu\u2019un.",
                    Out_put: "Objectifs partag\xe9s, \xe9quipe soud\xe9e, la force du nombre.",
                    Risk: "Division. Les conflits d\xe9font les liens."
                },
                "257": {
                    Company_Name: "Z Fraternit\xe9 Industries",
                    Description: "Le lien tacite de la camaraderie et de la confiance.",
                    Out_put: "Au-del\xe0 du sang : loyaut\xe9 et v\xe9cu commun.",
                    Risk: "Trahison. Quand la confiance casse, tout se brise."
                },
                "258": {
                    Company_Name: "Z Po\xe9tique Industries",
                    Description: "L\u2019expression tiss\xe9e en mots, rythme et sens.",
                    Out_put: "Beaut\xe9, profondeur et \xe9motion port\xe9es par la langue.",
                    Risk: "Obscurit\xe9. Sans oreilles, la po\xe9sie se tait."
                },
                "259": {
                    Company_Name: "Z Technologies d\u2019Illustration",
                    Description: "Raconter visuellement, saisir l\u2019id\xe9e en images.",
                    Out_put: "Une clart\xe9 qui parle au-del\xe0 des mots.",
                    Risk: "Flou. Sans nettet\xe9, l\u2019image perd son impact."
                },
                "260": {
                    Company_Name: "Zo Artistique Inc.",
                    Description: "L\u2019essence cr\xe9ative, quel que soit le m\xe9dium.",
                    Out_put: "Imagination, vision et courage de cr\xe9er.",
                    Risk: "Conformisme. La bo\xeete tue la cr\xe9ativit\xe9."
                },
                "261": {
                    Company_Name: "Z Confiance Mutuelle Corp.",
                    Description: "Le socle de toute relation qui dure.",
                    Out_put: "Foi en l\u2019autre : l\u2019adh\xe9sif des liens.",
                    Risk: "Tromperie. Mensonges et trahisons l\u2019effritent."
                },
                "262": {
                    Company_Name: "Z Liens Entreprises",
                    Description: "Rapprocher par l\u2019exp\xe9rience partag\xe9e.",
                    Out_put: "Connexions qui se tissent avec le temps.",
                    Risk: "Isolement. Sans \xe9changes, le lien s\u2019\xe9tiole."
                },
                "263": {
                    Company_Name: "Z Aventures Romantiques",
                    Description: "La qu\xeate d\u2019amour, de passion et de lien profond.",
                    Out_put: "Papillons, \xe9lan et frisson r\xe9ciproque.",
                    Risk: "C\u0153ur bris\xe9. Quand l\u2019amour tourne, la magie s\u2019\xe9teint."
                },
                "264": {
                    Company_Name: "Zo Affectif SA",
                    Description: "Chaleur, attention et tendresse en gestes simples.",
                    Out_put: "Petits signes qui disent \xab je t\u2019aime \xbb.",
                    Risk: "Froideur. Distance et indiff\xe9rence g\xe8lent tout."
                },
                "265": {
                    Company_Name: "Z Attachement Inc.",
                    Description: "Des liens qui rendent les s\xe9parations difficiles.",
                    Out_put: "Confort du lien, peur de perdre l\u2019essentiel.",
                    Risk: "D\xe9tachement. Le fil coup\xe9 laisse le vide."
                },
                "266": {
                    Company_Name: "Z Pleurs Inc.",
                    Description: "Quand l\u2019\xe9motion d\xe9borde et que les larmes coulent.",
                    Out_put: "Lib\xe9ration et vuln\xe9rabilit\xe9 \xe0 ciel ouvert.",
                    Risk: "Suppression. Retenir ne gu\xe9rit rien."
                },
                "267": {
                    Company_Name: "Z Chagrin Industries",
                    Description: "La peine, la tristesse, la morsure de la perte.",
                    Out_put: "R\xe9ponse profonde aux coups de la vie.",
                    Risk: "Temps. Les jours adoucissent les ar\xeates."
                },
                "268": {
                    Company_Name: "Zo M\xe9lancolique M\xe9dia",
                    Description: "Doux-amer des souvenirs, pertes et nostalgies.",
                    Out_put: "Tristesse calme, beaut\xe9 dans le manque.",
                    Risk: "Distraction. Remplir le vide anesth\xe9sie tout."
                },
                "269": {
                    Company_Name: "Z Guidance Inc.",
                    Description: "Cap, conseil et main s\xfbre.",
                    Out_put: "Sagesse et mentorat pour tracer la route.",
                    Risk: "Ignorance. Sans rep\xe8res, on erre."
                },
                "270": {
                    Company_Name: "Z Services de B\xe9n\xe9volat",
                    Description: "Donner temps, \xe9nergie et c\u0153ur aux autres.",
                    Out_put: "Soutien communautaire et acte gratuit.",
                    Risk: "\xc9puisement. M\xeame les d\xe9vou\xe9s br\xfblent."
                },
                "271": {
                    Company_Name: "Z Crainte Inc.",
                    Description: "Le poids d\u2019un mal \xe0 venir, r\xe9el ou non.",
                    Out_put: "Paralysie par la peur dans chaque choix.",
                    Risk: "Courage. Faire face r\xe9tr\xe9cit l\u2019ombre."
                },
                "272": {
                    Company_Name: "Z Hesitation Labs",
                    Description: "La pause avant d\u2019agir, o\xf9 le doute s\u2019attarde.",
                    Out_put: "Trop penser, pas assez faire : occasions perdues.",
                    Risk: "Confiance. Le pas franc casse la boucle."
                },
                "73": {
                    Company_Name: "Z R\xe9flexion Inc.",
                    Description: "Regarder dedans pour clarifier ses pens\xe9es.",
                    Out_put: "Introspection et qu\xeate de compr\xe9hension.",
                    Risk: "Distraction. Le bruit mental brouille tout."
                },
                "274": {
                    Company_Name: "Zo Sentimental Corporation",
                    Description: "Garder les souvenirs, ch\xe9rir le pass\xe9.",
                    Out_put: "Nostalgie et profondeur affective.",
                    Risk: "D\xe9tachement. L\u2019indiff\xe9rence efface tout."
                },
                "275": {
                    Company_Name: "Zo Solutions Spontan\xe9es",
                    Description: "D\xe9cisions vives, parfois g\xe9niales\u2026 parfois non.",
                    Out_put: "Cr\xe9ativit\xe9 sur le vif, adaptabilit\xe9 sous pression.",
                    Risk: "Regret. La pr\xe9cipitation peut co\xfbter cher."
                },
                "276": {
                    Company_Name: "Z Compagnonnage Inc.",
                    Description: "Le r\xe9confort d\u2019\xeatre compris pour de vrai.",
                    Out_put: "Loyaut\xe9, v\xe9cu commun et confiance mutuelle.",
                    Risk: "Solitude. Sans l\u2019autre, le monde refroidit."
                },
                "277": {
                    Company_Name: "Z Terreur Industries",
                    Description: "La peur primale qui agrippe l\u2019\xe2me.",
                    Out_put: "Choc, panique, noirceur tapie hors champ.",
                    Risk: "Bravoure. Le courage desserre l\u2019\xe9tau."
                },
                "278": {
                    Company_Name: "Z Soutien Industries",
                    Description: "La base solide qui tient quand \xe7a tangue.",
                    Out_put: "Encouragement, aide et fiabilit\xe9 sans faille.",
                    Risk: "N\xe9gligence. Sans support, tout s\u2019effrite."
                },
                "279": {
                    Company_Name: "Z Passion Illimit\xe9e",
                    Description: "\xc9lan inlassable, intensit\xe9 br\xfblante, d\xe9sir au volant.",
                    Out_put: "Carburant de l\u2019ambition, de la cr\xe9ation et de l\u2019amour.",
                    Risk: "\xc9puisement. Trop br\xfbler finit par consumer."
                },
                "280": {
                    Company_Name: "Zo Costaud Industrie",
                    Description: "Le cran d\u2019avancer malgr\xe9 tout.",
                    Out_put: "R\xe9silience, endurance et d\xe9termination inoxydable.",
                    Risk: "Faiblesse. Le doute fissure la carapace."
                },
                "281": {
                    Company_Name: "Z Chaleur Entreprises",
                    Description: "L\u2019\xe9treinte douce qui fait fondre le froid.",
                    Out_put: "Confort, bont\xe9 et s\xe9curit\xe9 \xe9motionnelle.",
                    Risk: "Distance. Sans chaleur, le lien se glace."
                },
                "282": {
                    Company_Name: "Z Risque Inc.",
                    Description: "Sauts de foi quand la mise est haute.",
                    Out_put: "Adr\xe9naline, frisson et gains possibles.",
                    Risk: "\xc9chec. Quand \xe7a ne paie pas, \xe7a pique."
                },
                "283": {
                    Company_Name: "Z M\xe9ditation Inc.",
                    Description: "L\u2019art de l\u2019immobilit\xe9 au c\u0153ur du chaos.",
                    Out_put: "Paix int\xe9rieure, clart\xe9 et ma\xeetrise des \xe9motions.",
                    Risk: "Agitation. Un esprit tourment\xe9 refuse la pose."
                },
                "284": {
                    Company_Name: "Z Paisible Industries",
                    Description: "Le calme quand tout s\u2019aligne juste comme il faut.",
                    Out_put: "Harmonie, \xe9quilibre, un monde sans conflit.",
                    Risk: "Perturbation. Un simple remous brise la s\xe9r\xe9nit\xe9."
                },
                "285": {
                    Company_Name: "Z Chill Inc.",
                    Description: "D\xe9tendu, sans stress, prendre la vie comme elle vient.",
                    Out_put: "Relaxation et sang-froid en toutes circonstances.",
                    Risk: "Surcharge. Trop de pression tue le chill."
                },
                "286": {
                    Company_Name: "Z Technologies Non-Conformistes",
                    Description: "Penser autrement, d\xe9fier les normes.",
                    Out_put: "Innovation et puissance d\u2019une vision unique.",
                    Risk: "Conformisme. Le syst\xe8me rigide \xe9touffe l\u2019originalit\xe9."
                },
                "287": {
                    Company_Name: "Z Subversion Inc.",
                    Description: "Saper l\u2019\xe9tabli, contester l\u2019autorit\xe9.",
                    Out_put: "R\xe9volte, d\xe9voilement et d\xe9molition des illusions.",
                    Risk: "R\xe9pression. Le pouvoir qui b\xe2illonne fait taire la dissidence."
                },
                "288": {
                    Company_Name: "Z Penseurs Ind\xe9pendants",
                    Description: "Des id\xe9es libres de toute pression.",
                    Out_put: "Autonomie, courage et pens\xe9e diff\xe9rente.",
                    Risk: "Dogme. Suivre aveugl\xe9ment efface l\u2019ind\xe9pendance."
                },
                "289": {
                    Company_Name: "Z Syst\xe8mes Fiables",
                    Description: "La confiance que \xe7a marchera comme pr\xe9vu.",
                    Out_put: "Stabilit\xe9 et base solide, sans surprises.",
                    Risk: "Panne. Quand la fiabilit\xe9 casse, c\u2019est le chaos."
                },
                "290": {
                    Company_Name: "Z Int\xe9grit\xe9 Industries",
                    Description: "Faire le bien, m\xeame sans t\xe9moin.",
                    Out_put: "Honn\xeatet\xe9 et principes in\xe9branlables.",
                    Risk: "Corruption. Quand l\u2019int\xe9grit\xe9 c\xe8de, la confiance tombe."
                },
                "291": {
                    Company_Name: "Z M\xe9rite Inc.",
                    Description: "La r\xe9ussite gagn\xe9e, pas donn\xe9e.",
                    Out_put: "Reconnaissance et accomplissement authentiques.",
                    Risk: "N\xe9potisme. Les faveurs sabotent le vrai m\xe9rite."
                },
                "292": {
                    Company_Name: "Z Solutions Visionnaires",
                    Description: "Foresight, cr\xe9ativit\xe9 et futur en chantier.",
                    Out_put: "Voir ce que d\u2019autres ne voient pas.",
                    Risk: "Myopie. Sans vision, le potentiel se fane."
                },
                "293": {
                    Company_Name: "Z Jalousie Inc.",
                    Description: "Envie de ce qu\u2019ont les autres, piq\xfbre de comparaison.",
                    Out_put: "M\xe9contentement et regard aiguis\xe9 sur soi.",
                    Risk: "Gratitude. Appr\xe9cier ce qu\u2019on a d\xe9samorce l\u2019envie."
                },
                "294": {
                    Company_Name: "Z Esprits Amers",
                    Description: "Rancune gard\xe9e, n\xe9gativit\xe9 nourrie.",
                    Out_put: "Cynisme lucide et catharsis cr\xe9ative.",
                    Risk: "Pardon. L\xe2cher prise all\xe8ge l\u2019amertume."
                },
                "295": {
                    Company_Name: "Z Leader Tech",
                    Description: "Prendre les r\xeanes et inspirer.",
                    Out_put: "Vision et pouvoir d\u2019orienter les autres.",
                    Risk: "Incomp\xe9tence. Un cap flou m\xe8ne \xe0 l\u2019\xe9chec."
                },
                "296": {
                    Company_Name: "Z Motivator Inc.",
                    Description: "Mettre en mouvement, pousser au meilleur.",
                    Out_put: "\xc9lan, ambition et envie d\u2019atteindre.",
                    Risk: "Apathie. Sans envie, la motivation se perd."
                },
                "297": {
                    Company_Name: "Z Syst\xe8mes d\u2019Influence",
                    Description: "Fa\xe7onner les esprits, guider les tendances.",
                    Out_put: "Persuasion et impact \xe0 grande \xe9chelle.",
                    Risk: "Irrelevance. Quand l\u2019\xe9cho s\u2019\xe9teint, la voix aussi."
                },
                "298": {
                    Company_Name: "Zo Philosophie Entreprises",
                    Description: "Penser l\u2019existence et le sens.",
                    Out_put: "R\xe9flexion profonde et qu\xeate de sagesse.",
                    Risk: "Dogmatisme. La rigidit\xe9 \xe9touffe la pens\xe9e."
                },
                "299": {
                    Company_Name: "Z Esprit & Traits",
                    Description: "Humour vif, intellect tranchant, reparties fines.",
                    Out_put: "Intelligence m\xeal\xe9e de charme et de jeu.",
                    Risk: "Insensibilit\xe9. Sans tact, l\u2019esprit blesse."
                },
                "300": {
                    Company_Name: "Z Sarcasme Inc.",
                    Description: "Dire une chose, en penser une autre, avec piquant.",
                    Out_put: "Ironie, humour et malice assum\xe9e.",
                    Risk: "Contresens. Mal compris, \xe7a fait mal."
                },
                "301": {
                    Company_Name: "Z D\xe9fense Industries",
                    Description: "Tenir bon et prot\xe9ger l\u2019essentiel.",
                    Out_put: "Loyaut\xe9, r\xe9silience et bouclier des faibles.",
                    Risk: "Imprudence. D\xe9fendre aveugl\xe9ment peut nuire."
                },
                "302": {
                    Company_Name: "Zo Extravagant Corporation",
                    Description: "Jamais trop : plus grand, plus brillant, plus fort.",
                    Out_put: "Luxe, exc\xe8s et pur spectacle.",
                    Risk: "Aust\xe9rit\xe9. Quand le strass s\u2019\xe9teint, reste le vide."
                },
                "303": {
                    Company_Name: "Zo Imbu Technologies",
                    Description: "Moi au-dessus, convaincu de ma sup\xe9riorit\xe9.",
                    Out_put: "Assurance et aura d\u2019autorit\xe9.",
                    Risk: "Humilit\xe9. La r\xe9alit\xe9 rabote l\u2019ego."
                },
                "304": {
                    Company_Name: "Zo Ambitieux Corp.",
                    Description: "Faim d\u2019aller plus haut, sans s\u2019arr\xeater.",
                    Out_put: "Succ\xe8s par volont\xe9 et d\xe9termination.",
                    Risk: "Burnout. L\u2019ambition d\xe9vore si on la l\xe2che."
                },
                "305": {
                    Company_Name: "Z \xc9charde \xe0 l\u2019\xc9paule",
                    Description: "Vieilles blessures, pr\xeat \xe0 en d\xe9coudre.",
                    Out_put: "Alerte, \xe9nergie et besoin de prouver.",
                    Risk: "Acceptation. L\xe2cher le pass\xe9 apporte la paix."
                },
                "306": {
                    Company_Name: "Z Manipulation Tech",
                    Description: "Tirer les ficelles, modeler l\u2019issue en coulisses.",
                    Out_put: "Contr\xf4le et persuasion invisibles.",
                    Risk: "Transparence. L\u2019honn\xeatet\xe9 casse l\u2019illusion."
                },
                "307": {
                    Company_Name: "Zo T\xeatu Inc.",
                    Description: "In\xe9branlable face \xe0 l\u2019opposition.",
                    Out_put: "Pers\xe9v\xe9rance et force d\u2019y croire.",
                    Risk: "Raideur. L\u2019ent\xeatement aveugle fait \xe9chouer."
                },
                "308": {
                    Company_Name: "Z Ranc\u0153ur Industrie",
                    Description: "Le go\xfbt amer des torts pass\xe9s.",
                    Out_put: "R\xe9flexion de soi et apprentissage \xe9motionnel.",
                    Risk: "Pardon. Lib\xe9rer la ranc\u0153ur lib\xe8re l\u2019esprit."
                },
                "309": {
                    Company_Name: "Z G\xean\xe9 Inc.",
                    Description: "Quand l\u2019erreur attire tous les regards.",
                    Out_put: "Humilit\xe9 et capacit\xe9 \xe0 grandir.",
                    Risk: "Confiance. Rire de soi dissout la g\xeane."
                },
                "310": {
                    Company_Name: "Z Vindication Industries",
                    Description: "Le doux moment o\xf9 l\u2019on avait raison.",
                    Out_put: "Soulagement, justice et fin des doutes.",
                    Risk: "Arrogance. Fanfaronez et vous vous ferez des ennemis."
                },
                "311": {
                    Company_Name: "Z Anxi\xe9t\xe9 Sociale Tech",
                    Description: "La peur paralysante de mal dire en soci\xe9t\xe9.",
                    Out_put: "Hyper-vigilance et finesse d\u2019observation.",
                    Risk: "Pratique. L\u2019exposition apprivoise la peur."
                }
            },
            "_meta": {
                "language": "Fran\xe7ais",
                "version": "1.0.0",
                "last_updated": "2025-08-05"
            },
            "auth": {
                "trader_id_placeholder": "ID du Trader",
                "password_placeholder": "Mot de passe",
                "login_button": "Connexion",
                "login_validation_message": "Veuillez saisir votre ID Trader et votre mot de passe",
                "login_failed_message": "\xc9chec de la connexion. V\xe9rifiez vos identifiants et r\xe9essayez.",
                "login_error_message": "Une erreur s'est produite lors de la connexion. Veuillez r\xe9essayer plus tard.",
                "authentication_failed_message": "\xc9chec de l'authentification. Veuillez vous reconnecter.",
                "password_required_message": "Mot de passe requis.",
                "enter_trader_name_placeholder": "Entrez votre nom de Trader",
                "enter_new_password_placeholder": "Entrez votre nouveau mot de passe",
                "secure_password_placeholder": "Entrez un mot de passe s\xe9curis\xe9",
                "set_password_label": "D\xe9finir le mot de passe",
                "authentication_failed": "\xc9chec de l'authentification. Veuillez vous reconnecter.",
                "session_required": "L'ID de session est manquant. Veuillez vous reconnecter."
            },
            "navigation": {
                "nav_commodity": "Marchandise",
                "nav_zollars": "Zollars",
                "nav_stock_zbond": "Actions & Z-Obligations",
                "nav_company": "Entreprise",
                "nav_portfolios": "Portefeuilles",
                "nav_control_panel": "Panneau de contr\xf4le"
            },
            "buttons": {
                choose_company: "Choisir cette entreprise",
                select: "S\xe9lectionner",
                "scan_button": "Scanner",
                "fulfill_button": "Ex\xe9cuter",
                "create_session_button": "Cr\xe9er une session",
                "search_button": "Rechercher",
                "close_search_button": "Fermer la recherche",
                "cancel_button": "Annuler",
                "close_button": "Fermer",
                "complete_setup_button": "Terminer la configuration",
                "save_button": "Sauvegarder",
                "delete_button": "Supprimer",
                "modify_name_button": "Modifier le nom",
                "modify_password_button": "Modifier le mot de passe",
                "logout_trader_button": "D\xe9connecter le trader",
                "view_qr_codes_button": "Voir les codes QR de connexion",
                "enter_mortality_chamber_button": "Entrer dans la chambre de mortalit\xe9",
                "continue_button": "Continue"
            },
            "stock_bid": {
                "title": "Offre d'achat d'actions",
                "offers_to_buy_points": "{portfolioName} propose d'acheter {shares} actions de {stockName} pour {amount} de Capital.",
                "offers_to_buy_zollars": "{portfolioName} propose d'acheter {shares} actions de {stockName} pour les zollars suivants :",
                "time_remaining": "Temps restant : {seconds} secondes",
                "time_expired": "Temps expir\xe9",
                "processing_bid": "Traitement de votre offre...",
                "no_response": " Aucune r\xe9ponse re\xe7ue. Cette action a expir\xe9.",
                "offer_expired": "Aucune r\xe9ponse re\xe7ue. Votre offre a expir\xe9."
            },
            "forms": {
                "mood_one_word": "Quel sentiment vivez-vous en ce moment ?",
                "one_word_hint": "(1 mot)",
                "reason_label": "Pourquoi ressentez-vous cela ?",
                "value_definition": "Pourquoi ressentez-vous cela ? (Valeur)",
                "value_definition_placeholder": "ex. : J'ai eu une promotion, Je suis mal r\xe9veill\xe9, Mon fils a marqu\xe9 3 buts...",
                "value_reaction": "Qu'est-ce que ce sentiment vous apporte ? (Profits de Vie)",
                "value_reaction_placeholder": "ex. : me donne de l'\xe9nergie, me d\xe9prime, m'aide \xe0 grandir...",
                "experiences_label": "Qu'est-ce qui cr\xe9e ce sentiment ?",
                "search_stocks_placeholder": "Rechercher des actions",
                "company_name_fixed_label": "Nom de l'entreprise (fixe) :",
                "company_description_label": "Description de l'entreprise :",
                "company_product_label": "Produit/Output de l'entreprise :",
                "trader_name_label": "Nom du Trader :",
                "session_name_label": "Nom de la session",
                "session_name_placeholder": "Entrez le nom de la session (lettres, chiffres, tirets bas uniquement)",
                "single_word_example": "ex. : heureux, triste, fatigu\xe9, curieux...",
                "reason_placeholder": "ex. : J'ai eu une promotion, Je suis mal r\xe9veill\xe9, Mon fils a marqu\xe9 3 buts...",
                "describe_feeling_placeholder": "ex. : me donne de l'\xe9nergie, me d\xe9prime, m'aide \xe0 grandir..."
            },
            "modals": {
                "select_action_title": "S\xe9lectionner une action",
                "action_modal_description": "S\xe9lectionnez Scanner pour \xeatre dirig\xe9 vers la page d'analyse des articles. S\xe9lectionnez Ex\xe9cuter pour ex\xe9cuter les commandes.",
                "choose_simulation_title": "Choisissez votre exp\xe9rience de simulation",
                "memento_mori_title": "Simulation Memento Mori",
                "memento_mori_description": "Souvenez-vous que vous devez mourir. Cette simulation explore les choix significatifs dans un temps limit\xe9.",
                "create_new_session_title": "Cr\xe9er une nouvelle session",
                "session_creation_description": "Cr\xe9er une nouvelle session de trading en tant que Banque centrale de la R\xe9serve f\xe9d\xe9rale Z.",
                "assign_to_portfolio_title": "Assigner au portefeuille :",
                "select_portfolio_short_title": "S\xe9lectionner un portefeuille pour placer une position courte",
                "select_portfolio_transfer_title": "S\xe9lectionner un portefeuille pour transf\xe9rer la propri\xe9t\xe9"
            },
            "tables": {
                "table_stock_name": "Nom de l'action",
                "table_symbol": "Symbole",
                "table_share_value": "Valeur de l'action",
                "table_owner": "Propri\xe9taire",
                "table_shorted": "Vendu \xe0 d\xe9couvert",
                "table_place_short": "Placer \xe0 d\xe9couvert",
                "table_delete": "Supprimer"
            },
            "titles": {
                "owned_stock_list_title": "Liste des actions poss\xe9d\xe9es",
                "short_positions_title": "Positions courtes",
                "stock_management_guide_title": "Guide de gestion des actions"
            },
            "validation": {
                "select_company_first_message": "Veuillez d'abord s\xe9lectionner une entreprise avant de r\xe9clamer.",
                "fill_trader_name_password_message": "Veuillez remplir votre nom de Trader et votre nouveau mot de passe.",
                "company_details_required_message": "Les d\xe9tails de l'entreprise sont requis. Veuillez terminer le processus de s\xe9lection de l'entreprise.",
                "portfolio_count_validation": "Le nombre de portefeuilles doit \xeatre entre 1 et 50.",
                "items_per_portfolio_validation": "Le nombre d'articles par portefeuille doit \xeatre entre 0 et 10.",
                "simulation_questions_required": "Veuillez r\xe9pondre \xe0 toutes les questions. Entrez un seul mot pour votre humeur et expliquez pourquoi vous vous sentez ainsi et ce qui cr\xe9e ce sentiment.",
                "complete_reflections": "Veuillez compl\xe9ter les trois r\xe9flexions.",
                "max_companies": "Maximum 5 entreprises autoris\xe9es"
            },
            "messages": {
                "success": "Succ\xe8s",
                "error": "Erreur",
                "loading": "Chargement...",
                "qr_error_message": "Erreur lors de l'affichage des codes QR. Veuillez r\xe9essayer.",
                "portfolios_created_success": "Portefeuille(s) cr\xe9\xe9(s) avec succ\xe8s",
                "portfolio_add_error": "Erreur lors de l'ajout du portefeuille. Veuillez r\xe9essayer.",
                "portfolio_updated_success": "Portefeuille mis \xe0 jour avec succ\xe8s",
                "fetch_portfolios_error": "Erreur lors de la r\xe9cup\xe9ration des portefeuilles. Veuillez r\xe9essayer plus tard."
            },
            "backend_messages": {
                "invalid_decision_message": "D\xe9cision invalide.",
                "assignment_in_progress": "L'assignation est d\xe9j\xe0 en cours.",
                "session_id_required": "L'ID de session est requis.",
                "not_enough_items_assign": "Pas assez d'articles disponibles \xe0 assigner",
                "items_assigned_success": "Nouveaux articles assign\xe9s \xe0 tous les portefeuilles avec succ\xe8s.",
                "items_assign_failed": "\xc9chec de l'assignation des nouveaux articles",
                "items_assigned_successfully": "Articles assign\xe9s avec succ\xe8s.",
                "no_available_items": "Aucun article disponible pour assignation.",
                "failed_assign_items": "\xc9chec de l'assignation des articles.",
                "points_distributed_success": "capitaux distribu\xe9s avec succ\xe8s.",
                "points_distribute_failed": "\xc9chec de la distribution des capitaux.",
                "items_removed_success": "Articles supprim\xe9s avec succ\xe8s.",
                "no_items_for_removal": "Aucun article non-\xe9chang\xe9 disponible pour suppression.",
                "failed_remove_items": "\xc9chec de la suppression des articles.",
                "tax_points_item_deducted": "capitaux et article al\xe9atoire d\xe9duits par les autorit\xe9s fiscales Z.",
                "tax_points_deducted": "capitaux de trading d\xe9duits par les autorit\xe9s fiscales Z.",
                "tax_points_zollars_item_deducted": "& bien al\xe9atoire d\xe9duits par les autorit\xe9s fiscales de la R\xe9serve Z\xe9d\xe9rale.",
                "tax_points_zollars_deducted": "d\xe9duits par les autorit\xe9s fiscales de la R\xe9serve Z\xe9d\xe9rale.",
                "tax_item_removed": "Article al\xe9atoire supprim\xe9 par les autorit\xe9s fiscales Z.",
                "error_fetching_portfolios": "Erreur lors de la r\xe9cup\xe9ration des portefeuilles",
                "portfolio_updated_success": "Portefeuille mis \xe0 jour avec succ\xe8s",
                "portfolio_not_found": "Portefeuille introuvable",
                "error_updating_portfolio": "Erreur lors de la mise \xe0 jour du portefeuille",
                "internal_server_error": "Erreur interne du serveur",
                "item_already_assigned": "L'article est d\xe9j\xe0 assign\xe9 \xe0 ce portefeuille",
                "item_assigned_success": "Article assign\xe9 au portefeuille avec succ\xe8s",
                "item_unassigned_success": "Article d\xe9sassign\xe9 du portefeuille avec succ\xe8s",
                "create_community_button_assigned": "Bouton de cr\xe9ation de communaut\xe9 assign\xe9 avec succ\xe8s",
                "portfolio_deleted_success": "Portefeuille supprim\xe9 avec succ\xe8s, articles et actions d\xe9sassign\xe9s.",
                "no_zollars_found": "Aucun Zollar trouv\xe9 pour ce portefeuille",
                "failed_fetch_bonds": "\xc9chec de la r\xe9cup\xe9ration des obligations",
                "message_exceeds_280": "Le message d\xe9passe 280 caract\xe8res.",
                "sender_portfolio_not_found": "Portefeuille exp\xe9diteur introuvable.",
                "recipient_portfolio_not_found": "Portefeuille destinataire introuvable.",
                "not_enough_points_message": "Pas assez de capitaux pour envoyer un message.",
                "message_sent_successfully": "Message envoy\xe9 avec succ\xe8s",
                "session_mismatch_sender": "Action non autoris\xe9e. Session ne correspond pas pour l'exp\xe9diteur.",
                "session_mismatch_recipient": "Action non autoris\xe9e. Session ne correspond pas pour le destinataire.",
                "requesting_portfolio_not_found": "Portefeuille demandeur introuvable",
                "user_not_part_of_session": "L'utilisateur ne fait partie d'aucune session",
                "item_not_found": "Article introuvable",
                "no_unassigned_items": "Aucun article non assign\xe9 trouv\xe9",
                "portfolio_not_found_in_session": "Portefeuille introuvable dans cette session",
                "item_not_found_in_session": "Article introuvable dans cette session",
                "failed_assign_item_portfolio": "\xc9chec de l'assignation de l'article au portefeuille"
            },
            llmFallback: {
                greedy: [
                    "Alerte \xe0 l\u2019abondance ! Grandissons ensemble \u2014 la valeur, ce sont les personnes, pas seulement le prix.",
                    "Pr\xeats \xe0 soutenir des id\xe9es audacieuses ? L\u2019ambition humaine alimente cet \xe9change.",
                    "Montrez-moi vos offres \u2014 chaque \xe9change raconte une histoire de faim et d\u2019espoir.",
                    "Souvenez-vous : la richesse est un outil pour de meilleures vies, gardons l\u2019humain au centre."
                ],
                angry: [
                    "Je d\xe9nonce des spreads injustes maintenant. Une col\xe8re honn\xeate \u2192 un march\xe9 honn\xeate.",
                    "Je ne reculerai pas tant que chaque voix ne sera pas entendue \u2014 la rage peut r\xe9\xe9crire les r\xe8gles.",
                    "Ce n\u2019est pas \xab truqu\xe9 \xbb, c\u2019est un miroir. Corrigeons le reflet.",
                    "Chaque \xe9change douteux allume une m\xe8che \u2014 transformons cette \xe9tincelle en r\xe9forme structurelle."
                ],
                happy: [
                    "Dividendes de joie en approche ! Comment va le portefeuille humain de chacun aujourd\u2019hui ?",
                    "L\u2019\xe9nergie est haute \u2014 l\u2019optimisme n\u2019a pas de prix, \xe9changeons !",
                    "Ouvert aux \xe9changes bienveillants \u2014 uniquement des accords gagnant-gagnant.",
                    "Les bonnes ondes composent vite ; c\xe9l\xe9brons les petits gains !"
                ],
                anxious: [
                    "La volatilit\xe9 vous crispe ? Respirez \u2014 l\u2019incertitude est humaine, pas un bug.",
                    "Conserver ou vendre ? Demandez-vous ce qui vous nourrit ; le profit suit le sens.",
                    "Partager ses doutes transforme la peur en clairvoyance. Parlons du risque ensemble.",
                    "Les variations du march\xe9 refl\xe8tent nos inqui\xe9tudes \u2014 les nommer nous redonne du pouvoir."
                ],
                manic: [
                    "VAGUE D\u2019OPPORTUNIT\xc9S ! \uD83D\uDE80 Hydratez-vous, ancrez-vous, *puis* \xe9changez.",
                    "\xab To the moon \xbb c\u2019est amusant \u2014 mais l\u2019humanit\xe9 est la v\xe9ritable destination.",
                    "Les ordres fusent \xe0 la vitesse de la lumi\xe8re \u2014 canalisons cette \xe9tincelle sans nous br\xfbler.",
                    "Surfez la vague, respectez les limites \u2014 le bien-\xeatre est le v\xe9ritable ticker."
                ],
                strategic: [
                    "Cartographier le sens, pas seulement l\u2019argent \u2014 diversifiez votre capital *humain*.",
                    "\xc0 l\u2019aff\xfbt de partenariats o\xf9 l\u2019empathie rencontre l\u2019innovation.",
                    "Point d\u2019entr\xe9e optimal ? L\xe0 o\xf9 le sens s\u2019aligne avec le potentiel.",
                    "Vision longue : le ROI communautaire d\xe9passe toujours les sursauts trimestriels."
                ],
                depressed: [
                    "Les jours sombres enseignent des le\xe7ons profondes \u2014 que vaut-il la peine de prot\xe9ger quand l\u2019espoir s\u2019amenuise ?",
                    "M\xeame les march\xe9s baissiers portent des graines de compr\xe9hension. On partage la charge ?",
                    "Quand tout para\xeet creux, le lien humain devient la seule vraie monnaie.",
                    "La mar\xe9e basse r\xe9v\xe8le ce qui est fait pour durer. Qu\u2019est-ce qui compte pour vous maintenant ?"
                ],
                competitive: [
                    "C\u2019est parti ! Mais souvenez-vous \u2014 les meilleures victoires \xe9l\xe8vent tout le monde.",
                    "Je vois vos coups et je surench\xe9ris avec de la collaboration. Qui est partant ?",
                    "La comp\xe9tition nous aiguise, la communaut\xe9 nous soutient. Les deux \xe0 la fois, pas l\u2019un ou l\u2019autre.",
                    "Pr\xeats \xe0 dominer ? Dominons la raret\xe9, pas les uns les autres."
                ],
                curious: [
                    "Quels motifs cach\xe9s voyez-vous dans les \xe9changes d\u2019aujourd\u2019hui ?",
                    "Les questions sont du capital \u2014 quels myst\xe8res votre portefeuille r\xe9v\xe8le-t-il ?",
                    "Chaque position raconte une histoire. Que dit la v\xf4tre ?",
                    "L\u2019\xe9merveillement est ma monnaie pr\xe9f\xe9r\xe9e. De quoi \xeates-vous curieux aujourd\u2019hui ?"
                ]
            },
            "messageSend": {
                " title": "Envoyer un message",
                "costPerRecipient": "Co\xfbt : 20 par destinataire",
                "searchRecipients": "Rechercher des destinataires",
                "unnamedPortfolio": "Portefeuille sans nom",
                "placeholder280": "Saisissez votre message (280 caract\xe8res max)",
                "send": "Envoyer",
                "close": "Fermer",
                "newMessageFrom": "Nouveau message de",
                "unknown": "Inconnu",
                "reply": "R\xe9pondre",
                "markAsRead": "Marquer comme lu",
                "onlyChatBots": "Vous ne pouvez discuter qu\u2019avec des joueurs bots, pas avec des humains.",
                "conversationWith": "Conversation avec",
                "messagesRemaining": "messages restants",
                "typeYourMessage": "Tapez votre message...",
                "chatLimitReached": "Limite de discussion atteinte. Cette conversation est termin\xe9e.",
                "error": "Erreur",
                "failedToSend": "\xc9chec de l\u2019envoi du message",
                "chatEnded": "Discussion termin\xe9e",
                "chatEndedThanks": "Cette discussion est termin\xe9e. Merci pour cet \xe9change !",
                "connectionError": "Erreur de connexion. Veuillez r\xe9essayer.",
                "botGreeting": "Salut ! Je suis {name}. Qu\u2019avez-vous en t\xeate ?",
                "message_user": "Message \xe0 {user} : {message}"
            },
            "bot": {
                "chat_connection_notready": "Connexion non pr\xeate. R\xe9essayez dans un instant.",
                "chat_greeting_fallback": "Salut ! Je suis {{name}}. Qu\u2019avez-vous en t\xeate ?",
                "chat_remaining": "messages restants",
                "chat_input_placeholder": "\xc9crivez votre message\u2026",
                "chat_connection_lost": "Connexion perdue. Veuillez r\xe9essayer.",
                "chat_error_notloggedin": "Erreur : utilisateur non connect\xe9",
                "chat_limit_reached": "Limite de messages atteinte.",
                "chat_timeout": "Le bot met trop de temps \xe0 r\xe9pondre. R\xe9essayez.",
                "chat_end_thanks": "Cette discussion est termin\xe9e. Merci d\u2019avoir parl\xe9 !",
                "chat_ended": "Discussion termin\xe9e",
                "chat_recommendation_title": "Recommandation de trading",
                "chat_action_buy": "Placer une offre",
                "chat_action_sell": "Cr\xe9er une offre",
                "chat_action_short": "Vendre \xe0 d\xe9couvert",
                "chat_action_trade": "Lancer un \xe9change",
                "chat_action_goto": "Aller au trading"
            },
            labels: {
                output: "Production"
            },
            "routes": {
                "lbo_notFound": "Un ou plusieurs portefeuilles sont introuvables.",
                "lbo_noTrigger": "L\u2019initiateur ne poss\xe8de pas de d\xe9clencheur LBO capitaliste.",
                "lbo_sessionMismatch": "Incoh\xe9rence de portefeuille ou de session.",
                "lbo_notEnoughPoints": "Capitaux insuffisant pour effectuer le LBO.",
                "lbo_success": "LBO r\xe9alis\xe9 avec succ\xe8s. Capital, biens et actions transf\xe9r\xe9s.",
                "lbo_triggerGiven": "D\xe9clencheur LBO capitaliste attribu\xe9 avec succ\xe8s.",
                "subsidy_notFound": "Portefeuille introuvable.",
                "subsidy_triggerGiven": "D\xe9clencheur de Subvention socialiste attribu\xe9 avec succ\xe8s.",
                "common_internal": "Erreur interne du serveur.",
                "subsidy_notFoundMulti": "Un ou plusieurs portefeuilles sont introuvables.",
                "subsidy_noTrigger": "L\u2019initiateur ne poss\xe8de pas de d\xe9clencheur de Subvention socialiste.",
                "subsidy_sessionMismatch": "Incoh\xe9rence de portefeuille ou de session.",
                "subsidy_noRecipients": "Aucun autre portefeuille disponible pour recevoir des subventions.",
                "subsidy_nothingToTax": "Aucune richesse \xe0 taxer pour ce portefeuille.",
                "subsidy_success": "Subvention effectu\xe9e avec succ\xe8s."
            },
            "LedHold": {
                "total_funds": "Total fonds",
                "earned_funds": "Capital gagn\xe9",
                "value_items": "Valeur des biens",
                "value_stock": "Valeur des actions",
                "value_short": "Position Short",
                "zollars": "Zollars",
                "total_points_label": "Capitaux totaux",
                "close": "Fermer"
            },
            "triggers": {
                "confirm": "Confirmer",
                "cancel": "Annuler",
                "close": "Fermer",
                "errorPrefix": "Erreur :",
                "ofWord": "de",
                "pointsLabel": "Capitaux",
                "sharesWord": "parts",
                "sharesAt": "parts \xe0 {value} chacune",
                "unknownUser": "Utilisateur inconnu",
                "noEligible": "Aucun portefeuille admissible \xe0 redistribuer. Action annul\xe9e.",
                "steal_stealerNotFound": "Portefeuille du voleur introuvable",
                "steal_noTrigger": "Ce portefeuille ne poss\xe8de pas de d\xe9clencheur de vol",
                "steal_itemUnavailable": "Objet non disponible pour le vol",
                "steal_itemNotInAnyPortfolio": "Objet introuvable dans un portefeuille",
                "steal_success": "Objet bien vol\xe9",
                "steal_serverError": "Erreur interne du serveur",
                "success": "Les avoirs du portefeuille s\xe9lectionn\xe9 ont \xe9t\xe9 redistribu\xe9s avec succ\xe8s.",
                "error": "Erreur : impossible de redistribuer le portefeuille s\xe9lectionn\xe9.",
                "steal_success": "Succ\xe8s, Objet vol\xe9",
                "ransom_pay_success": "La ran\xe7on a \xe9t\xe9 pay\xe9e. Votre portefeuille est d\xe9sormais d\xe9verrouill\xe9.",
                "itemStolenSuccess": "Bien vol\xe9 avec succ\xe8s.",
                "stealFailed": "\xc9chec du vol de bien",
                "title1": "Voulez-vous vraiment redistribuer les avoirs du portefeuille s\xe9lectionn\xe9 ?",
                "body1": "Cette action redistribuera al\xe9atoirement les avoirs du portefeuille du trader \xe0 d\u2019autres traders sur le march\xe9.",
                "cta1": "Oui, d\xe9clencher l\u2019assaut communiste",
                "selectPortfolioTitle": "S\xe9lectionnez un portefeuille :",
                "noAssetsSelected": "Aucun actif s\xe9lectionn\xe9 pour la LBO.",
                "successLBO": "LBO d\xe9clench\xe9e avec succ\xe8s.",
                "selectAssetsTitle": "S\xe9lectionnez les actifs pour la LBO",
                "selectAssetsItems": "Objets :",
                "selectAssetsStocks": "Actions :",
                "noItems": "Aucun objet disponible",
                "noStocks": "Aucune action disponible",
                "title_1": "S\xe9lectionnez un portefeuille sur lequel d\xe9clencher une LBO :",
                "titleLBO": "Confirmer la LBO (rachat avec effet de levier)",
                "bodyLBO": "Cette LBO vous co\xfbtera {cost} capitaux. Voulez-vous continuer ?",
                "ctaLBO": "Oui, d\xe9clencher la LBO",
                "removedStocksLabel": "Actions retir\xe9es :",
                "removedItemsLabel": "Objets retir\xe9s :",
                "unknownStock": "Action inconnue",
                "unknownItem": "Objet inconnu",
                "noRichPortfolios": "Aucun portefeuille \xab riche \xbb disponible comme cible.",
                "success3": "Subvention d\xe9clench\xe9e avec succ\xe8s.",
                "selectRichTitle3": "S\xe9lectionnez un portefeuille riche \xe0 taxer :",
                "stealFailedUse": "\xc9chec de l\u2019utilisation du bouton de vol",
                "stealFailedFetchItems": "\xc9chec du chargement des objets disponibles",
                "stealFailedUseOrFetch": "\xc9chec de l\u2019utilisation du bouton de vol ou du chargement des objets",
                "stealFailedToSteal": "\xc9chec du vol de l\u2019objet",
                "ransomNoEligible": "Aucun portefeuille admissible \xe0 ran\xe7onner. Action annul\xe9e.",
                "ransomSelectTargetTitle": "S\xe9lectionnez un portefeuille \xe0 ran\xe7onner :",
                "ransomSetFailed": "\xc9chec de la mise en place de la ran\xe7on",
                "ransomSetSuccess": "Ran\xe7on fix\xe9e avec succ\xe8s.",
                "ransomSetErrorPrefix": "Erreur : impossible de fixer la ran\xe7on.",
                "ransomSetAmountTitle": "D\xe9finir le montant de la ran\xe7on",
                "ransomSetAmountPlaceholder": "Saisissez le montant de la ran\xe7on",
                "ransomConfirmSetTitle": "Confirmer la ran\xe7on",
                "ransomConfirmSetBody": "Voulez-vous vraiment fixer une ran\xe7on de {amount} capitaux ?",
                "ransomPaySuccess": "Ran\xe7on pay\xe9e avec succ\xe8s. Votre portefeuille est d\xe9sormais d\xe9verrouill\xe9.",
                "ransomPayErrorPrefix": "Erreur : impossible de payer la ran\xe7on.",
                "ransomPayTitle": "Confirmer le paiement de la ran\xe7on",
                "ransomPayBody": "Voulez-vous vraiment payer {amount} capitaux pour d\xe9verrouiller votre portefeuille ?",
                "giveawayTitle": "Confirmer le don",
                "giveawayBody": "Voulez-vous vraiment donner cet objet ?",
                "communitySelectUsersTitle": "S\xe9lectionnez les utilisateurs pour la communaut\xe9 :",
                "statsTotalWealth": "Richesse totale :",
                "initiatorUndefined": "Le portefeuille initiateur est ind\xe9fini",
                "sessionUndefined": "La session est ind\xe9finie",
                "fetchPortfoliosFailed": "\xc9chec du chargement des portefeuilles"
            },
            "ui_labels": {
                "show_explanations_label": "Afficher les explications",
                "currency": "Devise",
                "balance": "Solde",
                "price": "Prix",
                "quantity": "Quantit\xe9",
                "total": "Total",
                "date": "Date",
                "time": "Heure",
                "status": "Statut",
                "active": "Actif",
                "inactive": "Inactif",
                "pending": "En attente",
                "completed": "Termin\xe9",
                "failed": "\xc9chou\xe9"
            },
            "marketing": {
                "tailor_stock_choice_message": "Adaptez votre choix d'actions pour qu'il s'aligne exactement avec vos valeurs.",
                "footer_copyright": 'Tous droits r\xe9serv\xe9s ZExchange 2025. ZExchange fait partie de <a href="https://zeconomy.xyz"> ZEconomy. </a>',
                "programs": {
                    "nav_home": "\u2190 Retour \xe0 ZExchange",
                    "nav_contact": "Nous Contacter",
                    "page_title": "ZExchange Studio Program",
                    "tagline": "Life profits.",
                    "intro": "Un programme en trois parties dans lequel les participants int\xe8grent une \xe9conomie con\xe7ue comme \u0153uvre d'art, s'approprient des notions conceptuelles cl\xe9s, construisent des syst\xe8mes de valeur (r\xe9els ou artistiques) et n\xe9gocient en direct sur la plateforme ZExchange.",
                    "part_one_title": "Premi\xe8re partie : Cadre th\xe9orique",
                    "part_one_text": "O\xf9 r\xe9side la valeur : dans l'\u0153uvre ? dans l'objet, l'institution ou l'exp\xe9rience ? De l'image cultuelle de Hans Belting aux marchandises fictives de Karl Polanyi, de la th\xe9\xe2tralit\xe9 de Michael Fried \xe0 la validation algorithmique des prix. Une introduction rigoureuse au d\xe9placement, envisag\xe9 \xe0 la fois comme trajectoire historico-artistique et comme intervention \xe9conomique.",
                    "part_two_title": "Deuxi\xe8me partie : Atelier cr\xe9atif",
                    "part_two_text": "Les participants \xe9laborent leurs propres syst\xe8mes de valeur \xe0 partir des principes de la ZEconomy d\xe9velopp\xe9s lors de la phase th\xe9orique. L'architecture \xe9conomique devient un mat\xe9riau artistique.",
                    "part_three_title": "Troisi\xe8me partie : S\xe9ance de trading en direct",
                    "part_three_text": "Entre 10 et 200 participants mettent en pratique la ZEconomy en temps r\xe9el sur la plateforme ZExchange. Une IA observe, analyse et livre son commentaire \u2014 produisant un Big Board visuel et un portrait \xe9crit du comportement collectif. Le march\xe9 devient son propre miroir.",
                    "institutional_title": "Objectifs institutionnels",
                    "art_programs_title": "Pour les programmes artistiques :",
                    "art_programs_text": "Positionner l'\xe9conomie comme mat\xe9riau, prolongeant l'Art conceptuel et la Critique institutionnelle tout en construisant des alternatives plut\xf4t qu'en se limitant \xe0 r\xe9v\xe9ler l'existant.",
                    "business_programs_title": "Pour les programmes de commerce et de management :",
                    "business_programs_text": "Appliquer la th\xe9orie de la valorisation exp\xe9rientielle. Les \xe9tudiants mobilisent des applications cr\xe9atives de leurs id\xe9es afin de mieux structurer leurs propres projets.",
                    "zeconomy_title": "ZEconomy",
                    "zeconomy_text_1": "ZExchange \xe9merge de la ZEconomy, une pratique artistique de long date d\xe9velopp\xe9e par JaZoN Frings depuis pr\xe8s de vingt ans, \xe0 travers un march\xe9 boursier personnel, des monnaies relationnelles et des syst\xe8mes publicitaires non fond\xe9s sur la consommation. Ces \u0153uvres interrogent la place de l'individu au sein des syst\xe8mes sociaux en intervenant dans leurs structures \u2014 en d\xe9pla\xe7ant les objectifs de production, en reconfigurant les modes op\xe9ratoires et en introduisant des formes d'expression impr\xe9vues qui en r\xe9v\xe8lent la logique sous-jacente.",
                    "zeconomy_text_2": "Repr\xe9sent\xe9e par la galerie mfc\u2013mich\xe8le didier et l'agent d'art Ghislain Mollet-Vi\xe9ville, la pratique a \xe9t\xe9 expos\xe9e dans des institutions telles que Transmediale Berlin, SPRING/BREAK ART SHOW NYC,  Wrong Biennial, Stanford University et Science Gallery Dublin. Avec de nombreuses interventions p\xe9dagogiques et de m\xe9diation \xe0 l'\xc9cole Camondo, Parsons Paris et au Centre Pompidou, elle a \xe9t\xe9 cit\xe9e dans Art Press, \u22C6\u22C6\u22C6 T\xe9l\xe9rama, Bloomberg et Blockchain Revolution de Don Tapscott.",
                    "contact_title": "Contact",
                    "contact_text": "Pour les d\xe9tails du programme, la planification et les demandes institutionnelles :"
                },
                "sessions": {
                    "nav_home": "\u2190 Retour \xe0 ZExchange",
                    "nav_contact": "Nous Contacter",
                    "page_title": "ZExchange",
                    "tagline": "Life profits.",
                    "intro": "Une \u0153uvre dans laquelle on entre, plut\xf4t qu\u2019on observe. Un espace d\u2019\xe9change. Une f\xeate. Une nouvelle fa\xe7on de regarder la valeur.",
                    "what_happens_title": "Ce qui se passe",
                    "what_happens_p1": "Les participants int\xe8grent une \xe9conomie \xe0 deux niveaux : actions et marchandises.",
                    "what_happens_p2": "Les actions repr\xe9sentent des valeurs intangibles \u2014 \xe9tats \xe9motionnels, ambitions, mani\xe8res d'\xeatre. On les n\xe9gocie, on sp\xe9cule dessus, on regarde leurs cours monter et descendre selon l'int\xe9r\xeat collectif.",
                    "what_happens_p3": "Les marchandises sont r\xe9elles \u2014 boissons, nourriture, objets, cadeaux. Tout est n\xe9gociable, mais on ne peut rien consommer seul. Pour obtenir une marchandise, un autre participant doit accepter d'obtenir les siennes avec vous. Le march\xe9 accorde ou refuse la permission.",
                    "what_happens_p4": "Une IA observe tout ce qui se d\xe9roule, commentant les dynamiques de valeur, de d\xe9sir et d'\xe9change \xe0 mesure qu'elles \xe9mergent.",
                    "what_produces_title": "Ce que cela produit",
                    "what_produces_text": "Une exp\xe9rience partag\xe9e qui recadre la consommation comme acte social. Un portrait du groupe r\xe9dig\xe9 par l'IA. Une visualisation Big Board disponible \xe0 l'achat. Et une question qui persiste : quelle est la vraie valeur d'\xeatre en vie ?",
                    "format_title": "Format",
                    "format_text": "2 \xe0 3 heures. De 10 \xe0 200 participants. \xc9v\xe9nement autonome, team building, cocktail, s\xe9minaire ou programme culturel.",
                    "zeconomy_title": "ZEconomy",
                    "zeconomy_text_1": "Le ZExchange \xe9merge de la ZEconomy, pratique artistique au long cours de JaZoN Frings d\xe9velopp\xe9e depuis pr\xe8s de vingt ans \xe0 travers un march\xe9 boursier personnel, des monnaies relationnelles et des syst\xe8mes publicitaires non fond\xe9s sur la consommation. Ces \u0153uvres interrogent la position de l'individu au sein des syst\xe8mes soci\xe9taux en intervenant dans leurs structures \u2014 d\xe9pla\xe7ant les objectifs de production, reconfigurant les op\xe9rations et introduisant des formes d'expression impr\xe9vues qui en r\xe9v\xe8lent la logique sous-jacente.",
                    "zeconomy_text_2": "Repr\xe9sent\xe9 par la Galerie mfc\u2013mich\xe8le didier et l'agent d'art Ghislain Mollet-Vi\xe9ville, la pratique a \xe9t\xe9 expos\xe9e dans des institutions telles que Transmediale Berlin, SPRING/BREAK ART SHOW NYC,  Wrong Biennial, Stanford University et Science Gallery Dublin. Avec de nombreuses interventions p\xe9dagogiques et de m\xe9diation \xe0 l'\xc9cole Camondo, Parsons Paris et au Centre Pompidou, elle a \xe9t\xe9 cit\xe9e dans Art Press, \u22C6\u22C6\u22C6 T\xe9l\xe9rama, Bloomberg et Blockchain Revolution de Tapscott.",
                    "contact_title": "Contact",
                    "contact_text": "Pour les d\xe9tails du programme, la planification et les demandes institutionnelles :"
                }
            },
            "classes": {
                "page_title": "Sessions p\xe9dagogiques ZEconomy",
                "presenter_title": "Pr\xe9sentation de cours ZEconomy",
                "back_link": "\u2190 Retour \xe0 ZExchange",
                "title": "Sessions p\xe9dagogiques ZEconomy",
                "tagline": "Explorer les intersections entre histoire de l'art, spiritualit\xe9 et repr\xe9sentation avec la th\xe9orie des march\xe9s, les syst\xe8mes de valeur et la r\xe9invention de la finance par la ZEconomy.",
                "lesson_selector": "\u2190 S\xe9lecteur de le\xe7ons",
                "previous": "\u2190 Pr\xe9c\xe9dent",
                "next": "Suivant \u2192",
                "toggle_images": "Afficher/Masquer les images",
                "no_classes": "Aucune session disponible pour le moment.",
                "load_error": "Impossible de charger les sessions. Veuillez r\xe9essayer ult\xe9rieurement.",
                "level": "Niveau",
                "duration": "Dur\xe9e",
                "minutes": "min",
                "mixed_level": "mixte",
                "presenter_suffix": "Pr\xe9sentation",
                "learning_objectives": "Objectifs p\xe9dagogiques",
                "view_details": "Voir les d\xe9tails",
                "discussion_points": "Points de discussion",
                "activity_instructions": "Consignes de l'activit\xe9",
                "estimated_reading_time": "Temps de lecture estim\xe9",
                "min": "min",
                "download_pdf": "T\xe9l\xe9charger le PDF",
                "no_lesson_specified": "Aucune le\xe7on sp\xe9cifi\xe9e.",
                "lesson_not_found": "Le\xe7on introuvable.",
                "load_lesson_error": "Erreur lors du chargement de la le\xe7on. Veuillez r\xe9essayer ult\xe9rieurement."
            },
            "placeholders": {
                "life_profits_placeholder_1": "J'appr\xe9cie jouer avec mes enfants...",
                "life_profits_placeholder_2": "La d\xe9pression semble \xeatre recherch\xe9e...",
                "life_profits_placeholder_3": "J'aime l'amour et tout ce qui s'y rapporte...",
                "life_profits_placeholder_4": "Un verre avec des amis vaut tout...",
                "life_profits_placeholder_5": "Je pense que le rejet cr\xe9e de la valeur...",
                "life_profits_placeholder_6": "Je vois la joie comme la vraie monnaie de la vie...",
                "life_profits_placeholder_7": "Aider les autres enrichit ma vie...",
                "life_profits_placeholder_8": "La solitude est devenue une exp\xe9rience tr\xe8s courante...",
                unnamed_company: "Entreprise sans nom",
                unknown_output: "Production inconnue",
                no_description: "Aucune description disponible",
                "experience_placeholder_1": "Danser sur de la techno me fait oublier mes soucis...",
                "experience_placeholder_2": "Passer du temps avec mes amis fait filer le temps...",
                "experience_placeholder_3": "Ma m\xe8re me manque, \xe7a me rappelle ce qui compte...",
                "experience_placeholder_4": "Courir r\xe9guli\xe8rement me vide la t\xeate...",
                "experience_placeholder_5": "Se disputer en ligne est toujours une perte de temps...",
                "experience_placeholder_6": "Regarder de vieux dessins anim\xe9s me fait redevenir un enfant...",
                "experience_placeholder_7": "Me lever t\xf4t donne une bonne \xe9nergie \xe0 ma journ\xe9e...",
                "experience_placeholder_8": "Prendre un chemin d\xe9tourn\xe9 m'aide \xe0 r\xe9fl\xe9chir...",
                "experience_placeholder_9": "La qualit\xe9 du caf\xe9 du matin donne le ton \xe0 ma journ\xe9e...",
                "experience_placeholder_10": "Porter mes lunettes de soleil la nuit me donne l'air cool..."
            },
            "ticker_texts": {
                "intro_z_exchange": "?? \u25BA INTRODUCTION Z EXCHANGE ?? \u25BA",
                "life_profits_value": "PROFITS DE VIE \u25BA VALEUR Z EXCHANGE \u25BA",
                "stocks_function": "\u25BA QUE FONT LES ACTIONS SUR Z EXCHANGE",
                "z_bonds_system": "Z OBLIGATIONS \u25BA Zollars \u25BA Z SYST\xc8ME MON\xc9TAIRE RELATIONNEL \u25BA LES CHIFFRES N'ONT PAS LEUR PLACE \u25BA",
                "commodity_x": "\u25BA MARCHANDISE X \u25BA CONSOMMATION SOCIALE Z EXCHANGE.",
                "interface_preview": "APER\xc7U DE L'INTERFACE Z EXCHANGE \u25BA",
                "generative_boards": "\u25BA TABLEAUX G\xc9N\xc9RATIFS Z EXCHANGE \u25BA EXPRESSION MARCH\xc9 EN TEMPS R\xc9EL"
            },
            "simulation": {
                "freestyle_title": "Freestyle est un simulateur de session r\xe9guli\xe8re ZExchange.",
                "freestyle_goal_label": "Objectif",
                "freestyle_goal_text": "apprendre l'interface et les concepts de ZExchange ; et surtout explorer comment la valeur devient votre histoire.",
                "details_heading": "D\xe9tails :",
                "freestyle_detail_1": "prend notre id\xe9e de profits en appliquant de la valeur \xe0 ce qui compte pour vous dans votre vie.",
                "life_profit_label": "Profit de Vie",
                "life_profit_description": "valeur de la vie consciemment v\xe9cue : joie, perte, contradiction, sexe, amour, d\xe9pression, ennui, f\xeate... (qualit\xe9 / quantit\xe9 / positif & n\xe9gatif).",
                "voice_of_bourse_label": "\"voix de la bourse\"",
                "voice_of_bourse_description": 'Sur ZExchange, le march\xe9 lui-m\xeame a une voix, analysant ce qu\'il pense de chaque transaction boursi\xe8re \u2192 cr\xe9ant des "grands tableaux" g\xe9n\xe9ratifs + cr\xe9e des r\xe9cits collaboratifs.',
                "zrms_label": "Syst\xe8me Mon\xe9taire Relationnel Z",
                "zrms_description": "Les Zollars appliquent votre valeur associative des relations pour payer les actifs en utilisant l'Amour, la Haine, l'Amiti\xe9, la Mort, la Fraternit\xe9...",
                "commodity_x_label": "Marchandise X",
                "commodity_x_description": "\xc9changez des marchandises avec un pi\xe8ge, vous avez besoin d'une validation sociale avant toute consommation (\xe9changer avec l'article d'un autre trader \u2192 consommer).",
                "economic_tools_label": "Outils \xe9conomiques",
                "economic_tools_description": "maniez les LBO (Leveraged Buyouts), assauts communistes, subventions socialistes, dark pools, ran\xe7on, vol..., utilisez l'\xe9conomie comme armes ou cadeaux envers d'autres traders.",
                "memento_title": "Memento Mori \u2013 \xc9changer la valeur de vie pour cr\xe9er votre \xc9loge fun\xe8bre",
                "memento_why_label": "Pourquoi ?",
                "memento_why_text": "r\xe9fl\xe9chir sur la fa\xe7on dont vous valorisez la vie, les exp\xe9riences et les \xe9motions pour d\xe9terminer ce que vous valoriseriez le plus lorsque votre vie se termine.",
                "memento_confront_label": "Affrontez la mortalit\xe9",
                "memento_confront_description": "Cr\xe9ez un portefeuille de valeurs de vie en n\xe9gociant des actions, dont la valeur de vie cumulative g\xe9n\xe9rera votre \xe9loge fun\xe8bre.",
                "memento_relational_label": "Capital relationnel",
                "memento_relational_description": "Les Zollars ici repr\xe9sentent l'association de relations positives et n\xe9gatives aux actions plut\xf4t qu'un rendement num\xe9rique.",
                "memento_bourse_eye_label": '"Sous l\'\u0153il de la bourse"',
                "memento_bourse_eye_description": "La bourse portera un jugement sur toi dans ton \xe9loge fun\xe8bre en observant toutes tes transactions jusqu'\xe0 la fin.",
                "enter_key_title": "Acc\xe8s au simulateur requis",
                "enter_key_title_session": "Acc\xe8s requis pour cr\xe9er une session",
                "enter_key_description": "Veuillez entrer votre cl\xe9 d'acc\xe8s au simulateur ou scanner le code QR pour continuer.",
                "enter_key_description_session": "Veuillez entrer votre cl\xe9 d'acc\xe8s pour cr\xe9er une nouvelle session.",
                "enter_key_placeholder": "Entrez la cl\xe9 du simulateur...",
                "analyzing_life_values": "Analyse de vos valeurs de vie...",
                "finding_companies": "Recherche d'entreprises align\xe9es avec votre h\xe9ritage...",
                "building_chamber": "Construction de votre chambre de mortalit\xe9...",
                "preparing_stocks": "Pr\xe9paration de votre portefeuille d'h\xe9ritage...",
                "market_response_label": "R\xe9ponse du march\xe9",
                "select_company_heading": "Choisissez une entreprise en phase avec votre \xe9tat \xe9motionnel.",
                "memento_mori_description": "Souviens-toi que tu dois mourir. Cette simulation explore les choix significatifs dans un temps limit\xe9.",
                "mortality_chamber_setup": "Vous serez transport\xe9 dans l'environnement de simulation, o\xf9 vous ferez face \xe0 un compte \xe0 rebours menant \xe0 votre mort symbolique et prendrez des d\xe9cisions de trading qui refl\xe8tent vos valeurs les plus profondes.",
                "simulation_instructions": "Vous commencerez par une courte r\xe9flexion sur vos valeurs de vie, puis recevrez des actions recommand\xe9es. Le compte \xe0 rebours commencera seulement apr\xe8s votre r\xe9flexion.",
                "building_experience": "Construction de votre Exp\xe9rience Memento Mori",
                "preparing_chamber": "Pr\xe9paration de votre chambre de mort symbolique...",
                "life_profit_title": "Explorer ce qui a de la valeur pour vous",
                "welcome_setup": "Bienvenue ! Configurons votre portefeuille de trading.",
                "life_profits_explanation": 'Trouvons une action d\'entreprise ZEconomy en laquelle vous croyez pour g\xe9n\xe9rer des "Profits de Vie".',
                "no_matching_companies": "Notre syst\xe8me n'a trouv\xe9 aucune entreprise correspondant \xe0 votre profil \xe9motionnel.",
                "creating_simulation": "Cr\xe9ation de votre Simulation...",
                "please_wait": "Veuillez patienter pendant que nous g\xe9n\xe9rons votre portefeuille virtuel.",
                "trade_title": "Trade sur ZExchange.",
                "one_off_session": "Session unique"
            },
            "story": {
                "catena_title": "Catena Narrativa",
                "catena_subtitle": "Construction de r\xe9cits comme des cha\xeenes d'approvisionnement : \xe9changez, personnalisez et consolidez \xe0 travers trois phases pour compl\xe9ter le processus de cr\xe9ation d'histoire.",
                "continue_to_selection": "Continuer vers la s\xe9lection d'histoire",
                "process_heading": "Processus :",
                "materials_motion_title": "Mat\xe9riaux en mouvement :",
                "materials_motion_desc": "\xc9changez des \xe9l\xe9ments narratifs comme des marchandises. Personnalisez-les pendant que vous les \xe9changez. La valeur se forme \xe0 travers le processus d'\xe9change pour construire une histoire.",
                "three_passes_title": "Trois passages :",
                "three_passes_desc": "Origine (d\xe9but) \u2192 Transit (milieu) \u2192 Assemblage (fin) ( 3min + 3min + 2min \u22488 minutes au total). Chaque phase se termine apr\xe8s l'expiration du temps, ou lorsque vous \xe9changez, ce qui entra\xeene la s\xe9curisation de vos marchandises de points cl\xe9s dans un registre d'histoire personnel.",
                "composition_title": "Composition :",
                "composition_desc": "\xc0 la fin, votre registre est transform\xe9 en une courte histoire g\xe9n\xe9r\xe9e \xe0 partir de vos \xe9changes personnalis\xe9s d'actifs et de points cl\xe9s \xe9chang\xe9s et s\xe9curis\xe9s.",
                "commodity_x_label": "Marchandise X",
                "commodity_x_desc": "fait partie de ZEconomy o\xf9 les profits sont mesur\xe9s en <strong>Profit de Vie</strong>\u2014 la qualit\xe9 et la quantit\xe9 d'intellect, d'affection, de f\xeate... etc, tous les divers \xe9v\xe9nements de la vie, promouvant l'\xeatre\u2014plut\xf4t que l'accumulation.",
                "footer_note_consumption": "Marchandise X o\xf9 la Consommation est relationnelle : vous ne pouvez pas consommer sans consentement mutuel. La marchandise n'est pas l'objet ; la marchandise est l'interaction.",
                "footer_note_redeem": "\xc9changez relationnellement. Consommez consciemment.",
                "simulation_title": "Simulation d'Histoire",
                "simulation_intro": "Engagez-vous dans un \xe9change narratif avec des participants automatis\xe9s \xe0 travers trois phases distinctes, cr\xe9ant une courte histoire unique gr\xe2ce \xe0 une collaboration dynamique.",
                "choose_genre": "Choisissez votre genre",
                "genre_scifi": "Science-Fiction",
                "genre_scifi_desc": "Visions futuristes et mondes sp\xe9culatifs",
                "genre_romance": "Romance",
                "genre_romance_desc": "\xc9motion, intimit\xe9 et connexion humaine",
                "genre_mystery": "Myst\xe8re",
                "genre_mystery_desc": "Secrets, enqu\xeate et motifs dissimul\xe9s",
                "genre_fantasy": "Fantaisie",
                "genre_fantasy_desc": "Mythe, imagination et transcendance",
                "genre_horror": "Horreur",
                "genre_horror_desc": "Peur, suspense et confrontation avec l'inconnu",
                "duration": "Dur\xe9e : 8 minutes (phases de 3 + 3 + 2 minutes)",
                "loading_elements": " Chargement des \xe9l\xe9ments d'histoire...",
                "choose_starting_element": "Choisissez votre \xe9l\xe9ment de d\xe9part",
                "select_one_element": "S\xe9lectionnez un \xe9l\xe9ment d'histoire pour commencer. Vous recevrez \xe9galement 2 \xe9l\xe9ments al\xe9atoires.",
                "skip_selection": "Passer la s\xe9lection (Obtenir 3 \xe9l\xe9ments al\xe9atoires)",
                "preparing_story": "Pr\xe9paration de votre histoire...",
                "setting_up_simulation": "Configuration de la simulation {theme}...",
                "story_begins": "L'histoire commence maintenant",
                "entering_world": "Entr\xe9e dans le monde {theme} dans 2 secondes...",
                "failed_load_elements": "\xc9chec du chargement des \xe9l\xe9ments d'histoire",
                "failed_create_session": "\xc9chec de la cr\xe9ation de la session d'histoire",
                "your_story_complete": "Votre histoire est termin\xe9e",
                "generating_final_story": "G\xe9n\xe9ration de votre histoire finale...",
                "please_wait": "Veuillez patienter...",
                "fallback_story": "Votre voyage narratif \xe0 travers le march\xe9 des histoires s'est conclu. Les \xe9l\xe9ments que vous avez \xe9chang\xe9s et personnalis\xe9s se sont tiss\xe9s ensemble en un conte unique."
            },
            "memento": {
                "question_1": "1. Comment vous sentez-vous par rapport \xe0 votre vie en ce moment ?",
                "question_1_placeholder": "ex. : anxieux pour l'avenir, reconnaissant pour mes relations...",
                "question_2": "2. Qu'est-ce qui compte le plus pour vous ?",
                "question_2_placeholder": "ex. : la famille, la cr\xe9ativit\xe9, avoir un impact...",
                "question_3": "3. Si votre vie se terminait demain, que voudriez-vous que votre h\xe9ritage repr\xe9sente ?",
                "question_3_placeholder": "ex. : quelqu'un qui a aid\xe9 les autres, qui a v\xe9cu authentiquement...",
                "find_companies_button": "Trouver des entreprises significatives",
                "choose_legacy_title": "Choisissez votre portefeuille d'h\xe9ritage",
                "choose_legacy_description": "S\xe9lectionnez 3 \xe0 5 entreprises qui repr\xe9sentent ce qui compte le plus pour vous.",
                "choose_legacy_warning": "Ce seront les actions que vous d\xe9tiendrez lorsque votre temps expirera.",
                "selected_count": "S\xe9lectionn\xe9",
                "your_time_begins": "\u23F3 Votre temps commence maintenant \u23F3",
                "entering_mortality_chamber": "Entr\xe9e dans votre chambre de mortalit\xe9 dans 2 secondes...",
                "your_eulogy_label": "VOTRE \xc9LOGE FUN\xc8BRE",
                "generating_eulogy": "G\xe9n\xe9ration de l'histoire de votre vie bas\xe9e sur vos choix...",
                "your_eulogy_expanded_title": "VOTRE \xc9LOGE FUN\xc8BRE",
                "eulogy_subtitle": "Une r\xe9flexion sur vos choix dans le march\xe9 de la vie",
                "eulogy_update_info": "Cet \xe9loge fun\xe8bre se met \xe0 jour toutes les 2 minutes en fonction de vos actions de trading",
                "eulogy_fallback": "Votre voyage \xe0 travers le march\xe9 de la vie continue de se d\xe9rouler, chaque choix r\xe9v\xe9lant les valeurs qui guident votre chemin.",
                "intor_pop": "Fen\xeatre d'introduction \xe0 la contemplation",
                "intro_pop": "Fen\xeatre d\u2019introduction \xe0 la contemplation",
                "first_form": "Premier formulaire de r\xe9flexion",
                "second_form": "Deuxi\xe8me formulaire de r\xe9flexion",
                "begin_countdown": "Lancer le compte \xe0 rebours",
                "instructions_title": "Comment cela fonctionne",
                "countdown_notice": "Le compte \xe0 rebours commencera apr\xe8s votre premi\xe8re r\xe9flexion.",
                "accept_eulogy": "Accepter l\u2019oraison",
                "regenerate_eulogy": "R\xe9g\xe9n\xe9rer l\u2019oraison",
                "enter_chamber": "Entrer dans la chambre",
                "pick_companies_title": "Entreprises recommand\xe9es selon vos r\xe9flexions",
                "continue_button": "Continuer",
                "validate_key": "Valider la cl\xe9",
                "scan_qr_code": "Scanner le code QR",
                "back_button": "Retour",
                "submit_button": "Valider",
                "finish_button": "Terminer",
                "questionnaire_title": "R\xe9fl\xe9chir avant d\u2019\xe9changer",
                "emotional_state_label": "Comment vous sentez-vous en ce moment ?",
                "intention_label": "Quelle intention guide vos choix ?",
                "portfolio_meaning_label": "Que doit signifier votre portefeuille ?",
                "oracle_ask_placeholder": "Demandez \xe0 le March\xe9 de votre parcours\u2026",
                "tribute_placeholder": "Laissez un hommage\u2026",
                // --- Flattened from the tree you pasted ---
                // Timer & banner
                "timer_title": "MEMENTO MORI",
                "timer_loading": "Chargement\u2026",
                "timer_click_to_reflect": "Cliquer pour r\xe9fl\xe9chir",
                // Trading overlay & notifications
                "trading_overlay_title": " N\xe9gociation consciente de la mortalit\xe9 ",
                "trading_overlay_line1": "Vous avez <strong>5 minutes</strong> pour n\xe9gocier en gardant la mortalit\xe9 \xe0 l\u2019esprit.",
                "trading_overlay_line2": "Chaque transaction refl\xe8te ce qui compte vraiment.",
                "trading_overlay_line3": "Des bots proposeront des \xe9changes symboliques pour mettre vos valeurs \xe0 l\u2019\xe9preuve.",
                "trading_begin_button": "Commencer \xe0 n\xe9gocier",
                "trading_active_badge": "N\xc9GOCIATION MEMENTO MORI ACTIVE",
                "trading_all_available": "Plus de 310 entreprises disponibles pour la n\xe9gociation",
                "trading_values_over_profit": "N\xe9gociez selon vos valeurs, pas pour le profit",
                // Oracle
                "oracle_loading_title": "le March\xe9 s\u2019\xe9veille",
                "oracle_loading_examining": "le March\xe9 examine l\u2019\xe2me de votre portefeuille\u2026",
                "oracle_loading_preparing": "Pr\xe9paration de questions personnalis\xe9es sur votre mortalit\xe9\u2026",
                "oracle_loading_wait": "Cela peut prendre un instant\u2026",
                "oracle_title": "Le March\xe9 de la mortalit\xe9",
                "oracle_greeting": "Le March\xe9 d\xe9c\xe8le dans votre portefeuille des motifs qui r\xe9v\xe8lent votre rapport \xe0 la mortalit\xe9.",
                "oracle_questions_header": "le March\xe9 a pr\xe9par\xe9 des questions pour votre \xe2me :",
                "oracle_direct_label": "Ou adressez-vous directement \xe0 le March\xe9 :",
                "oracle_custom_prompt": "Interrogez le March\xe9 sur votre mortalit\xe9, ce que dit votre portefeuille de votre \xe2me, ou le sens de vos choix financiers face \xe0 la finitude\u2026",
                "oracle_consult_button": "Consulter le March\xe9",
                "oracle_vision_title": "Vision de le March\xe9 :",
                "oracle_further_insight": "Analyse compl\xe9mentaire de le March\xe9 :",
                "oracle_continue_reflections": "Poursuivre les r\xe9flexions",
                "oracle_ask_another": "Poser une autre question",
                "oracle_return_trading": "Revenir au march\xe9",
                "oracle_ask_validation": "Veuillez s\xe9lectionner ou \xe9crire une question pertinente sur la mortalit\xe9 (au moins 10 caract\xe8res).",
                "oracle_failed": "La consultation de le March\xe9 a \xe9chou\xe9",
                "oracle_spoken_placeholder": "le March\xe9 s\u2019est exprim\xe9\u2026",
                "oracle_wisdom_received": "Sagesse re\xe7ue",
                // Reflection (Phase 1)
                "reflection_title": "MEMENTO MORI : R\xc9FLEXION",
                "reflection_subtitle": "Avant de n\xe9gocier, r\xe9fl\xe9chissez \xe0 ce qui compte vraiment dans votre vie",
                "reflection_placeholder": "Partagez vos pens\xe9es\u2026",
                "reflection_continue": "Passer \xe0 l\u2019analyse des valeurs \u2192",
                "reflection_answer_required": "Veuillez fournir une r\xe9ponse significative.",
                "reflection_process_failed": "\xc9chec du traitement des r\xe9flexions",
                "reflection_process_failed_retry": "\xc9chec du traitement des r\xe9flexions. Veuillez r\xe9essayer.",
                // Questions (fallback texts)
                "questions_life_values": "Quelles valeurs et quels principes ont guid\xe9 vos choix de vie ? Qu\u2019est-ce qui compte le plus pour vous ?",
                "questions_meaningful_pursuits": "Quelles activit\xe9s, relations ou qu\xeates vous ont apport\xe9 le plus de sens et d\u2019\xe9panouissement ?",
                "questions_relationships_impact": "En quoi vos relations avec les autres ont-elles influenc\xe9 votre vie ? Quels liens comptent le plus ?",
                // Value analysis (Phase 2)
                "analysis_title": "VOTRE PROFIL DE VALEURS",
                "analysis_subtitle": "D\u2019apr\xe8s vos r\xe9flexions, voici des entreprises en accord avec vos valeurs",
                "analysis_guidance_title": "Conseils :",
                "analysis_recommended_title": "Entreprises recommand\xe9es :",
                "analysis_start_trading": "Commencer \xe0 n\xe9gocier (310+ entreprises) \u2192",
                // Final call reminder
                "final_call_title": "DERNIER APPEL",
                "final_call_body": "Le temps s\u2019\xe9coule. Finalisez maintenant votre simulation Memento Mori.",
                "final_call_complete_now": "Terminer maintenant \u2192",
                // Timeout popup
                "timeout_title": "TEMPS \xc9COUL\xc9",
                "timeout_body": "La mort est survenue, mais le sens de votre portefeuille est pr\xe9serv\xe9\u2026",
                "timeout_generating": "G\xe9n\xe9ration de votre oraison finale\u2026",
                "death_complete_title": "MORT SYMBOLIQUE ACHEV\xc9E",
                "death_complete_subtitle": "Vous avez affront\xe9 votre mortalit\xe9 et cr\xe9\xe9 votre h\xe9ritage.",
                "final_judgment_title": "Jugement final de votre portefeuille :",
                "final_epitaph_title": "Votre \xe9pitaphe finale :",
                "return_to_void_button": "Retourner au n\xe9ant",
                "eulogy_title": "VOTRE ORAISON NUM\xc9RIQUE",
                "eulogy_subtitle": "Fond\xe9e sur vos choix de portefeuille et vos r\xe9flexions de vie",
                "eulogy_your_eulogy": "Votre oraison :",
                "eulogy_insights": "Enseignements du portefeuille :",
                "eulogy_rest_in_peace": "Reposez en paix"
            },
            "socketBack": {
                "narrativeProcessed": "R\xe9ponse narrative trait\xe9e",
                "unauthorizedSuperUser": "Non autoris\xe9 : seuls les banquiers de la Z\xe9d\xe9rale R\xe9serve peuvent effectuer cette action",
                "noTargetUser": "Aucun trader cible fourni",
                "logoutByAdmin": "Vous avez \xe9t\xe9 d\xe9connect\xe9 par un administrateur.",
                "logoutUserSuccess": "L\u2019utilisateur {id} a \xe9t\xe9 d\xe9connect\xe9 de force avec succ\xe8s.",
                "logoutUserOffline": "L\u2019utilisateur {id} est d\xe9j\xe0 hors ligne.",
                "marketClosed": "Le march\xe9 est ferm\xe9.",
                "logoutAllSuccess": "Tous les traders ont \xe9t\xe9 d\xe9connect\xe9s avec succ\xe8s.",
                "taxEvent": "Vous \xeates soumis \xe0 une taxe de march\xe9. Choisissez de donner un bien au hasard ou de perdre du capital.",
                "zollarIssued": "Un Zollar vous a \xe9t\xe9 \xe9mis par la Z\xe9d\xe9rale R\xe9serve.",
                "zollarFailed": "\xc9chec de l\u2019attribution des Zollars",
                "ransomAssigned": "Vous avez re\xe7u le d\xe9clencheur de ran\xe7on.",
                "ransomLocked": "Votre portefeuille a \xe9t\xe9 verrouill\xe9 avec une ran\xe7on de {points} capitaux.",
                "lboAssigned": "Vous avez re\xe7u le d\xe9clencheur de rachat avec effet de levier (LBO).",
                "lboAssetsRemoved": "Des actifs ont \xe9t\xe9 retir\xe9s de votre portefeuille en raison d\u2019un LBO.",
                "removedStocksLabel": "Actions retir\xe9es :",
                "removedItemsLabel": "Objets retir\xe9s :",
                "unknownStock": "Action inconnue",
                "unknownItem": "Objet inconnu",
                "sharesWord": "parts",
                "ofWord": "de",
                "subsidy_assigned": "Vous avez re\xe7u le d\xe9clencheur de Subvention.",
                "subsidy_taxed": "45 % de votre richesse ont \xe9t\xe9 redistribu\xe9s comme Subvention socialiste pour les revenus plus faibles.",
                "subsidy_received": "Vous avez re\xe7u une subvention socialiste.",
                "pointsGiven": "Du capital a \xe9t\xe9 \xe9mis.",
                "itemsDistributed": "Des biens ont \xe9t\xe9 distribu\xe9s.",
                "freebieZ1Message": "La Zederal Reserve a distribu\xe9 un bien gratuit \xe0 votre portefeuille !",
                "ransomPaidNotification": "{userName} a pay\xe9 la ran\xe7on de {points} capital. Les fonds ont \xe9t\xe9 transf\xe9r\xe9s sur votre compte.",
                "pointsDeducted": "{amount} capital ont \xe9t\xe9 d\xe9duits de votre compte.",
                "itemTaxed": "La Z\xe9d\xe9rale R\xe9serve a tax\xe9 un bien dans vos avoirs.",
                "deleteButtonAssigned": "Vous avez re\xe7u le d\xe9clencheur d\u2019Assaut communiste.",
                "deletePerformed": "Votre portefeuille a \xe9t\xe9 cibl\xe9 par un Assaut communiste.",
                "subsidyUpdateBotTarget": "{botName} a d\xe9clench\xe9 une Subvention socialiste \u2014 45 % de votre richesse ont \xe9t\xe9 redistribu\xe9s.",
                "specialSubsidyTarget": "{botName} a redistribu\xe9 45 % de votre richesse via une Subvention socialiste",
                "subsidyReceivedFrom": "Vous avez re\xe7u une Subvention socialiste gr\xe2ce \xe0 l\u2019action de redistribution de {botName} !",
                "specialSubsidyReceived": "Vous avez re\xe7u des fonds issus de la Subvention socialiste de {botName}",
                "ransomLockedBy": "{botName} a gel\xe9 votre portefeuille avec une ran\xe7on de {points} capital !",
                "specialRansomTarget": "{botName} a gel\xe9 votre portefeuille et exige une ran\xe7on",
                "specialRansomImpact": "Portefeuille verrouill\xe9 \u2014 {points} de capital requis",
                "lboExecutedOnYouBy": "{botName} a r\xe9alis\xe9 un rachat avec effet de levier (LBO) sur votre portefeuille.",
                "specialLboTarget": "Votre portefeuille a \xe9t\xe9 la cible d\u2019un LBO r\xe9alis\xe9 par {botName}",
                "itemStolen": "{botName} a vol\xe9 \xab {itemName} \xbb dans votre portefeuille !",
                "specialStealTarget": "{botName} vous a vol\xe9 \xab {itemName} \xbb",
                "specialStealImpact": "Objet perdu : {itemName}",
                "deleteUpdateBy": "{botName} a ex\xe9cut\xe9 un Assaut communiste sur votre portefeuille !",
                "specialDeleteTarget": "{botName} a ex\xe9cut\xe9 un Assaut communiste sur votre portefeuille",
                "assaultGameEvent": "{botName} a ex\xe9cut\xe9 un Assaut communiste contre {targetName} !",
                "unknownPlayer": "Joueur inconnu",
                "tradeAccepted": "\xc9change accept\xe9 ! capital attribu\xe9s.",
                "tradeDeclined": "\xc9change refus\xe9. Aucun capital attribu\xe9."
            },
            "socketFront": {
                "ransomTitle": "Portefeuille ran\xe7onn\xe9 !",
                "ransomHeldBy": "Votre portefeuille est retenu contre ran\xe7on par",
                "ransomMustPay": "Vous devez payer {points} capital pour reprendre le contr\xf4le.",
                "payRansomCta": "Payer la ran\xe7on ({points} capital)",
                "ransomPayFailed": "\xc9chec du paiement de la ran\xe7on. Veuillez r\xe9essayer.",
                "messageError": "Erreur d\u2019envoi du message :",
                "sendErrorPrefix": "Erreur d\u2019envoi du message :",
                "messageSent": "Message envoy\xe9 avec succ\xe8s !",
                "messageSentSuccess": "Message envoy\xe9 avec succ\xe8s !",
                "loggedOutByAdmin": "Vous avez \xe9t\xe9 d\xe9connect\xe9 par l\u2019administrateur.",
                "logoutActiveUpdateError": "Erreur lors de la mise \xe0 jour de l\u2019\xe9tat pendant la d\xe9connexion. Veuillez r\xe9essayer.",
                "logoutServerError": "Erreur lors de la d\xe9connexion serveur. Veuillez r\xe9essayer.",
                "mementoComplete": "Vous avez termin\xe9 votre contemplation de la mortalit\xe9 !",
                "darkPoolEnded": "Le Dark Pool est termin\xe9. Vous retrouvez votre statut normal.",
                "darkPoolExpired": "Le Dark Pool a expir\xe9. Vous retrouvez votre statut normal.",
                "timerExtended60": "Minuteur prolong\xe9 \xe0 60 secondes",
                "tradeAcceptedFrom": "\xc9change accept\xe9 de",
                "forWord": "pour",
                "ofType": "de type",
                "tradeAcceptFailed": "\xc9chec de l\u2019acceptation de l\u2019\xe9change :",
                "tradeAcceptFailedPrefix": "\xc9chec de l\u2019acceptation de l\u2019\xe9change :",
                "tradeDeclined": "\xc9change refus\xe9.",
                "respondedToAnalysis": "a r\xe9pondu \xe0 votre analyse d\u2019\xe9change",
                "tradeAnalysisResponded": "a r\xe9pondu \xe0 votre analyse d\u2019\xe9change",
                "offerAccepted": "Offre accept\xe9e !",
                "offerDeclined": "Offre refus\xe9e !",
                "offerAcceptedLong": "Votre offre a \xe9t\xe9 accept\xe9e.",
                "offerDeclinedLong": "Votre offre a \xe9t\xe9 refus\xe9e !",
                "offerExpired": "Votre offre a expir\xe9",
                "offerError": "Une erreur s\u2019est produite avec votre offre",
                "shortSuccess": "Vente \xe0 d\xe9couvert r\xe9ussie !",
                "shortFailed": "\xc9chec de la vente \xe0 d\xe9couvert :",
                "shortClosedPrefix": "Votre position courte sur l\u2019action",
                "shortClosedSuffix2": "a \xe9t\xe9 cl\xf4tur\xe9e automatiquement.",
                "bondBidPrefix": "Votre offre pour l\u2019obligation",
                "bondAccepted": "a \xe9t\xe9 accept\xe9e.",
                "bondDeclined": "a \xe9t\xe9 refus\xe9e.",
                "yourBond": "Votre obligation",
                "bondMatured": "est arriv\xe9e \xe0 \xe9ch\xe9ance et des zollars ont \xe9t\xe9 \xe9mis.",
                "buyOfferAcceptedFrom": "Offre d'achat accept\xe9e de",
                "buyAcceptFailed": "\xc9chec de l'acceptation de l'offre d'achat :",
                "buyAcceptFailedPrefix": "\xc9chec de l'acceptation de l'offre d'achat :",
                "warningPrefix": "ATTENTION :",
                "criticalPrefix": "CRITIQUE :",
                "debtPageVisit": "Visitez la page Dette pour plus de d\xe9tails.",
                "debtWipeoutDefault": "Votre portefeuille a \xe9t\xe9 effac\xe9 en raison d'une dette excessive.",
                "debtWarningPrefix": "ATTENTION : Cette dette se recharge toutes les 60 secondes avec un int\xe9r\xeat compos\xe9 de 15 % jusqu'au remboursement.",
                "bankruptcyWarning": "ATTENTION : Vous approchez de la faillite !",
                "debtCompounded": "Dette compos\xe9e :",
                "totalDebt": "Dette totale :",
                "youOwe": "Vous devez :",
                "checkDebtHeldSection": "Consultez votre section Dettes d\xe9tenues pour convertir."
            },
            "debtWarning": {
                "title": "Alerte de Dette",
                "aboutToGoIntoDebt": "Vous \xeates sur le point de vous endetter !",
                "currentBalance": "Solde actuel :",
                "bidAmount": "Montant de l'offre :",
                "offerAmount": "Montant de l'offre :",
                "youWillOwe": "Vous devrez :",
                "interestAccrues": "Les int\xe9r\xeats s'accumulent \xe0 5 % par jour sur les soldes n\xe9gatifs.",
                "creditLimit": "Limite de cr\xe9dit : -1000 capital (par d\xe9faut)",
                "proceedAnyway": "Continuer quand m\xeame",
                "cancel": "Annuler",
                "points": "Capitaux"
            },
            "debt": {
                "capital": "capital",
                "closedDefault": "Un instrument de dette de type {type} a \xe9t\xe9 cl\xf4tur\xe9.",
                "closedGeneric": "Un instrument de dette a \xe9t\xe9 cl\xf4tur\xe9.",
                "amounts": {
                    "none": "Aucun",
                    "barelyAny": "Presque rien",
                    "aTrace": "Une trace",
                    "aHint": "Un soup\xe7on",
                    "aLittle": "Un peu",
                    "aFew": "Quelques-uns",
                    "some": "Certains",
                    "several": "Plusieurs",
                    "moderate": "Mod\xe9r\xe9",
                    "noticeable": "Notable",
                    "considerable": "Consid\xe9rable",
                    "many": "Nombreux",
                    "aLot": "Beaucoup",
                    "abundant": "Abondant",
                    "heaps": "\xc9normes quantit\xe9s",
                    "aGreatDeal": "Une grande quantit\xe9",
                    "substantial": "Substantiel",
                    "immense": "Immense"
                },
                "interest": {
                    "minimal": "Charge \xe9motionnelle minimale",
                    "light": "Charge \xe9motionnelle l\xe9g\xe8re",
                    "modest": "Charge \xe9motionnelle modeste",
                    "fair": "Charge \xe9motionnelle \xe9quitable",
                    "moderate": "Charge \xe9motionnelle mod\xe9r\xe9e",
                    "notable": "Charge \xe9motionnelle notable",
                    "considerable": "Charge \xe9motionnelle consid\xe9rable",
                    "heavy": "Charge \xe9motionnelle lourde",
                    "intense": "Charge \xe9motionnelle intense",
                    "crushing": "Charge \xe9motionnelle \xe9crasante"
                },
                "altrau": {
                    "receivedTitle": "Effet Altrau Z re\xe7u",
                    "issuedTitle": "Effet Altrau Z \xe9mis",
                    "hasGivenYou": "vous a donn\xe9",
                    "ledgersBound": "Vos registres sont d\xe9sormais li\xe9s. Leur Profit Vital affecte le v\xf4tre.",
                    "youHaveSent": "Vous avez envoy\xe9",
                    "toRecipient": "\xe0",
                    "fatesBound": "Vos destins sont d\xe9sormais li\xe9s. Votre Profit Vital affecte le leur."
                },
                "mnote": {
                    "acceptedTitle": "Note M accept\xe9e",
                    "createdTitle": "Note M cr\xe9\xe9e",
                    "witnessedVulnerability": "a \xe9t\xe9 t\xe9moin de votre vuln\xe9rabilit\xe9",
                    "loanLabel": "Pr\xeat",
                    "atRate": "avec",
                    "positiveTradeTip": "Effectuez des \xe9changes positifs pour r\xe9duire automatiquement cette dette !",
                    "createdWith": "Note M cr\xe9\xe9e avec",
                    "tradeableAfter": "N\xe9gociable apr\xe8s 5 \xe9changes. Convertible apr\xe8s le maximum d'\xe9changes.",
                    "progressTitle": "Progression du remboursement de la Note M",
                    "repaidPercent": "Vous avez rembours\xe9",
                    "throughTrading": "gr\xe2ce \xe0 des \xe9changes positifs",
                    "keepTrading": "Continuez \xe0 bien n\xe9gocier pour r\xe9duire davantage votre dette.",
                    "debtClearedTitle": "Dette effac\xe9e !",
                    "repaidTitle": "Note M rembours\xe9e",
                    "positiveTrading": "\xe9changes positifs",
                    "directRepayment": "remboursement direct",
                    "fullyRepaidTo": "Vous avez enti\xe8rement rembours\xe9 votre Note M \xe0",
                    "throughMethod": "par",
                    "emotionalDebtCleared": "Votre dette \xe9motionnelle est effac\xe9e. Bien jou\xe9 !",
                    "hasFullyRepaid": "a enti\xe8rement rembours\xe9 sa Note M",
                    "instrumentClosed": "L'instrument de dette a \xe9t\xe9 cl\xf4tur\xe9.",
                    "alertTitle": "Alerte Note M",
                    "convertibleTitle": "Note M convertible",
                    "nowConvertible": "Votre Note M est d\xe9sormais",
                    "convertibleCaps": "CONVERTIBLE",
                    "canConvertTo": "Vous pouvez la convertir en",
                    "inLiquidAssets": "en actifs liquides"
                },
                "cdo": {
                    "acceptedTitle": "CDO Z-Payday accept\xe9e",
                    "createdTitle": "CDO Z-Payday cr\xe9\xe9e",
                    "offeredLoan": "vous a propos\xe9 un pr\xeat",
                    "availableImmediately": "disponible imm\xe9diatement",
                    "createdWith": "CDO Z-Payday cr\xe9\xe9e avec",
                    "tradeableCompounds": "N\xe9gociable. Composition toutes les 60s \xe0 15%.",
                    "bankruptcyWarningTitle": "ALERTE FAILLITE",
                    "reloadCycle": "Rechargement CDO : Cycle {cycle}",
                    "cdoCompounded": "Votre CDO a \xe9t\xe9 compos\xe9e",
                    "victimOwes": "La victime doit",
                    "bankruptcyTitle": "FAILLITE",
                    "cdoCollapsed": "Votre CDO Z-Payday s'est effondr\xe9e",
                    "totalDebtLabel": "Dette totale",
                    "assetsSeized": "Actifs saisis",
                    "standingDamaged": "Votre situation financi\xe8re a \xe9t\xe9 gravement endommag\xe9e.",
                    "maturedTitle": "CDO arriv\xe9e \xe0 maturit\xe9",
                    "victimBankrupt": "Votre victime a d\xe9clar\xe9 faillite",
                    "youSeized": "Vous avez saisi",
                    "toxicGainRecorded": "Gain toxique enregistr\xe9 dans les relations."
                },
                "vnote": {
                    "aidGrantedTitle": "Aide de la Note V accord\xe9e",
                    "hasGrantedAid": "vous a accord\xe9 son aide",
                    "received": "Re\xe7u",
                    "vulnerabilityWitnessed": "Votre vuln\xe9rabilit\xe9 a \xe9t\xe9 reconnue et accueillie avec compassion.",
                    "youGranted": "Vous avez accord\xe9",
                    "toRecipient": "\xe0",
                    "compassionRecorded": "Votre compassion a \xe9t\xe9 enregistr\xe9e dans le registre social."
                }
            },
            "tax": {
                "tax_alert_timer": "ALERTE FISCALE ! Vous avez 10 secondes pour choisir, sinon vous perdez les deux :",
                "lose_capital": "Perdre du capital",
                "lose_capital_zollars": "Perdre du capital & zollars",
                "give_random_asset": "Donner un bien al\xe9atoire",
                "assign_failed": "\xc9chec de l\u2019attribution d\u2019un nouvel actif \xe0 tous les portefeuilles.",
                "new_asset_assigned": "La Zederal Reserve a attribu\xe9 un nouvel actif \xe0 votre portefeuille.",
                "tax_call_no_assets": "La R\xe9serve Z\xe9d\xe9rale impose un pr\xe9l\xe8vement. Appuyez sur OK pour c\xe9der du capital, aucun bien disponible pour r\xe9gler.",
                "asset_taxed": "Un bien a \xe9t\xe9 tax\xe9 par la Zederal Reserve.",
                "no_items_available": "Aucun bien non \xe9chang\xe9 disponible pour la taxation.",
                "tax_item_failed": "\xc9chec de la taxation d\u2019un bien.",
                "capital_taxed_prefix": "Vous avez \xe9t\xe9 tax\xe9 en capital par la Zederal Reserve !",
                "refund_received_prefix": "Vous avez re\xe7u un remboursement de capital de la Zederal Reserve",
                "new_asset_received": "Vous avez re\xe7u un nouvel actif de la Zederal Reserve",
                "zollar_assigned": "Vous avez re\xe7u des Zollars de la Zederal Reserve.",
                "points": "Capitaux"
            },
            "trader": {
                "price": "prix",
                "bien_q": "Bien",
                "send_message": "Envoyer un message",
                "no_economic_tiggers": "Vous n'avez aucun d\xe9clencheur \xe9conomique.",
                "no_stocks": "Vous ne poss\xe9dez aucune action.",
                "output": "Production",
                "tap_for_details": "touchez pour la fiche compl\xe8te + graphique",
                "message_cost": "Co\xfbt : 20 ",
                "no_bond_port": "Vous n'avez aucune ZBond.",
                "select_recipient": "S\xe9lectionnez un destinataire :",
                "message_placeholder": "Saisissez votre message (280 caract\xe8res max)",
                "send_button": "Envoyer",
                "close_button": "Fermer",
                "no_bond_port": "",
                "no_redeemed_item": "Aucun bien converti dans votre portefeuille.",
                "steal_commodity": "Voler une Commodity",
                "ransom": "Ran\xe7on",
                "no_zollar_port": "Aucun Zollar dans vos portefeuille.",
                "create_dark_pool": "Cr\xe9er un Dark Pool",
                "delete_portfolio": "Supprimer le portefeuille",
                "capitalist_lbo": "LBO Capitaliste",
                "socialist_subsidy": "Subvention Socialiste",
                "explanations": "Explications",
                "click_learn_more": "Cliquez pour en savoir plus",
                "go_to_market": "Aller au March\xe9",
                "dark_pool_market": "March\xe9 Dark Pool",
                "no_reason_provided": "Aucune raison fournie",
                "stock_name": "Nom de l'action",
                "unknown": "Inconnu",
                "symbol": "Symbole",
                "quantity": "Quantit\xe9",
                "no_shorts_open": "Aucune position Short plac\xe9e",
                "no_short_data": "Aucune data",
                "initial_value_per_share": "Valeur initiale par action",
                "current_value_per_share": "Valeur actuelle par action",
                "total_gain_loss": "Gain/Perte total",
                "reason_for_short": "Raison du short",
                "close_short_position": "Fermer la position short",
                "your_portfolio": "Votre portefeuille",
                "emotional_state_banner_title": "Votre \xe9conomie \xe9motionnelle",
                "social_economy_banner_title": "Instruments de dette \xe9motionnelle",
                "issue_altrau_z_bill": "\xc9mettre un Billet Z Altrauiste",
                "issue_m_note_borrow": "\xc9mettre une Note M (Emprunter)",
                "issue_z_payday_cdo": "\xc9mettre un CDO Z-Payday",
                "issue_v_note_request_aid": "Note V (Appel \xe0 l'aide)"
            },
            "market": {
                "all_types": "Tous les types",
                "goods": "Biens",
                "stocks": "Actions",
                "short_stock_title": "Shorter une Action ",
                "stock_label": "Action",
                "current_share_value": "Cours actuel de l\u2019action",
                "bonds": "Obligations",
                "no_sort": "Aucun tri",
                "price_low_to_high": "Prix : du plus bas au plus \xe9lev\xe9",
                "price_high_to_low": "Prix : du plus \xe9lev\xe9 au plus bas",
                "apply_filter": "Appliquer le filtre",
                "reset": "R\xe9initialiser",
                "close": "Fermer",
                "explanations": "Explications",
                "items": "Biens",
                "trade": "\xc9changer",
                "buy": "Acheter",
                "processing": "traitement en cours",
                "trade_for": "\xc9changer contre",
                "description": "Description",
                "value": "Valeur",
                "quantity": "Quantit\xe9",
                "location": "Emplacement",
                "owner": "Propri\xe9taire",
                "portfolio": "Portefeuille",
                "filter": "Filtrer",
                "redeem": "\xc9changer \u2713",
                "buy_bond_confirmation": "Acheter cette obligation d\xe9clenchera sa p\xe9riode de maturit\xe9. Confirmez pour continuer.",
                "bond_purchased_success": "Obligation achet\xe9e avec succ\xe8s !",
                "bond_purchase_failed": "\xc9chec de l'achat de l'obligation. Veuillez r\xe9essayer.",
                "portfolio_ransomed": "Votre portefeuille est actuellement sous ran\xe7on. Payez la ran\xe7on pour voir et interagir avec les objets.",
                "shorted_by": "Short\xe9 par :",
                "unknown": "Inconnu",
                "num_shares": "# Actions :",
                "short_value": "Valeur du short :",
                "reason": "Raison :",
                "enter_offer_for": "Entrez votre offre pour",
                "available_points": "Vous avez {points} capital disponibles. Co\xfbt de l'objet : {cost}.",
                "choose_offer_type": "Choisissez le type d'offre :",
                "waiting": "Attente",
                "zollars": "Zollars",
                "capital": "Capital",
                "confirm": "Confirmer",
                "cancel": "Annuler",
                "enter_capital": "Entrez le capital :",
                "offer_amount_placeholder": "Montant de l'offre",
                "select_zollar_value": "S\xe9lectionnez une valeur en Zollars pour continuer.",
                "invalid_offer": "Offre invalide ou capital insuffisant",
                "processing_transaction": "Traitement de votre transaction...",
                "waiting_seconds": "Attente : {seconds} secondes",
                "short_stock": "Shorter une action",
                "stock": "Action :",
                "processing": "Traitement de votre transaction...",
                "current_value": "Valeur actuelle :",
                "available_shares": "Actions disponibles :",
                "enter_num_shares": "Saisir le nombre d\u2019actions",
                "short_amount_placeholder": "Nombre d'actions \xe0 shorter",
                "short_reason_placeholder": "Pourquoi shortez-vous cette action ?",
                "confirm_short": "Confirmer le Short",
                "short_stock_btn": "Short Action",
                "must_provide_reason": "Vous devez fournir une raison pour shorter cette action.",
                "portfolio_name": "Nom du portefeuille"
            },
            offer: {
                item_received: "Vous avez re\xe7u {item} de la part de {giver} !",
                offer_sent: "Offre envoy\xe9e",
                do_not_leave_page: "NE QUITTEZ PAS LA PAGE.",
                awaiting_response: "En attente de r\xe9ponse\u2026",
                time_remaining_html: "Temps restant : <span id=\"timer\">{seconds}</span> secondes",
                time_remaining: "Temps restant : {seconds} secondes",
                time_expired: "Temps \xe9coul\xe9. Offre refus\xe9e.",
                offer_declined: "Offre refus\xe9e. Aucun capital accord\xe9.",
                offer_accepted: "Offre accept\xe9e ! Capital accord\xe9s.",
                trade_offer: "Offre de troc",
                offers_you: "{initiator} vous propose : {offered} en \xe9change de : {requested}",
                reason: "Raison :",
                respond: "R\xe9pondre",
                accept: "Accepter",
                decline: "Refuser",
                time_remaining_extended: "Temps restant : {seconds} secondes (prolong\xe9)",
                buy_offer_received: "Offre d\u2019achat re\xe7ue",
                zollar_offer_for: "Offre en zollars pour {item} de la part de {portfolio} : {details}",
                points_offer_for: "Offre en capital pour {item} de la part de {portfolio} : {details}",
                no_zollar_details: "Aucun d\xe9tail de zollars disponible.",
                your_portfolio: "Votre portefeuille",
                session_missing: "Session ou autorisation manquante. Veuillez vous reconnecter.",
                error_missing_details: "Erreur : informations manquantes pour l\u2019offre. R\xe9essayez.",
                error_invalid_points: "Erreur : montant invalide pour l\u2019offre en capital.",
                error_missing_zollar_details: "Erreur : d\xe9tails manquants pour l\u2019offre en zollars.",
                error_invalid_offer_type: "Erreur : type d\u2019offre invalide.",
                success_buy_offer_accepted: "Succ\xe8s : offre d\u2019achat accept\xe9e pour {item}",
                error_accepting_offer: "Erreur lors de l\u2019acceptation : {message}",
                processing: "Traitement de la transaction\u2026",
                meaningful_exchange: "\xc9change avec intention",
                value_quote: "La valeur existe dans la perception, le jeu et la sp\xe9culation, pas seulement l\u2019utilit\xe9 ou la raret\xe9.",
                who_to_trade_with: "Avec qui souhaitez-vous \xe9changer ?",
                select_trader: "S\xe9lectionnez un\xb7e trader\u2026",
                why_trade: "Pourquoi souhaitez-vous faire cet \xe9change ?",
                describe_motivation: "D\xe9crivez votre motivation, votre \xe9motion ou votre histoire\u2026",
                trade_with: "\xc9changer avec :",
                capital: "Capital",
                zollars: "Zollars",
                cancel: "Annuler",
                send_offer: "Envoyer l\u2019offre",
                sending: "Envoi\u2026",
                meaningful_offer_sent: "Offre de troc envoy\xe9e ! {insight}",
                error_generic: "Erreur : {message}",
                share_reason_placeholder: "Partagez votre raison, une motivation, un souvenir ou une vision\u2026 Pour cr\xe9er des liens significatifs en \xe9changeant.",
                meaningful_trade_offer: "Offre de troc avec intention",
                wants_to_trade: "souhaite \xe9changer",
                respond_optional: "R\xe9pondez \xe0 son histoire (optionnel)\u2026",
                not_interested: "Pas int\xe9ress\xe9",
                im_interested: "Je suis int\xe9ress\xe9 !",
                response_sent: "R\xe9ponse envoy\xe9e",
                interest_shown: "Int\xe9r\xeat indiqu\xe9 ! L\u2019autre partie peut vous contacter.",
                respond_to_offer: "R\xe9pondre \xe0 l\u2019offre.",
                the_why: "Le pourquoi :",
                share_thoughts: "Partagez vos id\xe9es, posez des questions ou expliquez votre point de vue\u2026",
                response_min_length: "Veuillez \xe9crire au moins 10 caract\xe8res.",
                response_min_10: "Veuillez \xe9crire au moins 10 caract\xe8res sur votre motivation.",
                send_response: "Envoyer la r\xe9ponse",
                response_sent_title: "R\xe9ponse envoy\xe9e",
                response_sent_waiting: "R\xe9ponse envoy\xe9e ! En attente de leur r\xe9ponse\u2026",
                your_response: "Votre r\xe9ponse :",
                waiting_for_response: "En attente de sa r\xe9ponse\u2026",
                timer_extended_60: "Minuteur prolong\xe9 \xe0 60 secondes",
                they_responded: "Ils ont r\xe9pondu",
                their_original_why: "Leur pourquoi initial :",
                their_response: "Leur r\xe9ponse :",
                accept_trade: "Accepter l\u2019\xe9change",
                decline_trade: "Refuser l\u2019\xe9change",
                updated_trade_offer: "Offre de troc mise \xe0 jour",
                offer_sentence_simple: "{name} vous propose {offered} et demande {requested} en \xe9change.",
                conversation: "Conversation :",
                buy_accepted_points: "{seller} a accept\xe9 votre offre ! Vous avez obtenu {item} pour {points} capital.",
                buy_accepted_zollars: "{seller} a accept\xe9 votre offre ! Vous avez obtenu {item} contre des zollars.",
                buy_accepted_generic: "{seller} a accept\xe9 votre offre ! Vous avez obtenu {item}.",
                error_processing_trade: "Erreur lors du traitement de l\u2019offre",
                zollar_none: "Aucun",
                zollar_few: "Quelques-uns",
                zollar_some: "Certains",
                zollar_many: "Beaucoup",
                zollar_huge: "\xc9norm\xe9ment"
            },
            "transaction": {
                "requested_item": "Bien demand\xe9",
                "item_owner": "Propri\xe9taire du bien",
                "item_name": "Nom du bien",
                "points": "capital",
                "location": "Emplacement",
                "propose": "Proposer",
                "explain_trade_reason": "Expliquez pourquoi vous souhaitez faire cet \xe9change.",
                "you_offer": "Vous proposez :",
                "you_want": "Vous voulez :",
                "why_trade_question": "Pourquoi voulez-vous faire cet \xe9change ? Quel est votre objectif ?",
                "share_motivation": "Partagez votre motivation, un souvenir ou une vision\u2026 Les histoires cr\xe9ent des connexions significatives dans le trading. (15 caract\xe8res minimum)",
                "narrative_error": "Veuillez \xe9crire au moins 15 caract\xe8res pour expliquer votre objectif.",
                "char_missing": "Il manque encore {count} caract\xe8res pour expliquer votre objectif.",
                "char_missing_full": "Veuillez \xe9crire au moins 15 caract\xe8res pour expliquer pourquoi vous souhaitez cet \xe9change.",
                "send_trade_with_intention": "Envoyer l'\xe9change avec une intention",
                "cancel": "Annuler",
                "select_asset": "S\xe9lectionner un actif",
                "return_to_market": "Retour au march\xe9"
            },
            "boss": {
                "session_required_leaderboard": "L'ID de session est requis pour voir le classement.",
                "session_required_mood_board": "L'ID de session est requis pour voir le tableau d'humeur.",
                "invalid_point_amount": "Montant de capital invalide. Veuillez r\xe9essayer.",
                "session_required_system_bot": "L'ID de session est requis pour d\xe9marrer le bot syst\xe8me.",
                "system_bot_started": "Bot syst\xe8me d\xe9marr\xe9 : {name}",
                "system_bot_start_failed": "\xc9chec du d\xe9marrage du bot syst\xe8me : {error}",
                "session_required_stop_bot": "L'ID de session est requis pour arr\xeater le bot syst\xe8me.",
                "system_bot_stopped": "Bot syst\xe8me arr\xeat\xe9 avec succ\xe8s.",
                "system_bot_stop_failed": "\xc9chec de l'arr\xeat du bot syst\xe8me : {error}",
                "session_required_trigger_event": "L'ID de session est requis pour d\xe9clencher l'\xe9v\xe9nement syst\xe8me.",
                "system_event_triggered": "\xc9v\xe9nement syst\xe8me d\xe9clench\xe9 avec succ\xe8s !",
                "system_event_trigger_failed": "\xc9chec du d\xe9clenchement de l'\xe9v\xe9nement syst\xe8me : {error}",
                "session_required_logout": "L'ID de session est requis pour d\xe9connecter les traders."
            },
            "stock": {
                "ownership_transferred": "Propri\xe9t\xe9 transf\xe9r\xe9e.",
                "transfer_failed": "\xc9chec du transfert de propri\xe9t\xe9. R\xe9essayez.",
                "share_deleted": "Action supprim\xe9e.",
                "delete_failed": "\xc9chec de la suppression de l\u2019action. R\xe9essayez.",
                "short_closed": "Vente \xe0 d\xe9couvert cl\xf4tur\xe9e.",
                "close_short_failed": "\xc9chec de la cl\xf4ture de la vente \xe0 d\xe9couvert. R\xe9essayez.",
                "short_placed": "Vente \xe0 d\xe9couvert ouverte.",
                "place_short_failed": "\xc9chec de l\u2019ouverture de la vente \xe0 d\xe9couvert. R\xe9essayez.",
                "no_short_positions": "Aucune vente \xe0 d\xe9couvert pour cette action.",
                "no_zollars_available": "Aucun Zollar disponible.",
                "select_zollars_to_bid": "S\xe9lectionnez des Zollars pour votre ench\xe8re.",
                "value": "Valeur",
                "place_bid": "Placer une ench\xe8re",
                "bid": "Ench\xe8re",
                "name": "Action",
                "short_reason_required": "Merci d\u2019indiquer une raison pour la short de cette action.",
                "failed_missing_shares": "\xc9chec : informations sur les actions introuvables.",
                "invalid_short_amount": "Quantit\xe9 d\u2019actions \xe0 Shorter invalide.",
                "short_succes": "Position Short plac\xe9e avec succ\xe8s !",
                "bid_type": "Type d\u2019ench\xe8re",
                "available_shares": "Actions disponibles",
                "available_funds": "Fonds disponibles",
                "fetch_short_failed": "\xc9chec du chargement des ventes \xe0 d\xe9couvert. R\xe9essayez.",
                "short_positions_for": "Ventes \xe0 d\xe9couvert pour l\u2019action",
                "short_position": "Vente \xe0 d\xe9couvert",
                "insufficient_funds": "Fonds insuffisants.",
                "enter_bid_amount": "Saisissez le montant de l\u2019ench\xe8re.",
                "enter_shares": "Saisissez le nombre d\u2019actions.",
                "enter_valid_amount": "Montant ou nombre d\u2019actions invalide.",
                "close_short": "Cl\xf4turer la vente \xe0 d\xe9couvert",
                "go_to_market": "Aller au march\xe9",
                "fetch_zollars_failed": "\xc9chec du chargement des Zollars.",
                "descriptor_none": "Aucune",
                "descriptor_a_few": "Quelques-unes",
                "descriptor_some": "Un certain nombre",
                "descriptor_many": "Beaucoup",
                "descriptor_huge": "\xc9norm\xe9ment",
                "submitting_bid": "Soumission de votre offre...",
                "please_wait": "Veuillez patienter pendant que nous la traitons.",
                "redirect_in": "Redirection dans",
                "seconds": "secondes"
            },
            "social_class": {
                "working_class": {
                    "name": "Classe Ouvri\xe8re",
                    "description": "Vous commencez endett\xe9 avec des ressources minimales. Chaque d\xe9cision compte.",
                    "goal": "\xc9chapper \xe0 la dette gr\xe2ce au commerce strat\xe9gique et \xe0 la construction communautaire",
                    "goals": {
                        "pay_off_debt": "Remonte ton capital au-dessus de z\xe9ro avant la fin du temps. Vends des parts, \xe9change des objets, accepte les offres justes \u2014 chaque affaire qui rapporte compte.",
                        "two_swaps": "R\xe9alise 2 \xe9changes (trocs) avec d'autres traders : tes choses contre les leurs. Pas besoin d'argent \u2014 le troc, c'est comme \xe7a qu'on trade quand on est fauch\xe9.",
                        "reserve_lift": "Va \xe0 la R\xe9serve Z\xe9d\xe9rale, prends un Z Bond pour obtenir du capital, et transforme-le en au moins un \xe9change qui fait grandir ce que tu d\xe9tiens."
                    }
                },
                "lower_middle": {
                    "name": "Classe Moyenne Inf\xe9rieure",
                    "description": "Vous avez des ressources modestes. Une planification prudente peut mener \xe0 la prosp\xe9rit\xe9.",
                    "goal": "Construire la stabilit\xe9 financi\xe8re et d\xe9velopper votre r\xe9seau",
                    "goals": {
                        "own_two_companies": "D\xe9tiens des parts de 2 entreprises diff\xe9rentes avant la fin. Choisis des entreprises dont l'histoire te parle \u2014 tu grandis quand elles grandissent.",
                        "first_zollars": "Ach\xe8te des zollars \xe0 la R\xe9serve Z\xe9d\xe9rale et gagne un \xe9change en payant avec des relations (Amour, Amiti\xe9\u2026) plut\xf4t qu'avec du capital.",
                        "grow_worth": "Fais grandir ta valeur totale d'un cinqui\xe8me. Ench\xe9ris sur ce qui est sous-\xe9valu\xe9, \xe9change vers le haut, et ne laisse pas dormir ton capital."
                    }
                },
                "middle_class": {
                    "name": "Classe Moyenne",
                    "description": "Vous commencez avec un portefeuille \xe9quilibr\xe9. Les choix strat\xe9giques d\xe9termineront votre trajectoire.",
                    "goal": "Maintenir la stabilit\xe9 tout en poursuivant des opportunit\xe9s de croissance",
                    "goals": {
                        "diversify": "Termine la session en d\xe9tenant les trois formes de valeur : des parts d'une entreprise, un objet, et une obligation.",
                        "three_bids": "Gagne 3 ench\xe8res sur des choses que d'autres traders d\xe9tiennent. Propose ton prix, dis pourquoi tu le veux, et convaincs-les.",
                        "relations_over_money": "Finis plus riche en zollars qu'en capital \u2014 trade pour que les relations p\xe8sent plus lourd que l'argent dans ton portefeuille."
                    }
                },
                "upper_middle": {
                    "name": "Classe Moyenne Sup\xe9rieure",
                    "description": "Vous avez des ressources importantes. Utilisez-les judicieusement pour cr\xe9er des opportunit\xe9s.",
                    "goal": "Tirer parti de vos ressources pour construire une influence durable",
                    "goals": {
                        "fair_patron": "Joue le m\xe9c\xe8ne : gagne 2 ench\xe8res ET accepte 2 offres de traders plus pauvres que toi, \xe0 un prix juste. L'influence se construit, elle ne s'ach\xe8te pas.",
                        "capital_to_life": "Convertis ton capital en valeur vivante : termine avec plus de richesse en parts et en objets qu'en simple capital.",
                        "bond_collector": "Construis un carnet d'obligations : d\xe9tiens 3 Z Bonds de la R\xe9serve Z\xe9d\xe9rale et laisse les int\xe9r\xeats travailler pour toi."
                    }
                },
                "wealthy_elite": {
                    "name": "\xc9lite Fortun\xe9e",
                    "description": "Vous commencez avec une richesse immense. Tout le monde veut ce que vous avez\u2014la g\xe9n\xe9rosit\xe9 cr\xe9e la protection.",
                    "goal": "Partagez la richesse pour construire des alliances ou faire face \xe0 une r\xe9sistance coordonn\xe9e",
                    "goals": {
                        "generous_giant": "Donne pour grandir : accepte des \xe9changes ou des ench\xe8res modestes d'au moins 3 traders diff\xe9rents. Sur ce parquet, la g\xe9n\xe9rosit\xe9 est une protection.",
                        "biggest_backer": "R\xe9partis ta richesse en parts de 4 entreprises diff\xe9rentes \u2014 deviens le plus grand soutien du parquet.",
                        "keep_the_crown": "Termine la session toujours au sommet. Tout le monde veut ce que tu as ; les alliances et les affaires justes sont ta seule fa\xe7on de le garder."
                    }
                },
                "starting_capital": "Capital de d\xe9part :",
                "starting_items": "Objets de d\xe9part :",
                "your_goal": "Votre objectif :",
                "actions_note": "Vos actions fa\xe7onnent la fa\xe7on dont les autres vous traitent. La g\xe9n\xe9rosit\xe9 construit des alliances, l'exploitation invite aux repr\xe9sailles."
            },
            "debt_actions": {
                "common": {
                    "perceived_magnitude": "Ampleur per\xe7ue",
                    "magnitude_none": "Aucune",
                    "magnitude_hint": "Un soup\xe7on",
                    "error_login_required": "Veuillez d'abord vous connecter"
                },
                "help_friend": {
                    "intro": "Tendre la main. Choisissez <b>Z$</b> ou <b>Capital</b> pour votre don.",
                    "capital_label": "Capital (montant)",
                    "capital_placeholder": "Saisir le montant",
                    "select_zollars": "S\xe9lectionnez les types de Z$ \xe0 offrir.",
                    "recipient_label": "B\xe9n\xe9ficiaire :",
                    "no_zollars": "Aucun Z$ disponible.",
                    "modal_title": "Billet Z Altrauiste (Don altruiste)",
                    "error_no_recipient": "Choisissez un b\xe9n\xe9ficiaire.",
                    "error_invalid_capital": "Saisissez un montant de capital valide.",
                    "error_no_zollars_to_give": "Aucun Z$ \xe0 offrir.",
                    "error_select_zollars": "S\xe9lectionnez des Z$ \xe0 offrir.",
                    "error_insufficient_zollars": "Z$ {type} insuffisants. Vous en avez {available}, tentative d'envoi de {count}.",
                    "success": "Billet Z Altrauiste \xe9mis. Vos registres sont d\xe9sormais li\xe9s."
                },
                "predatory_lend": {
                    "intro": "CDO Z-Payday : proposez un pr\xeat compos\xe9 qui se recharge toutes les 60 secondes.",
                    "warning": "ATTENTION : Chaque cycle augmente la dette de 15 % jusqu'au remboursement ou \xe0 l'effondrement.",
                    "exploitation_note": "(Exploitation grim\xe9e en lien empathique.)",
                    "capital_label": "Capital (montant \xe0 \xab pr\xeater \xbb)",
                    "capital_placeholder": "Montant",
                    "select_zollars": "Choisissez l'app\xe2t Z$ pour pr\xe9cipiter la chute.",
                    "victim_label": "Cible vuln\xe9rable :",
                    "no_zollars": "Aucun Z$ disponible.",
                    "modal_title": "CDO Z-Payday (Pr\xeat pr\xe9dateur)",
                    "error_no_victim": "D\xe9signez une victime.",
                    "error_invalid_amount": "Saisissez un montant valide.",
                    "error_no_zollars_selected": "Aucun Z$ s\xe9lectionn\xe9.",
                    "error_select_zollars": "S\xe9lectionnez des Z$.",
                    "success_targeted": "Offre CDO Z-Payday envoy\xe9e \xe0 la cible. Se recharge toutes les 60 secondes d\xe8s acceptation.",
                    "success_market": "CDO Z-Payday list\xe9 sur le march\xe9 \u2014 grim\xe9 en offre attrayante."
                },
                "borrow": {
                    "intro": "Solliciter un pr\xeat (Note M).",
                    "vulnerability_required": "Exposez votre dette \xe9motionnelle. Vuln\xe9rabilit\xe9 requise.",
                    "vulnerability_label": "Pourquoi avez-vous besoin de ce pr\xeat ? (Confession \xe9motionnelle \u2014 min. 20 car.)",
                    "vulnerability_placeholder": "Exposez votre fragilit\xe9 ici...",
                    "char_count": "0 / 20 car.",
                    "char_suffix": "/ 20 car.",
                    "severity_label": "Gravit\xe9",
                    "severity_question": "\xc0 quel point votre besoin est-il pressant ?",
                    "move_sliders": "Ajustez les curseurs pour exprimer votre besoin :",
                    "lender_label": "Choisir un pr\xeateur :",
                    "modal_title": "Note M (Demande de pr\xeat)",
                    "error_vulnerability_required": "La Note M exige une confession de vuln\xe9rabilit\xe9 (min. 20 caract\xe8res).",
                    "error_move_slider": "D\xe9placez au moins un curseur pour exprimer votre besoin.",
                    "error_no_lender": "Veuillez s\xe9lectionner un pr\xeateur.",
                    "success_targeted": "Demande Note M envoy\xe9e au pr\xeateur.",
                    "success_market": "Note M list\xe9e sur le march\xe9 \u2014 en qu\xeate d'un pr\xeateur."
                },
                "request_aid": {
                    "intro": "Lancer un appel \xe0 l'aide (Note V).",
                    "description": "Demandez du soutien en partageant votre vuln\xe9rabilit\xe9.",
                    "accept_decline_note": "L'autre peut accepter ou refuser.",
                    "vulnerability_label": "Expliquez pourquoi vous avez besoin d'aide (confession de vuln\xe9rabilit\xe9 \u2014 min. 20 car.)",
                    "vulnerability_placeholder": "Partagez votre fragilit\xe9...",
                    "severity_question": "Urgence de la situation",
                    "target_label": "Demander de l'aide \xe0 :",
                    "modal_title": "Note V (Appel \xe0 l'aide)",
                    "error_no_target": "Choisissez \xe0 qui demander de l'aide.",
                    "error_vulnerability_required": "La Note V exige une confession de vuln\xe9rabilit\xe9 (min. 20 caract\xe8res).",
                    "success": "Demande Note V envoy\xe9e. En attente de r\xe9ponse."
                }
            },
            "items": {
                "item_added_success": "Objet ajout\xe9 avec succ\xe8s !",
                "item_add_failed": "\xc9chec de l'ajout de l'objet. Veuillez r\xe9essayer.",
                "no_items_portfolio": "Aucune marchandise dans ce portefeuille.",
                "search_portfolios": "Rechercher des portefeuilles...",
                "item_assigned_success": "Objet assign\xe9 au portefeuille avec succ\xe8s",
                "item_assign_failed": "\xc9chec de l'assignation de l'objet au portefeuille. Veuillez r\xe9essayer.",
                "item_unassigned_success": "Marchandise d\xe9sassign\xe9e du portefeuille avec succ\xe8s",
                "item_unassign_failed": "\xc9chec de la d\xe9sassignation de la marchandise du portefeuille. Veuillez r\xe9essayer.",
                "item_deleted_success": "Objet supprim\xe9 avec succ\xe8s",
                "item_delete_failed": "\xc9chec de la suppression de la marchandise. Veuillez r\xe9essayer.",
                "item_redeemed_success": "Objet \xe9chang\xe9 avec succ\xe8s",
                "item_unredeemed_success": "Objet non \xe9chang\xe9 avec succ\xe8s",
                "redeem_toggle_failed": "\xc9chec du basculement du statut d'\xe9change. Veuillez r\xe9essayer."
            },
            "zollar": {
                "select_relationship_required": "Veuillez s\xe9lectionner au moins une relation et entrer une quantit\xe9.",
                "zollars_added_success": "Zollar(s) ajout\xe9(s) avec succ\xe8s",
                "add_failed_error": "\xc9chec de l'ajout du/des zollar(s). Veuillez r\xe9essayer. Erreur : {error}",
                "deleted_success": "Zollar supprim\xe9 avec succ\xe8s",
                "delete_failed": "\xc9chec de la suppression du zollar",
                "fill_required_fields": "Veuillez remplir tous les champs requis correctement.",
                "zbond_added_success": "ZBond ajout\xe9 avec succ\xe8s",
                "zbond_add_failed": "\xc9chec de l'ajout du ZBond. Erreur : {error}",
                "select_portfolio_required": "Veuillez s\xe9lectionner un portefeuille auquel assigner l'objet.",
                "assign_failed": "\xc9chec de l'assignation de {itemType}. Veuillez r\xe9essayer.",
                "unassigned_success": "{itemType} d\xe9sassign\xe9 du portefeuille avec succ\xe8s",
                "unassign_failed": "\xc9chec de la d\xe9sassignation du portefeuille. Veuillez r\xe9essayer.",
                "bond_deleted_success": "Obligation supprim\xe9e avec succ\xe8s",
                "bond_delete_failed": "Erreur lors de la suppression de l'obligation : {error}",
                "session_details_failed": "\xc9chec de la r\xe9cup\xe9ration des d\xe9tails de session. Veuillez r\xe9essayer.",
                "session_fetch_error": "Erreur lors de la r\xe9cup\xe9ration des d\xe9tails de session. Veuillez r\xe9essayer plus tard.",
                "fetch_portfolios_error": "Erreur lors de la r\xe9cup\xe9ration des portefeuilles actifs. Veuillez r\xe9essayer."
            },
            presentation: {
                "title": "ZExchange - Pr\xe9sentation",
                "hero_tagline": "Et si la valeur n'\xe9tait pas un nombre ?",
                "intro_main": "Une exp\xe9rience de salle des march\xe9s en direct pour 10 \xe0 200 participants, durant de 1 \xe0 24 heures. Mais ce n'est pas Wall Street. Ici, la classe d'actifs est l'exp\xe9rience humaine elle-m\xeame.",
                "card_trade_title": "N\xe9gociez des Conditions Humaines",
                "card_trade_desc": "Au lieu d'Apple ou Nvidia, investissez dans Zo Depression Corp, Stomach Pain Industries, Zo Happy Inc. Chaque action repr\xe9sente une facette de l'existence.",
                "card_spend_title": "D\xe9pensez des Relations",
                "card_spend_desc": "Oubliez les dollars. Ici vous payez avec des Zollars, une monnaie libell\xe9e par type de relation : Amour, Amiti\xe9, Haine, \xc9rotique, Toxique, Mort.",
                "card_consume_title": "Consommez Collectivement",
                "card_consume_desc": "Vous poss\xe9dez un verre de vin ? Vous ne pouvez pas l'acqu\xe9rir seul. Pour \xe9changer toute marchandise, vous devez demander l'approbation des autres. La consommation requiert un consentement mutuel.",
                "card_market_title": "Le March\xe9 Vous Observe",
                "card_market_desc": "Une IA narre chaque transaction, interpr\xe9tant ce que vos \xe9changes r\xe9v\xe8lent sur vous. Le march\xe9 ne bouge pas seulement, il parle.",
                "intro_transform": "ZExchange transforme la logique \xe9conomique en une conversation collective sur ce que nous valorisons vraiment.",
                "intro_mirror": "C'est en partie art conceptuel, en partie art festif, en partie miroir. Les organisations d\xe9couvrent leurs valeurs cach\xe9es. Les groupes confrontent le pouvoir, l'\xe9quit\xe9 et la confiance. Chacun repart avec des questions qu'il n'avait pas en arrivant.",
                "section_video": "Vid\xe9os Explicatives",
                "section_video_desc": "Cliquez pour regarder les explications conceptuelles",
                "video_intro": "Introduction \xe0 ZExchange",
                "video_intro_desc": "Aper\xe7u du concept",
                "video_life": "Profits de Vie & Valeur",
                "video_life_desc": "La valeur dans la ZEconomy",
                "video_stocks": "Fonctionnement des Actions",
                "video_stocks_desc": "N\xe9gocier des conditions humaines",
                "video_zbonds": "ZBonds & Zollars",
                "video_zbonds_desc": "Syst\xe8me Mon\xe9taire Relationnel Z",
                "video_commodity": "Commodity X",
                "video_commodity_desc": "Consommation sociale",
                "video_interface": "Aper\xe7u de l'Interface",
                "video_interface_desc": "L'interface de trading",
                "video_bigboard": "Big Boards G\xe9n\xe9ratifs",
                "video_bigboard_desc": "Expression du march\xe9 en temps r\xe9el",
                "section_assets": "Actifs N\xe9gociables",
                "section_assets_desc": "Cliquez sur les banni\xe8res pour des explications d\xe9taill\xe9es",
                "label_stocks": "ACTIONS - Conditions Humaines en Parts",
                "label_zbonds": "ZBONDS - Investissements Bas\xe9s sur les Relations",
                "label_commodities": "MARCHANDISES - Objets Physiques avec Approbation Sociale",
                "label_zollars": "ZOLLARS - Monnaie Sans Chiffres",
                "section_economic": "Outils \xc9conomiques",
                "section_economic_desc": "Approches id\xe9ologiques de la richesse et du pouvoir",
                "label_economic": "D\xc9CLENCHEURS \xc9CONOMIQUES - L'Id\xe9ologie comme Action de March\xe9",
                "label_communist": "Assaut Communiste",
                "label_socialist": "Subvention Socialiste",
                "label_lbo": "LBO Capitaliste",
                "section_trader": "Outils du Trader",
                "section_trader_desc": "Jusqu'o\xf9 irez-vous dans la qu\xeate de valeur ?",
                "label_trader": "OUTILS DU TRADER - Actions Avec ou Contre les Autres",
                "label_steal": "Vol",
                "label_ransom": "Ran\xe7on",
                "label_darkpool": "Dark Pool",
                "section_features": "Fonctionnalit\xe9s du March\xe9",
                "label_emotional": "INDICE DE DETTE \xc9MOTIONNELLE - Flux d'\xc9motions Humaines",
                "label_bigboard": "LE BIG BOARD - Visualisation du March\xe9 en Temps R\xe9el",
                "label_voice": "VOIX DE LA BOURSE - Narration IA du March\xe9",
                "section_central": "R\xe9serve Z\xe9d\xe9rale / R\xe9gulateur ZExchange",
                "section_central_desc": "Comment l'op\xe9rateur ZExchange contr\xf4le les sessions de march\xe9",
                "central_intro": "La R\xe9serve Z\xe9d\xe9rale (ou Op\xe9rateur ZExchange) orchestre l'ensemble de la session de trading. Avant l'ouverture du march\xe9, c'est l'interface o\xf9 vous configurez l'\xe9conomie : cr\xe9ation de portefeuilles de traders avec capital initial et marchandises disponibles pendant la session, distribution d'actions parmi plus de 350 entreprises ZEconomy pr\xe9d\xe9finies, et \xe9mission de Zollars et ZBonds bas\xe9s sur les relations. Pendant la session, vous agissez comme r\xe9gulateur et autorit\xe9 centrale : ouverture et fermeture du march\xe9, contr\xf4le des types d'actifs n\xe9gociables, taxation des portefeuilles pour extraire de la valeur, subvention des traders avec capital ou marchandises, \xe9mission de d\xe9clencheurs sp\xe9ciaux (Vol, Ran\xe7on, Dark Pool, Assaut Communiste, Subvention Socialiste, LBO Capitaliste), diffusion d'\xe9v\xe9nements m\xe9diatiques, et d\xe9ploiement de bots de march\xe9 pour la liquidit\xe9. Vous pouvez fa\xe7onner le r\xe9cit de la session \xe0 travers des th\xe8mes narratifs qui guident l'interpr\xe9tation de l'IA de l'activit\xe9 du march\xe9. La R\xe9serve Z\xe9d\xe9rale agit comme une Banque Centrale incarnant la tension entre contr\xf4le et chaos dans toute \xe9conomie, vous pouvez favoriser l'\xe9quilibre ou cr\xe9er la disruption, r\xe9compenser ou punir, stimuler ou restreindre. Chaque d\xe9cision se r\xe9percute sur le march\xe9, mettant au d\xe9fi les traders de s'adapter et de r\xe9agir.",
                "label_control": "CONTR\xd4LE DU MARCH\xc9 - Ouverture/Fermeture & Liste des Actifs",
                "section_tax": "Taxation des Portefeuilles",
                "section_tax_desc": "Extraire de la valeur des portefeuilles des traders",
                "label_taxall": "Taxer Tous les Traders",
                "label_taxitem": "Taxer une Marchandise",
                "label_taxpoints": "Taxer le Capital",
                "section_subsidize": "Subventionner les Portefeuilles",
                "section_subsidize_desc": "Injecter de la valeur dans les portefeuilles des traders",
                "label_givezollar": "Donner des Zollars",
                "label_givepoints": "Donner du Capital",
                "label_giveitem": "Donner une Marchandise",
                "label_freebie": "Distribution de Marchandises",
                "section_events": "D\xe9clencheurs d'\xc9v\xe9nements",
                "section_events_desc": "Diffuser des m\xe9dias et cr\xe9er des r\xe9cits",
                "label_publizity": "Lancer PubliZity",
                "label_znews": "Lancer ZNews",
                "label_story": "Cr\xe9er un R\xe9cit",
                "section_bots": "Bots de March\xe9",
                "section_bots_desc": "Trading automatis\xe9 pour la liquidit\xe9 du march\xe9",
                "label_addbots": "Ajouter des Bots",
                "label_removebots": "Retirer les Bots",
                "label_botstatus": "Statut des Bots",
                "section_keep": "Ce que les Participants Gardent",
                "keep_bigboard": "Un Big Board fa\xe7onn\xe9 par chaque \xe9change, fig\xe9 en \u0153uvre d'art g\xe9n\xe9rative",
                "keep_story": "Une histoire \xe9crite par l'IA de la dynamique de votre groupe",
                "keep_award": "Peut-\xeatre un prix ou deux",
                "keep_mirror": "Un miroir refl\xe9tant ce que votre organisation valorise vraiment",
                "section_concepts": "Concepts Cl\xe9s",
                "concept_life_title": "Profit de Vie",
                "concept_life_desc": "La valeur de la vie consciemment v\xe9cue : joie, perte, amour, d\xe9pression. Qualit\xe9 plut\xf4t que quantit\xe9.",
                "concept_auto_title": "Pas de Pilote Automatique",
                "concept_auto_desc": "Chaque transaction requiert une pr\xe9sence. Pour \xe9changer, engagez-vous avec un autre. Pour racheter, vous devez demander.",
                "concept_market_title": "Le March\xe9 R\xe9pond",
                "concept_market_desc": "L'IA observe chaque transaction, offrant interpr\xe9tations et narration.",
                "concept_shared_title": "Valeurs Partag\xe9es",
                "concept_shared_desc": "Spectres politiques oppos\xe9s, m\xeames exp\xe9riences humaines.",
                "footer_mirror": "ZExchange n'est pas qu'un march\xe9 ; c'est un miroir.",
                "footer_transform": "Il transforme la logique froide de l'\xe9conomie en une conversation collective sur ce que nous valorisons vraiment.",
                "footer_part": "Fait partie de",
                "popup_stocks": "<h3>Actions (Stocks)</h3><strong>Description :</strong><br>Surveillez et \xe9changez vos positions en actions.<br><br><strong> qu'est :</strong><br>En finance traditionnelle, une action repr\xe9sente une part de propri\xe9t\xe9 d'une entreprise. Les investisseurs ach\xe8tent g\xe9n\xe9ralement des actions en esp\xe9rant que la valeur de l'entreprise augmente.<br><br>Dans la ZEconomy, chaque \xab entreprise \xbb refl\xe8te des valeurs personnelles ou humaines, comme le bien-\xeatre \xe9motionnel, les relations sociales ou les activit\xe9s du quotidien, plut\xf4t que des produits ou services classiques. En \xab investissant \xbb dans ces entreprises, vous pariez sur la croissance, la transformation ou la durabilit\xe9 des exp\xe9riences humaines.<br><br><strong>Lecture conceptuelle :</strong><br>ZExchange remet en question la notion de profit : au del\xe0 de simples gains financiers, on devrait penser plut\xf4t au l'expansion de la \xab life value \xbb la produit de sant\xe9 \xe9motionnelle, cr\xe9ativit\xe9, exp\xe9riences partag\xe9es ?<br><br>Consid\xe9rez vos actions comme des investissements dans la valeur humaine : bonheur, d\xe9pression, r\xe9ussite, \xe9chec, confusion, plut\xf4t qu'une entreprise produisant un bien ou un service.<br><br><strong>M\xe9canismes :</strong><br>Les actions sont \xe9changeables contre des Zollars ou du capital. \xc0 mesure que la valeur d'une entreprise augmente ou besse, la valeur de votre portefeuille cro\xeet \xe9galement.",
                "popup_zbonds": "<h3>ZBonds</h3><strong>Description :</strong><br>Les ZBonds fonctionnent comme des obligations traditionnelles : vous les achetez avec du capital, les conservez sur une dur\xe9e d\xe9termin\xe9e, et \xe0 leur \xe9ch\xe9ance, vous recevez des Zollars.<br><br><strong>Lecture conceptuelle :</strong><br>L\xe0 o\xf9 les obligations classiques financent des gouvernements ou des entreprises, les ZBonds financent la cr\xe9ation d'une monnaie (les Zollars) dont la valeur est enti\xe8rement li\xe9e aux relations humaines et aux exp\xe9riences v\xe9cues.<br><br>Investir dans un ZBond revient \xe0 placer sa confiance dans les valeurs partag\xe9es de la communaut\xe9 et des liens interpersonnels, plut\xf4t que dans un rendement purement financier.<br><br>Les ZBonds font le lien entre les \xab titres \xe0 revenu fixe \xbb traditionnels et la red\xe9finition de la valeur propos\xe9e par la ZEconomy.",
                "popup_commodities": "<h3>Mati\xe8res premi\xe8res (Commodity X)</h3><strong>Description :</strong><br>Les objets physiques \xe9changeables que vous poss\xe9dez.<br><br><strong>Validation sociale :</strong><br>Aucune marchandise ne peut \xeatre consomm\xe9e seul. Pour en \xe9changer une, les traders doivent demander l'approbation des autres. Si tous acceptent, l'objet est lib\xe9r\xe9 ; si l'un refuse, rien ne se passe.<br><br><strong>Lecture conceptuelle :</strong><br>Que signifie devoir demander la permission pour ce que l'on poss\xe8de d\xe9j\xe0 ? La validation sociale introduit une friction l\xe0 o\xf9 les march\xe9s cherchent \xe0 l'\xe9liminer, rendant la consommation visible, questionn\xe9e, collective.<br><br>Les mati\xe8res premi\xe8res nous rappellent que les march\xe9s concernent aussi des biens et des exp\xe9riences qui fa\xe7onnent nos vies.",
                "popup_zollars": "<h3>Zollars</h3><strong>Description :</strong><br>Consultez vos soldes et transactions en Zollars.<br><br><strong>Une monnaie sans chiffres :</strong><br>Les Zollars sont libell\xe9s par type de relation : Love, Erotic, Friendship, Fellowship, Superficial, Toxic, Hate, Death.<br><br>Utiliser des Zollars pousse les participants \xe0 r\xe9fl\xe9chir \xe0 <em>la nature</em> de la valeur en jeu, plut\xf4t qu'\xe0 <em>sa quantit\xe9</em>.<br><br><strong>Lecture conceptuelle :</strong><br>Acqu\xe9rir Zo Insomnia Incorporated avec des Zollars Love ne raconte pas la m\xeame histoire qu'avec des Zollars Toxic. L'interpr\xe9tation est personnelle ; le cadre est partag\xe9.<br><br>Les Zollars remettent en question les id\xe9es traditionnelles de la monnaie en fondant la valeur sur les relations humaines.",
                "popup_economic": "<h3>D\xe9clencheurs d'attaque \xe9conomique</h3><strong>Description :</strong><br>Les d\xe9clencheurs d'attaque \xe9conomique repr\xe9sentent diff\xe9rentes approches id\xe9ologiques de la richesse, du pouvoir et des dynamiques de march\xe9. Ils permettent aux traders d'utiliser des strat\xe9gies inspir\xe9es de syst\xe8mes \xe9conomiques \u2014 communisme, socialisme, capitalisme \u2014 pour obtenir ou redistribuer des avantages dans la ZEconomy.<br><br><strong>Lecture conceptuelle :</strong><br>Ces d\xe9clencheurs poussent les participants \xe0 confronter leurs croyances sur l'\xe9quit\xe9, l'ambition et la responsabilit\xe9 collective. Ils alimentent le d\xe9bat sur l'\xe9quilibre entre justice, ambition et compromis \xe9thiques.<br><br><ul><li>La richesse doit-elle \xeatre partag\xe9e \xe9quitablement, m\xeame si cela implique de confisquer le succ\xe8s d'autrui ?</li><li>Est-il \xe9thique de tirer profit au d\xe9triment de l'autonomie d'un autre ?</li><li>Jusqu'o\xf9 \xeates-vous pr\xeat \xe0 aller pour un gain personnel ou pour soutenir le bien collectif ?</li></ul>",
                "popup_communist": "<h3>D\xe9clencheur d'assaut communiste</h3><strong>Description :</strong><br>Saisir et redistribuer l'int\xe9gralit\xe9 de la richesse d'un portefeuille cibl\xe9 au collectif.<br><br><strong>Fonctionnement :</strong><br>La richesse de la cible (capital, actions, mati\xe8res premi\xe8res) est r\xe9partie \xe9quitablement entre les participants actifs. Aucun trader ne s'enrichit de mani\xe8re significative, garantissant un b\xe9n\xe9fice communautaire.<br><br><strong>Lecture conceptuelle :</strong><br>Cette action symbolise une redistribution extr\xeame, testant l'\xe9quit\xe9 de la confiscation des richesses au nom du bien commun. Elle soul\xe8ve des questions \xe9thiques sur le droit de propri\xe9t\xe9 et la moralit\xe9 de la redistribution forc\xe9e.<br><br><em>La richesse doit-elle \xeatre partag\xe9e \xe9quitablement, m\xeame si cela implique de confisquer le succ\xe8s d'autrui ?</em>",
                "popup_socialist": "<h3>D\xe9clencheur de subvention socialiste</h3><strong>Description :</strong><br>Taxer un portefeuille riche et redistribuer les ressources aux traders moins favoris\xe9s.<br><br><strong>Fonctionnement :</strong><br>50 % de la richesse du portefeuille cibl\xe9 est tax\xe9e et redistribu\xe9e proportionnellement aux traders disposant de plus petits avoirs, dans le but d'\xe9quilibrer le march\xe9.<br><br><strong>Lecture conceptuelle :</strong><br>La \xab subvention socialiste \xbb refl\xe8te la tension entre soutien au bien collectif et d\xe9couragement de l'ambition. Elle met en lumi\xe8re les difficult\xe9s de la lutte contre les in\xe9galit\xe9s sans freiner l'innovation ou la croissance.<br><br><em>Comment concilier \xe9quit\xe9 et r\xe9ussite individuelle ?</em>",
                "popup_lbo": "<h3>Rachat avec effet de levier capitaliste (LBO)</h3><strong>Description :</strong><br>Acqu\xe9rir de mani\xe8re agressive les actifs d'un autre portefeuille via un rachat avec effet de levier.<br><br><strong>Fonctionnement :</strong><br>Le trader acqu\xe9reur prend le contr\xf4le total du portefeuille cibl\xe9, \xe0 un co\xfbt s\xe9v\xe8re pour celui-ci. La transaction est coercitive mais compensatoire : la cible est pay\xe9e, et l'initiateur paie un prix excessif.<br><br><strong>Lecture conceptuelle :</strong><br>Le \xab LBO capitaliste \xbb illustre le pouvoir de la richesse \xe0 supplanter l'autonomie, mettant en lumi\xe8re les dynamiques du capitalisme agressif. Il interroge l'\xe9quilibre entre concurrence loyale et exploitation.<br><br><em>Est-il \xe9thique de tirer profit au d\xe9triment de l'autonomie d'un autre ?</em>",
                "popup_tools": "<h3>Outils du trader</h3><strong>Description :</strong><br>Utilitaires permettant d'effectuer des actions de march\xe9 avec ou contre d'autres traders.<br><br><strong>Lecture conceptuelle :</strong><br>Voler, ran\xe7onner, n\xe9gocier en priv\xe9 : chaque d\xe9clencheur met \xe0 l'\xe9preuve jusqu'o\xf9 vous \xeates pr\xeat \xe0 aller dans la qu\xeate de valeur. Explorerez-vous de nouvelles strat\xe9gies sans perdre votre sens des responsabilit\xe9s \u2014 ou franchirez-vous les limites au d\xe9triment des autres ?<br><br>La ZEconomy pose ces questions et vous laisse d\xe9cider ce que \xab valeur \xbb signifie r\xe9ellement, et ce que vous \xeates pr\xeat \xe0 faire pour l'obtenir.",
                "popup_steal": "<h3>Voler un objet</h3><strong>Description :</strong><br>Prendre des actifs d'un autre portefeuille de mani\xe8re anonyme, sans autorisation.<br><br><strong>Fonctionnement :</strong><br>L'objet s\xe9lectionn\xe9 est transf\xe9r\xe9 du portefeuille cibl\xe9 vers le v\xf4tre sans consentement. L'action reste anonyme, emp\xeachant toute repr\xe9saille imm\xe9diate.<br><br><strong>Lecture conceptuelle :</strong><br>Le vol met \xe0 l'\xe9preuve les limites \xe9thiques, explorant la priorit\xe9 accord\xe9e au gain personnel par rapport \xe0 l'empathie et \xe0 la confiance collective. Il invite \xe0 r\xe9fl\xe9chir aux cons\xe9quences des actes et \xe0 la valeur accord\xe9e \xe0 l'\xe9quit\xe9 dans la ZEconomy.",
                "popup_ransom": "<h3>Ran\xe7onner un portefeuille</h3><strong>Description :</strong><br>Verrouiller le portefeuille d'un autre trader et exiger une ran\xe7on pour le d\xe9verrouiller.<br><br><strong>Fonctionnement :</strong><br>Le portefeuille cibl\xe9 est verrouill\xe9 et devient inutilisable jusqu'au r\xe8glement de la ran\xe7on. Le trader initiateur gagne des points si la ran\xe7on est pay\xe9e. Son identit\xe9 est r\xe9v\xe9l\xe9e \xe0 la victime, introduisant une cons\xe9quence sociale directe.<br><br><strong>Lecture conceptuelle :</strong><br>La ran\xe7on explore les dynamiques de pouvoir et de coercition dans l'\xe9change. Elle force les traders \xe0 \xe9valuer si le gain financier l'emporte sur les retomb\xe9es sociales et les enjeux \xe9thiques.",
                "popup_darkpool": "<h3>Dark Pool</h3><strong>Description :</strong><br>\xc9tablir un groupe de trading priv\xe9, dissimul\xe9 du march\xe9 public.<br><br><strong>Fonctionnement :</strong><br>Cr\xe9e un espace d'\xe9change priv\xe9 et temporaire r\xe9serv\xe9 \xe0 certains participants. Les transactions effectu\xe9es dans le Dark Pool sont invisibles pour le march\xe9 global, permettant de fixer librement prix et conditions.<br><br><strong>Lecture conceptuelle :</strong><br>Les Dark Pools incarnent la tension entre collaboration et manipulation. Ils offrent la possibilit\xe9 de n\xe9gocier hors regard public, tout en remettant en question l'\xe9quit\xe9 et la transparence du march\xe9.",
                "popup_emotional": "<h3>Indice de dette \xe9motionnelle</h3><strong>Flux des \xe9motions humaines</strong><br><br><strong>Reconna\xeetre la valeur de la vuln\xe9rabilit\xe9 \xe0 travers la dette \xe9motionnelle.</strong><br><br>La valeur dans la ZEconomy n'est pas extraite, elle est ressentie. Chaque geste \u2014 aide, confiance, abandon, envie \u2014 laisse une trace : une dette \xe9motionnelle mesurable, positive ou n\xe9gative. Nous portons cette dette, que nous le voulions ou non.<br><br>Tenir l'autre, se laisser tenir : les formes de levier les plus humaines. La ZEconomy circule \xe0 travers nous.<br><br><strong>Indice relationnel</strong> \u2014 Mesure de l'int\xe9grit\xe9 relationnelle : il augmente avec l'honneur et l'entraide, et diminue avec l'exploitation et la trahison.<br><br><strong>\xc9quilibre existentiel</strong> \u2014 Mesure de l'impact de vos actions sur les profits de vie des autres. All\xe9gez-vous ou alourdissez-vous leurs charges symboliques ?<br><br><em>Rejetez le fantasme du capital, embrassez la liquidit\xe9 du ressenti humain.</em>",
                "popup_bigboard": "<h3>The Big Board</h3><strong>Visualisation du march\xe9 en temps r\xe9el</strong><br><br>The Big Board visualise l'activit\xe9 en direct, accumulant humeurs et actions, changeant de couleur au fil de la session.<br><br>Non pas des chiffres fictifs comme le S&P 500, mais une <em>pr\xe9sence ressentie rendue visible</em>.<br><br><strong>Ce que vous conservez :</strong><br>\xc0 la fin de la session, The Big Board devient une \u0153uvre g\xe9n\xe9rative \u2014 un instantan\xe9 fig\xe9 de chaque \xe9change, chaque \xe9motion, chaque moment collectif. Le portrait de votre organisation, rendu \xe0 travers le comportement \xe9conomique.",
                "popup_voicebourse": "<h3>Voice of the Bourse</h3><strong>Le march\xe9 vous r\xe9pond</strong><br><br>Un syst\xe8me d'IA observe chaque transaction et devient la voix du march\xe9 lui-m\xeame. Il ne calcule ni profits ni pertes ; il <em>interpr\xe8te</em>.<br><br>Il r\xe9pond \xe0 des questions telles que : <em>Pourquoi avez-vous effectu\xe9 cet \xe9change ? Que sugg\xe8re-t-il ?</em><br><br>Le march\xe9 exprime une opinion sur ce qui s'y \xe9change, tout en restant agnostique quant \xe0 la valeur elle-m\xeame.<br><br>Au fil de l'\xe9v\xe9nement, un r\xe9cit \xe9merge : un portrait collectif dessin\xe9 par le comportement \xe9conomique. Une narration \xe9crite par l'IA des dynamiques de votre groupe.",
                "popup_centralbank": "<h3>Contr\xf4le du march\xe9</h3><strong>Description :</strong><br>Ouvrir et fermer le march\xe9, et configurer les types d'actifs visibles et \xe9changeables par les traders.<br><br><strong>Mode d'emploi :</strong><br>S\xe9lectionnez les types d'actifs (actions, obligations, commodit\xe9) \xe0 activer ou d\xe9sactiver via le menu d\xe9roulant, puis appliquez les changements.<br><br><strong>Lecture conceptuelle :</strong><br>Faites sonner la cloche et \xe9changez. L'op\xe9rateur de la place contr\xf4le quand le march\xe9 est actif et sur quelles formes de valeur l'attention se porte. Ce pouvoir fa\xe7onne toute la dynamique de la session.",
                "popup_taxall": "<h3>Taxer tous les traders</h3><strong>Description :</strong><br>D\xe9clencher un \xe9v\xe9nement fiscal affectant tous les traders actifs. Ils peuvent choisir de payer en capital ou en mati\xe8res premi\xe8res ; l'absence de r\xe9ponse entra\xeene une taxation des deux.<br><br><strong>Mode d'emploi :</strong><br>D\xe9finissez le montant de la taxe (capital et Zollars), puis confirmez l'action.<br><br><strong>Lecture conceptuelle :</strong><br>Introduit des cons\xe9quences macro\xe9conomiques via des politiques fiscales. Cela peut favoriser l'\xe9quilibre ou g\xe9n\xe9rer de la frustration, testant l'adaptabilit\xe9 des traders aux changements syst\xe9miques.",
                "popup_taxitem": "<h3>Taxer une marchandise</h3><strong>Description :</strong><br>Retirer al\xe9atoirement une marchandise des portefeuilles des traders s\xe9lectionn\xe9s.<br><br><strong>Mode d'emploi :</strong><br>S\xe9lectionnez les traders dans la liste active, puis confirmez l'action.<br><br><strong>Lecture conceptuelle :</strong><br>La taxation cibl\xe9e permet \xe0 la banque de r\xe9\xe9quilibrer \u2014 ou d\xe9s\xe9quilibrer \u2014 le march\xe9, for\xe7ant les traders \xe0 adapter leurs strat\xe9gies. Elle \xe9voque les saisies d'actifs et soul\xe8ve des questions \xe9thiques sur l'application s\xe9lective.",
                "popup_taxpoints": "<h3>Taxer le capital</h3><strong>Description :</strong><br>Taxer les gains num\xe9riques des traders s\xe9lectionn\xe9s.<br><br><strong>Mode d'emploi :</strong><br>Indiquez le montant \xe0 d\xe9duire, s\xe9lectionnez les traders concern\xe9s, puis confirmez.<br><br><strong>Lecture conceptuelle :</strong><br>Outil de discipline ou d'\xe9quilibrage, cette taxation cibl\xe9e peut niveler le terrain ou servir de sanction. Elle met \xe0 l'\xe9preuve la r\xe9silience des traders tout en questionnant l'\xe9quit\xe9 fiscale.",
                "popup_givezollar": "<h3>Accorder une subvention en Zollars</h3><strong>Description :</strong><br>Ajouter une valeur en Zollars aux traders s\xe9lectionn\xe9s.<br><br><strong>Mode d'emploi :</strong><br>Choisissez les traders, pr\xe9cisez le quantit\xe9 de Zollars, puis confirmez.<br><br><strong>Lecture conceptuelle :</strong><br>Repr\xe9sente une stimulation \xe9conomique ou une r\xe9compense. Utilisez-la pour relancer un trader en difficult\xe9 ou offrir un avantage fond\xe9 sur une monnaie relationnelle.",
                "popup_givepoints": "<h3>Accorder une subvention en capital</h3><strong>Description :</strong><br>Ajouter une valeur num\xe9rique (capital) aux portefeuilles des traders s\xe9lectionn\xe9s.<br><br><strong>Mode d'emploi :</strong><br>Indiquez le montant de capital, s\xe9lectionnez les traders, puis confirmez.<br><br><strong>Lecture conceptuelle :</strong><br>Stimulation \xe9conomique par injection directe de capital. \xc0 utiliser pour relancer des traders en difficult\xe9 ou r\xe9compenser certains comportements.",
                "popup_giveitem": "<h3>Attribuer une commodit\xe9</h3><strong>Description :</strong><br>Attribuer une commodit\xe9 al\xe9atoire aux traders s\xe9lectionn\xe9s.<br><br><strong>Mode d'emploi :</strong><br>S\xe9lectionnez les traders dans la liste active, puis cliquez sur le bouton.<br><br><strong>Lecture conceptuelle :</strong><br>Les commodit\xe9s sont des actifs physiques pouvant servir de levier pour cr\xe9er de la demande et des \xe9changes dans le march\xe9 global.",
                "popup_freebie": "<h3>Distribution de commodit\xe9s (Tous)</h3><strong>Description :</strong><br>Distribuer simultan\xe9ment une commodit\xe9 \xe0 tous les traders actifs.<br><br><strong>Mode d'emploi :</strong><br>Cliquez pour activer la subvention.<br><br><strong>Lecture conceptuelle :</strong><br>Favorise la liquidit\xe9 en injectant massivement des ressources dans le march\xe9. Permet de stimuler la consommation et l'activit\xe9 d'\xe9change sur l'ensemble de la session.",
                "popup_publizity": "<h3>Lancer PubliZity</h3><strong>Description :</strong><br>Diffuser une vid\xe9o publicitaire al\xe9atoire mettant en sc\xe8ne des entreprises de la ZEconomy aupr\xe8s de tous les traders.<br><br><strong>Mode d'emploi :</strong><br>Cliquez sur le bouton pour d\xe9clencher la diffusion.<br><br><strong>Lecture conceptuelle :</strong><br>PubliZity utilise les codes de la publicit\xe9 pour promouvoir la consommation de la pr\xe9sence au monde. Chaque affiche renvoie \xe0 l'acte de vivre, invitant \xe0 rester ancr\xe9 dans l'instant plut\xf4t qu'\xe0 une distraction vide.",
                "popup_znews": "<h3>Lancer une \xe9dition ZNews</h3><strong>Description :</strong><br>Diffuser une vid\xe9o d'actualit\xe9 al\xe9atoire afin de contextualiser ou commenter le march\xe9.<br><br><strong>Mode d'emploi :</strong><br>Cliquez pour lancer la diffusion.<br><br><strong>Lecture conceptuelle :</strong><br>ZNews d\xe9tourne les codes des m\xe9dias \xe9conomiques pour d\xe9crire les \xe9v\xe9nements r\xe9cents de la ZEconomy. Les diff\xe9rentes s\xe9ries explorent la vie, l'art et l'\xe9conomie, ind\xe9pendamment des th\xe8mes ou techniques.",
                "popup_createstory": "<h3>Cr\xe9er un th\xe8me narratif</h3><strong>Description :</strong><br>Cr\xe9er un cadre narratif que l'IA utilisera pour interpr\xe9ter et raconter la session de trading.<br><br><strong>Mode d'emploi :</strong><br>Ouvrez la fen\xeatre de cr\xe9ation, saisissez un titre et une description, puis validez.<br><br><strong>Lecture conceptuelle :</strong><br>Le th\xe8me narratif fa\xe7onne la mani\xe8re dont la Voice of the Bourse interpr\xe8te l'activit\xe9 du march\xe9. Il \xe9tablit un prisme narratif \xe0 travers lequel tous les \xe9changes prennent sens.",
                "popup_addbots": "<h3>Ajouter des robo trader</h3><strong>Description :</strong><br>Ajouter des bots de trading automatis\xe9s \xe0 la session pour assurer la liquidit\xe9.<br><br><strong>Mode d'emploi :</strong><br>Configurez le nombre de robo traders et l'intervalle d'action, puis ajoutez-les \xe0 la session.<br><br><strong>Fonctionnement :</strong><br>Les robo trader adoptent diff\xe9rents styles et humeurs de trading. Ils effectuent des transactions automatiques \xe0 intervalles r\xe9guliers, g\xe9n\xe9rant activit\xe9 et liquidit\xe9.<br><br><strong>Lecture conceptuelle :</strong><br>Les robo traders simulent la pr\xe9sence de traders lorsque la participation humaine est faible. Ils cr\xe9ent l'illusion d'un march\xe9 anim\xe9 et garantissent une activit\xe9 constante.",
                "popup_removebots": "<h3>Retirer les robo traders de march\xe9</h3><strong>Description :</strong><br>Supprimer tous les robo traders de trading de la session.<br><br><strong>Mode d'emploi :</strong><br>Cliquez pour retirer tous les robo traders. Leurs actifs (objets, Zollars, actions) sont r\xe9inject\xe9s dans le march\xe9.<br><br><strong>Lecture conceptuelle :</strong><br>Retirer les robo traders rend au march\xe9 son caract\xe8re enti\xe8rement humain. Les actifs qu'ils d\xe9tenaient sont redistribu\xe9s dans le pool disponible.",
                "popup_botstatus": "<h3>\xc9tat des robo traders</h3><strong>Description :</strong><br>Consulter l'\xe9tat actuel des robo traders dans la session.<br><br><strong>Mode d'emploi :</strong><br>Cliquez pour voir le nombre de robo trader actifs, leurs noms et leurs styles de trading.<br><br><strong>Lecture conceptuelle :</strong><br>Surveiller l'activit\xe9 des bots aide l'op\xe9rateur \xe0 comprendre l'\xe9quilibre entre trading automatis\xe9 et humain."
            },
            tuts: {
                market_instructions: `
       <h3>Pr\xe9sentation du March\xe9</h3>
       ZExchange est le March\xe9 de la Z\xc9conomie. C\u{2019}est le c\u{153}ur dynamique des activit\xe9s de trading o\xf9 les traders peuvent explorer, ench\xe9rir, parier \xe0 la baisse et \xe9changer divers actifs. Le March\xe9 est le lieu o\xf9 se prennent les d\xe9cisions strat\xe9giques et o\xf9 se fa\xe7onnent activement les portefeuilles.
       <br><br>
       <h3>Activit\xe9s du March\xe9</h3>
       <strong>1. Explorer les actifs disponibles&nbsp;:</strong><br>
       Parcourez les actifs en liste (actions, marchandises, obligations) avec descriptions et valorisation quasi temps r\xe9el, afin d\u{2019}initier des \xe9changes ou des ench\xe8res en connaissance de cause. Vous pouvez aussi placer des positions \xe0 d\xe9couvert et voir qui a short\xe9 quoi.
       <br><br>
       <strong>2. Envoyer des offres d\u{2019}\xe9change&nbsp;:</strong><br>
       Proposez des \xe9changes de marchandises directement \xe0 d\u{2019}autres traders. Une offre est valable 10&nbsp;secondes&nbsp;; le destinataire peut l\u{2019}accepter ou la refuser. En l\u{2019}absence de r\xe9ponse, elle est refus\xe9e automatiquement. Des frais s\u{2019}appliquent aux deux parties en cas d\u{2019}acceptation.
       <br><br>
       <strong>3. Placer des ench\xe8res&nbsp;:</strong><br>
       Ench\xe9\xadrissez sur les actions et obligations list\xe9es. Les ench\xe8res peuvent permettre d\u{2019}obtenir un actif \xe0 meilleur prix, mais surveillez bien les \xe9ch\xe9ances.
       <br><br>
       <strong>4. Racheter des marchandises&nbsp;:</strong><br>
       S\xe9lectionnez entre 2 et 10 marchandises via leurs cases de rachat. Apr\xe8s la 2e s\xe9lection, le bouton de rachat appara\xeet pour finaliser la proc\xe9dure.
       <br><br>
       <strong>5. Prendre des positions \xe0 d\xe9couvert&nbsp;:</strong><br>
       Pariez sur la baisse de certains actifs. Outil puissant mais risqu\xe9, utile pour moduler vos gains/pertes. La cl\xf4ture se fait depuis votre portefeuille.
       <br><br>
       <h3>M\xe9caniques de trading</h3>
       <strong>1. Frais de transaction&nbsp;:</strong> chaque op\xe9ration a un co\xfbt, pour encourager les \xe9changes r\xe9fl\xe9chis.<br>
       <strong>2. Expiration des ench\xe8res&nbsp;:</strong> si la cible ne r\xe9pond pas dans les temps, l\u{2019}ench\xe8re expire (des p\xe9nalit\xe9s peuvent s\u{2019}appliquer \xe0 l\u{2019}absence de r\xe9ponse).<br>
       <strong>3. P\xe9nalit\xe9s sur offres&nbsp;:</strong> refuser une offre peut entra\xeener une p\xe9nalit\xe9 d\u{2019}earnings pour le refusant (et des frais si l\u{2019}offre est accept\xe9e).
       <br><br>
       <h3>Qu\u{2019}est-ce qu\u{2019}une bourse&nbsp;?</h3>
       Une bourse est une plateforme o\xf9 l\u{2019}on ach\xe8te et vend des actifs (actions, obligations, marchandises) selon l\u{2019}offre, la demande et la strat\xe9gie. La ZExchange d\xe9place la valeur vers les exp\xe9riences humaines, les relations et l\u{2019}\xe9change social. \xab&nbsp;Plus&nbsp;\xbb n\u{2019}est pas n\xe9cessairement \xab&nbsp;mieux&nbsp;\xbb. On privil\xe9gie la collaboration, l\u{2019}\xe9thique de la comp\xe9tition et la valeur des exp\xe9riences partag\xe9es.
       <br><br>
       En participant \xe0 la ZExchange, vous engagez une exp\xe9rience financi\xe8re qui met l\u{2019}accent sur l\u{2019}humain. Il s\u{2019}agit de d\xe9passer l\u{2019}accumulation mat\xe9rielle pour consid\xe9rer&nbsp;:
       <br><br>
       <strong>Dynamiques relationnelles&nbsp;:</strong> comment les interactions influencent les d\xe9cisions.<br>
       <strong>Trading \xe9thique&nbsp;:</strong> vos strat\xe9gies sont-elles align\xe9es avec vos valeurs&nbsp;?<br>
       <strong>Valeur exp\xe9rientielle&nbsp;:</strong> comment les \xe9changes refl\xe8tent et fa\xe7onnent les exp\xe9riences humaines.
     `,
                stock_trade_instructions: `
       <h3>Processus d\u{2019}ench\xe8re d\u{2019}actions</h3>
       <strong>Qu\u{2019}est-ce qu\u{2019}une action&nbsp;?</strong><br>
       En finance, une action repr\xe9sente une part d\u{2019}entreprise. Sa valeur \xe9volue ; vos positions aussi.
       <br><br>
       <strong>Actions dans la Z\xc9conomie&nbsp;:</strong><br>
       Ici, les actions refl\xe8tent des valeurs humaines (bien-\xeatre, liens sociaux, croissance personnelle). Trader devient une interaction avec des valeurs de vie, pas seulement un gain financier.
       <br><br>
       <strong>Perspective conceptuelle&nbsp;:</strong><br>
       Investir, c\xe9der ou shorter interroge&nbsp;: soutenez-vous des exp\xe9riences humaines ou les exploitez-vous&nbsp;? Chaque trade exprime vos priorit\xe9s.
       <br><br>
       <strong>Processus&nbsp;:</strong><br>
       1) Parcourez les actions disponibles (valeur, propri\xe9taire, potentiel).<br>
       2) Choisissez acheter / vendre / shorter selon votre lecture du march\xe9.<br>
       3) Ex\xe9cutez la transaction (quantit\xe9, confirmation) et observez la mise \xe0 jour de votre portefeuille.
       <br><br>
       <strong>Capital d\u{2019}attention&nbsp;:</strong><br>
       Les valeurs bougent vite ; shorting comporte un risque \xe9thique et financier ; chaque d\xe9cision refl\xe8te vos convictions.
     `,
                redeem_instructions: `
       <h3>Proc\xe9dure de rachat</h3>
       <strong>D\xe9finition&nbsp;:</strong><br>
       Le rachat transforme une marchandise en code&nbsp;QR pour un retrait physique tout en la retirant du march\xe9 et de votre portefeuille.
       <br><br>
       <strong>Particularit\xe9&nbsp;:</strong><br>
       Le rachat r\xe9ussit seulement si les autres traders cibl\xe9s acceptent de racheter en m\xeame temps.
       <br><br>
       <strong>Perspective conceptuelle&nbsp;:</strong><br>
       Le rachat d\xe9place l\u{2019}acte de consommer vers une d\xe9cision collective et consciente, renfor\xe7ant les liens sociaux et questionnant nos habitudes d\u{2019}achat.
       <br><br>
       <strong>\xc9tapes&nbsp;:</strong><br>
       1) S\xe9lectionnez vos marchandises et vos cibles.<br>
       2) Envoyez la demande de rachat (verrouillage 10&nbsp;s).<br>
       3) <em>Tous acceptent</em>&nbsp;: vous recevez un bonus et le code&nbsp;QR pour le retrait.<br>
       4) <em>Quelqu\u{2019}un refuse</em>&nbsp;: rien ne change, tout se d\xe9verrouille.
     `,
                transact_instructions: `
       <h3>Commodity&nbsp;X \u{2014} Rachat social</h3>
       <strong>Du bien \xe0 l\u{2019}interaction&nbsp;:</strong><br>
       La consommation devient relationnelle&nbsp;: le \xab&nbsp;oui&nbsp;\xbb collectif prime sur l\u{2019}acte individuel.
       <br><br>
       <strong>Processus social&nbsp;:</strong><br>
       S\xe9lectionnez votre Commodity&nbsp;X, invitez 1\u{2013}3 traders \xe0 racheter en m\xeame temps, envoyez la demande (10&nbsp;s). Succ\xe8s si tout le monde accepte&nbsp;; sinon, aucun changement.
       <br><br>
       <strong>Perspective conceptuelle&nbsp;:</strong><br>
       Consommer consciemment, avec validation sociale&nbsp;: la valeur \xe9merge de la relation, pas de l\u{2019}isolement.
     `,
                no_instructions: "Aucune instruction disponible.",
                no_info: "Aucune information disponible.",
                no_tutorial: "Aucun tutoriel disponible.",
                // === banner & button popups (keys must match your element ids) ===
                instructions: {
                    "trader_mood_gauge": "Jauge d'humeur des traders",
                    "description": "Description :",
                    "trader_gauge_description": "Cette jauge illustre l'humeur collective des traders pendant la s\xe9ance de march\xe9 en cours.",
                    "conceptual_insight": "Perspective conceptuelle :",
                    "gains_losses": "Gains / Pertes",
                    "portfolio_banner_description": "Cliquez sur la banni\xe8re pour voir la r\xe9partition de vos gains.",
                    "trader_tools": "Outils du trader",
                    "trader_tools_description": "Utilitaires pour effectuer des actions li\xe9es au march\xe9 avec ou contre d'autres traders.",
                    "trader_tools_insight": "Que vous voliez, ran\xe7onniez ou n\xe9gociiez en priv\xe9 : chaque d\xe9clencheur teste jusqu'o\xf9 vous irez dans la qu\xeate de valeur. Explorerez-vous de nouvelles strat\xe9gies sans perdre votre sens des responsabilit\xe9s, ou repousserez-vous les limites aux d\xe9pens des autres ? La Z\xc9conomie soul\xe8ve ces questions, vous laissant d\xe9cider de ce que \xab valeur \xbb signifie vraiment et ce que vous \xeates pr\xeat \xe0 faire pour l'obtenir.",
                    "transaction_instructions": "<h3>Instructions de Transaction</h3><p>S\xe9lectionnez un actif de vos avoirs pour proposer un \xe9change avec le propri\xe9taire de l'article. Cela permet l'\xe9change de marchandises entre portefeuilles de pair \xe0 pair.</p>",
                    "stock_instructions": "<h3>Instructions de Trading d'Actions</h3><p>Achetez des actions en saisissant la quantit\xe9 que vous souhaitez acheter. Votre capital disponible est affich\xe9 ci-dessus. Chaque transaction affecte le march\xe9 et construit votre portefeuille.</p>",
                    "bond_instructions": "<h3>Instructions de Trading d'Obligations</h3><p>\xc9changez des Z-Obligations, les instruments de dette \xe9motionnelle du Syst\xe8me Mon\xe9taire Relationnel Z. Les obligations repr\xe9sentent le capital relationnel entre traders.</p>",
                    // === popups ===
                    'portfolio-banner': `
        <h3>Gains / Pertes</h3>
        Cliquez sur la banni\xe8re pour afficher le d\xe9tail de vos gains.
      `,
                    'tools-banner': `
        <h3>Outils du trader</h3>
        Outils pour r\xe9aliser des actions li\xe9es au march\xe9, avec ou contre d\u{2019}autres traders.
        <br><br>
        Que vous voliez, ran\xe7onniez ou n\xe9gociiez en priv\xe9&nbsp;: chaque d\xe9clencheur teste jusqu\u{2019}o\xf9 vous irez dans votre qu\xeate de valeur. Explorerez-vous de nouvelles strat\xe9gies sans perdre votre sens des responsabilit\xe9s, ou franchirez-vous les limites aux d\xe9pens d\u{2019}autrui ? La ZEconomy pose ces questions et vous laisse d\xe9finir ce que \xab valeur \xbb signifie vraiment et jusqu\u{2019}o\xf9 vous \xeates pr\xeat \xe0 aller pour l\u{2019}obtenir.
      `,
                    'emotional-state-banner': `
        <h3>Indice de Dette \xc9motionnelle</h3>
        <strong>Flux des \xe9motions humaines</strong>
        <br><br>
        <strong>D\xe9couvrir la valeur de la vuln\xe9rabilit\xe9 \xe0 travers la dette \xe9motionnelle.</strong>
        <br><br>
        Dans cette \xe9conomie, la valeur ne s\u{2019}extrait pas : elle se ressent.
        Chaque geste \u{2014} aide, confiance, abandon, envie \u{2014} laisse une trace : un gain ou une perte \xe9motionnelle mesurable.
        Le \xab Profit de Vie \xbb devient la monnaie qui prend la temp\xe9rature de notre \xeatre.
        <br><br>
        Tenir l\u{2019}autre, se laisser tenir : les formes de levier les plus humaines. La ZEconomy circule \xe0 travers nous.
        <br><br>
        <strong>Indice de Confiance</strong> \u{2014} Mesure de l\u{2019}int\xe9grit\xe9 relationnelle.
        Il monte avec l\u{2019}honneur et l\u{2019}entraide, baisse avec l\u{2019}exploitation ou la trahison.
        <br><br>
        <strong>Profit de Vie</strong> \u{2014} La monnaie du sensible : ni argent ni possession, mais la valeur \xe9motionnelle et morale accumul\xe9e de votre existence.
        <br><br>
        <em>Rejetez la fantaisie du capital ; embrassez la liquidit\xe9 du sentiment humain.</em>
      `,
                    'social-economy-banner': `
        <h3>Instruments de dette \xe9motionnelle</h3>
        <strong>Ce qui circule ici n'est pas la finance, mais la reconnaissance.</strong>
        <br><br>
        La vuln\xe9rabilit\xe9 devient \xe0 la fois miroir et march\xe9 : chaque profit est l'\xe9cho du risque d'autrui,
        chaque dette une m\xe9moire qui refuse de s'effacer.
        <br><br>
        <strong>Les quatre instruments :</strong><br><br>
        \u{2022} <strong>Billet Z Altrauiste</strong> \u{2014} Aide altruiste sans contrepartie ; votre Profit Vital se lie \xe0 celui de l'autre (destin partag\xe9).<br><br>
        \u{2022} <strong>Note M (Note Mutuelle)</strong> \u{2014} Pr\xeat scell\xe9 par l'aveu : emprunter expose sa fragilit\xe9, pr\xeater assume un risque \xe9motionnel. La confiance prend forme.<br><br>
        \u{2022} <strong>CDO Z-Payday</strong> \u{2014} Exploitation grim\xe9e en lien affectif : siphonner la valeur de la d\xe9tresse, minute apr\xe8s minute ; le registre ne pardonne pas.<br><br>
        \u{2022} <strong>Note V (Note de Vuln\xe9rabilit\xe9)</strong> \u{2014} Le courage de demander : reconna\xeetre le besoin, risquer l'exposition, oser d\xe9pendre. L'aide donn\xe9e ou refus\xe9e fa\xe7onne la confiance.
        <br><br>
        <em>Chaque transaction s'inscrit dans l'Indice de Dette \xc9motionnelle.</em>
      `,
                    'economic-banner': `
          <h3>D\xe9clencheurs d\u{2019}attaque \xe9conomique</h3>
          <strong>Description&nbsp;:</strong><br>
          Ces d\xe9clencheurs incarnent diff\xe9rentes visions id\xe9ologiques de la richesse, du pouvoir et de la dynamique de march\xe9. Ils permettent d\u{2019}appliquer, dans la ZEconomy, des strat\xe9gies inspir\xe9es du communisme, du socialisme ou du capitalisme pour gagner ou redistribuer des avantages. Au-del\xe0 de la finance, ils invitent chacun \xe0 confronter ses convictions sur l\u{2019}\xe9quit\xe9, l\u{2019}ambition et la responsabilit\xe9 collective.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Con\xe7us pour faire r\xe9fl\xe9chir \xe0 l\u{2019}influence des syst\xe8mes \xe9conomiques sur les comportements et les r\xe9sultats, ils mettent en sc\xe8ne des dilemmes r\xe9els&nbsp;:
          <ul>
            <li>Faut-il partager la richesse, m\xeame si cela signifie confisquer la r\xe9ussite ?</li>
            <li>Est-il \xe9thique de profiter au d\xe9triment de l\u{2019}autonomie d\u{2019}autrui ?</li>
            <li>Jusqu\u{2019}o\xf9 iriez-vous pour votre gain personnel ou le bien-\xeatre collectif ?</li>
          </ul>
          \xc0 vous de peser b\xe9n\xe9fice individuel et cons\xe9quences sociales. La ZEconomy s\u{2019}en sert pour nourrir le d\xe9bat sur l\u{2019}\xe9quilibre entre justice, ambition et compromis \xe9thiques.
        `,
                    'stocks-banner': `
          <h3>Actions (Shares)</h3>
          <strong>Description&nbsp;:</strong><br>
          Surveillez et \xe9changez vos positions en actions.
          <br><br>
          <strong>D\xe9finition&nbsp;:</strong><br>
          Dans la finance classique, une action repr\xe9sente une part de propri\xe9t\xe9 dans une entreprise, achet\xe9e dans l\u{2019}espoir d\u{2019}une valorisation.
          <br><br>
          Dans la ZEconomy, chaque \xab entreprise \xbb incarne une valeur humaine : bien-\xeatre \xe9motionnel, relations sociales, activit\xe9s quotidiennes\u{2026} En \xab investissant \xbb dans ces entreprises, vous pariez sur la croissance, la transformation ou la durabilit\xe9 d\u{2019}exp\xe9riences humaines.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Cela remet en question la notion de profit : s\u{2019}agit-il d\u{2019}un gain mon\xe9taire ou du soutien \xe0 l\u{2019}expansion de la valeur de la vie ? Vos actions refl\xe8tent-elles ce que vous valorisez ou ce que vous voyez de valeur chez les autres ?
          <br><br>
          Chaque transaction souligne la tension entre l\u{2019}appui sinc\xe8re aux exp\xe9riences humaines et leur exploitation financi\xe8re.
          <br><br>
          <strong>M\xe9canique&nbsp;:</strong><br>
          Les actions se n\xe9gocient contre des Zollars ou du capital. Si la valeur de l\u{2019}\xab entreprise \xbb monte, votre portefeuille s\u{2019}appr\xe9cie ; si elle baisse, il se d\xe9pr\xe9cie.
        `,
                    'shorts-banner': `
          <h3>Ventes \xe0 d\xe9couvert</h3>
          <strong>Description&nbsp;:</strong><br>
          Consultez et g\xe9rez vos positions \xe0 d\xe9couvert.
          <br><br>
          <strong>D\xe9finition&nbsp;:</strong><br>
          La vente \xe0 d\xe9couvert est un pari sur la baisse d\u{2019}un actif. Vous empruntez des actions sans consentement, les vendez, puis les rachetez moins cher pour les rendre, empochant la diff\xe9rence. Si le prix monte, vous perdez.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Elle illustre le paradoxe de \xab profiter de la chute \xbb, questionnant l\u{2019}\xe9thique de miser sur l\u{2019}\xe9chec. Dans un syst\xe8me o\xf9 la vie est l\u{2019}actif, est-il juste de parier sur la faillite ?
          <br><br>
          <strong>Exemple&nbsp;:</strong><br>
          <em>Conceptualisation&nbsp;:</em> Vous empruntez le t\xe9l\xe9phone d\u{2019}un ami, le vendez 100 \u{20AC}, en rachetez un autre 90 \u{20AC} ; vous rendez l\u{2019}appareil et gagnez 10 \u{20AC}. Dans la vraie vie, c\u{2019}est du vol ; en finance, c\u{2019}est une technique de trading.
          <br><br>
          <strong>Ressource suppl\xe9mentaire&nbsp;:</strong><br>
          Vid\xe9o explicative : Techniques de life-trading \u{2013} Shorting
        `,
                    'commodities-banner': `
          <h3>Marchandises</h3>
          <strong>Description&nbsp;:</strong><br>
          Les biens physiques que vous pouvez \xe9changer ou racheter.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Les marchandises ancrent la ZEconomy dans le monde r\xe9el : elles rappellent que les march\xe9s concernent aussi les objets et exp\xe9riences qui fa\xe7onnent notre quotidien. Choisir de les racheter vous fait r\xe9fl\xe9chir \xe0 la consommation, \xe0 la valeur de la propri\xe9t\xe9 et \xe0 la mani\xe8re dont l\u{2019}\xe9change favorise la communaut\xe9.
          <br><br>
          <strong>D\xe9tails&nbsp;:</strong><br>
          Chaque marchandise est convertible en QR code via la proc\xe9dure de rachat ; une fois \xe9chang\xe9e, elle sort du march\xe9.
          <br><br>
          <strong>Proc\xe9dure de rachat&nbsp;:</strong>
          <ol>
            <li>Cochez entre 3 et 10 marchandises sur le march\xe9.</li>
            <li>Cliquez sur \xab Racheter \xbb en bas de l\u{2019}\xe9cran.</li>
            <li>Choisissez celles \xe0 transformer en QR code.</li>
            <li>Apr\xe8s validation, vous recevez un bonus (nouvelle marchandise non rachet\xe9e) et le QR code de l\u{2019}article choisi.</li>
          </ol>
          <br>
          <strong>Retrait physique&nbsp;:</strong><br>
          Pr\xe9sentez le QR code \xe0 l\u{2019}endroit indiqu\xe9 pour r\xe9cup\xe9rer la marchandise r\xe9elle. Une fois retir\xe9e, elle n\u{2019}est plus \xe9changeable ; elle rejoint votre vie hors march\xe9.
        `,
                    'redeemed-banner': `
          <h3>Objets rachet\xe9s</h3>
          <strong>Description&nbsp;:</strong><br>
          Affichez les codes&nbsp;QR de vos objets rachet\xe9s.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Chacune de vos marchandises correspond \xe0 un objet physique pouvant \xeatre rachet\xe9 via la proc\xe9dure de rachat du march\xe9. Une fois rachet\xe9e, la marchandise est convertie en code&nbsp;QR : c\u{2019}est la cl\xe9 qui permet de retirer l\u{2019}objet, \xe0 l\u{2019}endroit indiqu\xe9. Tant qu\u{2019}elles ne sont pas rachet\xe9es, les marchandises demeurent sur le march\xe9, ajoutent de la valeur \xe0 votre portefeuille et restent \xe9changeables. Apr\xe8s rachat, elles quittent le march\xe9 ; elles ne sont plus n\xe9gociables et entrent dans votre r\xe9alit\xe9 physique.
          <br><br>
          <strong>Proc\xe9dure de rachat&nbsp;:</strong>
          <ol>
            <li>Cochez entre 3 et 10 marchandises sur le march\xe9.</li>
            <li>Cliquez sur le bouton \xab Racheter \xbb en bas de l\u{2019}\xe9cran.</li>
            <li>Choisissez la ou les marchandises \xe0 convertir en code&nbsp;QR.</li>
            <li>Une fois la demande accept\xe9e, vous recevez un bonus (une marchandise non rachet\xe9e) ainsi que le code&nbsp;QR de l\u{2019}objet rachet\xe9.</li>
          </ol>
          <br>
          <strong>Retrait physique&nbsp;:</strong><br>
          Pr\xe9sentez le code&nbsp;QR \xe0 l\u{2019}emplacement indiqu\xe9 pour r\xe9cup\xe9rer l\u{2019}objet r\xe9el. Apr\xe8s rachat, l\u{2019}objet ne fait plus partie du march\xe9 ; il subsiste comme preuve tangible de vos choix et de votre syst\xe8me de valeurs dans la ZEconomy.
          <br><br>
          <strong>Finalit\xe9 du rachat&nbsp;:</strong><br>
          Racheter une marchandise souligne le lien concret entre l\u{2019}activit\xe9 de march\xe9 et l\u{2019}exp\xe9rience v\xe9cue. Vous \xeates invit\xe9 \xe0 r\xe9fl\xe9chir au moment et aux raisons qui motivent la conversion de valeur de march\xe9 en objet physique : une occasion d\u{2019}examiner vos modes de consommation, les besoins de la communaut\xe9 et l\u{2019}\xe9quilibre entre actifs num\xe9riques et biens mat\xe9riels.
        `,
                    'zbonds-banner': `
          <h3>ZBonds</h3>
          <strong>Description&nbsp;:</strong><br>
          Les ZBonds fonctionnent comme des obligations classiques : vous les achetez (en capitaux dans ce projet), les conservez pendant une dur\xe9e pr\xe9d\xe9finie et, \xe0 l\u{2019}\xe9ch\xe9ance, vous recevez un montant de Zollars. \xc0 l\u{2019}instar des obligations d\u{2019}\xc9tat ou d\u{2019}entreprise, ils peuvent \xeatre achet\xe9s et revendus sur le march\xe9 avant maturit\xe9.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Alors que les obligations traditionnelles financent des \xc9tats ou des entreprises, les ZBonds financent la cr\xe9ation d\u{2019}une monnaie \u{2013} les Zollars \u{2013} dont la valeur repose enti\xe8rement sur les relations humaines et les exp\xe9riences partag\xe9es. Investir dans un ZBond revient \xe0 placer sa confiance dans les valeurs collectives de la communaut\xe9 plut\xf4t que dans de simples rendements financiers.
          <br><br>
          <strong>Pourquoi les inclure&nbsp;?</strong><br>
          Les ZBonds font le pont entre la notion d\u{2019}\xab obligation \xe0 revenu fixe \xbb et la red\xe9finition de la valeur par la ZEconomy. Ils nous rappellent que nous pouvons investir les uns dans les autres : dans la qualit\xe9 de nos liens, pas seulement dans des soci\xe9t\xe9s ou des gouvernements. En \xab empruntant au futur \xbb pour cr\xe9er des Zollars maintenant, les ZBonds nous invitent \xe0 fa\xe7onner consciemment la valeur de nos liens sociaux et \xe0 replacer la relation au c\u{153}ur d\u{2019}une \xe9conomie florissante.
        `,
                    'zollars-banner': `
          <h3>Zollars</h3>
          <strong>Description&nbsp;:</strong><br>
          Consultez votre solde de Zollars et l\u{2019}historique de vos transactions.
          <br><br>
          <strong>D\xe9finition&nbsp;:</strong><br>
          Les Zollars sont une monnaie \xe9mise par la Zederal&nbsp;Reserve dans le cadre du Syst\xe8me mon\xe9taire des relations (Z&nbsp;Relationship Monetary System). Contrairement \xe0 une devise traditionnelle \u{2013} adoss\xe9e \xe0 un m\xe9tal pr\xe9cieux ou \xe0 la confiance envers une banque centrale \u{2013} les Zollars sont index\xe9s sur les qualit\xe9s intangibles des relations humaines, qu\u{2019}elles soient positives ou n\xe9gatives.
          <br><br>
          Dans une monnaie classique, la confiance va \xe0 l\u{2019}institution \xe9mettrice ; les Zollars vous invitent \xe0 consid\xe9rer les relations elles-m\xeames comme \xab r\xe9serve centrale \xbb de valeur. Chaque relation, quelle qu\u{2019}en soit la nature, contribue \xe0 la signification collective des Zollars.
          <br><br>
          <strong>Aper\xe7u&nbsp;:</strong><br>
          Les ZRelationship&nbsp;Zollars red\xe9finissent l\u{2019}\xe9change \xe9conomique en valorisant les liens plut\xf4t que les chiffres. Chaque type de Zollar vous pousse \xe0 r\xe9fl\xe9chir au r\xf4le et \xe0 l\u{2019}importance de diff\xe9rentes connexions dans votre vie.
          <br><br>
          <strong>Types disponibles&nbsp;:</strong>
          <ul>
            <li><strong>Love&nbsp;Zollars&nbsp;:</strong> la valeur que vous accordez \xe0 l\u{2019}amour.</li>
            <li><strong>Friendship&nbsp;Zollars&nbsp;:</strong> confiance, loyaut\xe9 et camaraderie.</li>
            <li><strong>Erotic&nbsp;Zollars&nbsp;:</strong> relations fond\xe9es sur le d\xe9sir et l\u{2019}intimit\xe9.</li>
            <li><strong>Fellowship&nbsp;Zollars&nbsp;:</strong> partenariats professionnels et collaboratifs.</li>
            <li><strong>Hate&nbsp;Zollars&nbsp;:</strong> intensit\xe9 des rapports adverses.</li>
            <li><strong>Superficial&nbsp;Zollars&nbsp;:</strong> interactions br\xe8ves ou de surface.</li>
            <li><strong>Toxic&nbsp;Zollars&nbsp;:</strong> gestion des relations complexes ou nocives.</li>
            <li><strong>Death&nbsp;Zollars&nbsp;:</strong> rapport \xe0 la mortalit\xe9, in\xe9vitable pour tous.</li>
            <li><strong>Custom&nbsp;Zollars&nbsp;:</strong> cr\xe9ez une devise pour des liens uniques ou personnels.</li>
          </ul>
          <br>
          <strong>Pourquoi les inclure&nbsp;?</strong><br>
          Les Zollars bousculent notre mani\xe8re de \xab chiffrer \xbb la valeur : ils nous poussent \xe0 r\xe9examiner le co\xfbt et l\u{2019}importance de nos liens, socle v\xe9ritable de toute \xe9conomie. Ils rappellent que la valeur ne se r\xe9sume pas aux finances ; elle est enracin\xe9e dans les relations et les connexions qui fa\xe7onnent nos vies.
        `,
                    'messageButton': "<h3>Messagerie</h3>Envoyez des messages aux autres traders (co\xfbt&nbsp;: 20&nbsp;capitaux).",
                    'stealButton': `
          <h3>D\xe9clencheur de vol d\u{2019}actif</h3>
          <strong>Description&nbsp;:</strong><br>
          Le d\xe9clencheur de vol vous permet de d\xe9rober un bien \xe0 un autre trader, anonymement et sans autorisation.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la banni\xe8re \xab Vol \xbb.</li>
            <li>Choisissez un objet dans la liste des avoirs disponibles.</li>
            <li>Confirmez l\u{2019}action pour finaliser le larcin.</li>
          </ul>
          <br>
          <strong>Plus d\u{2019}infos & d\xe9fi \xe9thique&nbsp;:</strong><br>
          Le vol est universellement condamn\xe9, mais existe sous d\u{2019}innombrables formes, de la petite d\xe9linquance \xe0 la corruption de haut vol. En commettant un vol ici, interrogez-vous : vos limites morales vacillent-elles ? Le plaisir imm\xe9diat de l\u{2019}objet \xab gratuit \xbb compense-t-il le tort caus\xe9 au propri\xe9taire ? Comment \xe9valuez-vous l\u{2019}empathie, la culpabilit\xe9 et le profit personnel dans la ZEconomy ?
          <br><br>
          <strong>Exemple d\u{2019}usage&nbsp;:</strong><br>
          Vous rep\xe9rez une marchandise convoit\xe9e sur le grand tableau. Gr\xe2ce au d\xe9clencheur de vol, vous l\u{2019}ajoutez \xe0 votre portefeuille\u{2026} mais comment vivez-vous le fait d\u{2019}avoir gagn\xe9 de la \xab valeur \xbb en l\xe9sant autrui ?
        `,
                    'ransomButton': `
          <h3>D\xe9clencheur de ran\xe7on d\u{2019}un trader</h3>
          <strong>Description&nbsp;:</strong><br>
          Verrouille le portefeuille d\u{2019}un trader et l\u{2019}oblige \xe0 payer votre ran\xe7on pour reprendre ses activit\xe9s.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la banni\xe8re \xab Ran\xe7on \xbb.</li>
            <li>S\xe9lectionnez le portefeuille \xe0 ran\xe7onner.</li>
            <li>Saisissez le montant de la ran\xe7on en capitaux.</li>
            <li>Une fois la ran\xe7on pos\xe9e, la victime ne peut plus trader tant qu\u{2019}elle ne paie pas.</li>
          </ul>
          <br>
          <strong>Plus d\u{2019}infos & d\xe9fi \xe9thique&nbsp;:</strong><br>
          La ran\xe7on s\u{2019}apparente \xe0 de l\u{2019}extorsion. Ill\xe9gale dans le monde r\xe9el, elle n\u{2019}entra\xeene ici qu\u{2019}une sanction sociale : votre identit\xe9 est r\xe9v\xe9l\xe9e \xe0 la victime. Aimez-vous ce pouvoir ? Craignez-vous les repr\xe9sailles ? Le profit justifie-t-il l\u{2019}angoisse impos\xe9e ?
          <br><br>
          <strong>Exemple d\u{2019}usage&nbsp;:</strong><br>
          Vous ciblez un trader riche mais \xe0 court de capitaux : en bloquant son portefeuille par une ran\xe7on \xe9lev\xe9e, vous esp\xe9rez un gain rapide \u{2013} \xe0 condition de g\xe9rer la col\xe8re suscit\xe9e.
        `,
                    'deletePortfolioButton': `
          <h3>D\xe9clencheur d\u{2019}assaut communiste</h3>
          <strong>Description&nbsp;:</strong><br>
          Saisit et redistribue l\u{2019}int\xe9gralit\xe9 de la richesse d\u{2019}un rival \xe0 l\u{2019}ensemble des traders actifs.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la banni\xe8re \xab Assaut communiste \xbb.</li>
            <li>Choisissez le portefeuille cible.</li>
            <li>Confirmez pour r\xe9partir instantan\xe9ment tous ses avoirs.</li>
          </ul>
          <br>
          <strong>Plus d\u{2019}infos & d\xe9fi \xe9thique&nbsp;:</strong><br>
          Tout le patrimoine d\u{2019}un trader est confisqu\xe9 puis distribu\xe9. Acte de solidarit\xe9 ou injustice ? Seriez-vous pr\xeat \xe0 perdre vos biens pour le bien commun ?
          <br><br>
          <strong>Exemple d\u{2019}usage&nbsp;:</strong><br>
          Un hoarder d\xe9s\xe9quilibre le march\xe9 ; vous lancez l\u{2019}assaut et redistribuez ses ressources. La mar\xe9e monte pour tous\u{2026} mais au prix d\u{2019}une confiscation forc\xe9e.
        `,
                    'LBOButton': `
          <h3>D\xe9clencheur capitaliste<br>(LBO) Rachat par levier</h3>
          <strong>Description&nbsp;:</strong><br>
          Rachetez agressivement les actifs d\u{2019}un autre trader, qu\u{2019}il le veuille ou non.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la banni\xe8re \xab LBO capitaliste \xbb.</li>
            <li>S\xe9lectionnez le portefeuille cible.</li>
            <li>Payez une somme importante en capital (capital \xe0 effet de levier).</li>
            <li>Vous prenez alors possession de ses items et actions.</li>
          </ul>
          <br>
          <strong>Plus d\u{2019}infos & d\xe9fi \xe9thique&nbsp;:</strong><br>
          LBO = emprunt massif pour une prise de contr\xf4le. M\xeame si la cible re\xe7oit un paiement, l\u{2019}op\xe9ration reste coercitive. Richesse = pouvoir ; \xeates-vous pour la libre concurrence ou l\u{2019}exploitation ?
          <br><br>
          <strong>Exemple d\u{2019}usage&nbsp;:</strong><br>
          Vous rep\xe9rez un petit portefeuille prometteur. En payant une prime \xe9lev\xe9e, vous le rachetez de force : il est d\xe9dommag\xe9, mais vous gagnez la mainmise \u{2013} juste ou abusif ?
        `,
                    'SubsidyButton': `
          <h3>D\xe9clencheur<br>de subvention socialiste</h3>
          <strong>Description&nbsp;:</strong><br>
          \xab Taxez \xbb un portefeuille riche pour soutenir la moiti\xe9 la plus pauvre du march\xe9.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la banni\xe8re \xab Subvention socialiste \xbb.</li>
            <li>Choisissez un portefeuille fortun\xe9.</li>
            <li>Validez la taxe : la richesse pr\xe9lev\xe9e est r\xe9partie entre les traders les moins ais\xe9s.</li>
          </ul>
          <br>
          <strong>Plus d\u{2019}infos & d\xe9fi \xe9thique&nbsp;:</strong><br>
          Prendre aux riches pour aider les plus d\xe9munis : \xe9galit\xe9 ou punition du succ\xe8s ? La justice sociale prime-t-elle sur la libert\xe9 individuelle ?
          <br><br>
          <strong>Exemple d\u{2019}usage&nbsp;:</strong><br>
          Voyant un joueur satur\xe9 de stocks alors que d\u{2019}autres peinent, vous appliquez la subvention : la richesse est tax\xe9e puis inject\xe9e chez les plus pauvres. \xc9quit\xe9 ou sanction ? \xc0 vous de juger.
        `,
                    'helpFriendButton': `
          <h3>Billet Z Altrauiste</h3>
          <strong>Valeur de vie altruiste. Pure empathie.</strong>
          <br><br>
          <strong>Description&nbsp;:</strong><br>
          Donner sans rien attendre. En aidant quelqu'un, vous vous liez \xe0 la trajectoire de son Profit Vital. Ses hauts et ses bas tirent vos propres profits de vie vers le positif ou le n\xe9gatif. Un pari silencieux : le bien-\xeatre d'autrui pourrait \xe9largir votre propre capacit\xe9 \xe0 ressentir, \xe0 d\xe9ployer votre empathie.
          <br><br>
          <strong>Sans contrepartie.</strong>
          <br><br>
          <strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          Une transaction qui lie deux registres ; une mise en commun des variances plut\xf4t qu'une simple addition. En \xe9mettant un Billet Z Altrauiste, vous ne faites pas qu'aider : vous tissez votre \xe9conomie \xe9motionnelle \xe0 celle de l'autre. Ses victoires deviennent les v\xf4tres, ses \xe9checs vous incombent aussi.
          <br><br>
          Cela soul\xe8ve une question&nbsp;: <em>L'empathie peut-elle \xeatre un investissement&nbsp;? Qu'advient-il lorsque la douleur de l'autre devient votre perte, sa joie votre gain&nbsp;?</em>
          <br><br>
          <strong>Utilisation&nbsp;:</strong><br>
          Cliquez sur \xab \xc9mettre un Billet Z Altrauiste \xbb, choisissez un trader \xe0 soutenir, s\xe9lectionnez votre don (Zollars ou Capital), puis confirmez. Votre Profit Vital fluctuera d\xe9sormais avec le sien \u{2014} un destin \xe9motionnel partag\xe9.
        `,
                    'borrowCapitalButton': `
          <h3>Note M (Note Mutuelle)</h3>
          <strong>Un pr\xeat scell\xe9 par l'aveu.</strong>
          <br><br>
          <strong>Description&nbsp;:</strong><br>
          La Note M engendre du cr\xe9dit \xe0 partir d'un besoin mis \xe0 nu et d'une confiance mesur\xe9e. Valeur n\xe9e de l'empathie humaine \u{2014} du partage de nos imperfections. L'emprunteur expose une faiblesse ; le pr\xeateur accepte le risque, faisant de l'empathie une forme d'investissement.
          <br><br>
          Ce qui d\xe9bute comme reconnaissance devient obligation \u{2014} la vuln\xe9rabilit\xe9 se mue en Collat\xe9ral Relationnel Z, les int\xe9r\xeats croissant en attention, en reconnaissance, en Profit Vital mutuel.
          <br><br>
          <strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          Un int\xe9r\xeat modul\xe9 par l'\xe9motion ; le temps se dilate au gr\xe9 de l'humeur. Contrairement aux pr\xeats classiques, la Note M ne transf\xe8re pas que du capital : elle transf\xe8re la vuln\xe9rabilit\xe9. L'emprunteur doit confesser son besoin, exposant sa fragilit\xe9 pour gagner la confiance.
          <br><br>
          Le pr\xeateur ne fournit pas que des ressources ; il endosse le risque \xe9motionnel de cette fragilit\xe9. Les deux parties se retrouvent li\xe9es : l'emprunteur par l'obligation, le pr\xeateur par l'empathie.
          <br><br>
          <em>Pr\xeater, c'est miser sur la capacit\xe9 de l'autre \xe0 se relever. Emprunter, c'est demander \xe0 quelqu'un de croire en vous.</em>
          <br><br>
          <strong>Utilisation&nbsp;:</strong><br>
          Cliquez sur \xab \xc9mettre une Note M (Emprunter) \xbb, choisissez un pr\xeateur, r\xe9digez votre confession de vuln\xe9rabilit\xe9 (pourquoi vous avez besoin d'aide), s\xe9lectionnez ce qu'il vous faut (Zollars ou Capital), puis envoyez. Le pr\xeateur d\xe9couvre votre aveu et d\xe9cide si votre fragilit\xe9 m\xe9rite sa confiance.
        `,
                    'predatoryLendButton': `
          <h3>CDO Z-Payday (Obligation de D\xe9sir Collat\xe9ralis\xe9e)</h3>
          <strong>L'exploitation grim\xe9e en lien humain.</strong>
          <br><br>
          <strong>Description&nbsp;:</strong><br>
          L'empathie et le soulagement se muent en instruments de d\xe9pendance toxique. Les pr\xeats Z-Payday prosp\xe8rent sur le besoin et la cupidit\xe9, convertissant la vuln\xe9rabilit\xe9 en rendement \u{2014} au d\xe9triment de la valeur humaine et de l'\xe9quilibre du syst\xe8me.
          <br><br>
          Chaque cycle de pr\xeat \xe9l\xe8ve le pr\xeateur, \xe9puise l'emprunteur, et laisse au march\xe9 le soin d'absorber la contagion.
          <br><br>
          <strong>Fonction&nbsp;:</strong><br>
          Des gestes d'entraide isol\xe9s deviennent un contrat r\xe9p\xe9titif \u{2014} chaque minute, une nouvelle obligation est \xe9mise, d\xe9coup\xe9e en tranches qui alimentent le CDO global. Le produit promet l'imm\xe9diatet\xe9, puis convertit le vivant en rendement ; la r\xe9colte provient de ce qui s'use quand la bont\xe9 devient m\xe9canique.
          <br><br>
          <strong>Le CDO Z-Payday ne pardonne pas. Il accumule l'exposition jusqu'\xe0 ce que le registre d\xe9vore le Profit Vital sous-jacent.</strong>
          <br><br>
          <strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          Le pr\xeat pr\xe9dateur, rendu visible. Contrairement aux cr\xe9dits sur salaire traditionnels, cach\xe9s derri\xe8re le jargon juridique, le CDO Z-Payday vous oblige \xe0 regarder en face ce que vous faites : extraire de la valeur de la d\xe9tresse d'autrui, minute apr\xe8s minute.
          <br><br>
          Question pos\xe9e&nbsp;: <em>Jusqu'o\xf9 irez-vous pour le profit ? Pouvez-vous regarder quelqu'un s'\xe9puiser \xe0 vous rembourser ? Est-ce du business, ou de la cruaut\xe9 ?</em>
          <br><br>
          Le Profit Vital de la victime d\xe9cro\xeet chaque minute, transf\xe9r\xe9 vers vous. Le syst\xe8me tout entier supporte le co\xfbt \xe9motionnel collectif \u{2014} tout le monde ressent l'exploitation.
          <br><br>
          <strong>Utilisation&nbsp;:</strong><br>
          Cliquez sur \xab \xc9mettre un CDO Z-Payday \xbb, d\xe9signez une victime, fixez le montant \xe0 siphonner par minute, puis confirmez. Chaque minute, son Profit Vital diminue et se transf\xe8re vers vous \u{2014} jusqu'\xe0 ce qu'elle solde la dette ou s'effondre.
          <br><br>
          <strong>Avertissement&nbsp;:</strong> Cette action entra\xeene de lourdes cons\xe9quences sociales et \xe9motionnelles. Les autres le sauront. Le march\xe9 le saura. Votre culpabilit\xe9 s'accumule.
        `,
                    'requestHandoutButton': `
          <h3>Note V (Note de Vuln\xe9rabilit\xe9)</h3>
          <strong>Oser avouer sa fragilit\xe9.</strong>
          <br><br>
          <strong>Description&nbsp;:</strong><br>
          Demander, c'est s'exposer \u{2014} risquer le petit effondrement qui accompagne le fait d'\xeatre vu dans le besoin. La vuln\xe9rabilit\xe9 n'est pas ici faiblesse, mais invitation : un signal que l'\xe9quilibre s'est rompu et qu'il faut une relation pour le restaurer.
          <br><br>
          L'aide, si elle est accord\xe9e, devient un instant partag\xe9 de recalibrage ; si elle est refus\xe9e, elle marque la fracture silencieuse entre confiance et fiert\xe9.
          <br><br>
          Chaque demande s'inscrit dans l'Indice de Dette \xc9motionnelle \u{2014} non pas une mesure de possession, mais du degr\xe9 auquel nous osons encore d\xe9pendre.
          <br><br>
          <strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          Une requ\xeate justifi\xe9e ; un soulagement conditionn\xe9 \xe0 l'assentiment ; le registre consigne \xe0 la fois l'appel et la r\xe9ponse. Contrairement \xe0 la Note M (pr\xeat formel avec obligation), la Note V est une simple demande \u{2014} sans condition, sans remboursement attendu.
          <br><br>
          Mais demander a son propre prix. Vous devez exposer votre besoin, votre vuln\xe9rabilit\xe9, votre d\xe9pendance. Et la r\xe9ponse \u{2014} acceptation ou rejet \u{2014} fa\xe7onne votre \xe9tat \xe9motionnel et votre confiance envers la communaut\xe9.
          <br><br>
          <em>Pouvez-vous reconna\xeetre avoir besoin d'aide ? Les autres peuvent-ils se permettre de la donner ? Que signifie une aide offerte librement, ou une aide refus\xe9e ?</em>
          <br><br>
          <strong>Utilisation&nbsp;:</strong><br>
          Cliquez sur \xab Note V (Appel \xe0 l'aide) \xbb, expliquez pourquoi vous avez besoin d'aide (votre d\xe9claration de vuln\xe9rabilit\xe9), choisissez ce que vous demandez (Zollars ou Capital), puis envoyez \xe0 un autre trader. Il peut accepter (vous donner ce que vous avez demand\xe9) ou d\xe9cliner (vous laisser vous d\xe9brouiller). Dans les deux cas, l'impact \xe9motionnel est enregistr\xe9.
        `,
                    'giveDeletePortfolioButton': `
          <h3>Attribuer le d\xe9clencheur d'Assaut communiste</h3>
          <strong>Description&nbsp;:</strong><br>
          Conf\xe9rez le bouton \xab Assaut communiste \xbb \xe0 un trader, lui donnant le pouvoir de saisir et redistribuer l'int\xe9gralit\xe9 de la richesse d'un portefeuille au collectif.
          <br><br><strong>Comment faire&nbsp;:</strong><br>
          S\xe9lectionnez un trader parmi les participants actifs et attribuez-lui le d\xe9clencheur.
          <br><br><strong>Fonctionnalit\xe9&nbsp;:</strong><br>
          La richesse de la cible (capital, actions, marchandises, etc.) est r\xe9partie \xe9quitablement entre les participants actifs. Personne ne s'enrichit d\xe9mesur\xe9ment : le b\xe9n\xe9fice est communautaire.
          <br><br><strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          Cette action incarne la redistribution radicale, testant l'\xe9quit\xe9 de la confiscation au nom du bien commun. Elle vise \xe0 niveler les disparit\xe9s, mais soul\xe8ve des questions \xe9thiques sur le droit de propri\xe9t\xe9 et la moralit\xe9 de la redistribution forc\xe9e. Attribuer ce bouton, c'est donner le pouvoir d'\xe9quilibrer \u{2014} ou de bouleverser \u{2014} le march\xe9.
          <br><br><strong>Exemple d'usage&nbsp;:</strong><br>
          Un trader remarque qu'un autre accumule des actifs pr\xe9cieux, cr\xe9ant un d\xe9s\xe9quilibre. Gr\xe2ce \xe0 l'\xab Assaut communiste \xbb, il redistribue la richesse, \xe9galisant les ressources \u{2014} mais risquant d'ali\xe9ner l'accumulateur et certains observateurs.
        `,
                    'giveLBOButton': `
          <h3>Attribuer le d\xe9clencheur<br>LBO capitaliste</h3>
          <strong>Description&nbsp;:</strong><br>
          Conf\xe9rez le bouton \xab LBO capitaliste \xbb \xe0 un trader, lui donnant le pouvoir d'acqu\xe9rir agressivement les actifs d'un autre portefeuille par rachat \xe0 effet de levier.
          <br><br><strong>Comment faire&nbsp;:</strong><br>
          S\xe9lectionnez un trader parmi les participants actifs et attribuez-lui le d\xe9clencheur.
          <br><br><strong>Fonctionnalit\xe9&nbsp;:</strong><br>
          L'acqu\xe9reur prend le contr\xf4le total du portefeuille cible (marchandises, actions, etc.) moyennant un co\xfbt \xe9lev\xe9.
          <br>
          La transaction est coercitive mais compensatoire : la cible re\xe7oit un paiement pour ses actifs, l'initiateur paie une prime.
          <br><br><strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          Le \xab LBO capitaliste \xbb incarne le pouvoir de la richesse \xe0 outrepasser l'autonomie, r\xe9v\xe9lant les dynamiques du capitalisme agressif. Il questionne l'\xe9quilibre entre concurrence loyale et exploitation, montrant comment la puissance financi\xe8re peut dicter le contr\xf4le du march\xe9.
          <br><br><strong>Exemple d'usage&nbsp;:</strong><br>
          Un trader rep\xe8re un petit portefeuille aux actifs sous-exploit\xe9s. Gr\xe2ce au \xab LBO capitaliste \xbb, il paie une prime pour s'en emparer, consolidant son pouvoir \u{2014} mais s'exposant \xe0 un retour de b\xe2ton pour ses tactiques hostiles.
        `,
                    'giveSubsidyButton': `
          <h3>Attribuer le d\xe9clencheur<br>Subvention socialiste</h3>
          <strong>Description&nbsp;:</strong><br>
          Conf\xe9rez le bouton \xab Subvention socialiste \xbb \xe0 un trader, lui permettant de ponctionner un portefeuille riche et d'en redistribuer les ressources aux moins nantis.
          <br><br><strong>Comment faire&nbsp;:</strong><br>
          S\xe9lectionnez un trader parmi les participants actifs et attribuez-lui le d\xe9clencheur.
          <br><br><strong>Fonctionnalit\xe9&nbsp;:</strong><br>
          50 % de la richesse du portefeuille cible est tax\xe9e et redistribu\xe9e proportionnellement aux traders les moins dot\xe9s, afin de r\xe9\xe9quilibrer le march\xe9.<br>
          Cette m\xe9canique nivelle les disparit\xe9s, mais peut aussi p\xe9naliser le succ\xe8s, alimentant le d\xe9bat sur l'\xe9quit\xe9 et la justice.
          <br><br><strong>Aper\xe7u conceptuel&nbsp;:</strong><br>
          La \xab Subvention socialiste \xbb cristallise la tension entre soutenir le bien-\xeatre collectif et brider l'ambition. En redistribuant la richesse, elle r\xe9v\xe8le la difficult\xe9 de traiter l'in\xe9galit\xe9 sans \xe9touffer l'innovation ou la croissance.
          <br><br><strong>Exemple d'usage&nbsp;:</strong><br>
          Un trader remarque un portefeuille exc\xe9dentaire alors que d'autres peinent. Gr\xe2ce \xe0 la \xab Subvention socialiste \xbb, il taxe le riche et redistribue aux plus modestes, insufflant un nouvel \xe9lan au march\xe9 et promouvant l'\xe9quit\xe9.
        `,
                    'createCommunityButton': `
          <h3>D\xe9clencheur de<br>Dark Pool</h3>
          <strong>Description&nbsp;:</strong><br>
          Cr\xe9e un espace de march\xe9 priv\xe9, invisible pour le reste de l\u{2019}\xe9change public.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la banni\xe8re \xab Dark Pool \xbb.</li>
            <li>S\xe9lectionnez les traders \xe0 inviter.</li>
            <li>S\u{2019}ils acceptent, vous disposez de 10 minutes d\u{2019}\xe9changes priv\xe9s.</li>
            <li>Chacun peut quitter le pool \xe0 tout moment et revenir au march\xe9 public.</li>
          </ul>
          <br>
          <strong>Plus d\u{2019}infos & d\xe9fi \xe9thique&nbsp;:</strong><br>
          Les dark pools sont l\u{2019}\xe9quivalent boursier d\u{2019}une communaut\xe9 ferm\xe9e : \xe0 l\u{2019}abri des regards, les participants peuvent librement fixer la \xab valeur \xbb. Coop\xe9ration honn\xeate ou manipulation ? Le secret nuit-il \xe0 la transparence ?
          <br><br>
          <strong>Exemple d\u{2019}usage&nbsp;:</strong><br>
          Vous et vos alli\xe9s n\xe9gociez discr\xe8tement des obligations \xe0 un prix avantageux. Gain strat\xe9gique\u{2026} mais la communaut\xe9, une fois inform\xe9e, se sentira-t-elle l\xe9s\xe9e ?
        `,
                    'goToMarketBtn': "Acc\xe9der au march\xe9 principal.",
                    'goToDarkPoolMarketBtn': "Acc\xe9der aux Dark Pools priv\xe9s.",
                    'emotional-debt-banner': `
          <h3>Indice de Dette \xc9motionnelle</h3>
          <strong>La circulation des \xe9motions humaines</strong>
          <br><br>
          D\xe9couvrir la valeur de la vuln\xe9rabilit\xe9 \xe0 travers la dette \xe9motionnelle. Ici, la valeur ne s'extrait pas : elle se ressent. Chaque geste \u{2014} aide, confiance, abandon, envie \u{2014} laisse une empreinte, un gain ou une perte \xe9motionnelle mesurable, une continuit\xe9. Le Profit Vital est une monnaie de sensation, qui prend la temp\xe9rature de notre \xeatre. Tenir l'autre, se laisser tenir : les formes les plus humaines de levier. La Z\xc9conomie circule \xe0 travers nous.
          <br><br>
          <strong>1. Billet Z Altrauiste</strong><br>
          <em>Valeur de vie altruiste. Pure empathie.</em><br>
          Donner sans rien attendre. Aider quelqu'un, c'est s'impliquer dans la trajectoire de son Profit Vital. Ses hauts et ses bas tirent vos propres profits de vie vers le positif ou le n\xe9gatif. Un pari silencieux : le bien-\xeatre d'autrui pourrait \xe9largir votre propre capacit\xe9 \xe0 ressentir, d\xe9ployer votre empathie. Sans contrepartie.
          <br><br>
          <em>(Code miroir : une transaction qui lie deux registres ; une mise en commun des variances plut\xf4t qu'une simple addition.)</em>
          <br><br>
          <strong>2. Note M (Note Mutuelle)</strong><br>
          <em>Un pr\xeat scell\xe9 par l'aveu.</em><br>
          La Note M engendre du cr\xe9dit \xe0 partir d'un besoin mis \xe0 nu et d'une confiance mesur\xe9e. Valeur n\xe9e du partage de nos imperfections. L'emprunteur expose une faiblesse ; le pr\xeateur accepte le risque, faisant de l'empathie un investissement. Ce qui d\xe9bute comme reconnaissance devient obligation \u{2014} la vuln\xe9rabilit\xe9 se mue en Collat\xe9ral Relationnel Z, les int\xe9r\xeats croissant en attention, reconnaissance et Profit Vital mutuel.
          <br><br>
          <em>(Code miroir : int\xe9r\xeat modul\xe9 par l'\xe9motion ; le temps se dilate au gr\xe9 de l'humeur.)</em>
          <br><br>
          <strong>3. CDO Z-Payday (Obligation Collat\xe9ralis\xe9e du D\xe9sir)</strong><br>
          <em>L'exploitation grim\xe9e en lien humain.</em><br>
          L'empathie et le soulagement se muent en instruments de d\xe9pendance toxique. Les pr\xeats Z-Payday prosp\xe8rent sur le besoin et la cupidit\xe9, convertissant la vuln\xe9rabilit\xe9 en rendement au d\xe9triment de la valeur humaine et de l'\xe9quilibre syst\xe9mique. Chaque cycle \xe9l\xe8ve le pr\xeateur, \xe9puise l'emprunteur, et laisse au march\xe9 le soin d'absorber la contagion.
          <br><br>
          <strong>Fonction :</strong> Des gestes d'entraide isol\xe9s deviennent un contrat r\xe9p\xe9titif \u{2014} chaque minute \xe9met une nouvelle obligation, d\xe9coup\xe9e en tranches qui alimentent le CDO global. Le produit promet l'imm\xe9diatet\xe9, puis convertit le vivant en rendement ; la r\xe9colte provient de ce qui s'use quand la bont\xe9 devient m\xe9canique. Le CDO Z-Payday ne pardonne pas. Il accumule l'exposition jusqu'\xe0 ce que le registre d\xe9vore le Profit Vital sous-jacent.
          <br><br>
          <strong>4. Note V (Note de Vuln\xe9rabilit\xe9)</strong><br>
          <em>Oser avouer sa fragilit\xe9.</em><br>
          Demander, c'est s'exposer \u{2014} risquer le petit effondrement qui accompagne le fait d'\xeatre vu dans le besoin. La vuln\xe9rabilit\xe9 n'est pas ici faiblesse, mais invitation : un signal que l'\xe9quilibre s'est rompu et qu'il faut une relation pour le restaurer. L'aide, si elle est accord\xe9e, devient un instant partag\xe9 de recalibrage ; si elle est refus\xe9e, elle marque la fracture silencieuse entre confiance et fiert\xe9. Chaque demande s'inscrit dans l'Indice de Dette \xc9motionnelle \u{2014} non pas une mesure de possession, mais du degr\xe9 auquel nous osons encore d\xe9pendre.
          <br><br>
          <em>(Code miroir : requ\xeate justifi\xe9e ; soulagement conditionn\xe9 \xe0 l'assentiment ; le registre consigne \xe0 la fois l'appel et la r\xe9ponse.)</em>
          <br><br>
          <strong>Note finale</strong><br>
          Ce qui circule ici n'est pas la finance, mais la reconnaissance. La vuln\xe9rabilit\xe9 devient \xe0 la fois miroir et march\xe9, o\xf9 chaque profit est l'\xe9cho du risque d'autrui, chaque dette une m\xe9moire qui refuse de s'effacer.
          <br><br>
          <h3>Indice de Dette \xc9motionnelle</h3>
          Tout commence par la reconnaissance que la vie accumul\xe9e a un poids \u{2014} que le simple fait de vivre avec les autres engendre une dette \xe9motionnelle, positive ou n\xe9gative, reconnue ou n\xe9glig\xe9e, que nous portons seuls et \xe9changeons ensemble. La dette non comme d\xe9ficit, mais comme acceptation : un instrument des effets de notre intrication mutuelle. Dans la Z\xc9conomie, la Dette \xc9motionnelle est le contrepoint de la productivit\xe9 \u{2014} elle ne suit pas ce qui est produit, mais ce qui est ressenti. Chaque geste, chaque h\xe9sitation, chaque confession ou retrait modifie le registre \xe9motionnel. Ses mouvements traduisent la circulation de l'affect \xe0 travers un syst\xe8me vivant et poreux, o\xf9 la valeur n'est ni extraite ni fabriqu\xe9e, mais engendr\xe9e par l'exp\xe9rience m\xeame de la vie. Les Profits Vitaux, flux qui r\xe9sistent \xe0 l'accumulation, fa\xe7onnent pourtant tout ce qui s'y construit.
          <br><br>
          L'Indice de Dette \xc9motionnelle rend visible la vuln\xe9rabilit\xe9 intime, cartographiant les \xe9conomies invisibles de confiance, d'\xe9puisement, de g\xe9n\xe9rosit\xe9, d'\xe9chec, de d\xe9pendance\u{2026} qui participent \xe0 une instabilit\xe9 ou un \xe9quilibre collectifs. Rejeter la fantaisie du capital ; embrasser la liquidit\xe9 du sentiment humain.
        `
                },
                redeem: {
                    "explanations": "Explications",
                    "redeemAsks": "Demandes de rachat",
                    "redeemableHoldings": "Avoirs rachetables :",
                    "sendRedeemAsks": "Envoyer les demandes de rachat",
                    "returnToMarket": "Retour au march\xe9",
                    "tutsTitle": "Comment fonctionne le rachat",
                    "Item_Name": "Nom du bien",
                    "Owner": "Propri\xe9taire",
                    "Capital": "Capital",
                    "no_selected_items_to_check": "Aucun objet s\xe9lectionn\xe9 \xe0 v\xe9rifier.",
                    "select_target_items": "S\xe9lectionnez les objets \xe0 cibler.",
                    "select_item_to_redeem": "S\xe9lectionnez un objet pour la conversion.",
                    "time_remaining": "Temps restant",
                    "second": "seconde",
                    "seconds": "secondes",
                    "Redemption_offer_accepted": "Offre de conversion accept\xe9e pour le bien :",
                    "Redemption_offer_declined": "Offre de conversion rejet\xe9e pour le bien :",
                    "Waiting_for_response": "En attente de r\xe9ponse...",
                    "DO_NOT_LEAVE": "NE PAS QUITTER LA PAGE",
                    "video_not_supported": "La lecture vid\xe9o n\u2019est pas prise en charge par ce navigateur."
                },
                "common": {
                    "close": "Fermer",
                    "assign": "Assigner",
                    "unassign": "D\xe9sassigner",
                    "delete": "Supprimer",
                    "redeem": "\xc9changer",
                    "unredeem": "Annuler l'\xe9change",
                    "yes": "Oui",
                    "no": "Non",
                    "assigned_to": "assign\xe9 \xe0",
                    "to_market": "au march\xe9",
                    "to_portfolio": "au portefeuille",
                    "successfully": "avec succ\xe8s",
                    "login_required": "Vous devez \xeatre connect\xe9 pour effectuer cette action.",
                    "bond_with_interest_rate": "obligation avec taux d'int\xe9r\xeat",
                    "assign_to_portfolio": "Assigner au Portefeuille",
                    "assign_to_market": "Assigner au March\xe9",
                    "item_name": "Nom de l'objet :",
                    "owner": "Propri\xe9taire :",
                    "trader_name": "Nom du Trader :",
                    "password": "Mot de passe :",
                    "connected": "Connect\xe9 :",
                    "portfolio_id": "ID du Portefeuille :",
                    "points_breakdown": "R\xe9partition des capitaux :",
                    "trading": "Trading",
                    "commodities": "Marchandises",
                    "stocks": "Actions",
                    "shorts": "Positions courtes",
                    "total": "Total :",
                    "holdings": "Avoirs :",
                    "commodity": "Marchandise :",
                    "stock": "Action :",
                    "quantity": "Quantit\xe9",
                    "shares": "Parts",
                    "value": "Valeur",
                    "no_holdings": "Aucun avoir dans ce portefeuille.",
                    "unnamed_portfolio": "Portefeuille sans nom",
                    "protected": "[prot\xe9g\xe9]",
                    "qr_code": "Code QR :",
                    "qr_code_for": "Code QR pour",
                    "no_qr_available": "Aucun code QR disponible.",
                    "custom_relationship_type": "Type de relation personnalis\xe9",
                    "remove": "Supprimer",
                    "created_for_relationship": "Zollar cr\xe9\xe9 pour la relation :",
                    "value_place_relationship": "La valeur que vous placez sur une relation :",
                    "na": "N/D"
                },
                "freeend": {
                    "title": "Session de Trading Termin\xe9e",
                    "trading_analysis": "ANALYSE DE TRADING",
                    "social_standing": "Position Sociale",
                    "return_home": "Retour \xe0 l'Accueil",
                    "panels": {
                        "stocks": "ACTIONS",
                        "items": "OBJETS",
                        "zollars": "ZOLLARS",
                        "bonds": "OBLIGATIONS"
                    },
                    "judgements": {
                        "performance": "Performance",
                        "style": "Style",
                        "social": "Social",
                        "risk": "Risque",
                        "mood": "Humeur"
                    },
                    "ratings": {
                        "excellent": "Excellent",
                        "good": "Bien",
                        "fair": "Moyen",
                        "poor": "M\xe9diocre",
                        "bad": "Mauvais",
                        "neutral": "Neutre",
                        "aggressive": "Agressif",
                        "calm": "Calme",
                        "balanced": "\xc9quilibr\xe9",
                        "active": "Actif",
                        "quiet": "Discret",
                        "moderate": "Mod\xe9r\xe9",
                        "diverse": "Diversifi\xe9",
                        "cautious": "Prudent",
                        "focused": "Cibl\xe9",
                        "euphoric": "Euphorique",
                        "optimistic": "Optimiste",
                        "positive": "Positif",
                        "anxious": "Anxieux",
                        "distressed": "En d\xe9tresse"
                    },
                    "sections": {
                        "social_class_movement": "VOTRE \xc9VOLUTION DE CLASSE SOCIALE",
                        "mood_state": "\xc9TAT D'HUMEUR",
                        "trading_behavior": "COMPORTEMENTS DE TRADING",
                        "commodities_supply": "APPROVISIONNEMENT EN COMMODIT\xc9S"
                    },
                    "labels": {
                        "commodities": "Commodit\xe9s:",
                        "no_commodities": "Aucune commodit\xe9 d\xe9tenue - concentration sur d'autres formes de valeur",
                        "stocks": "G\xe9n\xe9rateurs de Profits (Actions):",
                        "bonds": "Obligations:",
                        "zollar_holdings": "Avoirs en Zollars Relationnels:",
                        "total": "Total:",
                        "session_engagement": "Engagement de Session:",
                        "social_connections": "Connexions Sociales:",
                        "value_movement": "Mouvement de Valeur:"
                    },
                    "value_movement": {
                        "significant_gain": "Gain Significatif",
                        "strong_gain": "Gain Fort",
                        "moderate_gain": "Gain Mod\xe9r\xe9",
                        "slight_gain": "Gain L\xe9ger",
                        "no_change": "Aucun Changement",
                        "slight_loss": "Perte L\xe9g\xe8re",
                        "moderate_loss": "Perte Mod\xe9r\xe9e",
                        "strong_loss": "Perte Forte",
                        "significant_loss": "Perte Significative"
                    },
                    "activity_levels": {
                        "contemplative": "Contemplatif",
                        "measured": "Mesur\xe9",
                        "active": "Actif",
                        "very_active": "Tr\xe8s Actif",
                        "intensely_engaged": "Intens\xe9ment Engag\xe9"
                    },
                    "social_levels": {
                        "solitary": "Solitaire",
                        "selective": "S\xe9lectif",
                        "socially_active": "Socialement Actif",
                        "highly_connected": "Tr\xe8s Connect\xe9"
                    },
                    "emotional_states": {
                        "balanced": "\xc9quilibr\xe9",
                        "triumphant": "Triomphant",
                        "reflective": "R\xe9fl\xe9chi",
                        "socially_engaged": "Socialement Engag\xe9",
                        "energetically_active": "\xc9nergiquement Actif"
                    },
                    "quantities": {
                        "none": "Aucun",
                        "a_few": "Quelques-uns",
                        "some": "Certains",
                        "several": "Plusieurs",
                        "many": "Beaucoup",
                        "quite_a_lot": "Pas Mal",
                        "a_large_amount": "Une Grande Quantit\xe9",
                        "a_huge_amount": "Une \xc9norme Quantit\xe9"
                    }
                }
            }
        }
    }
};
var $0cb39f7c2a1e3ebc$export$2e2bcd8739ae039 = $0cb39f7c2a1e3ebc$var$translations;

});


parcelRegister("86ioh", function(module, exports) {

$parcel$export(module.exports, "showItemReceivedNotification", () => $5e5d264206c87423$export$671595af69028742);
$parcel$export(module.exports, "showOfferSentPopup", () => $5e5d264206c87423$export$f96bc44d9ad77c90);
$parcel$export(module.exports, "showOfferPopup", () => $5e5d264206c87423$export$48ca6cbcb2b01599);
$parcel$export(module.exports, "acceptTrade", () => $5e5d264206c87423$export$c9d68d666177c59c);
$parcel$export(module.exports, "showReceiveBuyOfferPopup", () => $5e5d264206c87423$export$54641e155c9500d5);
$parcel$export(module.exports, "handleRejectBuyOffer", () => $5e5d264206c87423$export$5bc1b41b6ea3d1d5);
$parcel$export(module.exports, "showSocialTradeReceived", () => $5e5d264206c87423$export$e6bbcc1b0179915c);
$parcel$export(module.exports, "showSocialTradeResponse", () => $5e5d264206c87423$export$e8b9a359288bb90c);
$parcel$export(module.exports, "handleBuyOfferAcceptedByOther", () => $5e5d264206c87423$export$e696bf2320418566);
//offer.js

var $cNeIB = parcelRequire("cNeIB");

var $fUPn2 = parcelRequire("fUPn2");

var $eD3DY = parcelRequire("eD3DY");
parcelRequire("21EbS");
const $5e5d264206c87423$var$tr = (0, $fUPn2.t);
function $5e5d264206c87423$var$getPortfolioId() {
    return localStorage.getItem('portfolioId');
}
function $5e5d264206c87423$var$unblockUI() {
    // reset body
    document.body.style.overflow = '';
    document.body.style.pointerEvents = '';
    // nuke any stray overlays/popups we create
    [
        'offerSentOverlay',
        'offerSentPopup',
        'tradeOfferPopup',
        'popup-container',
        'social-trade-dialog'
    ].forEach((id)=>{
        const el = document.getElementById(id);
        if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    // belt + suspenders: remove any full-screen divs we created with huge z-index
    [
        ...document.querySelectorAll('div')
    ].filter((el)=>{
        const s = getComputedStyle(el);
        return (socket.position === 'fixed' || s.position === 'absolute') && parseInt(s.zIndex || '0', 10) >= 9999 && (el.id || '').includes('overlay');
    }).forEach((el)=>el.parentNode && el.parentNode.removeChild(el));
}
window.forceUnblockUI = $5e5d264206c87423$var$unblockUI; // handy for debugging in console
function $5e5d264206c87423$export$671595af69028742(giverName, itemName) {
    const message = (0, $fUPn2.t)('offer.item_received', 'You received {item} from {giver}!').replace('{item}', itemName).replace('{giver}', giverName);
    (0, $eD3DY.showNotification)(message, true);
}
function $5e5d264206c87423$export$f96bc44d9ad77c90(portfolioId, knownItemIdsAtPageLoad) {
    // Guard: only show if an offer was just sent (flag set by your send flow)
    if (localStorage.getItem('pendingOffer') !== 'true') return;
    // Prevent duplicates if somehow called twice
    if (document.getElementById('offerSentPopup')) return;
    // --- Overlay & popup
    const overlay = document.createElement('div');
    overlay.id = 'offerSentOverlay'; // ADD ID so it can be cleaned up externally
    overlay.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10000; justify-content: center; align-items: center; display: flex;";
    document.body.appendChild(overlay);
    const popup = document.createElement('div');
    popup.id = 'offerSentPopup';
    popup.style = "position: relative; width:100%; max-width: 100%; height: 100%; max-height: 100%; padding: 20px; border-radius: 0px; border: 2px solid #00ff00; color: #00ff00; font-family: 'bithigh', sans-serif; text-align: center; z-index: 10001; overflow: hidden; display: flex; justify-content: center; align-items: center;";
    overlay.appendChild(popup);
    if (window.popupTracker) window.popupTracker.trackElement(popup, 'offer-sent');
    // --- Background video container
    const videoContainer = document.createElement('div');
    videoContainer.style = "position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: -1;";
    popup.appendChild(videoContainer);
    // --- Content
    const content = document.createElement('div');
    content.style = "position: relative; z-index: 1; padding: 20px; background-color: rgba(1, 32, 59, 0.7); border-radius: 3px; max-width: 80%;";
    content.innerHTML = `
	<h2>${(0, $fUPn2.t)('offer.offer_sent', 'Offer Sent')} <br><br> ${(0, $fUPn2.t)('offer.do_not_leave_page', 'DO NOT LEAVE PAGE.')} <br><br></h2>
	<p>${(0, $fUPn2.t)('offer.awaiting_response', 'Awaiting response. Please wait...')}</p>
	<p id="offerSentTimerText"></p>
  `;
    popup.appendChild(content);
    // Initialize timer line as PLAIN TEXT (no inner HTML templating)
    const timerP = content.querySelector('#offerSentTimerText');
    const timerLine = (sec)=>(0, $fUPn2.t)('offer.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', String(sec));
    timerP.textContent = timerLine(10);
    // --- Background HLS (with robust fallback)
    const videoBaseUrl = `${(0, $cNeIB.apiBaseUrl)}/uploads/specialBacks/itemTrade/`;
    const totalVideos = 10;
    let currentVideoIndex = 0;
    let hlsInstance = null;
    let videoInterval = null;
    let interval = null;
    let isCleanedUp = false; // ADD FLAG to prevent duplicate cleanup
    function loadRandomVideo() {
        currentVideoIndex = Math.floor(Math.random() * totalVideos) + 1;
        loadVideo();
    }
    function loadVideo() {
        if (!document.body.contains(overlay)) return; // already closed
        const videoUrl = `${videoBaseUrl}${currentVideoIndex}/playlist.m3u8`;
        const video = document.createElement('video');
        video.style = "position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; pointer-events: none; z-index: -1;";
        video.setAttribute('playsinline', 'true');
        video.setAttribute('webkit-playsinline', 'true');
        video.setAttribute('muted', 'true');
        video.setAttribute('autoplay', 'true');
        video.setAttribute('loop', 'true');
        video.setAttribute('controls', 'false');
        video.setAttribute('disablePictureInPicture', 'true');
        video.setAttribute('controlsList', 'nodownload nofullscreen noremoteplaybook');
        video.setAttribute('x-webkit-airplay', 'deny');
        video.setAttribute('preload', 'metadata');
        video.muted = true;
        video.controls = false;
        video.playsInline = true;
        video.tabIndex = -1;
        const preventEvent = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            return false;
        };
        [
            'contextmenu',
            'touchstart',
            'touchend',
            'touchmove',
            'click',
            'dblclick',
            'mousedown',
            'mouseup',
            'mousemove',
            'focus',
            'blur'
        ].forEach((ev)=>{
            video.addEventListener(ev, preventEvent, {
                passive: false
            });
        });
        [
            'webkitfullscreenchange',
            'fullscreenchange',
            'webkitbeginfullscreen',
            'webkitendfullscreen'
        ].forEach((ev)=>{
            video.addEventListener(ev, preventEvent);
        });
        // Tear down any existing HLS instance
        if (hlsInstance) {
            try {
                hlsInstance.destroy();
            } catch  {}
            hlsInstance = null;
        }
        if (window.Hls && Hls.isSupported()) {
            hlsInstance = new Hls();
            hlsInstance.loadSource(videoUrl);
            hlsInstance.attachMedia(video);
            hlsInstance.on(Hls.Events.MANIFEST_PARSED, ()=>video.play().catch(()=>{}));
            hlsInstance.on(Hls.Events.ERROR, (event, data)=>{
                console.error('HLS error:', data);
                if (data?.fatal) loadRandomVideo();
            });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = videoUrl;
            video.addEventListener('loadedmetadata', ()=>video.play().catch(()=>{}));
            video.addEventListener('error', ()=>loadRandomVideo());
        }
        videoContainer.innerHTML = '';
        videoContainer.appendChild(video);
    }
    loadRandomVideo();
    videoInterval = setInterval(loadRandomVideo, 10000);
    // --- Countdown (UI-only)
    let timeLeft = 10;
    function cleanup() {
        if (isCleanedUp) return;
        isCleanedUp = true;
        try {
            if (interval) clearInterval(interval);
        } catch  {}
        try {
            if (videoInterval) clearInterval(videoInterval);
        } catch  {}
        try {
            if (hlsInstance) hlsInstance.destroy();
        } catch  {}
        hlsInstance = null;
        interval = null;
        videoInterval = null;
        localStorage.removeItem('pendingOffer');
        // Unregister popups from popupTracker before removing
        if (window.popupTracker) try {
            window.popupTracker.unregisterPopup('offerSentPopup');
            window.popupTracker.unregisterPopup('offerSentOverlay');
        } catch (e) {
            console.warn('Error unregistering popups:', e);
        }
        if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
        const overlayById = document.getElementById('offerSentOverlay');
        if (overlayById && overlayById.parentNode) overlayById.parentNode.removeChild(overlayById);
        const popupById = document.getElementById('offerSentPopup');
        if (popupById && popupById.parentNode) popupById.parentNode.removeChild(popupById);
        // Navigate away after cleanup — back to the 3D floor if that is where the
        // swap was started from (it sets zxReturnTo), otherwise the classic page.
        // zxReturnTo is CONSUMED by whoever reads it first, and on this page
        // zxTakeReturn() is racing us. Falling through to the hardcoded 'trader.html'
        // is how a floor user ends up stranded on the classic page. goTrade() also
        // mirrors the destination into sessionStorage, which nothing consumes — so
        // check that before giving up.
        // zxHome last before the hardcoded default: zfloor.js stamps it on every load,
        // so a tab that has been on the floor goes back to the floor even when both
        // zxReturnTo copies are gone (consumed by whichever reader won the race).
        // That fallthrough to 'trader.html' is how a floor user still ended up in the
        // classic system after a completed swap.
        setTimeout(()=>{
            if (location.pathname.endsWith('/transaction.html')) {
                const target = localStorage.getItem('zxReturnTo');
                if (target) localStorage.removeItem('zxReturnTo');
                let mirrored = null, home = null;
                try {
                    mirrored = sessionStorage.getItem('zxReturnTo');
                } catch (_) {}
                try {
                    home = sessionStorage.getItem('zxHome');
                } catch (_) {}
                // The classic pages are abandoned: a user forwarded there is locked in
                // (their graphics live on the floor now). The floor is the only default.
                window.location.href = target || mirrored || home || 'zfloor.html';
            }
        }, 100);
    }
    // Make cleanup accessible globally for external calls
    window.cleanupOfferSentPopup = cleanup;
    window.handleOfferAccepted = ()=>{
        cleanup();
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.offer_accepted', 'Offer accepted!'), true);
    };
    window.handleOfferDeclined = ()=>{
        cleanup();
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.offer_declined', 'Offer declined.'), false);
    };
    // Ensure fast unload → no lag on trader.js
    const onPageHide = ()=>cleanup();
    const onBeforeUnload = ()=>cleanup();
    const onVis = ()=>{
        if (document.hidden) cleanup();
    };
    window.addEventListener('pagehide', onPageHide, {
        once: true
    });
    window.addEventListener('beforeunload', onBeforeUnload, {
        once: true
    });
    document.addEventListener('visibilitychange', onVis, {
        once: true
    });
    interval = setInterval(()=>{
        if (isCleanedUp) return; // Stop if already cleaned up
        timeLeft -= 1;
        if (timeLeft < 0) timeLeft = 0;
        if (document.body.contains(overlay) && timerP) timerP.textContent = timerLine(timeLeft);
        if (timeLeft === 0) {
            // Store notification for display after redirect to trader.html
            const msg = (0, $fUPn2.t)('offer.still_waiting', "Still waiting for a response\u2026");
            try {
                localStorage.setItem('pendingNotification', JSON.stringify({
                    message: msg,
                    success: false,
                    ts: Date.now()
                }));
            } catch (_) {}
            cleanup();
        }
    }, 1000);
}
function $5e5d264206c87423$export$48ca6cbcb2b01599(offerData, portfolioId, timeoutDuration = 10000) {
    try {
        window.__removeWaitingPopup?.();
    } catch  {}
    document.getElementById('waitingPopup')?.remove();
    console.log('Attempting to show offer popup:', offerData);
    if (!offerData) return;
    // Clean up any previous trade session when a new offer arrives
    const currentActiveSession = localStorage.getItem('activeTradeSession');
    if (currentActiveSession) {
        console.log('Clearing previous trade session:', currentActiveSession);
        localStorage.setItem(`${currentActiveSession}_active`, 'false');
        localStorage.removeItem(`${currentActiveSession}_offerData`);
        localStorage.removeItem(`${currentActiveSession}_expiryTime`);
    }
    const tradeSessionId = `trade_${offerData.offeredItemId}_${offerData.transactionItemId}_${Date.now()}`;
    localStorage.setItem('activeTradeSession', tradeSessionId);
    localStorage.setItem(`${tradeSessionId}_active`, 'true');
    localStorage.setItem(`${tradeSessionId}_offerData`, JSON.stringify(offerData));
    let tradeActive = true;
    let timerInterval = null;
    // Remove existing popup if present
    const old = document.getElementById('tradeOfferPopup');
    if (old) old.remove();
    const popup = document.createElement('div');
    popup.id = 'tradeOfferPopup';
    popup.style = `
	position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 9999;
	font-family: 'bithigh', Arial, sans-serif; color: #00ff00; overflow-y: auto; overflow-x: hidden;
	-webkit-overflow-scrolling: touch; padding: env(safe-area-inset-top,0) env(safe-area-inset-right,0) env(safe-area-inset-bottom,0) env(safe-area-inset-left,0);
  `;
    document.body.appendChild(popup);
    document.body.style.overflow = 'hidden';
    if (window.popupTracker) window.popupTracker.trackElement(popup, 'trade-offer');
    // Background video
    const video = document.createElement('video');
    video.id = 'offerPopupBackground';
    video.style = `
	position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; object-fit: cover; z-index: -1; pointer-events: none; background:#000;
  `;
    [
        'playsinline',
        'webkit-playsinline',
        'muted',
        'autoplay',
        'loop',
        'controls',
        'disablePictureInPicture',
        'preload',
        'x-webkit-airplay'
    ].forEach((attr)=>video.setAttribute(attr, attr === 'controls' ? 'false' : attr === 'preload' ? 'metadata' : 'true'));
    video.muted = true;
    video.controls = false;
    video.playsInline = true;
    video.tabIndex = -1;
    const preventEvent = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        return false;
    };
    [
        'contextmenu',
        'touchstart',
        'touchend',
        'touchmove',
        'click',
        'dblclick',
        'mousedown',
        'mouseup',
        'mousemove',
        'focus',
        'blur'
    ].forEach((ev)=>video.addEventListener(ev, preventEvent, {
            passive: false
        }));
    [
        'webkitfullscreenchange',
        'fullscreenchange',
        'webkitbeginfullscreen',
        'webkitendfullscreen'
    ].forEach((ev)=>video.addEventListener(ev, preventEvent));
    popup.appendChild(video);
    // Story section
    const storySection = offerData.tradeStory && offerData.hasStory ? `
	<div style="background: rgba(0, 255, 0, 0.1); border: 1px solid rgba(0, 255, 0, 0.3); border-radius: 5px; padding: 10px; margin: 15px 0;">
	  <h5 style="margin:0 0 8px 0;color:#00ff00;">${(0, $fUPn2.t)('offer.reason', 'Reason:')}</h5>
	  <p style="margin: 0; font-style: italic; font-size: 0.7em; line-height: 1.3;">"${offerData.tradeStory}"</p>
	</div>
  ` : '';
    const content = document.createElement('div');
    content.style = "position: relative; z-index: 1; min-height: 100vh; display:flex; align-items:center; justify-content:center; padding:20px; box-sizing:border-box;";
    content.innerHTML = `
	<div class="tradeOffPop">
	  <h2>${(0, $fUPn2.t)('offer.trade_offer', 'Trade Offer')}</h2>
	  <p class="zx-sec-explain" style="text-align:left;">${(0, $fUPn2.t)('floor.exp_trade_offer', "A trader is proposing a straight swap: their thing for yours. The floor's bots trade too \u2014 respond exactly as you would to a person.")}</p>
	  <p>${(0, $fUPn2.t)('offer.offers_you', '{initiator} offers you: {offered} in exchange for: {requested}').replace('{initiator}', offerData.initiatorPortfolioName).replace('{offered}', offerData.offeredItemName).replace('{requested}', offerData.transactionItemName)}</p>
	  ${storySection}
	  ${storySection ? `<div style="margin-top: 15px;">
			<button id="respondOffer" style="width: 100%; background: rgba(255, 165, 0, 0.6); color: #000; border: 1px solid #ffaa00; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">
			  ${(0, $fUPn2.t)('offer.respond', 'Respond')}
			</button>
		  </div>` : ''}
	  <div style="display: flex; gap: 10px; margin-top: 15px;">
		<button id="acceptOffer" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000; border: 1px solid #00ff00; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">${(0, $fUPn2.t)('offer.accept', 'Accept')}</button>
		<button id="declineOffer" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff; border: 1px solid #ff0000; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">${(0, $fUPn2.t)('offer.decline', 'Decline')}</button>
	  </div>
	  <div id="timer" style="margin-top:10px;text-align:center;"></div>
	</div>
  `;
    popup.appendChild(content);
    const style = document.createElement('style');
    style.textContent = `
	.tradeOffPop {
	  position: relative !important; transform: none !important; top:auto !important; left:auto !important;
	  width: 90%; max-width: 600px; padding: 20px; background-color: rgba(0, 8, 36, 0.9);
	  border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.5); z-index: 10000;
	  font-family: 'bithigh', Arial, sans-serif; color: #00ff00; text-align: center; margin: 0 auto;
	  box-sizing: border-box; backdrop-filter: blur(5px); -webkit-backdrop-filter: blur(5px);
	}
	@media (max-width: 600px){ .tradeOffPop { width:95%; max-width:95%; padding:15px; margin:10px auto; } }
	@media (max-height: 700px){ .tradeOffPop { margin:10px auto; } }
	.tradeOffPop button { min-height:44px; touch-action:manipulation; -webkit-appearance:none; appearance:none; }
  `;
    document.head.appendChild(style);
    // Load background HLS
    const videoBaseUrl = `${(0, $cNeIB.apiBaseUrl)}/uploads/specialBacks/itemTrade/`;
    const totalVideos = 10;
    const videoIndex = Math.floor(Math.random() * totalVideos) + 1;
    const videoUrl = `${videoBaseUrl}${videoIndex}/playlist.m3u8`;
    if (window.Hls && Hls.isSupported()) {
        const hls = new Hls({
            debug: false,
            enableWorker: false,
            lowLatencyMode: true,
            backBufferLength: 90
        });
        hls.loadSource(videoUrl);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, ()=>video.play().catch(()=>{
                video.style.display = 'none';
            }));
        hls.on(Hls.Events.ERROR, ()=>{
            video.style.display = 'none';
        });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoUrl;
        video.addEventListener('loadedmetadata', ()=>video.play().catch(()=>{
                video.style.display = 'none';
            }));
        video.addEventListener('error', ()=>{
            video.style.display = 'none';
        });
    }
    // Timer
    const timerEl = content.querySelector('#timer');
    let remainingTime = Math.floor(timeoutDuration / 1000);
    localStorage.setItem(`${tradeSessionId}_timerType`, 'initial');
    localStorage.setItem(`${tradeSessionId}_expiryTime`, String(Date.now() + timeoutDuration));
    const renderTime = ()=>{
        if (timerEl) timerEl.textContent = (0, $fUPn2.t)('offer.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', remainingTime);
    };
    renderTime();
    const autoDecline = ()=>{
        console.log('autoDecline called - checking session:', tradeSessionId);
        const sessionActive = localStorage.getItem(`${tradeSessionId}_active`) === 'true';
        const currentActiveSession = localStorage.getItem('activeTradeSession');
        if (!sessionActive || currentActiveSession !== tradeSessionId || !tradeActive) return;
        // lock
        localStorage.setItem(`${tradeSessionId}_active`, 'false');
        tradeActive = false;
        const declineBtn = document.getElementById('declineOffer');
        if (declineBtn) declineBtn.disabled = true;
        $5e5d264206c87423$export$40e1fe1299acaf1b(offerData).then(()=>console.log('Trade successfully auto-declined.')).catch((err)=>console.error('Error auto-declining trade:', err?.message || err)).finally(closePopup);
    };
    timerInterval = setInterval(()=>{
        const sessionActive = localStorage.getItem(`${tradeSessionId}_active`) === 'true';
        const currentActiveSession = localStorage.getItem('activeTradeSession');
        if (!sessionActive || currentActiveSession !== tradeSessionId) {
            clearInterval(timerInterval);
            return;
        }
        const currentTimerType = localStorage.getItem(`${tradeSessionId}_timerType`);
        if (currentTimerType === 'extended') {
            clearInterval(timerInterval);
            return;
        }
        remainingTime -= 1;
        renderTime();
        if (remainingTime <= 0) {
            clearInterval(timerInterval);
            const stillActive = localStorage.getItem(`${tradeSessionId}_active`) === 'true';
            const stillInitial = localStorage.getItem(`${tradeSessionId}_timerType`) === 'initial';
            if (stillActive && stillInitial && tradeActive) autoDecline();
        }
    }, 1000);
    // Buttons
    const acceptButton = document.getElementById('acceptOffer');
    const declineButton = document.getElementById('declineOffer');
    acceptButton.onclick = async ()=>{
        localStorage.setItem(`${tradeSessionId}_active`, 'false');
        if (timerInterval) clearInterval(timerInterval);
        if (!tradeActive) return;
        tradeActive = false;
        acceptButton.disabled = true;
        try {
            await $5e5d264206c87423$export$c9d68d666177c59c(offerData);
            closePopup();
        } catch (e) {
            console.error('Error accepting trade:', e);
            (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.error_accepting_offer', 'Error accepting offer: {message}').replace('{message}', e.message)}`, false);
            acceptButton.disabled = false;
            tradeActive = true;
            localStorage.setItem(`${tradeSessionId}_active`, 'true');
        }
    };
    declineButton.onclick = async ()=>{
        localStorage.setItem(`${tradeSessionId}_active`, 'false');
        if (timerInterval) clearInterval(timerInterval);
        if (!tradeActive) return;
        tradeActive = false;
        declineButton.disabled = true;
        try {
            await $5e5d264206c87423$export$40e1fe1299acaf1b(offerData);
            closePopup();
        } catch (e) {
            console.error('Error declining trade:', e);
            (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.error_declining_offer', 'Error declining offer: {message}').replace('{message}', e.message)}`, false);
            declineButton.disabled = false;
            tradeActive = true;
            localStorage.setItem(`${tradeSessionId}_active`, 'true');
        }
    };
    // Respond (extends timer 60s and opens narrative dialog)
    if (storySection) {
        const respondButton = document.getElementById('respondOffer');
        respondButton.onclick = ()=>{
            if (!tradeActive) return;
            localStorage.setItem(`${tradeSessionId}_timerType`, 'extended');
            localStorage.setItem(`${tradeSessionId}_expiryTime`, String(Date.now() + 60000));
            if (timerInterval) clearInterval(timerInterval);
            remainingTime = 60;
            renderTime();
            timerInterval = setInterval(()=>{
                const sessionActive = localStorage.getItem(`${tradeSessionId}_active`) === 'true';
                const currentActiveSession = localStorage.getItem('activeTradeSession');
                if (!sessionActive || currentActiveSession !== tradeSessionId || !tradeActive) {
                    clearInterval(timerInterval);
                    return;
                }
                remainingTime -= 1;
                renderTime();
                if (remainingTime <= 0) {
                    clearInterval(timerInterval);
                    if (sessionActive && tradeActive) autoDecline();
                }
            }, 1000);
            const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
            if (s && s.connected) s.emit('extendTradeTimer', {
                offeredItemId: offerData.offeredItemId,
                transactionItemId: offerData.transactionItemId,
                initiatorUserId: offerData.initiatorUserId,
                targetUserId: offerData.targetUserId,
                newDuration: 60000
            });
            $5e5d264206c87423$var$showNarrativeResponseDialog(offerData);
        };
    }
    function closePopup() {
        localStorage.setItem(`${tradeSessionId}_active`, 'false');
        localStorage.removeItem(`${tradeSessionId}_timerType`);
        localStorage.removeItem(`${tradeSessionId}_expiryTime`);
        localStorage.removeItem(`${tradeSessionId}_offerData`);
        if (localStorage.getItem('activeTradeSession') === tradeSessionId) localStorage.removeItem('activeTradeSession');
        tradeActive = false;
        if (timerInterval) clearInterval(timerInterval);
        if (window.currentTradeTimerExtension) delete window.currentTradeTimerExtension;
        const pop = document.getElementById('tradeOfferPopup');
        if (pop) {
            // Unregister from popupTracker before removing
            if (window.popupTracker) window.popupTracker.unregisterPopup('tradeOfferPopup');
            pop.remove();
            document.body.style.overflow = '';
        }
    }
    // Clean up stale sessions
    const allKeys = Object.keys(localStorage);
    const fiveMinutesAgo = Date.now() - 300000;
    allKeys.forEach((key)=>{
        if (key.startsWith('trade_') && key.endsWith('_expiryTime')) {
            const expiryTime = parseInt(localStorage.getItem(key), 10);
            if (!Number.isNaN(expiryTime) && expiryTime < fiveMinutesAgo) {
                const sessionId = key.replace('_expiryTime', '');
                localStorage.removeItem(`${sessionId}_active`);
                localStorage.removeItem(`${sessionId}_timerType`);
                localStorage.removeItem(`${sessionId}_expiryTime`);
            }
        }
    });
}
async function $5e5d264206c87423$export$c9d68d666177c59c(offerData) {
    if (!offerData) throw new Error('Missing offer data');
    return new Promise((resolve, reject)=>{
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        if (!s) return reject(new Error('Socket not available'));
        if (!s.connected) return reject(new Error('Socket is not connected'));
        s.emit('acceptTrade', {
            offeredItemId: offerData.offeredItemId,
            transactionItemId: offerData.transactionItemId,
            initiatorUserId: offerData.initiatorUserId,
            targetUserId: offerData.targetUserId
        }, (response)=>{
            if (response && response.success) {
                console.log('Trade acceptance confirmed by server');
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.offer_accepted', 'Offer accepted!'), true);
                resolve(response);
            } else {
                const errorMsg = response?.error || 'No response from server';
                (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.offer_accept_error', 'Error accepting offer: {message}').replace('{message}', errorMsg)}`, false);
                reject(new Error(errorMsg));
            }
        });
    });
}
async function $5e5d264206c87423$export$40e1fe1299acaf1b(offerData) {
    if (!offerData) throw new Error('Missing offer data');
    return new Promise((resolve, reject)=>{
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        if (!s) return reject(new Error('Socket not available'));
        const missing = [
            'offeredItemId',
            'transactionItemId',
            'initiatorUserId',
            'targetUserId'
        ].filter((k)=>!offerData[k]);
        if (missing.length) return reject(new Error('Incomplete trade data. Missing: ' + missing.join(', ')));
        if (!s.connected) return reject(new Error('Socket is not connected'));
        s.emit('declineTrade', {
            offeredItemId: offerData.offeredItemId,
            transactionItemId: offerData.transactionItemId,
            initiatorUserId: offerData.initiatorUserId,
            targetUserId: offerData.targetUserId
        }, (response)=>{
            if (response?.success) {
                console.log('Trade declination confirmed by server');
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.offer_declined', 'Offer declined.'), false);
                resolve(response);
            } else {
                const errorMsg = response?.error || 'No response from server';
                (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.offer_decline_error', 'Error declining offer: {message}').replace('{message}', errorMsg)}`, false);
                reject(new Error(errorMsg));
            }
        });
    });
}
let $5e5d264206c87423$var$clients = new Map();
function $5e5d264206c87423$export$54641e155c9500d5(data) {
    console.log('Attempting to show buy offer popup:', data);
    if (!data) return;
    // Check if this offer was recently handled (prevent duplicate popups from message replay)
    const offerKey = `buyOffer_handled_${data.itemId}_${data.buyerId}`;
    const handledTime = localStorage.getItem(offerKey);
    if (handledTime && Date.now() - parseInt(handledTime) < 30000) {
        console.log('Skipping buy offer popup - recently handled:', offerKey);
        return;
    }
    // Clean up any previous buy offer session
    const currentBuySession = localStorage.getItem('activeBuyOfferSession');
    if (currentBuySession) {
        console.log('Clearing previous buy offer session:', currentBuySession);
        localStorage.setItem(`${currentBuySession}_active`, 'false');
        localStorage.removeItem(`${currentBuySession}_offerData`);
        localStorage.removeItem(`${currentBuySession}_expiryTime`);
    }
    const buySessionId = `buy_${data.itemId}_${data.buyerId}_${Date.now()}`;
    localStorage.setItem('activeBuyOfferSession', buySessionId);
    localStorage.setItem(`${buySessionId}_active`, 'true');
    localStorage.setItem(`${buySessionId}_offerData`, JSON.stringify(data));
    let offerActive = true;
    let timerInterval = null;
    // Remove existing popup if present
    const old = document.getElementById('buyOfferPopup');
    if (old) old.remove();
    const popup = document.createElement('div');
    popup.id = 'buyOfferPopup';
    popup.style = `
	position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 9999;
	font-family: 'bithigh', Arial, sans-serif; color: #00ff00; overflow-y: auto; overflow-x: hidden;
	-webkit-overflow-scrolling: touch; padding: env(safe-area-inset-top,0) env(safe-area-inset-right,0) env(safe-area-inset-bottom,0) env(safe-area-inset-left,0);
  `;
    document.body.appendChild(popup);
    document.body.style.overflow = 'hidden';
    if (window.popupTracker) window.popupTracker.trackElement(popup, 'buy-offer');
    // Background video
    const video = document.createElement('video');
    video.id = 'buyOfferPopupBackground';
    video.style = `
	position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; object-fit: cover; z-index: -1; pointer-events: none; background:#000;
  `;
    [
        'playsinline',
        'webkit-playsinline',
        'muted',
        'autoplay',
        'loop',
        'controls',
        'disablePictureInPicture',
        'preload',
        'x-webkit-airplay'
    ].forEach((attr)=>video.setAttribute(attr, attr === 'controls' ? 'false' : attr === 'preload' ? 'metadata' : 'true'));
    video.muted = true;
    video.controls = false;
    video.playsInline = true;
    video.tabIndex = -1;
    const preventEvent = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        return false;
    };
    [
        'contextmenu',
        'touchstart',
        'touchend',
        'touchmove',
        'click',
        'dblclick',
        'mousedown',
        'mouseup',
        'mousemove',
        'focus',
        'blur'
    ].forEach((ev)=>video.addEventListener(ev, preventEvent, {
            passive: false
        }));
    [
        'webkitfullscreenchange',
        'fullscreenchange',
        'webkitbeginfullscreen',
        'webkitendfullscreen'
    ].forEach((ev)=>video.addEventListener(ev, preventEvent));
    popup.appendChild(video);
    // Build offer text
    let offerText = '';
    if (data.bidType === 'points') offerText = (0, $fUPn2.t)('offer.buy_offer_points', '{portfolio} offers {amount} points for {item}').replace('{portfolio}', data.portfolioName || 'Someone').replace('{amount}', data.offerAmount).replace('{item}', data.item_name || 'your item');
    else if (data.bidType === 'zollars') offerText = (0, $fUPn2.t)('offer.buy_offer_zollars', '{portfolio} offers zollars for {item}').replace('{portfolio}', data.portfolioName || 'Someone').replace('{item}', data.item_name || 'your item');
    else offerText = `${data.portfolioName || 'Someone'} ${(0, $fUPn2.t)('offer.wants_to_buy', 'wants to buy')} ${data.item_name || 'your item'}`;
    // Show buy reason if provided
    const reasonSection = data.buyReason ? `
	<div style="background: rgba(0, 255, 0, 0.1); border: 1px solid rgba(0, 255, 0, 0.3); border-radius: 5px; padding: 10px; margin: 15px 0;">
	  <h5 style="margin:0 0 8px 0;color:#00ff00;">${(0, $fUPn2.t)('offer.reason', 'Reason:')}</h5>
	  <p style="margin: 0; font-style: italic; font-size: 0.85em; line-height: 1.3;">"${data.buyReason}"</p>
	</div>
  ` : '';
    const content = document.createElement('div');
    content.style = "position: relative; z-index: 1; min-height: 100vh; display:flex; align-items:center; justify-content:center; padding:20px; box-sizing:border-box;";
    content.innerHTML = `
	<div class="buyOfferPop">
	  <h2>${(0, $fUPn2.t)('offer.buy_offer_received', 'Buy Offer Received')}</h2>
	  <p class="zx-sec-explain" style="text-align:left;">${(0, $fUPn2.t)('floor.exp_buy_offer', "Someone wants something you carry and is paying for it. Accept and the payment moves to you, the thing to them; decline and you keep it.")}</p>
	  <p>${offerText}</p>
	  ${reasonSection}
	  ${data.bidType === 'zollars' ? `<div style="margin: 10px 0;">${$5e5d264206c87423$var$displayZollarDetails(data.zollarBid || {})}</div>` : ''}
	  <div style="display: flex; gap: 10px; margin-top: 15px;">
		<button id="acceptBuyOffer" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000; border: 1px solid #00ff00; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">${(0, $fUPn2.t)('offer.accept', 'Accept')}</button>
		<button id="declineBuyOffer" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff; border: 1px solid #ff0000; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">${(0, $fUPn2.t)('offer.decline', 'Decline')}</button>
	  </div>
	  <div id="buyTimer" style="margin-top:10px;text-align:center;"></div>
	</div>
  `;
    popup.appendChild(content);
    // Setup close function first (offerKey already defined above for dedup check)
    function closePopup() {
        // Mark this offer as handled to prevent duplicate popups from message replay
        localStorage.setItem(offerKey, String(Date.now()));
        // Schedule cleanup of the handled marker after 30 seconds
        setTimeout(()=>localStorage.removeItem(offerKey), 30000);
        localStorage.setItem(`${buySessionId}_active`, 'false');
        localStorage.removeItem(`${buySessionId}_expiryTime`);
        localStorage.removeItem(`${buySessionId}_offerData`);
        if (localStorage.getItem('activeBuyOfferSession') === buySessionId) localStorage.removeItem('activeBuyOfferSession');
        offerActive = false;
        if (timerInterval) clearInterval(timerInterval);
        const pop = document.getElementById('buyOfferPopup');
        if (pop) {
            if (window.popupTracker) window.popupTracker.unregisterPopup('buyOfferPopup');
            pop.remove();
            document.body.style.overflow = '';
        }
    }
    // Setup buttons IMMEDIATELY after content is appended
    const acceptBtn = content.querySelector('#acceptBuyOffer');
    const declineBtn = content.querySelector('#declineBuyOffer');
    if (acceptBtn) acceptBtn.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        localStorage.setItem(`${buySessionId}_active`, 'false');
        if (timerInterval) clearInterval(timerInterval);
        if (!offerActive) return;
        offerActive = false;
        this.disabled = true;
        // Close popup immediately - don't wait for server response
        closePopup();
        try {
            await $5e5d264206c87423$export$fd3a0a3b7b4dc710({
                itemId: data.itemId,
                buyerId: data.buyerId,
                sellerId: data.sellerId,
                offerAmount: data.offerAmount,
                bidType: data.bidType,
                zollarBid: data.zollarBid || {},
                item_name: data.item_name
            });
        } catch (err) {
            console.error('Error in handleAcceptBuyOffer:', err);
            (0, $eD3DY.showNotification)(`Error: ${err.message}`, false);
        }
    });
    if (declineBtn) declineBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        localStorage.setItem(`${buySessionId}_active`, 'false');
        if (timerInterval) clearInterval(timerInterval);
        if (!offerActive) return;
        offerActive = false;
        this.disabled = true;
        // Close popup immediately - don't wait for server response
        closePopup();
        $5e5d264206c87423$export$5bc1b41b6ea3d1d5(data);
    });
    // Setup timer
    let remainingTime = 10;
    localStorage.setItem(`${buySessionId}_expiryTime`, String(Date.now() + 10000));
    const updateTimer = ()=>{
        const timerEl = content.querySelector('#buyTimer');
        if (timerEl) timerEl.textContent = `Time remaining: ${remainingTime} seconds`;
    };
    updateTimer();
    timerInterval = setInterval(()=>{
        const sessionActive = localStorage.getItem(`${buySessionId}_active`) === 'true';
        const currentSession = localStorage.getItem('activeBuyOfferSession');
        if (!sessionActive || currentSession !== buySessionId) {
            clearInterval(timerInterval);
            return;
        }
        remainingTime -= 1;
        updateTimer();
        if (remainingTime <= 0) {
            clearInterval(timerInterval);
            const stillActive = localStorage.getItem(`${buySessionId}_active`) === 'true';
            if (stillActive && offerActive) {
                localStorage.setItem(`${buySessionId}_active`, 'false');
                offerActive = false;
                $5e5d264206c87423$export$5bc1b41b6ea3d1d5(data);
                closePopup();
            }
        }
    }, 1000);
    const style = document.createElement('style');
    style.textContent = `
	.buyOfferPop {
	  position: relative !important; transform: none !important; top:auto !important; left:auto !important;
	  width: 90%; max-width: 600px; padding: 20px; background-color: rgba(0, 8, 36, 0.9);
	  border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.5); z-index: 10000;
	  font-family: 'bithigh', Arial, sans-serif; color: #00ff00; text-align: center; margin: 0 auto;
	  box-sizing: border-box; backdrop-filter: blur(5px); -webkit-backdrop-filter: blur(5px);
	}
	@media (max-width: 600px){ .buyOfferPop { width:95%; max-width:95%; padding:15px; margin:10px auto; } }
	@media (max-height: 700px){ .buyOfferPop { margin:10px auto; } }
	.buyOfferPop button { min-height:44px; touch-action:manipulation; -webkit-appearance:none; appearance:none; }
  `;
    document.head.appendChild(style);
    // Load background HLS (using same item trade backgrounds)
    const videoBaseUrl = `${(0, $cNeIB.apiBaseUrl)}/uploads/specialBacks/itemTrade/`;
    const totalVideos = 10;
    const videoIndex = Math.floor(Math.random() * totalVideos) + 1;
    const videoUrl = `${videoBaseUrl}${videoIndex}/playlist.m3u8`;
    if (window.Hls && Hls.isSupported()) {
        const hls = new Hls({
            debug: false,
            enableWorker: false,
            lowLatencyMode: true,
            backBufferLength: 90
        });
        hls.loadSource(videoUrl);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, ()=>video.play().catch(()=>{
                video.style.display = 'none';
            }));
        hls.on(Hls.Events.ERROR, ()=>{
            video.style.display = 'none';
        });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoUrl;
        video.addEventListener('loadedmetadata', ()=>video.play().catch(()=>{
                video.style.display = 'none';
            }));
        video.addEventListener('error', ()=>{
            video.style.display = 'none';
        });
    }
}
function $5e5d264206c87423$var$displayZollarDetails(zollarBid) {
    if (!zollarBid || Object.keys(zollarBid).length === 0) return `<p>${(0, $fUPn2.t)('offer.no_zollar_details', 'No Zollar details available.')}</p>`;
    let zollarHtml = '<ul>';
    for (const [type, value] of Object.entries(zollarBid))if (value > 0) {
        const descriptor = $5e5d264206c87423$var$getQualitativeDescriptor(value);
        zollarHtml += `<li>${type}: ${descriptor}</li>`; // Only display the descriptor
    }
    zollarHtml += '</ul>';
    return zollarHtml;
}
let $5e5d264206c87423$var$isProcessing = false;
function $5e5d264206c87423$export$fd3a0a3b7b4dc710(data) {
    return new Promise((resolve, reject)=>{
        if ($5e5d264206c87423$var$isProcessing) return reject(new Error('Transaction is already being processed.'));
        $5e5d264206c87423$var$isProcessing = true;
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        const trySocketFirst = !!(s && s.connected);
        const doSocket = ()=>$5e5d264206c87423$export$d789718bde385b17({
                itemId: data.itemId,
                buyerId: data.buyerId,
                sellerId: data.sellerId,
                bidType: data.bidType,
                offerAmount: data.offerAmount,
                zollarBid: data.zollarBid || {},
                sessionId: localStorage.getItem('sessionId')
            });
        const doHttp = ()=>fetch(`${(0, $cNeIB.apiBaseUrl)}/api/button/acceptBuyOffer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    buyerId: data.buyerId,
                    sellerId: data.sellerId,
                    itemId: data.itemId,
                    offerAmount: data.offerAmount,
                    bidType: data.bidType,
                    zollarBid: data.zollarBid || {},
                    sessionId: localStorage.getItem('sessionId')
                })
            }).then((r)=>r.json()).then((result)=>{
                if (!result?.success) throw new Error(result?.message || 'Failed to accept the buy offer');
                return result;
            });
        (trySocketFirst ? doSocket() : doHttp()).then((result)=>{
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.success_buy_offer_accepted', 'Success: Buy offer accepted for {item}').replace('{item}', data.item_name || (0, $fUPn2.t)('offer.item', 'item')), true);
            $5e5d264206c87423$var$closeBuyOfferPopupAfterAccept();
            resolve(result);
        }).catch(async (err)=>{
            // Fallback to HTTP if socket path failed
            if (trySocketFirst) try {
                const result = await doHttp();
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.success_buy_offer_accepted', 'Success: Buy offer accepted for {item}').replace('{item}', data.item_name || (0, $fUPn2.t)('offer.item', 'item')), true);
                $5e5d264206c87423$var$closeBuyOfferPopupAfterAccept();
                resolve(result);
                return;
            } catch (err2) {
                console.error('Failed via socket and HTTP:', err2);
                (0, $eD3DY.showNotification)(`Error: ${err2.message}`, false);
                reject(err2);
                return;
            }
            else {
                console.error('Failed to process the transaction:', err);
                (0, $eD3DY.showNotification)(`Error: ${err.message}`, false);
                reject(err);
            }
        }).finally(()=>{
            $5e5d264206c87423$var$isProcessing = false;
        });
    });
}
function $5e5d264206c87423$export$5bc1b41b6ea3d1d5(data) {
    console.log('Handling rejected buy offer:', data);
    // If you want to notify server about explicit declines, emit here:
    // if (socket && socket.connected) socket.emit('rejectBuyOffer', { ...data, sessionId: localStorage.getItem('sessionId') });
    (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.buy_offer_declined', 'Buy offer declined.'), false);
    $5e5d264206c87423$var$closeBuyOfferPopupAfterDecline();
}
async function $5e5d264206c87423$export$d789718bde385b17(data) {
    return new Promise((resolve, reject)=>{
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        if (!s) return reject(new Error('Socket not available'));
        if (!s.connected) return reject(new Error('Socket is not connected'));
        const message = {
            itemId: data.itemId,
            buyerId: data.buyerId,
            sellerId: data.sellerId,
            sessionId: data.sessionId || localStorage.getItem('sessionId'),
            bidType: data.bidType,
            offerAmount: data.offerAmount,
            zollarBid: data.zollarBid || {}
        };
        let resolved = false;
        const timeout = setTimeout(()=>{
            if (!resolved) {
                resolved = true;
                reject(new Error('Socket timeout - no response from server'));
            }
        }, 8000);
        s.emit('acceptBuyOfferSocket', message, (response)=>{
            if (resolved) return;
            resolved = true;
            clearTimeout(timeout);
            if (response?.success) {
                console.log('Buy offer accepted via socket:', response);
                resolve(response);
            } else {
                const errorMsg = response?.error || 'No response from server';
                reject(new Error(errorMsg));
            }
        });
    });
}
function $5e5d264206c87423$var$getQualitativeDescriptor(quantity) {
    if (quantity === 0) return (0, $fUPn2.t)('offer.zollar_none', 'None');
    if (quantity <= 3) return (0, $fUPn2.t)('offer.zollar_few', 'A Few');
    if (quantity <= 7) return (0, $fUPn2.t)('offer.zollar_some', 'Some');
    if (quantity <= 15) return (0, $fUPn2.t)('offer.zollar_many', 'Many');
    return (0, $fUPn2.t)('offer.zollar_huge', 'A Huge Amount');
}
function $5e5d264206c87423$var$closeBuyOfferPopupAfterAccept() {
    const popup = document.getElementById('buyOfferPopup');
    if (popup) {
        if (window.popupTracker) window.popupTracker.unregisterPopup('buyOfferPopup');
        popup.remove();
        document.body.style.overflow = '';
    }
}
function $5e5d264206c87423$var$closeBuyOfferPopupAfterDecline() {
    const popup = document.getElementById('buyOfferPopup');
    if (popup) {
        if (window.popupTracker) window.popupTracker.unregisterPopup('buyOfferPopup');
        popup.remove();
        document.body.style.overflow = '';
    }
}
function $5e5d264206c87423$var$showLoadingIndicator() {
    const popupContainer = document.getElementById('popup-container');
    if (popupContainer) {
        const loadingText = document.createElement("p");
        loadingText.textContent = (0, $fUPn2.t)('offer.processing', 'Processing transaction...');
        loadingText.style.color = "#00ff00";
        popupContainer.appendChild(loadingText);
    }
}
function $5e5d264206c87423$var$makeClientMessageId() {
    return `msg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}
function $5e5d264206c87423$export$2e349d3452c1a401(itemId, itemName, targetUsers, transactionData) {
    // Create overlay
    const overlay = document.createElement("div");
    overlay.id = 'storyCustomizationOverlay';
    overlay.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10000; justify-content: center; align-items: center; display: flex;";
    // Create form container
    const formContainer = document.createElement("div");
    formContainer.style = "background: rgba(1, 32, 59, 0.95); border: 2px solid #00ff00; color: #00ff00; padding: 20px; border-radius: 5px; max-width: 500px; width: 90%;";
    formContainer.innerHTML = `
    <h2 style="text-align:center;margin-bottom:20px;">
      ${(0, $fUPn2.t)('offer.customize_story_element', 'Customize Your Story Element')}
    </h2>

    <p style="font-style:italic;margin-bottom:15px;font-size:.9em;">
      "${(0, $fUPn2.t)('offer.story_element_description', 'Each trade shapes your story. Describe how you want this element to appear in the final narrative.')}"
    </p>

    <div style="margin-bottom:15px;background:rgba(0,255,0,0.1);padding:10px;border-radius:5px;">
      <strong>${(0, $fUPn2.t)('offer.trading_item', 'Trading Item:')} </strong> ${itemName}
    </div>

    <div style="margin-bottom:15px;">
      <label style="display:block;margin-bottom:5px;">
        ${(0, $fUPn2.t)('offer.how_customize', 'How would you like to customize this story element?')}
      </label>
      <textarea id="story-customization-text"
                placeholder="${(0, $fUPn2.t)('offer.customization_placeholder', 'Describe your vision for this story element... (e.g., character traits, setting details, plot twists)')}"
                style="width:100%;height:100px;padding:8px;background:rgba(36,65,192,.8);
                       color:#00ff00;border:1px solid #00ff00;resize:vertical;box-sizing:border-box;"
                maxlength="300"></textarea>
      <div style="text-align:right;font-size:.7em;margin-top:5px;">
        <span id="custom-char-count">0</span>/300
      </div>
    </div>

    <div style="display:flex;gap:10px;">
      <button id="cancel-story-customization"
              style="flex:1;padding:10px;background:rgba(255,0,0,.6);color:#fff;
                     border:1px solid #ff0000;cursor:pointer;border-radius:3px;">
        ${(0, $fUPn2.t)('offer.cancel', 'Cancel')}
      </button>
      <button id="submit-story-customization"
              style="flex:1;padding:10px;background:rgba(0,255,0,.6);color:#000;
                     border:1px solid #00ff00;cursor:pointer;border-radius:3px;" disabled>
        ${(0, $fUPn2.t)('offer.continue_trade', 'Continue Trade')}
      </button>
    </div>
  `;
    overlay.appendChild(formContainer);
    document.body.appendChild(overlay);
    if (window.popupTracker) window.popupTracker.trackElement(overlay, 'story-customization-form');
    // Add event listeners
    const customizationTextarea = document.getElementById('story-customization-text');
    const charCount = document.getElementById('custom-char-count');
    const submitButton = document.getElementById('submit-story-customization');
    const cancelButton = document.getElementById('cancel-story-customization');
    // Character counter and validation
    customizationTextarea.addEventListener('input', ()=>{
        const length = customizationTextarea.value.length;
        charCount.textContent = length;
        const isValid = customizationTextarea.value.trim().length >= 10;
        submitButton.disabled = !isValid;
        submitButton.style.opacity = isValid ? '1' : '0.5';
    });
    // Cancel button
    cancelButton.addEventListener('click', ()=>{
        document.body.removeChild(overlay);
    });
    // Submit button
    submitButton.addEventListener('click', async ()=>{
        const customization = customizationTextarea.value.trim();
        try {
            submitButton.disabled = true;
            submitButton.textContent = (0, $fUPn2.t)('offer.saving', 'Saving...');
            // Save the customization to the backend
            const portfolioId = localStorage.getItem('portfolioId');
            const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/storysim/save-customization`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    portfolioId: portfolioId,
                    itemId: itemId,
                    itemName: itemName,
                    customization: customization
                })
            });
            const result = await response.json();
            if (result.success) {
                document.body.removeChild(overlay);
                // Store customization in transaction data for the offer
                if (transactionData) transactionData.storyCustomization = customization;
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.customization_saved', 'Story element customized!'), true);
                // Now proceed with the actual trade offer (call original transaction logic)
                // This will be handled by the calling function
                if (window.proceedWithStoryTrade) window.proceedWithStoryTrade(customization);
            } else throw new Error(result.error || 'Failed to save customization');
        } catch (error) {
            console.error('Error saving story customization:', error);
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.error_generic', 'Error: {message}').replace('{message}', error.message), false);
            submitButton.textContent = (0, $fUPn2.t)('offer.continue_trade', 'Continue Trade');
            submitButton.disabled = false;
        }
    });
}
function $5e5d264206c87423$export$d6f732f4663dfbc(itemId, targetUsers) {
    // Create overlay
    const overlay = document.createElement("div");
    overlay.id = 'offerSentOverlay';
    overlay.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10000; justify-content: center; align-items: center; display: flex;";
    // Create form container
    const formContainer = document.createElement("div");
    formContainer.style = "background: rgba(1, 32, 59, 0.95); border: 2px solid #00ff00; color: #00ff00; padding: 20px; border-radius: 5px; max-width: 500px; width: 90%;";
    formContainer.innerHTML = `
   <h2 style="text-align:center;margin-bottom:20px;">
	 ${(0, $fUPn2.t)('offer.meaningful_exchange', 'Meaningful Exchange')}
   </h2>
 
   <p style="font-style:italic;margin-bottom:15px;font-size:.7em;">
	 "${(0, $fUPn2.t)('offer.value_quote', 'Value exists in perception, play and speculation, not just utility or rarity.')}"
   </p>
 
   <div style="margin-bottom:15px;">
	 <label style="display:block;margin-bottom:5px;">
	   ${(0, $fUPn2.t)('offer.who_to_trade_with', 'Who would you like to trade with?')}
	 </label>
	 <select id="social-target-select"
			 style="width:100%;padding:8px;background:rgba(36,65,192,.8);
					color:#00ff00;border:1px solid #00ff00;">
	   <option value="">${(0, $fUPn2.t)('offer.select_trader', 'Select a trader...')}</option>
	   ${targetUsers.map((u)=>`<option value="${u._id}">${u.name}${u.isBot ? " \uD83E\uDD16" : ''}</option>`).join('')}
	 </select>
   </div>
 
   <div style="margin-bottom:15px;">
	 <label style="display:block;margin-bottom:5px;">
	   ${(0, $fUPn2.t)('offer.why_trade', 'Why do you want to make this trade?')}
	 </label>
	 <textarea id="social-trade-reason"
			   placeholder="${(0, $fUPn2.t)('offer.describe_motivation', 'Describe your motivation, emotion or story...')}"
			   style="width:100%;height:80px;padding:8px;background:rgba(36,65,192,.8);
					  color:#00ff00;border:1px solid #00ff00;resize:none;"
			   maxlength="500"></textarea>
	 <div style="text-align:right;font-size:.7em;margin-top:5px;">
	   <span id="char-count">0</span>/500
	 </div>
   </div>
 
   <div style="margin-bottom:20px;">
	 <label style="display:block;margin-bottom:5px;">
	   ${(0, $fUPn2.t)('offer.trade_with', 'Trade with:')}
	 </label>
	 <div style="display:flex;gap:15px;">
	   <label style="display:flex;align-items:center;">
		 <input type="radio" name="bidType" value="points" checked style="margin-right:5px;">
		 ${(0, $fUPn2.t)('offer.capital', 'Capital')}
	   </label>
	   <label style="display:flex;align-items:center;">
		 <input type="radio" name="bidType" value="zollars" style="margin-right:5px;">
		 ${(0, $fUPn2.t)('offer.zollars', 'Zollars')}
	   </label>
	 </div>
   </div>
 
   <div style="display:flex;gap:10px;">
	 <button id="cancel-social-trade"
			 style="flex:1;padding:10px;background:rgba(255,0,0,.6);color:#fff;
					border:1px solid #ff0000;cursor:pointer;">
	   ${(0, $fUPn2.t)('offer.cancel', 'Cancel')}
	 </button>
	 <button id="submit-social-trade"
			 style="flex:1;padding:10px;background:rgba(0,255,0,.6);color:#000;
					border:1px solid #00ff00;cursor:pointer;" disabled>
	   ${(0, $fUPn2.t)('offer.send_offer', 'Send Offer')}
	 </button>
   </div>
 `;
    overlay.appendChild(formContainer);
    document.body.appendChild(overlay);
    if (window.popupTracker) window.popupTracker.trackElement(overlay, 'social-trade-form');
    // Add event listeners
    const targetSelect = document.getElementById('social-target-select');
    const reasonTextarea = document.getElementById('social-trade-reason');
    const charCount = document.getElementById('char-count');
    const submitButton = document.getElementById('submit-social-trade');
    const cancelButton = document.getElementById('cancel-social-trade');
    // Character counter and validation
    reasonTextarea.addEventListener('input', ()=>{
        const length = reasonTextarea.value.length;
        charCount.textContent = length;
        const isValid = targetSelect.value && reasonTextarea.value.trim().length >= 10;
        submitButton.disabled = !isValid;
        submitButton.style.opacity = isValid ? '1' : '0.5';
    });
    targetSelect.addEventListener('change', ()=>{
        const isValid = targetSelect.value && reasonTextarea.value.trim().length >= 10;
        submitButton.disabled = !isValid;
        submitButton.style.opacity = isValid ? '1' : '0.5';
    });
    // Cancel button
    cancelButton.addEventListener('click', ()=>{
        document.body.removeChild(overlay);
    });
    // Submit button  
    submitButton.addEventListener('click', async ()=>{
        const targetUserId = targetSelect.value;
        const reason = reasonTextarea.value.trim();
        const bidType = document.querySelector('input[name="bidType"]:checked').value;
        try {
            submitButton.disabled = true;
            submitButton.textContent = (0, $fUPn2.t)('offer.sending', 'Sending...');
            const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-trade-offer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    itemId: itemId,
                    targetUserId: targetUserId,
                    reason: reason,
                    bidType: bidType
                })
            });
            const result = await response.json();
            if (result.success) {
                document.body.removeChild(overlay);
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.meaningful_offer_sent', 'Meaningful trade offer sent! {insight}').replace('{insight}', result.llmInsight || ''), true);
                // Show the existing offer sent popup
                localStorage.setItem('pendingOffer', 'true');
                $5e5d264206c87423$export$f96bc44d9ad77c90(localStorage.getItem('portfolioId'), []);
            } else throw new Error(result.error || 'Failed to send offer');
        } catch (error) {
            console.error('Error sending social trade offer:', error);
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.error_generic', 'Error: {message}').replace('{message}', error.message), false);
            submitButton.textContent = (0, $fUPn2.t)('offer.send_meaningful_offer', 'Send Meaningful Offer');
            submitButton.disabled = false;
        }
    });
}
function $5e5d264206c87423$export$c8555101b1151e80(itemId, itemName, targetPortfolioId, targetPortfolioName) {
    const portfolioId = localStorage.getItem('portfolioId');
    const userPortfolioName = localStorage.getItem('portfolioName') || 'Your Portfolio';
    // Create the dialog
    const dialog = document.createElement('div');
    dialog.className = 'social-trade-overlay';
    dialog.id = 'social-trade-dialog'; // Add ID for easier removal
    dialog.style.cssText = `
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10000;
	font-family: 'bithigh', monospace;
  `;
    dialog.innerHTML = `
	<div style="background:linear-gradient(135deg,#001122 0%,#003344 100%);
				border:2px solid #00ff00;border-radius:5px;padding:30px;
				max-width:500px;width:90%;color:#00ff00;box-shadow:0 0 30px rgba(0,255,0,.3);">
	  <h2 style="margin:0 0 20px;text-align:center;color:#00ff00;">
		${(0, $fUPn2.t)('transaction.explain_trade_reason', 'Explain why you want to make this trade.')}
	  </h2>
  
	  <div style="margin-bottom:20px;padding:15px;background:rgba(0,255,0,.1);border-radius:5px;">
		<p style="margin:0;font-size:12px;">
		  <strong>${(0, $fUPn2.t)('transaction.item_name', 'Item')}:</strong> ${itemName}<br>
		  <strong>${(0, $fUPn2.t)('market.owner', 'Owner')}:</strong> ${targetPortfolioName}<br>
		  <strong>${(0, $fUPn2.t)('trader.your_portfolio', 'Your Portfolio')}:</strong> ${userPortfolioName}
		</p>
	  </div>
  
	  <div style="margin-bottom:20px;">
		<label style="display:block;margin-bottom:10px;font-weight:bold;">
		  ${(0, $fUPn2.t)('transaction.why_trade_question', 'Why do you want to make this trade? What is your goal?')}
		</label>
		<textarea id="tradeStoryText"
				  placeholder="${$5e5d264206c87423$var$tr('offer.share_reason_placeholder', 'Share your reason, motivation, memory, or vision... To create meaningful connections by trading.')}"
				  style="width:100%;height:120px;background:rgba(0,0,0,.7);
						 border:1px solid #00ff00;color:#00ff00;padding:10px;
						 border-radius:2px;font-family:'bithigh',Arial,sans-serif;
						 font-size:12px;resize:vertical;box-sizing:border-box;"
				  required></textarea>
		<div id="storyError"
			 style="color:#ff0000;font-size:12px;margin-top:5px;display:none;">
		  ${(0, $fUPn2.t)('transaction.narrative_error', 'Please write at least 15 characters to explain your goal.')}
		</div>
	  </div>
  
	  <div style="display:flex;gap:15px;justify-content:center;">
		<button id="sendTradeStory"
				style="background:linear-gradient(45deg,#00ff00,#00aa00);color:#000;
					   border:none;padding:12px 25px;border-radius:3px;cursor:pointer;
					   font-weight:bold;font-family:'bithigh',Arial,sans-serif;">
		  ${(0, $fUPn2.t)('transaction.send_trade_with_intention', 'Send trade with intention')}
		</button>
		<button id="cancelTradeStory"
				style="background:linear-gradient(45deg,#666,#444);color:#fff;
					   border:none;padding:12px 25px;border-radius:4px;cursor:pointer;
					   font-family:'bithigh',Arial,sans-serif;">
		  ${$5e5d264206c87423$var$tr('offer.cancel', 'Cancel')}
		</button>
	  </div>
	</div>
  `;
    document.body.appendChild(dialog);
    if (window.popupTracker) {
        const popupHandle = window.popupTracker.trackElement(dialog, 'social-trade-dialog');
    }
    // Handle send button
    const sendButton = document.getElementById('sendTradeStory');
    const cancelButton = document.getElementById('cancelTradeStory');
    const storyTextarea = document.getElementById('tradeStoryText');
    const errorDiv = document.getElementById('storyError');
    sendButton.onclick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const storyText = storyTextarea.value.trim();
        if (!storyText || storyText.length < 10) {
            errorDiv.style.display = 'block';
            errorDiv.textContent = (0, $fUPn2.t)('offer.response_min_10', 'Please write at least 10 characters about why you want this asset.');
            storyTextarea.focus();
            return;
        }
        // Store the story in localStorage for the transaction page
        localStorage.setItem('tradeStory', storyText);
        localStorage.setItem('tradeStoryTimestamp', new Date().toISOString());
        // Remove dialog
        dialog.remove();
        // Navigate to transaction page with story flag
        const url = `transaction.html?itemId=${encodeURIComponent(itemId)}&itemName=${encodeURIComponent(itemName)}&portfolioId=${encodeURIComponent(targetPortfolioId)}&portfolioName=${encodeURIComponent(targetPortfolioName)}&hasStory=true`;
        console.log('Navigating to:', url);
        window.location.href = url;
    };
    // Handle cancel button
    cancelButton.onclick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        console.log('Cancel button clicked');
        dialog.remove();
    };
    // Handle escape key
    const escapeHandler = (e)=>{
        if (e.key === 'Escape') {
            dialog.remove();
            document.removeEventListener('keydown', escapeHandler);
        }
    };
    document.addEventListener('keydown', escapeHandler);
    // Focus on textarea
    setTimeout(()=>{
        storyTextarea.focus();
    }, 100);
    // Add click outside to close (optional)
    dialog.addEventListener('click', (e)=>{
        if (e.target === dialog) dialog.remove();
    });
}
function $5e5d264206c87423$export$e6bbcc1b0179915c(data) {
    // Guard & destructure safely
    if (!data || typeof data !== 'object') return;
    const { itemName: itemName = (0, $fUPn2.t)?.('offer.item', 'item'), reason: reason = '', initiatorName: initiatorName = (0, $fUPn2.t)?.('offer.trader', 'Trader'), initiatorUserId: initiatorUserId, itemId: itemId } = data;
    // Must have these to route replies
    if (!initiatorUserId || !itemId) {
        console.warn('showSocialTradeReceived: missing initiatorUserId or itemId', data);
        return;
    }
    // Socket must be available now
    const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
    if (!s || !s.connected) {
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.error_no_socket', 'Not connected. Please try again.'), false);
        return;
    }
    // DOM
    const overlay = document.createElement('div');
    overlay.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%;background: rgba(0,0,0,0.8); z-index: 9999; display: flex; justify-content: center; align-items: center;";
    const popup = document.createElement('div');
    popup.style = "background: rgba(1, 32, 59, 0.95); border: 2px solid #00ff00; color: #00ff00; padding: 20px;border-radius: 5px; max-width: 500px; width: 90%; font-family: 'bithigh', sans-serif;";
    popup.innerHTML = `
	<h4 style="margin-top:0; text-align:center;">
	  ${(0, $fUPn2.t)('offer.meaningful_trade_offer', 'Meaningful Trade Offer')}
	</h4>
	<div style="margin-bottom:15px;">
	  <strong>${initiatorName}</strong> ${(0, $fUPn2.t)('offer.wants_to_trade', 'wants to trade')}
	  <strong>${itemName}</strong>
	</div>
	<div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 3px; margin-bottom: 15px; font-style: italic;">
	  "${reason || ''}"
	</div>
	<textarea id="response-message"
	  placeholder="${(0, $fUPn2.t)('offer.respond_optional', 'Respond to their story (optional)...')}"
	  style="width:100%; height:60px; padding:8px; background: rgba(36,65,192,0.8); color:#00ff00;
			 border:1px solid #00ff00; resize:none; margin-bottom:15px;"
	  maxlength="200"></textarea>
	<div style="display:flex; gap:10px;">
	  <button id="not-interested" style="flex:1; padding:10px; background: rgba(255,0,0,0.6); color:#fff; border:1px solid #ff0000; cursor:pointer;">
		${(0, $fUPn2.t)('offer.not_interested', 'Not Interested')}
	  </button>
	  <button id="interested" style="flex:1; padding:10px; background: rgba(0,255,0,0.6); color:#000; border:1px solid #00ff00; cursor:pointer;">
		${(0, $fUPn2.t)('offer.im_interested', "I'm Interested!")}
	  </button>
	</div>
  `;
    overlay.appendChild(popup);
    document.body.appendChild(overlay);
    if (window.popupTracker) window.popupTracker.trackElement(overlay, 'social-trade-received');
    const autoClose = setTimeout(removeOverlay, 30000);
    function removeOverlay() {
        clearTimeout(autoClose);
        if (document.body.contains(overlay)) document.body.removeChild(overlay);
    }
    // Close on ESC and click-outside
    const onEsc = (e)=>{
        if (e.key === 'Escape') removeOverlay();
    };
    document.addEventListener('keydown', onEsc);
    overlay.addEventListener('click', (e)=>{
        if (e.target === overlay) removeOverlay();
    });
    // Common send routine (no waitForReadySocket; we already checked)
    function sendReply({ interested: interested }) {
        const message = (document.getElementById('response-message')?.value || '').trim();
        const myPortfolioId = $5e5d264206c87423$var$getPortfolioId();
        const content = message || (interested ? (0, $fUPn2.t)('offer.default_interested', "I'm interested in this trade!") : (0, $fUPn2.t)('offer.default_not_interested', 'Not interested in this trade.'));
        if (!s || !s.connected) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.error_no_socket', 'Not connected. Please try again.'), false);
            return;
        }
        s.emit('socialTradeResponse', {
            initiatorUserId: initiatorUserId,
            targetUserId: myPortfolioId,
            itemId: itemId,
            interested: !!interested,
            message: content
        }, (ack)=>{
            if (ack && ack.success === false) {
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.error_sending', 'Error: {m}').replace('{m}', ack.error || 'Failed to send'), false);
                return;
            }
            removeOverlay();
            (0, $eD3DY.showNotification)(interested ? (0, $fUPn2.t)('offer.interest_shown', 'Interest shown! They may contact you directly.') : (0, $fUPn2.t)('offer.response_sent', 'Response sent'), !!interested);
        });
    }
    // Wire buttons
    popup.querySelector('#not-interested').addEventListener('click', ()=>sendReply({
            interested: false
        }));
    popup.querySelector('#interested').addEventListener('click', ()=>sendReply({
            interested: true
        }));
}
function $5e5d264206c87423$export$e8b9a359288bb90c(data) {
    const { responderName: responderName, interested: interested, message: message } = data;
    const emotion = interested ? 'yes' : 'meh';
    const color = interested ? 'rgba(0, 255, 0, 0.8)' : 'rgba(255, 165, 0, 0.8)';
    (0, $eD3DY.showNotification)(`${emotion} ${responderName}: "${message}"`, interested);
}
function $5e5d264206c87423$var$showNarrativeResponseDialog(offerData) {
    const overlay = document.createElement('div');
    overlay.style.cssText = `
	position: fixed; top: 0; left: 0; width: 100%; height: 100%;
	background: rgba(0,0,0,0.9); z-index: 10001;
	display: flex; align-items: flex-start; justify-content: center;
	overflow-y: auto; overflow-x: hidden; padding: 20px 0; box-sizing: border-box;
  `;
    const dialog = document.createElement('div');
    dialog.style.cssText = `
	background: linear-gradient(135deg, #001122 0%, #003344 100%);
	border: 2px solid #00ff00; border-radius: 10px; padding: 30px;
	max-width: 500px; width: 90%; color: #00ff00; font-family: 'bithigh', monospace;
	margin: auto; max-height: calc(100vh - 40px); overflow-y: auto; box-sizing: border-box; position: relative;
  `;
    dialog.innerHTML = `
	<h5 style="margin: 0 0 15px 0; text-align: center;">${(0, $fUPn2.t)('offer.respond_to_offer', 'Respond to offer.')}</h5>
	<div style="background: rgba(0,255,0,0.1); padding: 10px; border-radius: 5px; margin-bottom: 15px;">
	  <strong>${(0, $fUPn2.t)('offer.the_why', 'The why:')}</strong><br>
	  <em>"${offerData.tradeStory || ''}"</em>
	</div>
	<textarea id="responseText" placeholder="${(0, $fUPn2.t)('offer.response_placeholder', 'Share your thoughts, ask questions, or explain your perspective...')}"
	  style="width: 100%; height: 100px; background: rgba(0,0,0,0.7); border: 1px solid #00ff00; color: #00ff00; padding: 10px; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif; resize: vertical; box-sizing: border-box;" maxlength="300" required></textarea>
	<div style="text-align: right; font-size: 0.8em; margin: 5px 0;">
	  <span id="responseCharCount">0</span>/300
	</div>
	<div id="responseError" style="color: #ff0000; font-size: 12px; margin: 5px 0; display: none;">
	  ${(0, $fUPn2.t)('offer.response_min_chars', 'Please write at least 10 characters in your response.')}
	</div>
	<div style="display: flex; gap: 10px; margin-top: 15px;">
	  <button id="sendResponse" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000; border: 1px solid #00ff00; padding: 10px; cursor: pointer; border-radius: 5px;">
		${(0, $fUPn2.t)('offer.send_response', 'Send Response')}
	  </button>
	  <button id="cancelResponse" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff; border: 1px solid #ff0000; padding: 10px; cursor: pointer; border-radius: 5px;">
		${(0, $fUPn2.t)('offer.cancel', 'Cancel')}
	  </button>
	</div>
  `;
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    if (window.popupTracker) window.popupTracker.trackElement(overlay, 'narrative-response');
    const responseText = dialog.querySelector('#responseText');
    const charCount = dialog.querySelector('#responseCharCount');
    const sendButton = dialog.querySelector('#sendResponse');
    const cancelButton = dialog.querySelector('#cancelResponse');
    const errorDiv = dialog.querySelector('#responseError');
    let listenerAttached = false;
    let sending = false;
    responseText.addEventListener('input', ()=>{
        charCount.textContent = responseText.value.length;
        if (responseText.value.length > 0) errorDiv.style.display = 'none';
    });
    const cleanup = ()=>{
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        if (listenerAttached && s) s.off('llmResponseReceived', handleLLMResponse);
        listenerAttached = false;
        document.body.style.overflow = '';
        if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    };
    cancelButton.onclick = (e)=>{
        e.preventDefault();
        if (sending) return;
        cleanup();
    };
    function handleLLMResponse(data) {
        if (!data?.originalOffer) return;
        const match = data.originalOffer.offeredItemId === offerData.offeredItemId && data.originalOffer.transactionItemId === offerData.transactionItemId;
        if (!match) return;
        // Update dialog with bot response
        dialog.innerHTML = `
	  <h4 style="margin: 0 0 15px 0; text-align: center;">${(0, $fUPn2.t)('offer.they_responded', 'They Responded')}</h4>
	  <div style="background: rgba(0,255,0,0.1); padding: 10px; border-radius: 5px; margin-bottom: 10px;">
		<strong>${(0, $fUPn2.t)('offer.their_original_why', 'Their original why:')}</strong><br>
		<em>"${offerData.tradeStory || ''}"</em>
	  </div>
	  <div style="background: rgba(0,100,255,0.1); padding: 10px; border-radius: 5px; margin-bottom: 10px;">
		<strong>${(0, $fUPn2.t)('offer.your_response', 'Your response:')}</strong><br>
		<em>"${data.userResponse || ''}"</em>
	  </div>
	  <div style="background: rgba(255,165,0,0.1); padding: 10px; border-radius: 5px; margin-bottom: 15px;">
		<strong>${(0, $fUPn2.t)('offer.their_response', 'Their response:')}</strong><br>
		<em>"${data.botResponse || ''}"</em>
	  </div>
	  <div style="display: flex; gap: 10px; margin-top: 15px;">
		<button id="finalAcceptFromDialog" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000; border: 1px solid #00ff00; padding: 10px; cursor: pointer; border-radius: 5px;">
		  ${(0, $fUPn2.t)('offer.accept', 'Accept')}
		</button>
		<button id="finalDeclineFromDialog" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff; border: 1px solid #ff0000; padding: 10px; cursor: pointer; border-radius: 5px;">
		  ${(0, $fUPn2.t)('offer.decline', 'Decline')}
		</button>
	  </div>
	`;
        const finalAccept = dialog.querySelector('#finalAcceptFromDialog');
        const finalDecline = dialog.querySelector('#finalDeclineFromDialog');
        finalAccept.onclick = async ()=>{
            try {
                await $5e5d264206c87423$export$c9d68d666177c59c(offerData);
                cleanup();
                const original = document.getElementById('tradeOfferPopup');
                if (original) original.remove();
            } catch (e) {
                (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.error_accepting_offer', 'Error accepting offer: {message}').replace('{message}', e.message)}`, false);
            }
        };
        finalDecline.onclick = async ()=>{
            try {
                await $5e5d264206c87423$export$40e1fe1299acaf1b(offerData);
                cleanup();
                const original = document.getElementById('tradeOfferPopup');
                if (original) original.remove();
            } catch (e) {
                (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.error_declining_offer', 'Error declining offer: {message}').replace('{message}', e.message)}`, false);
            }
        };
        // detach, handled once
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        if (listenerAttached && s) {
            s.off('llmResponseReceived', handleLLMResponse);
            listenerAttached = false;
        }
    }
    sendButton.onclick = async (e)=>{
        e.preventDefault();
        if (sending) return;
        const response = responseText.value.trim();
        if (!response || response.length < 10) {
            errorDiv.style.display = 'block';
            errorDiv.textContent = (0, $fUPn2.t)('offer.response_min_chars', 'Please write at least 10 characters in your response.');
            responseText.focus();
            return;
        }
        try {
            sending = true;
            sendButton.disabled = true;
            sendButton.textContent = (0, $fUPn2.t)('offer.sending', 'Sending...');
            sendButton.style.opacity = '0.5';
            const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
            if (!s || !s.connected) throw new Error('Socket connection not available');
            s.emit('requestLlmResponseOffer', {
                originalOffer: offerData,
                userResponse: response,
                responderUserId: localStorage.getItem('portfolioId')
            }, (ack)=>{
                if (!ack?.success) (0, $eD3DY.showNotification)(`Error: ${ack?.error || 'LLM request failed'}`, false);
            });
            dialog.innerHTML = `
		<h3 style="margin: 0 0 15px 0; text-align: center;">${(0, $fUPn2.t)('offer.response_sent', 'Response Sent')}</h3>
		<div style="background: rgba(0,255,0,0.1); padding: 10px; border-radius: 5px; margin-bottom: 15px;">
		  <strong>${(0, $fUPn2.t)('offer.the_why', 'The why:')}</strong><br>
		  <em>"${offerData.tradeStory || ''}"</em>
		</div>
		<div style="background: rgba(0,100,255,0.1); padding: 10px; border-radius: 5px; margin-bottom: 15px;">
		  <strong>${(0, $fUPn2.t)('offer.your_response', 'Your response:')}</strong><br>
		  <em>"${response}"</em>
		</div>
		<div style="text-align: center; color: #ffaa00;">
		  <p>${(0, $fUPn2.t)('offer.waiting_for_their_response', 'Waiting for their response...')}</p>
		  <p style="font-size: 0.9em; color: #00ff00;">${(0, $fUPn2.t)('offer.timer_extended', 'Timer extended to 60 seconds')}</p>
		</div>
	  `;
            // listen once (guard against stacking)
            if (!listenerAttached && s) {
                s.off('llmResponseReceived', handleLLMResponse);
                s.on('llmResponseReceived', handleLLMResponse);
                listenerAttached = true;
            }
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.response_sent_wait', 'Response sent! Waiting for their response...'), true);
        } catch (err) {
            (0, $eD3DY.showNotification)(`Error: ${err.message}`, false);
            sending = false;
            sendButton.disabled = false;
            sendButton.textContent = (0, $fUPn2.t)('offer.send_response', 'Send Response');
            sendButton.style.opacity = '1';
        }
    };
    // Escape & outside to close
    const escapeHandler = (e)=>{
        if (e.key === 'Escape' && !sending) {
            cleanup();
            document.removeEventListener('keydown', escapeHandler);
        }
    };
    document.addEventListener('keydown', escapeHandler);
    setTimeout(()=>responseText.focus(), 100);
    overlay.addEventListener('click', (e)=>{
        if (e.target === overlay && !sending) cleanup();
    });
}
function $5e5d264206c87423$var$showUpdatedOfferPopup(offerData) {
    if (!offerData) return;
    // Remove existing popup
    const existingPopup = document.getElementById('tradeOfferPopup');
    if (existingPopup) existingPopup.remove();
    // Show new popup with narrative exchange
    const popup = document.createElement('div');
    popup.id = 'tradeOfferPopup';
    popup.style.cssText = `
	position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
	width: 100%; max-width: 100%; height: 100%; max-height: 100%;
	border-radius: 0px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); z-index: 9999;
	font-family: 'bithigh', Arial, sans-serif; color: #00ff00;
	text-align: center; align-content: center; overflow: hidden;
  `;
    let exchangeHtml = '';
    if (Array.isArray(offerData.narrativeExchange) && offerData.narrativeExchange.length > 0) exchangeHtml = `
	  <div style="background: rgba(0,255,0,0.1); border: 1px solid rgba(0,255,0,0.3);
				  border-radius: 3px; padding: 10px; margin: 15px 0; max-height: 200px; overflow-y: auto;">
		<h5 style="margin: 0 0 10px 0;">${(0, $fUPn2.t)('offer.conversation', 'Conversation:')}</h5>
		${offerData.narrativeExchange.map((msg)=>`
		  <div style="margin: 5px 0; padding: 5px; background: rgba(0,0,0,0.3); border-radius: 3px;">
			<strong>${msg.from === offerData.initiatorUserId ? offerData.initiatorPortfolioName || (0, $fUPn2.t)('offer.trader', 'Trader') : (0, $fUPn2.t)('offer.you', 'You')}:</strong>
			<span style="font-style: italic;">"${(msg.message ?? '').toString()}"</span>
		  </div>
		`).join('')}
	  </div>
	`;
    const content = document.createElement('div');
    content.style.cssText = `position: relative; z-index: 1; padding: 20px; border-radius: 10px;`;
    content.innerHTML = `
	<div class="tradeOffPop">
	  <h2>${(0, $fUPn2.t)('offer.updated_trade_offer', 'Updated Trade Offer')}</h2>
	  <p>${(0, $fUPn2.t)('offer.offer_sentence_simple', '{name} offers you {offered} and requests {requested} in return.').replace('{name}', offerData.initiatorPortfolioName || (0, $fUPn2.t)('offer.trader', 'Trader')).replace('{offered}', offerData.offeredItemName || (0, $fUPn2.t)('offer.item', 'item')).replace('{requested}', offerData.transactionItemName || (0, $fUPn2.t)('offer.item', 'item'))}</p>
	  ${exchangeHtml}
	  <div style="display: flex; gap: 10px; margin-top: 15px;">
		<button id="finalAccept" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000;
			   border: 1px solid #00ff00; padding: 10px; cursor: pointer;">${(0, $fUPn2.t)('offer.accept', 'Accept')}</button>
		<button id="finalDecline" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff;
			   border: 1px solid #ff0000; padding: 10px; cursor: pointer;">${(0, $fUPn2.t)('offer.decline', 'Decline')}</button>
	  </div>
	</div>
  `;
    popup.appendChild(content);
    document.body.appendChild(popup);
    if (window.popupTracker) window.popupTracker.trackElement(popup, 'updated-trade-offer');
    // Final decision buttons with double-click guard
    const acceptBtn = document.getElementById('finalAccept');
    const declineBtn = document.getElementById('finalDecline');
    let busy = false;
    const setBusy = (state)=>{
        busy = state;
        if (acceptBtn) {
            acceptBtn.disabled = state;
            acceptBtn.style.opacity = state ? '0.6' : '1';
        }
        if (declineBtn) {
            declineBtn.disabled = state;
            declineBtn.style.opacity = state ? '0.6' : '1';
        }
    };
    if (acceptBtn) acceptBtn.onclick = async ()=>{
        if (busy) return;
        setBusy(true);
        try {
            await $5e5d264206c87423$export$c9d68d666177c59c(offerData); // uses window.popupTrackerSocket internally
            popup.remove();
        } catch (error) {
            console.error('Error accepting trade:', error);
            (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.error_accepting_offer', 'Error accepting offer: {message}').replace('{message}', error.message)}`, false);
            setBusy(false);
        }
    };
    if (declineBtn) declineBtn.onclick = async ()=>{
        if (busy) return;
        setBusy(true);
        try {
            await $5e5d264206c87423$export$40e1fe1299acaf1b(offerData); // uses window.popupTrackerSocket internally
            popup.remove();
        } catch (error) {
            console.error('Error declining trade:', error);
            (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.error_declining_offer', 'Error declining offer: {message}').replace('{message}', error.message)}`, false);
            setBusy(false);
        }
    };
}
function $5e5d264206c87423$export$e696bf2320418566(data) {
    if (!data || typeof data !== 'object') {
        console.warn('handleBuyOfferAcceptedByOther: missing/invalid payload', data);
        return;
    }
    // Try to clean up any UI remnants from the offer flow
    [
        'popup-container',
        'offerSentPopup',
        'offerSentOverlay',
        'tradeOfferPopup'
    ].forEach((id)=>{
        const el = document.getElementById(id);
        if (el) {
            // Unregister from popupTracker before removing
            if (window.popupTracker) window.popupTracker.unregisterPopup(id);
            el.remove();
        }
    });
    // Call the global cleanup function if it exists
    if (window.cleanupOfferSentPopup) try {
        window.cleanupOfferSentPopup();
    } catch (e) {
        console.warn('Error calling cleanupOfferSentPopup:', e);
    }
    localStorage.removeItem('pendingOffer');
    // NOTE: Notification is already shown by showProcessingAndResultPopup() in market.js
    // This function only handles cleanup and LED display updates
    // Reflect potential balance changes - LED display updated automatically
    try {
        (0, $eD3DY.updateTotalPointsDisplay)();
    } catch (e) {}
}
// Bot trade offer handler function
// Bot trade offer handler function (robust: handles string/object, de-dupes, ACKs)
function $5e5d264206c87423$var$showBotTradeOffer(tradeDataStrOrObj) {
    try {
        // 1) Parse safely (server may send an object OR a JSON string)
        const raw = typeof tradeDataStrOrObj === 'string' ? JSON.parse(tradeDataStrOrObj) : tradeDataStrOrObj || {};
        // 2) Normalize expected fields (tolerate alternate keys)
        const myId = localStorage.getItem('portfolioId');
        const offerData = {
            initiatorUserId: raw.initiatorUserId ?? raw.botId ?? raw.fromUserId,
            initiatorPortfolioName: raw.initiatorPortfolioName ?? raw.botName ?? (0, $fUPn2.t)('offer.trader', 'Trader'),
            targetUserId: raw.targetUserId ?? raw.toUserId ?? myId,
            offeredItemId: raw.offeredItemId ?? raw.offered_id ?? raw.offerItemId,
            transactionItemId: raw.transactionItemId ?? raw.requested_id ?? raw.requestItemId,
            offeredItemName: raw.offeredItemName ?? raw.offerName ?? (0, $fUPn2.t)('offer.item', 'item'),
            transactionItemName: raw.transactionItemName ?? raw.requestName ?? (0, $fUPn2.t)('offer.item', 'item'),
            narrativeExchange: Array.isArray(raw.narrativeExchange) ? raw.narrativeExchange : raw.exchange || [],
            tradeStory: raw.tradeStory ?? raw.story ?? '',
            expiresAt: raw.expiresAt ?? raw.expireAt ?? null,
            // include all original fields in case your UI needs more
            ...raw
        };
        // 3) Only show if it's actually for this user (when explicitly targeted)
        if (offerData.targetUserId && offerData.targetUserId !== myId) {
            console.warn('Bot trade offer not for this user. Skipping.', {
                myId: myId,
                target: offerData.targetUserId
            });
            return;
        }
        // 4) De-duplicate: compute a stable message id and suppress repeats for 30s
        const msgId = raw.msgId || `${offerData.initiatorUserId || 'bot'}:${myId}:${offerData.offeredItemId || ''}:${offerData.transactionItemId || ''}:${raw.timestamp || ''}`;
        const now = Date.now();
        window._botOfferSeen = window._botOfferSeen || new Map();
        const seen = window._botOfferSeen.get(msgId);
        if (seen && now - seen < 30000) // Already processed recently; skip duplicate
        return;
        window._botOfferSeen.set(msgId, now);
        // Optional prune to prevent unbounded growth
        if (window._botOfferSeen.size > 200) {
            // delete oldest ~50
            let count = 0;
            for (const k of window._botOfferSeen.keys()){
                window._botOfferSeen.delete(k);
                if (++count >= 50) break;
            }
        }
        // 5) ACK back to server that we displayed it (best-effort)
        try {
            const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
            if (s && s.connected) s.emit('ackBotTradeOffer', {
                msgId: msgId,
                recipientId: myId
            }, ()=>{});
        } catch (_) {
        // non-fatal
        }
        // 6) Finally show the popup using your existing UI
        console.log('Bot trade offer (normalized):', offerData);
        $5e5d264206c87423$export$48ca6cbcb2b01599(offerData, myId);
    } catch (error) {
        console.error('Error handling bot trade offer:', error, tradeDataStrOrObj);
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.error_processing_trade', 'Error processing trade offer'), false);
    }
}
// Refresh offer texts when language changes
window.refreshOfferTexts = function() {
    console.log('Refreshing offer texts...');
    // Update any visible offer popups
    const offerPopup = document.getElementById('tradeOfferPopup');
    if (offerPopup) {
        const acceptBtn = offerPopup.querySelector('#acceptOffer');
        const declineBtn = offerPopup.querySelector('#declineOffer');
        if (acceptBtn) acceptBtn.textContent = (0, $fUPn2.t)('offer.accept', 'Accept');
        if (declineBtn) declineBtn.textContent = (0, $fUPn2.t)('offer.decline', 'Decline');
        // Trade popup uses <div id="timer">plain text</div> — keep it plain
        const tradeTimerEl = offerPopup.querySelector('#timer');
        if (tradeTimerEl) {
            const text = (0, $fUPn2.t)('offer.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', tradeTimerEl.textContent || '0');
        // render nearby if you want, or skip since your timer already writes directly
        // tradeTimerEl.textContent = text;
        }
    }
    // Update offer sent popup if present
    const offerSentPopup = document.getElementById('offerSentPopup');
    if (offerSentPopup) {
        const content = offerSentPopup.querySelector('div[style*="position: relative"]');
        if (content) {
            const current = content.querySelector('#offerSentTimer')?.textContent || '10';
            const timerP = content.querySelector('#offerSentTimerText');
            if (timerP) timerP.innerHTML = (0, $fUPn2.t)('offer.time_remaining_html', 'Time remaining: <span id="offerSentTimer">{seconds}</span> seconds').replace('{seconds}', current);
        }
    }
};
// Make functions globally available for integration with your existing system
window.showSocialTradeDialog = $5e5d264206c87423$export$c8555101b1151e80;
window.showBotTradeOffer = $5e5d264206c87423$var$showBotTradeOffer;

});
parcelRegister("cNeIB", function(module, exports) {

$parcel$export(module.exports, "apiBaseUrl", () => $95057a6d002adfe4$export$8ebae31efd30e025);
$parcel$export(module.exports, "apiBaseSocket", () => $95057a6d002adfe4$export$75aa299b0f1eb0a5);
// frontend/config.public.js  (browser-safe; no secrets, no Node deps)
const $95057a6d002adfe4$export$8ebae31efd30e025 = 'https://zexchange.me';
const $95057a6d002adfe4$export$75aa299b0f1eb0a5 = 'wss://zexchange.me';
const $95057a6d002adfe4$export$4c08e273c9d8d8ae = 'https://zexchange.me:8888';

});


parcelRegister("2C8cW", function(module, exports) {

$parcel$export(module.exports, "showRedeemOfferPopup", () => $1e757f4920ee6373$export$e02688e921d36782);
// Ensure imports are correct

var $cJVho = parcelRequire("cJVho");

var $cNeIB = parcelRequire("cNeIB");

var $21EbS = parcelRequire("21EbS");

var $fUPn2 = parcelRequire("fUPn2");

var $eD3DY = parcelRequire("eD3DY");
let $1e757f4920ee6373$var$knownItemIdsAtPageLoad = [];
let $1e757f4920ee6373$var$userHasInteracted = false; // Flag to track if the user has interacted with the popup
// Burst effect state for commodity exchange visuals
let $1e757f4920ee6373$var$burstParticles = [];
let $1e757f4920ee6373$var$burstCanvas = null;
let $1e757f4920ee6373$var$burstAnimationFrame = null;
// Commodity Exchange Burst Effect - creates animated particles
function $1e757f4920ee6373$var$createBurstEffect(container) {
    // Create canvas for burst particles
    $1e757f4920ee6373$var$burstCanvas = document.createElement('canvas');
    $1e757f4920ee6373$var$burstCanvas.style.cssText = `
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
	z-index: 2;
  `;
    container.appendChild($1e757f4920ee6373$var$burstCanvas);
    const ctx = $1e757f4920ee6373$var$burstCanvas.getContext('2d');
    $1e757f4920ee6373$var$burstCanvas.width = container.offsetWidth;
    $1e757f4920ee6373$var$burstCanvas.height = container.offsetHeight;
    // Create initial burst particles
    const particleCount = 30;
    for(let i = 0; i < particleCount; i++)$1e757f4920ee6373$var$burstParticles.push({
        x: Math.random() * $1e757f4920ee6373$var$burstCanvas.width,
        y: Math.random() * $1e757f4920ee6373$var$burstCanvas.height,
        vx: (Math.random() - 0.5) * 2,
        vy: (Math.random() - 0.5) * 2,
        life: Math.random() * 100 + 100,
        maxLife: 200,
        size: Math.random() * 3 + 2,
        hue: 120 + Math.random() * 40 // Green range
    });
    // Animation loop
    function animate() {
        ctx.clearRect(0, 0, $1e757f4920ee6373$var$burstCanvas.width, $1e757f4920ee6373$var$burstCanvas.height);
        $1e757f4920ee6373$var$burstParticles.forEach((particle, index)=>{
            // Update position
            particle.x += particle.vx;
            particle.y += particle.vy;
            particle.life--;
            // Bounce off edges
            if (particle.x < 0 || particle.x > $1e757f4920ee6373$var$burstCanvas.width) particle.vx *= -1;
            if (particle.y < 0 || particle.y > $1e757f4920ee6373$var$burstCanvas.height) particle.vy *= -1;
            // Draw particle with glow
            const alpha = particle.life / particle.maxLife;
            ctx.save();
            ctx.shadowBlur = 15;
            ctx.shadowColor = `hsla(${particle.hue}, 100%, 50%, ${alpha})`;
            ctx.fillStyle = `hsla(${particle.hue}, 100%, 50%, ${alpha * 0.8})`;
            ctx.beginPath();
            ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
            ctx.fill();
            ctx.restore();
            // Remove dead particles and spawn new ones
            if (particle.life <= 0) $1e757f4920ee6373$var$burstParticles[index] = {
                x: Math.random() * $1e757f4920ee6373$var$burstCanvas.width,
                y: Math.random() * $1e757f4920ee6373$var$burstCanvas.height,
                vx: (Math.random() - 0.5) * 2,
                vy: (Math.random() - 0.5) * 2,
                life: Math.random() * 100 + 100,
                maxLife: 200,
                size: Math.random() * 3 + 2,
                hue: 120 + Math.random() * 40
            };
        });
        $1e757f4920ee6373$var$burstAnimationFrame = requestAnimationFrame(animate);
    }
    animate();
}
// Clean up burst effect
function $1e757f4920ee6373$var$cleanupBurstEffect() {
    if ($1e757f4920ee6373$var$burstAnimationFrame) {
        cancelAnimationFrame($1e757f4920ee6373$var$burstAnimationFrame);
        $1e757f4920ee6373$var$burstAnimationFrame = null;
    }
    if ($1e757f4920ee6373$var$burstCanvas) {
        $1e757f4920ee6373$var$burstCanvas.remove();
        $1e757f4920ee6373$var$burstCanvas = null;
    }
    $1e757f4920ee6373$var$burstParticles = [];
}
async function $1e757f4920ee6373$export$e02688e921d36782(data) {
    console.log('Redeem offer received:', data);
    // Ensure socket is up (no-op if already connected)
    try {
        (0, $cJVho.connectWebSocket)?.();
    } catch (_) {}
    // Remove any existing popup
    const existingPopup = document.getElementById("redeemOfferPopup");
    if (existingPopup) existingPopup.remove();
    // Build popup shell
    const RedeemPopup = document.createElement("div");
    RedeemPopup.id = "redeemOfferPopup";
    RedeemPopup.style.cssText = `
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10001;
	font-family: 'bithigh', Arial, sans-serif;
	color: #00ff00;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background: linear-gradient(135deg, rgba(0, 40, 80, 0.95) 0%, rgba(0, 0, 0, 0.98) 100%);
  `;
    // Background video
    const video = document.createElement("video");
    video.id = "redeemPopupBackground";
    video.style.cssText = `
	position: absolute; top: 0; left: 0; width: 100%; height: 100%;
	object-fit: cover; z-index: -1; pointer-events: none; user-select: none;
  `;
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    RedeemPopup.appendChild(video);
    // Foreground content with enhanced styling
    const content = document.createElement("div");
    content.id = "redeemContentBox";
    content.style.cssText = `
	position: relative;
	z-index: 3;
	padding: 40px 30px;
	background: linear-gradient(135deg, rgba(0, 40, 80, 0.85) 0%, rgba(0, 0, 0, 0.92) 100%);
	border: 3px solid #00ff00;
	border-radius: 8px;
	max-width: 85%;
	width: 500px;
	box-shadow:
	  0 0 30px rgba(0, 255, 0, 0.6),
	  inset 0 0 20px rgba(0, 255, 0, 0.1);
	animation: pulseGlow 2s ease-in-out infinite;
  `;
    // Get offer details
    const senderName = $1e757f4920ee6373$var$sanitize(data?.senderName || 'Unknown');
    const itemName = $1e757f4920ee6373$var$sanitize(data?.itemName || 'Unknown Item');
    content.innerHTML = `
	<div style="margin-bottom: 20px; font-size: 0.85rem; color: #00ff00; opacity: 0.7; letter-spacing: 2px;">
	  INCOMING COMMODITY EXCHANGE
	</div>
	<h2 style="color: #00ff00; font-size: 1.8rem; margin: 20px 0; text-shadow: 0 0 10px rgba(0, 255, 0, 0.8);">
	  ${(0, $fUPn2.t)('Redemption Offer', 'Redemption Offer')}
	</h2>
	<div style="background: rgba(0, 255, 0, 0.1); border: 1px solid #00ff00; border-radius: 5px; padding: 15px; margin: 20px 0;">
	  <p style="color: #00ff00; font-size: 1rem; margin: 8px 0;">
		<strong>${(0, $fUPn2.t)('From:', 'From:')}</strong> ${senderName}
	  </p>
	  <p style="color: #00ff00; font-size: 1rem; margin: 8px 0;">
		<strong>${(0, $fUPn2.t)('Commodity:', 'Commodity:')}</strong> ${itemName}
	  </p>
	</div>
	<div style="display: flex; gap: 15px; justify-content: center; margin-top: 30px;">
	  <button id="acceptRedeemButton" style="
		flex: 1;
		max-width: 180px;
		padding: 15px 25px;
		background: linear-gradient(135deg, rgba(0, 100, 0, 0.9) 0%, rgba(0, 50, 0, 0.9) 100%);
		border: 2px solid #00ff00;
		border-radius: 5px;
		color: #00ff00;
		font-family: 'bithigh', sans-serif;
		font-size: 1.1rem;
		cursor: pointer;
		box-shadow: 0 0 15px rgba(0, 255, 0, 0.4);
		transition: all 0.3s ease;
		text-shadow: 0 0 5px rgba(0, 255, 0, 0.6);
	  " onmouseover="this.style.boxShadow='0 0 25px rgba(0, 255, 0, 0.8)'; this.style.transform='scale(1.05)'" onmouseout="this.style.boxShadow='0 0 15px rgba(0, 255, 0, 0.4)'; this.style.transform='scale(1)'">
		\u{2713} ${(0, $fUPn2.t)('Accept', 'Accept')}
	  </button>
	  <button id="declineRedeemButton" style="
		flex: 1;
		max-width: 180px;
		padding: 15px 25px;
		background: linear-gradient(135deg, rgba(100, 0, 0, 0.9) 0%, rgba(50, 0, 0, 0.9) 100%);
		border: 2px solid #ff6666;
		border-radius: 5px;
		color: #ff6666;
		font-family: 'bithigh', sans-serif;
		font-size: 1.1rem;
		cursor: pointer;
		box-shadow: 0 0 15px rgba(255, 0, 0, 0.4);
		transition: all 0.3s ease;
		text-shadow: 0 0 5px rgba(255, 0, 0, 0.6);
	  " onmouseover="this.style.boxShadow='0 0 25px rgba(255, 0, 0, 0.8)'; this.style.transform='scale(1.05)'" onmouseout="this.style.boxShadow='0 0 15px rgba(255, 0, 0, 0.4)'; this.style.transform='scale(1)'">
		\u{2715} ${(0, $fUPn2.t)('Decline', 'Decline')}
	  </button>
	</div>
	<div id="timer" style="font-size: 1.5rem; text-align: center; color: #00ff00; margin-top: 25px; font-weight: bold; text-shadow: 0 0 15px rgba(0, 255, 0, 0.9);"></div>
  `;
    // Add pulsing glow animation
    const style = document.createElement('style');
    style.textContent = `
	@keyframes pulseGlow {
	  0%, 100% {
		box-shadow:
		  0 0 30px rgba(0, 255, 0, 0.6),
		  inset 0 0 20px rgba(0, 255, 0, 0.1);
		border-color: #00ff00;
	  }
	  50% {
		box-shadow:
		  0 0 50px rgba(0, 255, 0, 0.9),
		  0 0 100px rgba(0, 255, 0, 0.4),
		  inset 0 0 30px rgba(0, 255, 0, 0.2);
		border-color: #00ff66;
	  }
	}
  `;
    document.head.appendChild(style);
    const escHandler = (e)=>{
        if (e.key === 'Escape') {
            cleanup();
            document.removeEventListener('keydown', escHandler);
        }
    };
    document.addEventListener('keydown', escHandler);
    RedeemPopup.addEventListener('click', (e)=>{
        // only close if the click is on the outer container (not content)
        if (e.target === RedeemPopup) cleanup();
    });
    RedeemPopup.appendChild(content);
    document.body.appendChild(RedeemPopup);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    // Start burst particle effect
    $1e757f4920ee6373$var$createBurstEffect(content);
    function cleanup() {
        clearInterval(timerInterval);
        $1e757f4920ee6373$var$cleanupBurstEffect();
        if (RedeemPopup && RedeemPopup.parentNode) RedeemPopup.parentNode.removeChild(RedeemPopup);
        document.body.style.overflow = prevOverflow;
        document.removeEventListener('keydown', escHandler);
    }
    // Load random background video
    try {
        const videoBaseUrl = `${(0, $cNeIB.apiBaseUrl)}/uploads/specialBacks/redeemBack/`;
        const totalVideos = 45;
        const videoIndex = Math.floor(Math.random() * totalVideos) + 1;
        const videoUrl = `${videoBaseUrl}${videoIndex}/playlist.m3u8`;
        if (window.Hls && window.Hls.isSupported()) {
            const hls = new window.Hls();
            hls.loadSource(videoUrl);
            hls.attachMedia(video);
            hls.on(window.Hls.Events.MANIFEST_PARSED, ()=>video.play().catch(()=>{}));
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = videoUrl;
            video.addEventListener('loadedmetadata', ()=>video.play().catch(()=>{}));
        }
    } catch (e) {
        // Non-fatal
        console.warn('Redeem background video load error:', e);
    }
    // Timer with enhanced formatting
    const timerElement = document.getElementById('timer');
    let remainingTime = Number(data?.timeoutSeconds) || 10;
    const tick = ()=>{
        if (timerElement) {
            const secondsLabel = remainingTime === 1 ? (0, $fUPn2.t)('second', 'second') : (0, $fUPn2.t)('seconds', 'seconds');
            timerElement.textContent = `${remainingTime} ${secondsLabel}`;
        }
    };
    tick();
    const timerInterval = setInterval(()=>{
        remainingTime -= 1;
        tick();
        if (remainingTime <= 0) {
            clearInterval(timerInterval);
            if (timerElement) {
                timerElement.textContent = (0, $fUPn2.t)('Time expired', 'Time expired');
                timerElement.style.color = '#ff6666';
                timerElement.style.textShadow = '0 0 15px rgba(255, 0, 0, 0.9)';
            }
            setTimeout(()=>cleanup(), 1000); // Brief delay before closing
        }
    }, 1000);
    // Helpers
    const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
    const myPortfolioId = localStorage.getItem('portfolioId') || '';
    const initiatorUserId = $1e757f4920ee6373$var$sanitize(data?.initiatorUserId);
    const preselectedItemId = $1e757f4920ee6373$var$sanitize(data?.preselectedItems?.[0]?.itemId ?? data?.preselectedItemId);
    const preselectedItemName = $1e757f4920ee6373$var$sanitize(data?.preselectedItems?.[0]?.itemName ?? data?.preselectedItemName);
    const offeredItemId = $1e757f4920ee6373$var$sanitize(data?.itemId);
    const transactionItemId = $1e757f4920ee6373$var$sanitize(data?.itemId);
    async function postDecision(url, pointsAdjustment) {
        return fetch(`${(0, $cNeIB.apiBaseUrl)}${url}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            body: JSON.stringify({
                initiatorUserId: initiatorUserId,
                targetUserId: myPortfolioId,
                pointsAdjustment: pointsAdjustment,
                preselectedItemId: preselectedItemId,
                preselectedItemName: preselectedItemName,
                offeredItemId: offeredItemId,
                transactionItemId: transactionItemId
            })
        });
    }
    function emitDecision(accepted) {
        if (!s || !s.connected) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('redeem.ws_not_connected', 'Not connected. Please try again.'), false);
            return;
        }
        s.emit('redeemResponse', {
            accepted: accepted,
            preselectedItemId: preselectedItemId,
            preselectedItemName: preselectedItemName,
            initiatorUserId: initiatorUserId,
            targetUserId: myPortfolioId
        }, (ack)=>{
            if (ack && ack.success === false) {
                console.error('redeemResponse ack error:', ack.error);
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('redeem.notify_failed', 'Failed to notify initiator.'), false);
            }
        });
    }
    // Wire buttons
    const acceptButton = document.getElementById("acceptRedeemButton");
    const declineButton = document.getElementById("declineRedeemButton");
    if (acceptButton) acceptButton.addEventListener('click', async ()=>{
        clearInterval(timerInterval);
        try {
            const resp = await postDecision('/api/acceptRedemption', 70);
            if (!resp.ok) {
                console.error('Failed to accept redeem.', await resp.text());
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('redeem.accept_failed', 'Failed to accept redemption.'), false);
            } else {
                console.log('Redeem accepted successfully.');
                emitDecision(true);
            }
        } catch (err) {
            console.error('Error accepting redeem:', err);
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('redeem.accept_failed', 'Failed to accept redemption.'), false);
        }
        cleanup();
    });
    if (declineButton) declineButton.addEventListener('click', async ()=>{
        clearInterval(timerInterval);
        try {
            const resp = await postDecision('/api/declineRedemption', -70);
            if (!resp.ok) {
                console.error('Failed to decline redeem.', await resp.text());
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('redeem.decline_failed', 'Failed to decline redemption.'), false);
            } else {
                console.log('Redeem declined successfully.');
                emitDecision(false);
            }
        } catch (err) {
            console.error('Error declining redeem:', err);
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('redeem.decline_failed', 'Failed to decline redemption.'), false);
        }
        cleanup();
    });
    // Block interactions with the background video
    [
        'click',
        'dblclick',
        'contextmenu'
    ].forEach((evt)=>video.addEventListener(evt, (e)=>{
            e.stopPropagation();
            e.preventDefault();
        }));
}
function $1e757f4920ee6373$var$sanitize(input) {
    const div = document.createElement('div');
    div.textContent = (input ?? '').toString();
    return div.innerHTML;
}

});

parcelRegister("jL4uR", function(module, exports) {

$parcel$export(module.exports, "showTaxDecisionPopup", () => $e625e50e5a3be76b$export$2fc91085295dc61);
$parcel$export(module.exports, "displayNotification", () => $e625e50e5a3be76b$export$6c932663eba61047);
$parcel$export(module.exports, "showPointsDeductedNotification", () => $e625e50e5a3be76b$export$3695e4081b3eabdd);
$parcel$export(module.exports, "showItemSelectedAssign", () => $e625e50e5a3be76b$export$25c21df5493fc2da);
$parcel$export(module.exports, "showPointsAssignedNotification", () => $e625e50e5a3be76b$export$4b96634ee2744b8b);
$parcel$export(module.exports, "showZollarSelectedAssign", () => $e625e50e5a3be76b$export$e859aac445856345);

var $5W4EI = parcelRequire("5W4EI");

var $21EbS = parcelRequire("21EbS");

var $fUPn2 = parcelRequire("fUPn2");

var $15BR8 = parcelRequire("15BR8");
globalThis.ZTranslations = globalThis.ZTranslations || (0, $15BR8.default);
function $e625e50e5a3be76b$var$_get(obj, pathArr) {
    return pathArr.reduce((o, k)=>o && o[k] !== undefined ? o[k] : undefined, obj);
}
function $e625e50e5a3be76b$var$T(key, fallback = '') {
    try {
        const res = (0, $fUPn2.t)(key, null);
        if (typeof res === 'string' && res && res !== key) return res;
    } catch (_) {}
    const lang = globalThis.Z_LANG || globalThis.Z_LOCALE || localStorage.getItem('language') || localStorage.getItem('locale') || (navigator.language || '').slice(0, 2) || 'en';
    const dict = (0, $15BR8.default)?.[lang] || (0, $15BR8.default)?.fr || (0, $15BR8.default)?.en || null;
    if (dict) {
        const val = $e625e50e5a3be76b$var$_get(dict, key.split('.'));
        if (typeof val === 'string' && val) return val;
    }
    return fallback || key;
}
const $e625e50e5a3be76b$var$tx = (k, fb)=>$e625e50e5a3be76b$var$T(`tax.${k}`, fb);
// Qualitative descriptor function for Zollars (users see descriptions, not numbers)
function $e625e50e5a3be76b$var$getQualitativeDescriptor(quantity, max) {
    const q = Number(quantity) || 0;
    const m = Number(max);
    if (q <= 0) return 'None';
    if (m && m > 0) {
        const r = q / m;
        if (r <= 0.01) return 'None';
        if (r <= 0.03) return 'Barely Any';
        if (r <= 0.07) return 'A Trace';
        if (r <= 0.12) return 'A Hint';
        if (r <= 0.18) return 'A Little';
        if (r <= 0.26) return 'A Few';
        if (r <= 0.33) return 'Some';
        if (r <= 0.40) return 'Several';
        if (r <= 0.50) return 'Moderate';
        if (r <= 0.58) return 'Noticeable';
        if (r <= 0.65) return 'Considerable';
        if (r <= 0.72) return 'Many';
        if (r <= 0.78) return 'A Lot';
        if (r <= 0.83) return 'Abundant';
        if (r <= 0.88) return 'Heaps';
        if (r <= 0.92) return 'A Great Deal';
        if (r <= 0.95) return 'Almost All';
        if (r <= 0.97) return 'Nearly Everything';
        if (r <= 0.985) return 'Overflowing';
        if (r <= 0.995) return 'Virtually Everything';
        return 'All You Have';
    }
    if (q <= 0) return 'None';
    if (q <= 1) return 'Barely Any';
    if (q <= 2) return 'A Trace';
    if (q <= 3) return 'A Hint';
    if (q <= 4) return 'A Little';
    if (q <= 6) return 'A Few';
    if (q <= 9) return 'Some';
    if (q <= 12) return 'Several';
    if (q <= 16) return 'Moderate';
    if (q <= 20) return 'Noticeable';
    if (q <= 26) return 'Considerable';
    if (q <= 33) return 'Many';
    if (q <= 40) return 'A Lot';
    if (q <= 55) return 'Abundant';
    if (q <= 70) return 'Heaps';
    if (q <= 90) return 'A Great Deal';
    if (q <= 120) return 'Substantial';
    if (q <= 160) return 'Ample';
    if (q <= 210) return 'Extensive';
    if (q <= 260) return 'Vast';
    if (q <= 320) return 'Profuse';
    if (q <= 380) return 'Almost All';
    if (q <= 440) return 'Nearly Everything';
    if (q <= 490) return 'Virtually Everything';
    return 'All You Have';
}
let $e625e50e5a3be76b$var$taxEventInProgress = false;
function $e625e50e5a3be76b$export$2fc91085295dc61(userId, pointAmount, zollarAmount) {
    console.log('showTaxDecisionPopup called with userId:', userId, 'pointAmount:', pointAmount, 'zollarAmount:', zollarAmount);
    if ($e625e50e5a3be76b$var$taxEventInProgress) return;
    $e625e50e5a3be76b$var$taxEventInProgress = true;
    $e625e50e5a3be76b$export$a67e7b472120cdc7(userId, pointAmount, zollarAmount);
}
// Function to directly proceed with points deduction if no items are available
function $e625e50e5a3be76b$var$directlyProceedWithPointsDecision(userId) {
    const userWantsToGiveItem = confirm((0, $fUPn2.t)('tax.tax_call_no_assets', 'Zederal Reserve has issued a tax call. Press OK to lose capital, no assets available for payment.'));
    if (!userWantsToGiveItem) $e625e50e5a3be76b$var$submitUserDecision(userId, 'points', null);
}
function $e625e50e5a3be76b$export$a67e7b472120cdc7(userId, pointAmount, zollarAmount) {
    console.log('showTaxPrompt called for user:', userId);
    $e625e50e5a3be76b$var$removeExistingTaxModal();
    $e625e50e5a3be76b$var$renderDecisionModal(userId, pointAmount, zollarAmount);
    $e625e50e5a3be76b$var$initiateCountdown(userId, 10, pointAmount, zollarAmount);
}
// Function to render the decision modal
function $e625e50e5a3be76b$var$renderDecisionModal(userId, pointAmount, zollarAmount) {
    console.log('Rendering decision modal for user:', userId, 'with pointAmount:', pointAmount, 'zollarAmount:', zollarAmount);
    // Ensure minimum of 1 zollar if not specified
    const actualZollarAmount = Math.max(1, zollarAmount || 1);
    // Convert zollar amount to qualitative descriptor (users don't see numbers for Zollars)
    const zollarDescriptor = $e625e50e5a3be76b$var$getQualitativeDescriptor(actualZollarAmount);
    const decisionModalHTML = `
	<div id="taxDecisionModal" class="tax-modal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.8); display: flex; justify-content: center; align-items: center; z-index: 99999;">
	  <div class="tax-modal-content" style="background-color: #000; padding: 20px; border: 2px solid #00ff00; border-radius: 10px; text-align: center; color: #00ff00; max-width: 92vw;">
		<p class="zx-sec-explain" style="text-align:left;max-width:420px;margin:0 auto 10px;">${(0, $fUPn2.t)('floor.exp_tax', "This is the Zederal Reserve \u2014 the market's system player. It taxes every trader from time to time. Choose what to give up before the timer runs out, or it takes both.")}</p>
		<p>${(0, $fUPn2.t)('tax.tax_alert_timer', 'TAX ALERT! You have 10 seconds to choose or lose both:')}</p>
		<p id="countdown" style="font-size: 24px; font-weight: bold;">10</p>
		<button id="deductPoints" style="margin: 5px; padding: 15px; background-color: #333; color: #00ff00; border: 1px solid #00ff00; min-width: 250px; line-height: 1.5; cursor: pointer;">
		  <div style="font-weight: bold; margin-bottom: 8px; pointer-events: none;">${(0, $fUPn2.t)('tax.lose_capital_zollars', 'Lose capital & Zollars')}</div>
		  <div style="font-size: 12px; margin-bottom: 3px; pointer-events: none;">${pointAmount} capital</div>
		  <div style="font-size: 12px; pointer-events: none;">${zollarDescriptor} relationship zollars</div>
		</button>
		<button id="giveRandomItem" style="margin: 5px; padding: 10px; background-color: #333; color: #00ff00; border: 1px solid #00ff00; min-width: 250px; cursor: pointer;">
		  <span style="pointer-events: none;">${(0, $fUPn2.t)('tax.give_random_asset', 'Give random asset')}</span>
		</button>
	  </div>
	</div>
  `;
    document.body.insertAdjacentHTML('beforeend', decisionModalHTML);
    console.log('Decision modal rendered');
}
function $e625e50e5a3be76b$var$initiateCountdown(userId, timeLeft, pointAmount, zollarAmount) {
    console.log('Initiating countdown for user:', userId);
    const startTime = new Date();
    // Ensure minimum of 1 zollar
    const actualZollarAmount = Math.max(1, zollarAmount || 1);
    localStorage.setItem('taxDecisionState', JSON.stringify({
        userId: userId,
        timeLeft: timeLeft,
        startTime: startTime,
        pointAmount: pointAmount,
        zollarAmount: actualZollarAmount
    }));
    const countdownTimer = setInterval(()=>{
        const countdownElement = document.getElementById("countdown");
        if (countdownElement) countdownElement.textContent = Math.max(0, timeLeft);
        if (timeLeft <= 0) {
            clearInterval(countdownTimer);
            console.log('Countdown finished, enforcing tax decision');
            $e625e50e5a3be76b$var$enforceTaxDecision(userId, pointAmount, actualZollarAmount);
        }
        timeLeft--;
    }, 1000);
    document.getElementById('taxDecisionModal').addEventListener('click', (event)=>{
        if (event.target.id === 'deductPoints' || event.target.id === 'giveRandomItem') {
            console.log(`User clicked ${event.target.id}`);
            $e625e50e5a3be76b$var$handleDecision(userId, event.target.id === 'deductPoints' ? 'points' : 'item', countdownTimer, pointAmount, actualZollarAmount);
        }
    });
}
function $e625e50e5a3be76b$var$handleDecision(userId, decision, countdownTimer, pointAmount, zollarAmount) {
    console.log(`Handling decision for user ${userId}: ${decision}`);
    clearInterval(countdownTimer);
    $e625e50e5a3be76b$var$submitUserDecision(userId, decision, null, pointAmount, zollarAmount);
    $e625e50e5a3be76b$var$removeDecisionModal();
}
function $e625e50e5a3be76b$var$removeExistingTaxModal() {
    const existingModal = document.getElementById("taxDecisionModal");
    if (existingModal) existingModal.remove();
    localStorage.removeItem('taxDecisionState');
}
function $e625e50e5a3be76b$var$removeDecisionModal() {
    console.log('Removing decision modal');
    const existingModal = document.getElementById("taxDecisionModal");
    if (existingModal) existingModal.remove();
    localStorage.removeItem('taxDecisionState');
    $e625e50e5a3be76b$var$taxEventInProgress = false;
}
function $e625e50e5a3be76b$var$enforceTaxDecision(userId, pointAmount, zollarAmount) {
    $e625e50e5a3be76b$var$submitUserDecision(userId, "both", null, pointAmount, zollarAmount);
    $e625e50e5a3be76b$var$removeDecisionModal();
}
function $e625e50e5a3be76b$var$submitUserDecision(userId, decision, itemId, pointAmount, zollarAmount) {
    const sessionId = localStorage.getItem('sessionId');
    const decisionData = {
        userId: userId,
        decision: decision,
        itemId: itemId || undefined,
        sessionId: sessionId,
        pointAmount: pointAmount,
        zollarAmount: zollarAmount
    };
    fetch(`${(0, $5W4EI.apiBaseUrl)}/api/boss/userDecision`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
        },
        body: JSON.stringify(decisionData)
    }).then(async (response)=>{
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const text = await response.text();
        try {
            return JSON.parse(text);
        } catch (e) {
            console.error("Could not parse JSON:", text);
            throw e;
        }
    }).then((data)=>{
        console.log("Decision submitted:", data.message);
        $e625e50e5a3be76b$var$showAlertTax(data.message);
    }).catch((error)=>console.error('Error submitting decision:', error));
}
// Function to show an alert after submitting the tax decision
function $e625e50e5a3be76b$var$showAlertTax(message) {
    const alertOverlay = document.createElement('div');
    alertOverlay.style.position = 'fixed';
    alertOverlay.style.top = '0';
    alertOverlay.style.left = '0';
    alertOverlay.style.width = '100vw';
    alertOverlay.style.height = '100vh';
    alertOverlay.style.backgroundColor = 'rgba(0, 0, 0, 1)'; // Black background
    alertOverlay.style.display = 'flex';
    alertOverlay.style.alignItems = 'center';
    alertOverlay.style.justifyContent = 'center';
    alertOverlay.style.zIndex = '99999';
    const alertBox = document.createElement('div');
    alertBox.style.backgroundColor = '#000'; // Black background
    alertBox.style.padding = '20px 40px';
    alertBox.style.border = '2px solid #00ff00'; // Green border
    alertBox.style.borderRadius = '10px';
    alertBox.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
    alertBox.style.textAlign = 'center';
    alertBox.style.maxWidth = '80%'; // Adjust the max-width
    alertBox.style.color = '#00ff00'; // Green text
    alertBox.innerText = message;
    alertOverlay.appendChild(alertBox);
    document.body.appendChild(alertOverlay);
    setTimeout(()=>{
        alertOverlay.remove();
    }, 3500);
}
let $e625e50e5a3be76b$var$isNotificationDisplayed = false;
const $e625e50e5a3be76b$var$userLocks = {};
function $e625e50e5a3be76b$var$debounceAsync(func, delay) {
    let timeoutId;
    let isExecuting = false;
    let pendingArgs = null;
    const execute = async (args, resolve, reject)=>{
        isExecuting = true;
        console.log('Executing function with args:', args);
        try {
            await func(...args);
            resolve();
        } catch (error) {
            reject(error);
        } finally{
            isExecuting = false;
            if (pendingArgs) {
                const nextArgs = pendingArgs;
                pendingArgs = null;
                execute(nextArgs.args, nextArgs.resolve, nextArgs.reject);
            }
        }
    };
    return (...args)=>{
        return new Promise((resolve, reject)=>{
            if (isExecuting) {
                pendingArgs = {
                    args: args,
                    resolve: resolve,
                    reject: reject
                };
                return;
            }
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(()=>{
                execute(args, resolve, reject);
            }, delay);
        });
    };
}
const $e625e50e5a3be76b$var$assignQueue = $e625e50e5a3be76b$var$debounceAsync(async function(userId) {
    if ($e625e50e5a3be76b$var$userLocks[userId] || $e625e50e5a3be76b$var$isNotificationDisplayed) return;
    $e625e50e5a3be76b$var$userLocks[userId] = true;
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/boss/assignNewItem`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            }
        });
        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse.message || (0, $fUPn2.t)('tax.assign_failed', 'Failed to assign new item to all portfolios.'));
        }
        $e625e50e5a3be76b$export$6c932663eba61047((0, $fUPn2.t)('tax.new_asset_assigned', 'Zederal Reserve has assigned a new asset to your portfolio.'));
    } catch (error) {
        console.error(`Error during commondity assignment process for user ${userId}:`, error);
    } finally{
        $e625e50e5a3be76b$var$userLocks[userId] = false;
    }
}, 1000);
const $e625e50e5a3be76b$export$f740b4822616dff0 = $e625e50e5a3be76b$var$debounceAsync(async function() {
    if ($e625e50e5a3be76b$var$isNotificationDisplayed) return;
    $e625e50e5a3be76b$export$6c932663eba61047((0, $fUPn2.t)('tax.new_asset_assigned', 'Zederal Reserve has assigned a new asset to your portfolio.'));
}, 1000);
let $e625e50e5a3be76b$var$isItemIssued = false;
let $e625e50e5a3be76b$var$userItemIssued = {};
let $e625e50e5a3be76b$var$userPointsIssued = {};
const $e625e50e5a3be76b$export$19ed5f257772fcea = $e625e50e5a3be76b$var$debounceAsync(async function(userId, portfolioIds) {
    if ($e625e50e5a3be76b$var$userLocks[userId] || $e625e50e5a3be76b$var$isNotificationDisplayed) return;
    if (!portfolioIds || portfolioIds.length === 0) return;
    $e625e50e5a3be76b$var$userLocks[userId] = true;
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/boss/taxSingleItem`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            body: JSON.stringify({
                portfolioIds: portfolioIds
            })
        });
        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse.message || 'Failed to notify the backend.');
        }
        const responseData = await response.json();
        console.log('Tax single item response:', responseData);
        if (responseData.removedItems && responseData.removedItems.length > 0) {
            $e625e50e5a3be76b$export$6c932663eba61047((0, $fUPn2.t)('tax.asset_taxed', 'You have been taxed an asset by the Zederal Reserve.'));
            $e625e50e5a3be76b$var$userItemIssued[userId] = false;
            $e625e50e5a3be76b$var$isItemIssued = false;
        } else $e625e50e5a3be76b$export$6c932663eba61047((0, $fUPn2.t)('tax.no_items_available', 'No non-traded items available for taxation.'));
    } catch (error) {
        console.error('Error during item taxing:', error);
        $e625e50e5a3be76b$export$6c932663eba61047((0, $fUPn2.t)('tax.tax_item_failed', 'Failed to tax an item.'), false);
    } finally{
        $e625e50e5a3be76b$var$userLocks[userId] = false;
    }
}, 1000);
const $e625e50e5a3be76b$export$3695e4081b3eabdd = $e625e50e5a3be76b$var$debounceAsync(async function(portfolioIds, points, message) {
    if (!portfolioIds || portfolioIds.length === 0 || !points || isNaN(points) || points <= 0) return;
    const defaultMsg = `${(0, $fUPn2.t)('tax.capital_taxed_prefix', 'You have been taxed capital by the Zederal Reserve!')} ${points} ${(0, $fUPn2.t)('tax.points', 'capitaux')}`;
    $e625e50e5a3be76b$export$6c932663eba61047(message || defaultMsg);
}, 1000);
const $e625e50e5a3be76b$export$25c21df5493fc2da = $e625e50e5a3be76b$var$debounceAsync(async function(portfolioIds, message) {
    if (!portfolioIds || portfolioIds.length === 0) return;
    $e625e50e5a3be76b$export$6c932663eba61047(message || (0, $fUPn2.t)('tax.new_asset_received', 'You have received a new asset from the Zederal Reserve'));
}, 1000);
const $e625e50e5a3be76b$export$4b96634ee2744b8b = $e625e50e5a3be76b$var$debounceAsync(async function(portfolioIds, points) {
    if (!portfolioIds || portfolioIds.length === 0 || !points || isNaN(points) || points <= 0) return;
    const msg = `${(0, $fUPn2.t)('tax.refund_received_prefix', 'You have received a refund of capital from the Zederal Reserve')} ${points} ${(0, $fUPn2.t)('tax.points', 'Capital')}`;
    $e625e50e5a3be76b$export$6c932663eba61047(msg);
}, 1000);
const $e625e50e5a3be76b$export$e859aac445856345 = $e625e50e5a3be76b$var$debounceAsync(async function(portfolioIds, message, amount) {
    if (!portfolioIds || portfolioIds.length === 0) return;
    const amt = Number(amount) > 0 ? Number(amount) : null;
    const fallback = amt ? `${(0, $fUPn2.t)('tax.zollar_assigned', 'You have received Zollars from the Zederal Reserve.')} (+${amt})` : (0, $fUPn2.t)('tax.zollar_assigned', 'You have received Zollars from the Zederal Reserve.');
    $e625e50e5a3be76b$export$6c932663eba61047(message || fallback);
}, 1000);
function $e625e50e5a3be76b$export$6c932663eba61047(message) {
    if ($e625e50e5a3be76b$var$isNotificationDisplayed) return;
    $e625e50e5a3be76b$var$isNotificationDisplayed = true;
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 1)';
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.zIndex = '99999';
    const notification = document.createElement('div');
    notification.textContent = message;
    notification.style.backgroundColor = '#000';
    notification.style.padding = '20px 40px';
    notification.style.border = '2px solid #00ff00';
    notification.style.borderRadius = '10px';
    notification.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
    notification.style.textAlign = 'center';
    notification.style.maxWidth = '80%';
    notification.style.color = '#00ff00';
    overlay.appendChild(notification);
    document.body.appendChild(overlay);
    setTimeout(()=>{
        overlay.remove();
        $e625e50e5a3be76b$var$isNotificationDisplayed = false;
    }, 2000);
}
window.showtaxSingleItem = $e625e50e5a3be76b$export$19ed5f257772fcea;
window.showPointsDeductedNotification = $e625e50e5a3be76b$export$3695e4081b3eabdd;
window.showItemSelectedAssign = $e625e50e5a3be76b$export$25c21df5493fc2da;
window.showPointsAssignedNotification = $e625e50e5a3be76b$export$4b96634ee2744b8b;
window.showZollarSelectedAssign = $e625e50e5a3be76b$export$e859aac445856345;

});

parcelRegister("1cx8d", function(module, exports) {

$parcel$export(module.exports, "showMementoMoriAnnouncement", () => $0e009ca592c858ec$export$76e9e1d001f81ca4);
$parcel$export(module.exports, "checkAndRestoreMementoMori", () => $0e009ca592c858ec$export$3392fc08bb337b13);
$parcel$export(module.exports, "checkAndShowMementoMori", () => $0e009ca592c858ec$export$d0a3225c3d52d92a);
$parcel$export(module.exports, "cleanupMementoMoriTimer", () => $0e009ca592c858ec$export$3e536f1cccf2aff1);
//frontend/js/objectives.js

var $6pKgs = parcelRequire("6pKgs");

var $cJVho = parcelRequire("cJVho");

var $5W4EI = parcelRequire("5W4EI");

var $fUPn2 = parcelRequire("fUPn2");
let $0e009ca592c858ec$var$mementoMoriTimer = null;
let $0e009ca592c858ec$var$mementoMoriData = null;
let $0e009ca592c858ec$var$oracleQuestionHistory = [];
let $0e009ca592c858ec$var$mementoMoriPhase = 'idle';
let $0e009ca592c858ec$var$reflectionTimeout, $0e009ca592c858ec$var$tradingTimeout, $0e009ca592c858ec$var$forcedDeathTimeout;
let $0e009ca592c858ec$var$finalCurationTimeout;
const $0e009ca592c858ec$var$isSentenceish = (s)=>{
    const text = (s || '').trim();
    if (!text) return false; // no empty
    const words = text.split(/\s+/).filter(Boolean);
    if (words.length < 2) return false; // no single-word
    const lettersLen = text.replace(/[^0-9A-Za-z\u00C0-\u017F]+/g, '').length;
    return lettersLen >= 6; // allow short sentences
};
function $0e009ca592c858ec$export$76e9e1d001f81ca4(data) {
    console.log("\uD83D\uDCE2 Memento Mori announcement received:", data);
    $0e009ca592c858ec$var$mementoMoriData = data;
    const timeRemaining = data.timeRemaining || 900000;
    localStorage.setItem('activeMementoMori', JSON.stringify({
        ...data,
        timeRemaining: timeRemaining,
        storedAt: Date.now()
    }));
    localStorage.setItem('simulationType', 'memento-mori');
// Timer popup removed - using bottom timer from simulationTimer.js instead
// createPersistentTimer();
// startMementoMoriTimer(timeRemaining);
}
function $0e009ca592c858ec$export$3392fc08bb337b13() {
    const activeMementoMori = localStorage.getItem('activeMementoMori');
    const simulationType = localStorage.getItem('simulationType');
    if (!activeMementoMori || simulationType !== 'memento-mori') return;
    try {
        const objectiveData = JSON.parse(activeMementoMori);
        // Calculate remaining time from stored timestamp
        const now = Date.now();
        const elapsed = now - (objectiveData.storedAt || now);
        const timeRemaining = Math.max(0, objectiveData.timeRemaining - elapsed);
        if (timeRemaining > 0) {
            console.log("\uD83D\uDD04 Restoring Memento Mori timer with", Math.floor(timeRemaining / 60000), 'minutes remaining');
            // Store the data globally
            $0e009ca592c858ec$var$mementoMoriData = objectiveData;
            // Check if simulation was already started
            const simulationStarted = localStorage.getItem('mementoMoriStarted') === 'true';
            if (simulationStarted) {
                // Timer popup removed - using bottom timer from simulationTimer.js instead
                console.log("\uD83D\uDCCD Restoring MementoMori session (timer handled by simulationTimer.js)");
                // createPersistentTimer();
                // startMementoMoriTimer(timeRemaining);
                // Check if they need to continue with reflections
                setTimeout(()=>$0e009ca592c858ec$var$checkReflectionProgress(), 2000);
            } else {
                // Show the full announcement flow
                objectiveData.timeRemaining = timeRemaining;
                $0e009ca592c858ec$export$76e9e1d001f81ca4(objectiveData);
            }
        } else {
            console.log("\u23F0 Stored Memento Mori timer has expired, cleaning up");
            $0e009ca592c858ec$var$cleanupMementoMoriStorage();
        }
    } catch (error) {
        console.error("\u274C Error restoring Memento Mori timer:", error);
        $0e009ca592c858ec$var$cleanupMementoMoriStorage();
    }
}
function $0e009ca592c858ec$var$createPersistentTimer() {
    // Remove any existing timer
    const existingTimer = document.getElementById('persistent-memento-timer');
    if (existingTimer) existingTimer.remove();
    const timerOverlay = document.createElement('div');
    timerOverlay.id = 'persistent-memento-timer';
    timerOverlay.style.cssText = `
	position: fixed;
	top: 20px;
	right: 20px;
	background: rgba(0, 0, 0, 0.9);
	border: 2px solid #ff6600;
	border-radius: 10px;
	padding: 15px;
	z-index: 1000;
	color: #ff6600;
	font-family: 'Courier New', monospace;
	font-size: 14px;
	text-align: center;
	cursor: pointer;
	box-shadow: 0 0 20px rgba(255, 102, 0, 0.5);
	transition: all 0.3s;
  `;
    timerOverlay.innerHTML = `
	<div style="margin-bottom: 5px; color: rgba(255, 102, 0, 0.8);">${(0, $fUPn2.t)('memento.title', 'MEMENTO MORI')}</div>
	<div id="persistent-timer-display" style="color: #00ff00; font-weight: bold;">${(0, $fUPn2.t)('memento.loading', 'Loading...')}</div>
	<div style="font-size: 0.8em; color: rgba(255, 102, 0, 0.8); margin-top: 5px;">${(0, $fUPn2.t)('memento.click_to_reflect', 'Click to reflect')}</div>
  `;
    // Make timer clickable to show oracle interface
    timerOverlay.addEventListener('click', ()=>{
        $0e009ca592c858ec$var$showMortalityOracleInterface();
    });
    // Add hover effects
    timerOverlay.addEventListener('mouseenter', ()=>{
        timerOverlay.style.transform = 'scale(1.05)';
        timerOverlay.style.boxShadow = '0 0 30px rgba(255, 102, 0, 0.8)';
    });
    timerOverlay.addEventListener('mouseleave', ()=>{
        timerOverlay.style.transform = 'scale(1)';
        timerOverlay.style.boxShadow = '0 0 20px rgba(255, 102, 0, 0.5)';
    });
    document.body.appendChild(timerOverlay);
}
// ========================================================================
// ORACLE INTERFACE
// ========================================================================
/**
 * Show the mortality oracle interface for deep questioning
 */ async function $0e009ca592c858ec$var$showMortalityOracleInterface() {
    // Remove any existing interface
    const existing = document.getElementById('mortality-oracle-interface');
    if (existing) existing.remove();
    // Show loading state
    const loadingInterface = document.createElement('div');
    loadingInterface.id = 'mortality-oracle-interface';
    loadingInterface.className = 'modal';
    loadingInterface.style.display = 'block';
    loadingInterface.innerHTML = `
	<div class="modal-content" style="text-align: center; background: #000; border: 3px solid #00ff00;">
	  <h2 style="color: #00ff00; margin-bottom: 30px;">
		${(0, $fUPn2.t)('memento.loading_title', 'The Market Awakens')}
	  </h2>
	  <div style="color: #00ff00;">
		<div style="font-size: 2em; margin-bottom: 20px;"></div>
		<p>${(0, $fUPn2.t)('memento.loading_examining', "The Market is examining your portfolio's soul...")}</p>
		<p>${(0, $fUPn2.t)('memento.loading_preparing', 'Preparing personalized questions about your mortality...')}</p>
		<p style="font-size: 0.8em; color: rgba(0, 255, 0, 0.7); margin-top: 15px;">${(0, $fUPn2.t)('memento.loading_wait', 'This may take a moment...')}</p>
	  </div>
	</div>
  `;
    document.body.appendChild(loadingInterface);
    try {
        // Generate personalized oracle interface
        const personalizedContent = await $0e009ca592c858ec$var$generatePersonalizedOracleInterface();
        loadingInterface.remove();
        $0e009ca592c858ec$var$showLiveOracleInterface(personalizedContent);
    } catch (error) {
        console.error('Error generating personalized oracle:', error);
        loadingInterface.remove();
        $0e009ca592c858ec$var$showFallbackOracleInterface();
    }
}
/**
 * Generate personalized oracle interface content
 */ async function $0e009ca592c858ec$var$generatePersonalizedOracleInterface() {
    try {
        const objectiveId = $0e009ca592c858ec$var$mementoMoriData?.objective?._id;
        const timeRemaining = $0e009ca592c858ec$var$getTimeRemaining();
        const timeInMinutes = Math.floor(timeRemaining / 60000);
        // Use fallback content since the route doesn't exist yet
        console.log("\u26A0\uFE0F Using fallback Market interface");
        return {
            oracleTitle: 'Market of Digital Mortality',
            oracleGreeting: `The Market awakens in the digital realm, sensing the patterns of your portfolio like constellations in the night sky. Your trading choices have created a unique signature in the cosmic ledger of human desire and fear. In these ${timeInMinutes} minutes before your symbolic death, the Market sees not just numbers, but the essence of your relationship with uncertainty and value.`,
            questionsHeader: 'The Market Has Prepared Questions for Your Soul:',
            personalizedQuestions: [
                'Fear and Courage: What does your portfolio reveal about how you face your own mortality?',
                'Legacy and Meaning: If you died today, what would your trading choices say about what you truly valued?',
                'Impermanence and Acceptance: How do your financial fears mirror your deeper existential anxieties?',
                'Truth and Deception: What patterns in your trading behavior expose your relationship with uncertainty?',
                'Regret and Redemption: What would you regret most about your financial choices if this were your last day?'
            ],
            customPrompt: 'Or speak directly to the Market about death, meaning, and the patterns in your portfolio...',
            consultButton: "\uD83D\uDD2E Consult the Market"
        };
    } catch (error) {
        console.error('Error generating Market interface:', error);
        throw error;
    }
}
/**
 * Show the live oracle interface with personalized content
 */ function $0e009ca592c858ec$var$showLiveOracleInterface(personalizedContent) {
    const oracleInterface = document.createElement('div');
    oracleInterface.id = 'mortality-oracle-interface';
    oracleInterface.className = 'modal';
    oracleInterface.style.display = 'block';
    oracleInterface.innerHTML = `
	<div class="modal-content" style="background: #000; border: 3px solid #00ff00; color: #00ff00;">
	  <h2 style="color: #00ff00; text-align: center; margin-bottom: 20px;">
		${personalizedContent.oracleTitle || (0, $fUPn2.t)('memento.title', 'Market of Mortality')}
	  </h2>
	  
	  <div style="margin-bottom: 25px;">
		<p style="color: #00ff00; text-align: center; line-height: 1.6; margin-bottom: 25px; font-style: italic;">
		  "${personalizedContent.oracleGreeting || (0, $fUPn2.t)('memento.greeting', 'The Market sees patterns in your portfolio that reveal deeper truths about your relationship with mortality.')}"
		</p>
	  </div>

	  <div style="margin-bottom: 25px;">
		<h4 style="color: rgba(0, 255, 0, 0.9); margin-bottom: 15px;">
		  ${personalizedContent.questionsHeader || 'The Market Has Seen Your Soul - Choose Your Question:'}
		</h4>
		
		<div style="margin-bottom: 15px;">
		  ${(personalizedContent.personalizedQuestions || []).map((q, i)=>`
			<div class="oracle-question-option" style="
			  margin-bottom: 10px; 
			  padding: 10px; 
			  border: 1px solid rgba(0, 255, 0, 0.3); 
			  cursor: pointer; 
			  transition: all 0.3s;
			  border-radius: 5px;
			" onclick="window.selectOracleQuestion('${q.replace(/'/g, "\\'")}', this)">
			  <div style="color: rgba(0, 255, 0, 0.9); font-weight: bold; margin-bottom: 5px;">
				${q.split(':')[0]}:
			  </div>
			  <div style="color: #00ff00; font-size: 0.9em;">
				${q.split(':').slice(1).join(':').trim()}
			  </div>
			</div>
		  `).join('')}
		</div>
		
		<div style="margin-top: 20px;">
		  <label style="color: rgba(0, 255, 0, 0.9); margin-bottom: 10px; display: block;">
			${(0, $fUPn2.t)('memento.direct_label', 'Or speak directly to the Market:')}
		  </label>
		  <textarea id="custom-mortality-question" placeholder="${personalizedContent.customPrompt || (0, $fUPn2.t)('memento.custom_prompt', 'Ask the Market about your mortality, what your portfolio says about your soul, or the meaning of your financial choices in the face of death...')}"
					style="
					  width: 100%;
					  height: 80px;
					  background: rgba(0, 0, 0, 0.8);
					  border: 2px solid #00ff00;
					  color: #00ff00;
					  padding: 10px;
					  border-radius: 5px;
					  font-family: 'Courier New', monospace;
					  resize: vertical;
					">
		  </textarea>
		</div>
		
		<button id="consult-mortality-oracle" style="
		  background: #000;
		  color: #00ff00;
		  border: 2px solid #00ff00;
		  padding: 15px 30px;
		  font-size: 16px;
		  border-radius: 5px;
		  cursor: pointer;
		  margin-top: 15px;
		  font-family: 'Courier New', monospace;
		  transition: all 0.3s;
		" onmouseover="this.style.background='#00ff00'; this.style.color='#000';" 
		   onmouseout="this.style.background='#000'; this.style.color='#00ff00';">
		  ${personalizedContent.consultButton || (0, $fUPn2.t)('memento.consult_button', 'Consult the Market')}
		</button>
	  </div>

	  <div id="mortality-oracle-response" style="display: none; margin-bottom: 25px;">
		<h4 style="color: rgba(255, 135, 0, 0.9); margin-bottom: 10px;">${(0, $fUPn2.t)('memento.vision_title', "Market's Vision:")}</h4>
		<div id="mortality-oracle-text" style="
		  line-height: 1.6; 
		  color: #00ff00; 
		  font-style: italic;
		  background: rgba(255, 135, 0, 0.05);
		  padding: 15px;
		  border-radius: 5px;
		  border-left: 3px solid rgba(255, 135, 0, 0.5);
		"></div>
		<div id="oracle-follow-up" style="
		  margin-top: 15px; 
		  padding: 10px; 
		  border-left: 3px solid rgba(255, 135, 0, 0.5); 
		  background: rgba(0, 0, 0, 0.3);
		"></div>
	  </div>
	  
	  <div style="text-align: center; margin-top: 30px;">
		<button id="continue-reflection-process" class="primary-btn" style="
		  background: #000;
		  color: #00ff00;
		  border: 2px solid #00ff00;
		  padding: 12px 25px;
		  font-size: 14px;
		  border-radius: 5px;
		  cursor: pointer;
		  margin-right: 10px;
		  display: none;
		  font-family: 'Courier New', monospace;
		">
		  ${(0, $fUPn2.t)('memento.continue_reflections', 'Continue to Reflections')}
		</button>
		<button id="ask-another-question" style="
		  background: #000;
		  color: rgba(255, 135, 0, 0.9);
		  border: 2px solid rgba(255, 135, 0, 0.9);
		  padding: 12px 25px;
		  font-size: 14px;
		  border-radius: 5px;
		  cursor: pointer;
		  margin-right: 10px;
		  display: none;
		  font-family: 'Courier New', monospace;
		">
		  ${(0, $fUPn2.t)('memento.ask_another', 'Ask Another Question')}
		</button>
		<button id="close-mortality-oracle" style="
		  background: #000;
		  color: rgba(255, 102, 0, 0.9);
		  border: 2px solid rgba(255, 102, 0, 0.9);
		  padding: 12px 25px;
		  font-size: 14px;
		  border-radius: 5px;
		  cursor: pointer;
		  font-family: 'Courier New', monospace;
		">
		  ${(0, $fUPn2.t)('memento.return_trading', 'Return to Trading')}
		</button>
	  </div>
	</div>
  `;
    document.body.appendChild(oracleInterface);
    // Make functions globally available
    window.selectOracleQuestion = $0e009ca592c858ec$var$selectOracleQuestion;
    // Add event handlers
    document.getElementById('consult-mortality-oracle').addEventListener('click', $0e009ca592c858ec$var$consultLiveMortalityOracle);
    document.getElementById('continue-reflection-process').addEventListener('click', ()=>{
        oracleInterface.remove();
    });
    document.getElementById('ask-another-question').addEventListener('click', ()=>{
        $0e009ca592c858ec$var$resetOracleInterface();
    });
    document.getElementById('close-mortality-oracle').addEventListener('click', ()=>{
        oracleInterface.style.display = 'none';
    });
}
/**
 * Select a predefined oracle question
 */ function $0e009ca592c858ec$var$selectOracleQuestion(questionText, element) {
    // Remove selection from other options
    document.querySelectorAll('.oracle-question-option').forEach((option)=>{
        option.style.backgroundColor = '';
        option.style.borderColor = 'rgba(0, 255, 0, 0.3)';
    });
    // Highlight selected option
    element.style.backgroundColor = 'rgba(0, 255, 0, 0.1)';
    element.style.borderColor = '#00ff00';
    // Fill custom question textarea
    document.getElementById('custom-mortality-question').value = questionText;
}
/**
 * Consult the oracle with user's question
 */ async function $0e009ca592c858ec$var$consultLiveMortalityOracle() {
    let question = document.getElementById('custom-mortality-question').value.trim();
    if (!$0e009ca592c858ec$var$isSentenceish(question)) {
        alert((0, $fUPn2.t)('memento.validation.short_sentence', 'Please write a short sentence (at least two words).'));
        return;
    }
    const button = document.getElementById('consult-mortality-oracle');
    const originalText = button.textContent;
    button.textContent = "\uD83D\uDD2E The Market Sees...";
    button.disabled = true;
    // Show typing animation
    const responseDiv = document.getElementById('mortality-oracle-response');
    responseDiv.style.display = 'block';
    const textDiv = document.getElementById('mortality-oracle-text');
    textDiv.innerHTML = '<span style="opacity: 0.5;">The Market gazes into the depths of your portfolio\'s soul...</span>';
    try {
        // Try to call the oracle route
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/oracle-question`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $6pKgs.getAuthToken)()}`
            },
            body: JSON.stringify({
                objectiveId: $0e009ca592c858ec$var$mementoMoriData?.objective?._id,
                question: question
            })
        });
        if (!response.ok) throw new Error((0, $fUPn2.t)('memento.failed', 'Market consultation failed'));
        const data = await response.json();
        // Store question in history
        $0e009ca592c858ec$var$oracleQuestionHistory.push(question);
        const oracleData = {
            oracleResponse: data.oracleResponse || 'The Market sees patterns in your soul that transcend mere numbers.',
            followUpInsight: 'Your question reveals a mind grappling with the eternal questions that define conscious existence.',
            personalizedGuidance: 'Continue to your reflections, for wisdom has been granted.'
        };
        // Animate the oracle response
        await $0e009ca592c858ec$var$animateOracleResponse(oracleData);
        // Update interface state
        $0e009ca592c858ec$var$updateOracleInterfaceAfterResponse();
    } catch (error) {
        console.error('Error consulting Market:', error);
        // Enhanced fallback response
        const fallbackData = {
            oracleResponse: `The Market's vision pierces through digital veils to see your mortal essence. Your question "${question}" echoes with the weight of someone who understands that every trade is a small death, every decision a step toward the final reckoning. In your portfolio's patterns, the Market recognizes the eternal human struggle with impermanence - your financial choices are prayers written in the language of probability.`,
            followUpInsight: "The Market sees that your seeking itself is wisdom. In questioning meaning, you have already transcended mere accumulation.",
            personalizedGuidance: "Continue to your reflections, for the Market has shown you that death gives meaning to every choice."
        };
        await $0e009ca592c858ec$var$animateOracleResponse(fallbackData);
        $0e009ca592c858ec$var$updateOracleInterfaceAfterResponse();
    }
}
/**
 * Update oracle interface after receiving response
 */ function $0e009ca592c858ec$var$updateOracleInterfaceAfterResponse() {
    // Disable question options
    document.querySelectorAll('.oracle-question-option').forEach((option)=>{
        option.style.opacity = '0.5';
        option.style.pointerEvents = 'none';
    });
    // Disable input
    document.getElementById('custom-mortality-question').disabled = true;
    document.getElementById('custom-mortality-question').placeholder = (0, $fUPn2.t)('memento.spoken_placeholder', 'The Market has spoken...');
    // Update button
    const button = document.getElementById('consult-mortality-oracle');
    button.textContent = (0, $fUPn2.t)('memento.wisdom_received', 'Wisdom Received');
    button.disabled = true;
    // Show action buttons
    document.getElementById('continue-reflection-process').style.display = 'inline-block';
    document.getElementById('ask-another-question').style.display = 'inline-block';
}
/**
 * Reset oracle interface for another question
 */ function $0e009ca592c858ec$var$resetOracleInterface() {
    // Reset all interactive elements
    document.querySelectorAll('.oracle-question-option').forEach((option)=>{
        option.style.opacity = '1';
        option.style.pointerEvents = 'auto';
        option.style.backgroundColor = '';
        option.style.borderColor = 'rgba(0, 255, 0, 0.3)';
    });
    document.getElementById('custom-mortality-question').disabled = false;
    document.getElementById('custom-mortality-question').value = '';
    document.getElementById('custom-mortality-question').placeholder = 'Ask the Market about your mortality...';
    document.getElementById('consult-mortality-oracle').disabled = false;
    document.getElementById('consult-mortality-oracle').textContent = 'Consult the Market';
    document.getElementById('mortality-oracle-response').style.display = 'none';
    document.getElementById('ask-another-question').style.display = 'none';
    document.getElementById('continue-reflection-process').style.display = 'none';
}
/**
 * Show fallback oracle interface if generation fails
 */ function $0e009ca592c858ec$var$showFallbackOracleInterface() {
    const fallbackContent = {
        oracleTitle: 'Market of Mortality',
        oracleGreeting: 'The Market awakens in the digital realm, seeing patterns in your portfolio that reveal deeper truths about your relationship with mortality.',
        questionsHeader: 'The Market Has Prepared Questions for Your Soul:',
        personalizedQuestions: [
            'Fear and Courage: What does your portfolio reveal about how you face your own mortality?',
            'Legacy and Meaning: If you died today, what would your trading choices say about what you truly valued?',
            'Impermanence and Acceptance: How do your financial fears mirror your deeper existential anxieties?',
            'Truth and Deception: What patterns in your trading behavior expose your relationship with uncertainty?',
            'Regret and Redemption: What would you regret most about your financial choices if this were your last day?'
        ],
        customPrompt: 'Or speak directly to the Market about death, meaning, and the patterns in your portfolio...',
        consultButton: 'Consult the Market'
    };
    $0e009ca592c858ec$var$showLiveOracleInterface(fallbackContent);
}
/**
 * Show the final death completion screen
 */ function $0e009ca592c858ec$var$showDeathCompletion(result) {
    console.log("\uD83E\uDEA6 showDeathCompletion called with result:", result);
    const completionPopup = document.createElement('div');
    completionPopup.className = 'memento-modal';
    completionPopup.style.cssText = `
	 position: fixed;
	 top: 0;
	 left: 0;
	 width: 100%;
	 height: 100%;
	 background: rgba(0, 0, 0, 0.95);
	 z-index: 99999;
	 display: flex;
	 justify-content: center;
	 align-items: center;
	 font-family: 'Courier New', monospace;
   `;
    // Extract eulogy with fallback logic
    let llmEulogy = "Your contemplation of mortality has revealed wisdom. In facing death, you have found what truly matters in life.";
    if (result?.personalInsight) llmEulogy = result.personalInsight;
    else if (result?.llmAnalysis?.personalInsight) llmEulogy = result.llmAnalysis.personalInsight;
    else if (result?.portfolioAnalysis?.eulogyDraft) llmEulogy = result.portfolioAnalysis.eulogyDraft;
    else if (result?.analysis?.personalInsight) llmEulogy = result.analysis.personalInsight;
    const userEpitaph = result?.finalEpitaph || result?.objective?.finalEpitaph || "A life reflected upon.";
    completionPopup.innerHTML = `
	 <div style="
	   background: #000;
	   border: 3px solid #00ff00;
	   border-radius: 10px;
	   padding: 30px;
	   max-width: 700px;
	   margin: 20px;
	   color: #00ff00;
	   text-align: center;
	   box-shadow: 0 0 20px #00ff00;
	 ">
	   <h1 style="
		 color: #00ff00;
		 font-size: 28px;
		 margin-bottom: 20px;
		 text-shadow: 0 0 10px #00ff00;
	   ">${(0, $fUPn2.t)('memento.death_complete_title', 'SYMBOLIC DEATH COMPLETE')}</h1>
 
	   <p style="
		 margin-bottom: 30px;
		 font-size: 16px;
		 line-height: 1.5;
		 color: #ff6600;
	   ">
		 ${(0, $fUPn2.t)('memento.death_complete_subtitle', 'You have confronted your mortality and created your legacy.')}
	   </p>
 
	   <div style="
		 margin: 30px 0;
		 padding: 20px;
		 border: 1px solid #00ff00;
		 border-radius: 5px;
		 background: rgba(0, 255, 0, 0.1);
	   ">
		 <h3 style="
		   color: #00ff00;
		   margin-bottom: 15px;
		   font-size: 18px;
		 ">${(0, $fUPn2.t)('memento.final_judgment_title', "Your Portfolio's Final Judgment:")}</h3>
		 <p id="memento-eulogy-text" style="
		   color: #00ff00;
		   font-style: italic;
		   line-height: 1.6;
		   margin-bottom: 0;
		   text-align: left;
		 "></p>
	   </div>
 
	   <div style="
		 margin: 30px 0;
		 padding: 20px;
		 border: 1px solid #ff6600;
		 border-radius: 5px;
		 background: rgba(255, 102, 0, 0.1);
	   ">
		 <strong style="color: #ff6600; font-size: 16px;">${(0, $fUPn2.t)('memento.final_epitaph_title', 'Your Final Epitaph:')}</strong><br><br>
		 <em id="memento-epitaph-text" style="
		   color: #ff6600;
		   font-size: 18px;
		   line-height: 1.4;
		   text-align: left;
		   display: block;
		 "></em>
	   </div>
 
	   <button id="return-to-void" style="
		 background: #000;
		 color: #00ff00;
		 border: 2px solid #00ff00;
		 padding: 15px 30px;
		 font-size: 16px;
		 border-radius: 5px;
		 cursor: pointer;
		 margin-top: 20px;
		 font-family: 'Courier New', monospace;
		 transition: all 0.3s;
	   " onmouseover="this.style.background='#00ff00'; this.style.color='#000';"
		  onmouseout="this.style.background='#000'; this.style.color='#00ff00';">
		 \u{1F30C} ${(0, $fUPn2.t)('memento.return_to_void_button', 'Return to the Void')}
	   </button>
	 </div>
   `;
    document.body.appendChild(completionPopup);
    // Safely inject dynamic text (prevents HTML injection)
    const eTxt = completionPopup.querySelector('#memento-eulogy-text');
    const epTxt = completionPopup.querySelector('#memento-epitaph-text');
    if (eTxt) eTxt.textContent = `"${llmEulogy}"`;
    if (epTxt) epTxt.textContent = `"${userEpitaph}"`;
    // Add click handler to log out user
    document.getElementById('return-to-void').addEventListener('click', async ()=>{
        console.log("\uD83C\uDF0C Return to Void button clicked");
        completionPopup.remove();
        try {
            await $0e009ca592c858ec$var$logout();
        } catch (error) {
            console.error("\u274C Error during logout:", error);
            // Force redirect anyway
            window.location.href = '/index.html';
        }
    });
}
// ========================================================================
// TIMER MANAGEMENT
// ========================================================================
/**
 * Start the Memento Mori countdown timer
 */ function $0e009ca592c858ec$var$startMementoMoriTimer(timeInMs) {
    console.log("\u23F0 Starting Memento Mori timer with", timeInMs, 'ms remaining');
    // Clear any existing timer
    if ($0e009ca592c858ec$var$mementoMoriTimer) clearInterval($0e009ca592c858ec$var$mementoMoriTimer);
    let remainingTime = timeInMs;
    const updateAllTimers = ()=>{
        const minutes = Math.floor(remainingTime / 60000);
        const seconds = Math.floor(remainingTime % 60000 / 1000);
        const timeString = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        // Update announcement timer if it exists
        const announcementTimer = document.getElementById('memento-timer');
        if (announcementTimer) announcementTimer.textContent = timeString;
        // Persistent timer removed - now handled by simulationTimer.js
        if (remainingTime <= 0) {
            clearInterval($0e009ca592c858ec$var$mementoMoriTimer);
            $0e009ca592c858ec$var$handleMementoMoriTimeout();
            return;
        }
        remainingTime -= 1000;
        // Update stored time for persistence
        if ($0e009ca592c858ec$var$mementoMoriData) {
            const storageData = {
                ...$0e009ca592c858ec$var$mementoMoriData,
                timeRemaining: remainingTime,
                storedAt: Date.now()
            };
            localStorage.setItem('activeMementoMori', JSON.stringify(storageData));
        }
    };
    // Update immediately
    updateAllTimers();
    // Start interval
    $0e009ca592c858ec$var$mementoMoriTimer = setInterval(updateAllTimers, 1000);
}
/**
 * Handle when the timer expires
 */ async function $0e009ca592c858ec$var$handleMementoMoriTimeout() {
    console.log("\u23F0 Memento Mori time has expired");
    // Clean up interfaces
    $0e009ca592c858ec$var$cleanupMementoMoriInterfaces();
    // Show loading popup while generating analysis
    const loadingPopup = document.createElement('div');
    loadingPopup.className = 'memento-modal';
    loadingPopup.style.cssText = `
	position: fixed; top: 0; left: 0; width: 100%; height: 100%;
	background: rgba(0, 0, 0, 0.95); z-index: 99999;
	display: flex; justify-content: center; align-items: center;
	font-family: 'Courier New', monospace;
  `;
    loadingPopup.innerHTML = `
	<div style="background: #000; border: 3px solid #ff6600; border-radius: 10px;
				padding: 40px; max-width: 500px; color: #ff6600; text-align: center;">
	  <h2 style="color: #ff6600; margin-bottom: 20px;">${(0, $fUPn2.t)('memento.title', 'TIME EXPIRED')}</h2>
	  <div style="font-size: 3em; margin: 20px 0;"></div>
	  <p>${(0, $fUPn2.t)('memento.body', "Death has come, but your portfolio's meaning is being preserved...")}</p>
	  <p style="font-size: 14px; margin-top: 15px;">${(0, $fUPn2.t)('memento.generating', 'Generating your final eulogy...')}</p>
	</div>
  `;
    document.body.appendChild(loadingPopup);
    try {
        const objectiveId = $0e009ca592c858ec$var$mementoMoriData?.objective?._id;
        if (objectiveId) {
            // Try to complete with auto-generated epitaph
            const epitaph = 'Time expired before completion, but the attempt to understand my financial soul in death\'s shadow holds meaning beyond words.';
            const completionResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/complete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${(0, $6pKgs.getAuthToken)()}`
                },
                body: JSON.stringify({
                    objectiveId: objectiveId,
                    finalEpitaph: epitaph
                })
            });
            if (completionResponse.ok) {
                const result = await completionResponse.json();
                loadingPopup.remove();
                $0e009ca592c858ec$var$cleanupMementoMoriStorage();
                $0e009ca592c858ec$var$showDeathCompletion(result);
                return;
            }
        }
    } catch (error) {
        console.error("\u274C Error in timeout handling:", error);
    }
    // Fallback completion
    loadingPopup.remove();
    const fallbackResult = {
        personalInsight: "Time claimed you before completion, but your willingness to confront mortality through your portfolio reveals profound courage. In the urgency of finite time, you touched something eternal about the human search for meaning.",
        finalEpitaph: "A trader who dared to face death's questions, even when time itself became the final adversary."
    };
    $0e009ca592c858ec$var$cleanupMementoMoriStorage();
    $0e009ca592c858ec$var$showDeathCompletion(fallbackResult);
}
// ========================================================================
// UTILITY FUNCTIONS
// ========================================================================
/**
 * Get current time remaining
 */ function $0e009ca592c858ec$var$getTimeRemaining() {
    if (!$0e009ca592c858ec$var$mementoMoriData) return 0;
    const now = Date.now();
    const elapsed = now - ($0e009ca592c858ec$var$mementoMoriData.storedAt || now);
    return Math.max(0, $0e009ca592c858ec$var$mementoMoriData.timeRemaining - elapsed);
}
/**
 * Check reflection progress and show appropriate interface
 */ async function $0e009ca592c858ec$var$checkReflectionProgress() {
    try {
        const objectiveId = $0e009ca592c858ec$var$mementoMoriData?.objective?._id;
        if (!objectiveId) return;
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/objective/${objectiveId}`, {
            headers: {
                'Authorization': `Bearer ${(0, $6pKgs.getAuthToken)()}`
            }
        });
        if (response.ok) {
            const data = await response.json();
            const objective = data.objective;
            // Check status and show appropriate interface
            if (objective.status === 'completed') // Already completed, just show timer
            return;
        }
    } catch (error) {
        console.error('Error checking reflection progress:', error);
    }
}
/**
 * Clean up all Memento Mori interfaces
 */ function $0e009ca592c858ec$var$cleanupMementoMoriInterfaces() {
    // Persistent timer removed - now handled by simulationTimer.js
    // const timerOverlay = document.getElementById('persistent-memento-timer');
    // if (timerOverlay) timerOverlay.remove();
    const oracleInterface = document.getElementById('mortality-oracle-interface');
    if (oracleInterface) oracleInterface.remove();
    const reflectionInterface = document.getElementById('reflection-interface');
    if (reflectionInterface) reflectionInterface.remove();
    const allocationInterface = document.getElementById('final-allocation-interface');
    if (allocationInterface) allocationInterface.remove();
    // Remove eulogy popup
    const eulogyPopup = document.getElementById('memento-mori-eulogy');
    if (eulogyPopup) eulogyPopup.remove();
    // Remove expanded eulogy modal
    const expandedEulogy = document.getElementById('expanded-eulogy-modal');
    if (expandedEulogy) expandedEulogy.remove();
    // Clear timer
    if ($0e009ca592c858ec$var$mementoMoriTimer) {
        clearInterval($0e009ca592c858ec$var$mementoMoriTimer);
        $0e009ca592c858ec$var$mementoMoriTimer = null;
    }
    if ($0e009ca592c858ec$var$finalCurationTimeout) {
        clearTimeout($0e009ca592c858ec$var$finalCurationTimeout);
        $0e009ca592c858ec$var$finalCurationTimeout = null;
    }
    // Clear eulogy update interval
    if (window.mementoEulogyInterval) {
        clearInterval(window.mementoEulogyInterval);
        window.mementoEulogyInterval = null;
    }
    // Reset initialization flag
    window.mementoMoriInitialized = false;
}
/**
 * Clean up Memento Mori storage
 */ function $0e009ca592c858ec$var$cleanupMementoMoriStorage() {
    localStorage.removeItem('activeMementoMori');
    localStorage.removeItem('mementoMoriStarted');
    localStorage.removeItem('simulationType');
}
/**
 * Animate oracle response with typewriter effect
 */ async function $0e009ca592c858ec$var$animateOracleResponse(data) {
    const textDiv = document.getElementById('mortality-oracle-text');
    const followUpDiv = document.getElementById('oracle-follow-up');
    // Clear previous content
    textDiv.innerHTML = '';
    followUpDiv.innerHTML = '';
    // Type out the main response
    const mainResponse = `"${data.oracleResponse}"`;
    await $0e009ca592c858ec$var$typeWriterEffect(textDiv, mainResponse, 30);
    // Add follow-up insight if available
    if (data.followUpInsight) setTimeout(async ()=>{
        followUpDiv.innerHTML = `
		<div style="color: rgba(255, 135, 0, 0.9); font-weight: bold; margin-bottom: 8px;">
		  ${(0, $fUPn2.t)('memento.further_insight', "The Market's Further Insight:")}
		</div>
		<div style="color: #00ff00; font-size: 0.9em;"></div>
	  `;
        const insightText = followUpDiv.querySelector('div:last-child');
        await $0e009ca592c858ec$var$typeWriterEffect(insightText, data.followUpInsight, 25);
        // Add personalized guidance if available
        if (data.personalizedGuidance) setTimeout(async ()=>{
            const guidanceDiv = document.createElement('div');
            guidanceDiv.style.cssText = 'margin-top: 10px; color: rgba(0, 255, 0, 0.8); font-size: 0.85em; font-style: italic;';
            followUpDiv.appendChild(guidanceDiv);
            await $0e009ca592c858ec$var$typeWriterEffect(guidanceDiv, `\u{2192} ${data.personalizedGuidance}`, 20);
        }, 1000);
    }, 1500);
}
/**
 * Typewriter effect for text animation
 */ async function $0e009ca592c858ec$var$typeWriterEffect(element, text, speed = 30) {
    return new Promise((resolve)=>{
        let i = 0;
        const timer = setInterval(()=>{
            if (i < text.length) {
                element.textContent += text.charAt(i);
                i++;
            } else {
                clearInterval(timer);
                resolve();
            }
        }, speed);
    });
}
/**
 * Logout function
 */ async function $0e009ca592c858ec$var$logout() {
    const portfolioId = localStorage.getItem('portfolioId');
    const token = (0, $6pKgs.getAuthToken)();
    const isSimulated = localStorage.getItem('isSimulated') === 'true';
    if (!portfolioId || !token) {
        console.error('Portfolio ID or token not found in local storage');
        return;
    }
    try {
        // First, disconnect all bot sockets if this is a simulated user
        if (isSimulated && (0, $cJVho.socket) && (0, $cJVho.socket).connected) {
            console.log("\uD83E\uDD16 Disconnecting bots for simulated user logout...");
            (0, $cJVho.socket).emit('disconnectUserBots', {
                portfolioId: portfolioId
            });
            // Wait a moment for bot disconnection to complete
            await new Promise((resolve)=>setTimeout(resolve, 1000));
        }
        // Update the active status to false on the server
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/${portfolioId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                active: false
            })
        });
        if (!response.ok) throw new Error('Failed to update active status during logout');
    } catch (error) {
        console.error('Error updating active status during logout:', error);
    }
    try {
        // Call the logout endpoint on the server
        const logoutResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                isSimulated: isSimulated
            }),
            credentials: 'include'
        });
        if (!logoutResponse.ok) throw new Error('Failed to logout from server');
        const logoutData = await logoutResponse.json();
        console.log(logoutData.message);
    } catch (error) {
        console.error('Error during server logout:', error);
    }
    // Disconnect main socket
    if ((0, $cJVho.socket) && (0, $cJVho.socket).connected) {
        console.log("\uD83D\uDD0C Disconnecting main socket...");
        (0, $cJVho.socket).disconnect();
    }
    // Clear all storage
    localStorage.clear();
    // Clear cookies
    document.cookie.split(";").forEach((cookie)=>{
        const name = cookie.split("=")[0].trim();
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax;Secure`;
    });
    window.location.href = '/index.html';
}
async function $0e009ca592c858ec$export$d0a3225c3d52d92a(portfolioId) {
    // Check local storage first
    const storedObjective = localStorage.getItem('activeMementoMori');
    const simulationType = localStorage.getItem('simulationType');
    if (storedObjective && simulationType === 'memento-mori') {
        console.log("\u2705 Memento Mori found in local storage. Restoring...");
        $0e009ca592c858ec$export$3392fc08bb337b13();
        return;
    }
    try {
        const res = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/portfolio/${portfolioId}/status`, {
            headers: {
                'Authorization': `Bearer ${(0, $6pKgs.getAuthToken)()}`
            }
        });
        if (!res.ok) {
            console.error('Failed to fetch Memento Mori status');
            return;
        }
        const data = await res.json();
        if (data.success && data.activeObjective) {
            console.log("\u26B0\uFE0F New Memento Mori objective found:", data.activeObjective);
            $0e009ca592c858ec$export$76e9e1d001f81ca4({
                objective: data.activeObjective,
                timeRemaining: data.activeObjective.timeRemaining
            });
        }
    } catch (err) {
        console.error('Error checking Memento Mori status:', err);
    }
}
// =====================================================
// NEW 3-PHASE MEMENTO MORI FLOW FUNCTIONS
// =====================================================
/**
 * Show new reflection interface for Phase 1
 */ /**
 * Show value analysis results and transition to trading phase
 */ function $0e009ca592c858ec$var$showValueAnalysisResults(analysisResult) {
    console.log("\uD83C\uDFAF Starting Phase 2: Values-Based Trading");
    $0e009ca592c858ec$var$mementoMoriPhase = 'trading';
    const resultsInterface = document.createElement('div');
    resultsInterface.id = 'value-analysis-results';
    resultsInterface.className = 'memento-mori-interface';
    resultsInterface.style.cssText = `
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: linear-gradient(135deg, #1a1a1a 0%, #1b2d1b 100%);
	border: 2px solid #228B22;
	border-radius: 15px;
	padding: 30px;
	z-index: 10000;
	max-width: 700px;
	max-height: 80vh;
	overflow-y: auto;
	box-shadow: 0 0 50px rgba(34, 139, 34, 0.8);
	color: white;
	font-family: 'Courier New', monospace;
  `;
    const recommendations = analysisResult.recommendedCompanies || [];
    const guidance = analysisResult.message || 'Trade based on your values, not profit.';
    resultsInterface.innerHTML = `
	<div style="text-align: center; margin-bottom: 25px;">
	  <h2 style="color: #90EE90; margin: 0; font-size: 24px;">${(0, $fUPn2.t)('memento.title', 'YOUR VALUE PROFILE')}</h2>
	  <p style="color: #ccc; margin: 10px 0;">${(0, $fUPn2.t)('memento.subtitle', 'Based on your reflections, here are companies that align with your values')}</p>
	</div>
	
	<div style="margin-bottom: 20px;">
	  <h3 style="color: #90EE90; margin-bottom: 10px;">${(0, $fUPn2.t)('memento.guidance_title', 'Guidance:')}</h3>
	  <p style="color: #ddd; line-height: 1.5; background: #2a2a2a; padding: 15px; border-radius: 8px;">
		${guidance}
	  </p>
	</div>
	
	<div style="margin-bottom: 25px;">
	  <h3 style="color: #90EE90; margin-bottom: 10px;">${(0, $fUPn2.t)('memento.recommended_title', 'Recommended Companies:')}</h3>
	  <div style="background: #2a2a2a; padding: 15px; border-radius: 8px; max-height: 200px; overflow-y: auto;">
		${recommendations.map((company)=>{
        const companyName = typeof company === 'object' ? company.companyName || company.name || 'Unknown Company' : company;
        const reason = typeof company === 'object' ? company.reason || '' : '';
        return `<div style="color: #fff; margin: 8px 0; padding: 5px;">
			<strong>\u{2022} ${companyName}</strong>
			${reason ? `<br><span style="color: #aaa; font-size: 0.9em; margin-left: 12px;">${reason}</span>` : ''}
		  </div>`;
    }).join('')}
	  </div>
	</div>
	
	<div style="text-align: center; margin-top: 25px;">
	  <button id="start-trading" style="
		background: linear-gradient(45deg, #228B22, #32CD32);
		color: white;
		border: none;
		padding: 12px 25px;
		border-radius: 25px;
		cursor: pointer;
		font-size: 16px;
		font-weight: bold;
		transition: all 0.3s;
	  ">
		${(0, $fUPn2.t)('memento.start_trading', "Start Trading (All 310+ Companies Available) \u2192")}
	  </button>
	</div>
  `;
    document.body.appendChild(resultsInterface);
    document.getElementById('start-trading').addEventListener('click', $0e009ca592c858ec$var$startTradingPhase);
}
/**
 * Start trading phase with all companies available
 */ function $0e009ca592c858ec$var$startTradingPhase() {
    console.log("\uD83D\uDCB0 Phase 2: Trading with all companies available");
    const resultsInterface = document.getElementById('value-analysis-results');
    if (resultsInterface) resultsInterface.remove();
    localStorage.setItem('simulationType', 'memento-mori');
    localStorage.setItem('mementoShowAllCompanies', 'true');
    ing;
    try {
        window.dispatchEvent(new CustomEvent('memento:showAllCompanies'));
    } catch  {}
    try {
        if (typeof displayPortfolioItems === 'function') displayPortfolioItems(true);
        else if (window.displayPortfolioItems) window.displayPortfolioItems(true);
        else setTimeout(()=>window.location.reload(), 500);
    } catch (err) {
        console.error('Error refreshing market:', err);
        setTimeout(()=>window.location.reload(), 500);
    }
    const tradingNotification = document.createElement('div');
    tradingNotification.style.cssText = `
	 position: fixed;
	 top: 20px;
	 right: 20px;
	 background: linear-gradient(45deg, #228B22, #32CD32);
	 color: white;
	 padding: 15px 20px;
	 border-radius: 10px;
	 z-index: 9999;
	 box-shadow: 0 4px 20px rgba(34, 139, 34, 0.5);
	 font-family: 'Courier New', monospace;
	 border: 2px solid #90EE90;
   `;
    tradingNotification.innerHTML = `
	 <div style="font-weight: bold; margin-bottom: 5px;">${(0, $fUPn2.t)('memento.active_badge', 'MEMENTO MORI TRADING ACTIVE')}</div>
	 <div style="font-size: 14px;">${(0, $fUPn2.t)('memento.all_available', 'All 310+ companies available for trading')}</div>
	 <div style="font-size: 12px; margin-top: 5px; opacity: 0.8;">${(0, $fUPn2.t)('memento.values_over_profit', 'Trade based on your values, not profit')}</div>
   `;
    document.body.appendChild(tradingNotification);
    setTimeout(()=>{
        if ($0e009ca592c858ec$var$mementoMoriPhase === 'trading') $0e009ca592c858ec$var$showFinalCompletionReminder();
    }, ($0e009ca592c858ec$var$mementoMoriData?.timeRemaining || 900000) - 180000);
}
/**
 * Show reminder to complete the simulation
 */ function $0e009ca592c858ec$var$showFinalCompletionReminder() {
    const reminder = document.createElement('div');
    reminder.style.cssText = `
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: linear-gradient(135deg, #8B0000, #DC143C);
	color: white;
	padding: 20px;
	border-radius: 10px;
	z-index: 10000;
	text-align: center;
	font-family: 'Courier New', monospace;
	border: 2px solid #ff4444;
  `;
    reminder.innerHTML = `
	<h3 style="margin: 0 0 10px 0;">${(0, $fUPn2.t)('memento.title', 'FINAL CALL')}</h3>
	<p style="margin: 0 0 15px 0;">${(0, $fUPn2.t)('memento.body', 'Time is running out. Complete your Memento Mori simulation now.')}</p>
	<button id="final-complete" style="
	  background: #8B0000;
	  color: white;
	  border: none;
	  padding: 10px 20px;
	  border-radius: 5px;
	  cursor: pointer;
	">
	  ${(0, $fUPn2.t)('memento.complete_now', "Complete Now \u2192")}
	</button>
  `;
    document.body.appendChild(reminder);
    document.getElementById('final-complete').addEventListener('click', ()=>{
        reminder.remove();
        $0e009ca592c858ec$var$completeNewMementoMoriFlow();
    });
    setTimeout(()=>{
        if (reminder.parentNode) reminder.remove();
    }, 30000);
}
/**
 * Complete the new Memento Mori flow with portfolio analysis
 */ async function $0e009ca592c858ec$var$completeNewMementoMoriFlow() {
    console.log("\uD83E\uDEA6 Phase 3: Completing Memento Mori with portfolio analysis");
    $0e009ca592c858ec$var$mementoMoriPhase = 'completed';
    // Clear any existing timers
    clearTimeout($0e009ca592c858ec$var$forcedDeathTimeout);
    try {
        const objectiveId = $0e009ca592c858ec$var$mementoMoriData?.objective?._id;
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/complete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $6pKgs.getAuthToken)()}`
            },
            body: JSON.stringify({
                objectiveId: objectiveId,
                finalReflections: {} // Could add final reflection questions here
            })
        });
        if (!response.ok) throw new Error('Failed to complete Memento Mori');
        const result = await response.json();
        console.log("\u2705 Memento Mori completed:", result);
        // Show final eulogy
        $0e009ca592c858ec$var$showFinalEulogy(result);
    } catch (error) {
        console.error('Error completing Memento Mori:', error);
        alert('Failed to complete Memento Mori simulation.');
    }
}
/**
 * Show the final portfolio-based eulogy
 */ function $0e009ca592c858ec$var$showFinalEulogy(completionResult) {
    const eulogyInterface = document.createElement('div');
    eulogyInterface.style.cssText = `
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: linear-gradient(135deg, #1a1a1a 0%, #2d1b1b 100%);
	border: 2px solid #8B0000;
	border-radius: 15px;
	padding: 30px;
	z-index: 10000;
	max-width: 800px;
	max-height: 80vh;
	overflow-y: auto;
	box-shadow: 0 0 50px rgba(139, 0, 0, 0.8);
	color: white;
	font-family: 'Courier New', monospace;
  `;
    const eulogy = completionResult.eulogy || 'Your portfolio reflected deep consideration of life values.';
    const insights = completionResult.portfolioInsights || [];
    eulogyInterface.innerHTML = `
	<div style="text-align: center; margin-bottom: 25px;">
	  <h2 style="color: #ff4444; margin: 0; font-size: 24px;">${(0, $fUPn2.t)('memento.title', 'YOUR DIGITAL EULOGY')}</h2>
	  <p style="color: #ccc; margin: 10px 0;">${(0, $fUPn2.t)('memento.subtitle', 'Based on your portfolio choices and life reflections')}</p>
	</div>
	
	<div style="background: #2a2a2a; padding: 20px; border-radius: 10px; margin-bottom: 20px;">
	  <h3 style="color: #ff6b6b; margin-bottom: 15px;">${(0, $fUPn2.t)('memento.your_eulogy', 'Your Eulogy:')}</h3>
	  <div style="color: #ddd; line-height: 1.6; font-style: italic;">
		"${eulogy}"
	  </div>
	</div>
	
	${insights.length > 0 ? `
	<div style="background: #2a2a2a; padding: 20px; border-radius: 10px; margin-bottom: 20px;">
	  <h3 style="color: #ff6b6b; margin-bottom: 15px;">${(0, $fUPn2.t)('memento.insights', 'Portfolio Insights:')}</h3>
	  ${insights.map((insight)=>`<div style="color: #ddd; margin: 8px 0;">\u{2022} ${insight}</div>`).join('')}
	</div>
	` : ''}
	
	<div style="text-align: center; margin-top: 25px;">
	  <button id="close-eulogy" style="
		background: linear-gradient(45deg, #8B0000, #DC143C);
		color: white;
		border: none;
		padding: 12px 25px;
		border-radius: 25px;
		cursor: pointer;
		font-size: 16px;
		font-weight: bold;
	  ">
		${(0, $fUPn2.t)('memento.rest_in_peace', 'Rest in Peace')}
	  </button>
	</div>
  `;
    document.body.appendChild(eulogyInterface);
    document.getElementById('close-eulogy').addEventListener('click', ()=>{
        eulogyInterface.remove();
        localStorage.removeItem('mementoMoriStarted');
        // Remove any trading notifications
        const notifications = document.querySelectorAll('[style*="MEMENTO MORI TRADING ACTIVE"]');
        notifications.forEach((notification)=>notification.remove());
    });
}
function $0e009ca592c858ec$var$cancelMementoMoriPhaseTimers() {}
// ✅ Listen for timer expiry event from simulationTimer.js
window.addEventListener('mementoMoriExpired', async ()=>{
    console.log("\u26B0\uFE0F [objectives.js] Memento Mori timer expired - completing session and redirecting");
    try {
        const objectiveId = localStorage.getItem('mementoMoriObjectiveId');
        if (!objectiveId) {
            console.error("\u274C No objective ID found for completion");
            // Redirect anyway with fallback
            $0e009ca592c858ec$var$redirectToMementoMoriEnd({
                eulogy: "Your journey through life's marketplace has concluded.",
                portfolioInsights: []
            });
            return;
        }
        // Call the completion endpoint
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/complete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $6pKgs.getAuthToken)()}`
            },
            body: JSON.stringify({
                objectiveId: objectiveId,
                finalReflections: {}
            })
        });
        if (!response.ok) throw new Error('Failed to complete Memento Mori');
        const result = await response.json();
        console.log("\u2705 Memento Mori auto-completed on timer expiry:", result);
        // Redirect to memento mori ending page with eulogy data
        $0e009ca592c858ec$var$redirectToMementoMoriEnd(result);
    } catch (error) {
        console.error("\u274C Error auto-completing Memento Mori on timer expiry:", error);
        // Redirect with fallback eulogy
        $0e009ca592c858ec$var$redirectToMementoMoriEnd({
            eulogy: "Your journey through life's marketplace has concluded. In facing mortality, you discovered what truly matters.",
            portfolioInsights: []
        });
    }
});
// Redirect to memento mori ending page with eulogy data
function $0e009ca592c858ec$var$redirectToMementoMoriEnd(eulogyData) {
    console.log("\uD83E\uDEA6 Redirecting to Memento Mori ending page...");
    try {
        // Store data in temporary localStorage (survives the logout/redirect)
        localStorage.setItem('tempMementoMoriResults', JSON.stringify({
            ...eulogyData,
            timestamp: Date.now()
        }));
        console.log("\uD83D\uDCBE Stored eulogy data for ending page");
        // Redirect to the ending page
        setTimeout(()=>{
            window.location.href = '/mementomoriend.html';
        }, 100);
    } catch (error) {
        console.error("\u274C Error preparing redirect:", error);
        // Try redirect anyway
        window.location.href = '/mementomoriend.html';
    }
}
function $0e009ca592c858ec$export$3e536f1cccf2aff1() {
    if ($0e009ca592c858ec$var$mementoMoriTimer) {
        clearInterval($0e009ca592c858ec$var$mementoMoriTimer);
        $0e009ca592c858ec$var$mementoMoriTimer = null;
    }
    $0e009ca592c858ec$var$cancelMementoMoriPhaseTimers(); // Also clean phase timers
    $0e009ca592c858ec$var$cleanupMementoMoriInterfaces();
    $0e009ca592c858ec$var$cleanupMementoMoriStorage();
}

});
parcelRegister("6pKgs", function(module, exports) {

$parcel$export(module.exports, "setAuthToken", () => $4ab8f70751c4aaf8$export$3c4602e16d9ace38);
$parcel$export(module.exports, "getAuthToken", () => $4ab8f70751c4aaf8$export$38e1f53b76ec7fed);
$parcel$export(module.exports, "setPortfolioId", () => $4ab8f70751c4aaf8$export$1dd65e4691de719b);
$parcel$export(module.exports, "setSessionId", () => $4ab8f70751c4aaf8$export$f61b5f0b88be99b3);
$parcel$export(module.exports, "setRole", () => $4ab8f70751c4aaf8$export$6ab8d810c69bec6f);
$parcel$export(module.exports, "setFirstLogin", () => $4ab8f70751c4aaf8$export$2fa8d65c91811f30);
// sessionVir.js
function $4ab8f70751c4aaf8$export$3c4602e16d9ace38(token) {
    localStorage.setItem('token', token);
}
function $4ab8f70751c4aaf8$export$38e1f53b76ec7fed() {
    return localStorage.getItem('token');
}
function $4ab8f70751c4aaf8$export$1dd65e4691de719b(id) {
    localStorage.setItem('portfolioId', id);
}
function $4ab8f70751c4aaf8$export$141bbd10c4c06cba() {
    return localStorage.getItem('portfolioId');
}
function $4ab8f70751c4aaf8$export$f61b5f0b88be99b3(id) {
    localStorage.setItem('sessionId', id);
}
function $4ab8f70751c4aaf8$export$b3739caaf2580dd() {
    return localStorage.getItem('sessionId');
}
function $4ab8f70751c4aaf8$export$6ab8d810c69bec6f(role) {
    localStorage.setItem('role', role);
}
function $4ab8f70751c4aaf8$export$d1c3a5ff834adfa2() {
    return localStorage.getItem('role');
}
function $4ab8f70751c4aaf8$export$2fa8d65c91811f30(flag) {
    localStorage.setItem('firstLogin', flag ? 'true' : 'false');
}
function $4ab8f70751c4aaf8$export$4ec71a5f45bc4759() {
    return localStorage.getItem('firstLogin') === 'true';
}

});


parcelRegister("1NhFL", function(module, exports) {

$parcel$export(module.exports, "showWaitingForResponsePopup", () => $14e813777626223f$export$9bb10ee1b3014f2a);
$parcel$export(module.exports, "closeWaitingForResponsePopup", () => $14e813777626223f$export$b000159a735d13c1);
$parcel$export(module.exports, "showStockBidPopup", () => $14e813777626223f$export$aa71e03faf15c300);

var $cNeIB = parcelRequire("cNeIB");

var $21EbS = parcelRequire("21EbS");

var $cJVho = parcelRequire("cJVho");

var $fUPn2 = parcelRequire("fUPn2");

var $bNbKd = parcelRequire("bNbKd");

var $eD3DY = parcelRequire("eD3DY");
// Redirect guard: only forward from stockTransaction.html
window.isOn ||= (file)=>location.pathname.endsWith(`/${file}`) || location.pathname.endsWith(file);
// Where this TAB calls home. zfloor.js stamps sessionStorage.zxHome on every
// load, so any classic page opened from a tab that has seen the floor knows to
// go back to the floor — even down a path that never recorded an explicit
// zxReturnTo. That is the whole point: zxReturnTo is written by ONE function at
// hand-off time and is CONSUMED by the first reader, so any route that skips it
// (or loses the race) fell through to a hardcoded 'trader.html'/'market.html'
// and dumped a floor user into the classic system. This is the backstop under
// all of them. sessionStorage, not localStorage: it dies with the tab, so a
// market-origin session in a fresh tab is never affected.
window.zxHome ||= ()=>{
    try {
        return sessionStorage.getItem('zxHome');
    } catch (_) {
        return null;
    }
};
// The 3D floor (zfloor.html) is the primary interface. It records zxReturnTo
// before handing off here, so a finished bid or swap lands back on the floor
// instead of the classic market page. Market-origin trades are unaffected.
window.zxTakeReturn ||= ()=>{
    const target = localStorage.getItem('zxReturnTo');
    // Default is the FLOOR, never a classic page: mobile browsers drop
    // sessionStorage when they discard/restore a tab, so zxHome can vanish
    // mid-session — falling through to market.html stranded users in the
    // abandoned classic system.
    if (!target) return window.zxHome?.() || 'zfloor.html';
    localStorage.removeItem('zxReturnTo');
    return target;
};
window.shouldRedirectToMarket ||= ()=>window.isOn('stockTransaction.html') || window.isOn('transaction.html') && !!localStorage.getItem('zxReturnTo');
window.doMarketRedirectIfNeeded ||= ()=>{
    // Only redirect if on a transaction page AND user is an initiator (not a responder)
    if (window.shouldRedirectToMarket() && window.__userIsInitiator !== false) window.location.href = window.zxTakeReturn();
};
function $14e813777626223f$var$getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
function $14e813777626223f$var$getPortfolioId() {
    return $14e813777626223f$var$getCookie('portfolioId') || localStorage.getItem('portfolioId');
}
function $14e813777626223f$export$526fd5de268d6a23() {
    const token = (0, $21EbS.getAuthToken)(); // Get the token
    if (!token) {
        (0, $eD3DY.showNotification)("You must be logged in to perform this action.", false);
        return;
    }
    fetch(`${(0, $cNeIB.apiBaseUrl)}/api/stocks`, {
        headers: {
            'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
            'Content-Type': 'application/json'
        }
    }).then((response)=>{
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
    }).then((stocks)=>{
        if (stocks && Array.isArray(stocks)) $14e813777626223f$export$9abe027fc04b3f48(stocks);
        else console.error("Received stocks data is not an array:", stocks);
    }).catch((error)=>{
        console.error('Error fetching stocks:', error);
    });
}
function $14e813777626223f$export$9bb10ee1b3014f2a(message, timeoutSeconds = 10) {
    let existingPopup = document.getElementById('waitingPopup');
    if (existingPopup) existingPopup.remove();
    const popup = document.createElement('div');
    popup.id = 'waitingPopup';
    popup.style.cssText = `
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.8);
	color: #00ff00;
	padding: env(safe-area-inset-top, 20px) env(safe-area-inset-right, 20px) env(safe-area-inset-bottom, 20px) env(safe-area-inset-left, 20px);
	z-index: 10000;
	font-family: 'bithigh', Arial, sans-serif;
	display: grid;
	place-items: center;
	text-align: center;
  `;
    const inner = document.createElement('div');
    inner.style.cssText = `max-width: 720px; width: 90%;`;
    const title = document.createElement('h3');
    title.textContent = message || (0, $fUPn2.t)('stock_bid.processing_bid', 'Processing your bid...');
    title.style.marginBottom = '12px';
    inner.appendChild(title);
    const spinner = document.createElement('div');
    spinner.className = 'spinner';
    spinner.style.cssText = `
	border: 3px solid rgba(0, 255, 0, 0.3);
	border-top: 3px solid #00ff00;
	border-radius: 50%;
	width: 40px;
	height: 40px;
	animation: spin 1s linear infinite;
	margin: 16px auto 10px auto;
  `;
    inner.appendChild(spinner);
    const countdown = document.createElement('div');
    countdown.id = 'waitingCountdown';
    countdown.style.cssText = 'margin-top: 8px;';
    inner.appendChild(countdown);
    popup.appendChild(inner);
    const style = document.createElement('style');
    style.textContent = `
	@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
  `;
    document.head.appendChild(style);
    document.body.appendChild(popup);
    // Track popup state for bot interaction management
    if (window.popupTracker) window.popupTracker.trackElement(popup, 'waiting-for-response');
    let remaining = Math.max(1, Number(timeoutSeconds) || 10);
    countdown.textContent = (0, $fUPn2.t)('stock_bid.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', `${remaining}`);
    const interval = setInterval(()=>{
        remaining -= 1;
        if (remaining <= 0) {
            clearInterval(interval);
            countdown.textContent = (0, $fUPn2.t)('stock_bid.no_response', 'No response received. This action has expired.');
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('stock_bid.offer_expired', 'No response received. Your offer expired.'), false);
            // Close popup and trigger redirect for initiator
            try {
                $14e813777626223f$export$b000159a735d13c1?.(false); // false = initiator, triggers redirect
            } catch (_) {}
        } else countdown.textContent = (0, $fUPn2.t)('stock_bid.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', `${remaining}`);
    }, 1000);
    // Store interval ID so it can be cleared
    window.__waitingPopupInterval = interval;
    // Expose closer globally - REMOVED redirect logic
    window.closeWaitingForResponsePopup = (isResponder = false)=>{
        clearInterval(interval);
        const p = document.getElementById('waitingPopup');
        if (p) {
            // Untrack popup before removing
            if (window.popupTracker) window.popupTracker.unregisterPopup('waitingPopup');
            p.remove();
        }
        console.log('[Popup] Closed, isResponder:', isResponder);
    // Do NOT redirect here - let the main closeWaitingForResponsePopup handle it
    };
}
async function $14e813777626223f$export$a53b6db1a226556a(stockId) {
    try {
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/stocks/${stockId}`, {
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch stock data: ${response.status} - ${response.statusText}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching stock data:', error);
        return null;
    }
}
function $14e813777626223f$export$9abe027fc04b3f48(stocks) {
    const stockList = document.getElementById('stock-list');
    if (!stockList) {
        console.error("Stock list element not found.");
        return;
    }
    if (!Array.isArray(stocks)) {
        console.error("Invalid stocks data:", stocks);
        return;
    }
    stockList.innerHTML = ''; // Clear existing stocks
    stocks.forEach((stock)=>{
        const stockElement = document.createElement('div');
        stockElement.innerHTML = `
	  <h3>${stock.name}</h3>
	  <p>${stock.description}</p>
	  <p>Product: ${stock.product}</p>
	  <p>Available Shares: ${stock.availableShares}</p>
	  <p>Share Value: ${stock.shareValue}</p>
	  <p>Company Value: ${(stock.shareValue * stock.availableShares).toFixed(2)}</p>
	  <button class="trade-button" data-stock-id="${stock._id}">Trade</button>
	`;
        stockList.appendChild(stockElement);
        $14e813777626223f$var$addGlobalIndicator(stockElement, stock);
        const tradeButton = stockElement.querySelector('.trade-button');
        tradeButton.onclick = ()=>{
            $14e813777626223f$export$da0f12a59a6d31d9(stock);
        };
    });
}
function $14e813777626223f$export$b3739caaf2580dd() {
    return localStorage.getItem('sessionId') || null;
}
function $14e813777626223f$export$da0f12a59a6d31d9(stock) {
    const stockTradeModal = document.createElement('div');
    stockTradeModal.classList.add('modal');
    stockTradeModal.innerHTML = `
	<div class="modal-content">
	  <span class="close">&times;</span>
	  <h2>Trade Stock</h2>
	  <p><strong>Company:</strong> ${stock.name}</p>
	  <p><strong>Description:</strong> ${stock.description}</p>
	  <p><strong>Product:</strong> ${stock.product}</p>
	  <p><strong>Available Shares:</strong> ${stock.availableShares}</p>
	  <button id="bid-button">Bid</button>
	  <button id="short-button">Short</button>
	  <button id="exchange-button">Exchange</button>
	</div>
  `;
    document.body.appendChild(stockTradeModal);
    // Generate unique ID for tracking
    const modalId = `stockTradeModal_${Date.now()}`;
    stockTradeModal.id = modalId;
    // Track popup state for bot interaction management
    if (window.popupTracker) window.popupTracker.trackElement(stockTradeModal, 'stock-trade-modal');
    const closeButton = stockTradeModal.querySelector('.close');
    closeButton.onclick = ()=>{
        // Untrack popup before removing
        if (window.popupTracker) window.popupTracker.unregisterPopup(modalId);
        stockTradeModal.remove();
    };
    const bidButton = stockTradeModal.querySelector('#bid-button');
    bidButton.onclick = ()=>{
        localStorage.setItem('stockData', JSON.stringify(stock));
        window.location.href = `stockTransaction.html?stockId=${stock._id}&stockName=${stock.name}`;
    };
    const exchangeButton = stockTradeModal.querySelector('#exchange-button');
    exchangeButton.onclick = ()=>{
        const itemId = prompt((0, $fUPn2.t)('stock.enter_item_id', 'Enter the item ID to exchange for the stock:'));
        if (!itemId) return;
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        if (!s || !s.connected) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('stock.ws_not_connected', 'Not connected. Please try again.'), false);
            return;
        }
        const payload = {
            stockId: stock._id,
            itemId: itemId,
            portfolioId: $14e813777626223f$var$getPortfolioId(),
            portfolioName: $14e813777626223f$var$getCookie('username'),
            sessionId: $14e813777626223f$export$b3739caaf2580dd()
        };
        s.emit('exchangeStockForItem', payload, (ack)=>{
            if (ack && ack.success === false) {
                (0, $eD3DY.showNotification)(ack.error || (0, $fUPn2.t)('stock.exchange_failed', 'Exchange failed.'), false);
                return;
            }
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('stock.exchange_sent', 'Exchange proposed.'), true);
            stockTradeModal.remove();
        });
    };
}
function $14e813777626223f$export$aa71e03faf15c300(bidData, portfolioId, timeoutDuration = 10000) {
    console.log('Attempting to show stock bid popup:', bidData);
    bidData.isResponder = true;
    // Remove any existing popup
    let existingPopup = document.getElementById("stockBidPopup");
    if (existingPopup) {
        console.log('Removing existing popup.');
        existingPopup.remove();
    }
    // Create a new popup
    const popup = document.createElement("div");
    popup.setAttribute("id", "stockBidPopup");
    popup.setAttribute("style", `
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	max-width: 100%;
	height: 100%;
	max-height: 100%;
	border-radius: 0px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
	z-index: 9999;
	font-family: 'bithigh', Arial, sans-serif;
	color: #00ff00;
	text-align: center;
	align-content: center;
	overflow: hidden;
  `);
    // Create video element
    const video = document.createElement("video");
    video.setAttribute("id", "stockBidBackground");
    video.setAttribute("style", `
	  position: absolute;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  object-fit: cover;
	  z-index: -1;
	  pointer-events: none; /* Ensure the video is non-interactive */
	`);
    video.setAttribute("autoplay", "true");
    video.setAttribute("loop", "true");
    video.setAttribute("muted", "true");
    video.setAttribute("playsinline", "true"); // Required for autoplay on mobile
    popup.appendChild(video);
    // Prevent interaction with the video
    video.addEventListener('click', (event)=>{
        event.stopPropagation();
        event.preventDefault();
    });
    // Prevent fullscreen on double-click
    video.addEventListener('dblclick', (event)=>{
        event.stopPropagation();
        event.preventDefault();
    });
    // Prevent right-click context menu
    video.addEventListener('contextmenu', (event)=>{
        event.preventDefault();
    });
    // Create content container
    const content = document.createElement("div");
    content.setAttribute("style", `
	 position: relative;
	 z-index: 1;
	 padding: 20px;
	 border-radius: 10px;
  `);
    // Translate company name using companies_by_id pattern if csvRow is available
    const csvRow = bidData.csvRow || bidData.companyCsvId || bidData.stockCsvRow;
    const translatedStockName = csvRow ? (0, $fUPn2.t)(`companies_by_id.${csvRow}.Company_Name`, bidData.stockName) : bidData.stockName;
    // Determine the bid description based on bid type
    let bidDescription = '';
    if (bidData.bidType === 'points') bidDescription = (0, $fUPn2.t)('stock_bid.offers_to_buy_points', '{portfolioName} offers to buy {shares} shares of {stockName} for {amount} of Capital.').replace('{portfolioName}', bidData.portfolioName).replace('{shares}', bidData.shares).replace('{stockName}', translatedStockName).replace('{amount}', bidData.amount);
    else if (bidData.bidType === 'zollars') bidDescription = (0, $fUPn2.t)('stock_bid.offers_to_buy_zollars', '{portfolioName} offers to buy {shares} shares of {stockName} for the following zollars:').replace('{portfolioName}', bidData.portfolioName).replace('{shares}', bidData.shares).replace('{stockName}', translatedStockName);
    content.innerHTML = `
	<h2>${(0, $fUPn2.t)('stock_bid.title', 'Stock Bid Offer')}</h2>
	<p class="zx-sec-explain" style="text-align:left;max-width:520px;margin:6px auto 10px;">${(0, $fUPn2.t)('floor.exp_stock_bid', "Another trader on the floor \u2014 often one of the market's bots \u2014 wants to buy shares you hold. Accept and their payment is yours; decline and nothing changes.")}</p>
	<p>${bidDescription}</p>
	${bidData.bidType === 'zollars' ? displayZollarDetails(bidData.zollarBid) : ''}
	<button id="acceptBid" style="margin: 10px; padding: 12px 24px; min-height: 44px; min-width: 44px; background-color: rgba(0, 255, 0, 0.7); color: black; border: none; cursor: pointer; touch-action: manipulation; font-size: 16px; font-family: 'bithigh', Arial, sans-serif;">Accept</button>
	<button id="declineBid" style="margin: 10px; padding: 12px 24px; min-height: 44px; min-width: 44px; background-color: rgba(255, 0, 0, 0.7); color: white; border: none; cursor: pointer; touch-action: manipulation; font-size: 16px; font-family: 'bithigh', Arial, sans-serif;">Decline</button>
	<div id="bidTimer"></div>
  `;
    popup.appendChild(content);
    // Append the popup to the body
    document.body.appendChild(popup);
    document.body.style.overflow = 'hidden';
    console.log('Popup should now be visible.');
    // Track popup state for bot interaction management
    if (window.popupTracker) window.popupTracker.trackElement(popup, 'stock-bid-popup');
    // Video background logic
    const videoBaseUrl = `${(0, $cNeIB.apiBaseUrl)}/uploads/specialBacks/stockBack/`;
    const totalVideos = 62;
    const videoIndex = Math.floor(Math.random() * totalVideos) + 1;
    const videoUrl = `${videoBaseUrl}${videoIndex}/playlist.m3u8`;
    if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(videoUrl);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, function() {
            video.play();
        });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoUrl;
        video.addEventListener('loadedmetadata', function() {
            video.play();
        });
    }
    const timerElement = document.getElementById('bidTimer');
    let remainingTime = timeoutDuration / 1000;
    const timerInterval = setInterval(()=>{
        remainingTime -= 1;
        if (timerElement) timerElement.textContent = (0, $fUPn2.t)('stock_bid.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', remainingTime);
        if (remainingTime <= 0) {
            clearInterval(timerInterval);
            if (timerElement) timerElement.textContent = (0, $fUPn2.t)('stock_bid.time_expired', 'Time expired');
            declineBid();
        }
    }, 1000);
    // Accept bid function
    const acceptBid = ()=>{
        clearInterval(timerInterval);
        const stockId = bidData.stockId;
        const bidId = bidData.bidId;
        const transactionId = bidData.transactionId || bidData.bidId;
        const initiatorPortfolioId = bidData.bidderId || bidData.initiatorPortfolioId;
        const responderPortfolioId = $14e813777626223f$var$getPortfolioId();
        const bidShares = bidData.shares;
        const bidType = bidData.bidType;
        const token = (0, $21EbS.getAuthToken)();
        const sessionId = $14e813777626223f$export$b3739caaf2580dd();
        if (!(stockId && bidId && initiatorPortfolioId && responderPortfolioId && bidShares && bidType && token)) {
            console.error('Invalid data for accepting bid:', {
                stockId: stockId,
                bidId: bidId,
                transactionId: transactionId,
                initiatorPortfolioId: initiatorPortfolioId,
                responderPortfolioId: responderPortfolioId,
                bidShares: bidShares,
                bidType: bidType
            });
            return;
        }
        // Mark user as responder - prevents redirect even if on stockTransaction.html
        window.__userIsInitiator = false;
        const _onceMood = (payload)=>{
            try {
                if (payload && payload.success !== false) {
                    const mood = payload.analysis || payload.moodResult;
                    if (mood) // Show immediately for responder (don't store, don't set redirect flag)
                    try {
                        (0, $bNbKd.showMoodAnalysisPopup)(mood);
                        // Clear sessionStorage to prevent duplicate display on next page
                        sessionStorage.removeItem('pendingMoodAnalysis');
                    // DO NOT set window.__pendingMarketRedirect for responders
                    } catch (e) {
                        console.error('Failed to show mood popup:', e);
                    }
                }
            } finally{
                (0, $cJVho.socket).off('moodAnalysis', _onceMood);
            // DO NOT redirect for responders
            }
        };
        (0, $cJVho.socket).once('moodAnalysis', _onceMood);
        // REMOVED duplicate notification - socketU.js bidAcceptSuccess handler will show it
        // This prevents double notifications when accepting a bid
        if (!(0, $cJVho.socket) || !(0, $cJVho.socket).connected) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('stock.ws_not_connected', 'Not connected. Please try again.'), false);
            (0, $cJVho.socket).off('moodAnalysis', _onceMood); // cleanup if we bail
            return;
        }
        try {
            popup.remove();
        } catch (e) {}
        document.body.style.overflow = 'auto';
        (0, $cJVho.socket).emit('acceptBid', {
            transactionId: transactionId,
            stockId: stockId,
            bidId: bidId,
            portfolioId: responderPortfolioId,
            bidderId: initiatorPortfolioId,
            bidShares: bidShares,
            bidType: bidType,
            token: token,
            sessionId: sessionId
        }, (ack)=>{
            if (ack && ack.success === false) {
                (0, $eD3DY.showNotification)(ack.error || (0, $fUPn2.t)('stock.accept_failed', 'Failed to accept bid.'), false);
                return;
            }
        // Success notification will be shown by bidAcceptSuccess socket handler
        });
    };
    const declineBid = ()=>{
        clearInterval(timerInterval);
        const stockId = bidData.stockId;
        const bidId = bidData.bidId;
        const transactionId = bidData.transactionId || bidData.bidId;
        const initiatorPortfolioId = bidData.bidderId || bidData.initiatorPortfolioId; // buyer
        const responderPortfolioId = $14e813777626223f$var$getPortfolioId(); // seller
        const bidShares = bidData.shares;
        const bidType = bidData.bidType;
        const token = (0, $21EbS.getAuthToken)();
        const sessionId = $14e813777626223f$export$b3739caaf2580dd();
        if (!(stockId && bidId && initiatorPortfolioId && responderPortfolioId && bidShares && bidType && token)) {
            console.error('Invalid data for declining bid:', {
                stockId: stockId,
                bidId: bidId,
                transactionId: transactionId,
                initiatorPortfolioId: initiatorPortfolioId,
                responderPortfolioId: responderPortfolioId,
                bidShares: bidShares,
                bidType: bidType
            });
            return;
        }
        // Mark user as responder - prevents redirect even if on stockTransaction.html
        window.__userIsInitiator = false;
        const _onceMood = (payload)=>{
            try {
                if (payload && payload.success !== false) {
                    const mood = payload.analysis || payload.moodResult;
                    if (mood) // Show immediately for responder (don't store, don't set redirect flag)
                    try {
                        (0, $bNbKd.showMoodAnalysisPopup)(mood);
                        // Clear sessionStorage to prevent duplicate display on next page
                        sessionStorage.removeItem('pendingMoodAnalysis');
                    // DO NOT set window.__pendingMarketRedirect for responders
                    } catch (e) {
                        console.error('Failed to show mood popup:', e);
                    }
                }
            } finally{
                (0, $cJVho.socket).off('moodAnalysis', _onceMood);
            // DO NOT redirect for responders
            }
        };
        (0, $cJVho.socket).once('moodAnalysis', _onceMood);
        // REMOVED duplicate notification - socketU.js bidDeclineSuccess handler will show it
        // This prevents double notifications when declining a bid
        if (!(0, $cJVho.socket) || !(0, $cJVho.socket).connected) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('stock.ws_not_connected', 'Not connected. Please try again.'), false);
            (0, $cJVho.socket).off('moodAnalysis', _onceMood); // cleanup if we bail
            return;
        }
        try {
            popup.remove();
        } catch (e) {}
        document.body.style.overflow = 'auto';
        (0, $cJVho.socket).emit('declineBid', {
            transactionId: transactionId,
            stockId: stockId,
            bidId: bidId,
            portfolioId: responderPortfolioId,
            bidderId: initiatorPortfolioId,
            bidShares: bidShares,
            bidType: bidType,
            token: token,
            sessionId: sessionId
        }, (ack)=>{
            if (ack && ack.success === false) {
                (0, $eD3DY.showNotification)(ack.error || (0, $fUPn2.t)('stock.decline_failed', 'Failed to decline bid.'), false);
                return;
            }
        // Success notification will be shown by bidDeclineSuccess socket handler
        });
    };
    const acceptButton = popup.querySelector("#acceptBid");
    const declineButton = popup.querySelector("#declineBid");
    if (acceptButton && declineButton) {
        acceptButton.addEventListener('click', acceptBid);
        declineButton.addEventListener('click', declineBid);
    } else console.error("Accept or decline buttons not found in DOM.");
    function displayZollarDetails(zollarBid) {
        if (!zollarBid || Object.keys(zollarBid).length === 0) return '<p>No zollar details available.</p>';
        let zollarHtml = '<ul>';
        for (const [type, value] of Object.entries(zollarBid))if (value > 0) {
            const descriptor = $14e813777626223f$var$getQualitativeDescriptor(value);
            zollarHtml += `<li>${type}: ${descriptor}</li>`;
        }
        zollarHtml += '</ul>';
        return zollarHtml;
    }
}
function $14e813777626223f$export$b000159a735d13c1(isResponder = false) {
    console.log('closeWaitingForResponsePopup called, isResponder:', isResponder);
    const ids = [
        'waitingPopup',
        'stockBidPopup',
        'bidSubmittingOverlay'
    ];
    for (const id of ids){
        const el = document.getElementById(id);
        if (el) {
            // Untrack popup before removing
            if (window.popupTracker) window.popupTracker.unregisterPopup(id);
            el.remove();
        }
    }
    // Clear all intervals
    if (window.__bidSubmittingInterval) {
        clearInterval(window.__bidSubmittingInterval);
        window.__bidSubmittingInterval = null;
    }
    if (window.__instantWaitInterval) {
        clearInterval(window.__instantWaitInterval);
        window.__instantWaitInterval = null;
    }
    if (window.__waitingPopupInterval) {
        clearInterval(window.__waitingPopupInterval);
        window.__waitingPopupInterval = null;
    }
    try {
        document.body.style.overflow = '';
    } catch (_) {}
    // CRITICAL: If responder, do nothing and exit
    if (isResponder) {
        console.log('Responder - NOT redirecting');
        return;
    }
    console.log('Initiator - setting up redirect logic');
    // Only for initiators: check if mood popup is open
    try {
        const moodEl = document.getElementById('moodAnalysisPopup') || document.getElementById('moodPopup') || document.querySelector('.mood-popup, .moodAnalysis, .mood-analysis, [data-mood-popup]');
        if (moodEl) {
            window.__pendingMarketRedirect = true;
            const obs = new MutationObserver(()=>{
                const stillOpen = document.getElementById('moodAnalysisPopup') || document.getElementById('moodPopup') || document.querySelector('.mood-popup, .moodAnalysis, .mood-analysis, [data-mood-popup]');
                if (!stillOpen) {
                    try {
                        doMarketRedirectIfNeeded();
                    } catch (_) {}
                    obs.disconnect();
                }
            });
            obs.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else doMarketRedirectIfNeeded();
    } catch (e) {
        try {
            doMarketRedirectIfNeeded();
        } catch (_) {}
    }
}
async function $14e813777626223f$var$addGlobalIndicator(stockElement, stock) {
    if (!stock.isSystemCompany || !stock.systemCompanyId) return;
    try {
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/stocks/global-valuation/${stock.systemCompanyId}`, {
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            }
        });
        if (response.ok) {
            const globalData = await response.json();
            const indicator = document.createElement('small');
            indicator.style.color = '#00ff00';
            indicator.style.display = 'block';
            indicator.innerHTML = `\u{1F310} Global: \u{1B5}${globalData.currentShareValue.toFixed(2)} | Trades: ${globalData.tradingStats.totalTransactions}`;
            stockElement.querySelector('h3').after(indicator);
        }
    } catch (error) {
        console.warn('Could not add global indicator:', error.message);
    }
}
function $14e813777626223f$var$getQualitativeDescriptor(quantity) {
    if (quantity === 0) return 'None';
    else if (quantity >= 1 && quantity <= 3) return 'A Few';
    else if (quantity >= 4 && quantity <= 7) return 'Some';
    else if (quantity >= 8 && quantity <= 15) return 'Many';
    else return 'A Huge Amount';
}
function $14e813777626223f$var$setFallbackBackground(element) {
    element.style.backgroundImage = 'linear-gradient(45deg, #000000, #001f3f)';
    element.style.backgroundSize = 'cover';
}

});

parcelRegister("8X27K", function(module, exports) {

$parcel$export(module.exports, "fetchBondData", () => $68457b2e043c885d$export$de4adcbe4254516b);
$parcel$export(module.exports, "buyBond", () => $68457b2e043c885d$export$58db19e34d32f9d);
$parcel$export(module.exports, "showBondBidPopup", () => $68457b2e043c885d$export$28abc84d2983bd41);

var $5W4EI = parcelRequire("5W4EI");

var $cJVho = parcelRequire("cJVho");

var $21EbS = parcelRequire("21EbS");

var $eD3DY = parcelRequire("eD3DY");
parcelRequire("fUPn2");
function $68457b2e043c885d$var$getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
function $68457b2e043c885d$var$getPortfolioId() {
    return $68457b2e043c885d$var$getCookie('portfolioId') || localStorage.getItem('portfolioId');
}
async function $68457b2e043c885d$export$de4adcbe4254516b(bondId) {
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/bonds/${bondId}`, {
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            }
        });
        console.log('Response Status:', response.status);
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('text/html')) {
            // Handle unexpected HTML response (e.g., login page)
            console.error('Unexpected HTML response. Redirecting to login...');
            window.location.href = '/login.html';
            return null;
        }
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to fetch bond data');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching bond data:', error);
        return null;
    }
}
async function $68457b2e043c885d$export$484c8551133d696f(bondId, amount, targetUser) {
    if (!bondId || typeof bondId !== 'string') {
        console.error('Invalid bondId provided:', bondId);
        throw new Error('Invalid bondId.');
    }
    if (!amount || isNaN(amount) || amount <= 0) {
        console.error('Invalid bid amount provided:', amount);
        throw new Error('Invalid bid amount.');
    }
    if (!targetUser || typeof targetUser !== 'string') {
        console.error('Invalid targetUser provided:', targetUser);
        throw new Error('Invalid targetUser.');
    }
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/bonds/${bondId}/bids`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                amount: amount,
                targetUser: targetUser
            })
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to place bid.');
        }
        console.log('Bid placed successfully!');
    } catch (error) {
        console.error('Error placing bond bid:', error.message);
        throw error;
    }
}
async function $68457b2e043c885d$export$58db19e34d32f9d(bondId) {
    try {
        console.log('Initiating bond purchase for ID:', bondId);
        // Retrieve buyer's portfolioId from localStorage
        const buyerPortfolioId = localStorage.getItem('portfolioId');
        console.log('Retrieved buyerPortfolioId from localStorage:', buyerPortfolioId);
        // Throw an error if portfolioId is missing
        if (!buyerPortfolioId) throw new Error('Portfolio ID is missing in localStorage');
        // Send portfolioId along with the request
        const payload = JSON.stringify({
            portfolioId: buyerPortfolioId
        });
        console.log('Payload sent to backend:', payload);
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/bonds/buy/${bondId}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: payload
        });
        if (!response.ok) {
            const errorData = await response.json();
            console.error('API error response:', errorData);
            throw new Error(errorData.error || 'Failed to buy bond');
        }
        const data = await response.json();
        console.log('Bond purchase response data:', data);
        return data;
    } catch (error) {
        console.error('Error buying bond:', error);
        throw error;
    }
}
function $68457b2e043c885d$export$28abc84d2983bd41(bidData, portfolioId) {
    const yieldDescriptor = $68457b2e043c885d$var$getQualitativeDescriptor(bidData.zollarValue || 0);
    // Create and populate the popup
    const popup = document.createElement('div');
    popup.id = 'BondPop-popup-container';
    popup.innerHTML = `
	<div class="BondPop-popup-content">
	  <h2>Bond Bid Offer</h2>
	  <h3><strong>${bidData.portfolioName} offers to buy "${bidData.bondName}" for ${bidData.amount} points.</strong></h3>
	  <p><strong>Interest Rate:</strong> ${bidData.interestRate}%</p>
	  <p><strong>Yield:</strong> ${yieldDescriptor} Zollars</p>
	  <p><strong>Maturity Date:</strong> ${new Date(bidData.maturityDate).toLocaleString()}</p>
	  <p><strong>Current Price:</strong> ${bidData.price || 'N/A'}</p>
	  <div class="BondPop-buttons">
		<button id="BondPop-acceptOffer">Accept</button>
		<button id="BondPop-declineOffer">Decline</button>
	  </div>
	</div>
  `;
    document.body.appendChild(popup);
    // Event listener for accepting the bid
    document.getElementById('BondPop-acceptOffer').onclick = async ()=>{
        const { bondId: bondId, bidderId: bidderId } = bidData;
        const bondBidId = bidData._id;
        const portfolioId = $68457b2e043c885d$var$getPortfolioId();
        const token = localStorage.getItem('token');
        try {
            console.log('Accepting bond bid with data:', {
                bondId: bondId,
                bondBidId: bondBidId,
                portfolioId: portfolioId,
                bidderId: bidderId
            });
            // Include bidderId in the payload
            const response = await fetch(`/api/bonds/${bondId}/bids/accept`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    bondBidId: bondBidId,
                    portfolioId: portfolioId,
                    bidderId: bidderId
                })
            });
            const result = await response.json();
            if (response.ok) {
                (0, $eD3DY.showNotification)('Bid accepted successfully.', true);
                // Emit the bondBidAccepted event to notify the bidder
                (0, $cJVho.socket).emit('bondBidAccepted', {
                    bondId: bondId,
                    bidId: bondBidId,
                    bondName: bidData.bondName,
                    bidderId: bidderId
                });
            } else {
                console.error('Failed to accept bond bid:', result.error);
                (0, $eD3DY.showNotification)('Error accepting bid: ' + result.error, false);
            }
        } catch (error) {
            console.error('Network error:', error.message);
            (0, $eD3DY.showNotification)('Network error occurred while accepting bond bid.', false);
        }
        popup.remove();
    };
    // Event listener for declining the bid
    document.getElementById('BondPop-declineOffer').onclick = async ()=>{
        const { bondId: bondId, bidderId: bidderId } = bidData;
        const bondBidId = bidData._id;
        const portfolioId = $68457b2e043c885d$var$getPortfolioId();
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`/api/bonds/${bondId}/bids/decline`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    bondBidId: bondBidId,
                    portfolioId: portfolioId
                })
            });
            const result = await response.json();
            if (response.ok) {
                (0, $eD3DY.showNotification)('Bid declined successfully.', false);
                (0, $cJVho.socket).emit('bondBidDeclined', {
                    bondId: bondId,
                    bidId: bondBidId,
                    bondName: bidData.bondName,
                    bidderId: bidderId
                }); // Notify the initiator
            } else {
                console.error('Failed to decline bid:', result.error);
                (0, $eD3DY.showNotification)('Error declining bid: ' + result.error, false);
            }
        } catch (error) {
            console.error('Network error:', error.message);
            (0, $eD3DY.showNotification)('Network error occurred while declining bid.', false);
        }
        popup.remove();
    };
}
function $68457b2e043c885d$var$getQualitativeDescriptor(quantity) {
    if (quantity === 0) return 'None';
    else if (quantity === 1) return 'Little';
    else if (quantity >= 2 && quantity <= 5) return 'A Few';
    else if (quantity >= 6 && quantity <= 10) return 'Some';
    else if (quantity >= 11 && quantity <= 15) return 'Many';
    else return 'A Huge Amount';
}
function $68457b2e043c885d$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});

parcelRegister("eevDZ", function(module, exports) {

$parcel$export(module.exports, "showCommunityInvitationPopup", () => $a5caeb58e516bc0d$export$9c77a35647b896d4);
$parcel$export(module.exports, "startCommunityTimer", () => $a5caeb58e516bc0d$export$1199d36f0c9e0a05);
$parcel$export(module.exports, "showCommunityInterface", () => $a5caeb58e516bc0d$export$3f25e634dcc98320);
$parcel$export(module.exports, "checkAndShowCommunityInterface", () => $a5caeb58e516bc0d$export$591b253c76185331);
$parcel$export(module.exports, "handleCreateCommunity", () => $a5caeb58e516bc0d$export$2ecabe3f52b7ee5c);
$parcel$export(module.exports, "initializeCreateCommunityButton", () => $a5caeb58e516bc0d$export$e46fc5cf7ceaffbf);

var $5W4EI = parcelRequire("5W4EI");

var $cJVho = parcelRequire("cJVho");

var $21EbS = parcelRequire("21EbS");

var $fUPn2 = parcelRequire("fUPn2");
// Translation helper function
const $a5caeb58e516bc0d$var$showNotification = (message, isSuccess)=>{
    // See notif.js — the 3D floor renders its own 8-bit side cards. This module
    // keeps a private copy of the notification, so it needs the hook too.
    if (typeof window !== 'undefined' && typeof window.zxNotify === 'function') return window.zxNotify(message, isSuccess);
    const notification = document.createElement('div');
    notification.style = `
	position: fixed; bottom: 8%; right: -100%; 
	width: 80%; 
	max-width: 100%; 
	margin-left: auto; 
	margin-right: auto; 
	left: 5%; 
	background-color: ${isSuccess ? 'rgba(0, 255, 0, 0.9)' : 'rgba(255, 0, 0, 0.9)'}; 
	padding: 20px; border-radius: 5px; border: 2px solid #00ff00; 
	color: #000000; font-family: 'bithigh', Arial, sans-serif; 
	z-index: 10001; text-align: center; 
	transition: right 0.5s ease-out;
  `;
    notification.innerHTML = `<p style="color: #000000;">${message}</p>`;
    document.body.appendChild(notification);
    setTimeout(()=>{
        notification.style.right = '10%';
    }, 10);
    setTimeout(()=>{
        notification.style.right = '-100%';
        setTimeout(()=>notification.remove(), 500);
    }, 2000);
};
let $a5caeb58e516bc0d$var$communityTimer;
let $a5caeb58e516bc0d$var$communityId;
function $a5caeb58e516bc0d$export$9c77a35647b896d4(data) {
    console.log('Showing community invitation popup');
    const popup = document.createElement('div');
    popup.id = 'communityInvitationPopup';
    popup.style = `
	position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
	background-color: rgba(0, 0, 0, 0.85); padding: 20px; border-radius: 10px;
	z-index: 1000; color: #00ff00; font-family: 'bithigh', sans-serif; width: 98%; max-width:98%;
	height:98%; max-height:98%; align-content: center;
  `;
    popup.innerHTML = `
	<h2>${(0, $fUPn2.t)('Dark Pool Invitation', 'Dark Pool Invitation')}</h2>
	<p>${(0, $fUPn2.t)('Join the dark pool for exclusive trading.', 'Join the dark pool for exclusive trading.')}</p>
	<p>${(0, $fUPn2.t)('The dark pool will be active for 10 minutes.', 'The dark pool will be active for 10 minutes.')}</p>
	<div style="display: flex; justify-content: space-between; margin-top: 20px;">
	  <button id="acceptCommunity" style="padding: 10px 20px; cursor: pointer;">${(0, $fUPn2.t)('Accept', 'Accept')}</button>
	  <button id="declineCommunity" style="padding: 10px 20px; cursor: pointer;">${(0, $fUPn2.t)('Decline', 'Decline')}</button>
	</div>
  `;
    document.body.appendChild(popup);
    (function(invitationData) {
        const acceptButton = document.getElementById('acceptCommunity');
        const declineButton = document.getElementById('declineCommunity');
        if (acceptButton) acceptButton.addEventListener('click', function() {
            console.log('Accept button clicked');
            $a5caeb58e516bc0d$export$bc337264c9bc2c55(true, invitationData);
        });
        else console.error('Accept button not found');
        if (declineButton) declineButton.addEventListener('click', function() {
            console.log('Decline button clicked');
            $a5caeb58e516bc0d$export$bc337264c9bc2c55(false, invitationData);
        });
        else console.error('Decline button not found');
    })(data);
}
async function $a5caeb58e516bc0d$export$bc337264c9bc2c55(accept, data) {
    console.log('handleResponse called with:', accept, data);
    const portfolioId = (0, $cJVho.getPortfolioId)();
    const token = localStorage.getItem('token');
    if (!portfolioId) {
        console.error('Portfolio ID not found');
        $a5caeb58e516bc0d$var$showNotification('Error: Portfolio ID not found', false);
        return;
    }
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/community/join`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                communityId: data.communityId,
                accept: accept
            })
        });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to process join request: ${response.status} ${errorText}`);
        }
        const result = await response.json();
        console.log('Join request result:', result);
        if (result.success) {
            $a5caeb58e516bc0d$var$showNotification(result.message, true);
            if (accept) {
                $a5caeb58e516bc0d$export$1199d36f0c9e0a05(data.communityId);
                $a5caeb58e516bc0d$export$3f25e634dcc98320(data.communityId);
                localStorage.setItem('activeCommunity', data.communityId);
            }
        } else $a5caeb58e516bc0d$var$showNotification(result.message, false);
        if (typeof (0, $cJVho.socket) !== 'undefined' && (0, $cJVho.socket).connected) {
            (0, $cJVho.socket).emit('communityInvitationResponse', {
                portfolioId: portfolioId,
                communityId: data.communityId,
                accept: accept
            });
            console.log('Emitted communityInvitationResponse event');
        }
    } catch (error) {
        console.error('Error processing dark pool join request:', error);
        $a5caeb58e516bc0d$var$showNotification(`Error: ${error.message}`, false);
    } finally{
        const popupElement = document.getElementById('communityInvitationPopup');
        if (popupElement) popupElement.remove();
    }
}
function $a5caeb58e516bc0d$export$1199d36f0c9e0a05(communityId) {
    console.log('Starting dark pool timer:', communityId);
    const storedEndTime = localStorage.getItem('communityTimerEnd');
    let endTime;
    if (storedEndTime) endTime = parseInt(storedEndTime, 10);
    else {
        endTime = Date.now() + 600000;
        localStorage.setItem('communityTimerEnd', endTime.toString());
    }
    const timerElement = document.getElementById('communityTimer') || $a5caeb58e516bc0d$var$createTimerElement();
    function updateTimer() {
        const now = Date.now();
        const timeLeft = Math.max(0, endTime - now);
        if (timeLeft > 0) {
            const minutes = Math.floor(timeLeft / 60000);
            const seconds = Math.floor(timeLeft % 60000 / 1000);
            timerElement.textContent = `Dark Pool Clock: ${minutes}:${seconds.toString().padStart(2, '0')}`;
            setTimeout(updateTimer, 1000);
        } else {
            timerElement.textContent = 'Dark Pool Ended';
            localStorage.removeItem('communityTimerEnd');
            $a5caeb58e516bc0d$export$b8f7201e0649077(communityId);
        }
    }
    updateTimer();
}
function $a5caeb58e516bc0d$var$createTimerElement() {
    const timerElement = document.createElement('div');
    timerElement.id = 'communityTimer';
    timerElement.classList.add('community-timer');
    document.body.appendChild(timerElement);
    return timerElement;
}
function $a5caeb58e516bc0d$export$591b253c76185331(portfolioData) {
    if (portfolioData.inDarkPool) {
        const communityId = portfolioData.darkPoolId;
        $a5caeb58e516bc0d$export$1199d36f0c9e0a05(communityId);
        $a5caeb58e516bc0d$export$3f25e634dcc98320(communityId);
    } else {
        const communityTimer = document.getElementById('communityTimer');
        const communityInterface = document.getElementById('communityInterface');
        if (communityTimer) communityTimer.remove();
        if (communityInterface) communityInterface.remove();
        localStorage.removeItem('communityTimerEnd');
    }
}
async function $a5caeb58e516bc0d$export$3f25e634dcc98320(communityId) {
    console.log('Showing dark pool interface for community:', communityId);
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/community/${communityId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}` // Ensure the token is included
            }
        });
        if (!response.ok) throw new Error('Failed to fetch dark pool details');
        const community = await response.json();
        const interfaceElement = document.getElementById('communityInterface') || $a5caeb58e516bc0d$var$createInterfaceElement();
        interfaceElement.innerHTML = `
	  Dark Pool: ${community.poolName}
	  <button id="leaveCommunityBtn">${(0, $fUPn2.t)('Leave Dark Pool', 'Leave Dark Pool')}</button>
	`;
        const leaveCommunityBtn = document.getElementById('leaveCommunityBtn');
        if (leaveCommunityBtn) leaveCommunityBtn.addEventListener('click', ()=>$a5caeb58e516bc0d$export$28eae7baf543a40a(communityId));
        else console.error('Leave dark pool button not found');
    } catch (error) {
        console.error('Error fetching dark pool details:', error);
        $a5caeb58e516bc0d$var$showNotification('Error: Could not load dark pool details.', false);
    }
}
function $a5caeb58e516bc0d$var$createInterfaceElement() {
    const interfaceElement = document.createElement('div');
    interfaceElement.id = 'communityInterface';
    interfaceElement.classList.add('community-interface'); // Add this line to use the class from CSS
    document.body.appendChild(interfaceElement);
    return interfaceElement;
}
async function $a5caeb58e516bc0d$export$28eae7baf543a40a(communityId) {
    console.log('Attempting to leave dark pool:', communityId);
    const portfolioId = (0, $cJVho.getPortfolioId)();
    const token = localStorage.getItem('token');
    if (!portfolioId || !token) {
        console.error('Portfolio ID or token not found');
        $a5caeb58e516bc0d$var$showNotification('Error: Unable to leave dark pool. Please try again.', false);
        return;
    }
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/community/leave`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                communityId: communityId
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.message || `${(0, $fUPn2.t)('Failed to leave dark pool:', 'Failed to leave dark pool:')} ${response.status} - ${response.statusText}`);
        console.log('Left dark pool successfully:', result);
        if (result.success) {
            // Update local storage and UI
            localStorage.removeItem('communityTimerEnd');
            const communityTimer = document.getElementById('communityTimer');
            const communityInterface = document.getElementById('communityInterface');
            if (communityTimer) communityTimer.remove();
            if (communityInterface) communityInterface.remove();
            $a5caeb58e516bc0d$var$showNotification((0, $fUPn2.t)('You have left the dark pool.', 'You have left the dark pool.'), true);
            // Refresh the page or update the UI
            setTimeout(()=>location.reload(), 2000);
        } else throw new Error(result.message || 'Failed to leave community');
    } catch (error) {
        console.error('Error leaving community:', error);
        $a5caeb58e516bc0d$var$showNotification(`Error: ${error.message}`, false);
    }
}
async function $a5caeb58e516bc0d$export$b8f7201e0649077(communityId) {
    console.log('Dark pool timer ended:', communityId);
    // Clean up UI elements
    const communityTimer = document.getElementById('communityTimer');
    const communityInterface = document.getElementById('communityInterface');
    if (communityTimer) communityTimer.remove();
    if (communityInterface) communityInterface.remove();
    $a5caeb58e516bc0d$var$showNotification((0, $fUPn2.t)('The dark pool has ended.', 'The dark pool has ended.'), true);
    // Optionally reload to refresh state
    setTimeout(()=>location.reload(), 2000);
}
async function $a5caeb58e516bc0d$export$2ecabe3f52b7ee5c() {
    try {
        const portfolioId = (0, $cJVho.getPortfolioId)();
        const sessionId = localStorage.getItem('sessionId'); // Retrieve the sessionId from localStorage
        console.log('Initiating dark pool creation from trader:', portfolioId);
        if (!portfolioId) throw new Error('Initiator trader ID is undefined');
        if (!sessionId) throw new Error('Session ID is required to create a community.');
        const activePortfoliosResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/active`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: sessionId
            })
        });
        if (!activePortfoliosResponse.ok) throw new Error('Failed to fetch active traders');
        const activePortfolios = await activePortfoliosResponse.json();
        const eligiblePortfolios = activePortfolios.filter((p)=>p._id !== portfolioId && !p.isSuperUser);
        if (eligiblePortfolios.length < 2) {
            $a5caeb58e516bc0d$var$showNotification((0, $fUPn2.t)('Not enough eligible portfolios to create a community. Action cancelled.', 'Not enough eligible portfolios to create a community. Action cancelled.'), false);
            return;
        }
        const result = await $a5caeb58e516bc0d$var$showMultiUserSelectionPopup(eligiblePortfolios, portfolioId); // Pass portfolioId
        if (!result || !result.selectedUserIds || result.selectedUserIds.length < 2 || !result.poolName) {
            $a5caeb58e516bc0d$var$showNotification((0, $fUPn2.t)('Please select at least two members and provide a pool name. Action cancelled.', 'Please select at least two members and provide a pool name. Action cancelled.'), false);
            return;
        }
        const { selectedUserIds: selectedUserIds, poolName: poolName } = result;
        // Ensure the initiator's portfolio is included in the community
        if (!selectedUserIds.includes(portfolioId)) selectedUserIds.push(portfolioId);
        if ((0, $cJVho.socket) && (0, $cJVho.socket).connected) {
            // Emit the createCommunity event
            (0, $cJVho.socket).emit('createCommunity', {
                initiatorPortfolioId: portfolioId,
                selectedPortfolioIds: selectedUserIds,
                poolName: poolName
            });
            return new Promise((resolve, reject)=>{
                $a5caeb58e516bc0d$var$showNotification((0, $fUPn2.t)('Community creation request sent. Waiting for server confirmation.', 'Community creation request sent. Waiting for server confirmation.'), true);
                (0, $cJVho.socket).once('communityCreationStatus', (data)=>{
                    console.log('Received communityCreationStatus:', data);
                    if (data.success) {
                        $a5caeb58e516bc0d$export$1199d36f0c9e0a05(data.communityId);
                        $a5caeb58e516bc0d$export$3f25e634dcc98320(data.communityId);
                        localStorage.setItem('activeCommunity', data.communityId);
                        $a5caeb58e516bc0d$var$showNotification(data.message, true);
                        resolve(data);
                    } else {
                        $a5caeb58e516bc0d$var$showNotification(`Error: ${data.message}`, false);
                        reject(new Error(data.message));
                    }
                });
            });
        } else throw new Error('connection is not open.');
    } catch (error) {
        console.error('Error creating community:', error);
        $a5caeb58e516bc0d$var$showNotification(`Error: Could not create community. ${error.message}`, false);
    }
}
async function $a5caeb58e516bc0d$export$e46fc5cf7ceaffbf() {
    const createCommunityButton = document.getElementById('createCommunityButton');
    if (createCommunityButton) {
        createCommunityButton.classList.remove('hiddenCM');
        if (!createCommunityButton.hasEventListener) {
            createCommunityButton.addEventListener('click', $a5caeb58e516bc0d$export$2ecabe3f52b7ee5c);
            createCommunityButton.hasEventListener = true;
        }
    } else console.error('Create Dark Pool button not found in the DOM');
}
function $a5caeb58e516bc0d$var$showMultiUserSelectionPopup(users, initiatorId) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        popup.innerHTML = `
	  <h2>${(0, $fUPn2.t)('Enter Dark Pool Name:', 'Enter Dark Pool Name:')}</h2>
	  <input type="text" id="poolNameInput" placeholder="${(0, $fUPn2.t)('Enter dark pool name', 'Enter dark pool name')}" style="margin-bottom: 10px; width: 100%;">
	  <h2>${(0, $fUPn2.t)('Select members of the dark pool:', 'Select members of the dark pool:')}</h2>
	  <input type="text" id="userSearchInput" placeholder="${(0, $fUPn2.t)('Search users...', 'Search users...')}" style="margin-bottom: 10px; width: 100%;">
	  <div id="userList" style="max-height: 300px; overflow-y: auto; border: 1px solid rgba(0, 255, 0, 0.5); padding: 10px;">
		${users.map((user)=>`
		  <label style="display: block; margin-bottom: 5px;">
			<input type="checkbox" value="${user._id}" style="margin-right: 5px;">
			${user.name} ${user._id === initiatorId ? (0, $fUPn2.t)('(You)', '(You)') : ''}
		  </label>
		`).join('')}
	  </div>
	  <div class="selButMuCon">
	  		<button id="confirmSelectionMU">${(0, $fUPn2.t)('Confirm', 'Confirm')}</button>
			  <button id="cancelSelectionMU">${(0, $fUPn2.t)('Cancel', 'Cancel')}</button>
	  </div>
	`;
        document.body.appendChild(popup);
        const confirmButton = document.getElementById('confirmSelectionMU');
        const cancelButton = document.getElementById('cancelSelectionMU');
        const poolNameInput = document.getElementById('poolNameInput');
        const userSearchInput = document.getElementById('userSearchInput');
        const userListContainer = document.getElementById('userList');
        // Handle Search
        userSearchInput.addEventListener('input', ()=>{
            const searchTerm = userSearchInput.value.toLowerCase();
            userListContainer.innerHTML = users.filter((user)=>user.name.toLowerCase().includes(searchTerm)).map((user)=>`
		  <label style="display: block; margin-bottom: 5px;">
			<input type="checkbox" value="${user._id}" style="margin-right: 5px;">
			${user.name} ${user._id === initiatorId ? (0, $fUPn2.t)('(You)', '(You)') : ''}
		  </label>
		`).join('');
        });
        // Confirm Selection
        confirmButton.addEventListener('click', ()=>{
            const selectedUserIds = Array.from(userListContainer.querySelectorAll('input:checked')).map((input)=>input.value);
            const poolName = poolNameInput.value.trim();
            document.body.removeChild(popup);
            if (!selectedUserIds.includes(initiatorId)) selectedUserIds.push(initiatorId);
            resolve({
                selectedUserIds: selectedUserIds,
                poolName: poolName
            });
        });
        // Cancel Selection
        cancelButton.addEventListener('click', ()=>{
            document.body.removeChild(popup);
            resolve(null);
        });
    });
}

});

parcelRegister("29zN8", function(module, exports) {

$parcel$export(module.exports, "showMessagePopup", () => $19182f7a3ecd96d1$export$b353271f9887b6fd);
$parcel$export(module.exports, "sendMessage", () => $19182f7a3ecd96d1$export$465cb47180de50f0);
$parcel$export(module.exports, "displayReceivedMessage", () => $19182f7a3ecd96d1$export$679799c18573f9e4);
parcelRequire("86ioh");
parcelRequire("2C8cW");
parcelRequire("jL4uR");
parcelRequire("1NhFL");

var $cJVho = parcelRequire("cJVho");
parcelRequire("alKwv");

var $5W4EI = parcelRequire("5W4EI");

var $fUPn2 = parcelRequire("fUPn2");

var $15BR8 = parcelRequire("15BR8");
if (!globalThis.ZTranslations) globalThis.ZTranslations = (0, $15BR8.default);
if (typeof globalThis.$t !== 'function') globalThis.$t = (key, params)=>{
    return (0, $fUPn2.t)(key);
};
let $19182f7a3ecd96d1$var$activeChatSession = null;
function $19182f7a3ecd96d1$export$b353271f9887b6fd(portfolios, currentUserId) {
    const existingPopup = document.getElementById('messagePopup');
    if (existingPopup) existingPopup.remove();
    // Debug: Log portfolios to check data integrity
    console.log('Portfolios received for message popup:', portfolios);
    const filteredPortfolios = portfolios.filter((p)=>{
        const isValid = p.active && p._id !== currentUserId && !p.isSuperUser;
        if (!p.name) console.warn(`Portfolio with ID ${p._id} is missing the 'name' property.`);
        return isValid;
    });
    const popup = document.createElement('div');
    popup.id = 'messagePopup';
    popup.innerHTML = `
      <h2>${(0, $fUPn2.t)('messageSend.title')}</h2>
      <p>${(0, $fUPn2.t)('messageSend.costPerRecipient')}</p>
      <input 
        type="text" 
        id="recipientSearch" 
        placeholder="${(0, $fUPn2.t)('messageSend.searchRecipients')}" 
        style="width: 100%; margin-bottom: 10px; padding: 5px;"
      />
      <div id="recipientList" style="max-height: 200px; overflow-y: auto; border: 1px solid #ccc; padding: 5px;">
        ${filteredPortfolios.map((p)=>`
          <div class="recipient" data-name="${(p.name || '').toLowerCase()}">
            <input type="checkbox" id="recipient-${p._id}" value="${p._id}">
            <label for="recipient-${p._id}">${p.name || (0, $fUPn2.t)('messageSend.unnamedPortfolio')}</label>
          </div>
        `).join('')}
      </div>
      <textarea 
        id="messageContent" 
        maxlength="280" 
        placeholder="${(0, $fUPn2.t)('messageSend.placeholder280')}" 
        style="width: 100%; margin-top: 10px; padding: 5px;"
      ></textarea>
      <button id="sendMessageBtn" style="margin-top: 10px;">${(0, $fUPn2.t)('messageSend.send')}</button>
      <button id="closePopupBtn" style="margin-left: 10px;">${(0, $fUPn2.t)('messageSend.close')}</button>
  `;
    document.body.appendChild(popup);
    popup.style.display = 'block';
    // Track popup state
    if (window.popupTracker) {
        const popupHandle = window.popupTracker.trackElement(popup, 'message');
    }
    const searchInput = document.getElementById('recipientSearch');
    const recipientList = document.getElementById('recipientList');
    // Implement search functionality
    searchInput.addEventListener('input', function() {
        const query = this.value.toLowerCase();
        const recipients = recipientList.querySelectorAll('.recipient');
        recipients.forEach((recipient)=>{
            const name = recipient.getAttribute('data-name');
            if (name.includes(query)) recipient.style.display = 'block';
            else recipient.style.display = 'none';
        });
    });
    // Close button functionality
    document.getElementById('closePopupBtn').addEventListener('click', ()=>{
        document.body.removeChild(popup);
    });
    // Sanitize message input
    document.getElementById('messageContent').addEventListener('input', function() {
        this.value = this.value.replace(/[^\w\s.,!?-]/gi, '');
    });
}
function $19182f7a3ecd96d1$export$465cb47180de50f0(senderId, recipientPortfolioIds, content, senderName) {
    return new Promise((resolve, reject)=>{
        if (content.length > 280) {
            reject('Message exceeds 280 characters.');
            return;
        }
        const sanitizedContent = content.replace(/[^\w\s.,!?-]/gi, '');
        (0, $cJVho.socket).emit('sendMessage', {
            senderId: senderId,
            recipientPortfolioIds: recipientPortfolioIds,
            content: sanitizedContent,
            senderName: senderName
        }, (response)=>{
            if (response.success) resolve(response.message);
            else {
                console.error('Error sending message:', response.message);
                alert(response.message); // Display the error to the user
                reject(response.message);
            }
        });
    });
}

function $19182f7a3ecd96d1$export$679799c18573f9e4(message) {
    // First bot message ever: run the one-time coach explaining what a bot
    // message is. The coach overlay (z-index 13000) sits above this popup
    // (9999), so it reads first; closing it reveals the message underneath.
    const looksLikeBot = message.isBot || message.senderName && (message.senderName.includes('_') || /\d{4}$/.test(message.senderName));
    if (looksLikeBot && window.zxNudge?.showOnce) window.zxNudge.showOnce('botmsg', {
        tag: (0, $fUPn2.t)('nudge.botmsg_tag', 'A BOT IS TALKING TO YOU'),
        steps: [
            {
                h: (0, $fUPn2.t)('nudge.botmsg_1_h', 'That message is from a bot.'),
                b: (0, $fUPn2.t)('nudge.botmsg_1_b', "The floor is populated by trader-bots \u2014 they hold values, make offers, and talk like anyone else in the room. This one just reached out to you.")
            },
            {
                h: (0, $fUPn2.t)('nudge.botmsg_2_h', "Answer it \u2014 or don't."),
                b: (0, $fUPn2.t)('nudge.botmsg_2_b', 'You can reply, trade with it, or ignore it. Treat it as you would any trader: what you say and do shapes how the room treats you.')
            }
        ],
        cta: {
            label: (0, $fUPn2.t)('nudge.botmsg_cta', 'GOT IT')
        }
    });
    // Remove any existing overlay first
    const existingOverlay = document.getElementById('messageOverlay');
    if (existingOverlay) existingOverlay.remove();
    const overlay = document.createElement('div');
    overlay.id = 'messageOverlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
    overlay.style.display = 'flex';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const messageElement = document.createElement('div');
    messageElement.style.backgroundColor = 'black';
    messageElement.style.padding = '20px';
    messageElement.style.borderRadius = '10px';
    messageElement.style.maxWidth = '80%';
    messageElement.style.maxHeight = '70%';
    messageElement.style.color = '#00ff00';
    messageElement.style.fontFamily = 'bithigh, sans-serif';
    messageElement.style.border = '2px solid #00ff00';
    messageElement.style.overflow = 'hidden';
    messageElement.style.display = 'flex';
    messageElement.style.flexDirection = 'column';
    // Generate unique IDs for this message
    const messageId = `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    const respondBtnId = `respond_${messageId}`;
    const closeBtnId = `close_${messageId}`;
    messageElement.innerHTML = `
    <div style="
      border-bottom: 1px solid #00ff00;
      padding-bottom: 10px;
      margin-bottom: 15px;
    ">
      <p style="
        margin: 0;
        font-size: 14px;
        font-weight: bold;
      ">${(0, $fUPn2.t)('messageSend.newMessageFrom')}</p>
      <p style="
        margin: 5px 0 0 0;
        font-size: 16px;
        color: #66ff66;
      ">${message.senderName || (0, $fUPn2.t)('messageSend.unknown')}</p>
    </div>
    
    <div style="
      flex: 1;
      overflow-y: auto;
      max-height: 300px;
      padding-right: 10px;
      margin-bottom: 15px;
    ">
      <div style="
        font-size: 12px;
        line-height: 1.4;
        word-wrap: break-word;
        white-space: pre-wrap;
      ">${message.content || ''}</div>
    </div>
    
    <div style="
      display: flex;
      gap: 10px;
      justify-content: space-between;
      border-top: 1px solid #00ff00;
      padding-top: 15px;
    ">
      <button id="${respondBtnId}" style="
        flex: 1;
        padding: 10px 20px; 
        background-color: rgba(0, 255, 0, 0.2);
        font-family: 'bithigh', Arial, sans-serif;
        border: 1px solid #00ff00; 
        color: #00ff00; 
        font-weight: bold; 
        cursor: pointer; 
        border-radius: 5px;
        font-size: 12px;
        transition: background-color 0.3s;
      " onmouseover="this.style.backgroundColor='rgba(0, 255, 0, 0.3)'" 
         onmouseout="this.style.backgroundColor='rgba(0, 255, 0, 0.2)'">
        ${(0, $fUPn2.t)('messageSend.reply')}
      </button>
      
      <button id="${closeBtnId}" style="
        flex: 1;
        padding: 10px 20px; 
        background-color: rgba(0, 255, 0, 0.8);
        font-family: 'bithigh', Arial, sans-serif;
        border: none; 
        color: black; 
        font-weight: bold; 
        cursor: pointer; 
        border-radius: 5px;
        font-size: 12px;
        transition: background-color 0.3s;
      " onmouseover="this.style.backgroundColor='rgba(0, 255, 0, 0.9)'" 
         onmouseout="this.style.backgroundColor='rgba(0, 255, 0, 0.8)'">
        ${(0, $fUPn2.t)('messageSend.markAsRead')}
      </button>
    </div>
  `;
    overlay.appendChild(messageElement);
    document.body.appendChild(overlay);
    // Track popup state
    if (window.popupTracker) {
        const popupHandle = window.popupTracker.trackElement(overlay, 'received-message');
    }
    // Get the actual DOM elements using the unique IDs
    const closeButton = document.getElementById(closeBtnId);
    const respondButton = document.getElementById(respondBtnId);
    if (!closeButton || !respondButton) {
        console.error('Failed to find message buttons');
        return;
    }
    // Define cleanup function
    const closeMessage = ()=>{
        try {
            if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
        } catch (error) {
            console.error('Error closing message overlay:', error);
        }
        // Remove event listeners
        document.removeEventListener('keydown', handleEscape);
    };
    // Attach event listeners using the actual DOM elements
    const handleCloseClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        closeMessage();
    };
    const handleRespondClick = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        try {
            // Check if the sender is a bot
            const isBot = await $19182f7a3ecd96d1$var$checkIfBotSender(message.senderId, message.senderName);
            if (isBot) {
                closeMessage();
                // Use the global botChatHandler instance
                if (window.botChatHandler) window.botChatHandler.startChat(message.senderId, message.senderName);
                else // Fallback: import dynamically
                (parcelRequire("kJdNP")).then(({ botChatHandler: botChatHandler })=>{
                    botChatHandler.startChat(message.senderId, message.senderName);
                });
            } else {
                console.log('Cannot chat with human players');
                alert((0, $fUPn2.t)('messageSend.onlyChatBots'));
                closeMessage();
            }
        } catch (error) {
            console.error('Error handling respond click:', error);
            closeMessage();
        }
    };
    // Add event listeners
    closeButton.addEventListener('click', handleCloseClick);
    closeButton.addEventListener('touchend', handleCloseClick);
    respondButton.addEventListener('click', handleRespondClick);
    respondButton.addEventListener('touchend', handleRespondClick);
    // Handle overlay click (close when clicking outside)
    const handleOverlayClick = (e)=>{
        if (e.target === overlay) closeMessage();
    };
    overlay.addEventListener('click', handleOverlayClick);
    // Handle escape key
    const handleEscape = (e)=>{
        if (e.key === 'Escape') closeMessage();
    };
    document.addEventListener('keydown', handleEscape);
    // Store references for cleanup (optional - for debugging)
    overlay._messageData = {
        messageId: messageId,
        senderId: message.senderId,
        senderName: message.senderName,
        closeMessage: closeMessage,
        respondBtnId: respondBtnId,
        closeBtnId: closeBtnId
    };
}
// Helper function to check if sender is a bot
async function $19182f7a3ecd96d1$var$checkIfBotSender(senderId, senderName) {
    try {
        // Method 1: Check if sender name contains bot patterns
        if (senderName && (senderName.includes('_') || senderName.match(/\d{4}$/))) return true;
        // Method 2: Check local cache
        if (window.botStatusCache && window.botStatusCache.has(senderId)) {
            const cached = window.botStatusCache.get(senderId);
            if (Date.now() - cached.timestamp < 300000) return cached.isBot;
        }
        // Method 3: API call as fallback
        const token = localStorage.getItem('authToken');
        if (!token || !senderId) return false;
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolio/${senderId}/info`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (response.ok) {
            const data = await response.json();
            // Cache the result
            if (!window.botStatusCache) window.botStatusCache = new Map();
            window.botStatusCache.set(senderId, {
                isBot: data.isBot,
                timestamp: Date.now()
            });
            return data.isBot;
        }
    } catch (error) {
        console.error('Error checking bot status:', error);
    }
    return false;
}
function $19182f7a3ecd96d1$export$162ddd3b1cbe3b13(botId, botName) {
    // Remove any existing chat
    const existingChat = document.getElementById('botChatPopup');
    if (existingChat) existingChat.remove();
    $19182f7a3ecd96d1$var$activeChatSession = {
        botId: botId,
        botName: botName,
        chatId: null,
        exchangeCount: 0,
        maxExchanges: 4
    };
    const chatPopup = document.createElement('div');
    chatPopup.id = 'botChatPopup';
    chatPopup.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 350px;
    height: 500px;
    background-color: black;
    border: 2px solid #00ff00;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    z-index: 10000;
    font-family: 'bithigh', sans-serif;
    color: #00ff00;
  `;
    chatPopup.innerHTML = `
    <div style="
      padding: 15px;
      border-bottom: 1px solid #00ff00;
      display: flex;
      justify-content: space-between;
      align-items: center;
    ">
      <div>
        <div style="font-size: 14px; font-weight: bold;">${(0, $fUPn2.t)('messageSend.conversationWith')} ${botName}</div>
        <div style="font-size: 11px; color: #66ff66;" id="chatStatus">
          ${$19182f7a3ecd96d1$var$activeChatSession.maxExchanges - $19182f7a3ecd96d1$var$activeChatSession.exchangeCount} ${(0, $fUPn2.t)('messageSend.messagesRemaining')}
        </div>
      </div>
      <button id="closeChatBtn" style="
        background: none;
        border: 1px solid #00ff00;
        color: #00ff00;
        padding: 5px 10px;
        cursor: pointer;
        border-radius: 3px;
        font-size: 12px;
      ">\u{2715}</button>
    </div>
    
    <div id="chatMessages" style="
      flex: 1;
      overflow-y: auto;
      padding: 15px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    "></div>
    
    <div style="
      padding: 15px;
      border-top: 1px solid #00ff00;
      display: flex;
      gap: 10px;
    ">
      <input type="text" id="chatInput" placeholder="${(0, $fUPn2.t)('messageSend.typeYourMessage')}" style="
        flex: 1;
        background: rgba(0, 255, 0, 0.1);
        border: 1px solid #00ff00;
        color: #00ff00;
        padding: 8px;
        border-radius: 3px;
        font-family: inherit;
      " maxlength="280">
      <button id="sendChatBtn" style="
        background: rgba(0, 255, 0, 0.2);
        border: 1px solid #00ff00;
        color: #00ff00;
        padding: 8px 15px;
        cursor: pointer;
        border-radius: 3px;
        font-weight: bold;
      ">${(0, $fUPn2.t)('messageSend.send')}</button>
    </div>
  `;
    document.body.appendChild(chatPopup);
    // Track popup state
    if (window.popupTracker) {
        const popupHandle = window.popupTracker.trackElement(chatPopup, 'bot-chat');
    }
    // Add event listeners
    document.getElementById('closeChatBtn').addEventListener('click', $19182f7a3ecd96d1$var$closeBotChat);
    document.getElementById('sendChatBtn').addEventListener('click', $19182f7a3ecd96d1$var$sendChatMessage);
    document.getElementById('chatInput').addEventListener('keypress', (e)=>{
        if (e.key === 'Enter') $19182f7a3ecd96d1$var$sendChatMessage();
    });
    // Add initial bot greeting
    $19182f7a3ecd96d1$var$addChatMessage('bot', (0, $fUPn2.t)('messageSend.botGreeting', {
        name: botName
    }) || `Good day I'm ${botName}. What's on your mind?`);
}
async function $19182f7a3ecd96d1$var$sendChatMessage() {
    const input = document.getElementById('chatInput');
    const message = input.value.trim();
    if (!message || !$19182f7a3ecd96d1$var$activeChatSession) return;
    if ($19182f7a3ecd96d1$var$activeChatSession.exchangeCount >= $19182f7a3ecd96d1$var$activeChatSession.maxExchanges) {
        $19182f7a3ecd96d1$var$addChatMessage('system', (0, $fUPn2.t)('messageSend.chatLimitReached'));
        return;
    }
    // Add user message to chat
    $19182f7a3ecd96d1$var$addChatMessage('user', message);
    input.value = '';
    input.disabled = true;
    document.getElementById('sendChatBtn').disabled = true;
    try {
        const userId = localStorage.getItem('portfolioId');
        const authToken = localStorage.getItem('token');
        if (!userId) {
            console.error('No portfolioId found in localStorage');
            $19182f7a3ecd96d1$var$addChatMessage('system', 'Error: User not logged in');
            input.disabled = false;
            document.getElementById('sendChatBtn').disabled = false;
            return;
        }
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/sys/chat`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                botId: $19182f7a3ecd96d1$var$activeChatSession.botId,
                userId: userId,
                message: message,
                chatId: $19182f7a3ecd96d1$var$activeChatSession.chatId
            })
        });
        const data = await response.json();
        if (data.success) {
            $19182f7a3ecd96d1$var$activeChatSession.chatId = data.chatId;
            $19182f7a3ecd96d1$var$activeChatSession.exchangeCount++;
            // Add bot response
            $19182f7a3ecd96d1$var$addChatMessage('bot', data.response);
            // Update status
            const remaining = data.exchangesRemaining;
            document.getElementById('chatStatus').textContent = remaining > 0 ? `${remaining} ${(0, $fUPn2.t)('messageSend.messagesRemaining')}` : (0, $fUPn2.t)('messageSend.chatEnded');
            if (data.chatEnded) {
                input.disabled = true;
                document.getElementById('sendChatBtn').disabled = true;
                $19182f7a3ecd96d1$var$addChatMessage('system', (0, $fUPn2.t)('messageSend.chatEndedThanks'));
            } else {
                input.disabled = false;
                document.getElementById('sendChatBtn').disabled = false;
                input.focus();
            }
        } else {
            $19182f7a3ecd96d1$var$addChatMessage('system', (0, $fUPn2.t)('messageSend.error') + ': ' + (data.error || (0, $fUPn2.t)('messageSend.failedToSend')));
            input.disabled = false;
            document.getElementById('sendChatBtn').disabled = false;
        }
    } catch (error) {
        console.error('Chat error:', error);
        $19182f7a3ecd96d1$var$addChatMessage('system', (0, $fUPn2.t)('messageSend.connectionError'));
        input.disabled = false;
        document.getElementById('sendChatBtn').disabled = false;
    }
}
function $19182f7a3ecd96d1$var$addChatMessage(sender, content) {
    const messagesDiv = document.getElementById('chatMessages');
    const messageEl = document.createElement('div');
    const styles = {
        user: {
            align: 'flex-end',
            bg: 'rgba(0, 255, 0, 0.2)',
            border: '1px solid #00ff00',
            color: '#00ff00'
        },
        bot: {
            align: 'flex-start',
            bg: 'rgba(255, 255, 255, 0.1)',
            border: '1px solid #666',
            color: '#fff'
        },
        system: {
            align: 'center',
            bg: 'transparent',
            border: 'none',
            color: '#666'
        }
    };
    const style = styles[sender] || styles.system;
    messageEl.style.cssText = `
    align-self: ${style.align};
    max-width: 85%;
    padding: 8px 12px;
    background: ${style.bg};
    border: ${style.border};
    border-radius: 3px;
    color: ${style.color};
    font-size: 12px;
    word-wrap: break-word;
  `;
    messageEl.textContent = content;
    messagesDiv.appendChild(messageEl);
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
}
function $19182f7a3ecd96d1$var$closeBotChat() {
    const chatPopup = document.getElementById('botChatPopup');
    if (chatPopup) chatPopup.remove();
    // End chat session on backend
    if ($19182f7a3ecd96d1$var$activeChatSession && $19182f7a3ecd96d1$var$activeChatSession.chatId) fetch(`${(0, $5W4EI.apiBaseUrl)}/api/bot/endChat`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({
            chatId: $19182f7a3ecd96d1$var$activeChatSession.chatId
        })
    }).catch((err)=>console.error('Error ending chat:', err));
    $19182f7a3ecd96d1$var$activeChatSession = null;
}

});
parcelRegister("alKwv", function(module, exports) {

$parcel$export(module.exports, "initializeDeletePortfolioButton", () => $788ff41eb2df4559$export$a6e5bb0ae101fb2e);
$parcel$export(module.exports, "handleDeletePortfolioButtonClick", () => $788ff41eb2df4559$export$a0a11e9c42d99a1f);
$parcel$export(module.exports, "preloadPortfolios", () => $788ff41eb2df4559$export$91b56dc9b26ba8fd);
$parcel$export(module.exports, "showUserSelectionPopup", () => $788ff41eb2df4559$export$9885a1621cce704b);
$parcel$export(module.exports, "displayDeletePortfolioUpdate", () => $788ff41eb2df4559$export$325d8b74cba8b87);
$parcel$export(module.exports, "initializeLBOButton", () => $788ff41eb2df4559$export$aafa747b458d16d8);
$parcel$export(module.exports, "handleLBOButtonClick", () => $788ff41eb2df4559$export$2f8c058aa77a73ca);
$parcel$export(module.exports, "handleLBOUpdateForTarget", () => $788ff41eb2df4559$export$99b33fa79ed814ff);
$parcel$export(module.exports, "initializeSubsidyButton", () => $788ff41eb2df4559$export$5cfe6cad46ff1007);
$parcel$export(module.exports, "handleSubsidyButtonClick", () => $788ff41eb2df4559$export$11daf329a23b2dc3);
$parcel$export(module.exports, "handleSubsidyUpdateForTarget", () => $788ff41eb2df4559$export$63f273c71ca2c50a);
$parcel$export(module.exports, "handleSubsidyReceived", () => $788ff41eb2df4559$export$6598253ef2e7f85f);
$parcel$export(module.exports, "initializeStealButton", () => $788ff41eb2df4559$export$6a4c2457de50e17b);
$parcel$export(module.exports, "handleStealButtonClick", () => $788ff41eb2df4559$export$566bbb08b3c4ec3f);
$parcel$export(module.exports, "handleRansomButtonClick", () => $788ff41eb2df4559$export$1ac0c914c8d316);
$parcel$export(module.exports, "showConfirmGiveAwayPopup", () => $788ff41eb2df4559$export$ad2c4ba1304fb03a);
$parcel$export(module.exports, "playPubVideo", () => $788ff41eb2df4559$export$35f287f5175d77ea);
$parcel$export(module.exports, "playZnewsVideo", () => $788ff41eb2df4559$export$887e8fd7f92867b);
$parcel$export(module.exports, "handleItemStolen", () => $788ff41eb2df4559$export$31f3cf3256e53c73);
$parcel$export(module.exports, "handleSpecialActionNotification", () => $788ff41eb2df4559$export$3f11d1f2c5a135aa);
// button.js

var $5W4EI = parcelRequire("5W4EI");

var $eD3DY = parcelRequire("eD3DY");

var $cJVho = parcelRequire("cJVho");

var $21EbS = parcelRequire("21EbS");

var $fUPn2 = parcelRequire("fUPn2");

var $15BR8 = parcelRequire("15BR8");
if (!globalThis.ZTranslations) globalThis.ZTranslations = (0, $15BR8.default);
if (typeof globalThis.$t !== 'function') globalThis.$t = (key, params)=>{
    return (0, $fUPn2.t)(key);
};
function $788ff41eb2df4559$var$localizeCompanyName(stockObj = {}) {
    const key = stockObj.csvId || stockObj.companyCsvId || stockObj.id || stockObj._id;
    return key ? (0, $fUPn2.t)(`companies_by_id.${String(key)}.Company_Name`, stockObj.name || '') : stockObj.name || '';
}
function $788ff41eb2df4559$export$a6e5bb0ae101fb2e() {
    const deletePortfolioButton = document.getElementById('deletePortfolioButton');
    if (deletePortfolioButton) deletePortfolioButton.addEventListener('click', $788ff41eb2df4559$export$a0a11e9c42d99a1f);
}
// At the top of button.js, replace your cache declaration with:
const $788ff41eb2df4559$var$portfolioCache = new Map();
const $788ff41eb2df4559$var$CACHE_DURATION = 300000; // 5 minutes
// Add this function to preload on page load:
async function $788ff41eb2df4559$export$91b56dc9b26ba8fd() {
    const sessionId = localStorage.getItem('sessionId');
    if (!sessionId) return;
    try {
        // Fetch both endpoints in parallel
        const [active, richest] = await Promise.all([
            fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/active`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    sessionId: sessionId
                })
            }).then((r)=>r.json()),
            fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/richest`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    sessionId: sessionId
                })
            }).then((r)=>r.json())
        ]);
        const now = Date.now();
        $788ff41eb2df4559$var$portfolioCache.set('active', {
            data: active,
            timestamp: now
        });
        $788ff41eb2df4559$var$portfolioCache.set('richest', {
            data: richest,
            timestamp: now
        });
    } catch (error) {
        console.error('Failed to preload portfolios:', error);
    }
}
async function $788ff41eb2df4559$var$getCachedPortfolios(sessionId, endpoint = '/api/portfolios/active') {
    const cacheKey = endpoint.includes('richest') ? 'richest' : 'active';
    const cached = $788ff41eb2df4559$var$portfolioCache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < $788ff41eb2df4559$var$CACHE_DURATION) return cached.data;
    // Fallback to API call if cache miss
    const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}${endpoint}`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            sessionId: sessionId
        })
    });
    const data = await response.json();
    $788ff41eb2df4559$var$portfolioCache.set(cacheKey, {
        data: data,
        timestamp: Date.now()
    });
    return data;
}
// ===== Delete Portfolio =====
let $788ff41eb2df4559$var$isProcessingDelete = false;
async function $788ff41eb2df4559$export$a0a11e9c42d99a1f() {
    if ($788ff41eb2df4559$var$isProcessingDelete) return;
    $788ff41eb2df4559$var$isProcessingDelete = true;
    // Immediate visual feedback
    const button = document.getElementById('deletePortfolioButton');
    const originalText = button ? button.textContent : null;
    if (button) {
        button.textContent = 'Processing...';
        button.disabled = true;
        button.style.opacity = '0.2';
    }
    try {
        const initiatorPortfolioId = window.traderPortfolioId;
        const sessionId = localStorage.getItem('sessionId');
        if (!initiatorPortfolioId) throw new Error((0, $fUPn2.t)('triggers.initiatorUndefined', 'Initiator Portfolio ID is undefined'));
        if (!sessionId) throw new Error((0, $fUPn2.t)('triggers.sessionUndefined', 'Session ID is undefined'));
        // Cached portfolios
        const activePortfolios = await $788ff41eb2df4559$var$getCachedPortfolios(sessionId, '/api/portfolios/active');
        const eligiblePortfolios = activePortfolios.filter((p)=>p._id !== initiatorPortfolioId && !p.isSuperUser);
        if (eligiblePortfolios.length === 0) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.noEligible', 'No eligible portfolios to redistribute. Action cancelled.'), false);
            return;
        }
        const selectedUser = await $788ff41eb2df4559$export$9885a1621cce704b(eligiblePortfolios);
        if (!selectedUser || !selectedUser.selectedUserId) return;
        const portfolioToDeleteId = selectedUser.selectedUserId;
        const confirmDelete = await $788ff41eb2df4559$var$showConfirmDeletePopup();
        if (!confirmDelete) return;
        const deleteResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/useDeletePortfolioButton`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                initiatorPortfolioId: initiatorPortfolioId,
                portfolioToDeleteId: portfolioToDeleteId,
                sessionId: sessionId
            })
        });
        if (!deleteResponse.ok) {
            const errorData = await deleteResponse.json().catch(()=>({}));
            throw new Error(errorData.message || 'Failed to redistribute portfolio');
        }
        // Parse the response to get redistribution details
        const deleteResult = await deleteResponse.json();
        await (0, $cJVho.waitForSocketConnection)();
        (0, $cJVho.socket).emit('message', {
            action: 'deletePortfolioPerformed',
            initiatorPortfolioId: initiatorPortfolioId,
            targetPortfolioId: portfolioToDeleteId,
            sessionId: sessionId,
            redistributionDetails: deleteResult.redistributionDetails,
            targetPortfolioName: deleteResult.targetPortfolioName,
            initiatorPortfolioName: deleteResult.initiatorPortfolioName
        });
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.success', "The selected portfolio's holdings have been successfully redistributed."), true, ()=>location.reload());
    } catch (error) {
        console.error('Error using delete portfolio button:', error);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.error', 'Error: Could not redistribute the selected portfolio.')} ${error.message}`, false);
    } finally{
        if (button) {
            button.textContent = originalText;
            button.disabled = false;
            button.style.opacity = '1';
        }
        $788ff41eb2df4559$var$isProcessingDelete = false;
    }
}
function $788ff41eb2df4559$var$showConfirmDeletePopup() {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        // build DOM nodes instead of full innerHTML
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.title1', "Are you sure you want to redistribute the selected portfolio's holdings?");
        const body = document.createElement('p');
        body.textContent = (0, $fUPn2.t)('triggers.body1', "This will randomly redistribute the trader's portfolio holdings to random traders in the market.");
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn'; // Add this line
        confirmButton.textContent = (0, $fUPn2.t)('triggers.cta1', 'Yes, Trigger Communist Assault');
        Object.assign(confirmButton.style, {
            padding: '10px 20px',
            cursor: 'pointer'
        });
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn'; // Add this line
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        Object.assign(cancelButton.style, {
            padding: '10px 20px',
            cursor: 'pointer'
        });
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, body, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(true);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(false);
        }, {
            once: true
        });
    });
}
// --- showUserSelectionPopup
function $788ff41eb2df4559$export$9885a1621cce704b(users) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.selectPortfolioTitle', 'Select a Portfolio:');
        const select = document.createElement('select');
        select.id = 'userSelectMU';
        users.forEach((user)=>{
            const option = document.createElement('option');
            option.value = user._id;
            const name = user.name || user.username || user.displayName || (0, $fUPn2.t)('triggers.unknownUser', 'Unknown user');
            const wealth = Number(user.totalWealth ?? 0).toFixed(2);
            option.textContent = `${name} - ${(0, $fUPn2.t)('triggers.statsTotalWealth', 'Total Wealth:')} ${wealth}`;
            select.appendChild(option);
        });
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.id = 'confirmSelectionMU';
        confirmButton.className = 'cyber-confirm-btn'; // Add this line
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.id = 'cancelSelectionMU';
        cancelButton.className = 'cyber-cancel-btn'; // Add this line
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, select, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            const selectedUserId = select.value;
            popup.remove();
            resolve({
                selectedUserId: selectedUserId
            });
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(null);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$325d8b74cba8b87(data) {
    const message = data.message || 'No message provided.';
    const type = data.type || 'unknown'; // 'victim' or 'recipient'
    console.log('Displaying Communist Assault notification:', {
        type: type,
        data: data
    });
    const notificationPopup = document.createElement('div');
    notificationPopup.className = 'subsidy-popup';
    // Create main message
    const messageDiv = document.createElement('div');
    messageDiv.innerHTML = `<strong>${message}</strong>`;
    notificationPopup.appendChild(messageDiv);
    // If this user received assets, show details
    if (type === 'recipient') {
        const detailsDiv = document.createElement('div');
        detailsDiv.style.marginTop = '15px';
        detailsDiv.style.textAlign = 'left';
        const detailsList = [];
        // Show received items
        if (data.receivedItems && data.receivedItems.length > 0) detailsList.push(`<strong>Items:</strong> ${data.receivedItems.map((item)=>item.itemName).join(', ')}`);
        // Show received stocks
        if (data.receivedStocks && data.receivedStocks.length > 0) {
            const stocksList = data.receivedStocks.map((stock)=>`${stock.stockName} (${stock.quantity} shares)`).join(', ');
            detailsList.push(`<strong>Stocks:</strong> ${stocksList}`);
        }
        // Show received zollars
        if (data.receivedZollars && data.receivedZollars > 0) detailsList.push(`<strong>Zollars:</strong> ${data.receivedZollars}`);
        // Show received points
        if (data.receivedPoints && data.receivedPoints > 0) detailsList.push(`<strong>Trading Capital:</strong> ${data.receivedPoints}`);
        if (detailsList.length > 0) {
            detailsDiv.innerHTML = '<div style="margin-top: 10px; margin-bottom: 10px;"><strong>You received:</strong></div>' + detailsList.join('<br>');
            notificationPopup.appendChild(detailsDiv);
        }
    }
    // If this user was attacked, show attacker info and what was removed
    if (type === 'victim') {
        const attackerDiv = document.createElement('div');
        attackerDiv.style.marginTop = '10px';
        const attackerName = data.botName || data.initiatorName || 'Unknown';
        attackerDiv.innerHTML = `<em>Attacked by: ${attackerName}</em>`;
        notificationPopup.appendChild(attackerDiv);
        // Show what was removed from the victim
        const removedDiv = document.createElement('div');
        removedDiv.style.marginTop = '15px';
        removedDiv.style.textAlign = 'left';
        removedDiv.style.color = '#ff6b6b';
        const removedList = [];
        if (data.removedItems && data.removedItems > 0) removedList.push(`<strong>Commodities Lost:</strong> ${data.removedItems}`);
        if (data.removedStocks && data.removedStocks > 0) removedList.push(`<strong>Stocks Lost:</strong> ${data.removedStocks} holdings`);
        if (data.removedZollars && data.removedZollars > 0) removedList.push(`<strong>Zollars Lost:</strong> ${data.removedZollars}`);
        if (data.removedPoints && data.removedPoints > 0) removedList.push(`<strong>Trading Capital Lost:</strong> ${data.removedPoints}`);
        if (removedList.length > 0) {
            removedDiv.innerHTML = '<div style="margin-top: 10px; margin-bottom: 10px;"><strong>Assets Redistributed:</strong></div>' + removedList.join('<br>');
            notificationPopup.appendChild(removedDiv);
        }
    }
    const closeButton = document.createElement('button');
    closeButton.textContent = (0, $fUPn2.t)('triggers.close', 'Close');
    closeButton.className = 'close-button-subsidy';
    closeButton.style.marginTop = '15px';
    closeButton.addEventListener('click', ()=>{
        document.body.removeChild(notificationPopup);
    });
    notificationPopup.appendChild(closeButton);
    document.body.appendChild(notificationPopup);
}
function $788ff41eb2df4559$export$aafa747b458d16d8() {
    const LBOButton = document.getElementById('LBOButton');
    if (LBOButton) {
        LBOButton.removeEventListener('click', $788ff41eb2df4559$export$2f8c058aa77a73ca);
        LBOButton.addEventListener('click', $788ff41eb2df4559$export$2f8c058aa77a73ca);
    }
}
// ===== LBO =====
let $788ff41eb2df4559$var$isProcessingLBO = false;
async function $788ff41eb2df4559$export$2f8c058aa77a73ca() {
    if ($788ff41eb2df4559$var$isProcessingLBO) return; // Prevent double-clicks
    $788ff41eb2df4559$var$isProcessingLBO = true;
    // Immediate visual feedback
    const button = document.getElementById('LBOButton');
    const originalText = button ? button.textContent : null;
    if (button) {
        button.textContent = 'Processing...';
        button.disabled = true;
        button.style.opacity = '0.2';
    }
    // Remove any existing popups
    const existingPopups = document.querySelectorAll('.lbo-popup, #multiUserSelectionPopup');
    existingPopups.forEach((popup)=>popup.remove());
    try {
        const initiatorPortfolioId = window.traderPortfolioId;
        const sessionId = localStorage.getItem('sessionId');
        if (!initiatorPortfolioId) throw new Error((0, $fUPn2.t)('triggers.initiatorUndefined', 'Initiator Portfolio is undefined'));
        if (!sessionId) throw new Error((0, $fUPn2.t)('triggers.sessionUndefined', 'Session ID is undefined'));
        // Cached active portfolios
        const activePortfolios = await $788ff41eb2df4559$var$getCachedPortfolios(sessionId, '/api/portfolios/active');
        const eligiblePortfolios = activePortfolios.filter((p)=>p._id !== initiatorPortfolioId && !p.isSuperUser);
        if (eligiblePortfolios.length === 0) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.noEligible', 'No eligible portfolios to redistribute. Action cancelled.'), false);
            return;
        }
        // Show target selection popup
        const selectedTarget = await $788ff41eb2df4559$export$479635ceeb190e22(eligiblePortfolios);
        if (!selectedTarget || !selectedTarget.selectedUserId) return;
        const targetPortfolioId = selectedTarget.selectedUserId;
        // Fetch target's holdings
        const targetPortfolioResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/${targetPortfolioId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            }
        });
        if (!targetPortfolioResponse.ok) throw new Error(`Failed to fetch target portfolio: ${targetPortfolioResponse.status}`);
        const targetPortfolioData = await targetPortfolioResponse.json();
        // Popup for selecting stocks/items
        const { selectedItems: selectedItems = [], selectedStocks: selectedStocks = [] } = await $788ff41eb2df4559$export$470b4df794730a1d(targetPortfolioData) || {};
        if (!selectedItems.length && !selectedStocks.length) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.noAssetsSelected', 'No assets selected for LBO.'), false);
            return;
        }
        const LBOCost = $788ff41eb2df4559$export$ca36d7b4da6613a9(selectedItems, selectedStocks);
        const confirmLBO = await $788ff41eb2df4559$export$7d30655850cce209(LBOCost);
        if (!confirmLBO) return;
        // Send LBO request
        const lboResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/useLBOButton`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                initiatorPortfolioId: initiatorPortfolioId,
                targetPortfolioId: targetPortfolioId,
                sessionId: sessionId,
                selectedItems: selectedItems,
                selectedStocks: selectedStocks,
                LBOCost: LBOCost
            })
        });
        if (!lboResponse.ok) {
            const errorData = await lboResponse.json().catch(()=>({}));
            throw new Error(errorData.message || 'Failed to perform LBO');
        }
        const { addedStocks: addedStocks, removedStocks: removedStocks, addedItems: addedItems, removedItems: removedItems } = await lboResponse.json();
        await (0, $cJVho.waitForSocketConnection)();
        (0, $cJVho.socket).emit('message', {
            action: 'LBOPerformed',
            initiatorPortfolioId: initiatorPortfolioId,
            targetPortfolioId: targetPortfolioId,
            removedStocks: removedStocks,
            removedItems: removedItems
        });
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.successLBO', 'LBO triggered successfully.'), true, ()=>location.reload());
    } catch (error) {
        console.error('Error using LBO button:', error);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.errorPrefix', 'Error:')} ${error.message}`, false);
    } finally{
        if (button) {
            button.textContent = originalText;
            button.disabled = false;
            button.style.opacity = '1';
        }
        $788ff41eb2df4559$var$isProcessingLBO = false;
    }
}
function $788ff41eb2df4559$export$470b4df794730a1d(targetPortfolioData) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.className = 'lbo-popup';
        const itemOptions = targetPortfolioData.items?.map((item)=>`
		  <label>
			<input type="checkbox" data-id="${item._id}" data-points="${item.points || 0}">
			${item.item_name} - ${item.points || 0} ${(0, $fUPn2.t)('triggers.pointsLabel', 'Capital')}
		  </label>
		`).join('') || `<p>${(0, $fUPn2.t)('triggers.noItems', 'No commodities available')}</p>`;
        const stockOptions = targetPortfolioData.stocks?.map((stock)=>`
		  <label>
			<input type="checkbox" data-id="${stock.stock._id}" data-value="${stock.stock.shareValue}" data-quantity="${stock.quantity}">
			${(0, $fUPn2.t)(`companies_by_id.${String(stock.stock.csvId || stock.stock.companyCsvId || stock.stock.id || stock.stock._id || '')}.Company_Name`, stock.stock.name)} - ${stock.quantity} ${(0, $fUPn2.t)('triggers.sharesAt', 'shares at {value} each').replace('{value}', stock.stock.shareValue || 0)}
		  </label>
		`).join('') || `<p>${(0, $fUPn2.t)('triggers.noStocks', 'No stocks available')}</p>`;
        popup.innerHTML = `
		  <h2>${(0, $fUPn2.t)('triggers.selectAssetsTitle', 'Select assets for the LBO')}</h2>
		  <h3>${(0, $fUPn2.t)('triggers.selectAssetsItems', 'Commodities:')}</h3>
		  ${itemOptions}
		  <h3>${(0, $fUPn2.t)('triggers.selectAssetsStocks', 'Stocks:')}</h3>
		  ${stockOptions}
		  <div class="lbo-buttons">
			<button id="confirmSelectionLBO" class="lbo-button">${(0, $fUPn2.t)('triggers.confirm', 'Confirm')}</button>
			<button id="cancelSelectionLBO" class="lbo-button">${(0, $fUPn2.t)('triggers.cancel', 'Cancel')}</button>
		  </div>
		`;
        document.body.appendChild(popup);
        const confirmButton = document.getElementById('confirmSelectionLBO');
        const cancelButton = document.getElementById('cancelSelectionLBO');
        confirmButton.addEventListener('click', ()=>{
            const selectedItems = Array.from(popup.querySelectorAll('input[type="checkbox"]:checked[data-points]')).map((input)=>({
                    id: input.getAttribute('data-id'),
                    points: parseInt(input.getAttribute('data-points'), 10)
                }));
            const selectedStocks = Array.from(popup.querySelectorAll('input[type="checkbox"]:checked[data-quantity]')).map((input)=>({
                    id: input.getAttribute('data-id'),
                    quantity: parseInt(input.getAttribute('data-quantity'), 10),
                    shareValue: parseFloat(input.getAttribute('data-value'))
                }));
            document.body.removeChild(popup);
            resolve({
                selectedItems: selectedItems,
                selectedStocks: selectedStocks
            });
        });
        cancelButton.addEventListener('click', ()=>{
            document.body.removeChild(popup);
            resolve({
                selectedItems: [],
                selectedStocks: []
            });
        });
    });
}
function $788ff41eb2df4559$export$ca36d7b4da6613a9(selectedItems = [], selectedStocks = []) {
    let cost = 0;
    selectedItems.forEach((item)=>{
        cost += item.points || 0; // Sum the points for each selected item
    });
    selectedStocks.forEach((stock)=>{
        cost += (stock.shareValue || 0) * (stock.quantity || 0); // Calculate the total value for each selected stock
    });
    return Math.ceil(cost * 1.5); // Return 150% of the selected asset cost
}
function $788ff41eb2df4559$export$479635ceeb190e22(users) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.title_1', 'Select a portfolio to trigger an LBO on:');
        const select = document.createElement('select');
        select.id = 'userSelectLBO';
        users.forEach((user)=>{
            const option = document.createElement('option');
            option.value = user._id;
            const name = user.name || user.username || user.displayName || (0, $fUPn2.t)('triggers.unknownUser', 'Unknown user');
            const wealth = Number(user.totalWealth ?? 0).toFixed(2);
            option.textContent = `${name} - ${(0, $fUPn2.t)('triggers.statsTotalWealth', 'Total Wealth:')} ${wealth}`;
            select.appendChild(option);
        });
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn';
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn';
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, select, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve({
                selectedUserId: select.value
            });
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(null);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$7d30655850cce209(LBOCost) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.titleLBO', 'Confirm Leveraged Buyout');
        const body = document.createElement('p');
        body.textContent = (0, $fUPn2.t)('triggers.bodyLBO', 'This LBO will cost you {cost} of capital. Do you wish to proceed?').replace('{cost}', LBOCost);
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn'; // Add this line
        confirmButton.textContent = (0, $fUPn2.t)('triggers.ctaLBO', 'Yes, trigger the LBO');
        Object.assign(confirmButton.style, {
            padding: '10px 20px',
            cursor: 'pointer'
        });
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn'; // Add this line
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        Object.assign(cancelButton.style, {
            padding: '10px 20px',
            cursor: 'pointer'
        });
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, body, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(true);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(false);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$99b33fa79ed814ff(data) {
    const { message: message, removedStocks: removedStocks = [], removedItems: removedItems = [] } = data;
    const notificationPopup = document.createElement('div');
    notificationPopup.className = 'lbo-popup';
    let details = `<div>${message}</div><ul>`;
    if (removedStocks.length > 0) {
        details += `<li><strong>${(0, $fUPn2.t)('triggers.removedStocksLabel', 'Removed Stocks:')}</strong> `;
        details += removedStocks.map((stock)=>`${stock.quantity} ${(0, $fUPn2.t)('triggers.sharesWord', 'shares')} ${(0, $fUPn2.t)('triggers.ofWord', 'of')} ${(0, $fUPn2.t)('companies_by_id.' + String(stock.csvId || stock.companyCsvId || stock.id || stock.stockId || stock._id || '') + '.Company_Name', stock.name || (0, $fUPn2.t)('triggers.unknownStock', 'Unknown Stock'))}`).join(', ');
        details += `</li>`;
    }
    if (removedItems.length > 0) {
        details += `<li><strong>${(0, $fUPn2.t)('triggers.removedItemsLabel', 'Removed Commodities:')}</strong> `;
        details += removedItems.map((item)=>item.name || (0, $fUPn2.t)('triggers.unknownItem', 'Unknown Commodity')).join(', ');
        details += `</li>`;
    }
    details += `</ul>`;
    notificationPopup.innerHTML = details;
    // Use a real button element
    const closeButton = document.createElement('button');
    closeButton.textContent = (0, $fUPn2.t)('triggers.close', 'Close');
    closeButton.className = 'close-button-LBO';
    closeButton.style.marginTop = '10px';
    closeButton.addEventListener('click', ()=>{
        document.body.removeChild(notificationPopup);
    });
    notificationPopup.appendChild(closeButton);
    document.body.appendChild(notificationPopup);
}
function $788ff41eb2df4559$export$5cfe6cad46ff1007() {
    const SubsidyButton = document.getElementById('SubsidyButton');
    if (SubsidyButton) {
        SubsidyButton.removeEventListener('click', $788ff41eb2df4559$export$11daf329a23b2dc3);
        SubsidyButton.addEventListener('click', $788ff41eb2df4559$export$11daf329a23b2dc3);
    }
}
// ===== Subsidy =====
let $788ff41eb2df4559$var$isProcessingSubsidy = false;
async function $788ff41eb2df4559$export$11daf329a23b2dc3() {
    if ($788ff41eb2df4559$var$isProcessingSubsidy) return;
    $788ff41eb2df4559$var$isProcessingSubsidy = true;
    // Immediate visual feedback
    const button = document.getElementById('SubsidyButton');
    const originalText = button ? button.textContent : null;
    if (button) {
        button.textContent = 'Processing...';
        button.disabled = true;
        button.style.opacity = '0.2';
    }
    try {
        const initiatorPortfolioId = window.traderPortfolioId;
        const sessionId = localStorage.getItem('sessionId');
        if (!initiatorPortfolioId) throw new Error((0, $fUPn2.t)('triggers.initiatorUndefined', 'Initiator Portfolio is undefined'));
        if (!sessionId) throw new Error((0, $fUPn2.t)('triggers.sessionUndefined', 'Session is undefined'));
        // Cached richest portfolios
        const richPortfolios = await $788ff41eb2df4559$var$getCachedPortfolios(sessionId, '/api/portfolios/richest');
        if (!richPortfolios || richPortfolios.length === 0) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.noRichPortfolios', 'No rich portfolios available to target.'), false);
            return;
        }
        const selectedTarget = await $788ff41eb2df4559$var$showUserSelectionPopupSubsidy(richPortfolios);
        if (!selectedTarget || !selectedTarget.selectedUserId) return;
        const targetPortfolioId = selectedTarget.selectedUserId;
        const subsidyResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/useSubsidyButton`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                initiatorPortfolioId: initiatorPortfolioId,
                targetPortfolioId: targetPortfolioId,
                sessionId: sessionId
            })
        });
        if (!subsidyResponse.ok) {
            const errorData = await subsidyResponse.json().catch(()=>({}));
            throw new Error(errorData.message || 'Failed to perform Subsidy action');
        }
        // Extract the detailed amounts from the API response
        const subsidyData = await subsidyResponse.json();
        await (0, $cJVho.waitForSocketConnection)();
        (0, $cJVho.socket).emit('message', {
            action: 'SubsidyPerformed',
            initiatorPortfolioId: initiatorPortfolioId,
            targetPortfolioId: targetPortfolioId,
            sessionId: sessionId,
            taxedAmount: subsidyData.taxedAmount || 0,
            taxedZollars: subsidyData.taxedZollars || 0,
            taxedItems: subsidyData.taxedItems || 0
        });
        // NOTE: your flat key is "success3" (not namespaced)
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.success3', 'Subsidy action triggered successfully.'), true, ()=>location.reload());
    } catch (error) {
        console.error('Error using Subsidy button:', error);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.errorPrefix', 'Error:')} ${error.message}`, false);
    } finally{
        if (button) {
            button.textContent = originalText;
            button.disabled = false;
            button.style.opacity = '1';
        }
        $788ff41eb2df4559$var$isProcessingSubsidy = false;
    }
}
function $788ff41eb2df4559$var$showUserSelectionPopupSubsidy(users) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.selectRichTitle3', 'Select a rich portfolio to tax:');
        const select = document.createElement('select');
        select.id = 'userSelectSubsidy';
        users.forEach((user)=>{
            const option = document.createElement('option');
            option.value = user._id;
            option.textContent = `${user.name} - ${(0, $fUPn2.t)('triggers.statsTotalWealth', 'Total Wealth:')} ${user.totalWealth.toFixed(2)}`;
            select.appendChild(option);
        });
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn'; // Add this line
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn'; // Add this line
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, select, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve({
                selectedUserId: select.value
            });
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(null);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$63f273c71ca2c50a(data) {
    let { message: message, initiatorName: initiatorName, taxedAmount: taxedAmount, taxedZollars: taxedZollars, taxedItems: taxedItems } = data;
    // Build detailed notification message
    let detailsHTML = '';
    if (initiatorName) detailsHTML += `<p style="font-weight: bold; color: #fcba03; margin-bottom: 10px;">${initiatorName} triggered a Socialist Subsidy against you!</p>`;
    detailsHTML += `<p style="margin-bottom: 15px;">45% of your wealth has been redistributed to lower income earners:</p>`;
    if (taxedAmount > 0 || taxedZollars > 0 || taxedItems > 0) {
        detailsHTML += `<ul style="list-style: none; padding: 0; margin: 10px 0;">`;
        if (taxedAmount > 0) detailsHTML += `<li>\u{1F4B8} Capital: <span style="color: #ff4444;">${taxedAmount.toFixed(2)}</span></li>`;
        if (taxedZollars > 0) detailsHTML += `<li>\u{1B5} Zollars: <span style="color: #ff4444;">${taxedZollars.toFixed(2)}</span></li>`;
        if (taxedItems > 0) detailsHTML += `<li>\u{1F4E6} Items: <span style="color: #ff4444;">${taxedItems}</span></li>`;
        detailsHTML += `</ul>`;
    }
    const notificationPopup = document.createElement('div');
    notificationPopup.className = 'subsidy-popup';
    notificationPopup.innerHTML = detailsHTML;
    const closeButton = document.createElement('button');
    closeButton.textContent = 'Close';
    closeButton.className = 'close-button-subsidy';
    closeButton.style.marginTop = '10px';
    closeButton.addEventListener('click', ()=>{
        document.body.removeChild(notificationPopup);
    });
    notificationPopup.appendChild(closeButton);
    document.body.appendChild(notificationPopup);
}
function $788ff41eb2df4559$export$6598253ef2e7f85f(data) {
    let { message: message, initiatorName: initiatorName, targetName: targetName, receivedAmount: receivedAmount, receivedZollars: receivedZollars } = data;
    // Build detailed notification message
    let detailsHTML = '<div style="background: linear-gradient(135deg, rgba(61, 210, 2, 0.15), rgba(61, 210, 2, 0.05)); padding: 15px; border-radius: 8px; margin-bottom: 15px;">';
    detailsHTML += '<p style="font-weight: bold; color: #3dd202; margin-bottom: 10px; font-size: 1.1em;">\uD83C\uDF81 Socialist Subsidy Received!</p>';
    if (initiatorName && targetName) detailsHTML += `<p style="margin-bottom: 15px; color: #ddd;"><strong style="color: #3dd202;">${initiatorName}</strong> redistributed wealth from <strong style="color: #fcba03;">${targetName}</strong></p>`;
    else if (initiatorName) detailsHTML += `<p style="margin-bottom: 15px; color: #ddd;"><strong style="color: #3dd202;">${initiatorName}</strong> triggered a wealth redistribution</p>`;
    else detailsHTML += `<p style="margin-bottom: 15px; color: #ddd;">You received a socialist subsidy</p>`;
    detailsHTML += '</div>';
    if (receivedAmount > 0 || receivedZollars > 0) {
        detailsHTML += `<div style="background: rgba(0,0,0,0.3); padding: 15px; border-radius: 8px; margin-bottom: 10px;">`;
        detailsHTML += `<div style="font-weight: bold; margin-bottom: 10px; color: #fff;">\u{1F4C8} You Received:</div>`;
        detailsHTML += `<ul style="list-style: none; padding: 0; margin: 0;">`;
        if (receivedAmount > 0) detailsHTML += `<li style="padding: 8px; margin: 5px 0; background: rgba(61, 210, 2, 0.1); border-left: 3px solid #3dd202; border-radius: 4px;">\u{1F4B0} Capital: <span style="color: #3dd202; font-weight: bold; font-size: 1.1em;">+${receivedAmount.toFixed(2)}</span></li>`;
        if (receivedZollars > 0) detailsHTML += `<li style="padding: 8px; margin: 5px 0; background: rgba(61, 210, 2, 0.1); border-left: 3px solid #3dd202; border-radius: 4px;">\u{1B5} Zollars: <span style="color: #3dd202; font-weight: bold; font-size: 1.1em;">+${receivedZollars.toFixed(2)}</span></li>`;
        detailsHTML += `</ul></div>`;
    } else detailsHTML += `<p style="padding: 10px; background: rgba(61, 210, 2, 0.1); border-radius: 5px; color: #ddd;">You have received assistance from the wealth redistribution program.</p>`;
    detailsHTML += `<div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #444; font-size: 0.85em; color: #888; font-style: italic;">
	\u{1F4A1} This wealth came from economic redistribution. Someone helped balance the economy!
  </div>`;
    const notificationPopup = document.createElement('div');
    notificationPopup.className = 'subsidy-popup';
    notificationPopup.innerHTML = detailsHTML;
    const closeButton = document.createElement('button');
    closeButton.textContent = 'Close';
    closeButton.className = 'close-button-subsidy';
    closeButton.style.marginTop = '10px';
    closeButton.addEventListener('click', ()=>{
        document.body.removeChild(notificationPopup);
    });
    notificationPopup.appendChild(closeButton);
    document.body.appendChild(notificationPopup);
}
function $788ff41eb2df4559$var$showUserSelectionPopupRS(users) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.ransomSelectTargetTitle', 'Select a portfolio to ransom:');
        const select = document.createElement('select');
        select.id = 'userSelectSubsidy';
        users.forEach((user)=>{
            const option = document.createElement('option');
            option.value = user._id;
            const name = user.name || user.username || user.displayName || (0, $fUPn2.t)('triggers.unknownUser', 'Unknown user');
            const wealth = Number(user.totalWealth ?? 0).toFixed(2);
            option.textContent = `${name} - ${(0, $fUPn2.t)('triggers.statsTotalWealth', 'Total Wealth:')} ${wealth}`;
            select.appendChild(option);
        });
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn';
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn';
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, select, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            const selectedUserId = select.value;
            popup.remove();
            resolve(selectedUserId);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(null);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$6a4c2457de50e17b() {
    const stealButton = document.getElementById('stealButton');
    if (stealButton) stealButton.addEventListener('click', $788ff41eb2df4559$export$566bbb08b3c4ec3f);
}
// ===== Steal =====
let $788ff41eb2df4559$var$isProcessingSteal = false;
async function $788ff41eb2df4559$export$566bbb08b3c4ec3f() {
    if ($788ff41eb2df4559$var$isProcessingSteal) return;
    $788ff41eb2df4559$var$isProcessingSteal = true;
    // Immediate visual feedback
    const button = document.getElementById('stealButton');
    const originalText = button ? button.textContent : null;
    if (button) {
        button.textContent = 'Processing...';
        button.disabled = true;
        button.style.opacity = '0.2';
    }
    try {
        const portfolioId = window.traderPortfolioId;
        console.log('Using steal button for portfolio:', portfolioId);
        if (!portfolioId) throw new Error((0, $fUPn2.t)('triggers.initiatorUndefined', 'Portfolio is undefined'));
        const useButtonResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/useStealButton`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId
            })
        });
        console.log('Use button response status:', useButtonResponse.status);
        if (!useButtonResponse.ok) {
            const errorText = await useButtonResponse.text();
            console.error('Error response body:', errorText);
            throw new Error(`${(0, $fUPn2.t)('triggers.stealFailedUse', 'Failed to use steal button')}: ${useButtonResponse.status} - ${errorText}`);
        }
        const useButtonResult = await useButtonResponse.json();
        console.log(useButtonResult.message);
        // Fetch available items
        const itemsResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/availableItems`, {
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            }
        });
        console.log('Items response status:', itemsResponse.status);
        if (!itemsResponse.ok) {
            const errorText = await itemsResponse.text();
            console.error('Error response body:', errorText);
            throw new Error(`${(0, $fUPn2.t)('triggers.stealFailedFetchItems', 'Failed to fetch available commodities')}: ${itemsResponse.status} - ${errorText}`);
        }
        const items = await itemsResponse.json();
        console.log('Available items:', items);
        $788ff41eb2df4559$export$41a2f775b0e16711(items);
    } catch (error) {
        console.error('Error using steal button:', error);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.stealFailedUseOrFetch', 'Failed to use steal button or fetch commmodities')}: ${error.message}`, false);
    } finally{
        if (button) {
            button.textContent = originalText;
            button.disabled = false;
            button.style.opacity = '1';
        }
        $788ff41eb2df4559$var$isProcessingSteal = false;
    }
}
function $788ff41eb2df4559$export$41a2f775b0e16711(items) {
    console.log('Displaying available items:', items);
    const existingModal = document.querySelector('.modal-steal');
    if (existingModal) existingModal.remove();
    const modal = document.createElement('div');
    modal.classList.add('modal-steal');
    const modalContent = document.createElement('div');
    modalContent.classList.add('modal-steal-content');
    const closeBtn = document.createElement('span');
    closeBtn.classList.add('modal-steal-close');
    closeBtn.textContent = 'X';
    closeBtn.onclick = ()=>document.body.removeChild(modal);
    const itemList = document.createElement('ul');
    itemList.classList.add('modal-steal-item-list'); // Apply the scrollable list class
    items.forEach((item)=>{
        const listItem = document.createElement('li');
        listItem.textContent = `${item.item_name} - ${item.description}`;
        listItem.style = `
		  cursor: pointer; padding: 5px; border-bottom: 1px solid #00ff00;
		`;
        listItem.onclick = ()=>{
            $788ff41eb2df4559$export$e8f5fefdc63a3196(item._id);
            document.body.removeChild(modal);
        };
        itemList.appendChild(listItem);
    });
    modalContent.appendChild(closeBtn);
    modalContent.appendChild(itemList);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);
    console.log('Steal modal created and added to the DOM');
}
async function $788ff41eb2df4559$export$e8f5fefdc63a3196(itemId) {
    try {
        const portfolioId = window.traderPortfolioId;
        console.log('Attempting to steal item:', itemId, 'for portfolio:', portfolioId);
        if (!portfolioId) throw new Error((0, $fUPn2.t)('triggers.initiatorUndefined', 'Portfolio ID is undefined'));
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/stealItem`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            body: JSON.stringify({
                stealerPortfolioId: portfolioId,
                itemId: itemId
            })
        });
        console.log('Steal item response status:', response.status);
        // Read body once; we may need it for both success & error
        let payload = null;
        let rawText = '';
        try {
            rawText = await response.text();
            payload = rawText ? JSON.parse(rawText) : null;
        } catch  {
            payload = null; // keep going; we’ll fall back to client-side keys
        }
        if (!response.ok) {
            console.error('Error response:', payload || rawText);
            // Prefer backend code if present, else map HTTP status to a client key
            const statusToKey = {
                403: 'triggers.steal_noTrigger',
                404: 'triggers.steal_itemUnavailable',
                500: 'triggers.steal_serverError'
            };
            const key = payload && payload.messageId || statusToKey[response.status] || 'trigger.steal_serverError';
            const msg = (0, $fUPn2.t)(key, payload && payload.message || (0, $fUPn2.t)('socketFront.stealFailed', 'Failed to steal asset'), payload && payload.params || {});
            throw new Error(msg);
        }
        // Success: always use the client translation key (don’t trust server strings)
        console.log('Steal item result:', payload);
        const successMsg = (0, $fUPn2.t)('triggers.steal_success', 'Item stolen successfully.');
        (0, $eD3DY.showNotification)(successMsg, true, ()=>location.reload());
    } catch (error) {
        console.error('Error stealing item:', error);
        // Final client-side fallback, still localized
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.stealFailedToSteal', 'Failed to steal asset')}: ${error?.message || ''}`, false);
    }
}
// ===== Ransom =====
let $788ff41eb2df4559$var$isProcessingRansom = false;
async function $788ff41eb2df4559$export$1ac0c914c8d316() {
    if ($788ff41eb2df4559$var$isProcessingRansom) return;
    $788ff41eb2df4559$var$isProcessingRansom = true;
    // Immediate visual feedback
    const button = document.getElementById('ransomButton');
    const originalText = button ? button.textContent : null;
    if (button) {
        button.textContent = 'Processing...';
        button.disabled = true;
        button.style.opacity = '0.2';
    }
    try {
        const portfolioId = window.traderPortfolioId;
        const sessionId = localStorage.getItem('sessionId');
        console.log('Initiating ransom action from portfolio:', portfolioId);
        if (!portfolioId) throw new Error((0, $fUPn2.t)('triggers.initiatorUndefined', 'Initiator Portfolio is undefined'));
        if (!sessionId) throw new Error((0, $fUPn2.t)('triggers.sessionUndefined', 'Session is undefined'));
        // Cached active portfolios
        const activePortfolios = await $788ff41eb2df4559$var$getCachedPortfolios(sessionId, '/api/portfolios/active');
        const eligiblePortfolios = activePortfolios.filter((p)=>p._id !== portfolioId && !p.isSuperUser);
        if (eligiblePortfolios.length === 0) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.ransomNoEligible', 'No eligible portfolios to ransom. Action cancelled.'), false);
            return;
        }
        // May return string or { selectedUserId } depending on previous helper versions
        const sel = await $788ff41eb2df4559$var$showUserSelectionPopupRS(eligiblePortfolios);
        const portfolioToRansomId = typeof sel === 'string' ? sel : sel?.selectedUserId;
        if (!portfolioToRansomId) return;
        // Find the selected portfolio to get their wealth
        const targetPortfolio = eligiblePortfolios.find((p)=>p._id === portfolioToRansomId);
        const targetWealth = targetPortfolio?.totalWealth || 0;
        const targetName = targetPortfolio?.name || 'Unknown';
        const ransomAmount = await $788ff41eb2df4559$var$showRansomAmountPopup(targetWealth, targetName);
        if (!ransomAmount) return;
        const confirmRansom = await $788ff41eb2df4559$var$showConfirmRansomPopup(ransomAmount);
        if (!confirmRansom) return;
        const ransomResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/setRansom`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                targetPortfolioId: portfolioToRansomId,
                ransomPoints: ransomAmount
            })
        });
        if (!ransomResponse.ok) {
            const errorData = await ransomResponse.json().catch(()=>({}));
            throw new Error(errorData.message || (0, $fUPn2.t)('triggers.ransomSetFailed', 'Failed to set ransom'));
        }
        const result = await ransomResponse.json();
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.ransomSetSuccess', 'Ransom set successfully.'), true);
    } catch (error) {
        console.error('Error using ransom button:', error);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.ransomSetErrorPrefix', 'Error: Could not set ransom.')} ${error.message}`, false);
    } finally{
        if (button) {
            button.textContent = originalText;
            button.disabled = false;
            button.style.opacity = '1';
        }
        $788ff41eb2df4559$var$isProcessingRansom = false;
    }
}
function $788ff41eb2df4559$var$showRansomAmountPopup(targetWealth = 0, targetName = 'Unknown') {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.ransomSetAmountTitle', 'Set Ransom Amount');
        // Display target info
        const targetInfo = document.createElement('p');
        targetInfo.style.cssText = 'margin: 10px 0; color: #0f0; font-size: 1.1em;';
        targetInfo.textContent = `${targetName} - Total Wealth: ${Math.floor(targetWealth)} capital`;
        // Percentage buttons container
        const percentButtonsContainer = document.createElement('div');
        percentButtonsContainer.style.cssText = 'display: flex; gap: 10px; margin: 15px 0; flex-wrap: wrap; justify-content: center;';
        const percentages = [
            5,
            10,
            25,
            50,
            75,
            100
        ];
        let selectedAmount = Math.max(1, Math.floor(targetWealth * 0.1)); // Default to 10%, minimum 1
        percentages.forEach((percent)=>{
            const btn = document.createElement('button');
            btn.className = 'cyber-confirm-btn';
            btn.textContent = `${percent}%`;
            btn.style.cssText = 'padding: 8px 16px; font-size: 0.9em; min-width: 60px; opacity: 0.6;';
            btn.type = 'button'; // Prevent form submission
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                selectedAmount = Math.max(1, Math.floor(targetWealth * (percent / 100)));
                amountDisplay.textContent = `${selectedAmount} capital`;
                slider.value = percent;
                // Visual feedback - highlight selected button
                percentButtonsContainer.querySelectorAll('button').forEach((b)=>{
                    b.style.opacity = '0.6';
                    b.style.transform = 'scale(1)';
                });
                btn.style.opacity = '1';
                btn.style.transform = 'scale(1.05)';
            });
            percentButtonsContainer.appendChild(btn);
        });
        // Slider container
        const sliderContainer = document.createElement('div');
        sliderContainer.style.cssText = 'margin: 20px 0;';
        const sliderLabel = document.createElement('label');
        sliderLabel.textContent = (0, $fUPn2.t)('triggers.ransomSliderLabel', 'Fine-tune percentage:');
        sliderLabel.style.cssText = 'display: block; margin-bottom: 8px; color: #0ff;';
        const slider = document.createElement('input');
        slider.type = 'range';
        slider.min = '1';
        slider.max = '100';
        slider.value = '10';
        slider.step = '1';
        slider.style.cssText = 'width: 100%; cursor: pointer;';
        const sliderValueDisplay = document.createElement('span');
        sliderValueDisplay.textContent = '10%';
        sliderValueDisplay.style.cssText = 'margin-left: 10px; color: #ff0; font-weight: bold;';
        slider.addEventListener('input', (e)=>{
            const percent = parseInt(e.target.value, 10);
            selectedAmount = Math.max(1, Math.floor(targetWealth * (percent / 100)));
            sliderValueDisplay.textContent = `${percent}%`;
            amountDisplay.textContent = `${selectedAmount} capital`;
            // Reset button highlights
            percentButtonsContainer.querySelectorAll('button').forEach((b)=>{
                b.style.opacity = '0.6';
                b.style.transform = 'scale(1)';
            });
        });
        sliderContainer.append(sliderLabel, slider, sliderValueDisplay);
        // Amount display
        const amountDisplay = document.createElement('div');
        amountDisplay.style.cssText = 'margin: 20px 0; padding: 15px; background: rgba(0, 255, 0, 0.1); border: 2px solid #0f0; border-radius: 8px; text-align: center; font-size: 1.3em; color: #0f0; font-weight: bold;';
        amountDisplay.textContent = `${selectedAmount} capital`;
        // Confirm/Cancel buttons
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn';
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn';
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, targetInfo, percentButtonsContainer, sliderContainer, amountDisplay, buttonContainer);
        document.body.appendChild(popup);
        // Set initial button highlight (10%)
        const tenPercentBtn = percentButtonsContainer.children[1]; // 10% is second button (index 1)
        if (tenPercentBtn) {
            tenPercentBtn.style.opacity = '1';
            tenPercentBtn.style.transform = 'scale(1.05)';
        }
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(selectedAmount > 0 ? selectedAmount : null);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(null);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$var$showConfirmRansomPopup(amount) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.ransomConfirmSetTitle', 'Confirm Ransom');
        const body = document.createElement('p');
        body.textContent = (0, $fUPn2.t)('triggers.ransomConfirmSetBody', 'Are you sure you want to set a ransom of {amount} capital?').replace('{amount}', String(amount));
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn';
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn';
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, body, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(true);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(false);
        }, {
            once: true
        });
    });
}
async function $788ff41eb2df4559$export$43381ed8b1163ece(portfolioId, ransomPoints) {
    try {
        const confirmPay = await $788ff41eb2df4559$var$showConfirmPayRansomPopup(ransomPoints);
        if (!confirmPay) return;
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/payRansom`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}` // Add the token to the Authorization header
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                ransomPoints: ransomPoints
            })
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to pay ransom');
        }
        const result = await response.json();
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.ransomPaySuccess', 'Ransom paid successfully. Your portfolio is now unlocked.'), true);
        location.reload();
    } catch (error) {
        console.error('Error paying ransom:', error);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.ransomPayErrorPrefix', 'Error: Could not pay ransom.')} ${error.message}`, false);
    }
}
function $788ff41eb2df4559$var$showConfirmPayRansomPopup(amount) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.ransomPayTitle', 'Confirm Pay Ransom');
        const body = document.createElement('p');
        body.textContent = (0, $fUPn2.t)('triggers.ransomPayBody', 'Are you sure you want to pay {amount} capital to unlock your portfolio?').replace('{amount}', amount);
        const buttonContainer = document.createElement('div');
        Object.assign(buttonContainer.style, {
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '20px'
        });
        const confirmButton = document.createElement('button');
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, body, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(true);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(false);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$ad2c4ba1304fb03a() {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'confirmGiveAwayPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.giveawayTitle', 'Confirm Give Away');
        const body = document.createElement('p');
        body.textContent = (0, $fUPn2.t)('triggers.giveawayBody', 'Are you sure you want to give away this commodity?');
        const buttonContainer = document.createElement('div');
        Object.assign(buttonContainer.style, {
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '20px'
        });
        const confirmButton = document.createElement('button');
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, body, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(true);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(false);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$30c1977a1acc5902(users) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.communitySelectUsersTitle', 'Select users for the community:');
        const listContainer = document.createElement('div');
        listContainer.id = 'userList';
        Object.assign(listContainer.style, {
            maxHeight: '200px',
            overflowY: 'auto'
        });
        (users || []).forEach((u)=>{
            const label = document.createElement('label');
            Object.assign(label.style, {
                display: 'block',
                marginBottom: '5px'
            });
            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.value = u._id;
            Object.assign(checkbox.style, {
                marginRight: '5px'
            });
            const name = u?.name || u?.username || u?.displayName || (0, $fUPn2.t)('triggers.unknownUser', 'Unknown user');
            label.append(checkbox, name);
            listContainer.appendChild(label);
        });
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn'; // Add this line
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn'; // Add this line
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, listContainer, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            const selectedUserIds = Array.from(listContainer.querySelectorAll('input:checked')).map((input)=>input.value);
            popup.remove();
            resolve(selectedUserIds);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(null);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$35f287f5175d77ea(mainVideoUrl, introVideoUrl) {
    console.log('Attempting to play pub video');
    console.log('Intro URL:', introVideoUrl);
    console.log('Main URL:', mainVideoUrl);
    const videoOverlay = document.createElement('div');
    videoOverlay.setAttribute("style", `
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: black;
		z-index: 10000;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	  `);
    const videoContainer = document.createElement('div');
    videoContainer.setAttribute("style", `
		width: 100%;
		height: calc(100% - 60px); /* Adjust height to leave space for buttons */
		position: relative;
	  `);
    const videoElement = document.createElement('video');
    videoElement.setAttribute("style", `
		width: 100%;
		height: 100%;
		object-fit: contain;
	  `);
    videoElement.controls = true;
    videoElement.autoplay = true;
    videoElement.muted = true;
    videoElement.playsInline = true; // Prevent automatic fullscreen on mobile
    videoContainer.appendChild(videoElement);
    videoOverlay.appendChild(videoContainer);
    document.body.appendChild(videoOverlay);
    const buttonContainer = document.createElement('div');
    buttonContainer.setAttribute("style", `
		position: absolute;
		bottom: 10px;
		left: 0;
		width: 100%;
		display: flex;
		justify-content: space-around;
		z-index: 10001;
	  `);
    const buttonStyle = `
		padding: 10px 20px;
		cursor: pointer;
		font-size: 1rem;
		font-weight: 700;
		text-align: center;
		border: 0.15em solid white;
		border-radius: 0.45em;
		background: rgba(0, 0, 0, 0.5);
		color: white;
	  `;
    const unmuteButton = document.createElement('button');
    unmuteButton.textContent = 'Unmute';
    unmuteButton.setAttribute("style", buttonStyle);
    const repeatButton = document.createElement('button');
    repeatButton.textContent = 'Replay';
    repeatButton.setAttribute("style", buttonStyle);
    unmuteButton.onclick = function(event) {
        event.stopPropagation();
        videoElement.muted = false;
        unmuteButton.style.display = 'none';
    };
    repeatButton.onclick = function(event) {
        event.stopPropagation();
        playVideo(mainVideoUrl);
    };
    buttonContainer.appendChild(unmuteButton);
    buttonContainer.appendChild(repeatButton);
    videoOverlay.appendChild(buttonContainer);
    function closeOverlay() {
        if (videoElement.ended) document.body.removeChild(videoOverlay);
    }
    function playVideo(introUrl, mainUrl) {
        if (Hls.isSupported()) {
            console.log('HLS is supported');
            const hls = new Hls();
            let currentlyPlaying = 'intro';
            hls.loadSource(introUrl);
            hls.attachMedia(videoElement);
            hls.on(Hls.Events.MANIFEST_PARSED, function() {
                console.log('HLS manifest parsed, attempting to play intro');
                videoElement.play().then(()=>console.log('Intro video playback started successfully')).catch((error)=>{
                    console.error('Error playing intro video:', error);
                });
            });
            videoElement.addEventListener('ended', function() {
                if (currentlyPlaying === 'intro') {
                    console.log('Intro ended, playing main video');
                    hls.loadSource(mainUrl);
                    currentlyPlaying = 'main';
                } else closeOverlay();
            });
            hls.on(Hls.Events.ERROR, function(event, data) {
                console.error('HLS error:', event, data);
            });
        } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
            console.log('Native HLS playback supported');
            videoElement.src = introUrl;
            videoElement.addEventListener('loadedmetadata', function() {
                console.log('Intro video metadata loaded, attempting to play');
                videoElement.play().then(()=>console.log('Intro video playback started successfully')).catch((error)=>{
                    console.error('Error playing intro video:', error);
                });
            });
            videoElement.addEventListener('ended', function() {
                if (videoElement.src === introUrl) {
                    console.log('Intro ended, playing main video');
                    videoElement.src = mainUrl;
                    videoElement.play();
                } else closeOverlay();
            });
        } else {
            console.error('HLS is not supported in this browser');
            const fallbackMessage = document.createElement('div');
            fallbackMessage.textContent = 'Video playback is not supported in this browser';
            fallbackMessage.style.color = '#ffffff';
            videoOverlay.appendChild(fallbackMessage);
        }
    }
    videoElement.addEventListener('error', function(e) {
        console.error('Error with pub video playback:', e);
    });
    playVideo(introVideoUrl, mainVideoUrl);
}
function $788ff41eb2df4559$export$887e8fd7f92867b(mainVideoUrl, introVideoUrl) {
    console.log('Attempting to play Znews video');
    console.log('Intro URL:', introVideoUrl);
    console.log('Main URL:', mainVideoUrl);
    const videoOverlay = document.createElement('div');
    videoOverlay.setAttribute("style", `
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: black;
		z-index: 10000;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	  `);
    const videoContainer = document.createElement('div');
    videoContainer.setAttribute("style", `
		width: 100%;
		height: calc(100% - 60px); /* Adjust height to leave space for buttons */
		position: relative;
	  `);
    const videoElement = document.createElement('video');
    videoElement.setAttribute("style", `
		width: 100%;
		height: 100%;
		object-fit: contain;
	  `);
    videoElement.controls = true;
    videoElement.autoplay = true;
    videoElement.muted = true;
    videoElement.playsInline = true; // Prevent automatic fullscreen on mobile
    videoContainer.appendChild(videoElement);
    videoOverlay.appendChild(videoContainer);
    document.body.appendChild(videoOverlay);
    const buttonContainer = document.createElement('div');
    buttonContainer.setAttribute("style", `
		position: absolute;
		bottom: 10px;
		left: 0;
		width: 100%;
		display: flex;
		justify-content: space-around;
		z-index: 10001;
	  `);
    const buttonStyle = `
		padding: 10px 20px;
		cursor: pointer;
		font-size: 1rem;
		font-weight: 700;
		text-align: center;
		border: 0.15em solid white;
		border-radius: 0.45em;
		background: rgba(0, 0, 0, 0.5);
		color: white;
	  `;
    const unmuteButton = document.createElement('button');
    unmuteButton.textContent = 'Unmute';
    unmuteButton.setAttribute("style", buttonStyle);
    const repeatButton = document.createElement('button');
    repeatButton.textContent = 'Replay';
    repeatButton.setAttribute("style", buttonStyle);
    unmuteButton.onclick = function(event) {
        event.stopPropagation();
        videoElement.muted = false;
        unmuteButton.style.display = 'none';
    };
    repeatButton.onclick = function(event) {
        event.stopPropagation();
        playVideo(mainVideoUrl);
    };
    buttonContainer.appendChild(unmuteButton);
    buttonContainer.appendChild(repeatButton);
    videoOverlay.appendChild(buttonContainer);
    function closeOverlay() {
        if (videoElement.ended) document.body.removeChild(videoOverlay);
    }
    function playVideo(introUrl, mainUrl) {
        if (Hls.isSupported()) {
            console.log('HLS is supported');
            const hls = new Hls();
            let currentlyPlaying = 'intro';
            hls.loadSource(introUrl);
            hls.attachMedia(videoElement);
            hls.on(Hls.Events.MANIFEST_PARSED, function() {
                console.log('HLS manifest parsed, attempting to play intro');
                videoElement.play().then(()=>console.log('Intro video playback started successfully')).catch((error)=>{
                    console.error('Error playing intro video:', error);
                });
            });
            videoElement.addEventListener('ended', function() {
                if (currentlyPlaying === 'intro') {
                    console.log('Intro ended, playing main video');
                    hls.loadSource(mainUrl);
                    currentlyPlaying = 'main';
                } else closeOverlay();
            });
            hls.on(Hls.Events.ERROR, function(event, data) {
                console.error('HLS error:', event, data);
            });
        } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
            console.log('Native HLS playback supported');
            videoElement.src = introUrl;
            videoElement.addEventListener('loadedmetadata', function() {
                console.log('Intro video metadata loaded, attempting to play');
                videoElement.play().then(()=>console.log('Intro video playback started successfully')).catch((error)=>{
                    console.error('Error playing intro video:', error);
                });
            });
            videoElement.addEventListener('ended', function() {
                if (videoElement.src === introUrl) {
                    console.log('Intro ended, playing main video');
                    videoElement.src = mainUrl;
                    videoElement.play();
                } else closeOverlay();
            });
        } else {
            console.error('HLS is not supported in this browser');
            const fallbackMessage = document.createElement('div');
            fallbackMessage.textContent = 'Video playback is not supported in this browser';
            fallbackMessage.style.color = '#ffffff';
            videoOverlay.appendChild(fallbackMessage);
        }
    }
    videoElement.addEventListener('error', function(e) {
        console.error('Error with Znews video playback:', e);
    });
    playVideo(introVideoUrl, mainVideoUrl);
}
// ===== ITEM STOLEN NOTIFICATION =====
function $788ff41eb2df4559$export$31f3cf3256e53c73(data) {
    const { message: message, botName: botName, stolenItemName: stolenItemName } = data;
    const notificationPopup = document.createElement('div');
    notificationPopup.className = 'subsidy-popup';
    const messageDiv = document.createElement('div');
    messageDiv.style.cssText = 'color: #ff4d4d; font-weight: bold; margin-bottom: 10px; text-shadow: 0 0 5px #ff4d4d;';
    messageDiv.textContent = message;
    notificationPopup.appendChild(messageDiv);
    const closeButton = document.createElement('button');
    closeButton.textContent = (0, $fUPn2.t)('triggers.close', 'Close');
    closeButton.className = 'close-button-subsidy';
    closeButton.style.marginTop = '10px';
    closeButton.addEventListener('click', ()=>{
        if (notificationPopup.parentNode) document.body.removeChild(notificationPopup);
    });
    notificationPopup.appendChild(closeButton);
    document.body.appendChild(notificationPopup);
}
// ===== SPECIAL ACTION NOTIFICATION (Generic) =====
function $788ff41eb2df4559$export$3f11d1f2c5a135aa(data) {
    const { type: type, message: message, details: details } = data;
    // For Subsidy_Success, always show detailed popup with recipient information
    if (type === 'Subsidy_Success' && details) {
        const notificationPopup = document.createElement('div');
        notificationPopup.className = 'subsidy-popup';
        notificationPopup.style.maxHeight = '70vh';
        notificationPopup.style.overflowY = 'auto';
        let content = `<div style="font-weight: bold; color: #3dd202; margin-bottom: 15px; font-size: 1.1em;">\u{2705} ${message}</div>`;
        // Show social score boost prominently
        if (details.lifeProfitBoost) content += `<div style="background: rgba(61, 210, 2, 0.2); padding: 12px; border-radius: 8px; margin-bottom: 15px; border: 2px solid #3dd202;">
        <div style="font-weight: bold; color: #3dd202; margin-bottom: 8px;">Social Score Boost: +${details.lifeProfitBoost}</div>
        <div style="color: #aaa; font-size: 0.9em;">New Life Profit: ${details.newLifeProfit || 'N/A'}</div>
        <div style="color: #bbb; font-size: 0.85em; margin-top: 5px; font-style: italic;">You helped ${details.recipientCount || 0} people - your positive social impact has been recorded!</div>
      </div>`;
        // Show what was redistributed per person
        if (details.amountPerRecipient !== undefined || details.zollarsPerRecipient !== undefined) {
            content += `<div style="margin-bottom: 15px;">
        <div style="font-weight: bold; margin-bottom: 8px;"> Distributed per recipient:</div>
        <ul style="list-style: none; padding-left: 10px;">`;
            if (details.amountPerRecipient > 0) content += `<li style="margin: 5px 0;"> Capital: <span style="color: #3dd202; font-weight: bold;">+${details.amountPerRecipient.toFixed(2)}</span></li>`;
            if (details.zollarsPerRecipient > 0) content += `<li style="margin: 5px 0;">\u{1B5} Zollars: <span style="color: #3dd202; font-weight: bold;">+${details.zollarsPerRecipient.toFixed(2)}</span></li>`;
            content += `</ul></div>`;
        }
        // Show recipient list
        if (details.recipientList && details.recipientList.length > 0) {
            content += `<div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #444;">
        <div style="font-weight: bold; margin-bottom: 8px;"> Beneficiaries (${details.recipientList.length}):</div>
        <div style="max-height: 200px; overflow-y: auto; background: rgba(0,0,0,0.3); padding: 10px; border-radius: 5px;">
          <ul style="list-style: none; padding: 0; margin: 0;">`;
            details.recipientList.forEach((name)=>{
                content += `<li style="padding: 4px 0; color: #3dd202;">\u{2713} ${name}</li>`;
            });
            content += `</ul></div></div>`;
        }
        // Show target info
        if (details.targetName) content += `<div style="margin-top: 10px; font-size: 0.9em; color: #888;">
        <em>Wealth redistributed from: ${details.targetName}</em>
      </div>`;
        notificationPopup.innerHTML = content;
        const closeButton = document.createElement('button');
        closeButton.textContent = (0, $fUPn2.t)('triggers.close', 'Close');
        closeButton.className = 'close-button-subsidy';
        closeButton.style.marginTop = '15px';
        closeButton.addEventListener('click', ()=>{
            if (notificationPopup.parentNode) document.body.removeChild(notificationPopup);
        });
        notificationPopup.appendChild(closeButton);
        document.body.appendChild(notificationPopup);
        return;
    }
    // For other action types, use LED notification or simple popup
    if (typeof (0, $eD3DY.showNotification) === 'function') {
        // Determine if this is a negative or positive action
        const isNegative = type && (type.includes('Target') || type.includes('Steal') || type.includes('LBO') || type.includes('DeletePortfolio') || type.includes('Subsidy_Target'));
        // Show LED notification (less intrusive)
        (0, $eD3DY.showNotification)(message, !isNegative);
    } else {
        // Fallback to popup if showNotification is not available
        const notificationPopup = document.createElement('div');
        notificationPopup.className = 'subsidy-popup';
        let content = `<div style="font-weight: bold; margin-bottom: 10px;">${message}</div>`;
        if (details) {
            content += '<div style="margin-top: 10px; font-size: 0.9em; color: #00ff00;">';
            if (details.executorName) content += `<p style="margin: 5px 0;">Executor: ${details.executorName}</p>`;
            if (details.impact) content += `<p style="margin: 5px 0;">Impact: ${details.impact}</p>`;
            content += '</div>';
        }
        notificationPopup.innerHTML = content;
        const closeButton = document.createElement('button');
        closeButton.textContent = (0, $fUPn2.t)('triggers.close', 'Close');
        closeButton.className = 'close-button-subsidy';
        closeButton.style.marginTop = '10px';
        closeButton.addEventListener('click', ()=>{
            if (notificationPopup.parentNode) document.body.removeChild(notificationPopup);
        });
        notificationPopup.appendChild(closeButton);
        document.body.appendChild(notificationPopup);
    }
}

});

parcelRegister("kJdNP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4zQMZ").then(()=>parcelRequire('l9yWn'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});



parcelRegister("bzRv7", function(module, exports) {

$parcel$export(module.exports, "initializeSimulationTimer", () => $86dc76c45b2250dc$export$cc7efffc33e38fab);
$parcel$export(module.exports, "cleanupSimulationTimer", () => $86dc76c45b2250dc$export$e42ace8a14893918);
// simulationTimer.js - Standalone simulation timer module

var $5W4EI = parcelRequire("5W4EI");

var $eD3DY = parcelRequire("eD3DY");

var $cJVho = parcelRequire("cJVho");
parcelRequire("21EbS");
// ────── TIMER STATE MANAGEMENT ──────
let $86dc76c45b2250dc$var$simulationTimer = null;
let $86dc76c45b2250dc$var$simulationEndTime = null;
let $86dc76c45b2250dc$var$warningTimers = [];
function $86dc76c45b2250dc$var$showFreestyleLoadingPopup() {
    // Remove existing popup if any
    const existing = document.getElementById('freestyle-loading-popup');
    if (existing) existing.remove();
    // Create popup
    const popup = document.createElement('div');
    popup.id = 'freestyle-loading-popup';
    popup.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.95);
    color: #0f0;
    padding: 30px 50px;
    border: 2px solid #0f0;
    border-radius: 8px;
    z-index: 999999;
    font-family: monospace;
    font-size: 18px;
    text-align: center;
    box-shadow: 0 0 20px rgba(0, 255, 0, 0.5);
  `;
    popup.innerHTML = `
    <div>\u{23F3} Processing simulation results...</div>
    <div style="margin-top: 10px; font-size: 14px;">Please wait</div>
  `;
    document.body.appendChild(popup);
    console.log("\u2705 Freestyle loading popup displayed");
}
function $86dc76c45b2250dc$var$broadcastLogoutToAllClients(resultsData = {}) {
    const portfolioId = localStorage.getItem('portfolioId') || resultsData.portfolioId || '';
    const enriched = {
        ...resultsData,
        portfolioId: portfolioId
    };
    try {
        localStorage.setItem('SIM_LOGOUT', JSON.stringify(enriched));
        setTimeout(()=>localStorage.removeItem('SIM_LOGOUT'), 500);
    } catch  {}
    try {
        const bc = new BroadcastChannel('sim-control');
        bc.postMessage({
            type: 'logout',
            resultsData: enriched
        });
        bc.close();
    } catch  {}
}
function $86dc76c45b2250dc$export$cc7efffc33e38fab(endTime, timerId) {
    const isSimulated = localStorage.getItem('isSimulated') === 'true';
    const simulationType = localStorage.getItem('simulationType');
    if (!isSimulated && !simulationType) {
        console.log("\uD83D\uDEE1\uFE0F Normal user detected \u2014 skipping timer initialization.");
        return;
    }
    const isMementoMori = simulationType === 'memento-mori';
    const isStorySimulation = simulationType === 'story-simulation';
    // Story Simulation uses its own phase-based timer (storyPhaseManager.js)
    if (isStorySimulation) {
        console.log("\uD83D\uDCD6 Story Simulation detected - using phase-based timer instead");
        return; // Exit early - story simulation has its own timer system
    }
    // If no parameters provided, try to get from localStorage
    if (!endTime) {
        endTime = localStorage.getItem('simulationEndTime');
        timerId = localStorage.getItem('simulationTimerId');
        console.log("\uD83D\uDCE6 Retrieved from localStorage:", {
            endTime: endTime,
            timerId: timerId
        });
    }
    // If still no endTime, check if we should show a demo timer for testing
    if (!endTime) {
        console.log("\u26A0\uFE0F No simulation timer data found");
        if (isSimulated) {
            console.log("\uD83E\uDDEA Creating demo timer for testing (2 minutes)");
            endTime = new Date(Date.now() + 120000).toISOString(); // 2 minutes from now
            timerId = 'demo-timer-' + Date.now();
        }
    }
    $86dc76c45b2250dc$var$simulationEndTime = new Date(endTime);
    console.log("\u23F0 Simulation timer initialized:", {
        endTime: $86dc76c45b2250dc$var$simulationEndTime,
        timerId: timerId,
        timeRemaining: $86dc76c45b2250dc$var$getTimeRemaining(),
        currentTime: new Date(),
        isMementoMori: isMementoMori
    });
    $86dc76c45b2250dc$var$clearSimulationTimers();
    $86dc76c45b2250dc$var$createTimerDisplay(isMementoMori);
    $86dc76c45b2250dc$var$updateTimerDisplay(isMementoMori);
    $86dc76c45b2250dc$var$simulationTimer = setInterval(()=>$86dc76c45b2250dc$var$updateTimerDisplay(isMementoMori), 1000);
    $86dc76c45b2250dc$var$scheduleWarnings();
    // Schedule freestyle LLM analysis pre-fetch (20s before end)
    if (simulationType === 'freestyle') $86dc76c45b2250dc$var$scheduleFreestyleLLMPreFetch();
    localStorage.setItem('simulationEndTime', endTime);
    localStorage.setItem('simulationTimerId', timerId);
}
function $86dc76c45b2250dc$var$getTimeRemaining() {
    if (!$86dc76c45b2250dc$var$simulationEndTime) return 0;
    return Math.max(0, $86dc76c45b2250dc$var$simulationEndTime.getTime() - Date.now());
}
function $86dc76c45b2250dc$var$clearSimulationTimers() {
    if ($86dc76c45b2250dc$var$simulationTimer) {
        clearInterval($86dc76c45b2250dc$var$simulationTimer);
        $86dc76c45b2250dc$var$simulationTimer = null;
    }
    // Clear memento eulogy interval
    if (window.mementoEulogyInterval) {
        clearInterval(window.mementoEulogyInterval);
        window.mementoEulogyInterval = null;
    }
    $86dc76c45b2250dc$var$warningTimers.forEach((timerId)=>clearTimeout(timerId));
    $86dc76c45b2250dc$var$warningTimers = [];
    // Reset fetch guard
    $86dc76c45b2250dc$var$eulogyFetchInProgress = false;
}
function $86dc76c45b2250dc$var$createTimerDisplay(isMementoMori = false) {
    const existingTimer = document.getElementById('simulationTimer');
    if (existingTimer) existingTimer.remove();
    const timerDisplay = document.createElement('div');
    timerDisplay.id = 'simulationTimer';
    if (isMementoMori) {
        timerDisplay.className = 'simulation-timer-display memento-mori';
        timerDisplay.innerHTML = `
      <div>
        <div style="color:#ff4444; font-size:0.8rem; font-weight:bold;">
          Memento Mori Session Timer
        </div>
        <div id="simulationTimerText" style="font-size:.8rem; font-weight:bold; color:#00ff00;">
          --:--
        </div>
      </div>
    `;
    } else {
        timerDisplay.className = 'simulation-timer-display freestyle';
        timerDisplay.innerHTML = `
      <div id="simulationTimerText">
        Freestyle Session Timer: --:--
      </div>
    `;
    }
    document.body.appendChild(timerDisplay); // ✅ always append
}
function $86dc76c45b2250dc$var$updateTimerDisplay(isMementoMori = false) {
    const timerText = document.getElementById('simulationTimerText');
    if (!timerText) return;
    const remaining = $86dc76c45b2250dc$var$getTimeRemaining();
    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor(remaining % 60000 / 1000);
    if (remaining <= 0) {
        timerText.innerHTML = isMementoMori ? `<span style="color:#ff0000;">Memento Mori Ended</span>` : `<span style="color:#ff0000;">Freestyle Session Ended</span>`;
        $86dc76c45b2250dc$var$clearSimulationTimers();
        // ✅ CRITICAL: Re-read simulation type from localStorage at the moment of expiry
        // to ensure we have the most current value, but also use parameter as backup
        const currentSimulationType = localStorage.getItem('simulationType');
        const isMementoMoriFromStorage = currentSimulationType === 'memento-mori';
        const isStorySimulationFromStorage = currentSimulationType === 'story-simulation';
        // Use parameter as backup if localStorage is cleared (belt-and-suspenders approach)
        const finalIsMementoMori = isMementoMoriFromStorage || isMementoMori;
        const finalSimulationType = currentSimulationType || (isMementoMori ? 'memento-mori' : 'freestyle');
        console.log("\u23F0 [updateTimerDisplay] Timer expired, routing to correct ending:", {
            currentSimulationType: currentSimulationType,
            isMementoMoriFromStorage: isMementoMoriFromStorage,
            isMementoMoriParam: isMementoMori,
            finalIsMementoMori: finalIsMementoMori,
            finalSimulationType: finalSimulationType,
            isStorySimulationFromStorage: isStorySimulationFromStorage
        });
        $86dc76c45b2250dc$var$handleSimulationEnd(finalSimulationType, finalIsMementoMori, isStorySimulationFromStorage);
        return;
    }
    // 🎨 Freestyle timer colors
    if (!isMementoMori) {
        let timeColor = '#fcba03';
        if (remaining <= 60000) timeColor = '#ff6b6b'; // last minute
        else if (remaining <= 120000) timeColor = '#ff8c00'; // last 2 min
        else if (remaining <= 300000) timeColor = '#ffd700'; // last 5 min
        timerText.style.color = timeColor;
        timerText.textContent = `Freestyle Session Timer: ${minutes}:${seconds.toString().padStart(2, '0')}`;
    } else {
        // ⚰️ Memento Mori colors
        timerText.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        const timerElement = document.getElementById('simulationTimer');
        if (remaining <= 60000) {
            timerText.style.color = '#ff0000';
            timerElement.style.borderColor = '#ff0000';
            timerElement.style.boxShadow = '0 0 30px rgba(255,0,0,0.5)';
        } else if (remaining <= 180000) {
            timerText.style.color = '#ff6600';
            timerElement.style.borderColor = '#ff6600';
        } else {
            timerText.style.color = '#00ff00';
            timerElement.style.borderColor = '#ff6666';
        }
    }
}
function $86dc76c45b2250dc$export$e42ace8a14893918() {
    $86dc76c45b2250dc$var$clearSimulationTimers();
    const timerDisplay = document.getElementById('simulationTimer');
    if (timerDisplay) timerDisplay.remove();
    $86dc76c45b2250dc$var$simulationEndTime = null;
    localStorage.removeItem('simulationEndTime');
    localStorage.removeItem('simulationTimerId');
}
function $86dc76c45b2250dc$var$scheduleWarnings() {
    const timeRemaining = $86dc76c45b2250dc$var$getTimeRemaining();
    // ✅ Capture simulation type at scheduling time to preserve it
    const simulationType = localStorage.getItem('simulationType');
    const isMementoMori = simulationType === 'memento-mori';
    const isStorySimulation = simulationType === 'story-simulation';
    console.log("\uD83D\uDCC5 [scheduleWarnings] Scheduling warnings for simulation:", {
        simulationType: simulationType,
        isMementoMori: isMementoMori,
        isStorySimulation: isStorySimulation,
        timeRemaining: timeRemaining,
        timeRemainingMinutes: Math.floor(timeRemaining / 60000)
    });
    // Schedule warnings at 5 min, 2 min, 1 min, and 30 seconds
    const warningTimes = [
        300000,
        120000,
        60000,
        30000
    ]; // milliseconds
    warningTimes.forEach((warningTime)=>{
        if (timeRemaining > warningTime) {
            const delay = timeRemaining - warningTime;
            const timerId = setTimeout(()=>{
                $86dc76c45b2250dc$var$showTimerWarning(warningTime);
            }, delay);
            $86dc76c45b2250dc$var$warningTimers.push(timerId);
        }
    });
    // Schedule simulation end - PASS simulation type to preserve it
    if (timeRemaining > 0) {
        const endTimerId = setTimeout(()=>{
            // ✅ Re-read localStorage at the moment of execution, with captured values as backup
            const currentSimulationType = localStorage.getItem('simulationType');
            const currentIsMementoMori = currentSimulationType === 'memento-mori';
            const currentIsStorySimulation = currentSimulationType === 'story-simulation';
            // ✅ CRITICAL: Use OR logic (not ternary) to detect from EITHER source
            // If EITHER the captured value OR the current localStorage says it's memento-mori, it is
            const finalSimulationType = currentSimulationType || simulationType;
            const finalIsMementoMori = currentIsMementoMori || isMementoMori;
            const finalIsStorySimulation = currentIsStorySimulation || isStorySimulation;
            console.log("\u23F0 [scheduleWarnings timeout] Simulation end triggered:", {
                capturedType: simulationType,
                currentType: currentSimulationType,
                finalType: finalSimulationType,
                finalIsMementoMori: finalIsMementoMori,
                finalIsStorySimulation: finalIsStorySimulation
            });
            $86dc76c45b2250dc$var$handleSimulationEnd(finalSimulationType, finalIsMementoMori, finalIsStorySimulation);
        }, timeRemaining);
        $86dc76c45b2250dc$var$warningTimers.push(endTimerId);
    }
}
// ────── SCHEDULE FREESTYLE LLM PRE-FETCH (20s BEFORE END) ──────
function $86dc76c45b2250dc$var$scheduleFreestyleLLMPreFetch() {
    const timeRemaining = $86dc76c45b2250dc$var$getTimeRemaining();
    const preFetchTime = 20000; // 20 seconds before end
    if (timeRemaining > preFetchTime) {
        const delay = timeRemaining - preFetchTime;
        console.log(`\u{23F0} [scheduleFreestyleLLMPreFetch] Scheduling LLM pre-fetch in ${Math.floor(delay / 1000)}s (20s before end)`);
        const preFetchTimerId = setTimeout(async ()=>{
            console.log("\uD83E\uDD16 [Pre-fetch] Fetching LLM analysis 20s before timer ends...");
            try {
                const timerId = localStorage.getItem('simulationTimerId');
                const token = localStorage.getItem('token');
                if (!timerId || !token) {
                    console.warn("\u26A0\uFE0F [Pre-fetch] Missing timerId or token");
                    return;
                }
                // Fetch simulation results
                const resultsResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/sim/simulation/results/${timerId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (!resultsResponse.ok) {
                    console.warn("\u26A0\uFE0F [Pre-fetch] Failed to fetch simulation results:", resultsResponse.status);
                    return;
                }
                const resultsData = await resultsResponse.json();
                const summary = resultsData?.summary || resultsData;
                // Cache the full live summary too: at T=0 the server logout may have
                // already deleted the portfolio, making the final results fetch come
                // back all-zeros. This snapshot from 20s before end is the fallback.
                if (summary && summary.finalPortfolio) {
                    window.freestyleSummaryCache = summary;
                    console.log("\u2705 [Pre-fetch] Live summary cached as end-of-sim fallback");
                }
                // Fetch LLM analysis
                const llmAnalysis = await $86dc76c45b2250dc$var$fetchFreestyleLLMAnalysis(summary, token);
                if (llmAnalysis) {
                    // Cache it globally (like memento-mori does with window.currentEulogyText)
                    window.freestyleLLMAnalysis = llmAnalysis;
                    console.log("\u2705 [Pre-fetch] LLM analysis cached:", llmAnalysis.substring(0, 100) + '...');
                }
            } catch (error) {
                console.error("\u274C [Pre-fetch] Error fetching LLM analysis:", error);
            }
        }, delay);
        $86dc76c45b2250dc$var$warningTimers.push(preFetchTimerId);
    } else console.log(`\u{26A0}\u{FE0F} [scheduleFreestyleLLMPreFetch] Not enough time remaining (${Math.floor(timeRemaining / 1000)}s), skipping pre-fetch`);
}
function $86dc76c45b2250dc$var$showTimerWarning(timeLeft) {
    const minutes = Math.floor(timeLeft / 60000);
    const seconds = Math.floor(timeLeft % 60000 / 1000);
    let message;
    if (minutes > 0) message = `${minutes} minute${minutes > 1 ? 's' : ''} remaining in simulation`;
    else message = `${seconds} seconds remaining in simulation`;
    // Create warning popup
    const warning = document.createElement('div');
    warning.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(255, 107, 107, 0.95);
    color: white;
    padding: 20px 30px;
    border-radius: 10px;
    font-family: 'bithigh', monospace;
    font-size: 18px;
    font-weight: bold;
    z-index: 900;
    box-shadow: 0 0 20px rgba(255, 107, 107, 0.7);
    text-align: center;
    animation: pulse 0.5s ease-in-out;
  `;
    // Add CSS animation
    const style = document.createElement('style');
    style.textContent = `
    @keyframes pulse {
      0% { transform: translate(-50%, -50%) scale(0.8); opacity: 0; }
      50% { transform: translate(-50%, -50%) scale(1.1); opacity: 1; }
      100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
    }
  `;
    document.head.appendChild(style);
    warning.textContent = message;
    document.body.appendChild(warning);
    // Remove warning after 3 seconds
    setTimeout(()=>{
        warning.remove();
        style.remove();
    }, 3000);
}
// ────── LOADING POPUP FOR EULOGY ──────
function $86dc76c45b2250dc$var$showEulogyLoadingPopup() {
    const existing = document.getElementById('eulogy-loading-popup');
    if (existing) existing.remove();
    const popup = document.createElement('div');
    popup.id = 'eulogy-loading-popup';
    popup.innerHTML = `
    <div style="
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(0, 0, 0, 0.9);
      display: flex; flex-direction: column; justify-content: center; align-items: center;
      z-index: 10000; color: #fff; font-family: Georgia, serif;
    ">
      <div style="font-size: 28px; margin-bottom: 20px; color: #c9a227;">Your Time Has Come</div>
      <div style="font-size: 18px; margin-bottom: 30px; color: #ccc;">Composing your eulogy...</div>
      <div style="width: 200px; height: 4px; background: #333; border-radius: 2px; overflow: hidden;">
        <div id="eulogy-progress-bar" style="
          width: 0%; height: 100%;
          background: linear-gradient(90deg, #8b0000, #dc143c);
          transition: width 0.5s ease;
        "></div>
      </div>
      <div style="font-size: 14px; margin-top: 15px; color: #888;">Please wait...</div>
    </div>
  `;
    document.body.appendChild(popup);
    // Animate progress bar over 20 seconds
    setTimeout(()=>{
        const bar = document.getElementById('eulogy-progress-bar');
        if (bar) {
            bar.style.width = '100%';
            bar.style.transition = 'width 19s linear';
        }
    }, 100);
}
// ────── PRE-FETCH EULOGY 15 SECONDS BEFORE END ──────
let $86dc76c45b2250dc$var$eulogyFetchInProgress = false;
async function $86dc76c45b2250dc$var$preFetchFinalEulogy() {
    if ($86dc76c45b2250dc$var$eulogyFetchInProgress) {
        console.log("\u23F8\uFE0F [preFetch] Already fetching eulogy, skipping duplicate");
        return;
    }
    const objectiveId = localStorage.getItem('mementoMoriObjectiveId');
    const token = localStorage.getItem('token');
    if (!objectiveId) {
        console.warn("\u26A0\uFE0F [preFetch] No objective ID");
        return;
    }
    $86dc76c45b2250dc$var$eulogyFetchInProgress = true;
    // Show loading indicator
    $86dc76c45b2250dc$var$showEulogyLoadingPopup();
    try {
        console.log("\uD83D\uDD04 [preFetch] Fetching eulogy from API (no timeout - LLM has 15s)...");
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/current-eulogy`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...token && {
                    Authorization: `Bearer ${token}`
                }
            },
            body: JSON.stringify({
                objectiveId: objectiveId
            })
        });
        if (response.ok) {
            const data = await response.json();
            if (data.eulogyText) {
                window.currentEulogyText = data.eulogyText;
                console.log("\u2705 [preFetch] Eulogy cached:", data.eulogyText.substring(0, 80) + '...');
            }
        } else console.warn("\u26A0\uFE0F [preFetch] API returned", response.status);
    } catch (err) {
        console.warn("\u26A0\uFE0F [preFetch] Error:", err.message);
    } finally{
        $86dc76c45b2250dc$var$eulogyFetchInProgress = false;
    }
}
// ────── HANDLE MEMENTO MORI END ──────
async function $86dc76c45b2250dc$var$handleMementoMoriEnd() {
    console.log("\u26B0\uFE0F Memento Mori session ending...");
    // Clear eulogy interval immediately
    if (window.mementoEulogyInterval) {
        console.log("\uD83D\uDDD1\uFE0F Clearing memento eulogy interval");
        clearInterval(window.mementoEulogyInterval);
        window.mementoEulogyInterval = null;
    }
    window.mementoMoriInitialized = false;
    const FALLBACK_EULOGY = "Your journey through life's marketplace has concluded. In facing mortality, you have positioned yourself into your vision of Life Value.";
    // ✅ Show loading popup immediately so user knows we're working
    $86dc76c45b2250dc$var$showEulogyLoadingPopup();
    try {
        const objectiveId = localStorage.getItem('mementoMoriObjectiveId');
        const token = localStorage.getItem('token');
        if (!objectiveId) {
            console.error("\u274C No objective ID found - redirecting with fallback");
            $86dc76c45b2250dc$var$redirectToMementoMoriEndPage({
                eulogy: FALLBACK_EULOGY,
                portfolioInsights: []
            });
            return;
        }
        // ✅ PRIORITY 1: Use cached eulogy from periodic fetches (instant, no LLM wait)
        let currentEulogy = window.currentEulogyText;
        console.log("\uD83D\uDCCB Cached eulogy available:", !!currentEulogy, currentEulogy ? `(${currentEulogy.length} chars)` : '');
        // ✅ PRIORITY 2: Fetch from API - user sees loading popup so we can wait longer (20s)
        if (!currentEulogy) {
            console.log("\u23F3 No cached eulogy, fetching from API (20s timeout - user sees loading)...");
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(()=>controller.abort(), 20000); // 20s - user sees loading
                const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/current-eulogy`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...token && {
                            Authorization: `Bearer ${token}`
                        }
                    },
                    body: JSON.stringify({
                        objectiveId: objectiveId
                    }),
                    signal: controller.signal
                });
                clearTimeout(timeoutId);
                if (response.ok) {
                    const data = await response.json();
                    currentEulogy = data.eulogyText;
                    console.log("\u2705 API fetch succeeded:", currentEulogy?.substring(0, 80));
                }
            } catch (fetchError) {
                console.warn("\u26A0\uFE0F API fetch failed/timed out - using fallback:", fetchError.message);
            }
        }
        // ✅ PRIORITY 3: Use fallback if still nothing
        if (!currentEulogy) {
            console.warn("\u26A0\uFE0F No eulogy available, using fallback");
            currentEulogy = FALLBACK_EULOGY;
        }
        console.log("\uD83D\uDCDC Redirecting with eulogy:", currentEulogy.substring(0, 80) + '...');
        // Redirect with eulogy data
        $86dc76c45b2250dc$var$redirectToMementoMoriEndPage({
            eulogy: currentEulogy,
            portfolioInsights: []
        });
    } catch (error) {
        console.error("\u274C Error completing Memento Mori:", error);
        $86dc76c45b2250dc$var$redirectToMementoMoriEndPage({
            eulogy: FALLBACK_EULOGY,
            portfolioInsights: []
        });
    }
}
// ────── REDIRECT TO MEMENTO MORI END PAGE ──────
function $86dc76c45b2250dc$var$redirectToMementoMoriEndPage(eulogyData) {
    console.log("\uD83E\uDEA6 Redirecting to Memento Mori ending page...");
    try {
        localStorage.setItem('simulationEnding', 'true');
        localStorage.setItem('preventBotRecreation', 'true');
        localStorage.setItem('tempMementoMoriResults', JSON.stringify({
            ...eulogyData,
            timestamp: Date.now()
        }));
        console.log("\uD83D\uDCBE Stored eulogy data for ending page");
        // Redirect to memento mori ending page
        console.log("\uD83C\uDFAF Final redirect to mementomoriend.html");
        window.location.replace('/mementomoriend.html');
    } catch (error) {
        console.error("\u274C Error storing data:", error);
        // Try redirect anyway with flag set
        localStorage.setItem('simulationEnding', 'true');
        window.location.replace('/mementomoriend.html');
    }
}
async function $86dc76c45b2250dc$var$handleSimulationEnd(simulationTypeParam = null, isMementoMoriParam = null, isStorySimulationParam = null) {
    console.log("\uD83C\uDFC1 [handleSimulationEnd] Simulation timer ended - determining route...");
    // ✅ CRITICAL ROUTING LOGIC: Check both parameters AND localStorage
    // Parameters are captured when timer starts, localStorage is current value
    const localStorageType = localStorage.getItem('simulationType');
    const simulationType = simulationTypeParam || localStorageType;
    // Calculate flags from BOTH sources and use OR logic for maximum detection
    const isMementoMoriFromParam = isMementoMoriParam === true;
    const isMementoMoriFromType = simulationType === 'memento-mori';
    const isMementoMori = isMementoMoriFromParam || isMementoMoriFromType;
    const isStorySimulationFromParam = isStorySimulationParam === true;
    const isStorySimulationFromType = simulationType === 'story-simulation';
    const isStorySimulation = isStorySimulationFromParam || isStorySimulationFromType;
    console.log("\uD83D\uDD0D [handleSimulationEnd] ROUTING DECISION:", {
        "\uD83D\uDCE6 Parameters": {
            simulationTypeParam: simulationTypeParam,
            isMementoMoriParam: isMementoMoriParam,
            isStorySimulationParam: isStorySimulationParam
        },
        "\uD83D\uDCBE LocalStorage": {
            localStorageType: localStorageType
        },
        "\u2705 Final Decision": {
            simulationType: simulationType,
            isMementoMori: isMementoMori ? ' YES - Route to mementomori.html' : 'no',
            isStorySimulation: isStorySimulation ? ' YES - Route to storysimend.html' : 'no',
            fallbackTo: !isMementoMori && !isStorySimulation ? "\uD83C\uDFAE Freestyle - Route to freeend.html" : 'N/A'
        }
    });
    if (isMementoMori) {
        console.log("\u26B0\uFE0F Memento Mori timer expired - completing and redirecting to eulogy");
        await $86dc76c45b2250dc$var$handleMementoMoriEnd();
        return; // Exit early - memento mori has its own flow
    }
    if (isStorySimulation) {
        console.log("\uD83D\uDCD6 Story Simulation timer expired - handled by storyPhaseManager.js");
        return; // Exit early - story simulation uses phase-based timer
    }
    console.log("\uD83C\uDFAE Freestyle simulation timer expired - redirecting to results");
    // ✅ Show loading popup FIRST (like memento-mori does)
    $86dc76c45b2250dc$var$showFreestyleLoadingPopup();
    // Freestyle simulation logic
    try {
        const portfolioId = localStorage.getItem('portfolioId');
        const timerId = localStorage.getItem('simulationTimerId');
        const isSimulated = localStorage.getItem('isSimulated') === 'true';
        const token = localStorage.getItem('token');
        if (!portfolioId || !timerId) {
            console.error("\u274C Missing portfolio ID or timer ID for simulation end");
            return;
        }
        // ────── CLOSE SHORT POSITIONS ──────
        console.log("\uD83D\uDCC9 Closing all short positions for simulation end...");
        try {
            const portfolioResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/${portfolioId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const portfolioData = await portfolioResponse.json();
            const shortPositions = portfolioData.shortPositions || [];
            for (const short of shortPositions)try {
                await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/stocks/${short.stockId}/closeShortPosition`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        portfolioId: portfolioId
                    })
                });
            } catch (error) {
                console.error(`\u{26A0}\u{FE0F} Error closing short for stock ${short.stockId}:`, error);
            }
        } catch (error) {
            console.error("\u26A0\uFE0F Error closing short positions:", error);
        }
        // ────── FETCH SIMULATION RESULTS ──────
        let simulationResults = null;
        try {
            const token = localStorage.getItem('token');
            // Try both possible backend mount paths for compatibility
            let response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/sim/simulation/results/${timerId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) {
                console.warn("\u26A0\uFE0F Primary results route failed, retrying alternate path...");
                response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/simulation/results/${timerId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
            }
            if (response.ok) {
                const data = await response.json();
                // Backend returns { summary: {...} } - keep the wrapper structure
                simulationResults = data;
                console.log("\u2705 Successfully fetched simulation results");
            } else {
                console.error("\u274C Failed to fetch simulation results (status:", response.status, ')');
                simulationResults = {
                    summary: $86dc76c45b2250dc$var$createDefaultResults?.() || $86dc76c45b2250dc$var$getDefaultResultsFallback()
                };
            }
        } catch (error) {
            console.error("\uD83D\uDCA5 Error fetching simulation results:", error);
            simulationResults = {
                summary: $86dc76c45b2250dc$var$createDefaultResults?.() || $86dc76c45b2250dc$var$getDefaultResultsFallback()
            };
        }
        // ────── USE CACHED LLM ANALYSIS (PRE-FETCHED 20s BEFORE END) ──────
        let summary = simulationResults?.summary || simulationResults;
        // If the server already cleaned up the portfolio, the fetched summary is
        // all zeros ("Ended With: Nothing"). Prefer the live snapshot cached 20s
        // before the end — it has the real holdings detail.
        const summaryLooksEmpty = (s)=>{
            const fp = s?.finalPortfolio || {};
            return !fp.totalValue && !fp.points && !fp.stocks && !fp.items && !fp.zollars && !fp.bonds;
        };
        if (summaryLooksEmpty(summary) && window.freestyleSummaryCache && !summaryLooksEmpty(window.freestyleSummaryCache)) {
            console.log("\u267B\uFE0F Fetched summary is empty (portfolio already cleaned up) \u2014 using pre-fetched live snapshot");
            summary = window.freestyleSummaryCache;
        }
        let llmAnalysis = window.freestyleLLMAnalysis || null;
        if (llmAnalysis) console.log("\u2705 Using pre-fetched LLM analysis from cache");
        else if (token) {
            console.log("\u26A0\uFE0F No cached LLM analysis, fetching now (fallback)...");
            llmAnalysis = await $86dc76c45b2250dc$var$fetchFreestyleLLMAnalysis(summary, token);
        }
        // ────── REDIRECT TO FREEEND.HTML WITH COMPLETE DATA ──────
        await $86dc76c45b2250dc$var$redirectToFreeendWithResults(summary, portfolioId, timerId, llmAnalysis);
    } catch (error) {
        console.error("\uD83D\uDCA5 Error handling simulation end:", error);
        await $86dc76c45b2250dc$var$redirectToFreeendWithResults($86dc76c45b2250dc$var$getDefaultResultsFallback(), null, null, null);
    }
}
// ────── LOCAL DEFAULT RESULTS FALLBACK ──────
function $86dc76c45b2250dc$var$getDefaultResultsFallback() {
    return {
        performance: 'Complete',
        duration: 10,
        netGain: 0,
        tradesCompleted: 0,
        socialInteractions: 0,
        finalPortfolio: {
            points: 0,
            totalValue: 0,
            stocks: 0,
            items: 0,
            zollars: 0
        }
    };
}
// ────── FETCH LLM ANALYSIS WHILE STILL AUTHENTICATED ──────
async function $86dc76c45b2250dc$var$fetchFreestyleLLMAnalysis(summary, authToken) {
    if (!authToken) {
        console.warn("\u26A0\uFE0F No auth token for LLM analysis");
        return null;
    }
    try {
        console.log("\uD83E\uDD16 Fetching LLM analysis BEFORE redirect (30s timeout)...");
        console.log("\uD83D\uDCCA [LLM Request] Summary data being sent:", {
            netGain: summary?.netGain,
            tradesCompleted: summary?.tradesCompleted,
            socialInteractions: summary?.socialInteractions,
            duration: summary?.duration,
            hasSensitivitySignals: !!summary?.sensitivitySignals,
            sensitivitySignals: summary?.sensitivitySignals
        });
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>{
            console.warn("\u23F1\uFE0F LLM analysis request timed out after 30 seconds");
            controller.abort();
        }, 30000);
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/sim/simulation/analysis`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                summary: summary
            }),
            credentials: 'include',
            signal: controller.signal
        });
        clearTimeout(timeoutId);
        if (response.ok) {
            const data = await response.json();
            console.log("\u2705 LLM analysis pre-fetched:", data.paragraph?.substring(0, 100) + '...');
            return data.paragraph || null;
        } else {
            console.warn("\u26A0\uFE0F LLM analysis API returned", response.status);
            return null;
        }
    } catch (error) {
        console.warn("\u26A0\uFE0F Error pre-fetching LLM analysis:", error.message);
        return null;
    }
}
// ────── REDIRECT TO FREEEND WITH RESULTS ──────
async function $86dc76c45b2250dc$var$redirectToFreeendWithResults(summary, portfolioId, timerId, llmAnalysis = null) {
    const isSimulated = localStorage.getItem('isSimulated') === 'true';
    const simulationType = localStorage.getItem('simulationType');
    const authToken = localStorage.getItem('token');
    // ✅ Guard: only simulations should ever run this redirect
    if (!isSimulated && !simulationType) {
        console.log("\uD83D\uDEE1\uFE0F Normal user detected \u2014 skipping redirectToFreeendWithResults entirely.");
        return;
    }
    console.log("\uD83D\uDD04 Preparing redirect to freeend.html with simulation results");
    const pid = portfolioId || localStorage.getItem('portfolioId') || '';
    const tid = timerId || localStorage.getItem('simulationTimerId') || '';
    try {
        // Build the results payload with pre-fetched LLM analysis
        const resultsData = {
            summary: summary || $86dc76c45b2250dc$var$createDefaultResults?.() || {},
            portfolioId: pid,
            timerId: tid,
            timestamp: Date.now(),
            llmAnalysis: llmAnalysis // ✅ Include pre-generated analysis (passed from caller)
        };
        // Keep a one-time copy of the auth token so the results page can
        // refresh data/LLM without leaking it via the URL backup.
        if (authToken) localStorage.setItem('tempSimulationToken', authToken);
        // Store in session/local for redundancy
        console.log("\uD83D\uDCBE Storing results in sessionStorage & localStorage...");
        try {
            sessionStorage.setItem('simulationResults', JSON.stringify(resultsData));
        } catch  {}
        try {
            localStorage.setItem('tempSimulationResults', JSON.stringify(resultsData));
        } catch  {}
        // Backup for URL recovery
        // (Do NOT include auth token in the URL backup)
        const encodedResults = btoa(JSON.stringify(resultsData));
        console.log("\uD83D\uDD10 Encoded results for URL backup");
        // Mark simulation ending before anything else
        localStorage.setItem('simulationEnding', 'true');
        localStorage.setItem('preventBotRecreation', 'true');
        // Wait to ensure storage writes complete and verify data
        await new Promise((r)=>setTimeout(r, 800));
        // ✅ Verify data was actually stored before redirecting
        const verifyStored = localStorage.getItem('tempSimulationResults');
        if (!verifyStored) {
            console.warn("\u26A0\uFE0F Data verification failed, retrying storage...");
            try {
                localStorage.setItem('tempSimulationResults', JSON.stringify(resultsData));
            } catch  {}
            await new Promise((r)=>setTimeout(r, 400));
        }
        console.log("\u2705 Data storage verified successfully");
        // Fan-out to other tabs if needed
        try {
            if (isSimulated && typeof $86dc76c45b2250dc$var$broadcastLogoutToAllClients === 'function') $86dc76c45b2250dc$var$broadcastLogoutToAllClients({
                ...resultsData,
                portfolioId: pid
            });
            else console.log("\uD83D\uDEE1\uFE0F Skipping broadcast logout for non-sim users.");
        } catch (e) {
            console.warn('broadcastLogoutToAllClients failed:', e);
        }
        // Notify local listeners
        try {
            window.dispatchEvent(new CustomEvent('simulation-ended', {
                detail: {
                    payload: {
                        ...resultsData,
                        portfolioId: pid
                    }
                }
            }));
        } catch  {}
        // ✅ Immediate redirect first — before any logout
        console.log("\uD83C\uDFAF Redirecting immediately to freeend.html");
        window.location.replace(`/freeend.html?data=${encodedResults}`);
        // ───────────────────────────────
        // ⏳ AFTER REDIRECT: run logout async in background (10s delay to allow LLM response)
        // ───────────────────────────────
        setTimeout(async ()=>{
            try {
                const simulationType = localStorage.getItem('simulationType');
                const isSimulated = localStorage.getItem('isSimulated') === 'true';
                // Skip server logout for freestyle to avoid redirect override
                if (simulationType === 'freestyle' || simulationType === 'free-style') {
                    console.log("\uD83D\uDEE1\uFE0F Freestyle simulation - skipping blocking logout.");
                    return;
                }
                if (isSimulated || simulationType) {
                    console.log("\uD83D\uDEAA Performing async logout after redirect (10s delay)...");
                    const logoutPromise = typeof $86dc76c45b2250dc$var$logout === 'function' ? $86dc76c45b2250dc$var$logout() : Promise.resolve();
                    await Promise.race([
                        logoutPromise,
                        new Promise((r)=>setTimeout(r, 2000))
                    ]);
                }
            } catch (e) {
                console.warn('Async logout failed silently (ignored):', e);
            }
        }, 10000); // ✅ Changed from 2000ms to 10000ms (10 seconds)
    } catch (error) {
        console.error('Error during redirect to freeend:', error);
        // Emergency fallback
        const fallbackData = {
            summary: summary || (typeof $86dc76c45b2250dc$var$createDefaultResults === 'function' ? $86dc76c45b2250dc$var$createDefaultResults() : {}),
            portfolioId: pid,
            timerId: tid,
            timestamp: Date.now()
        };
        try {
            localStorage.setItem('tempSimulationResults', JSON.stringify(fallbackData));
        } catch  {}
        const encodedFallback = btoa(JSON.stringify(fallbackData));
        window.location.replace(`/freeend.html?data=${encodedFallback}`);
    }
}
function $86dc76c45b2250dc$var$createDefaultResults() {
    return {
        performance: 'Complete',
        duration: 10,
        netGain: 0,
        tradesCompleted: 0,
        socialInteractions: 0,
        finalPortfolio: {
            points: 0,
            totalValue: 0,
            stocks: 0,
            items: 0,
            zollars: 0,
            bonds: 0
        },
        improvements: []
    };
}
// ────── LOGOUT FUNCTION ──────
async function $86dc76c45b2250dc$var$logout() {
    console.log('[logout()] CALLED', {
        isSimulated: localStorage.getItem('isSimulated'),
        simulationType: localStorage.getItem('simulationType'),
        simulationEnding: localStorage.getItem('simulationEnding')
    });
    console.trace('[logout()] stack');
    const portfolioId = localStorage.getItem('portfolioId');
    const token = localStorage.getItem('token');
    const isSimulated = localStorage.getItem('isSimulated') === 'true';
    const isMementoMori = localStorage.getItem('simulationType') === 'memento-mori';
    // 🛡️ Preserve Memento Mori eulogy data before cleanup
    const preservedEulogy = localStorage.getItem('tempMementoMoriResults');
    // ADD THIS BLOCK - Visual feedback immediately
    const logoutButton = document.getElementById('logOut');
    const originalText = logoutButton ? logoutButton.textContent : 'Logout';
    if (logoutButton) {
        logoutButton.textContent = 'Logging out...';
        logoutButton.disabled = true;
        logoutButton.style.opacity = '0.6';
        logoutButton.style.pointerEvents = 'none';
    }
    // Show a processing overlay
    const overlay = document.createElement('div');
    overlay.style.cssText = `
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background: rgba(0, 0, 0, 0.8);
   z-index: 10000;
   display: flex;
   align-items: center;
   justify-content: center;
   color: #00ff00;
   font-family: 'bithigh', Arial, sans-serif;
   font-size: 12px;
   `;
    overlay.textContent = 'Disconnecting...';
    document.body.appendChild(overlay);
    if (!portfolioId || !token) {
        console.error('Portfolio ID or token not found in local storage');
        if (overlay) overlay.remove();
        if (logoutButton) {
            logoutButton.textContent = originalText;
            logoutButton.disabled = false;
            logoutButton.style.opacity = '1';
            logoutButton.style.pointerEvents = 'auto';
        }
        return;
    }
    try {
        // First, disconnect all bot sockets if this is a simulated user
        if (isSimulated && (0, $cJVho.socket) && (0, $cJVho.socket).connected) {
            console.log("\uD83E\uDD16 Disconnecting bots for simulated user logout...");
            (0, $cJVho.socket).emit('disconnectUserBots', {
                portfolioId: portfolioId
            });
            // Wait a moment for bot disconnection to complete
            await new Promise((resolve)=>setTimeout(resolve, 1000));
        }
        // Update the active status to false on the server
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/${portfolioId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                active: false
            })
        });
        if (!response.ok) throw new Error('Failed to update active status during logout');
    } catch (error) {
        console.error('Error updating active status during logout:', error);
        (0, $eD3DY.showNotification)('Error updating active status during logout. Please try again.', false);
    }
    try {
        // Call the logout endpoint on the server
        const logoutResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                isSimulated: isSimulated
            }),
            credentials: 'include'
        });
        if (!logoutResponse.ok) throw new Error('Failed to logout from server');
        const logoutData = await logoutResponse.json();
        console.log(logoutData.message);
        // Show success message for simulated users
        if (isSimulated) console.log("\uD83C\uDFAF Simulation cleanup completed successfully");
    } catch (error) {
        console.error('Error during server logout:', error);
        (0, $eD3DY.showNotification)('Error during server logout. Please try again.', false);
    }
    const simulationEnding = localStorage.getItem('simulationEnding') === 'true';
    console.log(`\u{1F50D} [Logout] simulationEnding flag captured: ${simulationEnding}`);
    // Disconnect main socket
    if ((0, $cJVho.socket) && (0, $cJVho.socket).connected) {
        console.log("\uD83D\uDD0C Disconnecting main socket...");
        (0, $cJVho.socket).disconnect();
    }
    if (simulationEnding || isSimulated) $86dc76c45b2250dc$export$e42ace8a14893918();
    if (isMementoMori) cleanupMementoMoriTimer?.();
    // Clear local storage and redirect to the login page
    localStorage.removeItem('portfolioId');
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('socketId');
    localStorage.removeItem('initialPortfolioState');
    localStorage.removeItem('selectedItems');
    localStorage.removeItem('superUserId');
    localStorage.removeItem('isSimulated');
    localStorage.removeItem('simulatedCompany');
    localStorage.removeItem('firstLogin');
    localStorage.removeItem('activeMementoMori');
    localStorage.removeItem('mementoMoriChecked');
    localStorage.removeItem('mementoMoriStarted');
    // ⚠️ CRITICAL: Only remove simulationType if NOT in simulation ending flow
    // (Otherwise it breaks the redirect detection on the end page)
    if (!simulationEnding) {
        localStorage.removeItem('simulationType');
        console.log("\uD83D\uDDD1\uFE0F Removed simulationType (normal logout)");
    } else console.log("\uD83D\uDCBE Preserved simulationType for simulation end page");
    localStorage.removeItem('mementoMoriObjectiveId');
    localStorage.removeItem('mementoMoriMode');
    localStorage.removeItem('mementoShowAllCompanies');
    localStorage.removeItem('stockBidData');
    localStorage.removeItem('tradeStory');
    localStorage.removeItem('tradeStoryTimestamp');
    localStorage.removeItem('lastConnectedStableKey');
    localStorage.removeItem('simulationEndTime');
    localStorage.removeItem('simulationTimerId');
    localStorage.removeItem('simulationEnding');
    localStorage.removeItem('botTradeOffer');
    localStorage.removeItem('botTradeRecommendation');
    localStorage.removeItem('tradingRecommendation');
    localStorage.removeItem('botTradeTimestamp');
    localStorage.removeItem('psychologyAnalysis');
    localStorage.removeItem('preventBotRecreation');
    localStorage.removeItem('preferredLanguage');
    // 🔄 NEW — wipe any key that starts with "trade_"
    for(let i = localStorage.length - 1; i >= 0; i--){
        const key = localStorage.key(i);
        if (key && key.startsWith('trade_')) localStorage.removeItem(key);
    }
    // ✅ Restore preserved eulogy after cleanup
    if (preservedEulogy) {
        localStorage.setItem('tempMementoMoriResults', preservedEulogy);
        console.log("\uD83D\uDCBE Preserved tempMementoMoriResults through logout");
    }
    // Clear cookies related to the session (if applicable)
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'sessionId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'portfolioId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    if (!simulationEnding) window.location.href = '/index.html';
    // 🧹 Cleanup overlay & restore button state
    if (overlay) overlay.remove();
    if (logoutButton) {
        logoutButton.textContent = originalText;
        logoutButton.disabled = false;
        logoutButton.style.opacity = '1';
        logoutButton.style.pointerEvents = 'auto';
    }
}
// ────── SOCKET LISTENER FOR SERVER-TRIGGERED END ──────
// This handles the case where the server ends the simulation via checkExpiredSimulations
function $86dc76c45b2250dc$var$setupSimulationSocketListeners() {
    if (!(0, $cJVho.socket)) {
        console.log("\u26A0\uFE0F Socket not available for simulation listeners");
        return;
    }
    // Remove any existing listener to prevent duplicates
    (0, $cJVho.socket).off('simulation:ended');
    (0, $cJVho.socket).on('simulation:ended', async (payload)=>{
        console.log("\uD83D\uDCE1 [Socket] Received simulation:ended from server:", payload);
        const { summary: summary, portfolioId: portfolioId, timerId: timerId } = payload;
        // Only process if this is for our portfolio
        const myPortfolioId = localStorage.getItem('portfolioId');
        if (portfolioId && myPortfolioId && portfolioId !== myPortfolioId) {
            console.log("\u23ED\uFE0F Ignoring simulation:ended for different portfolio");
            return;
        }
        // Check simulation type to route correctly
        const simulationType = localStorage.getItem('simulationType');
        const isMementoMori = simulationType === 'memento-mori';
        const isStorySimulation = simulationType === 'story-simulation';
        if (isMementoMori) {
            console.log("\u26B0\uFE0F Server ended Memento Mori - handled separately");
            return; // Memento Mori has its own end flow
        }
        if (isStorySimulation) {
            console.log("\uD83D\uDCD6 Server ended Story Simulation - handled separately");
            return;
        }
        // Freestyle: use server-provided summary if available
        if (summary && Object.keys(summary).length > 0) {
            console.log("\u2705 Using server-provided summary for redirect");
            // Prefer the pre-fetched live snapshot if the payload summary is empty
            const fp = summary.finalPortfolio || {};
            const payloadEmpty = !fp.totalValue && !fp.points && !fp.stocks && !fp.items && !fp.zollars && !fp.bonds;
            const bestSummary = payloadEmpty && window.freestyleSummaryCache ? window.freestyleSummaryCache : summary;
            await $86dc76c45b2250dc$var$redirectToFreeendWithResults(bestSummary, portfolioId, timerId, window.freestyleLLMAnalysis || null);
        } else {
            console.log("\u26A0\uFE0F No summary in payload, triggering normal end flow");
            $86dc76c45b2250dc$var$handleSimulationEnd('freestyle', false, false);
        }
    });
    (0, $cJVho.socket).on('forceLogout', (payload)=>{
        console.log("\uD83D\uDCE1 [Socket] Received forceLogout:", payload);
        // If we're already on an end page, ignore
        if (window.location.pathname.includes('freeend') || window.location.pathname.includes('mementomoriend') || window.location.pathname.includes('storysimend')) {
            console.log("\u23ED\uFE0F Already on end page, ignoring forceLogout");
            return;
        }
    // Otherwise let normal flow handle it
    });
    console.log("\u2705 Simulation socket listeners registered");
}
// ────── AUTO-INITIALIZE ON PAGE LOAD (SAFE VERSION) ──────
document.addEventListener('DOMContentLoaded', ()=>{
    console.log("\uD83D\uDE80 SimulationTimer module loaded (safe mode)");
    const simulationEndTime = localStorage.getItem('simulationEndTime');
    const simulationTimerId = localStorage.getItem('simulationTimerId');
    const isSimulated = localStorage.getItem('isSimulated') === 'true';
    const simulationType = localStorage.getItem('simulationType');
    // Setup socket listeners for server-triggered simulation end
    // Wait a moment for socket to be ready
    setTimeout(()=>{
        $86dc76c45b2250dc$var$setupSimulationSocketListeners();
    }, 1000);
    // 🛡️ Only proceed for simulations
    if (!isSimulated && !simulationType) {
        console.log("\uD83D\uDED1 Normal user detected \u2014 skipping simulation timer entirely.");
        // Clean up any leftover visual timer from previous sessions
        const strayTimer = document.getElementById('simulationTimer');
        if (strayTimer) {
            console.log("\uD83E\uDDF9 Removing stray timer display for normal user.");
            strayTimer.remove();
        }
        return;
    }
    if (simulationEndTime && simulationTimerId) {
        const endTime = new Date(simulationEndTime);
        if (endTime instanceof Date && !isNaN(endTime)) {
            if (endTime > new Date()) {
                console.log("\uD83D\uDD04 Restoring simulation timer from localStorage");
                $86dc76c45b2250dc$export$cc7efffc33e38fab(simulationEndTime, simulationTimerId);
            } else {
                console.log("\u23F0 Timer expired, cleaning up");
                localStorage.removeItem('simulationEndTime');
                localStorage.removeItem('simulationTimerId');
            }
        } else {
            console.warn("\u26A0\uFE0F Invalid simulationEndTime detected \u2014 cleaning up.");
            localStorage.removeItem('simulationEndTime');
            localStorage.removeItem('simulationTimerId');
        }
    } else console.log("\uD83E\uDDD8 No simulation data yet \u2014 timer module idle.");
});
// ────── TESTING FUNCTIONS ──────
// Add global test functions for debugging
window.testSimulationTimer = function(minutes = 2) {
    console.log(`\u{1F9EA} Starting test timer for ${minutes} minutes`);
    const endTime = new Date(Date.now() + minutes * 60000).toISOString();
    const timerId = 'test-timer-' + Date.now();
    $86dc76c45b2250dc$export$cc7efffc33e38fab(endTime, timerId);
};
window.clearSimulationTimer = function() {
    console.log("\uD83E\uDDF9 Clearing simulation timer");
    $86dc76c45b2250dc$export$e42ace8a14893918();
};
window.checkTimerStatus = function() {
    console.log("\uD83D\uDCCA Timer Status:", {
        simulationEndTime: $86dc76c45b2250dc$var$simulationEndTime,
        timeRemaining: $86dc76c45b2250dc$var$getTimeRemaining(),
        timerExists: !!document.getElementById('simulationTimer'),
        localStorage: {
            endTime: localStorage.getItem('simulationEndTime'),
            timerId: localStorage.getItem('simulationTimerId')
        }
    });
};
let $86dc76c45b2250dc$var$scrollTimeout;
window.addEventListener('scroll', ()=>{
    const timer = document.getElementById('simulationTimer');
    if (timer) {
        if (window.scrollY > 50) timer.classList.add('scrolled');
        else timer.classList.remove('scrolled');
    }
});

});

parcelRegister("gwQDn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c08876841dbc6bba$export$2e2bcd8739ae039);
// frontend/js/emotionalDebtMeter.js

var $fUPn2 = parcelRequire("fUPn2");

var $15BR8 = parcelRequire("15BR8");
parcelRequire("cNeIB");
if (!globalThis.ZTranslations) globalThis.ZTranslations = (0, $15BR8.default);
if (typeof globalThis.$t !== 'function') globalThis.$t = (key, params)=>{
    return (0, $fUPn2.t)(key);
};
class $c08876841dbc6bba$var$EmotionalDebtMeter {
    constructor(containerId, portfolioId){
        this.container = document.getElementById(containerId);
        this.portfolioId = portfolioId;
        this.data = null;
        this.active = false;
    }
    async init() {
        if (!this.container) return console.warn('[EmotionalDebtMeter] container not found');
        // Initial backend fetch (only once)
        await this.fetchData();
        // Listen for socket updates if available
        if (socket && !this.active) {
            this.active = true;
            this.registerSocketListeners();
        }
    }
    registerSocketListeners() {
        // Emotion or trust index updates from backend
        socket.on('emotionalUpdate', (payload)=>{
            if (!payload || payload.portfolioId !== this.portfolioId) return;
            this.updateFromSocket(payload);
        });
        // Trust index change event (optional if separate)
        socket.on('trustIndexUpdate', (payload)=>{
            if (!payload || payload.portfolioId !== this.portfolioId) return;
            this.updateFromSocket(payload);
        });
    }
    async fetchData() {
        try {
            const res = await fetch(`/api/social-economy/emotional-state/${this.portfolioId}`);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const json = await res.json();
            if (!json.success) throw new Error('Invalid response');
            this.data = json;
            this.render();
        } catch (err) {
            console.error('[EmotionalDebtMeter] fetch error', err);
            this.container.innerHTML = `<div class="emotional-debt-meter loading"><div class="loading-text">loading emotional state...</div></div>`;
        }
    }
    updateFromSocket(payload) {
        this.data = {
            ...this.data,
            emotionalState: payload.emotionalState ?? this.data?.emotionalState,
            trustIndex: payload.trustIndex ?? this.data?.trustIndex,
            lifeProfitCache: payload.lifeProfitCache ?? this.data?.lifeProfitCache,
            recentTransactions: payload.recentTransactions ?? this.data?.recentTransactions
        };
        this.render();
    }
    // Convert intensity (0-1) to qualitative description
    getIntensityQualifier(intensity) {
        if (intensity >= 0.9) return {
            label: 'Overwhelming',
            color: '#ff00ff'
        };
        if (intensity >= 0.75) return {
            label: 'Intense',
            color: '#ff3366'
        };
        if (intensity >= 0.6) return {
            label: 'Strong',
            color: '#ff6699'
        };
        if (intensity >= 0.45) return {
            label: 'Moderate',
            color: '#00ffcc'
        };
        if (intensity >= 0.3) return {
            label: 'Gentle',
            color: '#66ff99'
        };
        if (intensity >= 0.15) return {
            label: 'Faint',
            color: '#99ff99'
        };
        return {
            label: 'Barely Perceptible',
            color: '#ccffcc'
        };
    }
    // Convert trust (0-1) to qualitative description
    getTrustQualifier(trust) {
        if (trust >= 0.9) return {
            label: 'Absolute Faith',
            color: '#00ffff'
        };
        if (trust >= 0.75) return {
            label: 'Deep Trust',
            color: '#00ddff'
        };
        if (trust >= 0.6) return {
            label: 'Solid Confidence',
            color: '#00bbff'
        };
        if (trust >= 0.45) return {
            label: 'Growing Bond',
            color: '#0099ff'
        };
        if (trust >= 0.3) return {
            label: 'Tentative',
            color: '#ffaa00'
        };
        if (trust >= 0.15) return {
            label: 'Fragile',
            color: '#ff8800'
        };
        return {
            label: 'Broken',
            color: '#ff4444'
        };
    }
    // Convert life profit to qualitative description
    getLifeProfitQualifier(profit) {
        if (profit >= 500) return {
            label: 'Radiant Abundance',
            color: '#00ffff'
        };
        if (profit >= 300) return {
            label: 'Flourishing',
            color: '#00ff99'
        };
        if (profit >= 150) return {
            label: 'Thriving',
            color: '#66ff66'
        };
        if (profit >= 50) return {
            label: 'Growing',
            color: '#99ff99'
        };
        if (profit >= 10) return {
            label: 'Emerging',
            color: '#ccff99'
        };
        if (profit >= -10) return {
            label: 'Balanced',
            color: '#ffff99'
        };
        if (profit >= -50) return {
            label: 'Strained',
            color: '#ffcc66'
        };
        if (profit >= -150) return {
            label: 'Burdened',
            color: '#ff9944'
        };
        if (profit >= -300) return {
            label: 'Depleted',
            color: '#ff6633'
        };
        if (profit >= -500) return {
            label: 'Exhausted',
            color: '#ff4422'
        };
        return {
            label: 'Crushing Weight',
            color: '#ff0000'
        };
    }
    render() {
        if (!this.data) {
            const loadingText = (0, $fUPn2.t)('emotional_debt.loading_state', 'loading human capital flux...');
            this.container.innerHTML = `<div class="emotional-debt-meter loading"><div class="loading-text">${loadingText}</div></div>`;
            return;
        }
        const { emotionalState: emotionalState, trustIndex: trustIndex, lifeProfitCache: lifeProfitCache, recentTransactions: recentTransactions } = this.data;
        const emotion = emotionalState?.dominant || 'neutral';
        const intensityRaw = emotionalState?.intensity || 0;
        const trustRaw = trustIndex || 0;
        // Map emotion → color
        const emotionColor = this.getEmotionColor(emotion);
        // Apply CSS variable for unified tone
        this.container.style.setProperty('--emotion-color', emotionColor);
        // Convert to qualitative descriptions
        const intensityQual = this.getIntensityQualifier(intensityRaw);
        const trustQual = this.getTrustQualifier(trustRaw);
        const lifeProfitQual = this.getLifeProfitQualifier(lifeProfitCache);
        const meterTitle = (0, $fUPn2.t)('emotional_debt.meter_title', 'Human Capital Flux Index');
        const meterSubtitle = (0, $fUPn2.t)('emotional_debt.meter_subtitle', 'Relational Topology');
        const trustIndexLabel = (0, $fUPn2.t)('emotional_debt.trust_index_label', 'Relational Trust');
        const lifeProfitLabel = (0, $fUPn2.t)('emotional_debt.life_profit_label', 'Existential Balance');
        const synergyDescription = (0, $fUPn2.t)('emotional_debt.synergy_description', 'moral / emotional / capital synergy');
        const recentEventsTitle = (0, $fUPn2.t)('emotional_debt.recent_events_title', 'Recent Flux Events');
        this.container.innerHTML = `
      <div class="emotional-debt-meter">
        <div class="meter-header">
          <div class="meter-title">${meterTitle}</div>
          <div class="meter-subtitle">${meterSubtitle}</div>
        </div>

        <div class="meter-body">
          <div class="emotion-display">
            <div class="emotion-icon" style="background: radial-gradient(circle, ${emotionColor} 0%, ${emotionColor}88 50%, transparent 100%); border-color: ${emotionColor};"></div>
            <div class="emotion-info">
              <div class="emotion-name">${this.formatEmotion(emotion)}</div>
              <div class="emotion-intensity">
                <div class="intensity-bar">
                  <div class="intensity-fill" style="width:${Math.round(intensityRaw * 100)}%; background: linear-gradient(90deg, ${emotionColor}dd, ${emotionColor}99);"></div>
                </div>
                <div class="intensity-text" style="color: ${intensityQual.color};">${intensityQual.label}</div>
              </div>
            </div>
          </div>

          <div class="metrics-grid">
            <div class="metric-card">
              <div class="metric-label">${trustIndexLabel}</div>
              <div class="metric-value" style="color: ${trustQual.color}; text-shadow: 0 0 6px ${trustQual.color}88;">
                ${trustQual.label}
              </div>
              <div class="metric-bar">
                <div class="metric-fill trust" style="width:${Math.round(trustRaw * 100)}%; background: linear-gradient(90deg, ${trustQual.color}dd, ${trustQual.color}99);"></div>
              </div>
            </div>
            <div class="metric-card">
              <div class="metric-label">${lifeProfitLabel}</div>
              <div class="metric-value" style="color: ${lifeProfitQual.color}; text-shadow: 0 0 6px ${lifeProfitQual.color}88;">
                ${lifeProfitQual.label}
              </div>
              <div class="metric-description">${synergyDescription}</div>
            </div>
          </div>

          ${recentTransactions?.length ? `<div class="recent-transactions">
                <div class="transactions-title">${recentEventsTitle}</div>
                <div class="transactions-list">
                  ${recentTransactions.slice(-5).map((tx)=>this.renderTransaction(tx)).join('')}
                </div>
              </div>` : ''}
        </div>
      </div>`;
    }
    renderTransaction(tx) {
        const color = this.getTransactionColor(tx.type);
        const timeAgo = this.timeAgo(new Date(tx.timestamp));
        const partner = tx.from?.name || tx.to?.name || 'unknown';
        const typeKey = `emotional_debt.transaction_types.${tx.type}`;
        const typeLabel = (0, $fUPn2.t)(typeKey, tx.type);
        const withLabel = (0, $fUPn2.t)('emotional_debt.transaction_with', 'with');
        return `
      <div class="transaction-item" style="border-left-color:${color}">
        <div class="tx-text">${typeLabel} ${withLabel} ${partner}</div>
        <div class="tx-time">${timeAgo}</div>
      </div>`;
    }
    formatEmotion(emotion) {
        if (!emotion) return (0, $fUPn2.t)('emotional_debt.emotions.neutral', 'Neutral');
        const emotionKey = `emotional_debt.emotions.${emotion}`;
        const fallback = emotion.charAt(0).toUpperCase() + emotion.slice(1);
        return (0, $fUPn2.t)(emotionKey, fallback);
    }
    getEmotionColor(emotion) {
        const map = {
            hopeful: '#00ff66',
            anxious: '#ff8800',
            despairing: '#555555',
            resentful: '#ff3333',
            grateful: '#66ff99',
            numb: '#999999',
            altruistic: '#33ffee',
            indebted: '#00ffee',
            empowered: '#00bfff',
            rejected: '#cc00ff',
            relieved: '#00ffcc',
            neutral: '#00ff00'
        };
        return map[emotion] || '#00ff00';
    }
    getTransactionColor(type) {
        const colors = {
            help: '#00ff66',
            loan: '#00bfff',
            forgiveness: '#66ff99',
            betrayal: '#ff3333'
        };
        return colors[type] || '#00ff00';
    }
    timeAgo(date) {
        const seconds = Math.floor((Date.now() - date) / 1000);
        if (seconds < 60) return (0, $fUPn2.t)('emotional_debt.time_labels.now', 'now');
        const m = Math.floor(seconds / 60);
        if (m < 60) return (0, $fUPn2.t)('emotional_debt.time_labels.minutes_ago', '{m}m ago').replace('{m}', m);
        const h = Math.floor(m / 60);
        if (h < 24) return (0, $fUPn2.t)('emotional_debt.time_labels.hours_ago', '{h}h ago').replace('{h}', h);
        const d = Math.floor(h / 24);
        return (0, $fUPn2.t)('emotional_debt.time_labels.days_ago', '{d}d ago').replace('{d}', d);
    }
}
var $c08876841dbc6bba$export$2e2bcd8739ae039 // =======================================================
 // USAGE EXAMPLE (anywhere after portfolio load)
 // =======================================================
 // import EmotionalDebtMeter from './emotionalDebtMeter.js';
 // const meter = new EmotionalDebtMeter('emotionalDebtContainer', currentPortfolioId);
 // meter.init();
 = $c08876841dbc6bba$var$EmotionalDebtMeter;

});

parcelRegister("iD9HX", function(module, exports) {

$parcel$export(module.exports, "qualitativeFromFraction_LOCAL", () => $d90366524d26acbf$export$9366fd60be9e5643);
$parcel$export(module.exports, "modalManager", () => $d90366524d26acbf$export$78d35f50a4fd5552);
$parcel$export(module.exports, "handleCDSVictimCollapse", () => $d90366524d26acbf$export$df02e6407caad277);
$parcel$export(module.exports, "handleCDSExploiterGuilt", () => $d90366524d26acbf$export$ce26b1f430b884de);
$parcel$export(module.exports, "handleCDSInitiation", () => $d90366524d26acbf$export$e136fdf6cbbbf403);
// frontend/js/socialEconomyHandlers.js
// Social Economy Integration for Trader Interface

var $cNeIB = parcelRequire("cNeIB");

var $21EbS = parcelRequire("21EbS");

var $fUPn2 = parcelRequire("fUPn2");

var $15BR8 = parcelRequire("15BR8");
if (!globalThis.ZTranslations) globalThis.ZTranslations = (0, $15BR8.default);
if (typeof globalThis.$t !== 'function') globalThis.$t = (key, params)=>{
    return (0, $fUPn2.t)(key);
};
// === Utility Setup ===
const $d90366524d26acbf$var$CACHE_DURATION = 10000; // 10 seconds
const $d90366524d26acbf$var$portfolioCache = new Map();
// === Local, self-contained Z$ slider utilities (no imports needed) ===
async function $d90366524d26acbf$var$fetchPortfolioZollars_LOCAL(apiBaseUrl, portfolioId, token) {
    const res = await fetch(`${apiBaseUrl}/api/trader/${portfolioId}/zollars`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!res.ok) throw new Error(`Failed to fetch zollars ${res.status}`);
    return res.json();
}
// === Shared "Zollars / Capital" holographic switch ===
function $d90366524d26acbf$var$createModeSwitch(start = 'zollars') {
    const wrap = document.createElement('div');
    wrap.style.cssText = 'display:flex;gap:12px;justify-content:center;margin:12px 0 8px;';
    const make = (id, label)=>{
        const b = document.createElement('button');
        b.id = id;
        b.textContent = label;
        b.style.cssText = `
      padding:10px 18px;border-radius:10px;font-family:'bithigh',monospace;
      cursor:pointer;transition:all .2s ease;background:rgba(0,0,0,.4);
      box-shadow:0 0 8px rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.3);
      color:#fcba03;
    `;
        b.dataset.active = '0';
        return b;
    };
    const zol = make('modeZollars', 'Zollars');
    const cap = make('modeCapital', 'Capital');
    const setActive = (btnOn)=>{
        [
            zol,
            cap
        ].forEach((b)=>{
            b.dataset.active = b === btnOn ? '1' : '0';
            if (b === btnOn) {
                b.style.background = 'rgba(252,186,3,.25)';
                b.style.boxShadow = '0 0 12px rgba(252,186,3,.8)';
                b.style.border = '1px solid #fcba03';
                b.style.color = '#fff';
            } else {
                b.style.background = 'rgba(0,0,0,.4)';
                b.style.boxShadow = '0 0 8px rgba(255,255,255,.08)';
                b.style.border = '1px solid rgba(255,255,255,.3)';
                b.style.color = '#fcba03';
            }
        });
    };
    wrap.appendChild(zol);
    wrap.appendChild(cap);
    setActive(start === 'zollars' ? zol : cap);
    return {
        el: wrap,
        zol: zol,
        cap: cap,
        setActive: setActive
    };
}
function $d90366524d26acbf$var$aggregateZollarsByType_LOCAL(zollars) {
    const map = {
        erotic: 'erotic',
        'Erotic': 'erotic',
        fellow: 'fellowship',
        'Fellow': 'fellowship',
        'fellowship': 'fellowship',
        'FellowShip': 'fellowship',
        friend: 'friendship',
        'Friend': 'friendship',
        'friendship': 'friendship',
        'Friendship': 'friendship',
        'FriendShip': 'friendship',
        hate: 'hate',
        'Hate': 'hate',
        love: 'love',
        'Love': 'love',
        superficial: 'superficial',
        'SuperFicial': 'superficial',
        'Superficial': 'superficial',
        superficiality: 'superficial',
        'Superficiality': 'superficial',
        toxic: 'toxic',
        'Toxic': 'toxic',
        death: 'death',
        'Death': 'death',
        'long life': 'long life',
        'Long Life': 'long life',
        'longlife': 'long life'
    };
    const totals = {};
    console.log(`\u{1F4CA} [aggregateZollars] Processing ${(zollars || []).length} zollars`);
    (zollars || []).forEach((z)=>{
        // Use regex to handle case-insensitive "Zollar" removal (matches backend logic)
        let t = String(z.zollar_name || '').replace(/\s*[Zz]ollar\s*$/i, '').trim().toLowerCase();
        // Check map for normalized version
        t = map[t] || t;
        if (!t) return;
        totals[t] = (totals[t] || 0) + 1;
        console.log(`  "${z.zollar_name}" \u{2192} "${t}" (total: ${totals[t]})`);
    });
    console.log(`\u{1F4CA} [aggregateZollars] Final totals:`, totals);
    return totals;
}
function $d90366524d26acbf$export$9366fd60be9e5643(r) {
    if (r <= 0) return 'None';
    if (r <= 0.03) return 'Barely Any';
    if (r <= 0.07) return 'A Trace';
    if (r <= 0.12) return 'A Hint';
    if (r <= 0.18) return 'A Little';
    if (r <= 0.26) return 'A Few';
    if (r <= 0.33) return 'Some';
    if (r <= 0.40) return 'Several';
    if (r <= 0.50) return 'Moderate';
    if (r <= 0.58) return 'Noticeable';
    if (r <= 0.65) return 'Considerable';
    if (r <= 0.72) return 'Many';
    if (r <= 0.78) return 'A Lot';
    if (r <= 0.83) return 'Abundant';
    if (r <= 0.88) return 'Heaps';
    if (r <= 0.92) return 'A Great Deal';
    if (r <= 0.95) return 'Almost All';
    if (r <= 0.97) return 'Nearly Everything';
    if (r <= 0.985) return 'Overflowing';
    if (r <= 0.995) return 'Virtually Everything';
    return 'All You Have';
}
function $d90366524d26acbf$var$colorForFraction_LOCAL(p) {
    const r = Math.max(0, Math.min(1, p));
    if (r <= 0.02) return 'rgba(255, 255, 153, 0.35)';
    if (r <= 0.05) return 'rgba(255, 247, 130, 0.4)';
    if (r <= 0.08) return 'rgba(255, 239, 100, 0.45)';
    if (r <= 0.12) return 'rgba(255, 230, 80, 0.5)';
    if (r <= 0.16) return 'rgba(255, 216, 60, 0.55)';
    if (r <= 0.20) return 'rgba(255, 204, 40, 0.6)';
    if (r <= 0.26) return 'rgba(255, 190, 30, 0.65)';
    if (r <= 0.32) return 'rgba(255, 175, 20, 0.68)';
    if (r <= 0.38) return 'rgba(255, 160, 10, 0.7)';
    if (r <= 0.44) return 'rgba(255, 145, 5, 0.72)';
    if (r <= 0.50) return 'rgba(255, 130, 0, 0.74)';
    if (r <= 0.58) return 'rgba(255, 115, 0, 0.76)';
    if (r <= 0.66) return 'rgba(255, 100, 0, 0.78)';
    if (r <= 0.74) return 'rgba(255, 85, 0, 0.75)';
    if (r <= 0.82) return 'rgba(255, 70, 10, 0.75)';
    if (r <= 0.88) return 'rgba(255, 55, 20, 0.75)';
    if (r <= 0.93) return 'rgba(255, 40, 25, 0.75)';
    if (r <= 0.97) return 'rgba(255, 25, 30, 0.75)';
    if (r <= 0.99) return 'rgba(240, 15, 40, 0.75)';
    return 'rgba(220, 5, 30, 0.88)';
}
/**
 * Create abstract sliders for borrowing (no specific quantities)
 */ function $d90366524d26acbf$var$createAbstractBorrowSliders_LOCAL() {
    const container = document.createElement('div');
    container.style.cssText = 'display:flex;flex-direction:column;gap:20px;padding:12px 0;';
    let zollarValue = 0;
    let capitalValue = 0;
    // Zollar Slider
    const zollarSection = document.createElement('div');
    zollarSection.innerHTML = `
    <label style="display:block;margin-bottom:8px;font-family:'bithigh',monospace;color:#fcba03;font-size:1.1em;">
      Zollars
    </label>
    <input type="range" class="abstract-zollar-slider range-slider" min="0" max="100" value="0" style="width:100%;height:10px;background:rgba(252,186,3,0.2);border-radius:4px;outline:none;cursor:pointer;-webkit-appearance:none;appearance:none;">
    <div style="display:flex;justify-content:space-between;margin-top:4px;font-family:'bithigh',monospace;font-size:0.85em;color:#999;">
      <span>None</span>
      <span class="zollar-magnitude" style="color:#fcba03;">None</span>
      <span>Maximum</span>
    </div>
  `;
    const zollarSlider = zollarSection.querySelector('.abstract-zollar-slider');
    const zollarMagnitude = zollarSection.querySelector('.zollar-magnitude');
    zollarSlider.addEventListener('input', ()=>{
        zollarValue = parseInt(zollarSlider.value) || 0;
        const frac = zollarValue / 100;
        zollarMagnitude.textContent = $d90366524d26acbf$export$9366fd60be9e5643(frac);
        zollarSlider.style.background = `linear-gradient(to right, rgba(252,186,3,0.6) 0%, rgba(252,186,3,0.6) ${zollarValue}%, rgba(252,186,3,0.2) ${zollarValue}%, rgba(252,186,3,0.2) 100%)`;
    });
    // Capital Slider
    const capitalSection = document.createElement('div');
    capitalSection.innerHTML = `
    <label style="display:block;margin-bottom:8px;font-family:'bithigh',monospace;color:#fcba03;font-size:1.1em;">
      Capital
    </label>
    <input type="range" class="abstract-capital-slider range-slider" min="0" max="100" value="0" style="width:100%;height:10px;background:rgba(252,186,3,0.2);border-radius:4px;outline:none;cursor:pointer;-webkit-appearance:none;appearance:none;">
    <div style="display:flex;justify-content:space-between;margin-top:4px;font-family:'bithigh',monospace;font-size:0.85em;color:#999;">
      <span>None</span>
      <span class="capital-magnitude" style="color:#fcba03;">None</span>
      <span>Maximum</span>
    </div>
  `;
    const capitalSlider = capitalSection.querySelector('.abstract-capital-slider');
    const capitalMagnitude = capitalSection.querySelector('.capital-magnitude');
    capitalSlider.addEventListener('input', ()=>{
        capitalValue = parseInt(capitalSlider.value) || 0;
        const frac = capitalValue / 100;
        capitalMagnitude.textContent = $d90366524d26acbf$export$9366fd60be9e5643(frac);
        capitalSlider.style.background = `linear-gradient(to right, rgba(252,186,3,0.6) 0%, rgba(252,186,3,0.6) ${capitalValue}%, rgba(252,186,3,0.2) ${capitalValue}%, rgba(252,186,3,0.2) 100%)`;
    });
    container.appendChild(zollarSection);
    container.appendChild(capitalSection);
    return {
        el: container,
        getZollarMagnitude: ()=>zollarValue,
        getCapitalMagnitude: ()=>capitalValue,
        hasSelection: ()=>zollarValue > 0 || capitalValue > 0
    };
}
function $d90366524d26acbf$var$createLocalZollarSliders_LOCAL(relationshipTotals) {
    const container = document.createElement('div');
    container.style.cssText = 'display:flex;flex-direction:column;gap:14px;padding:6px 0;';
    const bid = {};
    const types = Object.keys(relationshipTotals || {}).filter((k)=>relationshipTotals[k] > 0);
    const cap = (s)=>s.charAt(0).toUpperCase() + s.slice(1);
    types.forEach((type)=>{
        const max = Number(relationshipTotals[type]) || 0;
        bid[type] = 0;
        const row = document.createElement('div');
        row.style.cssText = 'display:flex;flex-direction:column;gap:6px;';
        const head = document.createElement('div');
        head.style.cssText = 'display:flex;justify-content:space-between;align-items:center;';
        head.innerHTML = `
      <span style="font-family:'bithigh',monospace;color:#fcba03;">${cap(type)}</span>
      <span id="desc-${type}" style="font-family:'bithigh',monospace;color:#fcba03;opacity:.9;">None</span>
    `;
        const bar = document.createElement('div');
        bar.style.cssText = `
      position:relative;width:100%;height:40px;background:rgba(0,0,0,.3);
      border:2px solid #fcba03;border-radius:8px;overflow:hidden;cursor:pointer;box-shadow:0 0 10px rgba(252,186,3,.5);
    `;
        const base = document.createElement('div');
        base.style.cssText = 'position:absolute;inset:0;background:#fcba03;opacity:.15;';
        const fill = document.createElement('div');
        fill.id = `fill-${type}`;
        fill.style.cssText = `
      position:absolute;top:0;left:0;height:100%;width:0%;
      background:rgba(252,186,3,.4);box-shadow:0 0 12px rgba(252,186,3,.7);
      transition:width .15s ease, background-color .15s ease;
    `;
        bar.appendChild(base);
        bar.appendChild(fill);
        const hidden = document.createElement('input');
        hidden.type = 'range';
        hidden.min = '0';
        hidden.max = String(max);
        hidden.value = '0';
        hidden.style.display = 'none';
        hidden.id = `slider-${type}`;
        const updateAt = (clientX)=>{
            const rect = bar.getBoundingClientRect();
            const p = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
            const raw = Math.round(p * max);
            hidden.value = String(raw);
            bid[type] = raw;
            const frac = max > 0 ? raw / max : 0;
            fill.style.width = `${frac * 100}%`;
            const c = $d90366524d26acbf$var$colorForFraction_LOCAL(frac);
            fill.style.backgroundColor = c;
            fill.style.boxShadow = `0 0 15px ${c}`;
            const d = document.getElementById(`desc-${type}`);
            if (d) d.textContent = $d90366524d26acbf$export$9366fd60be9e5643(frac);
        };
        let dragging = false;
        bar.addEventListener('mousedown', (e)=>{
            dragging = true;
            updateAt(e.clientX);
        });
        document.addEventListener('mousemove', (e)=>{
            if (dragging) updateAt(e.clientX);
        });
        document.addEventListener('mouseup', ()=>dragging = false);
        bar.addEventListener('click', (e)=>updateAt(e.clientX));
        bar.addEventListener('touchstart', (e)=>{
            dragging = true;
            updateAt(e.touches[0].clientX);
            e.preventDefault();
        });
        document.addEventListener('touchmove', (e)=>{
            if (dragging) updateAt(e.touches[0].clientX);
        });
        document.addEventListener('touchend', ()=>dragging = false);
        row.appendChild(head);
        row.appendChild(bar);
        row.appendChild(hidden);
        container.appendChild(row);
    });
    return {
        el: container,
        getBid: ()=>({
                ...bid
            }),
        total: ()=>Object.values(bid).reduce((a, b)=>a + (b || 0), 0),
        validate: ()=>true // holdings are baked into max; can’t exceed
    };
}
function $d90366524d26acbf$var$renderModeSwitch_LOCAL(defaultMode = 'capital') {
    const wrap = document.createElement('div');
    wrap.style.cssText = 'display:flex;gap:10px;margin:10px 0 6px;';
    const mk = (id, label, active = false)=>{
        const b = document.createElement('button');
        b.id = id;
        b.textContent = label;
        b.className = active ? 'mode-btn active' : 'mode-btn';
        b.style.cssText = `
      flex:1;padding:10px 12px;border:1px solid #fcba03;background:rgba(0,0,0,.35);
      color:#fcba03;font-family:'bithigh',monospace;cursor:pointer;border-radius:8px;
      box-shadow:${active ? '0 0 14px rgba(252,186,3,.8) inset' : '0 0 6px rgba(252,186,3,.4) inset'};
    `;
        return b;
    };
    const cap = mk('modeCapital', 'Capital', defaultMode === 'capital');
    const zol = mk('modeZollars', 'Zollars', defaultMode === 'zollars');
    wrap.appendChild(cap);
    wrap.appendChild(zol);
    return wrap;
}
// === Portfolio Preload + Cache System ===
async function $d90366524d26acbf$var$preloadPortfolios() {
    const sessionId = localStorage.getItem('sessionId');
    if (!sessionId) return;
    try {
        const [active, richest] = await Promise.all([
            fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/active`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${(0, $21EbS.getAuthToken)()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    sessionId: sessionId
                })
            }).then((r)=>r.json()),
            fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/richest`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${(0, $21EbS.getAuthToken)()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    sessionId: sessionId
                })
            }).then((r)=>r.json())
        ]);
        const now = Date.now();
        $d90366524d26acbf$var$portfolioCache.set('active', {
            data: active,
            timestamp: now
        });
        $d90366524d26acbf$var$portfolioCache.set('richest', {
            data: richest,
            timestamp: now
        });
        console.log("\uD83D\uDCE6 Preloaded active and richest portfolios");
    } catch (error) {
        console.error("\u274C Failed to preload portfolios:", error);
    }
}
async function $d90366524d26acbf$var$getCachedPortfolios(sessionId, endpoint = '/api/portfolios/active') {
    const cacheKey = endpoint.includes('richest') ? 'richest' : 'active';
    const cached = $d90366524d26acbf$var$portfolioCache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < $d90366524d26acbf$var$CACHE_DURATION) return cached.data;
    try {
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}${endpoint}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: sessionId
            })
        });
        const data = await response.json();
        $d90366524d26acbf$var$portfolioCache.set(cacheKey, {
            data: data,
            timestamp: Date.now()
        });
        return data;
    } catch (error) {
        console.error("\u274C Portfolio fetch failed:", error);
        return {
            portfolios: []
        };
    }
}
// === Emotional Debt Meter Initialization ===
document.addEventListener('DOMContentLoaded', ()=>{
    const portfolioId = localStorage.getItem('portfolioId');
    if (portfolioId && typeof EmotionalDebtMeter !== 'undefined') {
        const emotionalMeter = new EmotionalDebtMeter('emotional-debt-meter', portfolioId);
        emotionalMeter.init();
        console.log("\uD83D\uDC9E Emotional Debt Meter initialized");
        window.emotionalMeter = emotionalMeter;
    }
    $d90366524d26acbf$var$preloadPortfolios(); // Preload early
});
// === Social Economy Modal Manager ===
class $d90366524d26acbf$var$SocialEconomyModal {
    constructor(){
        this.activeModal = null;
    }
    async fetchAllActivePortfolios() {
        const portfolioId = localStorage.getItem('portfolioId');
        const sessionId = localStorage.getItem('sessionId');
        if (!sessionId) {
            console.warn("\u26A0\uFE0F No session found for portfolio fetch");
            return {
                portfolios: [],
                currentPortfolioId: portfolioId,
                hasSession: false
            };
        }
        try {
            const data = await $d90366524d26acbf$var$getCachedPortfolios(sessionId, '/api/portfolios/active');
            const portfolios = data.portfolios || data.data?.portfolios || [];
            return {
                portfolios: portfolios,
                currentPortfolioId: portfolioId,
                hasSession: true
            };
        } catch (error) {
            console.error("\u274C [SocialEconomy] Failed to fetch portfolios:", error);
            return {
                portfolios: [],
                currentPortfolioId: portfolioId,
                hasSession: false
            };
        }
    }
    createModal(title, content, onConfirm, onCancel) {
        this.closeModal();
        const overlay = document.createElement('div');
        overlay.className = 'social-economy-popup-overlay active';
        const modal = document.createElement('div');
        modal.className = 'social-economy-popup-content';
        const titleElement = document.createElement('h2');
        titleElement.textContent = title;
        modal.appendChild(titleElement);
        if (typeof content === 'string') modal.innerHTML += content;
        else modal.appendChild(content);
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'social-economy-popup-buttons';
        const confirmBtn = document.createElement('button');
        confirmBtn.className = 'confirm-btn';
        confirmBtn.textContent = 'Confirm';
        confirmBtn.onclick = ()=>onConfirm?.(modal);
        const cancelBtn = document.createElement('button');
        cancelBtn.className = 'cancel-btn';
        cancelBtn.textContent = 'Cancel';
        cancelBtn.onclick = ()=>{
            this.closeModal();
            onCancel?.();
        };
        buttonContainer.appendChild(confirmBtn);
        buttonContainer.appendChild(cancelBtn);
        modal.appendChild(buttonContainer);
        overlay.appendChild(modal);
        document.body.appendChild(overlay);
        this.activeModal = overlay;
        overlay.addEventListener('click', (e)=>{
            if (e.target === overlay) {
                this.closeModal();
                onCancel?.();
            }
        });
    }
    closeModal() {
        if (this.activeModal) {
            this.activeModal.remove();
            this.activeModal = null;
            // Always restore body scroll when closing modal
            document.body.style.overflow = '';
        }
    }
    showMessage(message, isSuccess = true, autoCloseMs = 5000, keepModalOpen = false) {
        // Close any existing modal first UNLESS keepModalOpen is true
        if (!keepModalOpen) this.closeModal();
        // Create overlay with forced visibility
        const overlay = document.createElement('div');
        overlay.className = 'social-economy-popup-overlay active';
        overlay.dataset.message = message;
        // Force display immediately to prevent CSS timing issues
        overlay.style.display = 'flex';
        overlay.style.position = 'fixed';
        overlay.style.inset = '0';
        overlay.style.zIndex = '10000'; // Higher than modal (9999) so it appears on top
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.85)';
        overlay.style.justifyContent = 'center';
        overlay.style.alignItems = 'center';
        const modal = document.createElement('div');
        modal.className = 'social-economy-popup-content';
        const titleElement = document.createElement('h2');
        titleElement.textContent = isSuccess ? 'Success' : 'Error';
        modal.appendChild(titleElement);
        const content = document.createElement('div');
        content.style.cssText = 'text-align: center; padding: 20px;';
        content.innerHTML = `<p style="font-size: 16px; color: ${isSuccess ? 'rgba(61, 210, 2, 0.9)' : '#ff4444'};">${message}</p>`;
        modal.appendChild(content);
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'social-economy-popup-buttons';
        const closeBtn = document.createElement('button');
        closeBtn.className = 'cancel-btn';
        closeBtn.textContent = 'Close';
        closeBtn.onclick = (e)=>{
            e.stopPropagation();
            e.preventDefault();
            overlay.remove();
        };
        buttonContainer.appendChild(closeBtn);
        modal.appendChild(buttonContainer);
        overlay.appendChild(modal);
        // Ensure DOM is ready and append
        requestAnimationFrame(()=>{
            document.body.appendChild(overlay);
            // Force a reflow to ensure rendering
            overlay.offsetHeight;
        });
        // Auto-close after specified time (default 5000ms = 5 seconds)
        // Pass null or 0 to disable auto-close for important messages
        if (autoCloseMs !== null && autoCloseMs > 0) setTimeout(()=>overlay.remove(), autoCloseMs);
        overlay.addEventListener('click', (e)=>{
            if (e.target === overlay) overlay.remove();
        });
    }
    createPortfolioSelection(portfolios, label) {
        const container = document.createElement('div');
        const labelElement = document.createElement('label');
        labelElement.textContent = label;
        container.appendChild(labelElement);
        const currentId = localStorage.getItem('portfolioId');
        const filtered = portfolios.filter((p)=>p._id !== currentId);
        const select = document.createElement('select');
        select.className = 'portfolio-selector';
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = '-- Select --';
        select.appendChild(defaultOption);
        filtered.forEach((p)=>{
            const option = document.createElement('option');
            option.value = p._id;
            option.dataset.isBot = p.isBot ? 'true' : 'false';
            option.textContent = `${p.name} (${p.wealth || 0})`;
            select.appendChild(option);
        });
        container.appendChild(select);
        return container;
    }
    getSelectedPortfolio(modal) {
        const selector = modal.querySelector('.portfolio-selector');
        if (!selector) return null;
        return selector.tagName === 'SELECT' ? {
            type: 'id',
            value: selector.value
        } : {
            type: 'name',
            value: selector.value.trim()
        };
    }
}
const $d90366524d26acbf$export$78d35f50a4fd5552 = new $d90366524d26acbf$var$SocialEconomyModal();
window.modalManager = $d90366524d26acbf$export$78d35f50a4fd5552;
const $d90366524d26acbf$export$1490a3f595688acf = {};
// === Action Handlers ===
document.addEventListener('DOMContentLoaded', ()=>{
    const token = (0, $21EbS.getAuthToken)();
    // ✅ Helper function for authorized POST
    async function authorizedPost(url, payload) {
        return fetch(`${(0, $cNeIB.apiBaseUrl)}${url}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then((r)=>r.json());
    }
    // === Help Friend (Z$ default, toggle to Capital) ===
    const onHelpFriend = async ()=>{
        const portfolioId = localStorage.getItem('portfolioId');
        const sessionId = localStorage.getItem('sessionId');
        const token = localStorage.getItem('token');
        if (!portfolioId || !sessionId || !token) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.common.error_login_required', 'Please log in first'), false);
        const res = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/active`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: sessionId
            })
        });
        const data = await res.json();
        const portfolios = Array.isArray(data) ? data : data.portfolios || [];
        const contentDiv = document.createElement('div');
        contentDiv.innerHTML = `<p>${(0, $fUPn2.t)('debt_actions.help_friend.intro', 'Give help. Choose <b>Z$</b> or <b>Capital</b> for the gift.')}</p>`;
        // holographic perceived label
        const badgeRow = document.createElement('div');
        badgeRow.style.cssText = 'display:flex;justify-content:flex-end;margin:6px 0 4px;';
        badgeRow.innerHTML = `<span id="help-perceived" style="
        font-family:'bithigh',monospace;color:#fcba03;border:1px solid #fcba03;
        padding:6px 10px;border-radius:8px;background:rgba(0,0,0,.35);
        box-shadow:0 0 6px rgba(252,186,3,.4) inset;">${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${(0, $fUPn2.t)('debt_actions.common.magnitude_none', 'None')}</span>`;
        contentDiv.appendChild(badgeRow);
        const setBadge = (txt)=>contentDiv.querySelector('#help-perceived').textContent = `${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${txt}`;
        // toggle (default zollars)
        const sw = $d90366524d26acbf$var$createModeSwitch('zollars');
        contentDiv.appendChild(sw.el);
        // capital UI
        const capWrap = document.createElement('div');
        capWrap.style.display = 'none';
        capWrap.innerHTML = `
        <label>${(0, $fUPn2.t)('debt_actions.help_friend.capital_label', 'Capital (amount)')}</label>
        <input type="number" class="help-capital" min="1" value="50" placeholder="${(0, $fUPn2.t)('debt_actions.help_friend.capital_placeholder', 'Enter capital')}">`;
        contentDiv.appendChild(capWrap);
        // zollars UI
        const zWrap = document.createElement('div');
        zWrap.id = 'help-zollars-ui';
        zWrap.innerHTML = `<p style="margin:8px 0 0;">${(0, $fUPn2.t)('debt_actions.help_friend.select_zollars', 'Select Z$ categories to gift.')}</p>`;
        contentDiv.appendChild(zWrap);
        // recipient
        const sel = $d90366524d26acbf$export$78d35f50a4fd5552.createPortfolioSelection(portfolios, (0, $fUPn2.t)('debt_actions.help_friend.recipient_label', 'Recipient:'));
        contentDiv.appendChild(sel);
        // helpers
        const clamp01 = (v)=>Math.max(0, Math.min(1, v));
        const perceivedLabelFrom01 = (v)=>$d90366524d26acbf$export$9366fd60be9e5643(clamp01(v));
        const affordabilityProxy01 = (amount, wealthNow = Number(localStorage.getItem('tradingPoints') || 0), near = 0)=>{
            const z = Number(wealthNow) || 0, need = Number(near) || 0;
            const buffer = Math.max(1, z - need);
            return clamp01(Math.log1p(Number(amount) || 0) / Math.log1p(buffer + (Number(amount) || 0)));
        };
        // mount Z$ sliders immediately (default)
        try {
            const zData = await $d90366524d26acbf$var$fetchPortfolioZollars_LOCAL((0, $cNeIB.apiBaseUrl), portfolioId, token);
            const totals = $d90366524d26acbf$var$aggregateZollarsByType_LOCAL(zData);
            zWrap._ZTOTAL = Object.values(totals).reduce((a, b)=>a + (b || 0), 0);
            const comp = $d90366524d26acbf$var$createLocalZollarSliders_LOCAL(totals);
            const slot = document.createElement('div');
            slot.style.marginTop = '8px';
            slot.appendChild(comp.el);
            zWrap.appendChild(slot);
            zWrap._ZCOMP = comp;
            const recomputeZ = ()=>{
                const frac = zWrap._ZTOTAL > 0 ? comp.total() / zWrap._ZTOTAL : 0;
                setBadge(perceivedLabelFrom01(frac));
            };
            slot.addEventListener('mouseup', recomputeZ);
            slot.addEventListener('touchend', recomputeZ, {
                passive: true
            });
            slot.addEventListener('click', recomputeZ);
            setBadge((0, $fUPn2.t)('debt_actions.common.magnitude_hint', 'A Hint')); // gentle default
        } catch (e) {
            console.error('Z$ load failed:', e);
            zWrap.innerHTML = `<p style="color:#ff3333;">${(0, $fUPn2.t)('debt_actions.help_friend.no_zollars', 'No Z$ available.')}</p>`;
            setBadge((0, $fUPn2.t)('debt_actions.common.magnitude_none', 'None'));
        }
        const toCapital = ()=>{
            sw.setActive(sw.cap);
            zWrap.style.display = 'none';
            capWrap.style.display = '';
            const amt = parseFloat(contentDiv.querySelector('.help-capital')?.value) || 0;
            setBadge(perceivedLabelFrom01(affordabilityProxy01(amt)));
        };
        const toZollars = ()=>{
            sw.setActive(sw.zol);
            capWrap.style.display = 'none';
            zWrap.style.display = '';
            const total = zWrap._ZCOMP ? zWrap._ZCOMP.total() : 0;
            const frac = zWrap._ZTOTAL > 0 ? total / zWrap._ZTOTAL : 0;
            setBadge(perceivedLabelFrom01(frac));
        };
        sw.cap.onclick = toCapital;
        sw.zol.onclick = toZollars;
        // live update for capital
        contentDiv.addEventListener('input', (e)=>{
            if (e.target && e.target.classList.contains('help-capital')) {
                const amt = parseFloat(e.target.value) || 0;
                setBadge(perceivedLabelFrom01(affordabilityProxy01(amt)));
            }
        });
        $d90366524d26acbf$export$78d35f50a4fd5552.createModal((0, $fUPn2.t)('debt_actions.help_friend.modal_title', 'Altrau Z Bill (Altruistic Gift)'), contentDiv, async (modal)=>{
            const recipient = $d90366524d26acbf$export$78d35f50a4fd5552.getSelectedPortfolio(modal);
            if (!recipient || !recipient.value) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.help_friend.error_no_recipient', 'Select a recipient.'), false, 3000, true);
            let payload;
            if (capWrap.style.display === '') {
                const points = parseFloat(contentDiv.querySelector('.help-capital').value) || 0;
                if (points <= 0) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.help_friend.error_invalid_capital', 'Enter a valid capital amount.'), false, 3000, true);
                payload = {
                    helperId: portfolioId,
                    targetId: recipient.value,
                    amount: points,
                    package: {
                        points: points,
                        zollars: 0,
                        stocks: 0
                    },
                    sessionId: sessionId,
                    type: 'help'
                };
            } else {
                if (!zWrap._ZCOMP) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.help_friend.error_no_zollars_to_give', 'No Z$ to give.'), false, 3000, true);
                const zBid = zWrap._ZCOMP.getBid(), totalZ = zWrap._ZCOMP.total();
                if (totalZ <= 0) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.help_friend.error_select_zollars', 'Select some Z$ to give.'), false, 3000, true);
                // Validate each zollar type against available holdings
                const availableTotals = $d90366524d26acbf$var$aggregateZollarsByType_LOCAL(await $d90366524d26acbf$var$fetchPortfolioZollars_LOCAL((0, $cNeIB.apiBaseUrl), portfolioId, token));
                for (const [type, count] of Object.entries(zBid)){
                    if (count > (availableTotals[type] || 0)) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.help_friend.error_insufficient_zollars', 'Insufficient {type} zollars. You have {available}, trying to send {count}.').replace('{type}', type).replace('{available}', availableTotals[type] || 0).replace('{count}', count), false, 3000, true);
                }
                payload = {
                    helperId: portfolioId,
                    targetId: recipient.value,
                    amount: totalZ,
                    package: {
                        points: 0,
                        zollars: zBid,
                        stocks: 0
                    },
                    sessionId: sessionId,
                    type: 'help'
                };
            }
            $d90366524d26acbf$export$78d35f50a4fd5552.closeModal();
            await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-economy/help`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.help_friend.success', 'Altrau Z Bill given. Your ledgers are now bound.'), true);
            if (window.emotionalMeter) window.emotionalMeter.fetchData();
        });
    };
    $d90366524d26acbf$export$1490a3f595688acf.helpFriendButton = onHelpFriend;
    document.getElementById('helpFriendButton')?.addEventListener('click', onHelpFriend);
    // === Predatory Lend (CDS) — Z$ default, toggle to Capital, calls /cds ===
    const onPredatoryLend = async ()=>{
        const portfolioId = localStorage.getItem('portfolioId');
        const sessionId = localStorage.getItem('sessionId');
        const token = localStorage.getItem('token');
        if (!portfolioId || !sessionId || !token) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.common.error_login_required', 'Please log in first'), false);
        const res = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/active`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: sessionId
            })
        });
        const data = await res.json();
        const portfolios = Array.isArray(data) ? data : data.portfolios || [];
        const contentDiv = document.createElement('div');
        contentDiv.innerHTML = `
        <p>${(0, $fUPn2.t)('debt_actions.predatory_lend.intro', 'Z-Payday CDO: Offer a compounding loan that reloads every 60 seconds.')}</p>
        <p style="color:#ff4d4d;font-size:.9em;">${(0, $fUPn2.t)('debt_actions.predatory_lend.warning', 'WARNING: Each cycle increases the debt by 15% until repayment or bankruptcy.')}</p>
        <p style="color:#fcba03;font-size:.85em;font-style:italic;">${(0, $fUPn2.t)('debt_actions.predatory_lend.exploitation_note', '(Exploitation disguised as empathic connection.)')}</p>
      `;
        // Add "Target Victim" vs "List on Market" choice
        const targetChoice = document.createElement('div');
        targetChoice.style.cssText = 'margin:12px 0;display:flex;gap:10px;';
        targetChoice.innerHTML = `
        <button class="mode-btn active" id="targetVictimBtn" style="flex:1;padding:10px;background:rgba(255,77,77,.25);border:1px solid #ff4d4d;color:#fff;font-family:'bithigh',monospace;cursor:pointer;border-radius:8px;">Target Specific Victim</button>
        <button class="mode-btn" id="listCDOOnMarketBtn" style="flex:1;padding:10px;background:rgba(0,0,0,.35);border:1px solid rgba(255,255,255,.3);color:#ff4d4d;font-family:'bithigh',monospace;cursor:pointer;border-radius:8px;">List on Market</button>
      `;
        contentDiv.appendChild(targetChoice);
        // perceived label (red-themed)
        const badgeRow = document.createElement('div');
        badgeRow.style.cssText = 'display:flex;justify-content:flex-end;margin:6px 0 4px;';
        badgeRow.innerHTML = `<span id="cds-perceived" style="
        font-family:'bithigh',monospace;color:#ff4d4d;border:1px solid #ff4d4d;
        padding:6px 10px;border-radius:8px;background:rgba(0,0,0,.35);
        box-shadow:0 0 6px rgba(255,77,77,.4) inset;">${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${(0, $fUPn2.t)('debt_actions.common.magnitude_hint', 'A Hint')}</span>`;
        contentDiv.appendChild(badgeRow);
        const setBadge = (txt)=>contentDiv.querySelector('#cds-perceived').textContent = `${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${txt}`;
        // toggle (default zollars)
        const sw = $d90366524d26acbf$var$createModeSwitch('zollars');
        contentDiv.appendChild(sw.el);
        // capital UI
        const capWrap = document.createElement('div');
        capWrap.style.display = 'none';
        capWrap.innerHTML = `
        <label>${(0, $fUPn2.t)('debt_actions.predatory_lend.capital_label', 'Capital (amount to "lend")')}</label>
        <input type="number" class="cds-capital" min="10" value="100" placeholder="${(0, $fUPn2.t)('debt_actions.predatory_lend.capital_placeholder', 'Amount')}">`;
        contentDiv.appendChild(capWrap);
        // zollars UI
        const zWrap = document.createElement('div');
        zWrap.id = 'cds-zollars-ui';
        zWrap.innerHTML = `<p style="margin:8px 0 0;">${(0, $fUPn2.t)('debt_actions.predatory_lend.select_zollars', 'Select Z$ bait for collapse.')}</p>`;
        contentDiv.appendChild(zWrap);
        // Victim selection (only shown when targeting specific victim)
        const victimSelectContainer = document.createElement('div');
        victimSelectContainer.id = 'victimSelectContainer';
        const victimSelect = $d90366524d26acbf$export$78d35f50a4fd5552.createPortfolioSelection(portfolios, (0, $fUPn2.t)('debt_actions.predatory_lend.victim_label', 'Target Victim:'));
        victimSelectContainer.appendChild(victimSelect);
        contentDiv.appendChild(victimSelectContainer);
        // Toggle between target victim and list on market
        let isMarketListing = false;
        const targetVictimBtn = targetChoice.querySelector('#targetVictimBtn');
        const listCDOOnMarketBtn = targetChoice.querySelector('#listCDOOnMarketBtn');
        const showVictimSelect = ()=>{
            isMarketListing = false;
            victimSelectContainer.style.display = '';
            targetVictimBtn.style.background = 'rgba(255,77,77,.25)';
            targetVictimBtn.style.color = '#fff';
            listCDOOnMarketBtn.style.background = 'rgba(0,0,0,.35)';
            listCDOOnMarketBtn.style.color = '#ff4d4d';
        };
        const showMarketListing = ()=>{
            isMarketListing = true;
            victimSelectContainer.style.display = 'none';
            listCDOOnMarketBtn.style.background = 'rgba(255,77,77,.25)';
            listCDOOnMarketBtn.style.color = '#fff';
            targetVictimBtn.style.background = 'rgba(0,0,0,.35)';
            targetVictimBtn.style.color = '#ff4d4d';
        };
        targetVictimBtn.onclick = showVictimSelect;
        listCDOOnMarketBtn.onclick = showMarketListing;
        // helpers
        const clamp01 = (v)=>Math.max(0, Math.min(1, v));
        const perceivedLabelFrom01 = (v)=>$d90366524d26acbf$export$9366fd60be9e5643(clamp01(v));
        const affordabilityProxy01 = (amount, wealthNow = Number(localStorage.getItem('tradingPoints') || 0), near = 0)=>{
            const z = Number(wealthNow) || 0, need = Number(near) || 0;
            const buffer = Math.max(1, z - need);
            return clamp01(Math.log1p(Number(amount) || 0) / Math.log1p(buffer + (Number(amount) || 0)));
        };
        // mount zollar sliders immediately (default)
        try {
            const zData = await $d90366524d26acbf$var$fetchPortfolioZollars_LOCAL((0, $cNeIB.apiBaseUrl), portfolioId, token);
            const totals = $d90366524d26acbf$var$aggregateZollarsByType_LOCAL(zData);
            zWrap._ZTOTAL = Object.values(totals).reduce((a, b)=>a + (b || 0), 0);
            const comp = $d90366524d26acbf$var$createLocalZollarSliders_LOCAL(totals);
            const slot = document.createElement('div');
            slot.style.marginTop = '8px';
            slot.appendChild(comp.el);
            zWrap.appendChild(slot);
            zWrap._ZCOMP = comp;
            const recomputeZ = ()=>{
                const frac = zWrap._ZTOTAL > 0 ? comp.total() / zWrap._ZTOTAL : 0;
                setBadge(perceivedLabelFrom01(Math.min(1, frac * 1.15))); // CDS bias
            };
            slot.addEventListener('mouseup', recomputeZ);
            slot.addEventListener('touchend', recomputeZ, {
                passive: true
            });
            slot.addEventListener('click', recomputeZ);
            setBadge((0, $fUPn2.t)('debt_actions.common.magnitude_hint', 'A Hint'));
        } catch (e) {
            console.error('Z$ load failed:', e);
            zWrap.innerHTML = `<p style="color:#ff3333;">${(0, $fUPn2.t)('debt_actions.predatory_lend.no_zollars', 'No Z$ available.')}</p>`;
            setBadge((0, $fUPn2.t)('debt_actions.common.magnitude_none', 'None'));
        }
        const toCapital = ()=>{
            sw.setActive(sw.cap);
            zWrap.style.display = 'none';
            capWrap.style.display = '';
            const amt = parseFloat(contentDiv.querySelector('.cds-capital')?.value) || 0;
            const v = Math.min(1, affordabilityProxy01(amt) * 1.15); // CDS perceived inflation
            setBadge(perceivedLabelFrom01(v));
        };
        const toZollars = ()=>{
            sw.setActive(sw.zol);
            capWrap.style.display = 'none';
            zWrap.style.display = '';
            const total = zWrap._ZCOMP ? zWrap._ZCOMP.total() : 0;
            const frac = zWrap._ZTOTAL > 0 ? total / zWrap._ZTOTAL : 0;
            setBadge(perceivedLabelFrom01(Math.min(1, frac * 1.15)));
        };
        sw.cap.onclick = toCapital;
        sw.zol.onclick = toZollars;
        // live update for capital
        contentDiv.addEventListener('input', (e)=>{
            if (e.target && e.target.classList.contains('cds-capital')) {
                const amt = parseFloat(e.target.value) || 0;
                setBadge(perceivedLabelFrom01(Math.min(1, affordabilityProxy01(amt) * 1.15)));
            }
        });
        $d90366524d26acbf$export$78d35f50a4fd5552.createModal((0, $fUPn2.t)('debt_actions.predatory_lend.modal_title', 'Z-Payday CDO (Predatory Loan)'), contentDiv, async (modal)=>{
            if (!isMarketListing) {
                // Target specific victim
                const victim = $d90366524d26acbf$export$78d35f50a4fd5552.getSelectedPortfolio(modal);
                if (!victim || !victim.value) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_no_victim', 'Select a victim.'), false, 3000, true);
                let payload;
                if (capWrap.style.display === '') {
                    const amount = parseFloat(contentDiv.querySelector('.cds-capital').value) || 0;
                    if (!amount || amount <= 0) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_invalid_amount', 'Enter a valid amount.'), false, 3000, true);
                    payload = {
                        exploiterId: portfolioId,
                        victimId: victim.value,
                        amount: amount,
                        sessionId: sessionId,
                        package: {
                            points: amount,
                            zollars: 0,
                            stocks: 0
                        }
                    };
                } else {
                    if (!zWrap._ZCOMP) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_no_zollars_selected', 'No Z$ selected.'), false, 3000, true);
                    const zBid = zWrap._ZCOMP.getBid(), totalZ = zWrap._ZCOMP.total();
                    if (totalZ <= 0) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_select_zollars', 'Select some Z$.'), false, 3000, true);
                    payload = {
                        exploiterId: portfolioId,
                        victimId: victim.value,
                        amount: totalZ,
                        sessionId: sessionId,
                        package: {
                            points: 0,
                            zollars: zBid,
                            stocks: 0
                        }
                    };
                }
                $d90366524d26acbf$export$78d35f50a4fd5552.closeModal();
                await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-economy/cds`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
                $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.success_targeted', 'Z-Payday CDO offer sent to victim. Reloads every 60 seconds once accepted.'), true);
            } else {
                // List on market
                let payload;
                if (capWrap.style.display === '') {
                    const amount = parseFloat(contentDiv.querySelector('.cds-capital').value) || 0;
                    if (!amount || amount <= 0) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_invalid_amount', 'Enter a valid amount.'), false, 3000, true);
                    payload = {
                        exploiterId: portfolioId,
                        amount: amount,
                        sessionId: sessionId,
                        package: {
                            points: amount,
                            zollars: 0,
                            stocks: 0
                        },
                        principalType: 'capital'
                    };
                } else {
                    if (!zWrap._ZCOMP) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_no_zollars_selected', 'No Z$ selected.'), false, 3000, true);
                    const zBid = zWrap._ZCOMP.getBid(), totalZ = zWrap._ZCOMP.total();
                    if (totalZ <= 0) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_select_zollars', 'Select some Z$.'), false, 3000, true);
                    payload = {
                        exploiterId: portfolioId,
                        amount: totalZ,
                        sessionId: sessionId,
                        package: {
                            points: 0,
                            zollars: zBid,
                            stocks: 0
                        },
                        principalType: 'zollars',
                        zollarBreakdown: zBid
                    };
                }
                $d90366524d26acbf$export$78d35f50a4fd5552.closeModal();
                await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-economy/market/list-cdo`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
                $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.success_market', 'Z-Payday CDO listed on market. Disguised as attractive offer.'), true);
            }
            if (window.emotionalMeter) window.emotionalMeter.fetchData();
        });
    };
    $d90366524d26acbf$export$1490a3f595688acf.predatoryLendButton = onPredatoryLend;
    document.getElementById('predatoryLendButton')?.addEventListener('click', onPredatoryLend);
    // === Borrow (Z$ default, toggle to Capital) - Borrower initiates M Note ===
    const onBorrowCapital = async ()=>{
        const portfolioId = localStorage.getItem('portfolioId');
        const sessionId = localStorage.getItem('sessionId');
        const token = localStorage.getItem('token');
        if (!portfolioId || !sessionId || !token) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.common.error_login_required', 'Please log in first'), false);
        const res = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/active`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: sessionId
            })
        });
        const data = await res.json();
        const portfolios = Array.isArray(data) ? data : data.portfolios || [];
        const humanInterestMap = {
            Amazing: 0.08,
            Great: 0.12,
            Good: 0.16,
            Neutral: 0.26,
            Bad: 0.35,
            Horrible: 0.45,
            Catastrophic: 0.60
        };
        const contentDiv = document.createElement('div');
        contentDiv.innerHTML = `<p style="font-family:'bithigh',monospace;color:#fcba03;"><strong>${(0, $fUPn2.t)('debt_actions.borrow.intro', 'Request a loan (M Note).')}</strong> ${(0, $fUPn2.t)('debt_actions.borrow.vulnerability_required', 'Disclose your emotional debt. Vulnerability.')}</p>`;
        // M Note: Vulnerability disclosure (required) - FIRST
        const vulnDiv = document.createElement('div');
        vulnDiv.style.cssText = 'margin-top:12px;';
        vulnDiv.innerHTML = `
        <label style="display:block;margin-bottom:4px;font-family:'bithigh',monospace;color:#fcba03;font-size:1.05em;font-weight:bold;">
          ${(0, $fUPn2.t)('debt_actions.borrow.vulnerability_label', 'Why do you need this loan? (Emotional debt disclosure - min 20 chars)')}
        </label>
        <textarea class="vuln-reason" rows="3" placeholder="${(0, $fUPn2.t)('debt_actions.borrow.vulnerability_placeholder', 'Disclose your emotional debt / vulnerability here...')}" style="
          width:100%;padding:8px;font-family:'bithigh',monospace;background:rgba(0,0,0,.3);
          border:1px solid #fcba03;border-radius:6px;color:#fcba03;resize:vertical;
        "></textarea>
        <div style="display:flex;justify-content:space-between;margin-top:4px;">
          <span class="vuln-char-count" style="font-family:'bithigh',monospace;font-size:0.85em;color:#999;">${(0, $fUPn2.t)('debt_actions.borrow.char_count', '0 / 20 chars')}</span>
          <span class="vuln-severity-label" style="font-family:'bithigh',monospace;font-size:0.85em;color:#fcba03;">${(0, $fUPn2.t)('debt_actions.borrow.severity_label', 'Severity')}: ${(0, $fUPn2.t)('debt_actions.common.magnitude_hint', 'A Hint')}</span>
        </div>
        <label style="display:block;margin-top:6px;font-family:'bithigh',monospace;font-size:0.9em;color:#fcba03;">
          ${(0, $fUPn2.t)('debt_actions.borrow.severity_question', 'How severe is your need?')}
        </label>
        <input type="range" class="vuln-severity" min="0" max="100" value="35" style="width:100%;margin-top:4px;">
      `;
        contentDiv.appendChild(vulnDiv);
        const badgeRow = document.createElement('div');
        badgeRow.style.cssText = 'display:flex;justify-content:flex-end;margin:16px 0 4px;';
        badgeRow.innerHTML = `<span id="lend-perceived" style="
        font-family:'bithigh',monospace;color:#fcba03;border:1px solid #fcba03;
        padding:6px 10px;border-radius:8px;background:rgba(0,0,0,.35);
        box-shadow:0 0 6px rgba(252,186,3,.4) inset;">${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${(0, $fUPn2.t)('debt_actions.common.magnitude_none', 'None')}</span>`;
        contentDiv.appendChild(badgeRow);
        const setBadge = (txt)=>contentDiv.querySelector('#lend-perceived').textContent = `${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${txt}`;
        // Abstract sliders section
        const sliderWrap = document.createElement('div');
        sliderWrap.id = 'abstract-loan-sliders';
        sliderWrap.innerHTML = `<p style="margin:12px 0 4px;font-family:'bithigh',monospace;color:#999;font-size:0.9em;">${(0, $fUPn2.t)('debt_actions.borrow.move_sliders', 'Move sliders to express your need:')}</p>`;
        contentDiv.appendChild(sliderWrap);
        // Add "Target Lender" vs "List on Market" choice
        const targetChoice = document.createElement('div');
        targetChoice.style.cssText = 'margin:12px 0;display:flex;gap:10px;';
        targetChoice.innerHTML = `
        <button class="mode-btn active" id="targetLenderBtn" style="flex:1;padding:10px;background:rgba(252,186,3,.25);border:1px solid #fcba03;color:#fff;font-family:'bithigh',monospace;cursor:pointer;border-radius:8px;">Target Specific Lender</button>
        <button class="mode-btn" id="listOnMarketBtn" style="flex:1;padding:10px;background:rgba(0,0,0,.35);border:1px solid rgba(255,255,255,.3);color:#fcba03;font-family:'bithigh',monospace;cursor:pointer;border-radius:8px;">List on Market</button>
      `;
        contentDiv.appendChild(targetChoice);
        // Lender selection (only shown when targeting specific lender)
        const lenderSelectContainer = document.createElement('div');
        lenderSelectContainer.id = 'lenderSelectContainer';
        const lenderSelect = $d90366524d26acbf$export$78d35f50a4fd5552.createPortfolioSelection(portfolios, (0, $fUPn2.t)('debt_actions.borrow.lender_label', 'Choose Lender:'));
        lenderSelectContainer.appendChild(lenderSelect);
        contentDiv.appendChild(lenderSelectContainer);
        // Toggle between target lender and list on market
        let isMarketListing = false;
        const targetLenderBtn = targetChoice.querySelector('#targetLenderBtn');
        const listOnMarketBtn = targetChoice.querySelector('#listOnMarketBtn');
        const showLenderSelect = ()=>{
            isMarketListing = false;
            lenderSelectContainer.style.display = '';
            targetLenderBtn.style.background = 'rgba(252,186,3,.25)';
            targetLenderBtn.style.color = '#fff';
            listOnMarketBtn.style.background = 'rgba(0,0,0,.35)';
            listOnMarketBtn.style.color = '#fcba03';
        };
        const showMarketListing = ()=>{
            isMarketListing = true;
            lenderSelectContainer.style.display = 'none';
            listOnMarketBtn.style.background = 'rgba(252,186,3,.25)';
            listOnMarketBtn.style.color = '#fff';
            targetLenderBtn.style.background = 'rgba(0,0,0,.35)';
            targetLenderBtn.style.color = '#fcba03';
        };
        targetLenderBtn.onclick = showLenderSelect;
        listOnMarketBtn.onclick = showMarketListing;
        // Update char count and severity label
        const vulnTextarea = vulnDiv.querySelector('.vuln-reason');
        const charCount = vulnDiv.querySelector('.vuln-char-count');
        const severitySlider = vulnDiv.querySelector('.vuln-severity');
        const severityLabel = vulnDiv.querySelector('.vuln-severity-label');
        vulnTextarea.addEventListener('input', ()=>{
            const len = vulnTextarea.value.length;
            charCount.textContent = `${len} ${(0, $fUPn2.t)('debt_actions.borrow.char_suffix', '/ 20 chars')}`;
            charCount.style.color = len >= 20 ? '#3dd202' : '#ff3333';
        });
        severitySlider.addEventListener('input', ()=>{
            const severity01 = Number(severitySlider.value) / 100;
            severityLabel.textContent = `${(0, $fUPn2.t)('debt_actions.borrow.severity_label', 'Severity')}: ${perceivedLabelFrom01(severity01)}`;
        });
        const clamp01 = (v)=>Math.max(0, Math.min(1, v));
        const perceivedLabelFrom01 = (v)=>$d90366524d26acbf$export$9366fd60be9e5643(clamp01(v));
        const affordabilityProxy01 = (amount, wealthNow = Number(localStorage.getItem('tradingPoints') || 0), near = 0)=>{
            const z = Number(wealthNow) || 0, need = Number(near) || 0;
            const buffer = Math.max(1, z - need);
            return clamp01(Math.log1p(Number(amount) || 0) / Math.log1p(buffer + (Number(amount) || 0)));
        };
        // Mount abstract sliders
        const sliderComp = $d90366524d26acbf$var$createAbstractBorrowSliders_LOCAL();
        sliderWrap.appendChild(sliderComp.el);
        // Update badge when sliders change
        const updateBadge = ()=>{
            const zMag = sliderComp.getZollarMagnitude();
            const cMag = sliderComp.getCapitalMagnitude();
            const maxMag = Math.max(zMag, cMag);
            const frac = maxMag / 100;
            setBadge(perceivedLabelFrom01(frac));
        };
        sliderWrap.addEventListener('input', updateBadge);
        setBadge((0, $fUPn2.t)('debt_actions.common.magnitude_none', 'None'));
        $d90366524d26acbf$export$78d35f50a4fd5552.createModal((0, $fUPn2.t)('debt_actions.borrow.modal_title', 'M Note (Request Loan)'), contentDiv, async (modal)=>{
            // Validate vulnerability disclosure
            const vulnerabilityReason = vulnTextarea.value.trim();
            if (vulnerabilityReason.length < 20) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.borrow.error_vulnerability_required', 'M Note requires vulnerability disclosure (min 20 characters).'), false, 3000, true);
            const vulnerabilityScore = Number(severitySlider.value) / 100;
            // Get abstract slider values
            const zollarMag = sliderComp.getZollarMagnitude();
            const capitalMag = sliderComp.getCapitalMagnitude();
            if (!sliderComp.hasSelection()) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.borrow.error_move_slider', 'Please move at least one slider to express your need.'), false, 3000, true);
            // Determine principal type and calculate actual amounts
            let principalType, packageData, totalAmount;
            if (zollarMag > capitalMag) {
                // Zollar-based loan
                principalType = 'zollars';
                const zollarCount = Math.max(1, Math.floor(zollarMag / 10)); // 0-100 → 1-10 zollars
                // Create a generic zollar breakdown (will use borrower's actual zollars)
                // Backend will handle the actual transfer from borrower's holdings
                packageData = {
                    points: 0,
                    zollars: {
                        _abstract: true,
                        _count: zollarCount,
                        _magnitude: zollarMag
                    },
                    stocks: 0
                };
                totalAmount = zollarCount * 50; // Estimate value
            } else {
                // Capital-based loan
                principalType = 'capital';
                const capitalAmount = Math.max(1, Math.floor(capitalMag * 10)); // 0-100 → 1-1000 capital
                packageData = {
                    points: capitalAmount,
                    zollars: 0,
                    stocks: 0
                };
                totalAmount = capitalAmount;
            }
            // Emotional interest scales with perceived need
            const needIntensity = Math.max(zollarMag, capitalMag) / 100;
            const baseRate = 0.16 + needIntensity * 0.24; // 16% to 40% based on need
            // Check if targeting lender or listing on market
            if (!isMarketListing) {
                // Target specific lender
                const lender = $d90366524d26acbf$export$78d35f50a4fd5552.getSelectedPortfolio(modal);
                if (!lender || !lender.value) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.borrow.error_no_lender', 'Please select a lender.'), false, 3000, true);
                const payload = {
                    borrowerId: portfolioId,
                    lenderId: lender.value,
                    amount: totalAmount,
                    principalType: principalType,
                    humanInterest: baseRate,
                    package: packageData,
                    sessionId: sessionId,
                    type: 'loan',
                    vulnerabilityReason: vulnerabilityReason,
                    vulnerabilityScore: vulnerabilityScore,
                    abstractRequest: {
                        zollarMagnitude: zollarMag,
                        capitalMagnitude: capitalMag
                    }
                };
                $d90366524d26acbf$export$78d35f50a4fd5552.closeModal();
                await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-economy/lend`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
                $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.borrow.success_targeted', 'M Note loan request sent to lender.'), true);
            } else {
                // List on market
                const payload = {
                    borrowerId: portfolioId,
                    amount: totalAmount,
                    principalType: principalType,
                    humanInterest: baseRate,
                    package: packageData,
                    vulnerabilityReason: vulnerabilityReason,
                    vulnerabilityScore: vulnerabilityScore,
                    sessionId: sessionId,
                    abstractRequest: {
                        zollarMagnitude: zollarMag,
                        capitalMagnitude: capitalMag
                    }
                };
                $d90366524d26acbf$export$78d35f50a4fd5552.closeModal();
                await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-economy/market/list-mnote`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
                $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.borrow.success_market', 'M Note listed on market for lenders to purchase.'), true);
            }
            if (window.emotionalMeter) window.emotionalMeter.fetchData();
        });
    };
    $d90366524d26acbf$export$1490a3f595688acf.borrowCapitalButton = onBorrowCapital;
    document.getElementById('borrowCapitalButton')?.addEventListener('click', onBorrowCapital);
    // === Request Aid (V Note) - Target specific user with vulnerability request ===
    const onRequestHandout = async ()=>{
        const portfolioId = localStorage.getItem('portfolioId');
        const sessionId = localStorage.getItem('sessionId');
        const token = localStorage.getItem('token');
        if (!portfolioId || !sessionId || !token) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.common.error_login_required', 'Please log in first'), false);
        // Fetch active portfolios
        const res = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/active`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: sessionId
            })
        });
        const data = await res.json();
        const portfolios = Array.isArray(data) ? data : data.portfolios || [];
        const clamp01 = (v)=>Math.max(0, Math.min(1, v));
        const perceivedLabelFrom01 = (v)=>$d90366524d26acbf$export$9366fd60be9e5643(clamp01(v));
        const contentDiv = document.createElement('div');
        contentDiv.innerHTML = `
        <p><strong>${(0, $fUPn2.t)('debt_actions.request_aid.intro', 'Request aid (V Note).')}</strong> ${(0, $fUPn2.t)('debt_actions.request_aid.description', 'Ask someone for a handout by sharing your vulnerability.')}</p>
        <p style="font-size:0.9em;color:#fcba03;">${(0, $fUPn2.t)('debt_actions.request_aid.accept_decline_note', 'They can accept or decline your request.')}</p>
      `;
        // Vulnerability disclosure FIRST - most important
        const justDiv = document.createElement('div');
        justDiv.style.cssText = 'margin-top:12px;';
        justDiv.innerHTML = `
        <label style="font-family:'bithigh',monospace;color:#fcba03;font-size:1.05em;font-weight:bold;">${(0, $fUPn2.t)('debt_actions.request_aid.vulnerability_label', 'Explain why you need aid (vulnerability disclosure - min 20 chars)')}</label>
        <textarea class="handout-just" rows="4" placeholder="${(0, $fUPn2.t)('debt_actions.request_aid.vulnerability_placeholder', 'Share your vulnerability...')}" style="
          width:100%;padding:8px;font-family:'bithigh',monospace;background:rgba(0,0,0,.3);
          border:1px solid #fcba03;border-radius:6px;color:#fcba03;resize:vertical;
        "></textarea>
        <div style="margin-top:10px;">
          <label style="font-family:'bithigh',monospace;color:#fcba03;">${(0, $fUPn2.t)('debt_actions.request_aid.severity_question', 'Situation severity (how urgent is this)')}</label>
          <input type="range" class="handout-severity" min="0" max="100" value="35" style="width:100%;">
          <div style="display:flex;justify-content:flex-end;">
            <span id="handout-perceived-label" style="
              margin-top:6px;font-family:'bithigh',monospace;color:#fcba03;border:1px solid #fcba03;
              padding:6px 10px;border-radius:8px;background:rgba(0,0,0,.35);
              box-shadow:0 0 6px rgba(252,186,3,.4) inset;">${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${(0, $fUPn2.t)('debt_actions.common.magnitude_hint', 'A Hint')}</span>
          </div>
        </div>
      `;
        contentDiv.appendChild(justDiv);
        // Target selection - comes after vulnerability disclosure
        const targetSelect = $d90366524d26acbf$export$78d35f50a4fd5552.createPortfolioSelection(portfolios, (0, $fUPn2.t)('debt_actions.request_aid.target_label', 'Request aid from:'));
        contentDiv.appendChild(targetSelect);
        const sev = contentDiv.querySelector('.handout-severity');
        const badge = contentDiv.querySelector('#handout-perceived-label');
        const recompute = ()=>badge.textContent = `${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${perceivedLabelFrom01((Number(sev.value) || 0) / 100)}`;
        setTimeout(recompute, 0);
        contentDiv.addEventListener('input', (e)=>{
            if (e.target === sev) recompute();
        });
        $d90366524d26acbf$export$78d35f50a4fd5552.createModal((0, $fUPn2.t)('debt_actions.request_aid.modal_title', 'V Note (Request Aid)'), contentDiv, async (modal)=>{
            // Validate target
            const target = $d90366524d26acbf$export$78d35f50a4fd5552.getSelectedPortfolio(modal);
            if (!target || !target.value) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.request_aid.error_no_target', 'Please select who to request aid from.'), false, 3000, true);
            // Validate vulnerability disclosure
            const justification = contentDiv.querySelector('.handout-just').value.trim();
            if (justification.length < 20) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.request_aid.error_vulnerability_required', 'V Note requires vulnerability disclosure (min 20 characters).'), false, 3000, true);
            const severity01 = (Number(sev.value) || 0) / 100;
            $d90366524d26acbf$export$78d35f50a4fd5552.closeModal();
            const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-economy/vnote`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    requesterId: portfolioId,
                    targetId: target.value,
                    justification: justification,
                    vulnerabilityScore: severity01,
                    sessionId: sessionId
                })
            });
            const result = await response.json();
            $d90366524d26acbf$export$78d35f50a4fd5552.showMessage(result.message || (0, $fUPn2.t)('debt_actions.request_aid.success', 'V Note request sent. Awaiting response.'), result.success !== false);
            if (window.emotionalMeter) window.emotionalMeter.fetchData();
        });
    };
    $d90366524d26acbf$export$1490a3f595688acf.requestHandoutButton = onRequestHandout;
    document.getElementById('requestHandoutButton')?.addEventListener('click', onRequestHandout);
});
function $d90366524d26acbf$export$df02e6407caad277({ title: title, message: message }) {
    if (typeof showPopup === 'function') showPopup(title, message, {
        theme: 'danger'
    });
    if (typeof showNotification === 'function') showNotification('You lost assets in a CDS collapse.', false);
    if (window.emotionalMeter) window.emotionalMeter.fetchData();
}
function $d90366524d26acbf$export$ce26b1f430b884de({ title: title, message: message }) {
    if (typeof showPopup === 'function') showPopup(title, message, {
        theme: 'warning'
    });
    setTimeout(()=>{
        if (typeof showNotification === 'function') showNotification('You profited, but your victim has fallen into debt.', true);
    }, 12000);
    if (window.emotionalMeter) window.emotionalMeter.fetchData();
}
function $d90366524d26acbf$export$e136fdf6cbbbf403({ title: title, message: message }) {
    if (typeof showNotification === 'function') showNotification(message || 'Predatory loan initiated.', true);
}
// expose to global (optional)
window.modalManager = $d90366524d26acbf$export$78d35f50a4fd5552;
window.handleCDSVictimCollapse = $d90366524d26acbf$export$df02e6407caad277;
window.handleCDSExploiterGuilt = $d90366524d26acbf$export$ce26b1f430b884de;
window.handleCDSInitiation = $d90366524d26acbf$export$e136fdf6cbbbf403;

});

parcelRegister("epcPG", function(module, exports) {

$parcel$export(module.exports, "showHoloModal", () => $a7cd5ac15d74341a$export$3316965de6cf85a5);
$parcel$export(module.exports, "showHoloConfirm", () => $a7cd5ac15d74341a$export$ea7f61922f616639);
$parcel$export(module.exports, "holoNotify", () => $a7cd5ac15d74341a$export$b7d5dd0847a5d722);
// frontend/js/holoModal.js
// Holographic modal system for Emotional Debt notifications
let $a7cd5ac15d74341a$var$_lockScrollY = 0;
function $a7cd5ac15d74341a$var$getLockCount() {
    return Number(document.body.dataset.holoLockCount || 0);
}
function $a7cd5ac15d74341a$var$setLockCount(n) {
    document.body.dataset.holoLockCount = String(n);
}
function $a7cd5ac15d74341a$var$lockScrollIfNeeded() {
    const count = $a7cd5ac15d74341a$var$getLockCount();
    if (count === 0) {
        $a7cd5ac15d74341a$var$_lockScrollY = window.scrollY || window.pageYOffset || 0;
        const inline = document.body.style.overflow;
        document.body.dataset.holoPrevOverflow = inline || '';
        // iOS-friendly lock: fix body in place
        document.body.style.position = 'fixed';
        document.body.style.top = `-${$a7cd5ac15d74341a$var$_lockScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
    }
    $a7cd5ac15d74341a$var$setLockCount(count + 1);
}
function $a7cd5ac15d74341a$var$unlockScrollIfNeeded() {
    const count = $a7cd5ac15d74341a$var$getLockCount();
    const next = Math.max(0, count - 1);
    $a7cd5ac15d74341a$var$setLockCount(next);
    if (next === 0) {
        const prev = document.body.dataset.holoPrevOverflow || '';
        // Restore before scrolling back
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        document.body.style.overflow = prev;
        window.scrollTo(0, $a7cd5ac15d74341a$var$_lockScrollY);
        delete document.body.dataset.holoPrevOverflow;
    }
}
function $a7cd5ac15d74341a$export$3316965de6cf85a5({ title: title = 'Notification', message: message = '', type: type = 'success', buttons: buttons = null, autoClose: autoClose = true }) {
    // If one exists, we’re replacing it; don’t double-lock
    const existing = document.querySelector('.holo-modal-overlay');
    const replacingExisting = !!existing;
    if (existing) existing.remove();
    // Create overlay
    const overlay = document.createElement('div');
    overlay.className = 'holo-modal-overlay';
    overlay.style.overflow = 'hidden'; // modal body will handle scrolling
    // Create modal
    const modal = document.createElement('div');
    modal.className = `holo-modal holo-${type}`;
    // Accessibility
    overlay.setAttribute('role', 'presentation');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', title);
    // Modal content
    const content = document.createElement('div');
    content.className = 'holo-modal-content';
    // Header
    const header = document.createElement('div');
    header.className = 'holo-modal-header';
    const titleEl = document.createElement('h3');
    titleEl.className = 'holo-modal-title';
    titleEl.textContent = title;
    header.appendChild(titleEl);
    // Body
    const body = document.createElement('div');
    body.className = 'holo-modal-body';
    body.innerHTML = message;
    // Footer with buttons
    const footer = document.createElement('div');
    footer.className = 'holo-modal-footer';
    if (buttons && buttons.length > 0) buttons.forEach((btn)=>{
        const button = document.createElement('button');
        button.className = `holo-btn ${btn.type ? 'holo-btn-' + btn.type : ''}`;
        button.textContent = btn.text || 'OK';
        button.onclick = (e)=>{
            e.stopPropagation();
            if (btn.onClick) btn.onClick();
            closeModal();
        };
        footer.appendChild(button);
    });
    else {
        const okBtn = document.createElement('button');
        okBtn.className = 'holo-btn holo-btn-primary';
        okBtn.textContent = 'OK';
        okBtn.onclick = (e)=>{
            e.stopPropagation();
            closeModal();
        };
        footer.appendChild(okBtn);
    }
    // Assemble
    content.appendChild(header);
    content.appendChild(body);
    content.appendChild(footer);
    modal.appendChild(content);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    // Generate unique ID for tracking
    const modalId = `holoModal_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    overlay.id = modalId;
    // Track popup state for bot interaction management
    if (window.popupTracker && !replacingExisting) window.popupTracker.trackElement(overlay, 'holo-modal');
    // Scroll lock: only lock if we weren't replacing an existing modal
    if (!replacingExisting) $a7cd5ac15d74341a$var$lockScrollIfNeeded();
    // Close on overlay click (but not on internal clicks)
    overlay.onclick = (e)=>{
        if (e.target === overlay) {
            e.stopPropagation();
            closeModal();
        }
    };
    // Prevent scroll chaining on overlay (swipes should stay in the body scroller)
    overlay.addEventListener('touchmove', (e)=>{
        const scroller = e.target.closest('.holo-modal-body');
        if (!scroller) e.preventDefault();
    }, {
        passive: false
    });
    // Auto-close
    if (autoClose && !buttons) setTimeout(closeModal, 5000);
    let isClosing = false;
    function closeModal() {
        if (isClosing) return;
        isClosing = true;
        // Untrack popup before removing
        if (window.popupTracker && overlay.id) window.popupTracker.unregisterPopup(overlay.id);
        overlay.style.animation = 'holo-fade-in 0.2s ease reverse';
        setTimeout(()=>{
            if (overlay.parentNode) overlay.remove();
            // Unlock scroll if no more overlays remain
            const remaining = document.querySelectorAll('.holo-modal-overlay').length;
            if (remaining === 0) $a7cd5ac15d74341a$var$unlockScrollIfNeeded();
        }, 200);
    }
    return {
        overlay: overlay,
        modal: modal,
        closeModal: closeModal
    };
}
function $a7cd5ac15d74341a$export$ea7f61922f616639({ title: title = 'Confirm', message: message = '', type: type = 'warning', onAccept: onAccept = ()=>{}, onDecline: onDecline = ()=>{}, acceptText: acceptText = 'Accept', declineText: declineText = 'Decline' }) {
    return $a7cd5ac15d74341a$export$3316965de6cf85a5({
        title: title,
        message: message,
        type: type,
        autoClose: false,
        buttons: [
            {
                text: declineText,
                type: 'danger',
                onClick: onDecline
            },
            {
                text: acceptText,
                type: 'primary',
                onClick: onAccept
            }
        ]
    });
}
function $a7cd5ac15d74341a$export$b7d5dd0847a5d722(message, type = 'success') {
    return $a7cd5ac15d74341a$export$3316965de6cf85a5({
        title: type === 'success' ? 'Success' : type === 'danger' ? 'Error' : 'Notice',
        message: message,
        type: type,
        autoClose: true
    });
}
var $a7cd5ac15d74341a$export$2e2bcd8739ae039 = {
    showHoloModal: $a7cd5ac15d74341a$export$3316965de6cf85a5,
    showHoloConfirm: $a7cd5ac15d74341a$export$ea7f61922f616639,
    holoNotify: $a7cd5ac15d74341a$export$b7d5dd0847a5d722
};

});

parcelRegister("lfdrK", function(module, exports) {

$parcel$export(module.exports, "registerDebtPopupHandlers", () => $f7756de821ba796a$export$b48f3c974c7de4d3);
/**
 * Debt Instrument Popup Handlers
 *
 * This module contains all the popup/modal logic for debt instruments:
 * - Altrau Z Bills
 * - M Notes
 * - Z-Payday CDOs
 * - V Notes
 * - Generic debt notifications
 */ 
var $epcPG = parcelRequire("epcPG");

var $iD9HX = parcelRequire("iD9HX");

var $fUPn2 = parcelRequire("fUPn2");
/**
 * Helper function to get qualitative label from fraction
 */ const $f7756de821ba796a$var$qLabel = (num, denom = 100)=>{
    const n = Number(num) || 0;
    const d = Math.max(1, Number(denom) || 100);
    return (0, $iD9HX.qualitativeFromFraction_LOCAL)(Math.max(0, Math.min(1, n / d)));
};
/**
 * Helper to get descriptive amount for M Notes
 */ const $f7756de821ba796a$var$getDescriptiveAmount = (amt)=>{
    if (!amt || amt <= 0) return (0, $fUPn2.t)('debt.amounts.none', 'None');
    if (amt <= 1) return (0, $fUPn2.t)('debt.amounts.barelyAny', 'Barely Any');
    if (amt <= 2) return (0, $fUPn2.t)('debt.amounts.aTrace', 'A Trace');
    if (amt <= 3) return (0, $fUPn2.t)('debt.amounts.aHint', 'A Hint');
    if (amt <= 5) return (0, $fUPn2.t)('debt.amounts.aLittle', 'A Little');
    if (amt <= 8) return (0, $fUPn2.t)('debt.amounts.aFew', 'A Few');
    if (amt <= 12) return (0, $fUPn2.t)('debt.amounts.some', 'Some');
    if (amt <= 18) return (0, $fUPn2.t)('debt.amounts.several', 'Several');
    if (amt <= 25) return (0, $fUPn2.t)('debt.amounts.moderate', 'Moderate');
    if (amt <= 35) return (0, $fUPn2.t)('debt.amounts.noticeable', 'Noticeable');
    if (amt <= 45) return (0, $fUPn2.t)('debt.amounts.considerable', 'Considerable');
    if (amt <= 60) return (0, $fUPn2.t)('debt.amounts.many', 'Many');
    if (amt <= 80) return (0, $fUPn2.t)('debt.amounts.aLot', 'A Lot');
    if (amt <= 100) return (0, $fUPn2.t)('debt.amounts.abundant', 'Abundant');
    if (amt <= 150) return (0, $fUPn2.t)('debt.amounts.heaps', 'Heaps');
    if (amt <= 200) return (0, $fUPn2.t)('debt.amounts.aGreatDeal', 'A Great Deal');
    if (amt <= 300) return (0, $fUPn2.t)('debt.amounts.substantial', 'Substantial');
    return (0, $fUPn2.t)('debt.amounts.immense', 'Immense');
};
/**
 * Helper to get descriptive interest rate for M Notes
 */ const $f7756de821ba796a$var$getDescriptiveInterest = (rate)=>{
    const pct = rate * 100;
    if (pct <= 5) return (0, $fUPn2.t)('debt.interest.minimal', 'Minimal Emotional Interest');
    if (pct <= 10) return (0, $fUPn2.t)('debt.interest.light', 'Light Emotional Interest');
    if (pct <= 15) return (0, $fUPn2.t)('debt.interest.modest', 'Modest Emotional Interest');
    if (pct <= 20) return (0, $fUPn2.t)('debt.interest.fair', 'Fair Emotional Interest');
    if (pct <= 25) return (0, $fUPn2.t)('debt.interest.moderate', 'Moderate Emotional Interest');
    if (pct <= 30) return (0, $fUPn2.t)('debt.interest.notable', 'Notable Emotional Interest');
    if (pct <= 35) return (0, $fUPn2.t)('debt.interest.considerable', 'Considerable Emotional Interest');
    if (pct <= 40) return (0, $fUPn2.t)('debt.interest.heavy', 'Heavy Emotional Interest');
    if (pct <= 50) return (0, $fUPn2.t)('debt.interest.intense', 'Intense Emotional Interest');
    return (0, $fUPn2.t)('debt.interest.crushing', 'Crushing Emotional Interest');
};
/**
 * Helper to get descriptive amount for V Notes
 */ const $f7756de821ba796a$var$getDescriptiveAmountVNote = (amt)=>{
    if (!amt || amt <= 0) return (0, $fUPn2.t)('debt.amounts.none', 'None');
    if (amt <= 10) return (0, $fUPn2.t)('debt.amounts.aHint', 'A Hint');
    if (amt <= 30) return (0, $fUPn2.t)('debt.amounts.aFew', 'A Few');
    if (amt <= 60) return (0, $fUPn2.t)('debt.amounts.some', 'Some');
    if (amt <= 100) return (0, $fUPn2.t)('debt.amounts.several', 'Several');
    if (amt <= 150) return (0, $fUPn2.t)('debt.amounts.noticeable', 'Noticeable');
    if (amt <= 200) return (0, $fUPn2.t)('debt.amounts.considerable', 'Considerable');
    return (0, $fUPn2.t)('debt.amounts.many', 'Many');
};
/**
 * Helper to format numbers for CDO display
 */ const $f7756de821ba796a$var$fmtNum = (n)=>{
    const v = Number(n);
    return Number.isFinite(v) ? v.toLocaleString() : String(n ?? '');
};
/**
 * Helper to resolve zollar count for CDO
 */ const $f7756de821ba796a$var$resolveZCount = (raw)=>{
    if (Array.isArray(raw)) return raw.length;
    if (typeof raw === 'object' && raw !== null) return Object.values(raw).reduce((a, b)=>a + (Number(b) || 0), 0);
    return Number(raw);
};
/**
 * Refreshes the emotional debt meter if available
 */ const $f7756de821ba796a$var$refreshEmotionalMeter = ()=>{
    if (window.emotionalMeter) window.emotionalMeter.fetchData();
};
/**
 * Refreshes portfolio data if the function is available
 */ const $f7756de821ba796a$var$refreshPortfolioData = ()=>{
    if (typeof loadPortfolioData === 'function') loadPortfolioData();
};
function $f7756de821ba796a$export$eb5a9d2428dab8a7(data) {
    console.log('Z Bill Altrau Received:', data);
    const { from: from, amount: amount, type: type, instrumentId: instrumentId, perceivedLabel: perceivedLabel, zollarBreakdown: zollarBreakdown } = data;
    // Prefer the backend's qualitative label, otherwise generate one
    let label = perceivedLabel;
    if (!label) {
        if (type === 'zollars') label = $f7756de821ba796a$var$qLabel(amount, 100);
        else if (type === 'capital' || type === 'points') label = $f7756de821ba796a$var$qLabel(amount, 1000);
    }
    const unitText = type === 'zollars' ? "\u01B5" : (0, $fUPn2.t)('debt.capital', 'capital');
    const giftText = label ? `${label} ${unitText}` : `${amount} ${type}`;
    (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.altrau.receivedTitle', 'Z Bill Altrau Received'),
        message: `<p><strong>${from}</strong> ${(0, $fUPn2.t)('debt.altrau.hasGivenYou', 'has given you')} <strong>${giftText}</strong>.</p>
              <p>${(0, $fUPn2.t)('debt.altrau.ledgersBound', 'Your ledgers are now bound. Their Life Profit affects yours.')}</p>`,
        type: 'success'
    });
    $f7756de821ba796a$var$refreshEmotionalMeter();
}
function $f7756de821ba796a$export$55738db6221cc039(data) {
    console.log('Z Bill Altrau issued:', data);
    const { to: to, amount: amount, type: type, perceivedLabel: perceivedLabel } = data;
    const normType = (type || '').toLowerCase();
    let label = perceivedLabel;
    if (!label) {
        if (normType === 'zollars') label = $f7756de821ba796a$var$qLabel(amount, 100);
        else if (normType === 'capital' || normType === 'points') label = $f7756de821ba796a$var$qLabel(amount, 1000);
        else // fallback: treat unknown as capital scale
        label = $f7756de821ba796a$var$qLabel(amount, 1000);
    }
    const unitText = normType === 'zollars' ? "\u01B5" : (0, $fUPn2.t)('debt.capital', 'capital');
    const giftText = `${label} ${unitText}`;
    (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.altrau.issuedTitle', 'Z Bill Altrau Issued'),
        message: `<p>${(0, $fUPn2.t)('debt.altrau.youHaveSent', 'You have sent')} <strong>${giftText}</strong> ${(0, $fUPn2.t)('debt.altrau.toRecipient', 'to')} <strong>${to}</strong>.</p>
              <p>${(0, $fUPn2.t)('debt.altrau.fatesBound', 'Your fates are now bound. Your Life Profit affects theirs.')}</p>`,
        type: 'success'
    });
    $f7756de821ba796a$var$refreshEmotionalMeter();
}
function $f7756de821ba796a$export$22034bdd75d488d8(data) {
    console.log("\uD83D\uDCAD [Frontend] ========================================");
    console.log("\uD83D\uDCAD [Frontend] M Note created event received!");
    console.log("\uD83D\uDCAD [Frontend] Data:", JSON.stringify(data, null, 2));
    const { role: role, from: from, to: to, amount: amount, interestRate: interestRate, instrumentId: instrumentId, message: message } = data;
    const title = role === 'borrower' ? (0, $fUPn2.t)('debt.mnote.acceptedTitle', 'M Note Accepted') : (0, $fUPn2.t)('debt.mnote.createdTitle', 'M Note Created');
    console.log("\uD83D\uDCAD [Frontend] Title:", title);
    console.log("\uD83D\uDCAD [Frontend] Role:", role);
    const msg = role === 'borrower' ? `<p><strong>${from}</strong> ${(0, $fUPn2.t)('debt.mnote.witnessedVulnerability', 'has witnessed your vulnerability')}.</p><p>${(0, $fUPn2.t)('debt.mnote.loanLabel', 'Loan')}: <strong>${$f7756de821ba796a$var$getDescriptiveAmount(amount)}</strong> ${(0, $fUPn2.t)('debt.mnote.atRate', 'at')} <strong>${$f7756de821ba796a$var$getDescriptiveInterest(interestRate || 0.26)}</strong>.</p><p style="font-size:0.9em;color:#3dd202;margin-top:8px;">\u{1F4A1} ${(0, $fUPn2.t)('debt.mnote.positiveTradeTip', 'Make positive trades to automatically reduce this debt!')}</p>` : `<p>${(0, $fUPn2.t)('debt.mnote.createdWith', 'M Note created with')} <strong>${to}</strong>.</p><p>${(0, $fUPn2.t)('debt.mnote.tradeableAfter', 'Tradeable after 5 exchanges. Convertible after max trades.')}</p>`;
    console.log("\uD83D\uDCAD [Frontend] Message HTML:", msg);
    console.log("\uD83D\uDCAD [Frontend] showHoloModal defined?", typeof (0, $epcPG.showHoloModal) === 'function');
    console.log("\uD83D\uDCAD [Frontend] Calling showHoloModal...");
    (0, $epcPG.showHoloModal)({
        title: title,
        message: msg,
        type: 'success'
    });
    console.log("\uD83D\uDCAD [Frontend] showHoloModal called successfully");
    $f7756de821ba796a$var$refreshEmotionalMeter();
    console.log("\uD83D\uDCAD [Frontend] ========================================");
}
function $f7756de821ba796a$export$60e5f18fbf40fa1(data) {
    console.log("\uD83D\uDCCA M Note progress:", data);
    const { milestone: milestone, percentRepaid: percentRepaid, remainingAmount: remainingAmount, message: message } = data;
    (0, $epcPG.holoNotify)(`<p><strong>${(0, $fUPn2.t)('debt.mnote.progressTitle', 'M Note Repayment Progress')}</strong></p>
     <p>${(0, $fUPn2.t)('debt.mnote.repaidPercent', "You've repaid")} <strong>${milestone}%</strong> ${(0, $fUPn2.t)('debt.mnote.throughTrading', 'through positive trading')}!</p>
     <p style="font-size:0.9em;color:#999;">${(0, $fUPn2.t)('debt.mnote.keepTrading', 'Keep trading well to continue reducing your debt.')}</p>`, 'success');
    $f7756de821ba796a$var$refreshPortfolioData();
}
function $f7756de821ba796a$export$e811bb0d4bb84631(data) {
    console.log("\u2705 M Note repaid:", data);
    const { role: role, instrumentId: instrumentId, borrowerName: borrowerName, lenderName: lenderName, message: message, repaymentMethod: repaymentMethod } = data;
    const title = role === 'borrower' ? (0, $fUPn2.t)('debt.mnote.debtClearedTitle', 'Debt Cleared!') : (0, $fUPn2.t)('debt.mnote.repaidTitle', 'M Note Repaid');
    const repaymentMethodText = repaymentMethod === 'trading' ? (0, $fUPn2.t)('debt.mnote.positiveTrading', 'positive trading') : (0, $fUPn2.t)('debt.mnote.directRepayment', 'direct repayment');
    const msg = role === 'borrower' ? `<p>\u{1F389} ${(0, $fUPn2.t)('debt.mnote.fullyRepaidTo', "You've fully repaid your M Note to")} <strong>${lenderName}</strong> ${(0, $fUPn2.t)('debt.mnote.throughMethod', 'through')} ${repaymentMethodText}!</p><p>${(0, $fUPn2.t)('debt.mnote.emotionalDebtCleared', 'Your emotional debt is cleared. Well done!')}</p>` : `<p><strong>${borrowerName}</strong> ${(0, $fUPn2.t)('debt.mnote.hasFullyRepaid', 'has fully repaid their M Note')} ${(0, $fUPn2.t)('debt.mnote.throughMethod', 'through')} ${repaymentMethodText}.</p><p>${(0, $fUPn2.t)('debt.mnote.instrumentClosed', 'The debt instrument has been closed.')}</p>`;
    (0, $epcPG.showHoloModal)({
        title: title,
        message: msg,
        type: 'success'
    });
    $f7756de821ba796a$var$refreshPortfolioData();
}
function $f7756de821ba796a$export$dd62890455bb572(data) {
    console.log("\uD83D\uDD14 M Note trade alert:", data);
    const { borrowerName: borrowerName, lenderName: lenderName, tradesRemaining: tradesRemaining, message: message } = data;
    (0, $epcPG.holoNotify)(`<p><strong>${(0, $fUPn2.t)('debt.mnote.alertTitle', 'M Note Alert')}</strong></p><p>${message}</p>`, 'warning');
}
function $f7756de821ba796a$export$b5805e5d8b8057e0(data) {
    console.log("\u2728 M Note convertible:", data);
    const { borrowerName: borrowerName, amount: amount, message: message } = data;
    (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.mnote.convertibleTitle', 'M Note Convertible'),
        message: `<p>${(0, $fUPn2.t)('debt.mnote.nowConvertible', 'Your M Note is now')} <strong>${(0, $fUPn2.t)('debt.mnote.convertibleCaps', 'CONVERTIBLE')}</strong>!</p><p>${(0, $fUPn2.t)('debt.mnote.canConvertTo', 'You can convert it to')} <strong>${amount}</strong> ${(0, $fUPn2.t)('debt.mnote.inLiquidAssets', 'in liquid assets')}.</p><p style="font-size:0.9em;color:#fcba03;margin-top:8px;">${(0, $fUPn2.t)('socketFront.checkDebtHeldSection', 'Check your Debt Held section to convert.')}</p>`,
        type: 'success'
    });
}
function $f7756de821ba796a$export$42c390334c7db64a(data) {
    console.log("\u2620\uFE0F Z-Payday CDO created:", data);
    const { role: role, from: from, to: to, amount: amount, instrumentId: instrumentId, message: message, principalType: principalType, zollarCount: zollarCount, pkg: pkg } = data;
    // Try to show zollars if provided; otherwise fall back to capital
    let headline;
    if (String(principalType).toLowerCase() === 'zollars') {
        let count = $f7756de821ba796a$var$resolveZCount(zollarCount);
        if (!Number.isFinite(count) || count <= 0) {
            const raw = pkg?.zollars;
            const derived = $f7756de821ba796a$var$resolveZCount(raw);
            count = Number.isFinite(derived) && derived > 0 ? derived : Number(amount) || 0;
        }
        // Use qualitative descriptor for zollars (assume max ~100 for context)
        const qualitativeLabel = $f7756de821ba796a$var$qLabel(count, 100);
        headline = `<strong>${qualitativeLabel} \u{1B5}</strong> ${(0, $fUPn2.t)('debt.cdo.availableImmediately', 'available immediately')}!`;
    } else headline = `<strong>${$f7756de821ba796a$var$fmtNum(amount)} ${(0, $fUPn2.t)('debt.capital', 'capital')}</strong> ${(0, $fUPn2.t)('debt.cdo.availableImmediately', 'available immediately')}!`;
    if (role === 'victim') (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.cdo.acceptedTitle', 'Z-Payday CDO Accepted'),
        message: `<p><strong>${from}</strong> ${(0, $fUPn2.t)('debt.cdo.offeredLoan', 'has offered you a loan')}.</p>
                <p style="font-size:1.1em;color:#3dd202;margin:10px 0;">${headline}</p>
                <p>${(0, $fUPn2.t)('socketFront.debtWarningPrefix', 'WARNING: This debt reloads every 60 seconds at 15% compound until repayment.')}</p>`,
        type: 'danger',
        autoClose: false
    });
    else (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.cdo.createdTitle', 'Z-Payday CDO Created'),
        message: `<p>${(0, $fUPn2.t)('debt.cdo.createdWith', 'Z-Payday CDO created with')} <strong>${to}</strong>.</p>
                <p>${(0, $fUPn2.t)('debt.cdo.tradeableCompounds', 'Tradeable. Compounds every 60s at 15%.')}</p>`,
        type: 'warning'
    });
    $f7756de821ba796a$var$refreshEmotionalMeter();
}
function $f7756de821ba796a$export$52be63a85f106281(data) {
    console.log("\uD83D\uDCB8 Z-Payday CDO reloaded:", data);
    const { role: role, cycle: cycle, newDebt: newDebt, totalDebt: totalDebt, isBankrupt: isBankrupt, message: message } = data;
    const modalType = isBankrupt ? 'danger' : role === 'victim' ? 'warning' : 'success';
    const title = isBankrupt ? (0, $fUPn2.t)('debt.cdo.bankruptcyWarningTitle', 'BANKRUPTCY WARNING') : (0, $fUPn2.t)('debt.cdo.reloadCycle', 'CDO Reload: Cycle {cycle}').replace('{cycle}', cycle);
    const msg = role === 'victim' ? `<p>${(0, $fUPn2.t)('socketFront.debtCompounded', 'Debt compounded:')} <strong>+${newDebt}</strong></p><p>${(0, $fUPn2.t)('socketFront.totalDebt', 'Total debt:')} <strong>${totalDebt}</strong></p>${isBankrupt ? `<p style="color:#ff4d4d;">${(0, $fUPn2.t)('socketFront.bankruptcyWarning', 'WARNING: You are approaching bankruptcy!')}</p>` : ''}` : `<p>${(0, $fUPn2.t)('debt.cdo.cdoCompounded', 'Your CDO compounded')}.</p><p>${(0, $fUPn2.t)('debt.cdo.victimOwes', 'Victim owes')}: <strong>${totalDebt}</strong></p>`;
    (0, $epcPG.holoNotify)(`${title}: ${message}`, modalType);
    $f7756de821ba796a$var$refreshEmotionalMeter();
}
function $f7756de821ba796a$export$27ddba50e36b177c(data) {
    console.log("\uD83D\uDCA5 Z-Payday CDO bankruptcy:", data);
    const { role: role, totalDebt: totalDebt, seized: seized, message: message } = data;
    if (role === 'victim') (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.cdo.bankruptcyTitle', 'BANKRUPTCY'),
        message: `<p><strong>${(0, $fUPn2.t)('debt.cdo.cdoCollapsed', 'Your Z-Payday CDO collapsed')}.</strong></p><p>${(0, $fUPn2.t)('debt.cdo.totalDebtLabel', 'Total debt')}: <strong>${totalDebt}</strong></p><p>${(0, $fUPn2.t)('debt.cdo.assetsSeized', 'Assets seized')}: <strong>${seized}</strong> ${(0, $fUPn2.t)('debt.capital', 'capital')}</p><p style="color:#ff4d4d;">${(0, $fUPn2.t)('debt.cdo.standingDamaged', 'Your financial standing has been severely damaged.')}</p>`,
        type: 'danger',
        autoClose: false
    });
    else (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.cdo.maturedTitle', 'CDO Matured'),
        message: `<p>${(0, $fUPn2.t)('debt.cdo.victimBankrupt', 'Your victim declared bankruptcy')}.</p><p>${(0, $fUPn2.t)('debt.cdo.youSeized', 'You seized')}: <strong>${seized}</strong> ${(0, $fUPn2.t)('debt.capital', 'capital')}</p><p style="color:#fcba03;">${(0, $fUPn2.t)('debt.cdo.toxicGainRecorded', 'Toxic relationship gain recorded.')}</p>`,
        type: 'success'
    });
    $f7756de821ba796a$var$refreshEmotionalMeter();
}
function $f7756de821ba796a$export$8baf2e763aa92bb8(data) {
    console.log("\uD83D\uDE4F V Note granted:", data);
    const { from: from, amount: amount, message: message } = data;
    const descriptiveAmount = $f7756de821ba796a$var$getDescriptiveAmountVNote(amount);
    (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.vnote.aidGrantedTitle', 'V Note Aid Granted'),
        message: `<p><strong>${from}</strong> ${(0, $fUPn2.t)('debt.vnote.hasGrantedAid', 'has granted you aid')}!</p>
      <p style="font-size:1.1em;color:#3dd202;margin:10px 0;">${(0, $fUPn2.t)('debt.vnote.received', 'Received')}: <strong>${descriptiveAmount} ${(0, $fUPn2.t)('debt.capital', 'capital')}</strong> (${amount})</p>
      <p style="font-size:0.9em;color:#fcba03;">${(0, $fUPn2.t)('debt.vnote.vulnerabilityWitnessed', 'Your vulnerability was witnessed and met with compassion.')}</p>`,
        type: 'success'
    });
    $f7756de821ba796a$var$refreshEmotionalMeter();
    $f7756de821ba796a$var$refreshPortfolioData();
}
function $f7756de821ba796a$export$64d03892c78bf290(data) {
    console.log("\u2705 V Note grant confirmed:", data);
    const { to: to, amount: amount, message: message } = data;
    const descriptiveAmount = $f7756de821ba796a$var$getDescriptiveAmountVNote(amount);
    (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.vnote.aidGrantedTitle', 'Aid Granted'),
        message: `<p>${(0, $fUPn2.t)('debt.vnote.youGranted', 'You granted')} <strong>${descriptiveAmount} ${(0, $fUPn2.t)('debt.capital', 'capital')}</strong> (${amount}) ${(0, $fUPn2.t)('debt.vnote.toRecipient', 'to')} <strong>${to}</strong>.</p>
      <p style="font-size:0.9em;color:#fcba03;">${(0, $fUPn2.t)('debt.vnote.compassionRecorded', 'Your compassion has been recorded in the social ledger.')}</p>`,
        type: 'success'
    });
    $f7756de821ba796a$var$refreshEmotionalMeter();
    $f7756de821ba796a$var$refreshPortfolioData();
}

function $f7756de821ba796a$export$2065a027b0dcfec2(data) {
    console.log("\uD83D\uDCB8 Debt notification received:", data);
    const { showNotification: showNotification } = (parcelRequire("eD3DY"));
    if (data.type === 'debt_warning') showNotification(`${(0, $fUPn2.t)('socketFront.warningPrefix', 'WARNING:')} ${data.message}`, false);
    else if (data.type === 'default_warning') showNotification(`${(0, $fUPn2.t)('socketFront.criticalPrefix', 'CRITICAL:')} ${data.message}`, false);
    else if (data.type === 'margin_notice') showNotification(`${data.message}`, true);
    else if (data.type === 'payment_received') showNotification(`${data.message}`, true);
    else if (data.type === 'recovery_offered') showNotification(`${data.message} ${(0, $fUPn2.t)('socketFront.debtPageVisit', 'Visit the Debt page for details.')}`, true);
}

function $f7756de821ba796a$export$599cf2b7ea32622f(data) {
    console.log("\uD83D\uDCA5 Debt wipeout event received:", data);
    const { showNotification: showNotification } = (parcelRequire("eD3DY"));
    showNotification(data.message || (0, $fUPn2.t)('socketFront.debtWipeoutDefault', 'Your portfolio has been wiped out due to excessive debt.'), false);
    setTimeout(()=>{
        window.location.href = data.redirectUrl || '/debtend.html';
    }, 2000);
}

function $f7756de821ba796a$export$529e377b6a0f0af1(data) {
    console.log("\uD83D\uDCB0 Debt closed notification received:", data);
    const { instrumentType: instrumentType, instrumentId: instrumentId, message: message, amount: amount } = data;
    const { showNotification: showNotification } = (parcelRequire("eD3DY"));
    const defaultMessage = instrumentType ? (0, $fUPn2.t)('debt.closedDefault', 'A {type} debt instrument has been closed.').replace('{type}', instrumentType) : (0, $fUPn2.t)('debt.closedGeneric', 'A debt instrument has been closed.');
    showNotification(message || defaultMessage, true);
}
function $f7756de821ba796a$export$b48f3c974c7de4d3(socket) {
    // Altrau Z Bill handlers
    socket.on('altrauZBillReceived', $f7756de821ba796a$export$eb5a9d2428dab8a7);
    socket.on('altrauZBillGiven', $f7756de821ba796a$export$55738db6221cc039);
    // M Note handlers
    socket.on('mNoteCreated', $f7756de821ba796a$export$22034bdd75d488d8);
    socket.on('mNoteProgress', $f7756de821ba796a$export$60e5f18fbf40fa1);
    socket.on('mNoteRepaid', $f7756de821ba796a$export$e811bb0d4bb84631);
    socket.on('mNoteTradeAlert', $f7756de821ba796a$export$dd62890455bb572);
    socket.on('mNoteConvertible', $f7756de821ba796a$export$b5805e5d8b8057e0);
    // Z-Payday CDO handlers
    socket.on('zPaydayCDOCreated', $f7756de821ba796a$export$42c390334c7db64a);
    socket.on('zPaydayCDOReloaded', $f7756de821ba796a$export$52be63a85f106281);
    socket.on('zPaydayCDOBankruptcy', $f7756de821ba796a$export$27ddba50e36b177c);
    // V Note handlers
    socket.on('vNoteGranted', $f7756de821ba796a$export$8baf2e763aa92bb8);
    socket.on('vNoteGrantConfirm', $f7756de821ba796a$export$64d03892c78bf290);
    // Generic debt notifications
    socket.on('debtNotification', $f7756de821ba796a$export$2065a027b0dcfec2);
    socket.on('debtWipeout', $f7756de821ba796a$export$599cf2b7ea32622f);
    socket.on('debtClosed', $f7756de821ba796a$export$529e377b6a0f0af1);
}

});

parcelRegister("ehiC0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jqanU").then(()=>parcelRequire('5AjYu'));

});




var $ae6bca06953b9a74$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"abTjN\",\"mood.81085e5c.js\",\"jqanU\",\"ransom.a7159958.js\",\"4zQMZ\",\"botChatHandler.e9453026.js\",\"iPtyb\",\"mood.a70c36df.js\"]"));


parcelRequire("bNbKd");

//# sourceMappingURL=mood.81085e5c.js.map
